(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire76ae"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire76ae"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("91cBK", function(module, exports) {
/*!
 * 
 * litepicker.umd.js
 * Litepicker v2.0.12 (https://github.com/wakirin/Litepicker)
 * Package: litepicker (https://www.npmjs.com/package/litepicker)
 * License: MIT (https://github.com/wakirin/Litepicker/blob/master/LICENCE.md)
 * Copyright 2019-2021 Rinat G.
 *     
 * Hash: 504eef9c08cb42543660
 * 
 */ !function(t, e) {
    module.exports = e();
}(window, function() {
    return function(t) {
        var e = {};
        function i(n) {
            if (e[n]) return e[n].exports;
            var o = e[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return t[n].call(o.exports, o, o.exports, i), o.l = !0, o.exports;
        }
        return i.m = t, i.c = e, i.d = function(t, e, n) {
            i.o(t, e) || Object.defineProperty(t, e, {
                enumerable: !0,
                get: n
            });
        }, i.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, i.t = function(t, e) {
            if (1 & e && (t = i(t)), 8 & e) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var n = Object.create(null);
            if (i.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t) for(var o in t)i.d(n, o, (function(e) {
                return t[e];
            }).bind(null, o));
            return n;
        }, i.n = function(t) {
            var e = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return i.d(e, "a", e), e;
        }, i.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, i.p = "", i(i.s = 4);
    }([
        function(t, e, i) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var n = function() {
                function t(e, i, n) {
                    void 0 === e && (e = null), void 0 === i && (i = null), void 0 === n && (n = "en-US"), this.dateInstance = "object" == typeof i && null !== i ? i.parse(e instanceof t ? e.clone().toJSDate() : e) : "string" == typeof i ? t.parseDateTime(e, i, n) : e ? t.parseDateTime(e) : t.parseDateTime(new Date), this.lang = n;
                }
                return t.parseDateTime = function(e, i, n) {
                    if (void 0 === i && (i = "YYYY-MM-DD"), void 0 === n && (n = "en-US"), !e) return new Date(NaN);
                    if (e instanceof Date) return new Date(e);
                    if (e instanceof t) return e.clone().toJSDate();
                    if (/^-?\d{10,}$/.test(e)) return t.getDateZeroTime(new Date(Number(e)));
                    if ("string" == typeof e) {
                        for(var o = [], s = null; null != (s = t.regex.exec(i));)"\\" !== s[1] && o.push(s);
                        if (o.length) {
                            var r = {
                                year: null,
                                month: null,
                                shortMonth: null,
                                longMonth: null,
                                day: null,
                                value: ""
                            };
                            o[0].index > 0 && (r.value += ".*?");
                            for(var a = 0, l = Object.entries(o); a < l.length; a++){
                                var c = l[a], h = c[0], p = c[1], d = Number(h), u = t.formatPatterns(p[0], n), m = u.group, f = u.pattern;
                                r[m] = d + 1, r.value += f, r.value += ".*?";
                            }
                            var g = new RegExp("^" + r.value + "$");
                            if (g.test(e)) {
                                var v = g.exec(e), y = Number(v[r.year]), b = null;
                                r.month ? b = Number(v[r.month]) - 1 : r.shortMonth ? b = t.shortMonths(n).indexOf(v[r.shortMonth]) : r.longMonth && (b = t.longMonths(n).indexOf(v[r.longMonth]));
                                var k = Number(v[r.day]) || 1;
                                return new Date(y, b, k, 0, 0, 0, 0);
                            }
                        }
                    }
                    return t.getDateZeroTime(new Date(e));
                }, t.convertArray = function(e, i) {
                    return e.map(function(e) {
                        return e instanceof Array ? e.map(function(e) {
                            return new t(e, i);
                        }) : new t(e, i);
                    });
                }, t.getDateZeroTime = function(t) {
                    return new Date(t.getFullYear(), t.getMonth(), t.getDate(), 0, 0, 0, 0);
                }, t.shortMonths = function(e) {
                    return t.MONTH_JS.map(function(t) {
                        return new Date(2019, t).toLocaleString(e, {
                            month: "short"
                        });
                    });
                }, t.longMonths = function(e) {
                    return t.MONTH_JS.map(function(t) {
                        return new Date(2019, t).toLocaleString(e, {
                            month: "long"
                        });
                    });
                }, t.formatPatterns = function(e, i) {
                    switch(e){
                        case "YY":
                        case "YYYY":
                            return {
                                group: "year",
                                pattern: "(\\d{" + e.length + "})"
                            };
                        case "M":
                            return {
                                group: "month",
                                pattern: "(\\d{1,2})"
                            };
                        case "MM":
                            return {
                                group: "month",
                                pattern: "(\\d{2})"
                            };
                        case "MMM":
                            return {
                                group: "shortMonth",
                                pattern: "(" + t.shortMonths(i).join("|") + ")"
                            };
                        case "MMMM":
                            return {
                                group: "longMonth",
                                pattern: "(" + t.longMonths(i).join("|") + ")"
                            };
                        case "D":
                            return {
                                group: "day",
                                pattern: "(\\d{1,2})"
                            };
                        case "DD":
                            return {
                                group: "day",
                                pattern: "(\\d{2})"
                            };
                    }
                }, t.prototype.toJSDate = function() {
                    return this.dateInstance;
                }, t.prototype.toLocaleString = function(t, e) {
                    return this.dateInstance.toLocaleString(t, e);
                }, t.prototype.toDateString = function() {
                    return this.dateInstance.toDateString();
                }, t.prototype.getSeconds = function() {
                    return this.dateInstance.getSeconds();
                }, t.prototype.getDay = function() {
                    return this.dateInstance.getDay();
                }, t.prototype.getTime = function() {
                    return this.dateInstance.getTime();
                }, t.prototype.getDate = function() {
                    return this.dateInstance.getDate();
                }, t.prototype.getMonth = function() {
                    return this.dateInstance.getMonth();
                }, t.prototype.getFullYear = function() {
                    return this.dateInstance.getFullYear();
                }, t.prototype.setMonth = function(t) {
                    return this.dateInstance.setMonth(t);
                }, t.prototype.setHours = function(t, e, i, n) {
                    void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === i && (i = 0), void 0 === n && (n = 0), this.dateInstance.setHours(t, e, i, n);
                }, t.prototype.setSeconds = function(t) {
                    return this.dateInstance.setSeconds(t);
                }, t.prototype.setDate = function(t) {
                    return this.dateInstance.setDate(t);
                }, t.prototype.setFullYear = function(t) {
                    return this.dateInstance.setFullYear(t);
                }, t.prototype.getWeek = function(t) {
                    var e = new Date(this.timestamp()), i = (this.getDay() + (7 - t)) % 7;
                    e.setDate(e.getDate() - i);
                    var n = e.getTime();
                    return e.setMonth(0, 1), e.getDay() !== t && e.setMonth(0, 1 + (4 - e.getDay() + 7) % 7), 1 + Math.ceil((n - e.getTime()) / 6048e5);
                }, t.prototype.clone = function() {
                    return new t(this.toJSDate());
                }, t.prototype.isBetween = function(t, e, i) {
                    switch(void 0 === i && (i = "()"), i){
                        default:
                        case "()":
                            return this.timestamp() > t.getTime() && this.timestamp() < e.getTime();
                        case "[)":
                            return this.timestamp() >= t.getTime() && this.timestamp() < e.getTime();
                        case "(]":
                            return this.timestamp() > t.getTime() && this.timestamp() <= e.getTime();
                        case "[]":
                            return this.timestamp() >= t.getTime() && this.timestamp() <= e.getTime();
                    }
                }, t.prototype.isBefore = function(t, e) {
                    switch(void 0 === e && (e = "seconds"), e){
                        case "second":
                        case "seconds":
                            return t.getTime() > this.getTime();
                        case "day":
                        case "days":
                            return new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime() > new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime();
                        case "month":
                        case "months":
                            return new Date(t.getFullYear(), t.getMonth(), 1).getTime() > new Date(this.getFullYear(), this.getMonth(), 1).getTime();
                        case "year":
                        case "years":
                            return t.getFullYear() > this.getFullYear();
                    }
                    throw new Error("isBefore: Invalid unit!");
                }, t.prototype.isSameOrBefore = function(t, e) {
                    switch(void 0 === e && (e = "seconds"), e){
                        case "second":
                        case "seconds":
                            return t.getTime() >= this.getTime();
                        case "day":
                        case "days":
                            return new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime() >= new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime();
                        case "month":
                        case "months":
                            return new Date(t.getFullYear(), t.getMonth(), 1).getTime() >= new Date(this.getFullYear(), this.getMonth(), 1).getTime();
                    }
                    throw new Error("isSameOrBefore: Invalid unit!");
                }, t.prototype.isAfter = function(t, e) {
                    switch(void 0 === e && (e = "seconds"), e){
                        case "second":
                        case "seconds":
                            return this.getTime() > t.getTime();
                        case "day":
                        case "days":
                            return new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime() > new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime();
                        case "month":
                        case "months":
                            return new Date(this.getFullYear(), this.getMonth(), 1).getTime() > new Date(t.getFullYear(), t.getMonth(), 1).getTime();
                        case "year":
                        case "years":
                            return this.getFullYear() > t.getFullYear();
                    }
                    throw new Error("isAfter: Invalid unit!");
                }, t.prototype.isSameOrAfter = function(t, e) {
                    switch(void 0 === e && (e = "seconds"), e){
                        case "second":
                        case "seconds":
                            return this.getTime() >= t.getTime();
                        case "day":
                        case "days":
                            return new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime() >= new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime();
                        case "month":
                        case "months":
                            return new Date(this.getFullYear(), this.getMonth(), 1).getTime() >= new Date(t.getFullYear(), t.getMonth(), 1).getTime();
                    }
                    throw new Error("isSameOrAfter: Invalid unit!");
                }, t.prototype.isSame = function(t, e) {
                    switch(void 0 === e && (e = "seconds"), e){
                        case "second":
                        case "seconds":
                            return this.getTime() === t.getTime();
                        case "day":
                        case "days":
                            return new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime() === new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime();
                        case "month":
                        case "months":
                            return new Date(this.getFullYear(), this.getMonth(), 1).getTime() === new Date(t.getFullYear(), t.getMonth(), 1).getTime();
                    }
                    throw new Error("isSame: Invalid unit!");
                }, t.prototype.add = function(t, e) {
                    switch(void 0 === e && (e = "seconds"), e){
                        case "second":
                        case "seconds":
                            this.setSeconds(this.getSeconds() + t);
                            break;
                        case "day":
                        case "days":
                            this.setDate(this.getDate() + t);
                            break;
                        case "month":
                        case "months":
                            this.setMonth(this.getMonth() + t);
                    }
                    return this;
                }, t.prototype.subtract = function(t, e) {
                    switch(void 0 === e && (e = "seconds"), e){
                        case "second":
                        case "seconds":
                            this.setSeconds(this.getSeconds() - t);
                            break;
                        case "day":
                        case "days":
                            this.setDate(this.getDate() - t);
                            break;
                        case "month":
                        case "months":
                            this.setMonth(this.getMonth() - t);
                    }
                    return this;
                }, t.prototype.diff = function(t, e) {
                    void 0 === e && (e = "seconds");
                    switch(e){
                        default:
                        case "second":
                        case "seconds":
                            return this.getTime() - t.getTime();
                        case "day":
                        case "days":
                            return Math.round((this.timestamp() - t.getTime()) / 864e5);
                        case "month":
                        case "months":
                    }
                }, t.prototype.format = function(e, i) {
                    if (void 0 === i && (i = "en-US"), "object" == typeof e) return e.output(this.clone().toJSDate());
                    for(var n = "", o = [], s = null; null != (s = t.regex.exec(e));)"\\" !== s[1] && o.push(s);
                    if (o.length) {
                        o[0].index > 0 && (n += e.substring(0, o[0].index));
                        for(var r = 0, a = Object.entries(o); r < a.length; r++){
                            var l = a[r], c = l[0], h = l[1], p = Number(c);
                            n += this.formatTokens(h[0], i), o[p + 1] && (n += e.substring(h.index + h[0].length, o[p + 1].index)), p === o.length - 1 && (n += e.substring(h.index + h[0].length));
                        }
                    }
                    return n.replace(/\\/g, "");
                }, t.prototype.timestamp = function() {
                    return new Date(this.getFullYear(), this.getMonth(), this.getDate(), 0, 0, 0, 0).getTime();
                }, t.prototype.formatTokens = function(e, i) {
                    switch(e){
                        case "YY":
                            return String(this.getFullYear()).slice(-2);
                        case "YYYY":
                            return String(this.getFullYear());
                        case "M":
                            return String(this.getMonth() + 1);
                        case "MM":
                            return ("0" + (this.getMonth() + 1)).slice(-2);
                        case "MMM":
                            return t.shortMonths(i)[this.getMonth()];
                        case "MMMM":
                            return t.longMonths(i)[this.getMonth()];
                        case "D":
                            return String(this.getDate());
                        case "DD":
                            return ("0" + this.getDate()).slice(-2);
                        default:
                            return "";
                    }
                }, t.regex = /(\\)?(Y{2,4}|M{1,4}|D{1,2}|d{1,4})/g, t.MONTH_JS = [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11
                ], t;
            }();
            e.DateTime = n;
        },
        function(t, e, i) {
            "use strict";
            var n, o = this && this.__extends || (n = function(t, e) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t, e) {
                    t.__proto__ = e;
                } || function(t, e) {
                    for(var i in e)e.hasOwnProperty(i) && (t[i] = e[i]);
                })(t, e);
            }, function(t, e) {
                function i() {
                    this.constructor = t;
                }
                n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i);
            }), s = this && this.__spreadArrays || function() {
                for(var t = 0, e = 0, i = arguments.length; e < i; e++)t += arguments[e].length;
                var n = Array(t), o = 0;
                for(e = 0; e < i; e++)for(var s = arguments[e], r = 0, a = s.length; r < a; r++, o++)n[o] = s[r];
                return n;
            };
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var r = i(5), a = i(0), l = i(3), c = i(2), h = function(t) {
                function e(e) {
                    var i = t.call(this, e) || this;
                    return i.preventClick = !1, i.bindEvents(), i;
                }
                return o(e, t), e.prototype.scrollToDate = function(t) {
                    if (this.options.scrollToDate) {
                        var e = this.options.startDate instanceof a.DateTime ? this.options.startDate.clone() : null, i = this.options.endDate instanceof a.DateTime ? this.options.endDate.clone() : null;
                        !this.options.startDate || t && t !== this.options.element ? t && this.options.endDate && t === this.options.elementEnd && (i.setDate(1), this.options.numberOfMonths > 1 && i.isAfter(e) && i.setMonth(i.getMonth() - (this.options.numberOfMonths - 1)), this.calendars[0] = i.clone()) : (e.setDate(1), this.calendars[0] = e.clone());
                    }
                }, e.prototype.bindEvents = function() {
                    document.addEventListener("click", this.onClick.bind(this), !0), this.ui = document.createElement("div"), this.ui.className = l.litepicker, this.ui.style.display = "none", this.ui.addEventListener("mouseenter", this.onMouseEnter.bind(this), !0), this.ui.addEventListener("mouseleave", this.onMouseLeave.bind(this), !1), this.options.autoRefresh ? (this.options.element instanceof HTMLElement && this.options.element.addEventListener("keyup", this.onInput.bind(this), !0), this.options.elementEnd instanceof HTMLElement && this.options.elementEnd.addEventListener("keyup", this.onInput.bind(this), !0)) : (this.options.element instanceof HTMLElement && this.options.element.addEventListener("change", this.onInput.bind(this), !0), this.options.elementEnd instanceof HTMLElement && this.options.elementEnd.addEventListener("change", this.onInput.bind(this), !0)), this.options.parentEl ? this.options.parentEl instanceof HTMLElement ? this.options.parentEl.appendChild(this.ui) : document.querySelector(this.options.parentEl).appendChild(this.ui) : this.options.inlineMode ? this.options.element instanceof HTMLInputElement ? this.options.element.parentNode.appendChild(this.ui) : this.options.element.appendChild(this.ui) : document.body.appendChild(this.ui), this.updateInput(), this.init(), "function" == typeof this.options.setup && this.options.setup.call(this, this), this.render(), this.options.inlineMode && this.show();
                }, e.prototype.updateInput = function() {
                    if (this.options.element instanceof HTMLInputElement) {
                        var t = this.options.startDate, e = this.options.endDate;
                        if (this.options.singleMode && t) this.options.element.value = t.format(this.options.format, this.options.lang);
                        else if (!this.options.singleMode && t && e) {
                            var i = t.format(this.options.format, this.options.lang), n = e.format(this.options.format, this.options.lang);
                            this.options.elementEnd instanceof HTMLInputElement ? (this.options.element.value = i, this.options.elementEnd.value = n) : this.options.element.value = "" + i + this.options.delimiter + n;
                        }
                        t || e || (this.options.element.value = "", this.options.elementEnd instanceof HTMLInputElement && (this.options.elementEnd.value = ""));
                    }
                }, e.prototype.isSamePicker = function(t) {
                    return t.closest("." + l.litepicker) === this.ui;
                }, e.prototype.shouldShown = function(t) {
                    return !t.disabled && (t === this.options.element || this.options.elementEnd && t === this.options.elementEnd);
                }, e.prototype.shouldResetDatePicked = function() {
                    return this.options.singleMode || 2 === this.datePicked.length;
                }, e.prototype.shouldSwapDatePicked = function() {
                    return 2 === this.datePicked.length && this.datePicked[0].getTime() > this.datePicked[1].getTime();
                }, e.prototype.shouldCheckLockDays = function() {
                    return this.options.disallowLockDaysInRange && 2 === this.datePicked.length;
                }, e.prototype.onClick = function(t) {
                    var e = t.target;
                    if (t.target.shadowRoot && (e = t.composedPath()[0]), e && this.ui) {
                        if (this.shouldShown(e)) this.show(e);
                        else if (e.closest("." + l.litepicker) || !this.isShowning()) {
                            if (this.isSamePicker(e)) {
                                if (this.emit("before:click", e), this.preventClick) this.preventClick = !1;
                                else {
                                    if (e.classList.contains(l.dayItem)) {
                                        if (t.preventDefault(), e.classList.contains(l.isLocked)) return;
                                        if (this.shouldResetDatePicked() && (this.datePicked.length = 0), this.datePicked[this.datePicked.length] = new a.DateTime(e.dataset.time), this.shouldSwapDatePicked()) {
                                            var i = this.datePicked[1].clone();
                                            this.datePicked[1] = this.datePicked[0].clone(), this.datePicked[0] = i.clone();
                                        }
                                        if (this.shouldCheckLockDays()) c.rangeIsLocked(this.datePicked, this.options) && (this.emit("error:range", this.datePicked), this.datePicked.length = 0);
                                        return this.render(), this.emit.apply(this, s([
                                            "preselect"
                                        ], s(this.datePicked).map(function(t) {
                                            return t.clone();
                                        }))), void (this.options.autoApply && (this.options.singleMode && this.datePicked.length ? (this.setDate(this.datePicked[0]), this.hide()) : this.options.singleMode || 2 !== this.datePicked.length || (this.setDateRange(this.datePicked[0], this.datePicked[1]), this.hide())));
                                    }
                                    if (e.classList.contains(l.buttonPreviousMonth)) {
                                        t.preventDefault();
                                        var n = 0, o = this.options.switchingMonths || this.options.numberOfMonths;
                                        if (this.options.splitView) {
                                            var r = e.closest("." + l.monthItem);
                                            n = c.findNestedMonthItem(r), o = 1;
                                        }
                                        return this.calendars[n].setMonth(this.calendars[n].getMonth() - o), this.gotoDate(this.calendars[n], n), void this.emit("change:month", this.calendars[n], n);
                                    }
                                    if (e.classList.contains(l.buttonNextMonth)) {
                                        t.preventDefault();
                                        n = 0, o = this.options.switchingMonths || this.options.numberOfMonths;
                                        if (this.options.splitView) {
                                            r = e.closest("." + l.monthItem);
                                            n = c.findNestedMonthItem(r), o = 1;
                                        }
                                        return this.calendars[n].setMonth(this.calendars[n].getMonth() + o), this.gotoDate(this.calendars[n], n), void this.emit("change:month", this.calendars[n], n);
                                    }
                                    e.classList.contains(l.buttonCancel) && (t.preventDefault(), this.hide(), this.emit("button:cancel")), e.classList.contains(l.buttonApply) && (t.preventDefault(), this.options.singleMode && this.datePicked.length ? this.setDate(this.datePicked[0]) : this.options.singleMode || 2 !== this.datePicked.length || this.setDateRange(this.datePicked[0], this.datePicked[1]), this.hide(), this.emit("button:apply", this.options.startDate, this.options.endDate));
                                }
                            }
                        } else this.hide();
                    }
                }, e.prototype.showTooltip = function(t, e) {
                    var i = this.ui.querySelector("." + l.containerTooltip);
                    i.style.visibility = "visible", i.innerHTML = e;
                    var n = this.ui.getBoundingClientRect(), o = i.getBoundingClientRect(), s = t.getBoundingClientRect(), r = s.top, a = s.left;
                    if (this.options.inlineMode && this.options.parentEl) {
                        var c = this.ui.parentNode.getBoundingClientRect();
                        r -= c.top, a -= c.left;
                    } else r -= n.top, a -= n.left;
                    r -= o.height, a -= o.width / 2, a += s.width / 2, i.style.top = r + "px", i.style.left = a + "px", this.emit("tooltip", i, t);
                }, e.prototype.hideTooltip = function() {
                    this.ui.querySelector("." + l.containerTooltip).style.visibility = "hidden";
                }, e.prototype.shouldAllowMouseEnter = function(t) {
                    return !this.options.singleMode && !t.classList.contains(l.isLocked);
                }, e.prototype.shouldAllowRepick = function() {
                    return this.options.elementEnd && this.options.allowRepick && this.options.startDate && this.options.endDate;
                }, e.prototype.isDayItem = function(t) {
                    return t.classList.contains(l.dayItem);
                }, e.prototype.onMouseEnter = function(t) {
                    var e = this, i = t.target;
                    if (this.isDayItem(i) && this.shouldAllowMouseEnter(i)) {
                        if (this.shouldAllowRepick() && (this.triggerElement === this.options.element ? this.datePicked[0] = this.options.endDate.clone() : this.triggerElement === this.options.elementEnd && (this.datePicked[0] = this.options.startDate.clone())), 1 !== this.datePicked.length) return;
                        var n = this.ui.querySelector("." + l.dayItem + '[data-time="' + this.datePicked[0].getTime() + '"]'), o = this.datePicked[0].clone(), s = new a.DateTime(i.dataset.time), r = !1;
                        if (o.getTime() > s.getTime()) {
                            var c = o.clone();
                            o = s.clone(), s = c.clone(), r = !0;
                        }
                        if (Array.prototype.slice.call(this.ui.querySelectorAll("." + l.dayItem)).forEach(function(t) {
                            var i = new a.DateTime(t.dataset.time), n = e.renderDay(i);
                            i.isBetween(o, s) && n.classList.add(l.isInRange), t.className = n.className;
                        }), i.classList.add(l.isEndDate), r ? (n && n.classList.add(l.isFlipped), i.classList.add(l.isFlipped)) : (n && n.classList.remove(l.isFlipped), i.classList.remove(l.isFlipped)), this.options.showTooltip) {
                            var h = s.diff(o, "day") + 1;
                            if ("function" == typeof this.options.tooltipNumber && (h = this.options.tooltipNumber.call(this, h)), h > 0) {
                                var p = this.pluralSelector(h), d = h + " " + (this.options.tooltipText[p] ? this.options.tooltipText[p] : "[" + p + "]");
                                this.showTooltip(i, d);
                                var u = window.navigator.userAgent, m = /(iphone|ipad)/i.test(u), f = /OS 1([0-2])/i.test(u);
                                m && f && i.dispatchEvent(new Event("click"));
                            } else this.hideTooltip();
                        }
                    }
                }, e.prototype.onMouseLeave = function(t) {
                    t.target;
                    this.options.allowRepick && (!this.options.allowRepick || this.options.startDate || this.options.endDate) && (this.datePicked.length = 0, this.render());
                }, e.prototype.onInput = function(t) {
                    var e = this.parseInput(), i = e[0], n = e[1], o = this.options.format;
                    if (this.options.elementEnd ? i instanceof a.DateTime && n instanceof a.DateTime && i.format(o) === this.options.element.value && n.format(o) === this.options.elementEnd.value : this.options.singleMode ? i instanceof a.DateTime && i.format(o) === this.options.element.value : i instanceof a.DateTime && n instanceof a.DateTime && "" + i.format(o) + this.options.delimiter + n.format(o) === this.options.element.value) {
                        if (n && i.getTime() > n.getTime()) {
                            var s = i.clone();
                            i = n.clone(), n = s.clone();
                        }
                        this.options.startDate = new a.DateTime(i, this.options.format, this.options.lang), n && (this.options.endDate = new a.DateTime(n, this.options.format, this.options.lang)), this.updateInput(), this.render();
                        var r = i.clone(), l = 0;
                        (this.options.elementEnd ? i.format(o) === t.target.value : t.target.value.startsWith(i.format(o))) || (r = n.clone(), l = this.options.numberOfMonths - 1), this.emit("selected", this.getStartDate(), this.getEndDate()), this.gotoDate(r, l);
                    }
                }, e;
            }(r.Calendar);
            e.Litepicker = h;
        },
        function(t, e, i) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.findNestedMonthItem = function(t) {
                for(var e = t.parentNode.childNodes, i = 0; i < e.length; i += 1){
                    if (e.item(i) === t) return i;
                }
                return 0;
            }, e.dateIsLocked = function(t, e, i) {
                var n = !1;
                return e.lockDays.length && (n = e.lockDays.filter(function(i) {
                    return i instanceof Array ? t.isBetween(i[0], i[1], e.lockDaysInclusivity) : i.isSame(t, "day");
                }).length), n || "function" != typeof e.lockDaysFilter || (n = e.lockDaysFilter.call(this, t.clone(), null, i)), n;
            }, e.rangeIsLocked = function(t, e) {
                var i = !1;
                return e.lockDays.length && (i = e.lockDays.filter(function(i) {
                    if (i instanceof Array) {
                        var n = t[0].toDateString() === i[0].toDateString() && t[1].toDateString() === i[1].toDateString();
                        return i[0].isBetween(t[0], t[1], e.lockDaysInclusivity) || i[1].isBetween(t[0], t[1], e.lockDaysInclusivity) || n;
                    }
                    return i.isBetween(t[0], t[1], e.lockDaysInclusivity);
                }).length), i || "function" != typeof e.lockDaysFilter || (i = e.lockDaysFilter.call(this, t[0].clone(), t[1].clone(), t)), i;
            };
        },
        function(t, e, i) {
            var n = i(8);
            "string" == typeof n && (n = [
                [
                    t.i,
                    n,
                    ""
                ]
            ]);
            var o = {
                insert: function(t) {
                    var e = document.querySelector("head"), i = window._lastElementInsertedByStyleLoader;
                    window.disableLitepickerStyles || (i ? i.nextSibling ? e.insertBefore(t, i.nextSibling) : e.appendChild(t) : e.insertBefore(t, e.firstChild), window._lastElementInsertedByStyleLoader = t);
                },
                singleton: !1
            };
            i(10)(n, o);
            n.locals && (t.exports = n.locals);
        },
        function(t, e, i) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var n = i(1);
            e.Litepicker = n.Litepicker, i(11), window.Litepicker = n.Litepicker, e.default = n.Litepicker;
        },
        function(t, e, i) {
            "use strict";
            var n, o = this && this.__extends || (n = function(t, e) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t, e) {
                    t.__proto__ = e;
                } || function(t, e) {
                    for(var i in e)e.hasOwnProperty(i) && (t[i] = e[i]);
                })(t, e);
            }, function(t, e) {
                function i() {
                    this.constructor = t;
                }
                n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i);
            });
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var s = i(6), r = i(0), a = i(3), l = i(2), c = function(t) {
                function e(e) {
                    return t.call(this, e) || this;
                }
                return o(e, t), e.prototype.render = function() {
                    var t = this;
                    this.emit("before:render", this.ui);
                    var e = document.createElement("div");
                    e.className = a.containerMain;
                    var i = document.createElement("div");
                    i.className = a.containerMonths, a["columns" + this.options.numberOfColumns] && (i.classList.remove(a.columns2, a.columns3, a.columns4), i.classList.add(a["columns" + this.options.numberOfColumns])), this.options.splitView && i.classList.add(a.splitView), this.options.showWeekNumbers && i.classList.add(a.showWeekNumbers);
                    for(var n = this.calendars[0].clone(), o = n.getMonth(), s = n.getMonth() + this.options.numberOfMonths, r = 0, l = o; l < s; l += 1){
                        var c = n.clone();
                        c.setDate(1), c.setHours(0, 0, 0, 0), this.options.splitView ? c = this.calendars[r].clone() : c.setMonth(l), i.appendChild(this.renderMonth(c, r)), r += 1;
                    }
                    if (this.ui.innerHTML = "", e.appendChild(i), this.options.resetButton) {
                        var h = void 0;
                        "function" == typeof this.options.resetButton ? h = this.options.resetButton.call(this) : ((h = document.createElement("button")).type = "button", h.className = a.resetButton, h.innerHTML = this.options.buttonText.reset), h.addEventListener("click", function(e) {
                            e.preventDefault(), t.clearSelection();
                        }), e.querySelector("." + a.monthItem + ":last-child").querySelector("." + a.monthItemHeader).appendChild(h);
                    }
                    this.ui.appendChild(e), this.options.autoApply && !this.options.footerHTML || this.ui.appendChild(this.renderFooter()), this.options.showTooltip && this.ui.appendChild(this.renderTooltip()), this.ui.dataset.plugins = (this.options.plugins || []).join("|"), this.emit("render", this.ui);
                }, e.prototype.renderMonth = function(t, e) {
                    var i = this, n = t.clone(), o = 32 - new Date(n.getFullYear(), n.getMonth(), 32).getDate(), s = document.createElement("div");
                    s.className = a.monthItem;
                    var c = document.createElement("div");
                    c.className = a.monthItemHeader;
                    var h = document.createElement("div");
                    if (this.options.dropdowns.months) {
                        var p = document.createElement("select");
                        p.className = a.monthItemName;
                        for(var d = 0; d < 12; d += 1){
                            var u = document.createElement("option"), m = new r.DateTime(new Date(t.getFullYear(), d, 2, 0, 0, 0)), f = new r.DateTime(new Date(t.getFullYear(), d, 1, 0, 0, 0));
                            u.value = String(d), u.text = m.toLocaleString(this.options.lang, {
                                month: "long"
                            }), u.disabled = this.options.minDate && f.isBefore(new r.DateTime(this.options.minDate), "month") || this.options.maxDate && f.isAfter(new r.DateTime(this.options.maxDate), "month"), u.selected = f.getMonth() === t.getMonth(), p.appendChild(u);
                        }
                        p.addEventListener("change", function(t) {
                            var e = t.target, n = 0;
                            if (i.options.splitView) {
                                var o = e.closest("." + a.monthItem);
                                n = l.findNestedMonthItem(o);
                            }
                            i.calendars[n].setMonth(Number(e.value)), i.render(), i.emit("change:month", i.calendars[n], n, t);
                        }), h.appendChild(p);
                    } else (m = document.createElement("strong")).className = a.monthItemName, m.innerHTML = t.toLocaleString(this.options.lang, {
                        month: "long"
                    }), h.appendChild(m);
                    if (this.options.dropdowns.years) {
                        var g = document.createElement("select");
                        g.className = a.monthItemYear;
                        var v = this.options.dropdowns.minYear, y = this.options.dropdowns.maxYear ? this.options.dropdowns.maxYear : (new Date).getFullYear();
                        if (t.getFullYear() > y) (u = document.createElement("option")).value = String(t.getFullYear()), u.text = String(t.getFullYear()), u.selected = !0, u.disabled = !0, g.appendChild(u);
                        for(d = y; d >= v; d -= 1){
                            var u = document.createElement("option"), b = new r.DateTime(new Date(d, 0, 1, 0, 0, 0));
                            u.value = String(d), u.text = String(d), u.disabled = this.options.minDate && b.isBefore(new r.DateTime(this.options.minDate), "year") || this.options.maxDate && b.isAfter(new r.DateTime(this.options.maxDate), "year"), u.selected = t.getFullYear() === d, g.appendChild(u);
                        }
                        if (t.getFullYear() < v) (u = document.createElement("option")).value = String(t.getFullYear()), u.text = String(t.getFullYear()), u.selected = !0, u.disabled = !0, g.appendChild(u);
                        if ("asc" === this.options.dropdowns.years) {
                            var k = Array.prototype.slice.call(g.childNodes).reverse();
                            g.innerHTML = "", k.forEach(function(t) {
                                t.innerHTML = t.value, g.appendChild(t);
                            });
                        }
                        g.addEventListener("change", function(t) {
                            var e = t.target, n = 0;
                            if (i.options.splitView) {
                                var o = e.closest("." + a.monthItem);
                                n = l.findNestedMonthItem(o);
                            }
                            i.calendars[n].setFullYear(Number(e.value)), i.render(), i.emit("change:year", i.calendars[n], n, t);
                        }), h.appendChild(g);
                    } else {
                        var w = document.createElement("span");
                        w.className = a.monthItemYear, w.innerHTML = String(t.getFullYear()), h.appendChild(w);
                    }
                    var D = document.createElement("button");
                    D.type = "button", D.className = a.buttonPreviousMonth, D.innerHTML = this.options.buttonText.previousMonth;
                    var x = document.createElement("button");
                    x.type = "button", x.className = a.buttonNextMonth, x.innerHTML = this.options.buttonText.nextMonth, c.appendChild(D), c.appendChild(h), c.appendChild(x), this.options.minDate && n.isSameOrBefore(new r.DateTime(this.options.minDate), "month") && s.classList.add(a.noPreviousMonth), this.options.maxDate && n.isSameOrAfter(new r.DateTime(this.options.maxDate), "month") && s.classList.add(a.noNextMonth);
                    var M = document.createElement("div");
                    M.className = a.monthItemWeekdaysRow, this.options.showWeekNumbers && (M.innerHTML = "<div>W</div>");
                    for(var _ = 1; _ <= 7; _ += 1){
                        var T = 3 + this.options.firstDay + _, L = document.createElement("div");
                        L.innerHTML = this.weekdayName(T), L.title = this.weekdayName(T, "long"), M.appendChild(L);
                    }
                    var E = document.createElement("div");
                    E.className = a.containerDays;
                    var S = this.calcSkipDays(n);
                    this.options.showWeekNumbers && S && E.appendChild(this.renderWeekNumber(n));
                    for(var I = 0; I < S; I += 1){
                        var P = document.createElement("div");
                        E.appendChild(P);
                    }
                    for(I = 1; I <= o; I += 1)n.setDate(I), this.options.showWeekNumbers && n.getDay() === this.options.firstDay && E.appendChild(this.renderWeekNumber(n)), E.appendChild(this.renderDay(n));
                    return s.appendChild(c), s.appendChild(M), s.appendChild(E), this.emit("render:month", s, t), s;
                }, e.prototype.renderDay = function(t) {
                    t.setHours();
                    var e = document.createElement("div");
                    if (e.className = a.dayItem, e.innerHTML = String(t.getDate()), e.dataset.time = String(t.getTime()), t.toDateString() === (new Date).toDateString() && e.classList.add(a.isToday), this.datePicked.length) this.datePicked[0].toDateString() === t.toDateString() && (e.classList.add(a.isStartDate), this.options.singleMode && e.classList.add(a.isEndDate)), 2 === this.datePicked.length && this.datePicked[1].toDateString() === t.toDateString() && e.classList.add(a.isEndDate), 2 === this.datePicked.length && t.isBetween(this.datePicked[0], this.datePicked[1]) && e.classList.add(a.isInRange);
                    else if (this.options.startDate) {
                        var i = this.options.startDate, n = this.options.endDate;
                        i.toDateString() === t.toDateString() && (e.classList.add(a.isStartDate), this.options.singleMode && e.classList.add(a.isEndDate)), n && n.toDateString() === t.toDateString() && e.classList.add(a.isEndDate), i && n && t.isBetween(i, n) && e.classList.add(a.isInRange);
                    }
                    if (this.options.minDate && t.isBefore(new r.DateTime(this.options.minDate)) && e.classList.add(a.isLocked), this.options.maxDate && t.isAfter(new r.DateTime(this.options.maxDate)) && e.classList.add(a.isLocked), this.options.minDays > 1 && 1 === this.datePicked.length) {
                        var o = this.options.minDays - 1, s = this.datePicked[0].clone().subtract(o, "day"), c = this.datePicked[0].clone().add(o, "day");
                        t.isBetween(s, this.datePicked[0], "(]") && e.classList.add(a.isLocked), t.isBetween(this.datePicked[0], c, "[)") && e.classList.add(a.isLocked);
                    }
                    if (this.options.maxDays && 1 === this.datePicked.length) {
                        var h = this.options.maxDays;
                        s = this.datePicked[0].clone().subtract(h, "day"), c = this.datePicked[0].clone().add(h, "day");
                        t.isSameOrBefore(s) && e.classList.add(a.isLocked), t.isSameOrAfter(c) && e.classList.add(a.isLocked);
                    }
                    (this.options.selectForward && 1 === this.datePicked.length && t.isBefore(this.datePicked[0]) && e.classList.add(a.isLocked), this.options.selectBackward && 1 === this.datePicked.length && t.isAfter(this.datePicked[0]) && e.classList.add(a.isLocked), l.dateIsLocked(t, this.options, this.datePicked) && e.classList.add(a.isLocked), this.options.highlightedDays.length) && this.options.highlightedDays.filter(function(e) {
                        return e instanceof Array ? t.isBetween(e[0], e[1], "[]") : e.isSame(t, "day");
                    }).length && e.classList.add(a.isHighlighted);
                    return e.tabIndex = e.classList.contains("is-locked") ? -1 : 0, this.emit("render:day", e, t), e;
                }, e.prototype.renderFooter = function() {
                    var t = document.createElement("div");
                    if (t.className = a.containerFooter, this.options.footerHTML ? t.innerHTML = this.options.footerHTML : t.innerHTML = '\n      <span class="' + a.previewDateRange + '"></span>\n      <button type="button" class="' + a.buttonCancel + '">' + this.options.buttonText.cancel + '</button>\n      <button type="button" class="' + a.buttonApply + '">' + this.options.buttonText.apply + "</button>\n      ", this.options.singleMode) {
                        if (1 === this.datePicked.length) {
                            var e = this.datePicked[0].format(this.options.format, this.options.lang);
                            t.querySelector("." + a.previewDateRange).innerHTML = e;
                        }
                    } else if (1 === this.datePicked.length && t.querySelector("." + a.buttonApply).setAttribute("disabled", ""), 2 === this.datePicked.length) {
                        e = this.datePicked[0].format(this.options.format, this.options.lang);
                        var i = this.datePicked[1].format(this.options.format, this.options.lang);
                        t.querySelector("." + a.previewDateRange).innerHTML = "" + e + this.options.delimiter + i;
                    }
                    return this.emit("render:footer", t), t;
                }, e.prototype.renderWeekNumber = function(t) {
                    var e = document.createElement("div"), i = t.getWeek(this.options.firstDay);
                    return e.className = a.weekNumber, e.innerHTML = 53 === i && 0 === t.getMonth() ? "53 / 1" : i, e;
                }, e.prototype.renderTooltip = function() {
                    var t = document.createElement("div");
                    return t.className = a.containerTooltip, t;
                }, e.prototype.weekdayName = function(t, e) {
                    return void 0 === e && (e = "short"), new Date(1970, 0, t, 12, 0, 0, 0).toLocaleString(this.options.lang, {
                        weekday: e
                    });
                }, e.prototype.calcSkipDays = function(t) {
                    var e = t.getDay() - this.options.firstDay;
                    return e < 0 && (e += 7), e;
                }, e;
            }(s.LPCore);
            e.Calendar = c;
        },
        function(t, e, i) {
            "use strict";
            var n, o = this && this.__extends || (n = function(t, e) {
                return (n = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(t, e) {
                    t.__proto__ = e;
                } || function(t, e) {
                    for(var i in e)e.hasOwnProperty(i) && (t[i] = e[i]);
                })(t, e);
            }, function(t, e) {
                function i() {
                    this.constructor = t;
                }
                n(t, e), t.prototype = null === e ? Object.create(e) : (i.prototype = e.prototype, new i);
            }), s = this && this.__assign || function() {
                return (s = Object.assign || function(t) {
                    for(var e, i = 1, n = arguments.length; i < n; i++)for(var o in e = arguments[i])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                    return t;
                }).apply(this, arguments);
            };
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var r = i(7), a = i(0), l = i(1), c = function(t) {
                function e(e) {
                    var i = t.call(this) || this;
                    i.datePicked = [], i.calendars = [], i.options = {
                        element: null,
                        elementEnd: null,
                        parentEl: null,
                        firstDay: 1,
                        format: "YYYY-MM-DD",
                        lang: "en-US",
                        delimiter: " - ",
                        numberOfMonths: 1,
                        numberOfColumns: 1,
                        startDate: null,
                        endDate: null,
                        zIndex: 9999,
                        position: "auto",
                        selectForward: !1,
                        selectBackward: !1,
                        splitView: !1,
                        inlineMode: !1,
                        singleMode: !0,
                        autoApply: !0,
                        allowRepick: !1,
                        showWeekNumbers: !1,
                        showTooltip: !0,
                        scrollToDate: !0,
                        mobileFriendly: !0,
                        resetButton: !1,
                        autoRefresh: !1,
                        lockDaysFormat: "YYYY-MM-DD",
                        lockDays: [],
                        disallowLockDaysInRange: !1,
                        lockDaysInclusivity: "[]",
                        highlightedDaysFormat: "YYYY-MM-DD",
                        highlightedDays: [],
                        dropdowns: {
                            minYear: 1990,
                            maxYear: null,
                            months: !1,
                            years: !1
                        },
                        buttonText: {
                            apply: "Apply",
                            cancel: "Cancel",
                            previousMonth: '<svg width="11" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M7.919 0l2.748 2.667L5.333 8l5.334 5.333L7.919 16 0 8z" fill-rule="nonzero"/></svg>',
                            nextMonth: '<svg width="11" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M2.748 16L0 13.333 5.333 8 0 2.667 2.748 0l7.919 8z" fill-rule="nonzero"/></svg>',
                            reset: '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">\n        <path d="M0 0h24v24H0z" fill="none"/>\n        <path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"/>\n      </svg>'
                        },
                        tooltipText: {
                            one: "day",
                            other: "days"
                        }
                    }, i.options = s(s({}, i.options), e.element.dataset), Object.keys(i.options).forEach(function(t) {
                        "true" !== i.options[t] && "false" !== i.options[t] || (i.options[t] = "true" === i.options[t]);
                    });
                    var n = s(s({}, i.options.dropdowns), e.dropdowns), o = s(s({}, i.options.buttonText), e.buttonText), r = s(s({}, i.options.tooltipText), e.tooltipText);
                    i.options = s(s({}, i.options), e), i.options.dropdowns = s({}, n), i.options.buttonText = s({}, o), i.options.tooltipText = s({}, r), i.options.elementEnd || (i.options.allowRepick = !1), i.options.lockDays.length && (i.options.lockDays = a.DateTime.convertArray(i.options.lockDays, i.options.lockDaysFormat)), i.options.highlightedDays.length && (i.options.highlightedDays = a.DateTime.convertArray(i.options.highlightedDays, i.options.highlightedDaysFormat));
                    var l = i.parseInput(), c = l[0], h = l[1];
                    i.options.startDate && (i.options.singleMode || i.options.endDate) && (c = new a.DateTime(i.options.startDate, i.options.format, i.options.lang)), c && i.options.endDate && (h = new a.DateTime(i.options.endDate, i.options.format, i.options.lang)), c instanceof a.DateTime && !isNaN(c.getTime()) && (i.options.startDate = c), i.options.startDate && h instanceof a.DateTime && !isNaN(h.getTime()) && (i.options.endDate = h), !i.options.singleMode || i.options.startDate instanceof a.DateTime || (i.options.startDate = null), i.options.singleMode || i.options.startDate instanceof a.DateTime && i.options.endDate instanceof a.DateTime || (i.options.startDate = null, i.options.endDate = null);
                    for(var p = 0; p < i.options.numberOfMonths; p += 1){
                        var d = i.options.startDate instanceof a.DateTime ? i.options.startDate.clone() : new a.DateTime;
                        if (!i.options.startDate && (0 === p || i.options.splitView)) {
                            var u = i.options.maxDate ? new a.DateTime(i.options.maxDate) : null, m = i.options.minDate ? new a.DateTime(i.options.minDate) : null, f = i.options.numberOfMonths - 1;
                            m && u && d.isAfter(u) ? (d = m.clone()).setDate(1) : !m && u && d.isAfter(u) && ((d = u.clone()).setDate(1), d.setMonth(d.getMonth() - f));
                        }
                        d.setDate(1), d.setMonth(d.getMonth() + p), i.calendars[p] = d;
                    }
                    if (i.options.showTooltip) {
                        if (i.options.tooltipPluralSelector) i.pluralSelector = i.options.tooltipPluralSelector;
                        else try {
                            var g = new Intl.PluralRules(i.options.lang);
                            i.pluralSelector = g.select.bind(g);
                        } catch (t) {
                            i.pluralSelector = function(t) {
                                return 0 === Math.abs(t) ? "one" : "other";
                            };
                        }
                    }
                    return i;
                }
                return o(e, t), e.add = function(t, e) {
                    l.Litepicker.prototype[t] = e;
                }, e.prototype.DateTime = function(t, e) {
                    return t ? new a.DateTime(t, e) : new a.DateTime;
                }, e.prototype.init = function() {
                    var t = this;
                    this.options.plugins && this.options.plugins.length && this.options.plugins.forEach(function(e) {
                        l.Litepicker.prototype.hasOwnProperty(e) ? l.Litepicker.prototype[e].init.call(t, t) : console.warn("Litepicker: plugin \xab" + e + "\xbb not found.");
                    });
                }, e.prototype.parseInput = function() {
                    var t = this.options.delimiter, e = new RegExp("" + t), i = this.options.element instanceof HTMLInputElement ? this.options.element.value.split(t) : [];
                    if (this.options.elementEnd) {
                        if (this.options.element instanceof HTMLInputElement && this.options.element.value.length && this.options.elementEnd instanceof HTMLInputElement && this.options.elementEnd.value.length) return [
                            new a.DateTime(this.options.element.value, this.options.format),
                            new a.DateTime(this.options.elementEnd.value, this.options.format)
                        ];
                    } else if (this.options.singleMode) {
                        if (this.options.element instanceof HTMLInputElement && this.options.element.value.length) return [
                            new a.DateTime(this.options.element.value, this.options.format)
                        ];
                    } else if (this.options.element instanceof HTMLInputElement && e.test(this.options.element.value) && i.length && i.length % 2 == 0) {
                        var n = i.slice(0, i.length / 2).join(t), o = i.slice(i.length / 2).join(t);
                        return [
                            new a.DateTime(n, this.options.format),
                            new a.DateTime(o, this.options.format)
                        ];
                    }
                    return [];
                }, e.prototype.isShowning = function() {
                    return this.ui && "none" !== this.ui.style.display;
                }, e.prototype.findPosition = function(t) {
                    var e = t.getBoundingClientRect(), i = this.ui.getBoundingClientRect(), n = this.options.position.split(" "), o = window.scrollX || window.pageXOffset, s = window.scrollY || window.pageYOffset, r = 0, a = 0;
                    if ("auto" !== n[0] && /top|bottom/.test(n[0])) r = e[n[0]] + s, "top" === n[0] && (r -= i.height);
                    else {
                        r = e.bottom + s;
                        var l = e.bottom + i.height > window.innerHeight, c = e.top + s - i.height >= i.height;
                        l && c && (r = e.top + s - i.height);
                    }
                    if (/left|right/.test(n[0]) || n[1] && "auto" !== n[1] && /left|right/.test(n[1])) a = /left|right/.test(n[0]) ? e[n[0]] + o : e[n[1]] + o, "right" !== n[0] && "right" !== n[1] || (a -= i.width);
                    else {
                        a = e.left + o;
                        l = e.left + i.width > window.innerWidth;
                        var h = e.right + o - i.width >= 0;
                        l && h && (a = e.right + o - i.width);
                    }
                    return {
                        left: a,
                        top: r
                    };
                }, e;
            }(r.EventEmitter);
            e.LPCore = c;
        },
        function(t, e, i) {
            "use strict";
            var n, o = "object" == typeof Reflect ? Reflect : null, s = o && "function" == typeof o.apply ? o.apply : function(t, e, i) {
                return Function.prototype.apply.call(t, e, i);
            };
            n = o && "function" == typeof o.ownKeys ? o.ownKeys : Object.getOwnPropertySymbols ? function(t) {
                return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
            } : function(t) {
                return Object.getOwnPropertyNames(t);
            };
            var r = Number.isNaN || function(t) {
                return t != t;
            };
            function a() {
                a.init.call(this);
            }
            t.exports = a, a.EventEmitter = a, a.prototype._events = void 0, a.prototype._eventsCount = 0, a.prototype._maxListeners = void 0;
            var l = 10;
            function c(t) {
                return void 0 === t._maxListeners ? a.defaultMaxListeners : t._maxListeners;
            }
            function h(t, e, i, n) {
                var o, s, r, a;
                if ("function" != typeof i) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof i);
                if (void 0 === (s = t._events) ? (s = t._events = Object.create(null), t._eventsCount = 0) : (void 0 !== s.newListener && (t.emit("newListener", e, i.listener ? i.listener : i), s = t._events), r = s[e]), void 0 === r) r = s[e] = i, ++t._eventsCount;
                else if ("function" == typeof r ? r = s[e] = n ? [
                    i,
                    r
                ] : [
                    r,
                    i
                ] : n ? r.unshift(i) : r.push(i), (o = c(t)) > 0 && r.length > o && !r.warned) {
                    r.warned = !0;
                    var l = new Error("Possible EventEmitter memory leak detected. " + r.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
                    l.name = "MaxListenersExceededWarning", l.emitter = t, l.type = e, l.count = r.length, a = l, console && console.warn && console.warn(a);
                }
                return t;
            }
            function p() {
                for(var t = [], e = 0; e < arguments.length; e++)t.push(arguments[e]);
                this.fired || (this.target.removeListener(this.type, this.wrapFn), this.fired = !0, s(this.listener, this.target, t));
            }
            function d(t, e, i) {
                var n = {
                    fired: !1,
                    wrapFn: void 0,
                    target: t,
                    type: e,
                    listener: i
                }, o = p.bind(n);
                return o.listener = i, n.wrapFn = o, o;
            }
            function u(t, e, i) {
                var n = t._events;
                if (void 0 === n) return [];
                var o = n[e];
                return void 0 === o ? [] : "function" == typeof o ? i ? [
                    o.listener || o
                ] : [
                    o
                ] : i ? function(t) {
                    for(var e = new Array(t.length), i = 0; i < e.length; ++i)e[i] = t[i].listener || t[i];
                    return e;
                }(o) : f(o, o.length);
            }
            function m(t) {
                var e = this._events;
                if (void 0 !== e) {
                    var i = e[t];
                    if ("function" == typeof i) return 1;
                    if (void 0 !== i) return i.length;
                }
                return 0;
            }
            function f(t, e) {
                for(var i = new Array(e), n = 0; n < e; ++n)i[n] = t[n];
                return i;
            }
            Object.defineProperty(a, "defaultMaxListeners", {
                enumerable: !0,
                get: function() {
                    return l;
                },
                set: function(t) {
                    if ("number" != typeof t || t < 0 || r(t)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
                    l = t;
                }
            }), a.init = function() {
                void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
            }, a.prototype.setMaxListeners = function(t) {
                if ("number" != typeof t || t < 0 || r(t)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + ".");
                return this._maxListeners = t, this;
            }, a.prototype.getMaxListeners = function() {
                return c(this);
            }, a.prototype.emit = function(t) {
                for(var e = [], i = 1; i < arguments.length; i++)e.push(arguments[i]);
                var n = "error" === t, o = this._events;
                if (void 0 !== o) n = n && void 0 === o.error;
                else if (!n) return !1;
                if (n) {
                    var r;
                    if (e.length > 0 && (r = e[0]), r instanceof Error) throw r;
                    var a = new Error("Unhandled error." + (r ? " (" + r.message + ")" : ""));
                    throw a.context = r, a;
                }
                var l = o[t];
                if (void 0 === l) return !1;
                if ("function" == typeof l) s(l, this, e);
                else {
                    var c = l.length, h = f(l, c);
                    for(i = 0; i < c; ++i)s(h[i], this, e);
                }
                return !0;
            }, a.prototype.addListener = function(t, e) {
                return h(this, t, e, !1);
            }, a.prototype.on = a.prototype.addListener, a.prototype.prependListener = function(t, e) {
                return h(this, t, e, !0);
            }, a.prototype.once = function(t, e) {
                if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
                return this.on(t, d(this, t, e)), this;
            }, a.prototype.prependOnceListener = function(t, e) {
                if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
                return this.prependListener(t, d(this, t, e)), this;
            }, a.prototype.removeListener = function(t, e) {
                var i, n, o, s, r;
                if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
                if (void 0 === (n = this._events)) return this;
                if (void 0 === (i = n[t])) return this;
                if (i === e || i.listener === e) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete n[t], n.removeListener && this.emit("removeListener", t, i.listener || e));
                else if ("function" != typeof i) {
                    for(o = -1, s = i.length - 1; s >= 0; s--)if (i[s] === e || i[s].listener === e) {
                        r = i[s].listener, o = s;
                        break;
                    }
                    if (o < 0) return this;
                    0 === o ? i.shift() : function(t, e) {
                        for(; e + 1 < t.length; e++)t[e] = t[e + 1];
                        t.pop();
                    }(i, o), 1 === i.length && (n[t] = i[0]), void 0 !== n.removeListener && this.emit("removeListener", t, r || e);
                }
                return this;
            }, a.prototype.off = a.prototype.removeListener, a.prototype.removeAllListeners = function(t) {
                var e, i, n;
                if (void 0 === (i = this._events)) return this;
                if (void 0 === i.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== i[t] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete i[t]), this;
                if (0 === arguments.length) {
                    var o, s = Object.keys(i);
                    for(n = 0; n < s.length; ++n)"removeListener" !== (o = s[n]) && this.removeAllListeners(o);
                    return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
                }
                if ("function" == typeof (e = i[t])) this.removeListener(t, e);
                else if (void 0 !== e) for(n = e.length - 1; n >= 0; n--)this.removeListener(t, e[n]);
                return this;
            }, a.prototype.listeners = function(t) {
                return u(this, t, !0);
            }, a.prototype.rawListeners = function(t) {
                return u(this, t, !1);
            }, a.listenerCount = function(t, e) {
                return "function" == typeof t.listenerCount ? t.listenerCount(e) : m.call(t, e);
            }, a.prototype.listenerCount = m, a.prototype.eventNames = function() {
                return this._eventsCount > 0 ? n(this._events) : [];
            };
        },
        function(t, e, i) {
            (e = i(9)(!1)).push([
                t.i,
                ':root{--litepicker-container-months-color-bg: #fff;--litepicker-container-months-box-shadow-color: #ddd;--litepicker-footer-color-bg: #fafafa;--litepicker-footer-box-shadow-color: #ddd;--litepicker-tooltip-color-bg: #fff;--litepicker-month-header-color: #333;--litepicker-button-prev-month-color: #9e9e9e;--litepicker-button-next-month-color: #9e9e9e;--litepicker-button-prev-month-color-hover: #2196f3;--litepicker-button-next-month-color-hover: #2196f3;--litepicker-month-width: calc(var(--litepicker-day-width) * 7);--litepicker-month-weekday-color: #9e9e9e;--litepicker-month-week-number-color: #9e9e9e;--litepicker-day-width: 38px;--litepicker-day-color: #333;--litepicker-day-color-hover: #2196f3;--litepicker-is-today-color: #f44336;--litepicker-is-in-range-color: #bbdefb;--litepicker-is-locked-color: #9e9e9e;--litepicker-is-start-color: #fff;--litepicker-is-start-color-bg: #2196f3;--litepicker-is-end-color: #fff;--litepicker-is-end-color-bg: #2196f3;--litepicker-button-cancel-color: #fff;--litepicker-button-cancel-color-bg: #9e9e9e;--litepicker-button-apply-color: #fff;--litepicker-button-apply-color-bg: #2196f3;--litepicker-button-reset-color: #909090;--litepicker-button-reset-color-hover: #2196f3;--litepicker-highlighted-day-color: #333;--litepicker-highlighted-day-color-bg: #ffeb3b}.show-week-numbers{--litepicker-month-width: calc(var(--litepicker-day-width) * 8)}.litepicker{font-family:-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;font-size:0.8em;display:none}.litepicker button{border:none;background:none}.litepicker .container__main{display:-webkit-box;display:-ms-flexbox;display:flex}.litepicker .container__months{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;background-color:var(--litepicker-container-months-color-bg);border-radius:5px;-webkit-box-shadow:0 0 5px var(--litepicker-container-months-box-shadow-color);box-shadow:0 0 5px var(--litepicker-container-months-box-shadow-color);width:calc(var(--litepicker-month-width) + 10px);-webkit-box-sizing:content-box;box-sizing:content-box}.litepicker .container__months.columns-2{width:calc((var(--litepicker-month-width) * 2) + 20px)}.litepicker .container__months.columns-3{width:calc((var(--litepicker-month-width) * 3) + 30px)}.litepicker .container__months.columns-4{width:calc((var(--litepicker-month-width) * 4) + 40px)}.litepicker .container__months.split-view .month-item-header .button-previous-month,.litepicker .container__months.split-view .month-item-header .button-next-month{visibility:visible}.litepicker .container__months .month-item{padding:5px;width:var(--litepicker-month-width);-webkit-box-sizing:content-box;box-sizing:content-box}.litepicker .container__months .month-item-header{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;font-weight:500;padding:10px 5px;text-align:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:var(--litepicker-month-header-color)}.litepicker .container__months .month-item-header div{-webkit-box-flex:1;-ms-flex:1;flex:1}.litepicker .container__months .month-item-header div>.month-item-name{margin-right:5px}.litepicker .container__months .month-item-header div>.month-item-year{padding:0}.litepicker .container__months .month-item-header .reset-button{color:var(--litepicker-button-reset-color)}.litepicker .container__months .month-item-header .reset-button>svg{fill:var(--litepicker-button-reset-color)}.litepicker .container__months .month-item-header .reset-button *{pointer-events:none}.litepicker .container__months .month-item-header .reset-button:hover{color:var(--litepicker-button-reset-color-hover)}.litepicker .container__months .month-item-header .reset-button:hover>svg{fill:var(--litepicker-button-reset-color-hover)}.litepicker .container__months .month-item-header .button-previous-month,.litepicker .container__months .month-item-header .button-next-month{visibility:hidden;text-decoration:none;padding:3px 5px;border-radius:3px;-webkit-transition:color 0.3s, border 0.3s;transition:color 0.3s, border 0.3s;cursor:default}.litepicker .container__months .month-item-header .button-previous-month *,.litepicker .container__months .month-item-header .button-next-month *{pointer-events:none}.litepicker .container__months .month-item-header .button-previous-month{color:var(--litepicker-button-prev-month-color)}.litepicker .container__months .month-item-header .button-previous-month>svg,.litepicker .container__months .month-item-header .button-previous-month>img{fill:var(--litepicker-button-prev-month-color)}.litepicker .container__months .month-item-header .button-previous-month:hover{color:var(--litepicker-button-prev-month-color-hover)}.litepicker .container__months .month-item-header .button-previous-month:hover>svg{fill:var(--litepicker-button-prev-month-color-hover)}.litepicker .container__months .month-item-header .button-next-month{color:var(--litepicker-button-next-month-color)}.litepicker .container__months .month-item-header .button-next-month>svg,.litepicker .container__months .month-item-header .button-next-month>img{fill:var(--litepicker-button-next-month-color)}.litepicker .container__months .month-item-header .button-next-month:hover{color:var(--litepicker-button-next-month-color-hover)}.litepicker .container__months .month-item-header .button-next-month:hover>svg{fill:var(--litepicker-button-next-month-color-hover)}.litepicker .container__months .month-item-weekdays-row{display:-webkit-box;display:-ms-flexbox;display:flex;justify-self:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;color:var(--litepicker-month-weekday-color)}.litepicker .container__months .month-item-weekdays-row>div{padding:5px 0;font-size:85%;-webkit-box-flex:1;-ms-flex:1;flex:1;width:var(--litepicker-day-width);text-align:center}.litepicker .container__months .month-item:first-child .button-previous-month{visibility:visible}.litepicker .container__months .month-item:last-child .button-next-month{visibility:visible}.litepicker .container__months .month-item.no-previous-month .button-previous-month{visibility:hidden}.litepicker .container__months .month-item.no-next-month .button-next-month{visibility:hidden}.litepicker .container__days{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;justify-self:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;text-align:center;-webkit-box-sizing:content-box;box-sizing:content-box}.litepicker .container__days>div,.litepicker .container__days>a{padding:5px 0;width:var(--litepicker-day-width)}.litepicker .container__days .day-item{color:var(--litepicker-day-color);text-align:center;text-decoration:none;border-radius:3px;-webkit-transition:color 0.3s, border 0.3s;transition:color 0.3s, border 0.3s;cursor:default}.litepicker .container__days .day-item:hover{color:var(--litepicker-day-color-hover);-webkit-box-shadow:inset 0 0 0 1px var(--litepicker-day-color-hover);box-shadow:inset 0 0 0 1px var(--litepicker-day-color-hover)}.litepicker .container__days .day-item.is-today{color:var(--litepicker-is-today-color)}.litepicker .container__days .day-item.is-locked{color:var(--litepicker-is-locked-color)}.litepicker .container__days .day-item.is-locked:hover{color:var(--litepicker-is-locked-color);-webkit-box-shadow:none;box-shadow:none;cursor:default}.litepicker .container__days .day-item.is-in-range{background-color:var(--litepicker-is-in-range-color);border-radius:0}.litepicker .container__days .day-item.is-start-date{color:var(--litepicker-is-start-color);background-color:var(--litepicker-is-start-color-bg);border-top-left-radius:5px;border-bottom-left-radius:5px;border-top-right-radius:0;border-bottom-right-radius:0}.litepicker .container__days .day-item.is-start-date.is-flipped{border-top-left-radius:0;border-bottom-left-radius:0;border-top-right-radius:5px;border-bottom-right-radius:5px}.litepicker .container__days .day-item.is-end-date{color:var(--litepicker-is-end-color);background-color:var(--litepicker-is-end-color-bg);border-top-left-radius:0;border-bottom-left-radius:0;border-top-right-radius:5px;border-bottom-right-radius:5px}.litepicker .container__days .day-item.is-end-date.is-flipped{border-top-left-radius:5px;border-bottom-left-radius:5px;border-top-right-radius:0;border-bottom-right-radius:0}.litepicker .container__days .day-item.is-start-date.is-end-date{border-top-left-radius:5px;border-bottom-left-radius:5px;border-top-right-radius:5px;border-bottom-right-radius:5px}.litepicker .container__days .day-item.is-highlighted{color:var(--litepicker-highlighted-day-color);background-color:var(--litepicker-highlighted-day-color-bg)}.litepicker .container__days .week-number{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;color:var(--litepicker-month-week-number-color);font-size:85%}.litepicker .container__footer{text-align:right;padding:10px 5px;margin:0 5px;background-color:var(--litepicker-footer-color-bg);-webkit-box-shadow:inset 0px 3px 3px 0px var(--litepicker-footer-box-shadow-color);box-shadow:inset 0px 3px 3px 0px var(--litepicker-footer-box-shadow-color);border-bottom-left-radius:5px;border-bottom-right-radius:5px}.litepicker .container__footer .preview-date-range{margin-right:10px;font-size:90%}.litepicker .container__footer .button-cancel{background-color:var(--litepicker-button-cancel-color-bg);color:var(--litepicker-button-cancel-color);border:0;padding:3px 7px 4px;border-radius:3px}.litepicker .container__footer .button-cancel *{pointer-events:none}.litepicker .container__footer .button-apply{background-color:var(--litepicker-button-apply-color-bg);color:var(--litepicker-button-apply-color);border:0;padding:3px 7px 4px;border-radius:3px;margin-left:10px;margin-right:10px}.litepicker .container__footer .button-apply:disabled{opacity:0.7}.litepicker .container__footer .button-apply *{pointer-events:none}.litepicker .container__tooltip{position:absolute;margin-top:-4px;padding:4px 8px;border-radius:4px;background-color:var(--litepicker-tooltip-color-bg);-webkit-box-shadow:0 1px 3px rgba(0,0,0,0.25);box-shadow:0 1px 3px rgba(0,0,0,0.25);white-space:nowrap;font-size:11px;pointer-events:none;visibility:hidden}.litepicker .container__tooltip:before{position:absolute;bottom:-5px;left:calc(50% - 5px);border-top:5px solid rgba(0,0,0,0.12);border-right:5px solid transparent;border-left:5px solid transparent;content:""}.litepicker .container__tooltip:after{position:absolute;bottom:-4px;left:calc(50% - 4px);border-top:4px solid var(--litepicker-tooltip-color-bg);border-right:4px solid transparent;border-left:4px solid transparent;content:""}\n',
                ""
            ]), e.locals = {
                showWeekNumbers: "show-week-numbers",
                litepicker: "litepicker",
                containerMain: "container__main",
                containerMonths: "container__months",
                columns2: "columns-2",
                columns3: "columns-3",
                columns4: "columns-4",
                splitView: "split-view",
                monthItemHeader: "month-item-header",
                buttonPreviousMonth: "button-previous-month",
                buttonNextMonth: "button-next-month",
                monthItem: "month-item",
                monthItemName: "month-item-name",
                monthItemYear: "month-item-year",
                resetButton: "reset-button",
                monthItemWeekdaysRow: "month-item-weekdays-row",
                noPreviousMonth: "no-previous-month",
                noNextMonth: "no-next-month",
                containerDays: "container__days",
                dayItem: "day-item",
                isToday: "is-today",
                isLocked: "is-locked",
                isInRange: "is-in-range",
                isStartDate: "is-start-date",
                isFlipped: "is-flipped",
                isEndDate: "is-end-date",
                isHighlighted: "is-highlighted",
                weekNumber: "week-number",
                containerFooter: "container__footer",
                previewDateRange: "preview-date-range",
                buttonCancel: "button-cancel",
                buttonApply: "button-apply",
                containerTooltip: "container__tooltip"
            }, t.exports = e;
        },
        function(t, e, i) {
            "use strict";
            t.exports = function(t) {
                var e = [];
                return e.toString = function() {
                    return this.map(function(e) {
                        var i = function(t, e) {
                            var i = t[1] || "", n = t[3];
                            if (!n) return i;
                            if (e && "function" == typeof btoa) {
                                var o = (r = n, a = btoa(unescape(encodeURIComponent(JSON.stringify(r)))), l = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(a), "/*# ".concat(l, " */")), s = n.sources.map(function(t) {
                                    return "/*# sourceURL=".concat(n.sourceRoot || "").concat(t, " */");
                                });
                                return [
                                    i
                                ].concat(s).concat([
                                    o
                                ]).join("\n");
                            }
                            var r, a, l;
                            return [
                                i
                            ].join("\n");
                        }(e, t);
                        return e[2] ? "@media ".concat(e[2], " {").concat(i, "}") : i;
                    }).join("");
                }, e.i = function(t, i, n) {
                    "string" == typeof t && (t = [
                        [
                            null,
                            t,
                            ""
                        ]
                    ]);
                    var o = {};
                    if (n) for(var s = 0; s < this.length; s++){
                        var r = this[s][0];
                        null != r && (o[r] = !0);
                    }
                    for(var a = 0; a < t.length; a++){
                        var l = [].concat(t[a]);
                        n && o[l[0]] || (i && (l[2] ? l[2] = "".concat(i, " and ").concat(l[2]) : l[2] = i), e.push(l));
                    }
                }, e;
            };
        },
        function(t, e, i) {
            "use strict";
            var n, o = {}, s = function() {
                return void 0 === n && (n = Boolean(window && document && document.all && !window.atob)), n;
            }, r = function() {
                var t = {};
                return function(e) {
                    if (void 0 === t[e]) {
                        var i = document.querySelector(e);
                        if (window.HTMLIFrameElement && i instanceof window.HTMLIFrameElement) try {
                            i = i.contentDocument.head;
                        } catch (t) {
                            i = null;
                        }
                        t[e] = i;
                    }
                    return t[e];
                };
            }();
            function a(t, e) {
                for(var i = [], n = {}, o = 0; o < t.length; o++){
                    var s = t[o], r = e.base ? s[0] + e.base : s[0], a = {
                        css: s[1],
                        media: s[2],
                        sourceMap: s[3]
                    };
                    n[r] ? n[r].parts.push(a) : i.push(n[r] = {
                        id: r,
                        parts: [
                            a
                        ]
                    });
                }
                return i;
            }
            function l(t, e) {
                for(var i = 0; i < t.length; i++){
                    var n = t[i], s = o[n.id], r = 0;
                    if (s) {
                        for(s.refs++; r < s.parts.length; r++)s.parts[r](n.parts[r]);
                        for(; r < n.parts.length; r++)s.parts.push(g(n.parts[r], e));
                    } else {
                        for(var a = []; r < n.parts.length; r++)a.push(g(n.parts[r], e));
                        o[n.id] = {
                            id: n.id,
                            refs: 1,
                            parts: a
                        };
                    }
                }
            }
            function c(t) {
                var e = document.createElement("style");
                if (void 0 === t.attributes.nonce) {
                    var n = i.nc;
                    n && (t.attributes.nonce = n);
                }
                if (Object.keys(t.attributes).forEach(function(i) {
                    e.setAttribute(i, t.attributes[i]);
                }), "function" == typeof t.insert) t.insert(e);
                else {
                    var o = r(t.insert || "head");
                    if (!o) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
                    o.appendChild(e);
                }
                return e;
            }
            var h, p = (h = [], function(t, e) {
                return h[t] = e, h.filter(Boolean).join("\n");
            });
            function d(t, e, i, n) {
                var o = i ? "" : n.css;
                if (t.styleSheet) t.styleSheet.cssText = p(e, o);
                else {
                    var s = document.createTextNode(o), r = t.childNodes;
                    r[e] && t.removeChild(r[e]), r.length ? t.insertBefore(s, r[e]) : t.appendChild(s);
                }
            }
            function u(t, e, i) {
                var n = i.css, o = i.media, s = i.sourceMap;
                if (o && t.setAttribute("media", o), s && btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(s)))), " */")), t.styleSheet) t.styleSheet.cssText = n;
                else {
                    for(; t.firstChild;)t.removeChild(t.firstChild);
                    t.appendChild(document.createTextNode(n));
                }
            }
            var m = null, f = 0;
            function g(t, e) {
                var i, n, o;
                if (e.singleton) {
                    var s = f++;
                    i = m || (m = c(e)), n = d.bind(null, i, s, !1), o = d.bind(null, i, s, !0);
                } else i = c(e), n = u.bind(null, i, e), o = function() {
                    !function(t) {
                        if (null === t.parentNode) return !1;
                        t.parentNode.removeChild(t);
                    }(i);
                };
                return n(t), function(e) {
                    if (e) {
                        if (e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap) return;
                        n(t = e);
                    } else o();
                };
            }
            t.exports = function(t, e) {
                (e = e || {}).attributes = "object" == typeof e.attributes ? e.attributes : {}, e.singleton || "boolean" == typeof e.singleton || (e.singleton = s());
                var i = a(t, e);
                return l(i, e), function(t) {
                    for(var n = [], s = 0; s < i.length; s++){
                        var r = i[s], c = o[r.id];
                        c && (c.refs--, n.push(c));
                    }
                    t && l(a(t, e), e);
                    for(var h = 0; h < n.length; h++){
                        var p = n[h];
                        if (0 === p.refs) {
                            for(var d = 0; d < p.parts.length; d++)p.parts[d]();
                            delete o[p.id];
                        }
                    }
                };
            };
        },
        function(t, e, i) {
            "use strict";
            var n = this && this.__assign || function() {
                return (n = Object.assign || function(t) {
                    for(var e, i = 1, n = arguments.length; i < n; i++)for(var o in e = arguments[i])Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                    return t;
                }).apply(this, arguments);
            };
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var o = i(0), s = i(1), r = i(2);
            s.Litepicker.prototype.show = function(t) {
                void 0 === t && (t = null), this.emit("before:show", t);
                var e = t || this.options.element;
                if (this.triggerElement = e, !this.isShowning()) {
                    if (this.options.inlineMode) return this.ui.style.position = "relative", this.ui.style.display = "inline-block", this.ui.style.top = null, this.ui.style.left = null, this.ui.style.bottom = null, void (this.ui.style.right = null);
                    this.scrollToDate(t), this.render(), this.ui.style.position = "absolute", this.ui.style.display = "block", this.ui.style.zIndex = this.options.zIndex;
                    var i = this.findPosition(e);
                    this.ui.style.top = i.top + "px", this.ui.style.left = i.left + "px", this.ui.style.right = null, this.ui.style.bottom = null, this.emit("show", t);
                }
            }, s.Litepicker.prototype.hide = function() {
                this.isShowning() && (this.datePicked.length = 0, this.updateInput(), this.options.inlineMode ? this.render() : (this.ui.style.display = "none", this.emit("hide")));
            }, s.Litepicker.prototype.getDate = function() {
                return this.getStartDate();
            }, s.Litepicker.prototype.getStartDate = function() {
                return this.options.startDate ? this.options.startDate.clone() : null;
            }, s.Litepicker.prototype.getEndDate = function() {
                return this.options.endDate ? this.options.endDate.clone() : null;
            }, s.Litepicker.prototype.setDate = function(t, e) {
                void 0 === e && (e = !1);
                var i = new o.DateTime(t, this.options.format, this.options.lang);
                r.dateIsLocked(i, this.options, [
                    i
                ]) && !e ? this.emit("error:date", i) : (this.setStartDate(t), this.options.inlineMode && this.render(), this.emit("selected", this.getDate()));
            }, s.Litepicker.prototype.setStartDate = function(t) {
                t && (this.options.startDate = new o.DateTime(t, this.options.format, this.options.lang), this.updateInput());
            }, s.Litepicker.prototype.setEndDate = function(t) {
                t && (this.options.endDate = new o.DateTime(t, this.options.format, this.options.lang), this.options.startDate.getTime() > this.options.endDate.getTime() && (this.options.endDate = this.options.startDate.clone(), this.options.startDate = new o.DateTime(t, this.options.format, this.options.lang)), this.updateInput());
            }, s.Litepicker.prototype.setDateRange = function(t, e, i) {
                void 0 === i && (i = !1), this.triggerElement = void 0;
                var n = new o.DateTime(t, this.options.format, this.options.lang), s = new o.DateTime(e, this.options.format, this.options.lang);
                (this.options.disallowLockDaysInRange ? r.rangeIsLocked([
                    n,
                    s
                ], this.options) : r.dateIsLocked(n, this.options, [
                    n,
                    s
                ]) || r.dateIsLocked(s, this.options, [
                    n,
                    s
                ])) && !i ? this.emit("error:range", [
                    n,
                    s
                ]) : (this.setStartDate(n), this.setEndDate(s), this.options.inlineMode && this.render(), this.updateInput(), this.emit("selected", this.getStartDate(), this.getEndDate()));
            }, s.Litepicker.prototype.gotoDate = function(t, e) {
                void 0 === e && (e = 0);
                var i = new o.DateTime(t);
                i.setDate(1), this.calendars[e] = i.clone(), this.render();
            }, s.Litepicker.prototype.setLockDays = function(t) {
                this.options.lockDays = o.DateTime.convertArray(t, this.options.lockDaysFormat), this.render();
            }, s.Litepicker.prototype.setHighlightedDays = function(t) {
                this.options.highlightedDays = o.DateTime.convertArray(t, this.options.highlightedDaysFormat), this.render();
            }, s.Litepicker.prototype.setOptions = function(t) {
                delete t.element, delete t.elementEnd, delete t.parentEl, t.startDate && (t.startDate = new o.DateTime(t.startDate, this.options.format, this.options.lang)), t.endDate && (t.endDate = new o.DateTime(t.endDate, this.options.format, this.options.lang));
                var e = n(n({}, this.options.dropdowns), t.dropdowns), i = n(n({}, this.options.buttonText), t.buttonText), s = n(n({}, this.options.tooltipText), t.tooltipText);
                this.options = n(n({}, this.options), t), this.options.dropdowns = n({}, e), this.options.buttonText = n({}, i), this.options.tooltipText = n({}, s), !this.options.singleMode || this.options.startDate instanceof o.DateTime || (this.options.startDate = null, this.options.endDate = null), this.options.singleMode || this.options.startDate instanceof o.DateTime && this.options.endDate instanceof o.DateTime || (this.options.startDate = null, this.options.endDate = null);
                for(var r = 0; r < this.options.numberOfMonths; r += 1){
                    var a = this.options.startDate ? this.options.startDate.clone() : new o.DateTime;
                    a.setDate(1), a.setMonth(a.getMonth() + r), this.calendars[r] = a;
                }
                this.options.lockDays.length && (this.options.lockDays = o.DateTime.convertArray(this.options.lockDays, this.options.lockDaysFormat)), this.options.highlightedDays.length && (this.options.highlightedDays = o.DateTime.convertArray(this.options.highlightedDays, this.options.highlightedDaysFormat)), this.render(), this.options.inlineMode && this.show(), this.updateInput();
            }, s.Litepicker.prototype.clearSelection = function() {
                this.options.startDate = null, this.options.endDate = null, this.datePicked.length = 0, this.updateInput(), this.isShowning() && this.render(), this.emit("clear:selection");
            }, s.Litepicker.prototype.destroy = function() {
                this.ui && this.ui.parentNode && (this.ui.parentNode.removeChild(this.ui), this.ui = null), this.emit("destroy");
            };
        }
    ]);
});

});

parcelRegister("iUSsr", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});


var $91cBK = parcelRequire("91cBK");

var $iUSsr = parcelRequire("iUSsr");
var $67569c21d3f40419$exports = {};
var $67569c21d3f40419$var$d3 = function() {
    var d3 = {
        version: "3.1.5"
    };
    if (!Date.now) Date.now = function() {
        return +new Date();
    };
    var d3_document = document, d3_window = window;
    try {
        d3_document.createElement("div").style.setProperty("opacity", 0, "");
    } catch (error) {
        var d3_style_prototype = d3_window.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
        d3_style_prototype.setProperty = function(name, value, priority) {
            d3_style_setProperty.call(this, name, value + "", priority);
        };
    }
    d3.ascending = function(a, b1) {
        return a < b1 ? -1 : a > b1 ? 1 : a >= b1 ? 0 : NaN;
    };
    d3.descending = function(a, b1) {
        return b1 < a ? -1 : b1 > a ? 1 : b1 >= a ? 0 : NaN;
    };
    d3.min = function(array, f) {
        var i = -1, n = array.length, a, b1;
        if (arguments.length === 1) {
            while(++i < n && ((a = array[i]) == null || a != a))a = undefined;
            while(++i < n)if ((b1 = array[i]) != null && a > b1) a = b1;
        } else {
            while(++i < n && ((a = f.call(array, array[i], i)) == null || a != a))a = undefined;
            while(++i < n)if ((b1 = f.call(array, array[i], i)) != null && a > b1) a = b1;
        }
        return a;
    };
    d3.max = function(array, f) {
        var i = -1, n = array.length, a, b1;
        if (arguments.length === 1) {
            while(++i < n && ((a = array[i]) == null || a != a))a = undefined;
            while(++i < n)if ((b1 = array[i]) != null && b1 > a) a = b1;
        } else {
            while(++i < n && ((a = f.call(array, array[i], i)) == null || a != a))a = undefined;
            while(++i < n)if ((b1 = f.call(array, array[i], i)) != null && b1 > a) a = b1;
        }
        return a;
    };
    d3.extent = function(array, f) {
        var i = -1, n = array.length, a, b1, c;
        if (arguments.length === 1) {
            while(++i < n && ((a = c = array[i]) == null || a != a))a = c = undefined;
            while(++i < n)if ((b1 = array[i]) != null) {
                if (a > b1) a = b1;
                if (c < b1) c = b1;
            }
        } else {
            while(++i < n && ((a = c = f.call(array, array[i], i)) == null || a != a))a = undefined;
            while(++i < n)if ((b1 = f.call(array, array[i], i)) != null) {
                if (a > b1) a = b1;
                if (c < b1) c = b1;
            }
        }
        return [
            a,
            c
        ];
    };
    d3.sum = function(array, f) {
        var s = 0, n = array.length, a, i = -1;
        if (arguments.length === 1) {
            while(++i < n)if (!isNaN(a = +array[i])) s += a;
        } else {
            while(++i < n)if (!isNaN(a = +f.call(array, array[i], i))) s += a;
        }
        return s;
    };
    function d3_number(x) {
        return x != null && !isNaN(x);
    }
    d3.mean = function(array, f) {
        var n = array.length, a, m = 0, i = -1, j = 0;
        if (arguments.length === 1) {
            while(++i < n)if (d3_number(a = array[i])) m += (a - m) / ++j;
        } else {
            while(++i < n)if (d3_number(a = f.call(array, array[i], i))) m += (a - m) / ++j;
        }
        return j ? m : undefined;
    };
    d3.quantile = function(values, p) {
        var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
        return e ? v + e * (values[h] - v) : v;
    };
    d3.median = function(array, f) {
        if (arguments.length > 1) array = array.map(f);
        array = array.filter(d3_number);
        return array.length ? d3.quantile(array.sort(d3.ascending), .5) : undefined;
    };
    d3.bisector = function(f) {
        return {
            left: function(a, x, lo, hi) {
                if (arguments.length < 3) lo = 0;
                if (arguments.length < 4) hi = a.length;
                while(lo < hi){
                    var mid = lo + hi >>> 1;
                    if (f.call(a, a[mid], mid) < x) lo = mid + 1;
                    else hi = mid;
                }
                return lo;
            },
            right: function(a, x, lo, hi) {
                if (arguments.length < 3) lo = 0;
                if (arguments.length < 4) hi = a.length;
                while(lo < hi){
                    var mid = lo + hi >>> 1;
                    if (x < f.call(a, a[mid], mid)) hi = mid;
                    else lo = mid + 1;
                }
                return lo;
            }
        };
    };
    var d3_bisector = d3.bisector(function(d) {
        return d;
    });
    d3.bisectLeft = d3_bisector.left;
    d3.bisect = d3.bisectRight = d3_bisector.right;
    d3.shuffle = function(array) {
        var m = array.length, t, i;
        while(m){
            i = Math.random() * m-- | 0;
            t = array[m], array[m] = array[i], array[i] = t;
        }
        return array;
    };
    d3.permute = function(array, indexes) {
        var permutes = [], i = -1, n = indexes.length;
        while(++i < n)permutes[i] = array[indexes[i]];
        return permutes;
    };
    d3.zip = function() {
        if (!(n = arguments.length)) return [];
        for(var i = -1, m = d3.min(arguments, d3_zipLength), zips = new Array(m); ++i < m;)for(var j = -1, n, zip = zips[i] = new Array(n); ++j < n;)zip[j] = arguments[j][i];
        return zips;
    };
    function d3_zipLength(d) {
        return d.length;
    }
    d3.transpose = function(matrix) {
        return d3.zip.apply(d3, matrix);
    };
    d3.keys = function(map) {
        var keys = [];
        for(var key in map)keys.push(key);
        return keys;
    };
    d3.values = function(map) {
        var values = [];
        for(var key in map)values.push(map[key]);
        return values;
    };
    d3.entries = function(map) {
        var entries = [];
        for(var key in map)entries.push({
            key: key,
            value: map[key]
        });
        return entries;
    };
    d3.merge = function(arrays) {
        return Array.prototype.concat.apply([], arrays);
    };
    d3.range = function(start, stop, step) {
        if (arguments.length < 3) {
            step = 1;
            if (arguments.length < 2) {
                stop = start;
                start = 0;
            }
        }
        if ((stop - start) / step === Infinity) throw new Error("infinite range");
        var range = [], k = d3_range_integerScale(Math.abs(step)), i = -1, j;
        start *= k, stop *= k, step *= k;
        if (step < 0) while((j = start + step * ++i) > stop)range.push(j / k);
        else while((j = start + step * ++i) < stop)range.push(j / k);
        return range;
    };
    function d3_range_integerScale(x) {
        var k = 1;
        while(x * k % 1)k *= 10;
        return k;
    }
    function d3_class(ctor, properties) {
        try {
            for(var key in properties)Object.defineProperty(ctor.prototype, key, {
                value: properties[key],
                enumerable: false
            });
        } catch (e) {
            ctor.prototype = properties;
        }
    }
    d3.map = function(object) {
        var map = new d3_Map();
        for(var key in object)map.set(key, object[key]);
        return map;
    };
    function d3_Map() {}
    d3_class(d3_Map, {
        has: function(key) {
            return d3_map_prefix + key in this;
        },
        get: function(key) {
            return this[d3_map_prefix + key];
        },
        set: function(key, value) {
            return this[d3_map_prefix + key] = value;
        },
        remove: function(key) {
            key = d3_map_prefix + key;
            return key in this && delete this[key];
        },
        keys: function() {
            var keys = [];
            this.forEach(function(key) {
                keys.push(key);
            });
            return keys;
        },
        values: function() {
            var values = [];
            this.forEach(function(key, value) {
                values.push(value);
            });
            return values;
        },
        entries: function() {
            var entries = [];
            this.forEach(function(key, value) {
                entries.push({
                    key: key,
                    value: value
                });
            });
            return entries;
        },
        forEach: function(f) {
            for(var key in this)if (key.charCodeAt(0) === d3_map_prefixCode) f.call(this, key.substring(1), this[key]);
        }
    });
    var d3_map_prefix = "\0", d3_map_prefixCode = d3_map_prefix.charCodeAt(0);
    d3.nest = function() {
        var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
        function map(mapType, array, depth) {
            if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
            var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
            while(++i < n)if (values = valuesByKey.get(keyValue = key(object = array[i]))) values.push(object);
            else valuesByKey.set(keyValue, [
                object
            ]);
            if (mapType) {
                object = mapType();
                setter = function(keyValue, values) {
                    object.set(keyValue, map(mapType, values, depth));
                };
            } else {
                object = {};
                setter = function(keyValue, values) {
                    object[keyValue] = map(mapType, values, depth);
                };
            }
            valuesByKey.forEach(setter);
            return object;
        }
        function entries(map, depth) {
            if (depth >= keys.length) return map;
            var array = [], sortKey = sortKeys[depth++];
            map.forEach(function(key, keyMap) {
                array.push({
                    key: key,
                    values: entries(keyMap, depth)
                });
            });
            return sortKey ? array.sort(function(a, b1) {
                return sortKey(a.key, b1.key);
            }) : array;
        }
        nest.map = function(array, mapType) {
            return map(mapType, array, 0);
        };
        nest.entries = function(array) {
            return entries(map(d3.map, array, 0), 0);
        };
        nest.key = function(d) {
            keys.push(d);
            return nest;
        };
        nest.sortKeys = function(order) {
            sortKeys[keys.length - 1] = order;
            return nest;
        };
        nest.sortValues = function(order) {
            sortValues = order;
            return nest;
        };
        nest.rollup = function(f) {
            rollup = f;
            return nest;
        };
        return nest;
    };
    d3.set = function(array) {
        var set = new d3_Set();
        if (array) for(var i = 0; i < array.length; i++)set.add(array[i]);
        return set;
    };
    function d3_Set() {}
    d3_class(d3_Set, {
        has: function(value) {
            return d3_map_prefix + value in this;
        },
        add: function(value) {
            this[d3_map_prefix + value] = true;
            return value;
        },
        remove: function(value) {
            value = d3_map_prefix + value;
            return value in this && delete this[value];
        },
        values: function() {
            var values = [];
            this.forEach(function(value) {
                values.push(value);
            });
            return values;
        },
        forEach: function(f) {
            for(var value in this)if (value.charCodeAt(0) === d3_map_prefixCode) f.call(this, value.substring(1));
        }
    });
    d3.behavior = {};
    d3.rebind = function(target, source) {
        var i = 1, n = arguments.length, method;
        while(++i < n)target[method = arguments[i]] = d3_rebind(target, source, source[method]);
        return target;
    };
    function d3_rebind(target, source, method) {
        return function() {
            var value = method.apply(source, arguments);
            return value === source ? target : value;
        };
    }
    d3.dispatch = function() {
        var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
        while(++i < n)dispatch[arguments[i]] = d3_dispatch_event(dispatch);
        return dispatch;
    };
    function d3_dispatch() {}
    d3_dispatch.prototype.on = function(type, listener) {
        var i = type.indexOf("."), name = "";
        if (i >= 0) {
            name = type.substring(i + 1);
            type = type.substring(0, i);
        }
        if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
        if (arguments.length === 2) {
            if (listener == null) {
                for(type in this)if (this.hasOwnProperty(type)) this[type].on(name, null);
            }
            return this;
        }
    };
    function d3_dispatch_event(dispatch) {
        var listeners = [], listenerByName = new d3_Map();
        function event() {
            var z = listeners, i = -1, n = z.length, l;
            while(++i < n)if (l = z[i].on) l.apply(this, arguments);
            return dispatch;
        }
        event.on = function(name, listener) {
            var l = listenerByName.get(name), i;
            if (arguments.length < 2) return l && l.on;
            if (l) {
                l.on = null;
                listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
                listenerByName.remove(name);
            }
            if (listener) listeners.push(listenerByName.set(name, {
                on: listener
            }));
            return dispatch;
        };
        return event;
    }
    d3.event = null;
    function d3_eventCancel() {
        d3.event.stopPropagation();
        d3.event.preventDefault();
    }
    function d3_eventSource() {
        var e = d3.event, s;
        while(s = e.sourceEvent)e = s;
        return e;
    }
    function d3_eventSuppress(target, type) {
        function off() {
            target.on(type, null);
        }
        target.on(type, function() {
            d3_eventCancel();
            off();
        }, true);
        setTimeout(off, 0);
    }
    function d3_eventDispatch(target) {
        var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
        while(++i < n)dispatch[arguments[i]] = d3_dispatch_event(dispatch);
        dispatch.of = function(thiz, argumentz) {
            return function(e1) {
                try {
                    var e0 = e1.sourceEvent = d3.event;
                    e1.target = target;
                    d3.event = e1;
                    dispatch[e1.type].apply(thiz, argumentz);
                } finally{
                    d3.event = e0;
                }
            };
        };
        return dispatch;
    }
    d3.mouse = function(container) {
        return d3_mousePoint(container, d3_eventSource());
    };
    var d3_mouse_bug44083 = /WebKit/.test(d3_window.navigator.userAgent) ? -1 : 0;
    function d3_mousePoint(container, e) {
        var svg = container.ownerSVGElement || container;
        if (svg.createSVGPoint) {
            var point = svg.createSVGPoint();
            if (d3_mouse_bug44083 < 0 && (d3_window.scrollX || d3_window.scrollY)) {
                svg = d3.select(d3_document.body).append("svg").style("position", "absolute").style("top", 0).style("left", 0);
                var ctm = svg[0][0].getScreenCTM();
                d3_mouse_bug44083 = !(ctm.f || ctm.e);
                svg.remove();
            }
            if (d3_mouse_bug44083) {
                point.x = e.pageX;
                point.y = e.pageY;
            } else {
                point.x = e.clientX;
                point.y = e.clientY;
            }
            point = point.matrixTransform(container.getScreenCTM().inverse());
            return [
                point.x,
                point.y
            ];
        }
        var rect = container.getBoundingClientRect();
        return [
            e.clientX - rect.left - container.clientLeft,
            e.clientY - rect.top - container.clientTop
        ];
    }
    var d3_array = d3_arraySlice;
    function d3_arrayCopy(pseudoarray) {
        var i = -1, n = pseudoarray.length, array = [];
        while(++i < n)array.push(pseudoarray[i]);
        return array;
    }
    function d3_arraySlice(pseudoarray) {
        return Array.prototype.slice.call(pseudoarray);
    }
    try {
        d3_array(d3_document.documentElement.childNodes)[0].nodeType;
    } catch (e) {
        d3_array = d3_arrayCopy;
    }
    var d3_arraySubclass = [].__proto__ ? function(array, prototype) {
        array.__proto__ = prototype;
    } : function(array, prototype) {
        for(var property in prototype)array[property] = prototype[property];
    };
    d3.touches = function(container, touches) {
        if (arguments.length < 2) touches = d3_eventSource().touches;
        return touches ? d3_array(touches).map(function(touch) {
            var point = d3_mousePoint(container, touch);
            point.identifier = touch.identifier;
            return point;
        }) : [];
    };
    d3.behavior.drag = function() {
        var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null;
        function drag() {
            this.on("mousedown.drag", mousedown).on("touchstart.drag", mousedown);
        }
        function mousedown() {
            var target = this, event_ = event.of(target, arguments), eventTarget = d3.event.target, touchId = d3.event.touches ? d3.event.changedTouches[0].identifier : null, offset, origin_ = point(), moved = 0;
            var w = d3.select(d3_window).on(touchId != null ? "touchmove.drag-" + touchId : "mousemove.drag", dragmove).on(touchId != null ? "touchend.drag-" + touchId : "mouseup.drag", dragend, true);
            if (origin) {
                offset = origin.apply(target, arguments);
                offset = [
                    offset.x - origin_[0],
                    offset.y - origin_[1]
                ];
            } else offset = [
                0,
                0
            ];
            if (touchId == null) d3_eventCancel();
            event_({
                type: "dragstart"
            });
            function point() {
                var p = target.parentNode;
                return touchId != null ? d3.touches(p).filter(function(p) {
                    return p.identifier === touchId;
                })[0] : d3.mouse(p);
            }
            function dragmove() {
                if (!target.parentNode) return dragend();
                var p = point(), dx = p[0] - origin_[0], dy = p[1] - origin_[1];
                moved |= dx | dy;
                origin_ = p;
                d3_eventCancel();
                event_({
                    type: "drag",
                    x: p[0] + offset[0],
                    y: p[1] + offset[1],
                    dx: dx,
                    dy: dy
                });
            }
            function dragend() {
                event_({
                    type: "dragend"
                });
                if (moved) {
                    d3_eventCancel();
                    if (d3.event.target === eventTarget) d3_eventSuppress(w, "click");
                }
                w.on(touchId != null ? "touchmove.drag-" + touchId : "mousemove.drag", null).on(touchId != null ? "touchend.drag-" + touchId : "mouseup.drag", null);
            }
        }
        drag.origin = function(x) {
            if (!arguments.length) return origin;
            origin = x;
            return drag;
        };
        return d3.rebind(drag, event, "on");
    };
    function d3_selection(groups) {
        d3_arraySubclass(groups, d3_selectionPrototype);
        return groups;
    }
    var d3_select = function(s, n) {
        return n.querySelector(s);
    }, d3_selectAll = function(s, n) {
        return n.querySelectorAll(s);
    }, d3_selectRoot = d3_document.documentElement, d3_selectMatcher = d3_selectRoot.matchesSelector || d3_selectRoot.webkitMatchesSelector || d3_selectRoot.mozMatchesSelector || d3_selectRoot.msMatchesSelector || d3_selectRoot.oMatchesSelector, d3_selectMatches = function(n, s) {
        return d3_selectMatcher.call(n, s);
    };
    if (typeof Sizzle === "function") {
        d3_select = function(s, n) {
            return Sizzle(s, n)[0] || null;
        };
        d3_selectAll = function(s, n) {
            return Sizzle.uniqueSort(Sizzle(s, n));
        };
        d3_selectMatches = Sizzle.matchesSelector;
    }
    var d3_selectionPrototype = [];
    d3.selection = function() {
        return d3_selectionRoot;
    };
    d3.selection.prototype = d3_selectionPrototype;
    d3_selectionPrototype.select = function(selector) {
        var subgroups = [], subgroup, subnode, group, node;
        if (typeof selector !== "function") selector = d3_selection_selector(selector);
        for(var j = -1, m = this.length; ++j < m;){
            subgroups.push(subgroup = []);
            subgroup.parentNode = (group = this[j]).parentNode;
            for(var i = -1, n = group.length; ++i < n;)if (node = group[i]) {
                subgroup.push(subnode = selector.call(node, node.__data__, i));
                if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
            } else subgroup.push(null);
        }
        return d3_selection(subgroups);
    };
    function d3_selection_selector(selector) {
        return function() {
            return d3_select(selector, this);
        };
    }
    d3_selectionPrototype.selectAll = function(selector) {
        var subgroups = [], subgroup, node;
        if (typeof selector !== "function") selector = d3_selection_selectorAll(selector);
        for(var j = -1, m = this.length; ++j < m;){
            for(var group = this[j], i = -1, n = group.length; ++i < n;)if (node = group[i]) {
                subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i)));
                subgroup.parentNode = node;
            }
        }
        return d3_selection(subgroups);
    };
    function d3_selection_selectorAll(selector) {
        return function() {
            return d3_selectAll(selector, this);
        };
    }
    var d3_nsPrefix = {
        svg: "http://www.w3.org/2000/svg",
        xhtml: "http://www.w3.org/1999/xhtml",
        xlink: "http://www.w3.org/1999/xlink",
        xml: "http://www.w3.org/XML/1998/namespace",
        xmlns: "http://www.w3.org/2000/xmlns/"
    };
    d3.ns = {
        prefix: d3_nsPrefix,
        qualify: function(name) {
            var i = name.indexOf(":"), prefix = name;
            if (i >= 0) {
                prefix = name.substring(0, i);
                name = name.substring(i + 1);
            }
            return d3_nsPrefix.hasOwnProperty(prefix) ? {
                space: d3_nsPrefix[prefix],
                local: name
            } : name;
        }
    };
    d3_selectionPrototype.attr = function(name, value) {
        if (arguments.length < 2) {
            if (typeof name === "string") {
                var node = this.node();
                name = d3.ns.qualify(name);
                return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
            }
            for(value in name)this.each(d3_selection_attr(value, name[value]));
            return this;
        }
        return this.each(d3_selection_attr(name, value));
    };
    function d3_selection_attr(name, value) {
        name = d3.ns.qualify(name);
        function attrNull() {
            this.removeAttribute(name);
        }
        function attrNullNS() {
            this.removeAttributeNS(name.space, name.local);
        }
        function attrConstant() {
            this.setAttribute(name, value);
        }
        function attrConstantNS() {
            this.setAttributeNS(name.space, name.local, value);
        }
        function attrFunction() {
            var x = value.apply(this, arguments);
            if (x == null) this.removeAttribute(name);
            else this.setAttribute(name, x);
        }
        function attrFunctionNS() {
            var x = value.apply(this, arguments);
            if (x == null) this.removeAttributeNS(name.space, name.local);
            else this.setAttributeNS(name.space, name.local, x);
        }
        return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
    }
    function d3_collapse(s) {
        return s.trim().replace(/\s+/g, " ");
    }
    d3.requote = function(s) {
        return s.replace(d3_requote_re, "\\$&");
    };
    var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
    d3_selectionPrototype.classed = function(name, value) {
        if (arguments.length < 2) {
            if (typeof name === "string") {
                var node = this.node(), n = (name = name.trim().split(/^|\s+/g)).length, i = -1;
                if (value = node.classList) {
                    while(++i < n)if (!value.contains(name[i])) return false;
                } else {
                    value = node.getAttribute("class");
                    while(++i < n)if (!d3_selection_classedRe(name[i]).test(value)) return false;
                }
                return true;
            }
            for(value in name)this.each(d3_selection_classed(value, name[value]));
            return this;
        }
        return this.each(d3_selection_classed(name, value));
    };
    function d3_selection_classedRe(name) {
        return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
    }
    function d3_selection_classed(name, value) {
        name = name.trim().split(/\s+/).map(d3_selection_classedName);
        var n = name.length;
        function classedConstant() {
            var i = -1;
            while(++i < n)name[i](this, value);
        }
        function classedFunction() {
            var i = -1, x = value.apply(this, arguments);
            while(++i < n)name[i](this, x);
        }
        return typeof value === "function" ? classedFunction : classedConstant;
    }
    function d3_selection_classedName(name) {
        var re = d3_selection_classedRe(name);
        return function(node, value) {
            if (c = node.classList) return value ? c.add(name) : c.remove(name);
            var c = node.getAttribute("class") || "";
            if (value) {
                re.lastIndex = 0;
                if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
            } else node.setAttribute("class", d3_collapse(c.replace(re, " ")));
        };
    }
    d3_selectionPrototype.style = function(name, value, priority) {
        var n = arguments.length;
        if (n < 3) {
            if (typeof name !== "string") {
                if (n < 2) value = "";
                for(priority in name)this.each(d3_selection_style(priority, name[priority], value));
                return this;
            }
            if (n < 2) return d3_window.getComputedStyle(this.node(), null).getPropertyValue(name);
            priority = "";
        }
        return this.each(d3_selection_style(name, value, priority));
    };
    function d3_selection_style(name, value, priority) {
        function styleNull() {
            this.style.removeProperty(name);
        }
        function styleConstant() {
            this.style.setProperty(name, value, priority);
        }
        function styleFunction() {
            var x = value.apply(this, arguments);
            if (x == null) this.style.removeProperty(name);
            else this.style.setProperty(name, x, priority);
        }
        return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
    }
    d3_selectionPrototype.property = function(name, value) {
        if (arguments.length < 2) {
            if (typeof name === "string") return this.node()[name];
            for(value in name)this.each(d3_selection_property(value, name[value]));
            return this;
        }
        return this.each(d3_selection_property(name, value));
    };
    function d3_selection_property(name, value) {
        function propertyNull() {
            delete this[name];
        }
        function propertyConstant() {
            this[name] = value;
        }
        function propertyFunction() {
            var x = value.apply(this, arguments);
            if (x == null) delete this[name];
            else this[name] = x;
        }
        return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
    }
    d3_selectionPrototype.text = function(value) {
        return arguments.length ? this.each(typeof value === "function" ? function() {
            var v = value.apply(this, arguments);
            this.textContent = v == null ? "" : v;
        } : value == null ? function() {
            this.textContent = "";
        } : function() {
            this.textContent = value;
        }) : this.node().textContent;
    };
    d3_selectionPrototype.html = function(value) {
        return arguments.length ? this.each(typeof value === "function" ? function() {
            var v = value.apply(this, arguments);
            this.innerHTML = v == null ? "" : v;
        } : value == null ? function() {
            this.innerHTML = "";
        } : function() {
            this.innerHTML = value;
        }) : this.node().innerHTML;
    };
    d3_selectionPrototype.append = function(name) {
        name = d3.ns.qualify(name);
        function append() {
            return this.appendChild(d3_document.createElementNS(this.namespaceURI, name));
        }
        function appendNS() {
            return this.appendChild(d3_document.createElementNS(name.space, name.local));
        }
        return this.select(name.local ? appendNS : append);
    };
    d3_selectionPrototype.insert = function(name, before) {
        name = d3.ns.qualify(name);
        if (typeof before !== "function") before = d3_selection_selector(before);
        function insert(d, i) {
            return this.insertBefore(d3_document.createElementNS(this.namespaceURI, name), before.call(this, d, i));
        }
        function insertNS(d, i) {
            return this.insertBefore(d3_document.createElementNS(name.space, name.local), before.call(this, d, i));
        }
        return this.select(name.local ? insertNS : insert);
    };
    d3_selectionPrototype.remove = function() {
        return this.each(function() {
            var parent = this.parentNode;
            if (parent) parent.removeChild(this);
        });
    };
    d3_selectionPrototype.data = function(value, key) {
        var i = -1, n = this.length, group, node;
        if (!arguments.length) {
            value = new Array(n = (group = this[0]).length);
            while(++i < n)if (node = group[i]) value[i] = node.__data__;
            return value;
        }
        function bind(group, groupData) {
            var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
            if (key) {
                var nodeByKeyValue = new d3_Map(), dataByKeyValue = new d3_Map(), keyValues = [], keyValue;
                for(i = -1; ++i < n;){
                    keyValue = key.call(node = group[i], node.__data__, i);
                    if (nodeByKeyValue.has(keyValue)) exitNodes[i] = node;
                    else nodeByKeyValue.set(keyValue, node);
                    keyValues.push(keyValue);
                }
                for(i = -1; ++i < m;){
                    keyValue = key.call(groupData, nodeData = groupData[i], i);
                    if (node = nodeByKeyValue.get(keyValue)) {
                        updateNodes[i] = node;
                        node.__data__ = nodeData;
                    } else if (!dataByKeyValue.has(keyValue)) enterNodes[i] = d3_selection_dataNode(nodeData);
                    dataByKeyValue.set(keyValue, nodeData);
                    nodeByKeyValue.remove(keyValue);
                }
                for(i = -1; ++i < n;)if (nodeByKeyValue.has(keyValues[i])) exitNodes[i] = group[i];
            } else {
                for(i = -1; ++i < n0;){
                    node = group[i];
                    nodeData = groupData[i];
                    if (node) {
                        node.__data__ = nodeData;
                        updateNodes[i] = node;
                    } else enterNodes[i] = d3_selection_dataNode(nodeData);
                }
                for(; i < m; ++i)enterNodes[i] = d3_selection_dataNode(groupData[i]);
                for(; i < n; ++i)exitNodes[i] = group[i];
            }
            enterNodes.update = updateNodes;
            enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
            enter.push(enterNodes);
            update.push(updateNodes);
            exit.push(exitNodes);
        }
        var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
        if (typeof value === "function") while(++i < n)bind(group = this[i], value.call(group, group.parentNode.__data__, i));
        else while(++i < n)bind(group = this[i], value);
        update.enter = function() {
            return enter;
        };
        update.exit = function() {
            return exit;
        };
        return update;
    };
    function d3_selection_dataNode(data) {
        return {
            __data__: data
        };
    }
    d3_selectionPrototype.datum = function(value) {
        return arguments.length ? this.property("__data__", value) : this.property("__data__");
    };
    d3_selectionPrototype.filter = function(filter) {
        var subgroups = [], subgroup, group, node;
        if (typeof filter !== "function") filter = d3_selection_filter(filter);
        for(var j = 0, m = this.length; j < m; j++){
            subgroups.push(subgroup = []);
            subgroup.parentNode = (group = this[j]).parentNode;
            for(var i = 0, n = group.length; i < n; i++)if ((node = group[i]) && filter.call(node, node.__data__, i)) subgroup.push(node);
        }
        return d3_selection(subgroups);
    };
    function d3_selection_filter(selector) {
        return function() {
            return d3_selectMatches(this, selector);
        };
    }
    d3_selectionPrototype.order = function() {
        for(var j = -1, m = this.length; ++j < m;){
            for(var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
                if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
                next = node;
            }
        }
        return this;
    };
    d3_selectionPrototype.sort = function(comparator) {
        comparator = d3_selection_sortComparator.apply(this, arguments);
        for(var j = -1, m = this.length; ++j < m;)this[j].sort(comparator);
        return this.order();
    };
    function d3_selection_sortComparator(comparator) {
        if (!arguments.length) comparator = d3.ascending;
        return function(a, b1) {
            return !a - !b1 || comparator(a.__data__, b1.__data__);
        };
    }
    function d3_noop() {}
    d3_selectionPrototype.on = function(type, listener, capture) {
        var n = arguments.length;
        if (n < 3) {
            if (typeof type !== "string") {
                if (n < 2) listener = false;
                for(capture in type)this.each(d3_selection_on(capture, type[capture], listener));
                return this;
            }
            if (n < 2) return (n = this.node()["__on" + type]) && n._;
            capture = false;
        }
        return this.each(d3_selection_on(type, listener, capture));
    };
    function d3_selection_on(type, listener, capture) {
        var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
        if (i > 0) type = type.substring(0, i);
        var filter = d3_selection_onFilters.get(type);
        if (filter) type = filter, wrap = d3_selection_onFilter;
        function onRemove() {
            var l = this[name];
            if (l) {
                this.removeEventListener(type, l, l.$);
                delete this[name];
            }
        }
        function onAdd() {
            var l = wrap(listener, d3_array(arguments));
            onRemove.call(this);
            this.addEventListener(type, this[name] = l, l.$ = capture);
            l._ = listener;
        }
        function removeAll() {
            var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
            for(var name in this)if (match = name.match(re)) {
                var l = this[name];
                this.removeEventListener(match[1], l, l.$);
                delete this[name];
            }
        }
        return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
    }
    var d3_selection_onFilters = d3.map({
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    });
    d3_selection_onFilters.forEach(function(k) {
        if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
    });
    function d3_selection_onListener(listener, argumentz) {
        return function(e) {
            var o = d3.event;
            d3.event = e;
            argumentz[0] = this.__data__;
            try {
                listener.apply(this, argumentz);
            } finally{
                d3.event = o;
            }
        };
    }
    function d3_selection_onFilter(listener, argumentz) {
        var l = d3_selection_onListener(listener, argumentz);
        return function(e) {
            var target = this, related = e.relatedTarget;
            if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) l.call(target, e);
        };
    }
    d3_selectionPrototype.each = function(callback) {
        return d3_selection_each(this, function(node, i, j) {
            callback.call(node, node.__data__, i, j);
        });
    };
    function d3_selection_each(groups, callback) {
        for(var j = 0, m = groups.length; j < m; j++){
            for(var group = groups[j], i = 0, n = group.length, node; i < n; i++)if (node = group[i]) callback(node, i, j);
        }
        return groups;
    }
    d3_selectionPrototype.call = function(callback) {
        var args = d3_array(arguments);
        callback.apply(args[0] = this, args);
        return this;
    };
    d3_selectionPrototype.empty = function() {
        return !this.node();
    };
    d3_selectionPrototype.node = function() {
        for(var j = 0, m = this.length; j < m; j++)for(var group = this[j], i = 0, n = group.length; i < n; i++){
            var node = group[i];
            if (node) return node;
        }
        return null;
    };
    function d3_selection_enter(selection) {
        d3_arraySubclass(selection, d3_selection_enterPrototype);
        return selection;
    }
    var d3_selection_enterPrototype = [];
    d3.selection.enter = d3_selection_enter;
    d3.selection.enter.prototype = d3_selection_enterPrototype;
    d3_selection_enterPrototype.append = d3_selectionPrototype.append;
    d3_selection_enterPrototype.insert = d3_selectionPrototype.insert;
    d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
    d3_selection_enterPrototype.node = d3_selectionPrototype.node;
    d3_selection_enterPrototype.select = function(selector) {
        var subgroups = [], subgroup, subnode, upgroup, group, node;
        for(var j = -1, m = this.length; ++j < m;){
            upgroup = (group = this[j]).update;
            subgroups.push(subgroup = []);
            subgroup.parentNode = group.parentNode;
            for(var i = -1, n = group.length; ++i < n;)if (node = group[i]) {
                subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i));
                subnode.__data__ = node.__data__;
            } else subgroup.push(null);
        }
        return d3_selection(subgroups);
    };
    d3_selectionPrototype.transition = function() {
        var id = d3_transitionInheritId || ++d3_transitionId, subgroups = [], subgroup, node, transition = Object.create(d3_transitionInherit);
        transition.time = Date.now();
        for(var j = -1, m = this.length; ++j < m;){
            subgroups.push(subgroup = []);
            for(var group = this[j], i = -1, n = group.length; ++i < n;){
                if (node = group[i]) d3_transitionNode(node, i, id, transition);
                subgroup.push(node);
            }
        }
        return d3_transition(subgroups, id);
    };
    var d3_selectionRoot = d3_selection([
        [
            d3_document
        ]
    ]);
    d3_selectionRoot[0].parentNode = d3_selectRoot;
    d3.select = function(selector) {
        return typeof selector === "string" ? d3_selectionRoot.select(selector) : d3_selection([
            [
                selector
            ]
        ]);
    };
    d3.selectAll = function(selector) {
        return typeof selector === "string" ? d3_selectionRoot.selectAll(selector) : d3_selection([
            d3_array(selector)
        ]);
    };
    d3.behavior.zoom = function() {
        var translate = [
            0,
            0
        ], translate0, scale = 1, scale0, scaleExtent = d3_behavior_zoomInfinity, event = d3_eventDispatch(zoom, "zoom"), x0, x1, y0, y1, touchtime;
        function zoom() {
            this.on("mousedown.zoom", mousedown).on("mousemove.zoom", mousemove).on(d3_behavior_zoomWheel + ".zoom", mousewheel).on("dblclick.zoom", dblclick).on("touchstart.zoom", touchstart).on("touchmove.zoom", touchmove).on("touchend.zoom", touchstart);
        }
        zoom.translate = function(x) {
            if (!arguments.length) return translate;
            translate = x.map(Number);
            rescale();
            return zoom;
        };
        zoom.scale = function(x) {
            if (!arguments.length) return scale;
            scale = +x;
            rescale();
            return zoom;
        };
        zoom.scaleExtent = function(x) {
            if (!arguments.length) return scaleExtent;
            scaleExtent = x == null ? d3_behavior_zoomInfinity : x.map(Number);
            return zoom;
        };
        zoom.x = function(z) {
            if (!arguments.length) return x1;
            x1 = z;
            x0 = z.copy();
            translate = [
                0,
                0
            ];
            scale = 1;
            return zoom;
        };
        zoom.y = function(z) {
            if (!arguments.length) return y1;
            y1 = z;
            y0 = z.copy();
            translate = [
                0,
                0
            ];
            scale = 1;
            return zoom;
        };
        function location(p) {
            return [
                (p[0] - translate[0]) / scale,
                (p[1] - translate[1]) / scale
            ];
        }
        function point(l) {
            return [
                l[0] * scale + translate[0],
                l[1] * scale + translate[1]
            ];
        }
        function scaleTo(s) {
            scale = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
        }
        function translateTo(p, l) {
            l = point(l);
            translate[0] += p[0] - l[0];
            translate[1] += p[1] - l[1];
        }
        function rescale() {
            if (x1) x1.domain(x0.range().map(function(x) {
                return (x - translate[0]) / scale;
            }).map(x0.invert));
            if (y1) y1.domain(y0.range().map(function(y) {
                return (y - translate[1]) / scale;
            }).map(y0.invert));
        }
        function dispatch(event) {
            rescale();
            d3.event.preventDefault();
            event({
                type: "zoom",
                scale: scale,
                translate: translate
            });
        }
        function mousedown() {
            var target = this, event_ = event.of(target, arguments), eventTarget = d3.event.target, moved = 0, w = d3.select(d3_window).on("mousemove.zoom", mousemove).on("mouseup.zoom", mouseup), l = location(d3.mouse(target));
            d3_window.focus();
            d3_eventCancel();
            function mousemove() {
                moved = 1;
                translateTo(d3.mouse(target), l);
                dispatch(event_);
            }
            function mouseup() {
                if (moved) d3_eventCancel();
                w.on("mousemove.zoom", null).on("mouseup.zoom", null);
                if (moved && d3.event.target === eventTarget) d3_eventSuppress(w, "click.zoom");
            }
        }
        function mousewheel() {
            if (!translate0) translate0 = location(d3.mouse(this));
            scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * scale);
            translateTo(d3.mouse(this), translate0);
            dispatch(event.of(this, arguments));
        }
        function mousemove() {
            translate0 = null;
        }
        function dblclick() {
            var p = d3.mouse(this), l = location(p), k = Math.log(scale) / Math.LN2;
            scaleTo(Math.pow(2, d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1));
            translateTo(p, l);
            dispatch(event.of(this, arguments));
        }
        function touchstart() {
            var touches = d3.touches(this), now = Date.now();
            scale0 = scale;
            translate0 = {};
            touches.forEach(function(t) {
                translate0[t.identifier] = location(t);
            });
            d3_eventCancel();
            if (touches.length === 1) {
                if (now - touchtime < 500) {
                    var p = touches[0], l = location(touches[0]);
                    scaleTo(scale * 2);
                    translateTo(p, l);
                    dispatch(event.of(this, arguments));
                }
                touchtime = now;
            }
        }
        function touchmove() {
            var touches = d3.touches(this), p0 = touches[0], l0 = translate0[p0.identifier];
            if (p1 = touches[1]) {
                var p1, l1 = translate0[p1.identifier];
                p0 = [
                    (p0[0] + p1[0]) / 2,
                    (p0[1] + p1[1]) / 2
                ];
                l0 = [
                    (l0[0] + l1[0]) / 2,
                    (l0[1] + l1[1]) / 2
                ];
                scaleTo(d3.event.scale * scale0);
            }
            translateTo(p0, l0);
            touchtime = null;
            dispatch(event.of(this, arguments));
        }
        return d3.rebind(zoom, event, "on");
    };
    var d3_behavior_zoomInfinity = [
        0,
        Infinity
    ];
    var d3_behavior_zoomDelta, d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
    }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
        return d3.event.wheelDelta;
    }, "mousewheel") : (d3_behavior_zoomDelta = function() {
        return -d3.event.detail;
    }, "MozMousePixelScroll");
    function d3_Color() {}
    d3_Color.prototype.toString = function() {
        return this.rgb() + "";
    };
    d3.hsl = function(h, s, l) {
        return arguments.length === 1 ? h instanceof d3_Hsl ? d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : d3_hsl(+h, +s, +l);
    };
    function d3_hsl(h, s, l) {
        return new d3_Hsl(h, s, l);
    }
    function d3_Hsl(h, s, l) {
        this.h = h;
        this.s = s;
        this.l = l;
    }
    var d3_hslPrototype = d3_Hsl.prototype = new d3_Color();
    d3_hslPrototype.brighter = function(k) {
        k = Math.pow(.7, arguments.length ? k : 1);
        return d3_hsl(this.h, this.s, this.l / k);
    };
    d3_hslPrototype.darker = function(k) {
        k = Math.pow(.7, arguments.length ? k : 1);
        return d3_hsl(this.h, this.s, k * this.l);
    };
    d3_hslPrototype.rgb = function() {
        return d3_hsl_rgb(this.h, this.s, this.l);
    };
    function d3_hsl_rgb(h, s, l) {
        var m1, m2;
        h = h % 360;
        if (h < 0) h += 360;
        s = s < 0 ? 0 : s > 1 ? 1 : s;
        l = l < 0 ? 0 : l > 1 ? 1 : l;
        m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
        m1 = 2 * l - m2;
        function v(h) {
            if (h > 360) h -= 360;
            else if (h < 0) h += 360;
            if (h < 60) return m1 + (m2 - m1) * h / 60;
            if (h < 180) return m2;
            if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
            return m1;
        }
        function vv(h) {
            return Math.round(v(h) * 255);
        }
        return d3_rgb(vv(h + 120), vv(h), vv(h - 120));
    }
    var \u03C0 = Math.PI, \u03B5 = 1e-6, d3_radians = \u03C0 / 180, d3_degrees = 180 / \u03C0;
    function d3_sgn(x) {
        return x > 0 ? 1 : x < 0 ? -1 : 0;
    }
    function d3_acos(x) {
        return Math.acos(Math.max(-1, Math.min(1, x)));
    }
    function d3_asin(x) {
        return x > 1 ? \u03C0 / 2 : x < -1 ? -\u03C0 / 2 : Math.asin(x);
    }
    function d3_sinh(x) {
        return (Math.exp(x) - Math.exp(-x)) / 2;
    }
    function d3_cosh(x) {
        return (Math.exp(x) + Math.exp(-x)) / 2;
    }
    function d3_haversin(x) {
        return (x = Math.sin(x / 2)) * x;
    }
    d3.hcl = function(h, c, l) {
        return arguments.length === 1 ? h instanceof d3_Hcl ? d3_hcl(h.h, h.c, h.l) : h instanceof d3_Lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : d3_hcl(+h, +c, +l);
    };
    function d3_hcl(h, c, l) {
        return new d3_Hcl(h, c, l);
    }
    function d3_Hcl(h, c, l) {
        this.h = h;
        this.c = c;
        this.l = l;
    }
    var d3_hclPrototype = d3_Hcl.prototype = new d3_Color();
    d3_hclPrototype.brighter = function(k) {
        return d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
    };
    d3_hclPrototype.darker = function(k) {
        return d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
    };
    d3_hclPrototype.rgb = function() {
        return d3_hcl_lab(this.h, this.c, this.l).rgb();
    };
    function d3_hcl_lab(h, c, l) {
        return d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
    }
    d3.lab = function(l, a, b1) {
        return arguments.length === 1 ? l instanceof d3_Lab ? d3_lab(l.l, l.a, l.b) : l instanceof d3_Hcl ? d3_hcl_lab(l.l, l.c, l.h) : d3_rgb_lab((l = d3.rgb(l)).r, l.g, l.b) : d3_lab(+l, +a, +b1);
    };
    function d3_lab(l, a, b1) {
        return new d3_Lab(l, a, b1);
    }
    function d3_Lab(l, a, b1) {
        this.l = l;
        this.a = a;
        this.b = b1;
    }
    var d3_lab_K = 18;
    var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
    var d3_labPrototype = d3_Lab.prototype = new d3_Color();
    d3_labPrototype.brighter = function(k) {
        return d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
    };
    d3_labPrototype.darker = function(k) {
        return d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
    };
    d3_labPrototype.rgb = function() {
        return d3_lab_rgb(this.l, this.a, this.b);
    };
    function d3_lab_rgb(l, a, b1) {
        var y = (l + 16) / 116, x = y + a / 500, z = y - b1 / 200;
        x = d3_lab_xyz(x) * d3_lab_X;
        y = d3_lab_xyz(y) * d3_lab_Y;
        z = d3_lab_xyz(z) * d3_lab_Z;
        return d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-0.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
    }
    function d3_lab_hcl(l, a, b1) {
        return d3_hcl(Math.atan2(b1, a) * d3_degrees, Math.sqrt(a * a + b1 * b1), l);
    }
    function d3_lab_xyz(x) {
        return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
    }
    function d3_xyz_lab(x) {
        return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
    }
    function d3_xyz_rgb(r) {
        return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
    }
    d3.rgb = function(r, g, b1) {
        return arguments.length === 1 ? r instanceof d3_Rgb ? d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : d3_rgb(~~r, ~~g, ~~b1);
    };
    function d3_rgb(r, g, b1) {
        return new d3_Rgb(r, g, b1);
    }
    function d3_Rgb(r, g, b1) {
        this.r = r;
        this.g = g;
        this.b = b1;
    }
    var d3_rgbPrototype = d3_Rgb.prototype = new d3_Color();
    d3_rgbPrototype.brighter = function(k) {
        k = Math.pow(.7, arguments.length ? k : 1);
        var r = this.r, g = this.g, b1 = this.b, i = 30;
        if (!r && !g && !b1) return d3_rgb(i, i, i);
        if (r && r < i) r = i;
        if (g && g < i) g = i;
        if (b1 && b1 < i) b1 = i;
        return d3_rgb(Math.min(255, Math.floor(r / k)), Math.min(255, Math.floor(g / k)), Math.min(255, Math.floor(b1 / k)));
    };
    d3_rgbPrototype.darker = function(k) {
        k = Math.pow(.7, arguments.length ? k : 1);
        return d3_rgb(Math.floor(k * this.r), Math.floor(k * this.g), Math.floor(k * this.b));
    };
    d3_rgbPrototype.hsl = function() {
        return d3_rgb_hsl(this.r, this.g, this.b);
    };
    d3_rgbPrototype.toString = function() {
        return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
    };
    function d3_rgb_hex(v) {
        return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
    }
    function d3_rgb_parse(format, rgb, hsl) {
        var r = 0, g = 0, b1 = 0, m1, m2, name;
        m1 = /([a-z]+)\((.*)\)/i.exec(format);
        if (m1) {
            m2 = m1[2].split(",");
            switch(m1[1]){
                case "hsl":
                    return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
                case "rgb":
                    return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
            }
        }
        if (name = d3_rgb_names.get(format)) return rgb(name.r, name.g, name.b);
        if (format != null && format.charAt(0) === "#") {
            if (format.length === 4) {
                r = format.charAt(1);
                r += r;
                g = format.charAt(2);
                g += g;
                b1 = format.charAt(3);
                b1 += b1;
            } else if (format.length === 7) {
                r = format.substring(1, 3);
                g = format.substring(3, 5);
                b1 = format.substring(5, 7);
            }
            r = parseInt(r, 16);
            g = parseInt(g, 16);
            b1 = parseInt(b1, 16);
        }
        return rgb(r, g, b1);
    }
    function d3_rgb_hsl(r, g, b1) {
        var min = Math.min(r /= 255, g /= 255, b1 /= 255), max = Math.max(r, g, b1), d = max - min, h, s, l = (max + min) / 2;
        if (d) {
            s = l < .5 ? d / (max + min) : d / (2 - max - min);
            if (r == max) h = (g - b1) / d + (g < b1 ? 6 : 0);
            else if (g == max) h = (b1 - r) / d + 2;
            else h = (r - g) / d + 4;
            h *= 60;
        } else s = h = 0;
        return d3_hsl(h, s, l);
    }
    function d3_rgb_lab(r, g, b1) {
        r = d3_rgb_xyz(r);
        g = d3_rgb_xyz(g);
        b1 = d3_rgb_xyz(b1);
        var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b1) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b1) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b1) / d3_lab_Z);
        return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
    }
    function d3_rgb_xyz(r) {
        return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
    }
    function d3_rgb_parseNumber(c) {
        var f = parseFloat(c);
        return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
    }
    var d3_rgb_names = d3.map({
        aliceblue: "#f0f8ff",
        antiquewhite: "#faebd7",
        aqua: "#00ffff",
        aquamarine: "#7fffd4",
        azure: "#f0ffff",
        beige: "#f5f5dc",
        bisque: "#ffe4c4",
        black: "#000000",
        blanchedalmond: "#ffebcd",
        blue: "#0000ff",
        blueviolet: "#8a2be2",
        brown: "#a52a2a",
        burlywood: "#deb887",
        cadetblue: "#5f9ea0",
        chartreuse: "#7fff00",
        chocolate: "#d2691e",
        coral: "#ff7f50",
        cornflowerblue: "#6495ed",
        cornsilk: "#fff8dc",
        crimson: "#dc143c",
        cyan: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgoldenrod: "#b8860b",
        darkgray: "#a9a9a9",
        darkgreen: "#006400",
        darkgrey: "#a9a9a9",
        darkkhaki: "#bdb76b",
        darkmagenta: "#8b008b",
        darkolivegreen: "#556b2f",
        darkorange: "#ff8c00",
        darkorchid: "#9932cc",
        darkred: "#8b0000",
        darksalmon: "#e9967a",
        darkseagreen: "#8fbc8f",
        darkslateblue: "#483d8b",
        darkslategray: "#2f4f4f",
        darkslategrey: "#2f4f4f",
        darkturquoise: "#00ced1",
        darkviolet: "#9400d3",
        deeppink: "#ff1493",
        deepskyblue: "#00bfff",
        dimgray: "#696969",
        dimgrey: "#696969",
        dodgerblue: "#1e90ff",
        firebrick: "#b22222",
        floralwhite: "#fffaf0",
        forestgreen: "#228b22",
        fuchsia: "#ff00ff",
        gainsboro: "#dcdcdc",
        ghostwhite: "#f8f8ff",
        gold: "#ffd700",
        goldenrod: "#daa520",
        gray: "#808080",
        green: "#008000",
        greenyellow: "#adff2f",
        grey: "#808080",
        honeydew: "#f0fff0",
        hotpink: "#ff69b4",
        indianred: "#cd5c5c",
        indigo: "#4b0082",
        ivory: "#fffff0",
        khaki: "#f0e68c",
        lavender: "#e6e6fa",
        lavenderblush: "#fff0f5",
        lawngreen: "#7cfc00",
        lemonchiffon: "#fffacd",
        lightblue: "#add8e6",
        lightcoral: "#f08080",
        lightcyan: "#e0ffff",
        lightgoldenrodyellow: "#fafad2",
        lightgray: "#d3d3d3",
        lightgreen: "#90ee90",
        lightgrey: "#d3d3d3",
        lightpink: "#ffb6c1",
        lightsalmon: "#ffa07a",
        lightseagreen: "#20b2aa",
        lightskyblue: "#87cefa",
        lightslategray: "#778899",
        lightslategrey: "#778899",
        lightsteelblue: "#b0c4de",
        lightyellow: "#ffffe0",
        lime: "#00ff00",
        limegreen: "#32cd32",
        linen: "#faf0e6",
        magenta: "#ff00ff",
        maroon: "#800000",
        mediumaquamarine: "#66cdaa",
        mediumblue: "#0000cd",
        mediumorchid: "#ba55d3",
        mediumpurple: "#9370db",
        mediumseagreen: "#3cb371",
        mediumslateblue: "#7b68ee",
        mediumspringgreen: "#00fa9a",
        mediumturquoise: "#48d1cc",
        mediumvioletred: "#c71585",
        midnightblue: "#191970",
        mintcream: "#f5fffa",
        mistyrose: "#ffe4e1",
        moccasin: "#ffe4b5",
        navajowhite: "#ffdead",
        navy: "#000080",
        oldlace: "#fdf5e6",
        olive: "#808000",
        olivedrab: "#6b8e23",
        orange: "#ffa500",
        orangered: "#ff4500",
        orchid: "#da70d6",
        palegoldenrod: "#eee8aa",
        palegreen: "#98fb98",
        paleturquoise: "#afeeee",
        palevioletred: "#db7093",
        papayawhip: "#ffefd5",
        peachpuff: "#ffdab9",
        peru: "#cd853f",
        pink: "#ffc0cb",
        plum: "#dda0dd",
        powderblue: "#b0e0e6",
        purple: "#800080",
        red: "#ff0000",
        rosybrown: "#bc8f8f",
        royalblue: "#4169e1",
        saddlebrown: "#8b4513",
        salmon: "#fa8072",
        sandybrown: "#f4a460",
        seagreen: "#2e8b57",
        seashell: "#fff5ee",
        sienna: "#a0522d",
        silver: "#c0c0c0",
        skyblue: "#87ceeb",
        slateblue: "#6a5acd",
        slategray: "#708090",
        slategrey: "#708090",
        snow: "#fffafa",
        springgreen: "#00ff7f",
        steelblue: "#4682b4",
        tan: "#d2b48c",
        teal: "#008080",
        thistle: "#d8bfd8",
        tomato: "#ff6347",
        turquoise: "#40e0d0",
        violet: "#ee82ee",
        wheat: "#f5deb3",
        white: "#ffffff",
        whitesmoke: "#f5f5f5",
        yellow: "#ffff00",
        yellowgreen: "#9acd32"
    });
    d3_rgb_names.forEach(function(key, value) {
        d3_rgb_names.set(key, d3_rgb_parse(value, d3_rgb, d3_hsl_rgb));
    });
    function d3_functor(v) {
        return typeof v === "function" ? v : function() {
            return v;
        };
    }
    d3.functor = d3_functor;
    function d3_identity(d) {
        return d;
    }
    d3.xhr = function(url, mimeType, callback) {
        var xhr = {}, dispatch = d3.dispatch("progress", "load", "error"), headers = {}, response = d3_identity, request = new (d3_window.XDomainRequest && /^(http(s)?:)?\/\//.test(url) ? XDomainRequest : XMLHttpRequest)();
        "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
            request.readyState > 3 && respond();
        };
        function respond() {
            var s = request.status;
            !s && request.responseText || s >= 200 && s < 300 || s === 304 ? dispatch.load.call(xhr, response.call(xhr, request)) : dispatch.error.call(xhr, request);
        }
        request.onprogress = function(event) {
            var o = d3.event;
            d3.event = event;
            try {
                dispatch.progress.call(xhr, request);
            } finally{
                d3.event = o;
            }
        };
        xhr.header = function(name, value) {
            name = (name + "").toLowerCase();
            if (arguments.length < 2) return headers[name];
            if (value == null) delete headers[name];
            else headers[name] = value + "";
            return xhr;
        };
        xhr.mimeType = function(value) {
            if (!arguments.length) return mimeType;
            mimeType = value == null ? null : value + "";
            return xhr;
        };
        xhr.response = function(value) {
            response = value;
            return xhr;
        };
        [
            "get",
            "post"
        ].forEach(function(method) {
            xhr[method] = function() {
                return xhr.send.apply(xhr, [
                    method
                ].concat(d3_array(arguments)));
            };
        });
        xhr.send = function(method, data, callback) {
            if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
            request.open(method, url, true);
            if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
            if (request.setRequestHeader) for(var name in headers)request.setRequestHeader(name, headers[name]);
            if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
            if (callback != null) xhr.on("error", callback).on("load", function(request) {
                callback(null, request);
            });
            request.send(data == null ? null : data);
            return xhr;
        };
        xhr.abort = function() {
            request.abort();
            return xhr;
        };
        d3.rebind(xhr, dispatch, "on");
        if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, mimeType = null;
        return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
    };
    function d3_xhr_fixCallback(callback) {
        return callback.length === 1 ? function(error, request) {
            callback(error == null ? request : null);
        } : callback;
    }
    function d3_dsv(delimiter, mimeType) {
        var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
        function dsv(url, row, callback) {
            if (arguments.length < 3) callback = row, row = null;
            var xhr = d3.xhr(url, mimeType, callback);
            xhr.row = function(_) {
                return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
            };
            return xhr.row(row);
        }
        function response(request) {
            return dsv.parse(request.responseText);
        }
        function typedResponse(f) {
            return function(request) {
                return dsv.parse(request.responseText, f);
            };
        }
        dsv.parse = function(text, f) {
            var o;
            return dsv.parseRows(text, function(row, i) {
                if (o) return o(row, i - 1);
                var a = new Function("d", "return {" + row.map(function(name, i) {
                    return JSON.stringify(name) + ": d[" + i + "]";
                }).join(",") + "}");
                o = f ? function(row, i) {
                    return f(a(row), i);
                } : a;
            });
        };
        dsv.parseRows = function(text, f) {
            var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
            function token() {
                if (I >= N) return EOF;
                if (eol) return eol = false, EOL;
                var j = I;
                if (text.charCodeAt(j) === 34) {
                    var i = j;
                    while(i++ < N)if (text.charCodeAt(i) === 34) {
                        if (text.charCodeAt(i + 1) !== 34) break;
                        ++i;
                    }
                    I = i + 2;
                    var c = text.charCodeAt(i + 1);
                    if (c === 13) {
                        eol = true;
                        if (text.charCodeAt(i + 2) === 10) ++I;
                    } else if (c === 10) eol = true;
                    return text.substring(j + 1, i).replace(/""/g, '"');
                }
                while(I < N){
                    var c = text.charCodeAt(I++), k = 1;
                    if (c === 10) eol = true;
                    else if (c === 13) {
                        eol = true;
                        if (text.charCodeAt(I) === 10) ++I, ++k;
                    } else if (c !== delimiterCode) continue;
                    return text.substring(j, I - k);
                }
                return text.substring(j);
            }
            while((t = token()) !== EOF){
                var a = [];
                while(t !== EOL && t !== EOF){
                    a.push(t);
                    t = token();
                }
                if (f && !(a = f(a, n++))) continue;
                rows.push(a);
            }
            return rows;
        };
        dsv.format = function(rows) {
            if (Array.isArray(rows[0])) return dsv.formatRows(rows);
            var fieldSet = new d3_Set(), fields = [];
            rows.forEach(function(row) {
                for(var field in row)if (!fieldSet.has(field)) fields.push(fieldSet.add(field));
            });
            return [
                fields.map(formatValue).join(delimiter)
            ].concat(rows.map(function(row) {
                return fields.map(function(field) {
                    return formatValue(row[field]);
                }).join(delimiter);
            })).join("\n");
        };
        dsv.formatRows = function(rows) {
            return rows.map(formatRow).join("\n");
        };
        function formatRow(row) {
            return row.map(formatValue).join(delimiter);
        }
        function formatValue(text) {
            return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
        }
        return dsv;
    }
    d3.csv = d3_dsv(",", "text/csv");
    d3.tsv = d3_dsv("	", "text/tab-separated-values");
    var d3_timer_id = 0, d3_timer_byId = {}, d3_timer_queue = null, d3_timer_interval, d3_timer_timeout;
    d3.timer = function(callback, delay, then) {
        if (arguments.length < 3) {
            if (arguments.length < 2) delay = 0;
            else if (!isFinite(delay)) return;
            then = Date.now();
        }
        var timer = d3_timer_byId[callback.id];
        if (timer && timer.callback === callback) {
            timer.then = then;
            timer.delay = delay;
        } else d3_timer_byId[callback.id = ++d3_timer_id] = d3_timer_queue = {
            callback: callback,
            then: then,
            delay: delay,
            next: d3_timer_queue
        };
        if (!d3_timer_interval) {
            d3_timer_timeout = clearTimeout(d3_timer_timeout);
            d3_timer_interval = 1;
            d3_timer_frame(d3_timer_step);
        }
    };
    function d3_timer_step() {
        var elapsed, now = Date.now(), t1 = d3_timer_queue;
        while(t1){
            elapsed = now - t1.then;
            if (elapsed >= t1.delay) t1.flush = t1.callback(elapsed);
            t1 = t1.next;
        }
        var delay = d3_timer_flush() - now;
        if (delay > 24) {
            if (isFinite(delay)) {
                clearTimeout(d3_timer_timeout);
                d3_timer_timeout = setTimeout(d3_timer_step, delay);
            }
            d3_timer_interval = 0;
        } else {
            d3_timer_interval = 1;
            d3_timer_frame(d3_timer_step);
        }
    }
    d3.timer.flush = function() {
        var elapsed, now = Date.now(), t1 = d3_timer_queue;
        while(t1){
            elapsed = now - t1.then;
            if (!t1.delay) t1.flush = t1.callback(elapsed);
            t1 = t1.next;
        }
        d3_timer_flush();
    };
    function d3_timer_flush() {
        var t0 = null, t1 = d3_timer_queue, then = Infinity;
        while(t1)if (t1.flush) {
            delete d3_timer_byId[t1.callback.id];
            t1 = t0 ? t0.next = t1.next : d3_timer_queue = t1.next;
        } else {
            then = Math.min(then, t1.then + t1.delay);
            t1 = (t0 = t1).next;
        }
        return then;
    }
    var d3_timer_frame = d3_window.requestAnimationFrame || d3_window.webkitRequestAnimationFrame || d3_window.mozRequestAnimationFrame || d3_window.oRequestAnimationFrame || d3_window.msRequestAnimationFrame || function(callback) {
        setTimeout(callback, 17);
    };
    var d3_format_decimalPoint = ".", d3_format_thousandsSeparator = ",", d3_format_grouping = [
        3,
        3
    ];
    var d3_formatPrefixes = [
        "y",
        "z",
        "a",
        "f",
        "p",
        "n",
        "\xb5",
        "m",
        "",
        "k",
        "M",
        "G",
        "T",
        "P",
        "E",
        "Z",
        "Y"
    ].map(d3_formatPrefix);
    d3.formatPrefix = function(value, precision) {
        var i = 0;
        if (value) {
            if (value < 0) value *= -1;
            if (precision) value = d3.round(value, d3_format_precision(value, precision));
            i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
            i = Math.max(-24, Math.min(24, Math.floor((i <= 0 ? i + 1 : i - 1) / 3) * 3));
        }
        return d3_formatPrefixes[8 + i / 3];
    };
    function d3_formatPrefix(d, i) {
        var k = Math.pow(10, Math.abs(8 - i) * 3);
        return {
            scale: i > 8 ? function(d) {
                return d / k;
            } : function(d) {
                return d * k;
            },
            symbol: d
        };
    }
    d3.round = function(x, n) {
        return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
    };
    d3.format = function(specifier) {
        var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "", basePrefix = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, suffix = "", integer = false;
        if (precision) precision = +precision.substring(1);
        if (zfill || fill === "0" && align === "=") {
            zfill = fill = "0";
            align = "=";
            if (comma) width -= Math.floor((width - 1) / 4);
        }
        switch(type){
            case "n":
                comma = true;
                type = "g";
                break;
            case "%":
                scale = 100;
                suffix = "%";
                type = "f";
                break;
            case "p":
                scale = 100;
                suffix = "%";
                type = "r";
                break;
            case "b":
            case "o":
            case "x":
            case "X":
                if (basePrefix) basePrefix = "0" + type.toLowerCase();
            case "c":
            case "d":
                integer = true;
                precision = 0;
                break;
            case "s":
                scale = -1;
                type = "r";
                break;
        }
        if (basePrefix === "#") basePrefix = "";
        if (type == "r" && !precision) type = "g";
        if (precision != null) {
            if (type == "g") precision = Math.max(1, Math.min(21, precision));
            else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
        }
        type = d3_format_types.get(type) || d3_format_typeDefault;
        var zcomma = zfill && comma;
        return function(value) {
            if (integer && value % 1) return "";
            var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign;
            if (scale < 0) {
                var prefix = d3.formatPrefix(value, precision);
                value = prefix.scale(value);
                suffix = prefix.symbol;
            } else value *= scale;
            value = type(value, precision);
            if (!zfill && comma) value = d3_format_group(value);
            var length = basePrefix.length + value.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
            if (zcomma) value = d3_format_group(padding + value);
            if (d3_format_decimalPoint) value.replace(".", d3_format_decimalPoint);
            negative += basePrefix;
            return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + suffix;
        };
    };
    var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?(#)?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
    var d3_format_types = d3.map({
        b: function(x) {
            return x.toString(2);
        },
        c: function(x) {
            return String.fromCharCode(x);
        },
        o: function(x) {
            return x.toString(8);
        },
        x: function(x) {
            return x.toString(16);
        },
        X: function(x) {
            return x.toString(16).toUpperCase();
        },
        g: function(x, p) {
            return x.toPrecision(p);
        },
        e: function(x, p) {
            return x.toExponential(p);
        },
        f: function(x, p) {
            return x.toFixed(p);
        },
        r: function(x, p) {
            return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
        }
    });
    function d3_format_precision(x, p) {
        return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
    }
    function d3_format_typeDefault(x) {
        return x + "";
    }
    var d3_format_group = d3_identity;
    if (d3_format_grouping) {
        var d3_format_groupingLength = d3_format_grouping.length;
        d3_format_group = function(value) {
            var i = value.lastIndexOf("."), f = i >= 0 ? "." + value.substring(i + 1) : (i = value.length, ""), t = [], j = 0, g = d3_format_grouping[0];
            while(i > 0 && g > 0){
                t.push(value.substring(i -= g, i + g));
                g = d3_format_grouping[j = (j + 1) % d3_format_groupingLength];
            }
            return t.reverse().join(d3_format_thousandsSeparator || "") + f;
        };
    }
    d3.geo = {};
    d3.geo.stream = function(object, listener) {
        if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) d3_geo_streamObjectType[object.type](object, listener);
        else d3_geo_streamGeometry(object, listener);
    };
    function d3_geo_streamGeometry(geometry, listener) {
        if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) d3_geo_streamGeometryType[geometry.type](geometry, listener);
    }
    var d3_geo_streamObjectType = {
        Feature: function(feature, listener) {
            d3_geo_streamGeometry(feature.geometry, listener);
        },
        FeatureCollection: function(object, listener) {
            var features = object.features, i = -1, n = features.length;
            while(++i < n)d3_geo_streamGeometry(features[i].geometry, listener);
        }
    };
    var d3_geo_streamGeometryType = {
        Sphere: function(object, listener) {
            listener.sphere();
        },
        Point: function(object, listener) {
            var coordinate = object.coordinates;
            listener.point(coordinate[0], coordinate[1]);
        },
        MultiPoint: function(object, listener) {
            var coordinates = object.coordinates, i = -1, n = coordinates.length, coordinate;
            while(++i < n)coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1]);
        },
        LineString: function(object, listener) {
            d3_geo_streamLine(object.coordinates, listener, 0);
        },
        MultiLineString: function(object, listener) {
            var coordinates = object.coordinates, i = -1, n = coordinates.length;
            while(++i < n)d3_geo_streamLine(coordinates[i], listener, 0);
        },
        Polygon: function(object, listener) {
            d3_geo_streamPolygon(object.coordinates, listener);
        },
        MultiPolygon: function(object, listener) {
            var coordinates = object.coordinates, i = -1, n = coordinates.length;
            while(++i < n)d3_geo_streamPolygon(coordinates[i], listener);
        },
        GeometryCollection: function(object, listener) {
            var geometries = object.geometries, i = -1, n = geometries.length;
            while(++i < n)d3_geo_streamGeometry(geometries[i], listener);
        }
    };
    function d3_geo_streamLine(coordinates, listener, closed) {
        var i = -1, n = coordinates.length - closed, coordinate;
        listener.lineStart();
        while(++i < n)coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1]);
        listener.lineEnd();
    }
    function d3_geo_streamPolygon(coordinates, listener) {
        var i = -1, n = coordinates.length;
        listener.polygonStart();
        while(++i < n)d3_geo_streamLine(coordinates[i], listener, 1);
        listener.polygonEnd();
    }
    d3.geo.area = function(object) {
        d3_geo_areaSum = 0;
        d3.geo.stream(object, d3_geo_area);
        return d3_geo_areaSum;
    };
    var d3_geo_areaSum, d3_geo_areaRingU, d3_geo_areaRingV;
    var d3_geo_area = {
        sphere: function() {
            d3_geo_areaSum += 4 * \u03C0;
        },
        point: d3_noop,
        lineStart: d3_noop,
        lineEnd: d3_noop,
        polygonStart: function() {
            d3_geo_areaRingU = 1, d3_geo_areaRingV = 0;
            d3_geo_area.lineStart = d3_geo_areaRingStart;
        },
        polygonEnd: function() {
            var area = 2 * Math.atan2(d3_geo_areaRingV, d3_geo_areaRingU);
            d3_geo_areaSum += area < 0 ? 4 * \u03C0 + area : area;
            d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
        }
    };
    function d3_geo_areaRingStart() {
        var \u03BB00, \u03C600, \u03BB0, cos\u03C60, sin\u03C60;
        d3_geo_area.point = function(\u03BB, \u03C6) {
            d3_geo_area.point = nextPoint;
            \u03BB0 = (\u03BB00 = \u03BB) * d3_radians, cos\u03C60 = Math.cos(\u03C6 = (\u03C600 = \u03C6) * d3_radians / 2 + \u03C0 / 4), sin\u03C60 = Math.sin(\u03C6);
        };
        function nextPoint(\u03BB, \u03C6) {
            \u03BB *= d3_radians;
            \u03C6 = \u03C6 * d3_radians / 2 + \u03C0 / 4;
            var d\u03BB = \u03BB - \u03BB0, cos\u03C6 = Math.cos(\u03C6), sin\u03C6 = Math.sin(\u03C6), k = sin\u03C60 * sin\u03C6, u0 = d3_geo_areaRingU, v0 = d3_geo_areaRingV, u = cos\u03C60 * cos\u03C6 + k * Math.cos(d\u03BB), v = k * Math.sin(d\u03BB);
            d3_geo_areaRingU = u0 * u - v0 * v;
            d3_geo_areaRingV = v0 * u + u0 * v;
            \u03BB0 = \u03BB, cos\u03C60 = cos\u03C6, sin\u03C60 = sin\u03C6;
        }
        d3_geo_area.lineEnd = function() {
            nextPoint(\u03BB00, \u03C600);
        };
    }
    d3.geo.bounds = d3_geo_bounds(d3_identity);
    function d3_geo_bounds(projectStream) {
        var x0, y0, x1, y1;
        var bound = {
            point: boundPoint,
            lineStart: d3_noop,
            lineEnd: d3_noop,
            polygonStart: function() {
                bound.lineEnd = boundPolygonLineEnd;
            },
            polygonEnd: function() {
                bound.point = boundPoint;
            }
        };
        function boundPoint(x, y) {
            if (x < x0) x0 = x;
            if (x > x1) x1 = x;
            if (y < y0) y0 = y;
            if (y > y1) y1 = y;
        }
        function boundPolygonLineEnd() {
            bound.point = bound.lineEnd = d3_noop;
        }
        return function(feature) {
            y1 = x1 = -(x0 = y0 = Infinity);
            d3.geo.stream(feature, projectStream(bound));
            return [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        };
    }
    d3.geo.centroid = function(object) {
        d3_geo_centroidDimension = d3_geo_centroidW = d3_geo_centroidX = d3_geo_centroidY = d3_geo_centroidZ = 0;
        d3.geo.stream(object, d3_geo_centroid);
        var m;
        if (d3_geo_centroidW && Math.abs(m = Math.sqrt(d3_geo_centroidX * d3_geo_centroidX + d3_geo_centroidY * d3_geo_centroidY + d3_geo_centroidZ * d3_geo_centroidZ)) > \u03B5) return [
            Math.atan2(d3_geo_centroidY, d3_geo_centroidX) * d3_degrees,
            Math.asin(Math.max(-1, Math.min(1, d3_geo_centroidZ / m))) * d3_degrees
        ];
    };
    var d3_geo_centroidDimension, d3_geo_centroidW, d3_geo_centroidX, d3_geo_centroidY, d3_geo_centroidZ;
    var d3_geo_centroid = {
        sphere: function() {
            if (d3_geo_centroidDimension < 2) {
                d3_geo_centroidDimension = 2;
                d3_geo_centroidW = d3_geo_centroidX = d3_geo_centroidY = d3_geo_centroidZ = 0;
            }
        },
        point: d3_geo_centroidPoint,
        lineStart: d3_geo_centroidLineStart,
        lineEnd: d3_geo_centroidLineEnd,
        polygonStart: function() {
            if (d3_geo_centroidDimension < 2) {
                d3_geo_centroidDimension = 2;
                d3_geo_centroidW = d3_geo_centroidX = d3_geo_centroidY = d3_geo_centroidZ = 0;
            }
            d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
        },
        polygonEnd: function() {
            d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
        }
    };
    function d3_geo_centroidPoint(\u03BB, \u03C6) {
        if (d3_geo_centroidDimension) return;
        ++d3_geo_centroidW;
        \u03BB *= d3_radians;
        var cos\u03C6 = Math.cos(\u03C6 *= d3_radians);
        d3_geo_centroidX += (cos\u03C6 * Math.cos(\u03BB) - d3_geo_centroidX) / d3_geo_centroidW;
        d3_geo_centroidY += (cos\u03C6 * Math.sin(\u03BB) - d3_geo_centroidY) / d3_geo_centroidW;
        d3_geo_centroidZ += (Math.sin(\u03C6) - d3_geo_centroidZ) / d3_geo_centroidW;
    }
    function d3_geo_centroidRingStart() {
        var \u03BB00, \u03C600;
        d3_geo_centroidDimension = 1;
        d3_geo_centroidLineStart();
        d3_geo_centroidDimension = 2;
        var linePoint = d3_geo_centroid.point;
        d3_geo_centroid.point = function(\u03BB, \u03C6) {
            linePoint(\u03BB00 = \u03BB, \u03C600 = \u03C6);
        };
        d3_geo_centroid.lineEnd = function() {
            d3_geo_centroid.point(\u03BB00, \u03C600);
            d3_geo_centroidLineEnd();
            d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
        };
    }
    function d3_geo_centroidLineStart() {
        var x0, y0, z0;
        if (d3_geo_centroidDimension > 1) return;
        if (d3_geo_centroidDimension < 1) {
            d3_geo_centroidDimension = 1;
            d3_geo_centroidW = d3_geo_centroidX = d3_geo_centroidY = d3_geo_centroidZ = 0;
        }
        d3_geo_centroid.point = function(\u03BB, \u03C6) {
            \u03BB *= d3_radians;
            var cos\u03C6 = Math.cos(\u03C6 *= d3_radians);
            x0 = cos\u03C6 * Math.cos(\u03BB);
            y0 = cos\u03C6 * Math.sin(\u03BB);
            z0 = Math.sin(\u03C6);
            d3_geo_centroid.point = nextPoint;
        };
        function nextPoint(\u03BB, \u03C6) {
            \u03BB *= d3_radians;
            var cos\u03C6 = Math.cos(\u03C6 *= d3_radians), x = cos\u03C6 * Math.cos(\u03BB), y = cos\u03C6 * Math.sin(\u03BB), z = Math.sin(\u03C6), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
            d3_geo_centroidW += w;
            d3_geo_centroidX += w * (x0 + (x0 = x));
            d3_geo_centroidY += w * (y0 + (y0 = y));
            d3_geo_centroidZ += w * (z0 + (z0 = z));
        }
    }
    function d3_geo_centroidLineEnd() {
        d3_geo_centroid.point = d3_geo_centroidPoint;
    }
    function d3_geo_cartesian(spherical) {
        var \u03BB = spherical[0], \u03C6 = spherical[1], cos\u03C6 = Math.cos(\u03C6);
        return [
            cos\u03C6 * Math.cos(\u03BB),
            cos\u03C6 * Math.sin(\u03BB),
            Math.sin(\u03C6)
        ];
    }
    function d3_geo_cartesianDot(a, b1) {
        return a[0] * b1[0] + a[1] * b1[1] + a[2] * b1[2];
    }
    function d3_geo_cartesianCross(a, b1) {
        return [
            a[1] * b1[2] - a[2] * b1[1],
            a[2] * b1[0] - a[0] * b1[2],
            a[0] * b1[1] - a[1] * b1[0]
        ];
    }
    function d3_geo_cartesianAdd(a, b1) {
        a[0] += b1[0];
        a[1] += b1[1];
        a[2] += b1[2];
    }
    function d3_geo_cartesianScale(vector, k) {
        return [
            vector[0] * k,
            vector[1] * k,
            vector[2] * k
        ];
    }
    function d3_geo_cartesianNormalize(d) {
        var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
        d[0] /= l;
        d[1] /= l;
        d[2] /= l;
    }
    function d3_true() {
        return true;
    }
    function d3_geo_spherical(cartesian) {
        return [
            Math.atan2(cartesian[1], cartesian[0]),
            Math.asin(Math.max(-1, Math.min(1, cartesian[2])))
        ];
    }
    function d3_geo_sphericalEqual(a, b1) {
        return Math.abs(a[0] - b1[0]) < \u03B5 && Math.abs(a[1] - b1[1]) < \u03B5;
    }
    function d3_geo_clipPolygon(segments, compare, inside, interpolate, listener) {
        var subject = [], clip = [];
        segments.forEach(function(segment) {
            if ((n = segment.length - 1) <= 0) return;
            var n, p0 = segment[0], p1 = segment[n];
            if (d3_geo_sphericalEqual(p0, p1)) {
                listener.lineStart();
                for(var i = 0; i < n; ++i)listener.point((p0 = segment[i])[0], p0[1]);
                listener.lineEnd();
                return;
            }
            var a = {
                point: p0,
                points: segment,
                other: null,
                visited: false,
                entry: true,
                subject: true
            }, b1 = {
                point: p0,
                points: [
                    p0
                ],
                other: a,
                visited: false,
                entry: false,
                subject: false
            };
            a.other = b1;
            subject.push(a);
            clip.push(b1);
            a = {
                point: p1,
                points: [
                    p1
                ],
                other: null,
                visited: false,
                entry: false,
                subject: true
            };
            b1 = {
                point: p1,
                points: [
                    p1
                ],
                other: a,
                visited: false,
                entry: true,
                subject: false
            };
            a.other = b1;
            subject.push(a);
            clip.push(b1);
        });
        clip.sort(compare);
        d3_geo_clipPolygonLinkCircular(subject);
        d3_geo_clipPolygonLinkCircular(clip);
        if (!subject.length) return;
        if (inside) for(var i = 1, e = !inside(clip[0].point), n = clip.length; i < n; ++i)clip[i].entry = e = !e;
        var start = subject[0], current, points, point;
        while(true){
            current = start;
            while(current.visited)if ((current = current.next) === start) return;
            points = current.points;
            listener.lineStart();
            do {
                current.visited = current.other.visited = true;
                if (current.entry) {
                    if (current.subject) for(var i = 0; i < points.length; i++)listener.point((point = points[i])[0], point[1]);
                    else interpolate(current.point, current.next.point, 1, listener);
                    current = current.next;
                } else {
                    if (current.subject) {
                        points = current.prev.points;
                        for(var i = points.length; --i >= 0;)listener.point((point = points[i])[0], point[1]);
                    } else interpolate(current.point, current.prev.point, -1, listener);
                    current = current.prev;
                }
                current = current.other;
                points = current.points;
            }while (!current.visited);
            listener.lineEnd();
        }
    }
    function d3_geo_clipPolygonLinkCircular(array) {
        if (!(n = array.length)) return;
        var n, i = 0, a = array[0], b1;
        while(++i < n){
            a.next = b1 = array[i];
            b1.prev = a;
            a = b1;
        }
        a.next = b1 = array[0];
        b1.prev = a;
    }
    function d3_geo_clip(pointVisible, clipLine, interpolate) {
        return function(listener) {
            var line = clipLine(listener);
            var clip = {
                point: point,
                lineStart: lineStart,
                lineEnd: lineEnd,
                polygonStart: function() {
                    clip.point = pointRing;
                    clip.lineStart = ringStart;
                    clip.lineEnd = ringEnd;
                    invisible = false;
                    invisibleArea = visibleArea = 0;
                    segments = [];
                    listener.polygonStart();
                },
                polygonEnd: function() {
                    clip.point = point;
                    clip.lineStart = lineStart;
                    clip.lineEnd = lineEnd;
                    segments = d3.merge(segments);
                    if (segments.length) d3_geo_clipPolygon(segments, d3_geo_clipSort, null, interpolate, listener);
                    else if (visibleArea < -\u03B5 || invisible && invisibleArea < -\u03B5) {
                        listener.lineStart();
                        interpolate(null, null, 1, listener);
                        listener.lineEnd();
                    }
                    listener.polygonEnd();
                    segments = null;
                },
                sphere: function() {
                    listener.polygonStart();
                    listener.lineStart();
                    interpolate(null, null, 1, listener);
                    listener.lineEnd();
                    listener.polygonEnd();
                }
            };
            function point(\u03BB, \u03C6) {
                if (pointVisible(\u03BB, \u03C6)) listener.point(\u03BB, \u03C6);
            }
            function pointLine(\u03BB, \u03C6) {
                line.point(\u03BB, \u03C6);
            }
            function lineStart() {
                clip.point = pointLine;
                line.lineStart();
            }
            function lineEnd() {
                clip.point = point;
                line.lineEnd();
            }
            var segments, visibleArea, invisibleArea, invisible;
            var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), ring;
            function pointRing(\u03BB, \u03C6) {
                ringListener.point(\u03BB, \u03C6);
                ring.push([
                    \u03BB,
                    \u03C6
                ]);
            }
            function ringStart() {
                ringListener.lineStart();
                ring = [];
            }
            function ringEnd() {
                pointRing(ring[0][0], ring[0][1]);
                ringListener.lineEnd();
                var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
                if (!n) {
                    invisible = true;
                    invisibleArea += d3_geo_clipAreaRing(ring, -1);
                    ring = null;
                    return;
                }
                ring = null;
                if (clean & 1) {
                    segment = ringSegments[0];
                    visibleArea += d3_geo_clipAreaRing(segment, 1);
                    var n = segment.length - 1, i = -1, point;
                    listener.lineStart();
                    while(++i < n)listener.point((point = segment[i])[0], point[1]);
                    listener.lineEnd();
                    return;
                }
                if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
                segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
            }
            return clip;
        };
    }
    function d3_geo_clipSegmentLength1(segment) {
        return segment.length > 1;
    }
    function d3_geo_clipBufferListener() {
        var lines = [], line;
        return {
            lineStart: function() {
                lines.push(line = []);
            },
            point: function(\u03BB, \u03C6) {
                line.push([
                    \u03BB,
                    \u03C6
                ]);
            },
            lineEnd: d3_noop,
            buffer: function() {
                var buffer = lines;
                lines = [];
                line = null;
                return buffer;
            },
            rejoin: function() {
                if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
            }
        };
    }
    function d3_geo_clipAreaRing(ring, invisible) {
        if (!(n = ring.length)) return 0;
        var n, i = 0, area = 0, p = ring[0], \u03BB = p[0], \u03C6 = p[1], cos\u03C6 = Math.cos(\u03C6), x0 = Math.atan2(invisible * Math.sin(\u03BB) * cos\u03C6, Math.sin(\u03C6)), y0 = 1 - invisible * Math.cos(\u03BB) * cos\u03C6, x1 = x0, x, y;
        while(++i < n){
            p = ring[i];
            cos\u03C6 = Math.cos(\u03C6 = p[1]);
            x = Math.atan2(invisible * Math.sin(\u03BB = p[0]) * cos\u03C6, Math.sin(\u03C6));
            y = 1 - invisible * Math.cos(\u03BB) * cos\u03C6;
            if (Math.abs(y0 - 2) < \u03B5 && Math.abs(y - 2) < \u03B5) continue;
            if (Math.abs(y) < \u03B5 || Math.abs(y0) < \u03B5) ;
            else if (Math.abs(Math.abs(x - x0) - \u03C0) < \u03B5) {
                if (y + y0 > 2) area += 4 * (x - x0);
            } else if (Math.abs(y0 - 2) < \u03B5) area += 4 * (x - x1);
            else area += ((3 * \u03C0 + x - x0) % (2 * \u03C0) - \u03C0) * (y0 + y);
            x1 = x0, x0 = x, y0 = y;
        }
        return area;
    }
    function d3_geo_clipSort(a, b1) {
        return ((a = a.point)[0] < 0 ? a[1] - \u03C0 / 2 - \u03B5 : \u03C0 / 2 - a[1]) - ((b1 = b1.point)[0] < 0 ? b1[1] - \u03C0 / 2 - \u03B5 : \u03C0 / 2 - b1[1]);
    }
    var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate);
    function d3_geo_clipAntimeridianLine(listener) {
        var \u03BB0 = NaN, \u03C60 = NaN, s\u03BB0 = NaN, clean;
        return {
            lineStart: function() {
                listener.lineStart();
                clean = 1;
            },
            point: function(\u03BB1, \u03C61) {
                var s\u03BB1 = \u03BB1 > 0 ? \u03C0 : -\u03C0, d\u03BB = Math.abs(\u03BB1 - \u03BB0);
                if (Math.abs(d\u03BB - \u03C0) < \u03B5) {
                    listener.point(\u03BB0, \u03C60 = (\u03C60 + \u03C61) / 2 > 0 ? \u03C0 / 2 : -\u03C0 / 2);
                    listener.point(s\u03BB0, \u03C60);
                    listener.lineEnd();
                    listener.lineStart();
                    listener.point(s\u03BB1, \u03C60);
                    listener.point(\u03BB1, \u03C60);
                    clean = 0;
                } else if (s\u03BB0 !== s\u03BB1 && d\u03BB >= \u03C0) {
                    if (Math.abs(\u03BB0 - s\u03BB0) < \u03B5) \u03BB0 -= s\u03BB0 * \u03B5;
                    if (Math.abs(\u03BB1 - s\u03BB1) < \u03B5) \u03BB1 -= s\u03BB1 * \u03B5;
                    \u03C60 = d3_geo_clipAntimeridianIntersect(\u03BB0, \u03C60, \u03BB1, \u03C61);
                    listener.point(s\u03BB0, \u03C60);
                    listener.lineEnd();
                    listener.lineStart();
                    listener.point(s\u03BB1, \u03C60);
                    clean = 0;
                }
                listener.point(\u03BB0 = \u03BB1, \u03C60 = \u03C61);
                s\u03BB0 = s\u03BB1;
            },
            lineEnd: function() {
                listener.lineEnd();
                \u03BB0 = \u03C60 = NaN;
            },
            clean: function() {
                return 2 - clean;
            }
        };
    }
    function d3_geo_clipAntimeridianIntersect(\u03BB0, \u03C60, \u03BB1, \u03C61) {
        var cos\u03C60, cos\u03C61, sin\u03BB0_\u03BB1 = Math.sin(\u03BB0 - \u03BB1);
        return Math.abs(sin\u03BB0_\u03BB1) > \u03B5 ? Math.atan((Math.sin(\u03C60) * (cos\u03C61 = Math.cos(\u03C61)) * Math.sin(\u03BB1) - Math.sin(\u03C61) * (cos\u03C60 = Math.cos(\u03C60)) * Math.sin(\u03BB0)) / (cos\u03C60 * cos\u03C61 * sin\u03BB0_\u03BB1)) : (\u03C60 + \u03C61) / 2;
    }
    function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
        var \u03C6;
        if (from == null) {
            \u03C6 = direction * \u03C0 / 2;
            listener.point(-\u03C0, \u03C6);
            listener.point(0, \u03C6);
            listener.point(\u03C0, \u03C6);
            listener.point(\u03C0, 0);
            listener.point(\u03C0, -\u03C6);
            listener.point(0, -\u03C6);
            listener.point(-\u03C0, -\u03C6);
            listener.point(-\u03C0, 0);
            listener.point(-\u03C0, \u03C6);
        } else if (Math.abs(from[0] - to[0]) > \u03B5) {
            var s = (from[0] < to[0] ? 1 : -1) * \u03C0;
            \u03C6 = direction * s / 2;
            listener.point(-s, \u03C6);
            listener.point(0, \u03C6);
            listener.point(s, \u03C6);
        } else listener.point(to[0], to[1]);
    }
    function d3_geo_clipCircle(radius) {
        var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = Math.abs(cr) > \u03B5, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
        return d3_geo_clip(visible, clipLine, interpolate);
        function visible(\u03BB, \u03C6) {
            return Math.cos(\u03BB) * Math.cos(\u03C6) > cr;
        }
        function clipLine(listener) {
            var point0, c0, v0, v00, clean;
            return {
                lineStart: function() {
                    v00 = v0 = false;
                    clean = 1;
                },
                point: function(\u03BB, \u03C6) {
                    var point1 = [
                        \u03BB,
                        \u03C6
                    ], point2, v = visible(\u03BB, \u03C6), c = smallRadius ? v ? 0 : code(\u03BB, \u03C6) : v ? code(\u03BB + (\u03BB < 0 ? \u03C0 : -\u03C0), \u03C6) : 0;
                    if (!point0 && (v00 = v0 = v)) listener.lineStart();
                    if (v !== v0) {
                        point2 = intersect(point0, point1);
                        if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
                            point1[0] += \u03B5;
                            point1[1] += \u03B5;
                            v = visible(point1[0], point1[1]);
                        }
                    }
                    if (v !== v0) {
                        clean = 0;
                        if (v) {
                            listener.lineStart();
                            point2 = intersect(point1, point0);
                            listener.point(point2[0], point2[1]);
                        } else {
                            point2 = intersect(point0, point1);
                            listener.point(point2[0], point2[1]);
                            listener.lineEnd();
                        }
                        point0 = point2;
                    } else if (notHemisphere && point0 && smallRadius ^ v) {
                        var t;
                        if (!(c & c0) && (t = intersect(point1, point0, true))) {
                            clean = 0;
                            if (smallRadius) {
                                listener.lineStart();
                                listener.point(t[0][0], t[0][1]);
                                listener.point(t[1][0], t[1][1]);
                                listener.lineEnd();
                            } else {
                                listener.point(t[1][0], t[1][1]);
                                listener.lineEnd();
                                listener.lineStart();
                                listener.point(t[0][0], t[0][1]);
                            }
                        }
                    }
                    if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) listener.point(point1[0], point1[1]);
                    point0 = point1, v0 = v, c0 = c;
                },
                lineEnd: function() {
                    if (v0) listener.lineEnd();
                    point0 = null;
                },
                clean: function() {
                    return clean | (v00 && v0) << 1;
                }
            };
        }
        function intersect(a, b1, two) {
            var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b1);
            var n1 = [
                1,
                0,
                0
            ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
            if (!determinant) return !two && a;
            var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
            d3_geo_cartesianAdd(A, B);
            var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
            if (t2 < 0) return;
            var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
            d3_geo_cartesianAdd(q, A);
            q = d3_geo_spherical(q);
            if (!two) return q;
            var \u03BB0 = a[0], \u03BB1 = b1[0], \u03C60 = a[1], \u03C61 = b1[1], z;
            if (\u03BB1 < \u03BB0) z = \u03BB0, \u03BB0 = \u03BB1, \u03BB1 = z;
            var \u03B4\u03BB = \u03BB1 - \u03BB0, polar = Math.abs(\u03B4\u03BB - \u03C0) < \u03B5, meridian = polar || \u03B4\u03BB < \u03B5;
            if (!polar && \u03C61 < \u03C60) z = \u03C60, \u03C60 = \u03C61, \u03C61 = z;
            if (meridian ? polar ? \u03C60 + \u03C61 > 0 ^ q[1] < (Math.abs(q[0] - \u03BB0) < \u03B5 ? \u03C60 : \u03C61) : \u03C60 <= q[1] && q[1] <= \u03C61 : \u03B4\u03BB > \u03C0 ^ (\u03BB0 <= q[0] && q[0] <= \u03BB1)) {
                var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
                d3_geo_cartesianAdd(q1, A);
                return [
                    q,
                    d3_geo_spherical(q1)
                ];
            }
        }
        function code(\u03BB, \u03C6) {
            var r = smallRadius ? radius : \u03C0 - radius, code = 0;
            if (\u03BB < -r) code |= 1;
            else if (\u03BB > r) code |= 2;
            if (\u03C6 < -r) code |= 4;
            else if (\u03C6 > r) code |= 8;
            return code;
        }
    }
    var d3_geo_clipViewMAX = 1e9;
    function d3_geo_clipView(x0, y0, x1, y1) {
        return function(listener) {
            var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), segments, polygon, ring;
            var clip = {
                point: point,
                lineStart: lineStart,
                lineEnd: lineEnd,
                polygonStart: function() {
                    listener = bufferListener;
                    segments = [];
                    polygon = [];
                },
                polygonEnd: function() {
                    listener = listener_;
                    if ((segments = d3.merge(segments)).length) {
                        listener.polygonStart();
                        d3_geo_clipPolygon(segments, compare, inside, interpolate, listener);
                        listener.polygonEnd();
                    } else if (insidePolygon([
                        x0,
                        y0
                    ])) {
                        listener.polygonStart(), listener.lineStart();
                        interpolate(null, null, 1, listener);
                        listener.lineEnd(), listener.polygonEnd();
                    }
                    segments = polygon = ring = null;
                }
            };
            function inside(point) {
                var a = corner(point, -1), i = insidePolygon([
                    a === 0 || a === 3 ? x0 : x1,
                    a > 1 ? y1 : y0
                ]);
                return i;
            }
            function insidePolygon(p) {
                var wn = 0, n = polygon.length, y = p[1];
                for(var i = 0; i < n; ++i)for(var j = 1, v = polygon[i], m = v.length, a = v[0]; j < m; ++j){
                    b = v[j];
                    if (a[1] <= y) {
                        if (b[1] > y && isLeft(a, b, p) > 0) ++wn;
                    } else if (b[1] <= y && isLeft(a, b, p) < 0) --wn;
                    a = b;
                }
                return wn !== 0;
            }
            function isLeft(a, b1, c) {
                return (b1[0] - a[0]) * (c[1] - a[1]) - (c[0] - a[0]) * (b1[1] - a[1]);
            }
            function interpolate(from, to, direction, listener) {
                var a = 0, a1 = 0;
                if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) do listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
                while ((a = (a + direction + 4) % 4) !== a1);
                else listener.point(to[0], to[1]);
            }
            function visible(x, y) {
                return x0 <= x && x <= x1 && y0 <= y && y <= y1;
            }
            function point(x, y) {
                if (visible(x, y)) listener.point(x, y);
            }
            var x__, y__, v__, x_, y_, v_, first;
            function lineStart() {
                clip.point = linePoint;
                if (polygon) polygon.push(ring = []);
                first = true;
                v_ = false;
                x_ = y_ = NaN;
            }
            function lineEnd() {
                if (segments) {
                    linePoint(x__, y__);
                    if (v__ && v_) bufferListener.rejoin();
                    segments.push(bufferListener.buffer());
                }
                clip.point = point;
                if (v_) listener.lineEnd();
            }
            function linePoint(x, y) {
                x = Math.max(-d3_geo_clipViewMAX, Math.min(d3_geo_clipViewMAX, x));
                y = Math.max(-d3_geo_clipViewMAX, Math.min(d3_geo_clipViewMAX, y));
                var v = visible(x, y);
                if (polygon) ring.push([
                    x,
                    y
                ]);
                if (first) {
                    x__ = x, y__ = y, v__ = v;
                    first = false;
                    if (v) {
                        listener.lineStart();
                        listener.point(x, y);
                    }
                } else if (v && v_) listener.point(x, y);
                else {
                    var a = [
                        x_,
                        y_
                    ], b1 = [
                        x,
                        y
                    ];
                    if (clipLine(a, b1)) {
                        if (!v_) {
                            listener.lineStart();
                            listener.point(a[0], a[1]);
                        }
                        listener.point(b1[0], b1[1]);
                        if (!v) listener.lineEnd();
                    } else {
                        listener.lineStart();
                        listener.point(x, y);
                    }
                }
                x_ = x, y_ = y, v_ = v;
            }
            return clip;
        };
        function corner(p, direction) {
            return Math.abs(p[0] - x0) < \u03B5 ? direction > 0 ? 0 : 3 : Math.abs(p[0] - x1) < \u03B5 ? direction > 0 ? 2 : 1 : Math.abs(p[1] - y0) < \u03B5 ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
        }
        function compare(a, b1) {
            return comparePoints(a.point, b1.point);
        }
        function comparePoints(a, b1) {
            var ca = corner(a, 1), cb = corner(b1, 1);
            return ca !== cb ? ca - cb : ca === 0 ? b1[1] - a[1] : ca === 1 ? a[0] - b1[0] : ca === 2 ? a[1] - b1[1] : b1[0] - a[0];
        }
        function clipLine(a, b1) {
            var dx = b1[0] - a[0], dy = b1[1] - a[1], t = [
                0,
                1
            ];
            if (Math.abs(dx) < \u03B5 && Math.abs(dy) < \u03B5) return x0 <= a[0] && a[0] <= x1 && y0 <= a[1] && a[1] <= y1;
            if (d3_geo_clipViewT(x0 - a[0], dx, t) && d3_geo_clipViewT(a[0] - x1, -dx, t) && d3_geo_clipViewT(y0 - a[1], dy, t) && d3_geo_clipViewT(a[1] - y1, -dy, t)) {
                if (t[1] < 1) {
                    b1[0] = a[0] + t[1] * dx;
                    b1[1] = a[1] + t[1] * dy;
                }
                if (t[0] > 0) {
                    a[0] += t[0] * dx;
                    a[1] += t[0] * dy;
                }
                return true;
            }
            return false;
        }
    }
    function d3_geo_clipViewT(num, denominator, t) {
        if (Math.abs(denominator) < \u03B5) return num <= 0;
        var u = num / denominator;
        if (denominator > 0) {
            if (u > t[1]) return false;
            if (u > t[0]) t[0] = u;
        } else {
            if (u < t[0]) return false;
            if (u < t[1]) t[1] = u;
        }
        return true;
    }
    function d3_geo_compose(a, b1) {
        function compose(x, y) {
            return x = a(x, y), b1(x[0], x[1]);
        }
        if (a.invert && b1.invert) compose.invert = function(x, y) {
            return x = b1.invert(x, y), x && a.invert(x[0], x[1]);
        };
        return compose;
    }
    function d3_geo_resample(project) {
        var \u03B42 = .5, maxDepth = 16;
        function resample(stream) {
            var \u03BB0, x0, y0, a0, b0, c0;
            var resample = {
                point: point,
                lineStart: lineStart,
                lineEnd: lineEnd,
                polygonStart: function() {
                    stream.polygonStart();
                    resample.lineStart = polygonLineStart;
                },
                polygonEnd: function() {
                    stream.polygonEnd();
                    resample.lineStart = lineStart;
                }
            };
            function point(x, y) {
                x = project(x, y);
                stream.point(x[0], x[1]);
            }
            function lineStart() {
                x0 = NaN;
                resample.point = linePoint;
                stream.lineStart();
            }
            function linePoint(\u03BB, \u03C6) {
                var c = d3_geo_cartesian([
                    \u03BB,
                    \u03C6
                ]), p = project(\u03BB, \u03C6);
                resampleLineTo(x0, y0, \u03BB0, a0, b0, c0, x0 = p[0], y0 = p[1], \u03BB0 = \u03BB, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
                stream.point(x0, y0);
            }
            function lineEnd() {
                resample.point = point;
                stream.lineEnd();
            }
            function polygonLineStart() {
                var \u03BB00, \u03C600, x00, y00, a00, b00, c00;
                lineStart();
                resample.point = function(\u03BB, \u03C6) {
                    linePoint(\u03BB00 = \u03BB, \u03C600 = \u03C6), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
                    resample.point = linePoint;
                };
                resample.lineEnd = function() {
                    resampleLineTo(x0, y0, \u03BB0, a0, b0, c0, x00, y00, \u03BB00, a00, b00, c00, maxDepth, stream);
                    resample.lineEnd = lineEnd;
                    lineEnd();
                };
            }
            return resample;
        }
        function resampleLineTo(x0, y0, \u03BB0, a0, b0, c0, x1, y1, \u03BB1, a1, b1, c1, depth, stream) {
            var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
            if (d2 > 4 * \u03B42 && depth--) {
                var a = a0 + a1, b2 = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b2 * b2 + c * c), \u03C62 = Math.asin(c /= m), \u03BB2 = Math.abs(Math.abs(c) - 1) < \u03B5 ? (\u03BB0 + \u03BB1) / 2 : Math.atan2(b2, a), p = project(\u03BB2, \u03C62), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
                if (dz * dz / d2 > \u03B42 || Math.abs((dx * dx2 + dy * dy2) / d2 - .5) > .3) {
                    resampleLineTo(x0, y0, \u03BB0, a0, b0, c0, x2, y2, \u03BB2, a /= m, b2 /= m, c, depth, stream);
                    stream.point(x2, y2);
                    resampleLineTo(x2, y2, \u03BB2, a, b2, c, x1, y1, \u03BB1, a1, b1, c1, depth, stream);
                }
            }
        }
        resample.precision = function(_) {
            if (!arguments.length) return Math.sqrt(\u03B42);
            maxDepth = (\u03B42 = _ * _) > 0 && 16;
            return resample;
        };
        return resample;
    }
    d3.geo.projection = d3_geo_projection;
    d3.geo.projectionMutator = d3_geo_projectionMutator;
    function d3_geo_projection(project) {
        return d3_geo_projectionMutator(function() {
            return project;
        })();
    }
    function d3_geo_projectionMutator(projectAt) {
        var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
            x = project(x, y);
            return [
                x[0] * k + \u03B4x,
                \u03B4y - x[1] * k
            ];
        }), k = 150, x = 480, y = 250, \u03BB = 0, \u03C6 = 0, \u03B4\u03BB = 0, \u03B4\u03C6 = 0, \u03B4\u03B3 = 0, \u03B4x, \u03B4y, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null;
        function projection(point) {
            point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
            return [
                point[0] * k + \u03B4x,
                \u03B4y - point[1] * k
            ];
        }
        function invert(point) {
            point = projectRotate.invert((point[0] - \u03B4x) / k, (\u03B4y - point[1]) / k);
            return point && [
                point[0] * d3_degrees,
                point[1] * d3_degrees
            ];
        }
        projection.stream = function(stream) {
            return d3_geo_projectionRadiansRotate(rotate, preclip(projectResample(postclip(stream))));
        };
        projection.clipAngle = function(_) {
            if (!arguments.length) return clipAngle;
            preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
            return projection;
        };
        projection.clipExtent = function(_) {
            if (!arguments.length) return clipExtent;
            clipExtent = _;
            postclip = _ == null ? d3_identity : d3_geo_clipView(_[0][0], _[0][1], _[1][0], _[1][1]);
            return projection;
        };
        projection.scale = function(_) {
            if (!arguments.length) return k;
            k = +_;
            return reset();
        };
        projection.translate = function(_) {
            if (!arguments.length) return [
                x,
                y
            ];
            x = +_[0];
            y = +_[1];
            return reset();
        };
        projection.center = function(_) {
            if (!arguments.length) return [
                \u03BB * d3_degrees,
                \u03C6 * d3_degrees
            ];
            \u03BB = _[0] % 360 * d3_radians;
            \u03C6 = _[1] % 360 * d3_radians;
            return reset();
        };
        projection.rotate = function(_) {
            if (!arguments.length) return [
                \u03B4\u03BB * d3_degrees,
                \u03B4\u03C6 * d3_degrees,
                \u03B4\u03B3 * d3_degrees
            ];
            \u03B4\u03BB = _[0] % 360 * d3_radians;
            \u03B4\u03C6 = _[1] % 360 * d3_radians;
            \u03B4\u03B3 = _.length > 2 ? _[2] % 360 * d3_radians : 0;
            return reset();
        };
        d3.rebind(projection, projectResample, "precision");
        function reset() {
            projectRotate = d3_geo_compose(rotate = d3_geo_rotation(\u03B4\u03BB, \u03B4\u03C6, \u03B4\u03B3), project);
            var center = project(\u03BB, \u03C6);
            \u03B4x = x - center[0] * k;
            \u03B4y = y + center[1] * k;
            return projection;
        }
        return function() {
            project = projectAt.apply(this, arguments);
            projection.invert = project.invert && invert;
            return reset();
        };
    }
    function d3_geo_projectionRadiansRotate(rotate, stream) {
        return {
            point: function(x, y) {
                y = rotate(x * d3_radians, y * d3_radians), x = y[0];
                stream.point(x > \u03C0 ? x - 2 * \u03C0 : x < -\u03C0 ? x + 2 * \u03C0 : x, y[1]);
            },
            sphere: function() {
                stream.sphere();
            },
            lineStart: function() {
                stream.lineStart();
            },
            lineEnd: function() {
                stream.lineEnd();
            },
            polygonStart: function() {
                stream.polygonStart();
            },
            polygonEnd: function() {
                stream.polygonEnd();
            }
        };
    }
    function d3_geo_equirectangular(\u03BB, \u03C6) {
        return [
            \u03BB,
            \u03C6
        ];
    }
    (d3.geo.equirectangular = function() {
        return d3_geo_projection(d3_geo_equirectangular);
    }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
    d3.geo.rotation = function(rotate) {
        rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
        function forward(coordinates) {
            coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
            return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
        }
        forward.invert = function(coordinates) {
            coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
            return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
        };
        return forward;
    };
    function d3_geo_rotation(\u03B4\u03BB, \u03B4\u03C6, \u03B4\u03B3) {
        return \u03B4\u03BB ? \u03B4\u03C6 || \u03B4\u03B3 ? d3_geo_compose(d3_geo_rotation\u03BB(\u03B4\u03BB), d3_geo_rotation\u03C6\u03B3(\u03B4\u03C6, \u03B4\u03B3)) : d3_geo_rotation\u03BB(\u03B4\u03BB) : \u03B4\u03C6 || \u03B4\u03B3 ? d3_geo_rotation\u03C6\u03B3(\u03B4\u03C6, \u03B4\u03B3) : d3_geo_equirectangular;
    }
    function d3_geo_forwardRotation\u03BB(\u03B4\u03BB) {
        return function(\u03BB, \u03C6) {
            return \u03BB += \u03B4\u03BB, [
                \u03BB > \u03C0 ? \u03BB - 2 * \u03C0 : \u03BB < -\u03C0 ? \u03BB + 2 * \u03C0 : \u03BB,
                \u03C6
            ];
        };
    }
    function d3_geo_rotation\u03BB(\u03B4\u03BB) {
        var rotation = d3_geo_forwardRotation\u03BB(\u03B4\u03BB);
        rotation.invert = d3_geo_forwardRotation\u03BB(-\u03B4\u03BB);
        return rotation;
    }
    function d3_geo_rotation\u03C6\u03B3(\u03B4\u03C6, \u03B4\u03B3) {
        var cos\u03B4\u03C6 = Math.cos(\u03B4\u03C6), sin\u03B4\u03C6 = Math.sin(\u03B4\u03C6), cos\u03B4\u03B3 = Math.cos(\u03B4\u03B3), sin\u03B4\u03B3 = Math.sin(\u03B4\u03B3);
        function rotation(\u03BB, \u03C6) {
            var cos\u03C6 = Math.cos(\u03C6), x = Math.cos(\u03BB) * cos\u03C6, y = Math.sin(\u03BB) * cos\u03C6, z = Math.sin(\u03C6), k = z * cos\u03B4\u03C6 + x * sin\u03B4\u03C6;
            return [
                Math.atan2(y * cos\u03B4\u03B3 - k * sin\u03B4\u03B3, x * cos\u03B4\u03C6 - z * sin\u03B4\u03C6),
                Math.asin(Math.max(-1, Math.min(1, k * cos\u03B4\u03B3 + y * sin\u03B4\u03B3)))
            ];
        }
        rotation.invert = function(\u03BB, \u03C6) {
            var cos\u03C6 = Math.cos(\u03C6), x = Math.cos(\u03BB) * cos\u03C6, y = Math.sin(\u03BB) * cos\u03C6, z = Math.sin(\u03C6), k = z * cos\u03B4\u03B3 - y * sin\u03B4\u03B3;
            return [
                Math.atan2(y * cos\u03B4\u03B3 + z * sin\u03B4\u03B3, x * cos\u03B4\u03C6 + k * sin\u03B4\u03C6),
                Math.asin(Math.max(-1, Math.min(1, k * cos\u03B4\u03C6 - x * sin\u03B4\u03C6)))
            ];
        };
        return rotation;
    }
    d3.geo.circle = function() {
        var origin = [
            0,
            0
        ], angle, precision = 6, interpolate;
        function circle() {
            var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
            interpolate(null, null, 1, {
                point: function(x, y) {
                    ring.push(x = rotate(x, y));
                    x[0] *= d3_degrees, x[1] *= d3_degrees;
                }
            });
            return {
                type: "Polygon",
                coordinates: [
                    ring
                ]
            };
        }
        circle.origin = function(x) {
            if (!arguments.length) return origin;
            origin = x;
            return circle;
        };
        circle.angle = function(x) {
            if (!arguments.length) return angle;
            interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
            return circle;
        };
        circle.precision = function(_) {
            if (!arguments.length) return precision;
            interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
            return circle;
        };
        return circle.angle(90);
    };
    function d3_geo_circleInterpolate(radius, precision) {
        var cr = Math.cos(radius), sr = Math.sin(radius);
        return function(from, to, direction, listener) {
            if (from != null) {
                from = d3_geo_circleAngle(cr, from);
                to = d3_geo_circleAngle(cr, to);
                if (direction > 0 ? from < to : from > to) from += direction * 2 * \u03C0;
            } else {
                from = radius + direction * 2 * \u03C0;
                to = radius;
            }
            var point;
            for(var step = direction * precision, t = from; direction > 0 ? t > to : t < to; t -= step)listener.point((point = d3_geo_spherical([
                cr,
                -sr * Math.cos(t),
                -sr * Math.sin(t)
            ]))[0], point[1]);
        };
    }
    function d3_geo_circleAngle(cr, point) {
        var a = d3_geo_cartesian(point);
        a[0] -= cr;
        d3_geo_cartesianNormalize(a);
        var angle = d3_acos(-a[1]);
        return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - \u03B5) % (2 * Math.PI);
    }
    d3.geo.distance = function(a, b1) {
        var \u0394\u03BB = (b1[0] - a[0]) * d3_radians, \u03C60 = a[1] * d3_radians, \u03C61 = b1[1] * d3_radians, sin\u0394\u03BB = Math.sin(\u0394\u03BB), cos\u0394\u03BB = Math.cos(\u0394\u03BB), sin\u03C60 = Math.sin(\u03C60), cos\u03C60 = Math.cos(\u03C60), sin\u03C61 = Math.sin(\u03C61), cos\u03C61 = Math.cos(\u03C61), t;
        return Math.atan2(Math.sqrt((t = cos\u03C61 * sin\u0394\u03BB) * t + (t = cos\u03C60 * sin\u03C61 - sin\u03C60 * cos\u03C61 * cos\u0394\u03BB) * t), sin\u03C60 * sin\u03C61 + cos\u03C60 * cos\u03C61 * cos\u0394\u03BB);
    };
    d3.geo.graticule = function() {
        var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
        function graticule() {
            return {
                type: "MultiLineString",
                coordinates: lines()
            };
        }
        function lines() {
            return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
                return Math.abs(x % DX) > \u03B5;
            }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
                return Math.abs(y % DY) > \u03B5;
            }).map(y));
        }
        graticule.lines = function() {
            return lines().map(function(coordinates) {
                return {
                    type: "LineString",
                    coordinates: coordinates
                };
            });
        };
        graticule.outline = function() {
            return {
                type: "Polygon",
                coordinates: [
                    X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))
                ]
            };
        };
        graticule.extent = function(_) {
            if (!arguments.length) return graticule.minorExtent();
            return graticule.majorExtent(_).minorExtent(_);
        };
        graticule.majorExtent = function(_) {
            if (!arguments.length) return [
                [
                    X0,
                    Y0
                ],
                [
                    X1,
                    Y1
                ]
            ];
            X0 = +_[0][0], X1 = +_[1][0];
            Y0 = +_[0][1], Y1 = +_[1][1];
            if (X0 > X1) _ = X0, X0 = X1, X1 = _;
            if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
            return graticule.precision(precision);
        };
        graticule.minorExtent = function(_) {
            if (!arguments.length) return [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
            x0 = +_[0][0], x1 = +_[1][0];
            y0 = +_[0][1], y1 = +_[1][1];
            if (x0 > x1) _ = x0, x0 = x1, x1 = _;
            if (y0 > y1) _ = y0, y0 = y1, y1 = _;
            return graticule.precision(precision);
        };
        graticule.step = function(_) {
            if (!arguments.length) return graticule.minorStep();
            return graticule.majorStep(_).minorStep(_);
        };
        graticule.majorStep = function(_) {
            if (!arguments.length) return [
                DX,
                DY
            ];
            DX = +_[0], DY = +_[1];
            return graticule;
        };
        graticule.minorStep = function(_) {
            if (!arguments.length) return [
                dx,
                dy
            ];
            dx = +_[0], dy = +_[1];
            return graticule;
        };
        graticule.precision = function(_) {
            if (!arguments.length) return precision;
            precision = +_;
            x = d3_geo_graticuleX(y0, y1, 90);
            y = d3_geo_graticuleY(x0, x1, precision);
            X = d3_geo_graticuleX(Y0, Y1, 90);
            Y = d3_geo_graticuleY(X0, X1, precision);
            return graticule;
        };
        return graticule.majorExtent([
            [
                -180,
                -90 + \u03B5
            ],
            [
                180,
                90 - \u03B5
            ]
        ]).minorExtent([
            [
                -180,
                -80 - \u03B5
            ],
            [
                180,
                80 + \u03B5
            ]
        ]);
    };
    function d3_geo_graticuleX(y0, y1, dy) {
        var y = d3.range(y0, y1 - \u03B5, dy).concat(y1);
        return function(x) {
            return y.map(function(y) {
                return [
                    x,
                    y
                ];
            });
        };
    }
    function d3_geo_graticuleY(x0, x1, dx) {
        var x = d3.range(x0, x1 - \u03B5, dx).concat(x1);
        return function(y) {
            return x.map(function(x) {
                return [
                    x,
                    y
                ];
            });
        };
    }
    function d3_source(d) {
        return d.source;
    }
    function d3_target(d) {
        return d.target;
    }
    d3.geo.greatArc = function() {
        var source = d3_source, source_, target = d3_target, target_;
        function greatArc() {
            return {
                type: "LineString",
                coordinates: [
                    source_ || source.apply(this, arguments),
                    target_ || target.apply(this, arguments)
                ]
            };
        }
        greatArc.distance = function() {
            return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
        };
        greatArc.source = function(_) {
            if (!arguments.length) return source;
            source = _, source_ = typeof _ === "function" ? null : _;
            return greatArc;
        };
        greatArc.target = function(_) {
            if (!arguments.length) return target;
            target = _, target_ = typeof _ === "function" ? null : _;
            return greatArc;
        };
        greatArc.precision = function() {
            return arguments.length ? greatArc : 0;
        };
        return greatArc;
    };
    d3.geo.interpolate = function(source, target) {
        return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
    };
    function d3_geo_interpolate(x0, y0, x1, y1) {
        var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
        var interpolate = d ? function(t) {
            var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
            return [
                Math.atan2(y, x) * d3_degrees,
                Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees
            ];
        } : function() {
            return [
                x0 * d3_degrees,
                y0 * d3_degrees
            ];
        };
        interpolate.distance = d;
        return interpolate;
    }
    d3.geo.length = function(object) {
        d3_geo_lengthSum = 0;
        d3.geo.stream(object, d3_geo_length);
        return d3_geo_lengthSum;
    };
    var d3_geo_lengthSum;
    var d3_geo_length = {
        sphere: d3_noop,
        point: d3_noop,
        lineStart: d3_geo_lengthLineStart,
        lineEnd: d3_noop,
        polygonStart: d3_noop,
        polygonEnd: d3_noop
    };
    function d3_geo_lengthLineStart() {
        var \u03BB0, sin\u03C60, cos\u03C60;
        d3_geo_length.point = function(\u03BB, \u03C6) {
            \u03BB0 = \u03BB * d3_radians, sin\u03C60 = Math.sin(\u03C6 *= d3_radians), cos\u03C60 = Math.cos(\u03C6);
            d3_geo_length.point = nextPoint;
        };
        d3_geo_length.lineEnd = function() {
            d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
        };
        function nextPoint(\u03BB, \u03C6) {
            var sin\u03C6 = Math.sin(\u03C6 *= d3_radians), cos\u03C6 = Math.cos(\u03C6), t = Math.abs((\u03BB *= d3_radians) - \u03BB0), cos\u0394\u03BB = Math.cos(t);
            d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cos\u03C6 * Math.sin(t)) * t + (t = cos\u03C60 * sin\u03C6 - sin\u03C60 * cos\u03C6 * cos\u0394\u03BB) * t), sin\u03C60 * sin\u03C6 + cos\u03C60 * cos\u03C6 * cos\u0394\u03BB);
            \u03BB0 = \u03BB, sin\u03C60 = sin\u03C6, cos\u03C60 = cos\u03C6;
        }
    }
    function d3_geo_conic(projectAt) {
        var \u03C60 = 0, \u03C61 = \u03C0 / 3, m = d3_geo_projectionMutator(projectAt), p = m(\u03C60, \u03C61);
        p.parallels = function(_) {
            if (!arguments.length) return [
                \u03C60 / \u03C0 * 180,
                \u03C61 / \u03C0 * 180
            ];
            return m(\u03C60 = _[0] * \u03C0 / 180, \u03C61 = _[1] * \u03C0 / 180);
        };
        return p;
    }
    function d3_geo_conicEqualArea(\u03C60, \u03C61) {
        var sin\u03C60 = Math.sin(\u03C60), n = (sin\u03C60 + Math.sin(\u03C61)) / 2, C = 1 + sin\u03C60 * (2 * n - sin\u03C60), \u03C10 = Math.sqrt(C) / n;
        function forward(\u03BB, \u03C6) {
            var \u03C1 = Math.sqrt(C - 2 * n * Math.sin(\u03C6)) / n;
            return [
                \u03C1 * Math.sin(\u03BB *= n),
                \u03C10 - \u03C1 * Math.cos(\u03BB)
            ];
        }
        forward.invert = function(x, y) {
            var \u03C10_y = \u03C10 - y;
            return [
                Math.atan2(x, \u03C10_y) / n,
                Math.asin((C - (x * x + \u03C10_y * \u03C10_y) * n * n) / (2 * n))
            ];
        };
        return forward;
    }
    (d3.geo.conicEqualArea = function() {
        return d3_geo_conic(d3_geo_conicEqualArea);
    }).raw = d3_geo_conicEqualArea;
    d3.geo.albersUsa = function() {
        var lower48 = d3.geo.conicEqualArea().rotate([
            98,
            0
        ]).center([
            0,
            38
        ]).parallels([
            29.5,
            45.5
        ]);
        var alaska = d3.geo.conicEqualArea().rotate([
            160,
            0
        ]).center([
            0,
            60
        ]).parallels([
            55,
            65
        ]);
        var hawaii = d3.geo.conicEqualArea().rotate([
            160,
            0
        ]).center([
            0,
            20
        ]).parallels([
            8,
            18
        ]);
        var puertoRico = d3.geo.conicEqualArea().rotate([
            60,
            0
        ]).center([
            0,
            10
        ]).parallels([
            8,
            18
        ]);
        var alaskaInvert, hawaiiInvert, puertoRicoInvert;
        function albersUsa(coordinates) {
            return projection(coordinates)(coordinates);
        }
        function projection(point) {
            var lon = point[0], lat = point[1];
            return lat > 50 ? alaska : lon < -140 ? hawaii : lat < 21 ? puertoRico : lower48;
        }
        albersUsa.invert = function(coordinates) {
            return alaskaInvert(coordinates) || hawaiiInvert(coordinates) || puertoRicoInvert(coordinates) || lower48.invert(coordinates);
        };
        albersUsa.scale = function(x) {
            if (!arguments.length) return lower48.scale();
            lower48.scale(x);
            alaska.scale(x * .6);
            hawaii.scale(x);
            puertoRico.scale(x * 1.5);
            return albersUsa.translate(lower48.translate());
        };
        albersUsa.translate = function(x) {
            if (!arguments.length) return lower48.translate();
            var dz = lower48.scale(), dx = x[0], dy = x[1];
            lower48.translate(x);
            alaska.translate([
                dx - .4 * dz,
                dy + .17 * dz
            ]);
            hawaii.translate([
                dx - .19 * dz,
                dy + .2 * dz
            ]);
            puertoRico.translate([
                dx + .58 * dz,
                dy + .43 * dz
            ]);
            alaskaInvert = d3_geo_albersUsaInvert(alaska, [
                [
                    -180,
                    50
                ],
                [
                    -130,
                    72
                ]
            ]);
            hawaiiInvert = d3_geo_albersUsaInvert(hawaii, [
                [
                    -164,
                    18
                ],
                [
                    -154,
                    24
                ]
            ]);
            puertoRicoInvert = d3_geo_albersUsaInvert(puertoRico, [
                [
                    -67.5,
                    17.5
                ],
                [
                    -65,
                    19
                ]
            ]);
            return albersUsa;
        };
        return albersUsa.scale(1e3);
    };
    function d3_geo_albersUsaInvert(projection, extent) {
        var a = projection(extent[0]), b1 = projection([
            .5 * (extent[0][0] + extent[1][0]),
            extent[0][1]
        ]), c = projection([
            extent[1][0],
            extent[0][1]
        ]), d = projection(extent[1]);
        var dya = b1[1] - a[1], dxa = b1[0] - a[0], dyb = c[1] - b1[1], dxb = c[0] - b1[0];
        var ma = dya / dxa, mb = dyb / dxb;
        var cx = .5 * (ma * mb * (a[1] - c[1]) + mb * (a[0] + b1[0]) - ma * (b1[0] + c[0])) / (mb - ma), cy = (.5 * (a[0] + b1[0]) - cx) / ma + .5 * (a[1] + b1[1]);
        var dx0 = d[0] - cx, dy0 = d[1] - cy, dx1 = a[0] - cx, dy1 = a[1] - cy, r0 = dx0 * dx0 + dy0 * dy0, r1 = dx1 * dx1 + dy1 * dy1;
        var a0 = Math.atan2(dy0, dx0), a1 = Math.atan2(dy1, dx1);
        return function(coordinates) {
            var dx = coordinates[0] - cx, dy = coordinates[1] - cy, r = dx * dx + dy * dy, a = Math.atan2(dy, dx);
            if (r0 < r && r < r1 && a0 < a && a < a1) return projection.invert(coordinates);
        };
    }
    var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
        point: d3_noop,
        lineStart: d3_noop,
        lineEnd: d3_noop,
        polygonStart: function() {
            d3_geo_pathAreaPolygon = 0;
            d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
        },
        polygonEnd: function() {
            d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
            d3_geo_pathAreaSum += Math.abs(d3_geo_pathAreaPolygon / 2);
        }
    };
    function d3_geo_pathAreaRingStart() {
        var x00, y00, x0, y0;
        d3_geo_pathArea.point = function(x, y) {
            d3_geo_pathArea.point = nextPoint;
            x00 = x0 = x, y00 = y0 = y;
        };
        function nextPoint(x, y) {
            d3_geo_pathAreaPolygon += y0 * x - x0 * y;
            x0 = x, y0 = y;
        }
        d3_geo_pathArea.lineEnd = function() {
            nextPoint(x00, y00);
        };
    }
    function d3_geo_pathBuffer() {
        var pointCircle = d3_geo_pathCircle(4.5), buffer = [];
        var stream = {
            point: point,
            lineStart: function() {
                stream.point = pointLineStart;
            },
            lineEnd: lineEnd,
            polygonStart: function() {
                stream.lineEnd = lineEndPolygon;
            },
            polygonEnd: function() {
                stream.lineEnd = lineEnd;
                stream.point = point;
            },
            pointRadius: function(_) {
                pointCircle = d3_geo_pathCircle(_);
                return stream;
            },
            result: function() {
                if (buffer.length) {
                    var result = buffer.join("");
                    buffer = [];
                    return result;
                }
            }
        };
        function point(x, y) {
            buffer.push("M", x, ",", y, pointCircle);
        }
        function pointLineStart(x, y) {
            buffer.push("M", x, ",", y);
            stream.point = pointLine;
        }
        function pointLine(x, y) {
            buffer.push("L", x, ",", y);
        }
        function lineEnd() {
            stream.point = point;
        }
        function lineEndPolygon() {
            buffer.push("Z");
        }
        return stream;
    }
    var d3_geo_pathCentroid = {
        point: d3_geo_pathCentroidPoint,
        lineStart: d3_geo_pathCentroidLineStart,
        lineEnd: d3_geo_pathCentroidLineEnd,
        polygonStart: function() {
            d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
        },
        polygonEnd: function() {
            d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
            d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
            d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
        }
    };
    function d3_geo_pathCentroidPoint(x, y) {
        if (d3_geo_centroidDimension) return;
        d3_geo_centroidX += x;
        d3_geo_centroidY += y;
        ++d3_geo_centroidZ;
    }
    function d3_geo_pathCentroidLineStart() {
        var x0, y0;
        if (d3_geo_centroidDimension !== 1) {
            if (d3_geo_centroidDimension < 1) {
                d3_geo_centroidDimension = 1;
                d3_geo_centroidX = d3_geo_centroidY = d3_geo_centroidZ = 0;
            } else return;
        }
        d3_geo_pathCentroid.point = function(x, y) {
            d3_geo_pathCentroid.point = nextPoint;
            x0 = x, y0 = y;
        };
        function nextPoint(x, y) {
            var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
            d3_geo_centroidX += z * (x0 + x) / 2;
            d3_geo_centroidY += z * (y0 + y) / 2;
            d3_geo_centroidZ += z;
            x0 = x, y0 = y;
        }
    }
    function d3_geo_pathCentroidLineEnd() {
        d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
    }
    function d3_geo_pathCentroidRingStart() {
        var x00, y00, x0, y0;
        if (d3_geo_centroidDimension < 2) {
            d3_geo_centroidDimension = 2;
            d3_geo_centroidX = d3_geo_centroidY = d3_geo_centroidZ = 0;
        }
        d3_geo_pathCentroid.point = function(x, y) {
            d3_geo_pathCentroid.point = nextPoint;
            x00 = x0 = x, y00 = y0 = y;
        };
        function nextPoint(x, y) {
            var z = y0 * x - x0 * y;
            d3_geo_centroidX += z * (x0 + x);
            d3_geo_centroidY += z * (y0 + y);
            d3_geo_centroidZ += z * 3;
            x0 = x, y0 = y;
        }
        d3_geo_pathCentroid.lineEnd = function() {
            nextPoint(x00, y00);
        };
    }
    function d3_geo_pathContext(context) {
        var pointRadius = 4.5;
        var stream = {
            point: point,
            lineStart: function() {
                stream.point = pointLineStart;
            },
            lineEnd: lineEnd,
            polygonStart: function() {
                stream.lineEnd = lineEndPolygon;
            },
            polygonEnd: function() {
                stream.lineEnd = lineEnd;
                stream.point = point;
            },
            pointRadius: function(_) {
                pointRadius = _;
                return stream;
            },
            result: d3_noop
        };
        function point(x, y) {
            context.moveTo(x, y);
            context.arc(x, y, pointRadius, 0, 2 * \u03C0);
        }
        function pointLineStart(x, y) {
            context.moveTo(x, y);
            stream.point = pointLine;
        }
        function pointLine(x, y) {
            context.lineTo(x, y);
        }
        function lineEnd() {
            stream.point = point;
        }
        function lineEndPolygon() {
            context.closePath();
        }
        return stream;
    }
    d3.geo.path = function() {
        var pointRadius = 4.5, projection, context, projectStream, contextStream;
        function path(object) {
            if (object) d3.geo.stream(object, projectStream(contextStream.pointRadius(typeof pointRadius === "function" ? +pointRadius.apply(this, arguments) : pointRadius)));
            return contextStream.result();
        }
        path.area = function(object) {
            d3_geo_pathAreaSum = 0;
            d3.geo.stream(object, projectStream(d3_geo_pathArea));
            return d3_geo_pathAreaSum;
        };
        path.centroid = function(object) {
            d3_geo_centroidDimension = d3_geo_centroidX = d3_geo_centroidY = d3_geo_centroidZ = 0;
            d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
            return d3_geo_centroidZ ? [
                d3_geo_centroidX / d3_geo_centroidZ,
                d3_geo_centroidY / d3_geo_centroidZ
            ] : undefined;
        };
        path.bounds = function(object) {
            return d3_geo_bounds(projectStream)(object);
        };
        path.projection = function(_) {
            if (!arguments.length) return projection;
            projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
            return path;
        };
        path.context = function(_) {
            if (!arguments.length) return context;
            contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
            return path;
        };
        path.pointRadius = function(_) {
            if (!arguments.length) return pointRadius;
            pointRadius = typeof _ === "function" ? _ : +_;
            return path;
        };
        return path.projection(d3.geo.albersUsa()).context(null);
    };
    function d3_geo_pathCircle(radius) {
        return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
    }
    function d3_geo_pathProjectStream(project) {
        var resample = d3_geo_resample(function(\u03BB, \u03C6) {
            return project([
                \u03BB * d3_degrees,
                \u03C6 * d3_degrees
            ]);
        });
        return function(stream) {
            stream = resample(stream);
            return {
                point: function(\u03BB, \u03C6) {
                    stream.point(\u03BB * d3_radians, \u03C6 * d3_radians);
                },
                sphere: function() {
                    stream.sphere();
                },
                lineStart: function() {
                    stream.lineStart();
                },
                lineEnd: function() {
                    stream.lineEnd();
                },
                polygonStart: function() {
                    stream.polygonStart();
                },
                polygonEnd: function() {
                    stream.polygonEnd();
                }
            };
        };
    }
    d3.geo.albers = function() {
        return d3.geo.conicEqualArea().parallels([
            29.5,
            45.5
        ]).rotate([
            98,
            0
        ]).center([
            0,
            38
        ]).scale(1e3);
    };
    function d3_geo_azimuthal(scale, angle) {
        function azimuthal(\u03BB, \u03C6) {
            var cos\u03BB = Math.cos(\u03BB), cos\u03C6 = Math.cos(\u03C6), k = scale(cos\u03BB * cos\u03C6);
            return [
                k * cos\u03C6 * Math.sin(\u03BB),
                k * Math.sin(\u03C6)
            ];
        }
        azimuthal.invert = function(x, y) {
            var \u03C1 = Math.sqrt(x * x + y * y), c = angle(\u03C1), sinc = Math.sin(c), cosc = Math.cos(c);
            return [
                Math.atan2(x * sinc, \u03C1 * cosc),
                Math.asin(\u03C1 && y * sinc / \u03C1)
            ];
        };
        return azimuthal;
    }
    var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cos\u03BBcos\u03C6) {
        return Math.sqrt(2 / (1 + cos\u03BBcos\u03C6));
    }, function(\u03C1) {
        return 2 * Math.asin(\u03C1 / 2);
    });
    (d3.geo.azimuthalEqualArea = function() {
        return d3_geo_projection(d3_geo_azimuthalEqualArea);
    }).raw = d3_geo_azimuthalEqualArea;
    var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cos\u03BBcos\u03C6) {
        var c = Math.acos(cos\u03BBcos\u03C6);
        return c && c / Math.sin(c);
    }, d3_identity);
    (d3.geo.azimuthalEquidistant = function() {
        return d3_geo_projection(d3_geo_azimuthalEquidistant);
    }).raw = d3_geo_azimuthalEquidistant;
    function d3_geo_conicConformal(\u03C60, \u03C61) {
        var cos\u03C60 = Math.cos(\u03C60), t = function(\u03C6) {
            return Math.tan(\u03C0 / 4 + \u03C6 / 2);
        }, n = \u03C60 === \u03C61 ? Math.sin(\u03C60) : Math.log(cos\u03C60 / Math.cos(\u03C61)) / Math.log(t(\u03C61) / t(\u03C60)), F = cos\u03C60 * Math.pow(t(\u03C60), n) / n;
        if (!n) return d3_geo_mercator;
        function forward(\u03BB, \u03C6) {
            var \u03C1 = Math.abs(Math.abs(\u03C6) - \u03C0 / 2) < \u03B5 ? 0 : F / Math.pow(t(\u03C6), n);
            return [
                \u03C1 * Math.sin(n * \u03BB),
                F - \u03C1 * Math.cos(n * \u03BB)
            ];
        }
        forward.invert = function(x, y) {
            var \u03C10_y = F - y, \u03C1 = d3_sgn(n) * Math.sqrt(x * x + \u03C10_y * \u03C10_y);
            return [
                Math.atan2(x, \u03C10_y) / n,
                2 * Math.atan(Math.pow(F / \u03C1, 1 / n)) - \u03C0 / 2
            ];
        };
        return forward;
    }
    (d3.geo.conicConformal = function() {
        return d3_geo_conic(d3_geo_conicConformal);
    }).raw = d3_geo_conicConformal;
    function d3_geo_conicEquidistant(\u03C60, \u03C61) {
        var cos\u03C60 = Math.cos(\u03C60), n = \u03C60 === \u03C61 ? Math.sin(\u03C60) : (cos\u03C60 - Math.cos(\u03C61)) / (\u03C61 - \u03C60), G = cos\u03C60 / n + \u03C60;
        if (Math.abs(n) < \u03B5) return d3_geo_equirectangular;
        function forward(\u03BB, \u03C6) {
            var \u03C1 = G - \u03C6;
            return [
                \u03C1 * Math.sin(n * \u03BB),
                G - \u03C1 * Math.cos(n * \u03BB)
            ];
        }
        forward.invert = function(x, y) {
            var \u03C10_y = G - y;
            return [
                Math.atan2(x, \u03C10_y) / n,
                G - d3_sgn(n) * Math.sqrt(x * x + \u03C10_y * \u03C10_y)
            ];
        };
        return forward;
    }
    (d3.geo.conicEquidistant = function() {
        return d3_geo_conic(d3_geo_conicEquidistant);
    }).raw = d3_geo_conicEquidistant;
    var d3_geo_gnomonic = d3_geo_azimuthal(function(cos\u03BBcos\u03C6) {
        return 1 / cos\u03BBcos\u03C6;
    }, Math.atan);
    (d3.geo.gnomonic = function() {
        return d3_geo_projection(d3_geo_gnomonic);
    }).raw = d3_geo_gnomonic;
    function d3_geo_mercator(\u03BB, \u03C6) {
        return [
            \u03BB,
            Math.log(Math.tan(\u03C0 / 4 + \u03C6 / 2))
        ];
    }
    d3_geo_mercator.invert = function(x, y) {
        return [
            x,
            2 * Math.atan(Math.exp(y)) - \u03C0 / 2
        ];
    };
    function d3_geo_mercatorProjection(project) {
        var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
        m.scale = function() {
            var v = scale.apply(m, arguments);
            return v === m ? clipAuto ? m.clipExtent(null) : m : v;
        };
        m.translate = function() {
            var v = translate.apply(m, arguments);
            return v === m ? clipAuto ? m.clipExtent(null) : m : v;
        };
        m.clipExtent = function(_) {
            var v = clipExtent.apply(m, arguments);
            if (v === m) {
                if (clipAuto = _ == null) {
                    var k = \u03C0 * scale(), t = translate();
                    clipExtent([
                        [
                            t[0] - k,
                            t[1] - k
                        ],
                        [
                            t[0] + k,
                            t[1] + k
                        ]
                    ]);
                }
            } else if (clipAuto) v = null;
            return v;
        };
        return m.clipExtent(null);
    }
    (d3.geo.mercator = function() {
        return d3_geo_mercatorProjection(d3_geo_mercator);
    }).raw = d3_geo_mercator;
    var d3_geo_orthographic = d3_geo_azimuthal(function() {
        return 1;
    }, Math.asin);
    (d3.geo.orthographic = function() {
        return d3_geo_projection(d3_geo_orthographic);
    }).raw = d3_geo_orthographic;
    var d3_geo_stereographic = d3_geo_azimuthal(function(cos\u03BBcos\u03C6) {
        return 1 / (1 + cos\u03BBcos\u03C6);
    }, function(\u03C1) {
        return 2 * Math.atan(\u03C1);
    });
    (d3.geo.stereographic = function() {
        return d3_geo_projection(d3_geo_stereographic);
    }).raw = d3_geo_stereographic;
    function d3_geo_transverseMercator(\u03BB, \u03C6) {
        var B = Math.cos(\u03C6) * Math.sin(\u03BB);
        return [
            Math.log((1 + B) / (1 - B)) / 2,
            Math.atan2(Math.tan(\u03C6), Math.cos(\u03BB))
        ];
    }
    d3_geo_transverseMercator.invert = function(x, y) {
        return [
            Math.atan2(d3_sinh(x), Math.cos(y)),
            d3_asin(Math.sin(y) / d3_cosh(x))
        ];
    };
    (d3.geo.transverseMercator = function() {
        return d3_geo_mercatorProjection(d3_geo_transverseMercator);
    }).raw = d3_geo_transverseMercator;
    d3.geom = {};
    d3.svg = {};
    function d3_svg_line(projection) {
        var x = d3_svg_lineX, y = d3_svg_lineY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
        function line(data) {
            var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
            function segment() {
                segments.push("M", interpolate(projection(points), tension));
            }
            while(++i < n){
                if (defined.call(this, d = data[i], i)) points.push([
                    +fx.call(this, d, i),
                    +fy.call(this, d, i)
                ]);
                else if (points.length) {
                    segment();
                    points = [];
                }
            }
            if (points.length) segment();
            return segments.length ? segments.join("") : null;
        }
        line.x = function(_) {
            if (!arguments.length) return x;
            x = _;
            return line;
        };
        line.y = function(_) {
            if (!arguments.length) return y;
            y = _;
            return line;
        };
        line.defined = function(_) {
            if (!arguments.length) return defined;
            defined = _;
            return line;
        };
        line.interpolate = function(_) {
            if (!arguments.length) return interpolateKey;
            if (typeof _ === "function") interpolateKey = interpolate = _;
            else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
            return line;
        };
        line.tension = function(_) {
            if (!arguments.length) return tension;
            tension = _;
            return line;
        };
        return line;
    }
    d3.svg.line = function() {
        return d3_svg_line(d3_identity);
    };
    function d3_svg_lineX(d) {
        return d[0];
    }
    function d3_svg_lineY(d) {
        return d[1];
    }
    var d3_svg_lineInterpolators = d3.map({
        linear: d3_svg_lineLinear,
        "linear-closed": d3_svg_lineLinearClosed,
        "step-before": d3_svg_lineStepBefore,
        "step-after": d3_svg_lineStepAfter,
        basis: d3_svg_lineBasis,
        "basis-open": d3_svg_lineBasisOpen,
        "basis-closed": d3_svg_lineBasisClosed,
        bundle: d3_svg_lineBundle,
        cardinal: d3_svg_lineCardinal,
        "cardinal-open": d3_svg_lineCardinalOpen,
        "cardinal-closed": d3_svg_lineCardinalClosed,
        monotone: d3_svg_lineMonotone
    });
    d3_svg_lineInterpolators.forEach(function(key, value) {
        value.key = key;
        value.closed = /-closed$/.test(key);
    });
    function d3_svg_lineLinear(points) {
        return points.join("L");
    }
    function d3_svg_lineLinearClosed(points) {
        return d3_svg_lineLinear(points) + "Z";
    }
    function d3_svg_lineStepBefore(points) {
        var i = 0, n = points.length, p = points[0], path = [
            p[0],
            ",",
            p[1]
        ];
        while(++i < n)path.push("V", (p = points[i])[1], "H", p[0]);
        return path.join("");
    }
    function d3_svg_lineStepAfter(points) {
        var i = 0, n = points.length, p = points[0], path = [
            p[0],
            ",",
            p[1]
        ];
        while(++i < n)path.push("H", (p = points[i])[0], "V", p[1]);
        return path.join("");
    }
    function d3_svg_lineCardinalOpen(points, tension) {
        return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, points.length - 1), d3_svg_lineCardinalTangents(points, tension));
    }
    function d3_svg_lineCardinalClosed(points, tension) {
        return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), points), d3_svg_lineCardinalTangents([
            points[points.length - 2]
        ].concat(points, [
            points[1]
        ]), tension));
    }
    function d3_svg_lineCardinal(points, tension) {
        return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
    }
    function d3_svg_lineHermite(points, tangents) {
        if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) return d3_svg_lineLinear(points);
        var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
        if (quad) {
            path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
            p0 = points[1];
            pi = 2;
        }
        if (tangents.length > 1) {
            t = tangents[1];
            p = points[pi];
            pi++;
            path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
            for(var i = 2; i < tangents.length; i++, pi++){
                p = points[pi];
                t = tangents[i];
                path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
            }
        }
        if (quad) {
            var lp = points[pi];
            path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
        }
        return path;
    }
    function d3_svg_lineCardinalTangents(points, tension) {
        var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
        while(++i < n){
            p0 = p1;
            p1 = p2;
            p2 = points[i];
            tangents.push([
                a * (p2[0] - p0[0]),
                a * (p2[1] - p0[1])
            ]);
        }
        return tangents;
    }
    function d3_svg_lineBasis(points) {
        if (points.length < 3) return d3_svg_lineLinear(points);
        var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [
            x0,
            x0,
            x0,
            (pi = points[1])[0]
        ], py = [
            y0,
            y0,
            y0,
            pi[1]
        ], path = [
            x0,
            ",",
            y0
        ];
        d3_svg_lineBasisBezier(path, px, py);
        while(++i < n){
            pi = points[i];
            px.shift();
            px.push(pi[0]);
            py.shift();
            py.push(pi[1]);
            d3_svg_lineBasisBezier(path, px, py);
        }
        i = -1;
        while(++i < 2){
            px.shift();
            px.push(pi[0]);
            py.shift();
            py.push(pi[1]);
            d3_svg_lineBasisBezier(path, px, py);
        }
        return path.join("");
    }
    function d3_svg_lineBasisOpen(points) {
        if (points.length < 4) return d3_svg_lineLinear(points);
        var path = [], i = -1, n = points.length, pi, px = [
            0
        ], py = [
            0
        ];
        while(++i < 3){
            pi = points[i];
            px.push(pi[0]);
            py.push(pi[1]);
        }
        path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
        --i;
        while(++i < n){
            pi = points[i];
            px.shift();
            px.push(pi[0]);
            py.shift();
            py.push(pi[1]);
            d3_svg_lineBasisBezier(path, px, py);
        }
        return path.join("");
    }
    function d3_svg_lineBasisClosed(points) {
        var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
        while(++i < 4){
            pi = points[i % n];
            px.push(pi[0]);
            py.push(pi[1]);
        }
        path = [
            d3_svg_lineDot4(d3_svg_lineBasisBezier3, px),
            ",",
            d3_svg_lineDot4(d3_svg_lineBasisBezier3, py)
        ];
        --i;
        while(++i < m){
            pi = points[i % n];
            px.shift();
            px.push(pi[0]);
            py.shift();
            py.push(pi[1]);
            d3_svg_lineBasisBezier(path, px, py);
        }
        return path.join("");
    }
    function d3_svg_lineBundle(points, tension) {
        var n = points.length - 1;
        if (n) {
            var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
            while(++i <= n){
                p = points[i];
                t = i / n;
                p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
                p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
            }
        }
        return d3_svg_lineBasis(points);
    }
    function d3_svg_lineDot4(a, b1) {
        return a[0] * b1[0] + a[1] * b1[1] + a[2] * b1[2] + a[3] * b1[3];
    }
    var d3_svg_lineBasisBezier1 = [
        0,
        2 / 3,
        1 / 3,
        0
    ], d3_svg_lineBasisBezier2 = [
        0,
        1 / 3,
        2 / 3,
        0
    ], d3_svg_lineBasisBezier3 = [
        0,
        1 / 6,
        2 / 3,
        1 / 6
    ];
    function d3_svg_lineBasisBezier(path, x, y) {
        path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
    }
    function d3_svg_lineSlope(p0, p1) {
        return (p1[1] - p0[1]) / (p1[0] - p0[0]);
    }
    function d3_svg_lineFiniteDifferences(points) {
        var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
        while(++i < j)m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
        m[i] = d;
        return m;
    }
    function d3_svg_lineMonotoneTangents(points) {
        var tangents = [], d, a, b1, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
        while(++i < j){
            d = d3_svg_lineSlope(points[i], points[i + 1]);
            if (Math.abs(d) < 1e-6) m[i] = m[i + 1] = 0;
            else {
                a = m[i] / d;
                b1 = m[i + 1] / d;
                s = a * a + b1 * b1;
                if (s > 9) {
                    s = d * 3 / Math.sqrt(s);
                    m[i] = s * a;
                    m[i + 1] = s * b1;
                }
            }
        }
        i = -1;
        while(++i <= j){
            s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
            tangents.push([
                s || 0,
                m[i] * s || 0
            ]);
        }
        return tangents;
    }
    function d3_svg_lineMonotone(points) {
        return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
    }
    d3.geom.hull = function(vertices) {
        var x = d3_svg_lineX, y = d3_svg_lineY;
        if (arguments.length) return hull(vertices);
        function hull(data) {
            if (data.length < 3) return [];
            var fx = d3_functor(x), fy = d3_functor(y), n = data.length, vertices, plen = n - 1, points = [], stack = [], d, i, j, h = 0, x1, y1, x2, y2, u, v, a, sp;
            if (fx === d3_svg_lineX && y === d3_svg_lineY) vertices = data;
            else for(i = 0, vertices = []; i < n; ++i)vertices.push([
                +fx.call(this, d = data[i], i),
                +fy.call(this, d, i)
            ]);
            for(i = 1; i < n; ++i){
                if (vertices[i][1] < vertices[h][1]) h = i;
                else if (vertices[i][1] == vertices[h][1]) h = vertices[i][0] < vertices[h][0] ? i : h;
            }
            for(i = 0; i < n; ++i){
                if (i === h) continue;
                y1 = vertices[i][1] - vertices[h][1];
                x1 = vertices[i][0] - vertices[h][0];
                points.push({
                    angle: Math.atan2(y1, x1),
                    index: i
                });
            }
            points.sort(function(a, b1) {
                return a.angle - b1.angle;
            });
            a = points[0].angle;
            v = points[0].index;
            u = 0;
            for(i = 1; i < plen; ++i){
                j = points[i].index;
                if (a == points[i].angle) {
                    x1 = vertices[v][0] - vertices[h][0];
                    y1 = vertices[v][1] - vertices[h][1];
                    x2 = vertices[j][0] - vertices[h][0];
                    y2 = vertices[j][1] - vertices[h][1];
                    if (x1 * x1 + y1 * y1 >= x2 * x2 + y2 * y2) points[i].index = -1;
                    else {
                        points[u].index = -1;
                        a = points[i].angle;
                        u = i;
                        v = j;
                    }
                } else {
                    a = points[i].angle;
                    u = i;
                    v = j;
                }
            }
            stack.push(h);
            for(i = 0, j = 0; i < 2; ++j)if (points[j].index !== -1) {
                stack.push(points[j].index);
                i++;
            }
            sp = stack.length;
            for(; j < plen; ++j){
                if (points[j].index === -1) continue;
                while(!d3_geom_hullCCW(stack[sp - 2], stack[sp - 1], points[j].index, vertices))--sp;
                stack[sp++] = points[j].index;
            }
            var poly = [];
            for(i = 0; i < sp; ++i)poly.push(data[stack[i]]);
            return poly;
        }
        hull.x = function(_) {
            return arguments.length ? (x = _, hull) : x;
        };
        hull.y = function(_) {
            return arguments.length ? (y = _, hull) : y;
        };
        return hull;
    };
    function d3_geom_hullCCW(i1, i2, i3, v) {
        var t, a, b1, c, d, e, f;
        t = v[i1];
        a = t[0];
        b1 = t[1];
        t = v[i2];
        c = t[0];
        d = t[1];
        t = v[i3];
        e = t[0];
        f = t[1];
        return (f - b1) * (c - a) - (d - b1) * (e - a) > 0;
    }
    d3.geom.polygon = function(coordinates) {
        coordinates.area = function() {
            var i = 0, n = coordinates.length, area = coordinates[n - 1][1] * coordinates[0][0] - coordinates[n - 1][0] * coordinates[0][1];
            while(++i < n)area += coordinates[i - 1][1] * coordinates[i][0] - coordinates[i - 1][0] * coordinates[i][1];
            return area * .5;
        };
        coordinates.centroid = function(k) {
            var i = -1, n = coordinates.length, x = 0, y = 0, a, b1 = coordinates[n - 1], c;
            if (!arguments.length) k = -1 / (6 * coordinates.area());
            while(++i < n){
                a = b1;
                b1 = coordinates[i];
                c = a[0] * b1[1] - b1[0] * a[1];
                x += (a[0] + b1[0]) * c;
                y += (a[1] + b1[1]) * c;
            }
            return [
                x * k,
                y * k
            ];
        };
        coordinates.clip = function(subject) {
            var input, i = -1, n = coordinates.length, j, m, a = coordinates[n - 1], b1, c, d;
            while(++i < n){
                input = subject.slice();
                subject.length = 0;
                b1 = coordinates[i];
                c = input[(m = input.length) - 1];
                j = -1;
                while(++j < m){
                    d = input[j];
                    if (d3_geom_polygonInside(d, a, b1)) {
                        if (!d3_geom_polygonInside(c, a, b1)) subject.push(d3_geom_polygonIntersect(c, d, a, b1));
                        subject.push(d);
                    } else if (d3_geom_polygonInside(c, a, b1)) subject.push(d3_geom_polygonIntersect(c, d, a, b1));
                    c = d;
                }
                a = b1;
            }
            return subject;
        };
        return coordinates;
    };
    function d3_geom_polygonInside(p, a, b1) {
        return (b1[0] - a[0]) * (p[1] - a[1]) < (b1[1] - a[1]) * (p[0] - a[0]);
    }
    function d3_geom_polygonIntersect(c, d, a, b1) {
        var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b1[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b1[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
        return [
            x1 + ua * x21,
            y1 + ua * y21
        ];
    }
    d3.geom.delaunay = function(vertices) {
        var edges = vertices.map(function() {
            return [];
        }), triangles = [];
        d3_geom_voronoiTessellate(vertices, function(e) {
            edges[e.region.l.index].push(vertices[e.region.r.index]);
        });
        edges.forEach(function(edge, i) {
            var v = vertices[i], cx = v[0], cy = v[1];
            edge.forEach(function(v) {
                v.angle = Math.atan2(v[0] - cx, v[1] - cy);
            });
            edge.sort(function(a, b1) {
                return a.angle - b1.angle;
            });
            for(var j = 0, m = edge.length - 1; j < m; j++)triangles.push([
                v,
                edge[j],
                edge[j + 1]
            ]);
        });
        return triangles;
    };
    d3.geom.voronoi = function(points) {
        var size = null, x = d3_svg_lineX, y = d3_svg_lineY, clip;
        if (arguments.length) return voronoi(points);
        function voronoi(data) {
            var points, polygons = data.map(function() {
                return [];
            }), fx = d3_functor(x), fy = d3_functor(y), d, i, n = data.length, Z = 1e6;
            if (fx === d3_svg_lineX && fy === d3_svg_lineY) points = data;
            else for(points = [], i = 0; i < n; ++i)points.push([
                +fx.call(this, d = data[i], i),
                +fy.call(this, d, i)
            ]);
            d3_geom_voronoiTessellate(points, function(e) {
                var s1, s2, x1, x2, y1, y2;
                if (e.a === 1 && e.b >= 0) {
                    s1 = e.ep.r;
                    s2 = e.ep.l;
                } else {
                    s1 = e.ep.l;
                    s2 = e.ep.r;
                }
                if (e.a === 1) {
                    y1 = s1 ? s1.y : -Z;
                    x1 = e.c - e.b * y1;
                    y2 = s2 ? s2.y : Z;
                    x2 = e.c - e.b * y2;
                } else {
                    x1 = s1 ? s1.x : -Z;
                    y1 = e.c - e.a * x1;
                    x2 = s2 ? s2.x : Z;
                    y2 = e.c - e.a * x2;
                }
                var v1 = [
                    x1,
                    y1
                ], v2 = [
                    x2,
                    y2
                ];
                polygons[e.region.l.index].push(v1, v2);
                polygons[e.region.r.index].push(v1, v2);
            });
            polygons = polygons.map(function(polygon, i) {
                var cx = points[i][0], cy = points[i][1], angle = polygon.map(function(v) {
                    return Math.atan2(v[0] - cx, v[1] - cy);
                }), order = d3.range(polygon.length).sort(function(a, b1) {
                    return angle[a] - angle[b1];
                });
                return order.filter(function(d, i) {
                    return !i || angle[d] - angle[order[i - 1]] > \u03B5;
                }).map(function(d) {
                    return polygon[d];
                });
            });
            polygons.forEach(function(polygon, i) {
                var n = polygon.length;
                if (!n) return polygon.push([
                    -Z,
                    -Z
                ], [
                    -Z,
                    Z
                ], [
                    Z,
                    Z
                ], [
                    Z,
                    -Z
                ]);
                if (n > 2) return;
                var p0 = points[i], p1 = polygon[0], p2 = polygon[1], x0 = p0[0], y0 = p0[1], x1 = p1[0], y1 = p1[1], x2 = p2[0], y2 = p2[1], dx = Math.abs(x2 - x1), dy = y2 - y1;
                if (Math.abs(dy) < \u03B5) {
                    var y = y0 < y1 ? -Z : Z;
                    polygon.push([
                        -Z,
                        y
                    ], [
                        Z,
                        y
                    ]);
                } else if (dx < \u03B5) {
                    var x = x0 < x1 ? -Z : Z;
                    polygon.push([
                        x,
                        -Z
                    ], [
                        x,
                        Z
                    ]);
                } else {
                    var y = (x2 - x1) * (y1 - y0) < (x1 - x0) * (y2 - y1) ? Z : -Z, z = Math.abs(dy) - dx;
                    if (Math.abs(z) < \u03B5) polygon.push([
                        dy < 0 ? y : -y,
                        y
                    ]);
                    else {
                        if (z > 0) y *= -1;
                        polygon.push([
                            -Z,
                            y
                        ], [
                            Z,
                            y
                        ]);
                    }
                }
            });
            if (clip) for(i = 0; i < n; ++i)clip(polygons[i]);
            for(i = 0; i < n; ++i)polygons[i].point = data[i];
            return polygons;
        }
        voronoi.x = function(_) {
            return arguments.length ? (x = _, voronoi) : x;
        };
        voronoi.y = function(_) {
            return arguments.length ? (y = _, voronoi) : y;
        };
        voronoi.size = function(_) {
            if (!arguments.length) return size;
            if (_ == null) clip = null;
            else {
                size = [
                    +_[0],
                    +_[1]
                ];
                clip = d3.geom.polygon([
                    [
                        0,
                        0
                    ],
                    [
                        0,
                        size[1]
                    ],
                    size,
                    [
                        size[0],
                        0
                    ]
                ]).clip;
            }
            return voronoi;
        };
        voronoi.links = function(data) {
            var points, graph = data.map(function() {
                return [];
            }), links = [], fx = d3_functor(x), fy = d3_functor(y), d, i, n = data.length;
            if (fx === d3_svg_lineX && fy === d3_svg_lineY) points = data;
            else for(i = 0; i < n; ++i)points.push([
                +fx.call(this, d = data[i], i),
                +fy.call(this, d, i)
            ]);
            d3_geom_voronoiTessellate(points, function(e) {
                var l = e.region.l.index, r = e.region.r.index;
                if (graph[l][r]) return;
                graph[l][r] = graph[r][l] = true;
                links.push({
                    source: data[l],
                    target: data[r]
                });
            });
            return links;
        };
        voronoi.triangles = function(data) {
            if (x === d3_svg_lineX && y === d3_svg_lineY) return d3.geom.delaunay(data);
            var points, point, fx = d3_functor(x), fy = d3_functor(y), d, i, n;
            for(i = 0, points = [], n = data.length; i < n; ++i){
                point = [
                    +fx.call(this, d = data[i], i),
                    +fy.call(this, d, i)
                ];
                point.data = d;
                points.push(point);
            }
            return d3.geom.delaunay(points).map(function(triangle) {
                return triangle.map(function(point) {
                    return point.data;
                });
            });
        };
        return voronoi;
    };
    var d3_geom_voronoiOpposite = {
        l: "r",
        r: "l"
    };
    function d3_geom_voronoiTessellate(points, callback) {
        var Sites = {
            list: points.map(function(v, i) {
                return {
                    index: i,
                    x: v[0],
                    y: v[1]
                };
            }).sort(function(a, b1) {
                return a.y < b1.y ? -1 : a.y > b1.y ? 1 : a.x < b1.x ? -1 : a.x > b1.x ? 1 : 0;
            }),
            bottomSite: null
        };
        var EdgeList = {
            list: [],
            leftEnd: null,
            rightEnd: null,
            init: function() {
                EdgeList.leftEnd = EdgeList.createHalfEdge(null, "l");
                EdgeList.rightEnd = EdgeList.createHalfEdge(null, "l");
                EdgeList.leftEnd.r = EdgeList.rightEnd;
                EdgeList.rightEnd.l = EdgeList.leftEnd;
                EdgeList.list.unshift(EdgeList.leftEnd, EdgeList.rightEnd);
            },
            createHalfEdge: function(edge, side) {
                return {
                    edge: edge,
                    side: side,
                    vertex: null,
                    l: null,
                    r: null
                };
            },
            insert: function(lb, he) {
                he.l = lb;
                he.r = lb.r;
                lb.r.l = he;
                lb.r = he;
            },
            leftBound: function(p) {
                var he = EdgeList.leftEnd;
                do he = he.r;
                while (he != EdgeList.rightEnd && Geom.rightOf(he, p));
                he = he.l;
                return he;
            },
            del: function(he) {
                he.l.r = he.r;
                he.r.l = he.l;
                he.edge = null;
            },
            right: function(he) {
                return he.r;
            },
            left: function(he) {
                return he.l;
            },
            leftRegion: function(he) {
                return he.edge == null ? Sites.bottomSite : he.edge.region[he.side];
            },
            rightRegion: function(he) {
                return he.edge == null ? Sites.bottomSite : he.edge.region[d3_geom_voronoiOpposite[he.side]];
            }
        };
        var Geom = {
            bisect: function(s1, s2) {
                var newEdge = {
                    region: {
                        l: s1,
                        r: s2
                    },
                    ep: {
                        l: null,
                        r: null
                    }
                };
                var dx = s2.x - s1.x, dy = s2.y - s1.y, adx = dx > 0 ? dx : -dx, ady = dy > 0 ? dy : -dy;
                newEdge.c = s1.x * dx + s1.y * dy + (dx * dx + dy * dy) * .5;
                if (adx > ady) {
                    newEdge.a = 1;
                    newEdge.b = dy / dx;
                    newEdge.c /= dx;
                } else {
                    newEdge.b = 1;
                    newEdge.a = dx / dy;
                    newEdge.c /= dy;
                }
                return newEdge;
            },
            intersect: function(el1, el2) {
                var e1 = el1.edge, e2 = el2.edge;
                if (!e1 || !e2 || e1.region.r == e2.region.r) return null;
                var d = e1.a * e2.b - e1.b * e2.a;
                if (Math.abs(d) < 1e-10) return null;
                var xint = (e1.c * e2.b - e2.c * e1.b) / d, yint = (e2.c * e1.a - e1.c * e2.a) / d, e1r = e1.region.r, e2r = e2.region.r, el, e;
                if (e1r.y < e2r.y || e1r.y == e2r.y && e1r.x < e2r.x) {
                    el = el1;
                    e = e1;
                } else {
                    el = el2;
                    e = e2;
                }
                var rightOfSite = xint >= e.region.r.x;
                if (rightOfSite && el.side === "l" || !rightOfSite && el.side === "r") return null;
                return {
                    x: xint,
                    y: yint
                };
            },
            rightOf: function(he, p) {
                var e = he.edge, topsite = e.region.r, rightOfSite = p.x > topsite.x;
                if (rightOfSite && he.side === "l") return 1;
                if (!rightOfSite && he.side === "r") return 0;
                if (e.a === 1) {
                    var dyp = p.y - topsite.y, dxp = p.x - topsite.x, fast = 0, above = 0;
                    if (!rightOfSite && e.b < 0 || rightOfSite && e.b >= 0) above = fast = dyp >= e.b * dxp;
                    else {
                        above = p.x + p.y * e.b > e.c;
                        if (e.b < 0) above = !above;
                        if (!above) fast = 1;
                    }
                    if (!fast) {
                        var dxs = topsite.x - e.region.l.x;
                        above = e.b * (dxp * dxp - dyp * dyp) < dxs * dyp * (1 + 2 * dxp / dxs + e.b * e.b);
                        if (e.b < 0) above = !above;
                    }
                } else {
                    var yl = e.c - e.a * p.x, t1 = p.y - yl, t2 = p.x - topsite.x, t3 = yl - topsite.y;
                    above = t1 * t1 > t2 * t2 + t3 * t3;
                }
                return he.side === "l" ? above : !above;
            },
            endPoint: function(edge, side, site) {
                edge.ep[side] = site;
                if (!edge.ep[d3_geom_voronoiOpposite[side]]) return;
                callback(edge);
            },
            distance: function(s, t) {
                var dx = s.x - t.x, dy = s.y - t.y;
                return Math.sqrt(dx * dx + dy * dy);
            }
        };
        var EventQueue = {
            list: [],
            insert: function(he, site, offset) {
                he.vertex = site;
                he.ystar = site.y + offset;
                for(var i = 0, list = EventQueue.list, l = list.length; i < l; i++){
                    var next = list[i];
                    if (he.ystar > next.ystar || he.ystar == next.ystar && site.x > next.vertex.x) continue;
                    else break;
                }
                list.splice(i, 0, he);
            },
            del: function(he) {
                for(var i = 0, ls = EventQueue.list, l = ls.length; i < l && ls[i] != he; ++i);
                ls.splice(i, 1);
            },
            empty: function() {
                return EventQueue.list.length === 0;
            },
            nextEvent: function(he) {
                for(var i = 0, ls = EventQueue.list, l = ls.length; i < l; ++i){
                    if (ls[i] == he) return ls[i + 1];
                }
                return null;
            },
            min: function() {
                var elem = EventQueue.list[0];
                return {
                    x: elem.vertex.x,
                    y: elem.ystar
                };
            },
            extractMin: function() {
                return EventQueue.list.shift();
            }
        };
        EdgeList.init();
        Sites.bottomSite = Sites.list.shift();
        var newSite = Sites.list.shift(), newIntStar;
        var lbnd, rbnd, llbnd, rrbnd, bisector;
        var bot, top, temp, p, v;
        var e, pm;
        while(true){
            if (!EventQueue.empty()) newIntStar = EventQueue.min();
            if (newSite && (EventQueue.empty() || newSite.y < newIntStar.y || newSite.y == newIntStar.y && newSite.x < newIntStar.x)) {
                lbnd = EdgeList.leftBound(newSite);
                rbnd = EdgeList.right(lbnd);
                bot = EdgeList.rightRegion(lbnd);
                e = Geom.bisect(bot, newSite);
                bisector = EdgeList.createHalfEdge(e, "l");
                EdgeList.insert(lbnd, bisector);
                p = Geom.intersect(lbnd, bisector);
                if (p) {
                    EventQueue.del(lbnd);
                    EventQueue.insert(lbnd, p, Geom.distance(p, newSite));
                }
                lbnd = bisector;
                bisector = EdgeList.createHalfEdge(e, "r");
                EdgeList.insert(lbnd, bisector);
                p = Geom.intersect(bisector, rbnd);
                if (p) EventQueue.insert(bisector, p, Geom.distance(p, newSite));
                newSite = Sites.list.shift();
            } else if (!EventQueue.empty()) {
                lbnd = EventQueue.extractMin();
                llbnd = EdgeList.left(lbnd);
                rbnd = EdgeList.right(lbnd);
                rrbnd = EdgeList.right(rbnd);
                bot = EdgeList.leftRegion(lbnd);
                top = EdgeList.rightRegion(rbnd);
                v = lbnd.vertex;
                Geom.endPoint(lbnd.edge, lbnd.side, v);
                Geom.endPoint(rbnd.edge, rbnd.side, v);
                EdgeList.del(lbnd);
                EventQueue.del(rbnd);
                EdgeList.del(rbnd);
                pm = "l";
                if (bot.y > top.y) {
                    temp = bot;
                    bot = top;
                    top = temp;
                    pm = "r";
                }
                e = Geom.bisect(bot, top);
                bisector = EdgeList.createHalfEdge(e, pm);
                EdgeList.insert(llbnd, bisector);
                Geom.endPoint(e, d3_geom_voronoiOpposite[pm], v);
                p = Geom.intersect(llbnd, bisector);
                if (p) {
                    EventQueue.del(llbnd);
                    EventQueue.insert(llbnd, p, Geom.distance(p, bot));
                }
                p = Geom.intersect(bisector, rrbnd);
                if (p) EventQueue.insert(bisector, p, Geom.distance(p, bot));
            } else break;
        }
        for(lbnd = EdgeList.right(EdgeList.leftEnd); lbnd != EdgeList.rightEnd; lbnd = EdgeList.right(lbnd))callback(lbnd.edge);
    }
    d3.geom.quadtree = function(points, x1, y1, x2, y2) {
        var x = d3_svg_lineX, y = d3_svg_lineY, compat;
        if (compat = arguments.length) {
            x = d3_geom_quadtreeCompatX;
            y = d3_geom_quadtreeCompatY;
            if (compat === 3) {
                y2 = y1;
                x2 = x1;
                y1 = x1 = 0;
            }
            return quadtree(points);
        }
        function quadtree(data) {
            var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
            if (x1 != null) x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
            else {
                x2_ = y2_ = -(x1_ = y1_ = Infinity);
                xs = [], ys = [];
                n = data.length;
                if (compat) for(i = 0; i < n; ++i){
                    d = data[i];
                    if (d.x < x1_) x1_ = d.x;
                    if (d.y < y1_) y1_ = d.y;
                    if (d.x > x2_) x2_ = d.x;
                    if (d.y > y2_) y2_ = d.y;
                    xs.push(d.x);
                    ys.push(d.y);
                }
                else for(i = 0; i < n; ++i){
                    var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
                    if (x_ < x1_) x1_ = x_;
                    if (y_ < y1_) y1_ = y_;
                    if (x_ > x2_) x2_ = x_;
                    if (y_ > y2_) y2_ = y_;
                    xs.push(x_);
                    ys.push(y_);
                }
            }
            var dx = x2_ - x1_, dy = y2_ - y1_;
            if (dx > dy) y2_ = y1_ + dx;
            else x2_ = x1_ + dy;
            function insert(n, d, x, y, x1, y1, x2, y2) {
                if (isNaN(x) || isNaN(y)) return;
                if (n.leaf) {
                    var nx = n.x, ny = n.y;
                    if (nx != null) {
                        if (Math.abs(nx - x) + Math.abs(ny - y) < .01) insertChild(n, d, x, y, x1, y1, x2, y2);
                        else {
                            var nPoint = n.point;
                            n.x = n.y = n.point = null;
                            insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
                            insertChild(n, d, x, y, x1, y1, x2, y2);
                        }
                    } else n.x = x, n.y = y, n.point = d;
                } else insertChild(n, d, x, y, x1, y1, x2, y2);
            }
            function insertChild(n, d, x, y, x1, y1, x2, y2) {
                var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, right = x >= sx, bottom = y >= sy, i = (bottom << 1) + right;
                n.leaf = false;
                n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
                if (right) x1 = sx;
                else x2 = sx;
                if (bottom) y1 = sy;
                else y2 = sy;
                insert(n, d, x, y, x1, y1, x2, y2);
            }
            var root = d3_geom_quadtreeNode();
            root.add = function(d) {
                insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
            };
            root.visit = function(f) {
                d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
            };
            i = -1;
            if (x1 == null) {
                while(++i < n)insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
                --i;
            } else data.forEach(root.add);
            xs = ys = data = d = null;
            return root;
        }
        quadtree.x = function(_) {
            return arguments.length ? (x = _, quadtree) : x;
        };
        quadtree.y = function(_) {
            return arguments.length ? (y = _, quadtree) : y;
        };
        quadtree.size = function(_) {
            if (!arguments.length) return x1 == null ? null : [
                x2,
                y2
            ];
            if (_ == null) x1 = y1 = x2 = y2 = null;
            else {
                x1 = y1 = 0;
                x2 = +_[0], y2 = +_[1];
            }
            return quadtree;
        };
        return quadtree;
    };
    function d3_geom_quadtreeCompatX(d) {
        return d.x;
    }
    function d3_geom_quadtreeCompatY(d) {
        return d.y;
    }
    function d3_geom_quadtreeNode() {
        return {
            leaf: true,
            nodes: [],
            point: null,
            x: null,
            y: null
        };
    }
    function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
        if (!f(node, x1, y1, x2, y2)) {
            var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
            if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
            if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
            if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
            if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
        }
    }
    d3.interpolateRgb = d3_interpolateRgb;
    function d3_interpolateRgb(a, b1) {
        a = d3.rgb(a);
        b1 = d3.rgb(b1);
        var ar = a.r, ag = a.g, ab = a.b, br = b1.r - ar, bg = b1.g - ag, bb = b1.b - ab;
        return function(t) {
            return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
        };
    }
    d3.transform = function(string) {
        var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
        return (d3.transform = function(string) {
            g.setAttribute("transform", string);
            var t = g.transform.baseVal.consolidate();
            return new d3_transform(t ? t.matrix : d3_transformIdentity);
        })(string);
    };
    function d3_transform(m) {
        var r0 = [
            m.a,
            m.b
        ], r1 = [
            m.c,
            m.d
        ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
        if (r0[0] * r1[1] < r1[0] * r0[1]) {
            r0[0] *= -1;
            r0[1] *= -1;
            kx *= -1;
            kz *= -1;
        }
        this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
        this.translate = [
            m.e,
            m.f
        ];
        this.scale = [
            kx,
            ky
        ];
        this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
    }
    d3_transform.prototype.toString = function() {
        return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
    };
    function d3_transformDot(a, b1) {
        return a[0] * b1[0] + a[1] * b1[1];
    }
    function d3_transformNormalize(a) {
        var k = Math.sqrt(d3_transformDot(a, a));
        if (k) {
            a[0] /= k;
            a[1] /= k;
        }
        return k;
    }
    function d3_transformCombine(a, b1, k) {
        a[0] += k * b1[0];
        a[1] += k * b1[1];
        return a;
    }
    var d3_transformIdentity = {
        a: 1,
        b: 0,
        c: 0,
        d: 1,
        e: 0,
        f: 0
    };
    d3.interpolateNumber = d3_interpolateNumber;
    function d3_interpolateNumber(a, b1) {
        b1 -= a = +a;
        return function(t) {
            return a + b1 * t;
        };
    }
    d3.interpolateTransform = d3_interpolateTransform;
    function d3_interpolateTransform(a, b1) {
        var s = [], q = [], n, A = d3.transform(a), B = d3.transform(b1), ta = A.translate, tb = B.translate, ra = A.rotate, rb = B.rotate, wa = A.skew, wb = B.skew, ka = A.scale, kb = B.scale;
        if (ta[0] != tb[0] || ta[1] != tb[1]) {
            s.push("translate(", null, ",", null, ")");
            q.push({
                i: 1,
                x: d3_interpolateNumber(ta[0], tb[0])
            }, {
                i: 3,
                x: d3_interpolateNumber(ta[1], tb[1])
            });
        } else if (tb[0] || tb[1]) s.push("translate(" + tb + ")");
        else s.push("");
        if (ra != rb) {
            if (ra - rb > 180) rb += 360;
            else if (rb - ra > 180) ra += 360;
            q.push({
                i: s.push(s.pop() + "rotate(", null, ")") - 2,
                x: d3_interpolateNumber(ra, rb)
            });
        } else if (rb) s.push(s.pop() + "rotate(" + rb + ")");
        if (wa != wb) q.push({
            i: s.push(s.pop() + "skewX(", null, ")") - 2,
            x: d3_interpolateNumber(wa, wb)
        });
        else if (wb) s.push(s.pop() + "skewX(" + wb + ")");
        if (ka[0] != kb[0] || ka[1] != kb[1]) {
            n = s.push(s.pop() + "scale(", null, ",", null, ")");
            q.push({
                i: n - 4,
                x: d3_interpolateNumber(ka[0], kb[0])
            }, {
                i: n - 2,
                x: d3_interpolateNumber(ka[1], kb[1])
            });
        } else if (kb[0] != 1 || kb[1] != 1) s.push(s.pop() + "scale(" + kb + ")");
        n = q.length;
        return function(t) {
            var i = -1, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    }
    d3.interpolateObject = d3_interpolateObject;
    function d3_interpolateObject(a, b1) {
        var i = {}, c = {}, k;
        for(k in a)if (k in b1) i[k] = d3_interpolateByName(k)(a[k], b1[k]);
        else c[k] = a[k];
        for(k in b1)if (!(k in a)) c[k] = b1[k];
        return function(t) {
            for(k in i)c[k] = i[k](t);
            return c;
        };
    }
    d3.interpolateString = d3_interpolateString;
    function d3_interpolateString(a, b1) {
        var m, i, j, s0 = 0, s1 = 0, s = [], q = [], n, o;
        a = a + "", b1 = b1 + "";
        d3_interpolate_number.lastIndex = 0;
        for(i = 0; m = d3_interpolate_number.exec(b1); ++i){
            if (m.index) s.push(b1.substring(s0, s1 = m.index));
            q.push({
                i: s.length,
                x: m[0]
            });
            s.push(null);
            s0 = d3_interpolate_number.lastIndex;
        }
        if (s0 < b1.length) s.push(b1.substring(s0));
        for(i = 0, n = q.length; (m = d3_interpolate_number.exec(a)) && i < n; ++i){
            o = q[i];
            if (o.x == m[0]) {
                if (o.i) {
                    if (s[o.i + 1] == null) {
                        s[o.i - 1] += o.x;
                        s.splice(o.i, 1);
                        for(j = i + 1; j < n; ++j)q[j].i--;
                    } else {
                        s[o.i - 1] += o.x + s[o.i + 1];
                        s.splice(o.i, 2);
                        for(j = i + 1; j < n; ++j)q[j].i -= 2;
                    }
                } else if (s[o.i + 1] == null) s[o.i] = o.x;
                else {
                    s[o.i] = o.x + s[o.i + 1];
                    s.splice(o.i + 1, 1);
                    for(j = i + 1; j < n; ++j)q[j].i--;
                }
                q.splice(i, 1);
                n--;
                i--;
            } else o.x = d3_interpolateNumber(parseFloat(m[0]), parseFloat(o.x));
        }
        while(i < n){
            o = q.pop();
            if (s[o.i + 1] == null) s[o.i] = o.x;
            else {
                s[o.i] = o.x + s[o.i + 1];
                s.splice(o.i + 1, 1);
            }
            n--;
        }
        if (s.length === 1) return s[0] == null ? q[0].x : function() {
            return b1;
        };
        return function(t) {
            for(i = 0; i < n; ++i)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    }
    var d3_interpolate_number = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
    d3.interpolate = d3_interpolate;
    function d3_interpolate(a, b1) {
        var i = d3.interpolators.length, f;
        while(--i >= 0 && !(f = d3.interpolators[i](a, b1)));
        return f;
    }
    function d3_interpolateByName(name) {
        return name == "transform" ? d3_interpolateTransform : d3_interpolate;
    }
    d3.interpolators = [
        function(a, b1) {
            var t = typeof b1;
            return (t === "string" || t !== typeof a ? d3_rgb_names.has(b1) || /^(#|rgb\(|hsl\()/.test(b1) ? d3_interpolateRgb : d3_interpolateString : b1 instanceof d3_Color ? d3_interpolateRgb : t === "object" ? Array.isArray(b1) ? d3_interpolateArray : d3_interpolateObject : d3_interpolateNumber)(a, b1);
        }
    ];
    d3.interpolateArray = d3_interpolateArray;
    function d3_interpolateArray(a, b1) {
        var x = [], c = [], na = a.length, nb = b1.length, n0 = Math.min(a.length, b1.length), i;
        for(i = 0; i < n0; ++i)x.push(d3_interpolate(a[i], b1[i]));
        for(; i < na; ++i)c[i] = a[i];
        for(; i < nb; ++i)c[i] = b1[i];
        return function(t) {
            for(i = 0; i < n0; ++i)c[i] = x[i](t);
            return c;
        };
    }
    var d3_ease_default = function() {
        return d3_identity;
    };
    var d3_ease = d3.map({
        linear: d3_ease_default,
        poly: d3_ease_poly,
        quad: function() {
            return d3_ease_quad;
        },
        cubic: function() {
            return d3_ease_cubic;
        },
        sin: function() {
            return d3_ease_sin;
        },
        exp: function() {
            return d3_ease_exp;
        },
        circle: function() {
            return d3_ease_circle;
        },
        elastic: d3_ease_elastic,
        back: d3_ease_back,
        bounce: function() {
            return d3_ease_bounce;
        }
    });
    var d3_ease_mode = d3.map({
        "in": d3_identity,
        out: d3_ease_reverse,
        "in-out": d3_ease_reflect,
        "out-in": function(f) {
            return d3_ease_reflect(d3_ease_reverse(f));
        }
    });
    d3.ease = function(name) {
        var i = name.indexOf("-"), t = i >= 0 ? name.substring(0, i) : name, m = i >= 0 ? name.substring(i + 1) : "in";
        t = d3_ease.get(t) || d3_ease_default;
        m = d3_ease_mode.get(m) || d3_identity;
        return d3_ease_clamp(m(t.apply(null, Array.prototype.slice.call(arguments, 1))));
    };
    function d3_ease_clamp(f) {
        return function(t) {
            return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
        };
    }
    function d3_ease_reverse(f) {
        return function(t) {
            return 1 - f(1 - t);
        };
    }
    function d3_ease_reflect(f) {
        return function(t) {
            return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
        };
    }
    function d3_ease_quad(t) {
        return t * t;
    }
    function d3_ease_cubic(t) {
        return t * t * t;
    }
    function d3_ease_cubicInOut(t) {
        if (t <= 0) return 0;
        if (t >= 1) return 1;
        var t2 = t * t, t3 = t2 * t;
        return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
    }
    function d3_ease_poly(e) {
        return function(t) {
            return Math.pow(t, e);
        };
    }
    function d3_ease_sin(t) {
        return 1 - Math.cos(t * \u03C0 / 2);
    }
    function d3_ease_exp(t) {
        return Math.pow(2, 10 * (t - 1));
    }
    function d3_ease_circle(t) {
        return 1 - Math.sqrt(1 - t * t);
    }
    function d3_ease_elastic(a, p) {
        var s;
        if (arguments.length < 2) p = .45;
        if (arguments.length) s = p / (2 * \u03C0) * Math.asin(1 / a);
        else a = 1, s = p / 4;
        return function(t) {
            return 1 + a * Math.pow(2, 10 * -t) * Math.sin((t - s) * 2 * \u03C0 / p);
        };
    }
    function d3_ease_back(s) {
        if (!s) s = 1.70158;
        return function(t) {
            return t * t * ((s + 1) * t - s);
        };
    }
    function d3_ease_bounce(t) {
        return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
    }
    d3.interpolateHcl = d3_interpolateHcl;
    function d3_interpolateHcl(a, b1) {
        a = d3.hcl(a);
        b1 = d3.hcl(b1);
        var ah = a.h, ac = a.c, al = a.l, bh = b1.h - ah, bc = b1.c - ac, bl = b1.l - al;
        if (bh > 180) bh -= 360;
        else if (bh < -180) bh += 360;
        return function(t) {
            return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
        };
    }
    d3.interpolateHsl = d3_interpolateHsl;
    function d3_interpolateHsl(a, b1) {
        a = d3.hsl(a);
        b1 = d3.hsl(b1);
        var h0 = a.h, s0 = a.s, l0 = a.l, h1 = b1.h - h0, s1 = b1.s - s0, l1 = b1.l - l0;
        if (h1 > 180) h1 -= 360;
        else if (h1 < -180) h1 += 360;
        return function(t) {
            return d3_hsl_rgb(h0 + h1 * t, s0 + s1 * t, l0 + l1 * t) + "";
        };
    }
    d3.interpolateLab = d3_interpolateLab;
    function d3_interpolateLab(a, b1) {
        a = d3.lab(a);
        b1 = d3.lab(b1);
        var al = a.l, aa = a.a, ab = a.b, bl = b1.l - al, ba = b1.a - aa, bb = b1.b - ab;
        return function(t) {
            return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
        };
    }
    d3.interpolateRound = d3_interpolateRound;
    function d3_interpolateRound(a, b1) {
        b1 -= a;
        return function(t) {
            return Math.round(a + b1 * t);
        };
    }
    function d3_uninterpolateNumber(a, b1) {
        b1 = b1 - (a = +a) ? 1 / (b1 - a) : 0;
        return function(x) {
            return (x - a) * b1;
        };
    }
    function d3_uninterpolateClamp(a, b1) {
        b1 = b1 - (a = +a) ? 1 / (b1 - a) : 0;
        return function(x) {
            return Math.max(0, Math.min(1, (x - a) * b1));
        };
    }
    d3.layout = {};
    d3.layout.bundle = function() {
        return function(links) {
            var paths = [], i = -1, n = links.length;
            while(++i < n)paths.push(d3_layout_bundlePath(links[i]));
            return paths;
        };
    };
    function d3_layout_bundlePath(link) {
        var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [
            start
        ];
        while(start !== lca){
            start = start.parent;
            points.push(start);
        }
        var k = points.length;
        while(end !== lca){
            points.splice(k, 0, end);
            end = end.parent;
        }
        return points;
    }
    function d3_layout_bundleAncestors(node) {
        var ancestors = [], parent = node.parent;
        while(parent != null){
            ancestors.push(node);
            node = parent;
            parent = parent.parent;
        }
        ancestors.push(node);
        return ancestors;
    }
    function d3_layout_bundleLeastCommonAncestor(a, b1) {
        if (a === b1) return a;
        var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b1), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
        while(aNode === bNode){
            sharedNode = aNode;
            aNode = aNodes.pop();
            bNode = bNodes.pop();
        }
        return sharedNode;
    }
    d3.layout.chord = function() {
        var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
        function relayout() {
            var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
            chords = [];
            groups = [];
            k = 0, i = -1;
            while(++i < n){
                x = 0, j = -1;
                while(++j < n)x += matrix[i][j];
                groupSums.push(x);
                subgroupIndex.push(d3.range(n));
                k += x;
            }
            if (sortGroups) groupIndex.sort(function(a, b1) {
                return sortGroups(groupSums[a], groupSums[b1]);
            });
            if (sortSubgroups) subgroupIndex.forEach(function(d, i) {
                d.sort(function(a, b1) {
                    return sortSubgroups(matrix[i][a], matrix[i][b1]);
                });
            });
            k = (2 * \u03C0 - padding * n) / k;
            x = 0, i = -1;
            while(++i < n){
                x0 = x, j = -1;
                while(++j < n){
                    var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
                    subgroups[di + "-" + dj] = {
                        index: di,
                        subindex: dj,
                        startAngle: a0,
                        endAngle: a1,
                        value: v
                    };
                }
                groups[di] = {
                    index: di,
                    startAngle: x0,
                    endAngle: x,
                    value: (x - x0) / k
                };
                x += padding;
            }
            i = -1;
            while(++i < n){
                j = i - 1;
                while(++j < n){
                    var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
                    if (source.value || target.value) chords.push(source.value < target.value ? {
                        source: target,
                        target: source
                    } : {
                        source: source,
                        target: target
                    });
                }
            }
            if (sortChords) resort();
        }
        function resort() {
            chords.sort(function(a, b1) {
                return sortChords((a.source.value + a.target.value) / 2, (b1.source.value + b1.target.value) / 2);
            });
        }
        chord.matrix = function(x) {
            if (!arguments.length) return matrix;
            n = (matrix = x) && matrix.length;
            chords = groups = null;
            return chord;
        };
        chord.padding = function(x) {
            if (!arguments.length) return padding;
            padding = x;
            chords = groups = null;
            return chord;
        };
        chord.sortGroups = function(x) {
            if (!arguments.length) return sortGroups;
            sortGroups = x;
            chords = groups = null;
            return chord;
        };
        chord.sortSubgroups = function(x) {
            if (!arguments.length) return sortSubgroups;
            sortSubgroups = x;
            chords = null;
            return chord;
        };
        chord.sortChords = function(x) {
            if (!arguments.length) return sortChords;
            sortChords = x;
            if (chords) resort();
            return chord;
        };
        chord.chords = function() {
            if (!chords) relayout();
            return chords;
        };
        chord.groups = function() {
            if (!groups) relayout();
            return groups;
        };
        return chord;
    };
    d3.layout.force = function() {
        var force = {}, event = d3.dispatch("start", "tick", "end"), size = [
            1,
            1
        ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, gravity = .1, theta = .8, nodes = [], links = [], distances, strengths, charges;
        function repulse(node) {
            return function(quad, x1, _, x2) {
                if (quad.point !== node) {
                    var dx = quad.cx - node.x, dy = quad.cy - node.y, dn = 1 / Math.sqrt(dx * dx + dy * dy);
                    if ((x2 - x1) * dn < theta) {
                        var k = quad.charge * dn * dn;
                        node.px -= dx * k;
                        node.py -= dy * k;
                        return true;
                    }
                    if (quad.point && isFinite(dn)) {
                        var k = quad.pointCharge * dn * dn;
                        node.px -= dx * k;
                        node.py -= dy * k;
                    }
                }
                return !quad.charge;
            };
        }
        force.tick = function() {
            if ((alpha *= .99) < .005) {
                event.end({
                    type: "end",
                    alpha: alpha = 0
                });
                return true;
            }
            var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
            for(i = 0; i < m; ++i){
                o = links[i];
                s = o.source;
                t = o.target;
                x = t.x - s.x;
                y = t.y - s.y;
                if (l = x * x + y * y) {
                    l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
                    x *= l;
                    y *= l;
                    t.x -= x * (k = s.weight / (t.weight + s.weight));
                    t.y -= y * k;
                    s.x += x * (k = 1 - k);
                    s.y += y * k;
                }
            }
            if (k = alpha * gravity) {
                x = size[0] / 2;
                y = size[1] / 2;
                i = -1;
                if (k) while(++i < n){
                    o = nodes[i];
                    o.x += (x - o.x) * k;
                    o.y += (y - o.y) * k;
                }
            }
            if (charge) {
                d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
                i = -1;
                while(++i < n)if (!(o = nodes[i]).fixed) q.visit(repulse(o));
            }
            i = -1;
            while(++i < n){
                o = nodes[i];
                if (o.fixed) {
                    o.x = o.px;
                    o.y = o.py;
                } else {
                    o.x -= (o.px - (o.px = o.x)) * friction;
                    o.y -= (o.py - (o.py = o.y)) * friction;
                }
            }
            event.tick({
                type: "tick",
                alpha: alpha
            });
        };
        force.nodes = function(x) {
            if (!arguments.length) return nodes;
            nodes = x;
            return force;
        };
        force.links = function(x) {
            if (!arguments.length) return links;
            links = x;
            return force;
        };
        force.size = function(x) {
            if (!arguments.length) return size;
            size = x;
            return force;
        };
        force.linkDistance = function(x) {
            if (!arguments.length) return linkDistance;
            linkDistance = typeof x === "function" ? x : +x;
            return force;
        };
        force.distance = force.linkDistance;
        force.linkStrength = function(x) {
            if (!arguments.length) return linkStrength;
            linkStrength = typeof x === "function" ? x : +x;
            return force;
        };
        force.friction = function(x) {
            if (!arguments.length) return friction;
            friction = +x;
            return force;
        };
        force.charge = function(x) {
            if (!arguments.length) return charge;
            charge = typeof x === "function" ? x : +x;
            return force;
        };
        force.gravity = function(x) {
            if (!arguments.length) return gravity;
            gravity = +x;
            return force;
        };
        force.theta = function(x) {
            if (!arguments.length) return theta;
            theta = +x;
            return force;
        };
        force.alpha = function(x) {
            if (!arguments.length) return alpha;
            x = +x;
            if (alpha) {
                if (x > 0) alpha = x;
                else alpha = 0;
            } else if (x > 0) {
                event.start({
                    type: "start",
                    alpha: alpha = x
                });
                d3.timer(force.tick);
            }
            return force;
        };
        force.start = function() {
            var i, j, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
            for(i = 0; i < n; ++i){
                (o = nodes[i]).index = i;
                o.weight = 0;
            }
            for(i = 0; i < m; ++i){
                o = links[i];
                if (typeof o.source == "number") o.source = nodes[o.source];
                if (typeof o.target == "number") o.target = nodes[o.target];
                ++o.source.weight;
                ++o.target.weight;
            }
            for(i = 0; i < n; ++i){
                o = nodes[i];
                if (isNaN(o.x)) o.x = position("x", w);
                if (isNaN(o.y)) o.y = position("y", h);
                if (isNaN(o.px)) o.px = o.x;
                if (isNaN(o.py)) o.py = o.y;
            }
            distances = [];
            if (typeof linkDistance === "function") for(i = 0; i < m; ++i)distances[i] = +linkDistance.call(this, links[i], i);
            else for(i = 0; i < m; ++i)distances[i] = linkDistance;
            strengths = [];
            if (typeof linkStrength === "function") for(i = 0; i < m; ++i)strengths[i] = +linkStrength.call(this, links[i], i);
            else for(i = 0; i < m; ++i)strengths[i] = linkStrength;
            charges = [];
            if (typeof charge === "function") for(i = 0; i < n; ++i)charges[i] = +charge.call(this, nodes[i], i);
            else for(i = 0; i < n; ++i)charges[i] = charge;
            function position(dimension, size) {
                var neighbors = neighbor(i), j = -1, m = neighbors.length, x;
                while(++j < m)if (!isNaN(x = neighbors[j][dimension])) return x;
                return Math.random() * size;
            }
            function neighbor() {
                if (!neighbors) {
                    neighbors = [];
                    for(j = 0; j < n; ++j)neighbors[j] = [];
                    for(j = 0; j < m; ++j){
                        var o = links[j];
                        neighbors[o.source.index].push(o.target);
                        neighbors[o.target.index].push(o.source);
                    }
                }
                return neighbors[i];
            }
            return force.resume();
        };
        force.resume = function() {
            return force.alpha(.1);
        };
        force.stop = function() {
            return force.alpha(0);
        };
        force.drag = function() {
            if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
            if (!arguments.length) return drag;
            this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
        };
        function dragmove(d) {
            d.px = d3.event.x, d.py = d3.event.y;
            force.resume();
        }
        return d3.rebind(force, event, "on");
    };
    function d3_layout_forceDragstart(d) {
        d.fixed |= 2;
    }
    function d3_layout_forceDragend(d) {
        d.fixed &= -7;
    }
    function d3_layout_forceMouseover(d) {
        d.fixed |= 4;
        d.px = d.x, d.py = d.y;
    }
    function d3_layout_forceMouseout(d) {
        d.fixed &= -5;
    }
    function d3_layout_forceAccumulate(quad, alpha, charges) {
        var cx = 0, cy = 0;
        quad.charge = 0;
        if (!quad.leaf) {
            var nodes = quad.nodes, n = nodes.length, i = -1, c;
            while(++i < n){
                c = nodes[i];
                if (c == null) continue;
                d3_layout_forceAccumulate(c, alpha, charges);
                quad.charge += c.charge;
                cx += c.charge * c.cx;
                cy += c.charge * c.cy;
            }
        }
        if (quad.point) {
            if (!quad.leaf) {
                quad.point.x += Math.random() - .5;
                quad.point.y += Math.random() - .5;
            }
            var k = alpha * charges[quad.point.index];
            quad.charge += quad.pointCharge = k;
            cx += k * quad.point.x;
            cy += k * quad.point.y;
        }
        quad.cx = cx / quad.charge;
        quad.cy = cy / quad.charge;
    }
    var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1;
    d3.layout.hierarchy = function() {
        var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
        function recurse(node, depth, nodes) {
            var childs = children.call(hierarchy, node, depth);
            node.depth = depth;
            nodes.push(node);
            if (childs && (n = childs.length)) {
                var i = -1, n, c = node.children = [], v = 0, j = depth + 1, d;
                while(++i < n){
                    d = recurse(childs[i], j, nodes);
                    d.parent = node;
                    c.push(d);
                    v += d.value;
                }
                if (sort) c.sort(sort);
                if (value) node.value = v;
            } else if (value) node.value = +value.call(hierarchy, node, depth) || 0;
            return node;
        }
        function revalue(node, depth) {
            var children = node.children, v = 0;
            if (children && (n = children.length)) {
                var i = -1, n, j = depth + 1;
                while(++i < n)v += revalue(children[i], j);
            } else if (value) v = +value.call(hierarchy, node, depth) || 0;
            if (value) node.value = v;
            return v;
        }
        function hierarchy(d) {
            var nodes = [];
            recurse(d, 0, nodes);
            return nodes;
        }
        hierarchy.sort = function(x) {
            if (!arguments.length) return sort;
            sort = x;
            return hierarchy;
        };
        hierarchy.children = function(x) {
            if (!arguments.length) return children;
            children = x;
            return hierarchy;
        };
        hierarchy.value = function(x) {
            if (!arguments.length) return value;
            value = x;
            return hierarchy;
        };
        hierarchy.revalue = function(root) {
            revalue(root, 0);
            return root;
        };
        return hierarchy;
    };
    function d3_layout_hierarchyRebind(object, hierarchy) {
        d3.rebind(object, hierarchy, "sort", "children", "value");
        object.nodes = object;
        object.links = d3_layout_hierarchyLinks;
        return object;
    }
    function d3_layout_hierarchyChildren(d) {
        return d.children;
    }
    function d3_layout_hierarchyValue(d) {
        return d.value;
    }
    function d3_layout_hierarchySort(a, b1) {
        return b1.value - a.value;
    }
    function d3_layout_hierarchyLinks(nodes) {
        return d3.merge(nodes.map(function(parent) {
            return (parent.children || []).map(function(child) {
                return {
                    source: parent,
                    target: child
                };
            });
        }));
    }
    d3.layout.partition = function() {
        var hierarchy = d3.layout.hierarchy(), size = [
            1,
            1
        ];
        function position(node, x, dx, dy) {
            var children = node.children;
            node.x = x;
            node.y = node.depth * dy;
            node.dx = dx;
            node.dy = dy;
            if (children && (n = children.length)) {
                var i = -1, n, c, d;
                dx = node.value ? dx / node.value : 0;
                while(++i < n){
                    position(c = children[i], x, d = c.value * dx, dy);
                    x += d;
                }
            }
        }
        function depth(node) {
            var children = node.children, d = 0;
            if (children && (n = children.length)) {
                var i = -1, n;
                while(++i < n)d = Math.max(d, depth(children[i]));
            }
            return 1 + d;
        }
        function partition(d, i) {
            var nodes = hierarchy.call(this, d, i);
            position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
            return nodes;
        }
        partition.size = function(x) {
            if (!arguments.length) return size;
            size = x;
            return partition;
        };
        return d3_layout_hierarchyRebind(partition, hierarchy);
    };
    d3.layout.pie = function() {
        var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = 2 * \u03C0;
        function pie(data) {
            var values = data.map(function(d, i) {
                return +value.call(pie, d, i);
            });
            var a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle);
            var k = ((typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a) / d3.sum(values);
            var index = d3.range(data.length);
            if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
                return values[j] - values[i];
            } : function(i, j) {
                return sort(data[i], data[j]);
            });
            var arcs = [];
            index.forEach(function(i) {
                var d;
                arcs[i] = {
                    data: data[i],
                    value: d = values[i],
                    startAngle: a,
                    endAngle: a += d * k
                };
            });
            return arcs;
        }
        pie.value = function(x) {
            if (!arguments.length) return value;
            value = x;
            return pie;
        };
        pie.sort = function(x) {
            if (!arguments.length) return sort;
            sort = x;
            return pie;
        };
        pie.startAngle = function(x) {
            if (!arguments.length) return startAngle;
            startAngle = x;
            return pie;
        };
        pie.endAngle = function(x) {
            if (!arguments.length) return endAngle;
            endAngle = x;
            return pie;
        };
        return pie;
    };
    var d3_layout_pieSortByValue = {};
    d3.layout.stack = function() {
        var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
        function stack(data, index) {
            var series = data.map(function(d, i) {
                return values.call(stack, d, i);
            });
            var points = series.map(function(d) {
                return d.map(function(v, i) {
                    return [
                        x.call(stack, v, i),
                        y.call(stack, v, i)
                    ];
                });
            });
            var orders = order.call(stack, points, index);
            series = d3.permute(series, orders);
            points = d3.permute(points, orders);
            var offsets = offset.call(stack, points, index);
            var n = series.length, m = series[0].length, i, j, o;
            for(j = 0; j < m; ++j){
                out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
                for(i = 1; i < n; ++i)out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
            }
            return data;
        }
        stack.values = function(x) {
            if (!arguments.length) return values;
            values = x;
            return stack;
        };
        stack.order = function(x) {
            if (!arguments.length) return order;
            order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
            return stack;
        };
        stack.offset = function(x) {
            if (!arguments.length) return offset;
            offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
            return stack;
        };
        stack.x = function(z) {
            if (!arguments.length) return x;
            x = z;
            return stack;
        };
        stack.y = function(z) {
            if (!arguments.length) return y;
            y = z;
            return stack;
        };
        stack.out = function(z) {
            if (!arguments.length) return out;
            out = z;
            return stack;
        };
        return stack;
    };
    function d3_layout_stackX(d) {
        return d.x;
    }
    function d3_layout_stackY(d) {
        return d.y;
    }
    function d3_layout_stackOut(d, y0, y) {
        d.y0 = y0;
        d.y = y;
    }
    var d3_layout_stackOrders = d3.map({
        "inside-out": function(data) {
            var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b1) {
                return max[a] - max[b1];
            }), top = 0, bottom = 0, tops = [], bottoms = [];
            for(i = 0; i < n; ++i){
                j = index[i];
                if (top < bottom) {
                    top += sums[j];
                    tops.push(j);
                } else {
                    bottom += sums[j];
                    bottoms.push(j);
                }
            }
            return bottoms.reverse().concat(tops);
        },
        reverse: function(data) {
            return d3.range(data.length).reverse();
        },
        "default": d3_layout_stackOrderDefault
    });
    var d3_layout_stackOffsets = d3.map({
        silhouette: function(data) {
            var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
            for(j = 0; j < m; ++j){
                for(i = 0, o = 0; i < n; i++)o += data[i][j][1];
                if (o > max) max = o;
                sums.push(o);
            }
            for(j = 0; j < m; ++j)y0[j] = (max - sums[j]) / 2;
            return y0;
        },
        wiggle: function(data) {
            var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
            y0[0] = o = o0 = 0;
            for(j = 1; j < m; ++j){
                for(i = 0, s1 = 0; i < n; ++i)s1 += data[i][j][1];
                for(i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i){
                    for(k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k)s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
                    s2 += s3 * data[i][j][1];
                }
                y0[j] = o -= s1 ? s2 / s1 * dx : 0;
                if (o < o0) o0 = o;
            }
            for(j = 0; j < m; ++j)y0[j] -= o0;
            return y0;
        },
        expand: function(data) {
            var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
            for(j = 0; j < m; ++j){
                for(i = 0, o = 0; i < n; i++)o += data[i][j][1];
                if (o) for(i = 0; i < n; i++)data[i][j][1] /= o;
                else for(i = 0; i < n; i++)data[i][j][1] = k;
            }
            for(j = 0; j < m; ++j)y0[j] = 0;
            return y0;
        },
        zero: d3_layout_stackOffsetZero
    });
    function d3_layout_stackOrderDefault(data) {
        return d3.range(data.length);
    }
    function d3_layout_stackOffsetZero(data) {
        var j = -1, m = data[0].length, y0 = [];
        while(++j < m)y0[j] = 0;
        return y0;
    }
    function d3_layout_stackMaxIndex(array) {
        var i = 1, j = 0, v = array[0][1], k, n = array.length;
        for(; i < n; ++i)if ((k = array[i][1]) > v) {
            j = i;
            v = k;
        }
        return j;
    }
    function d3_layout_stackReduceSum(d) {
        return d.reduce(d3_layout_stackSum, 0);
    }
    function d3_layout_stackSum(p, d) {
        return p + d[1];
    }
    d3.layout.histogram = function() {
        var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
        function histogram(data, i) {
            var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
            while(++i < m){
                bin = bins[i] = [];
                bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
                bin.y = 0;
            }
            if (m > 0) {
                i = -1;
                while(++i < n){
                    x = values[i];
                    if (x >= range[0] && x <= range[1]) {
                        bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
                        bin.y += k;
                        bin.push(data[i]);
                    }
                }
            }
            return bins;
        }
        histogram.value = function(x) {
            if (!arguments.length) return valuer;
            valuer = x;
            return histogram;
        };
        histogram.range = function(x) {
            if (!arguments.length) return ranger;
            ranger = d3_functor(x);
            return histogram;
        };
        histogram.bins = function(x) {
            if (!arguments.length) return binner;
            binner = typeof x === "number" ? function(range) {
                return d3_layout_histogramBinFixed(range, x);
            } : d3_functor(x);
            return histogram;
        };
        histogram.frequency = function(x) {
            if (!arguments.length) return frequency;
            frequency = !!x;
            return histogram;
        };
        return histogram;
    };
    function d3_layout_histogramBinSturges(range, values) {
        return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
    }
    function d3_layout_histogramBinFixed(range, n) {
        var x = -1, b1 = +range[0], m = (range[1] - b1) / n, f = [];
        while(++x <= n)f[x] = m * x + b1;
        return f;
    }
    function d3_layout_histogramRange(values) {
        return [
            d3.min(values),
            d3.max(values)
        ];
    }
    d3.layout.tree = function() {
        var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [
            1,
            1
        ];
        function tree(d, i) {
            var nodes = hierarchy.call(this, d, i), root = nodes[0];
            function firstWalk(node, previousSibling) {
                var children = node.children, layout = node._tree;
                if (children && (n = children.length)) {
                    var n, firstChild = children[0], previousChild, ancestor = firstChild, child, i = -1;
                    while(++i < n){
                        child = children[i];
                        firstWalk(child, previousChild);
                        ancestor = apportion(child, previousChild, ancestor);
                        previousChild = child;
                    }
                    d3_layout_treeShift(node);
                    var midpoint = .5 * (firstChild._tree.prelim + child._tree.prelim);
                    if (previousSibling) {
                        layout.prelim = previousSibling._tree.prelim + separation(node, previousSibling);
                        layout.mod = layout.prelim - midpoint;
                    } else layout.prelim = midpoint;
                } else if (previousSibling) layout.prelim = previousSibling._tree.prelim + separation(node, previousSibling);
            }
            function secondWalk(node, x) {
                node.x = node._tree.prelim + x;
                var children = node.children;
                if (children && (n = children.length)) {
                    var i = -1, n;
                    x += node._tree.mod;
                    while(++i < n)secondWalk(children[i], x);
                }
            }
            function apportion(node, previousSibling, ancestor) {
                if (previousSibling) {
                    var vip = node, vop = node, vim = previousSibling, vom = node.parent.children[0], sip = vip._tree.mod, sop = vop._tree.mod, sim = vim._tree.mod, som = vom._tree.mod, shift;
                    while(vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip){
                        vom = d3_layout_treeLeft(vom);
                        vop = d3_layout_treeRight(vop);
                        vop._tree.ancestor = node;
                        shift = vim._tree.prelim + sim - vip._tree.prelim - sip + separation(vim, vip);
                        if (shift > 0) {
                            d3_layout_treeMove(d3_layout_treeAncestor(vim, node, ancestor), node, shift);
                            sip += shift;
                            sop += shift;
                        }
                        sim += vim._tree.mod;
                        sip += vip._tree.mod;
                        som += vom._tree.mod;
                        sop += vop._tree.mod;
                    }
                    if (vim && !d3_layout_treeRight(vop)) {
                        vop._tree.thread = vim;
                        vop._tree.mod += sim - sop;
                    }
                    if (vip && !d3_layout_treeLeft(vom)) {
                        vom._tree.thread = vip;
                        vom._tree.mod += sip - som;
                        ancestor = node;
                    }
                }
                return ancestor;
            }
            d3_layout_treeVisitAfter(root, function(node, previousSibling) {
                node._tree = {
                    ancestor: node,
                    prelim: 0,
                    mod: 0,
                    change: 0,
                    shift: 0,
                    number: previousSibling ? previousSibling._tree.number + 1 : 0
                };
            });
            firstWalk(root);
            secondWalk(root, -root._tree.prelim);
            var left = d3_layout_treeSearch(root, d3_layout_treeLeftmost), right = d3_layout_treeSearch(root, d3_layout_treeRightmost), deep = d3_layout_treeSearch(root, d3_layout_treeDeepest), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2, y1 = deep.depth || 1;
            d3_layout_treeVisitAfter(root, function(node) {
                node.x = (node.x - x0) / (x1 - x0) * size[0];
                node.y = node.depth / y1 * size[1];
                delete node._tree;
            });
            return nodes;
        }
        tree.separation = function(x) {
            if (!arguments.length) return separation;
            separation = x;
            return tree;
        };
        tree.size = function(x) {
            if (!arguments.length) return size;
            size = x;
            return tree;
        };
        return d3_layout_hierarchyRebind(tree, hierarchy);
    };
    function d3_layout_treeSeparation(a, b1) {
        return a.parent == b1.parent ? 1 : 2;
    }
    function d3_layout_treeLeft(node) {
        var children = node.children;
        return children && children.length ? children[0] : node._tree.thread;
    }
    function d3_layout_treeRight(node) {
        var children = node.children, n;
        return children && (n = children.length) ? children[n - 1] : node._tree.thread;
    }
    function d3_layout_treeSearch(node, compare) {
        var children = node.children;
        if (children && (n = children.length)) {
            var child, n, i = -1;
            while(++i < n)if (compare(child = d3_layout_treeSearch(children[i], compare), node) > 0) node = child;
        }
        return node;
    }
    function d3_layout_treeRightmost(a, b1) {
        return a.x - b1.x;
    }
    function d3_layout_treeLeftmost(a, b1) {
        return b1.x - a.x;
    }
    function d3_layout_treeDeepest(a, b1) {
        return a.depth - b1.depth;
    }
    function d3_layout_treeVisitAfter(node, callback) {
        function visit(node, previousSibling) {
            var children = node.children;
            if (children && (n = children.length)) {
                var child, previousChild = null, i = -1, n;
                while(++i < n){
                    child = children[i];
                    visit(child, previousChild);
                    previousChild = child;
                }
            }
            callback(node, previousSibling);
        }
        visit(node, null);
    }
    function d3_layout_treeShift(node) {
        var shift = 0, change = 0, children = node.children, i = children.length, child;
        while(--i >= 0){
            child = children[i]._tree;
            child.prelim += shift;
            child.mod += shift;
            shift += child.shift + (change += child.change);
        }
    }
    function d3_layout_treeMove(ancestor, node, shift) {
        ancestor = ancestor._tree;
        node = node._tree;
        var change = shift / (node.number - ancestor.number);
        ancestor.change += change;
        node.change -= change;
        node.shift += shift;
        node.prelim += shift;
        node.mod += shift;
    }
    function d3_layout_treeAncestor(vim, node, ancestor) {
        return vim._tree.ancestor.parent == node.parent ? vim._tree.ancestor : ancestor;
    }
    d3.layout.pack = function() {
        var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [
            1,
            1
        ];
        function pack(d, i) {
            var nodes = hierarchy.call(this, d, i), root = nodes[0];
            root.x = 0;
            root.y = 0;
            d3_layout_treeVisitAfter(root, function(d) {
                d.r = Math.sqrt(d.value);
            });
            d3_layout_treeVisitAfter(root, d3_layout_packSiblings);
            var w = size[0], h = size[1], k = Math.max(2 * root.r / w, 2 * root.r / h);
            if (padding > 0) {
                var dr = padding * k / 2;
                d3_layout_treeVisitAfter(root, function(d) {
                    d.r += dr;
                });
                d3_layout_treeVisitAfter(root, d3_layout_packSiblings);
                d3_layout_treeVisitAfter(root, function(d) {
                    d.r -= dr;
                });
                k = Math.max(2 * root.r / w, 2 * root.r / h);
            }
            d3_layout_packTransform(root, w / 2, h / 2, 1 / k);
            return nodes;
        }
        pack.size = function(x) {
            if (!arguments.length) return size;
            size = x;
            return pack;
        };
        pack.padding = function(_) {
            if (!arguments.length) return padding;
            padding = +_;
            return pack;
        };
        return d3_layout_hierarchyRebind(pack, hierarchy);
    };
    function d3_layout_packSort(a, b1) {
        return a.value - b1.value;
    }
    function d3_layout_packInsert(a, b1) {
        var c = a._pack_next;
        a._pack_next = b1;
        b1._pack_prev = a;
        b1._pack_next = c;
        c._pack_prev = b1;
    }
    function d3_layout_packSplice(a, b1) {
        a._pack_next = b1;
        b1._pack_prev = a;
    }
    function d3_layout_packIntersects(a, b1) {
        var dx = b1.x - a.x, dy = b1.y - a.y, dr = a.r + b1.r;
        return dr * dr - dx * dx - dy * dy > .001;
    }
    function d3_layout_packSiblings(node) {
        if (!(nodes = node.children) || !(n = nodes.length)) return;
        var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b1, c, i, j, k, n;
        function bound(node) {
            xMin = Math.min(node.x - node.r, xMin);
            xMax = Math.max(node.x + node.r, xMax);
            yMin = Math.min(node.y - node.r, yMin);
            yMax = Math.max(node.y + node.r, yMax);
        }
        nodes.forEach(d3_layout_packLink);
        a = nodes[0];
        a.x = -a.r;
        a.y = 0;
        bound(a);
        if (n > 1) {
            b1 = nodes[1];
            b1.x = b1.r;
            b1.y = 0;
            bound(b1);
            if (n > 2) {
                c = nodes[2];
                d3_layout_packPlace(a, b1, c);
                bound(c);
                d3_layout_packInsert(a, c);
                a._pack_prev = c;
                d3_layout_packInsert(c, b1);
                b1 = a._pack_next;
                for(i = 3; i < n; i++){
                    d3_layout_packPlace(a, b1, c = nodes[i]);
                    var isect = 0, s1 = 1, s2 = 1;
                    for(j = b1._pack_next; j !== b1; j = j._pack_next, s1++)if (d3_layout_packIntersects(j, c)) {
                        isect = 1;
                        break;
                    }
                    if (isect == 1) for(k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++){
                        if (d3_layout_packIntersects(k, c)) break;
                    }
                    if (isect) {
                        if (s1 < s2 || s1 == s2 && b1.r < a.r) d3_layout_packSplice(a, b1 = j);
                        else d3_layout_packSplice(a = k, b1);
                        i--;
                    } else {
                        d3_layout_packInsert(a, c);
                        b1 = c;
                        bound(c);
                    }
                }
            }
        }
        var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
        for(i = 0; i < n; i++){
            c = nodes[i];
            c.x -= cx;
            c.y -= cy;
            cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
        }
        node.r = cr;
        nodes.forEach(d3_layout_packUnlink);
    }
    function d3_layout_packLink(node) {
        node._pack_next = node._pack_prev = node;
    }
    function d3_layout_packUnlink(node) {
        delete node._pack_next;
        delete node._pack_prev;
    }
    function d3_layout_packTransform(node, x, y, k) {
        var children = node.children;
        node.x = x += k * node.x;
        node.y = y += k * node.y;
        node.r *= k;
        if (children) {
            var i = -1, n = children.length;
            while(++i < n)d3_layout_packTransform(children[i], x, y, k);
        }
    }
    function d3_layout_packPlace(a, b1, c) {
        var db = a.r + c.r, dx = b1.x - a.x, dy = b1.y - a.y;
        if (db && (dx || dy)) {
            var da = b1.r + c.r, dc = dx * dx + dy * dy;
            da *= da;
            db *= db;
            var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
            c.x = a.x + x * dx + y * dy;
            c.y = a.y + x * dy - y * dx;
        } else {
            c.x = a.x + db;
            c.y = a.y;
        }
    }
    d3.layout.cluster = function() {
        var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [
            1,
            1
        ];
        function cluster(d, i) {
            var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
            d3_layout_treeVisitAfter(root, function(node) {
                var children = node.children;
                if (children && children.length) {
                    node.x = d3_layout_clusterX(children);
                    node.y = d3_layout_clusterY(children);
                } else {
                    node.x = previousNode ? x += separation(node, previousNode) : 0;
                    node.y = 0;
                    previousNode = node;
                }
            });
            var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
            d3_layout_treeVisitAfter(root, function(node) {
                node.x = (node.x - x0) / (x1 - x0) * size[0];
                node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
            });
            return nodes;
        }
        cluster.separation = function(x) {
            if (!arguments.length) return separation;
            separation = x;
            return cluster;
        };
        cluster.size = function(x) {
            if (!arguments.length) return size;
            size = x;
            return cluster;
        };
        return d3_layout_hierarchyRebind(cluster, hierarchy);
    };
    function d3_layout_clusterY(children) {
        return 1 + d3.max(children, function(child) {
            return child.y;
        });
    }
    function d3_layout_clusterX(children) {
        return children.reduce(function(x, child) {
            return x + child.x;
        }, 0) / children.length;
    }
    function d3_layout_clusterLeft(node) {
        var children = node.children;
        return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
    }
    function d3_layout_clusterRight(node) {
        var children = node.children, n;
        return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
    }
    d3.layout.treemap = function() {
        var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [
            1,
            1
        ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
        function scale(children, k) {
            var i = -1, n = children.length, child, area;
            while(++i < n){
                area = (child = children[i]).value * (k < 0 ? 0 : k);
                child.area = isNaN(area) || area <= 0 ? 0 : area;
            }
        }
        function squarify(node) {
            var children = node.children;
            if (children && children.length) {
                var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
                scale(remaining, rect.dx * rect.dy / node.value);
                row.area = 0;
                while((n = remaining.length) > 0){
                    row.push(child = remaining[n - 1]);
                    row.area += child.area;
                    if (mode !== "squarify" || (score = worst(row, u)) <= best) {
                        remaining.pop();
                        best = score;
                    } else {
                        row.area -= row.pop().area;
                        position(row, u, rect, false);
                        u = Math.min(rect.dx, rect.dy);
                        row.length = row.area = 0;
                        best = Infinity;
                    }
                }
                if (row.length) {
                    position(row, u, rect, true);
                    row.length = row.area = 0;
                }
                children.forEach(squarify);
            }
        }
        function stickify(node) {
            var children = node.children;
            if (children && children.length) {
                var rect = pad(node), remaining = children.slice(), child, row = [];
                scale(remaining, rect.dx * rect.dy / node.value);
                row.area = 0;
                while(child = remaining.pop()){
                    row.push(child);
                    row.area += child.area;
                    if (child.z != null) {
                        position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
                        row.length = row.area = 0;
                    }
                }
                children.forEach(stickify);
            }
        }
        function worst(row, u) {
            var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
            while(++i < n){
                if (!(r = row[i].area)) continue;
                if (r < rmin) rmin = r;
                if (r > rmax) rmax = r;
            }
            s *= s;
            u *= u;
            return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
        }
        function position(row, u, rect, flush) {
            var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
            if (u == rect.dx) {
                if (flush || v > rect.dy) v = rect.dy;
                while(++i < n){
                    o = row[i];
                    o.x = x;
                    o.y = y;
                    o.dy = v;
                    x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
                }
                o.z = true;
                o.dx += rect.x + rect.dx - x;
                rect.y += v;
                rect.dy -= v;
            } else {
                if (flush || v > rect.dx) v = rect.dx;
                while(++i < n){
                    o = row[i];
                    o.x = x;
                    o.y = y;
                    o.dx = v;
                    y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
                }
                o.z = false;
                o.dy += rect.y + rect.dy - y;
                rect.x += v;
                rect.dx -= v;
            }
        }
        function treemap(d) {
            var nodes = stickies || hierarchy(d), root = nodes[0];
            root.x = 0;
            root.y = 0;
            root.dx = size[0];
            root.dy = size[1];
            if (stickies) hierarchy.revalue(root);
            scale([
                root
            ], root.dx * root.dy / root.value);
            (stickies ? stickify : squarify)(root);
            if (sticky) stickies = nodes;
            return nodes;
        }
        treemap.size = function(x) {
            if (!arguments.length) return size;
            size = x;
            return treemap;
        };
        treemap.padding = function(x) {
            if (!arguments.length) return padding;
            function padFunction(node) {
                var p = x.call(treemap, node, node.depth);
                return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [
                    p,
                    p,
                    p,
                    p
                ] : p);
            }
            function padConstant(node) {
                return d3_layout_treemapPad(node, x);
            }
            var type;
            pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [
                x,
                x,
                x,
                x
            ], padConstant) : padConstant;
            return treemap;
        };
        treemap.round = function(x) {
            if (!arguments.length) return round != Number;
            round = x ? Math.round : Number;
            return treemap;
        };
        treemap.sticky = function(x) {
            if (!arguments.length) return sticky;
            sticky = x;
            stickies = null;
            return treemap;
        };
        treemap.ratio = function(x) {
            if (!arguments.length) return ratio;
            ratio = x;
            return treemap;
        };
        treemap.mode = function(x) {
            if (!arguments.length) return mode;
            mode = x + "";
            return treemap;
        };
        return d3_layout_hierarchyRebind(treemap, hierarchy);
    };
    function d3_layout_treemapPadNull(node) {
        return {
            x: node.x,
            y: node.y,
            dx: node.dx,
            dy: node.dy
        };
    }
    function d3_layout_treemapPad(node, padding) {
        var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
        if (dx < 0) {
            x += dx / 2;
            dx = 0;
        }
        if (dy < 0) {
            y += dy / 2;
            dy = 0;
        }
        return {
            x: x,
            y: y,
            dx: dx,
            dy: dy
        };
    }
    d3.random = {
        normal: function(mu, \u03C3) {
            var n = arguments.length;
            if (n < 2) \u03C3 = 1;
            if (n < 1) mu = 0;
            return function() {
                var x, y, r;
                do {
                    x = Math.random() * 2 - 1;
                    y = Math.random() * 2 - 1;
                    r = x * x + y * y;
                }while (!r || r > 1);
                return mu + \u03C3 * x * Math.sqrt(-2 * Math.log(r) / r);
            };
        },
        logNormal: function() {
            var random = d3.random.normal.apply(d3, arguments);
            return function() {
                return Math.exp(random());
            };
        },
        irwinHall: function(m) {
            return function() {
                for(var s = 0, j = 0; j < m; j++)s += Math.random();
                return s / m;
            };
        }
    };
    d3.scale = {};
    function d3_scaleExtent(domain) {
        var start = domain[0], stop = domain[domain.length - 1];
        return start < stop ? [
            start,
            stop
        ] : [
            stop,
            start
        ];
    }
    function d3_scaleRange(scale) {
        return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
    }
    function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
        var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
        return function(x) {
            return i(u(x));
        };
    }
    function d3_scale_nice(domain, nice) {
        var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
        if (x1 < x0) {
            dx = i0, i0 = i1, i1 = dx;
            dx = x0, x0 = x1, x1 = dx;
        }
        if (nice = nice(x1 - x0)) {
            domain[i0] = nice.floor(x0);
            domain[i1] = nice.ceil(x1);
        }
        return domain;
    }
    function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
        var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
        if (domain[k] < domain[0]) {
            domain = domain.slice().reverse();
            range = range.slice().reverse();
        }
        while(++j <= k){
            u.push(uninterpolate(domain[j - 1], domain[j]));
            i.push(interpolate(range[j - 1], range[j]));
        }
        return function(x) {
            var j = d3.bisect(domain, x, 1, k) - 1;
            return i[j](u[j](x));
        };
    }
    d3.scale.linear = function() {
        return d3_scale_linear([
            0,
            1
        ], [
            0,
            1
        ], d3_interpolate, false);
    };
    function d3_scale_linear(domain, range, interpolate, clamp) {
        var output, input;
        function rescale() {
            var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
            output = linear(domain, range, uninterpolate, interpolate);
            input = linear(range, domain, uninterpolate, d3_interpolate);
            return scale;
        }
        function scale(x) {
            return output(x);
        }
        scale.invert = function(y) {
            return input(y);
        };
        scale.domain = function(x) {
            if (!arguments.length) return domain;
            domain = x.map(Number);
            return rescale();
        };
        scale.range = function(x) {
            if (!arguments.length) return range;
            range = x;
            return rescale();
        };
        scale.rangeRound = function(x) {
            return scale.range(x).interpolate(d3_interpolateRound);
        };
        scale.clamp = function(x) {
            if (!arguments.length) return clamp;
            clamp = x;
            return rescale();
        };
        scale.interpolate = function(x) {
            if (!arguments.length) return interpolate;
            interpolate = x;
            return rescale();
        };
        scale.ticks = function(m) {
            return d3_scale_linearTicks(domain, m);
        };
        scale.tickFormat = function(m, format) {
            return d3_scale_linearTickFormat(domain, m, format);
        };
        scale.nice = function() {
            d3_scale_nice(domain, d3_scale_linearNice);
            return rescale();
        };
        scale.copy = function() {
            return d3_scale_linear(domain, range, interpolate, clamp);
        };
        return rescale();
    }
    function d3_scale_linearRebind(scale, linear) {
        return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
    }
    function d3_scale_linearNice(dx) {
        dx = Math.pow(10, Math.round(Math.log(dx) / Math.LN10) - 1);
        return dx && {
            floor: function(x) {
                return Math.floor(x / dx) * dx;
            },
            ceil: function(x) {
                return Math.ceil(x / dx) * dx;
            }
        };
    }
    function d3_scale_linearTickRange(domain, m) {
        var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
        if (err <= .15) step *= 10;
        else if (err <= .35) step *= 5;
        else if (err <= .75) step *= 2;
        extent[0] = Math.ceil(extent[0] / step) * step;
        extent[1] = Math.floor(extent[1] / step) * step + step * .5;
        extent[2] = step;
        return extent;
    }
    function d3_scale_linearTicks(domain, m) {
        return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
    }
    function d3_scale_linearTickFormat(domain, m, format) {
        var precision = -Math.floor(Math.log(d3_scale_linearTickRange(domain, m)[2]) / Math.LN10 + .01);
        return d3.format(format ? format.replace(d3_format_re, function(a, b1, c, d, e, f, g, h, i, j) {
            return [
                b1,
                c,
                d,
                e,
                f,
                g,
                h,
                i || "." + (precision - (j === "%") * 2),
                j
            ].join("");
        }) : ",." + precision + "f");
    }
    d3.scale.log = function() {
        return d3_scale_log(d3.scale.linear().domain([
            0,
            Math.LN10
        ]), 10, d3_scale_logp, d3_scale_powp);
    };
    function d3_scale_log(linear, base, log, pow) {
        function scale(x) {
            return linear(log(x));
        }
        scale.invert = function(x) {
            return pow(linear.invert(x));
        };
        scale.domain = function(x) {
            if (!arguments.length) return linear.domain().map(pow);
            if (x[0] < 0) log = d3_scale_logn, pow = d3_scale_pown;
            else log = d3_scale_logp, pow = d3_scale_powp;
            linear.domain(x.map(log));
            return scale;
        };
        scale.base = function(_) {
            if (!arguments.length) return base;
            base = +_;
            return scale;
        };
        scale.nice = function() {
            linear.domain(d3_scale_nice(linear.domain(), d3_scale_logNice(base)));
            return scale;
        };
        scale.ticks = function() {
            var extent = d3_scaleExtent(linear.domain()), ticks = [];
            if (extent.every(isFinite)) {
                var b1 = Math.log(base), i = Math.floor(extent[0] / b1), j = Math.ceil(extent[1] / b1), u = pow(extent[0]), v = pow(extent[1]), n = base % 1 ? 2 : base;
                if (log === d3_scale_logn) {
                    ticks.push(-Math.pow(base, -i));
                    for(; i++ < j;)for(var k = n - 1; k > 0; k--)ticks.push(-Math.pow(base, -i) * k);
                } else {
                    for(; i < j; i++)for(var k = 1; k < n; k++)ticks.push(Math.pow(base, i) * k);
                    ticks.push(Math.pow(base, i));
                }
                for(i = 0; ticks[i] < u; i++);
                for(j = ticks.length; ticks[j - 1] > v; j--);
                ticks = ticks.slice(i, j);
            }
            return ticks;
        };
        scale.tickFormat = function(n, format) {
            if (arguments.length < 2) format = d3_scale_logFormat;
            if (!arguments.length) return format;
            var b1 = Math.log(base), k = Math.max(.1, n / scale.ticks().length), f = log === d3_scale_logn ? (e = -0.000000000001, Math.floor) : (e = 1e-12, Math.ceil), e;
            return function(d) {
                return d / pow(b1 * f(log(d) / b1 + e)) <= k ? format(d) : "";
            };
        };
        scale.copy = function() {
            return d3_scale_log(linear.copy(), base, log, pow);
        };
        return d3_scale_linearRebind(scale, linear);
    }
    var d3_scale_logFormat = d3.format(".0e");
    function d3_scale_logp(x) {
        return Math.log(x < 0 ? 0 : x);
    }
    function d3_scale_powp(x) {
        return Math.exp(x);
    }
    function d3_scale_logn(x) {
        return -Math.log(x > 0 ? 0 : -x);
    }
    function d3_scale_pown(x) {
        return -Math.exp(-x);
    }
    function d3_scale_logNice(base) {
        base = Math.log(base);
        var nice = {
            floor: function(x) {
                return Math.floor(x / base) * base;
            },
            ceil: function(x) {
                return Math.ceil(x / base) * base;
            }
        };
        return function() {
            return nice;
        };
    }
    d3.scale.pow = function() {
        return d3_scale_pow(d3.scale.linear(), 1);
    };
    function d3_scale_pow(linear, exponent) {
        var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
        function scale(x) {
            return linear(powp(x));
        }
        scale.invert = function(x) {
            return powb(linear.invert(x));
        };
        scale.domain = function(x) {
            if (!arguments.length) return linear.domain().map(powb);
            linear.domain(x.map(powp));
            return scale;
        };
        scale.ticks = function(m) {
            return d3_scale_linearTicks(scale.domain(), m);
        };
        scale.tickFormat = function(m, format) {
            return d3_scale_linearTickFormat(scale.domain(), m, format);
        };
        scale.nice = function() {
            return scale.domain(d3_scale_nice(scale.domain(), d3_scale_linearNice));
        };
        scale.exponent = function(x) {
            if (!arguments.length) return exponent;
            var domain = scale.domain();
            powp = d3_scale_powPow(exponent = x);
            powb = d3_scale_powPow(1 / exponent);
            return scale.domain(domain);
        };
        scale.copy = function() {
            return d3_scale_pow(linear.copy(), exponent);
        };
        return d3_scale_linearRebind(scale, linear);
    }
    function d3_scale_powPow(e) {
        return function(x) {
            return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
        };
    }
    d3.scale.sqrt = function() {
        return d3.scale.pow().exponent(.5);
    };
    d3.scale.ordinal = function() {
        return d3_scale_ordinal([], {
            t: "range",
            a: [
                []
            ]
        });
    };
    function d3_scale_ordinal(domain, ranger) {
        var index, range, rangeBand;
        function scale(x) {
            return range[((index.get(x) || index.set(x, domain.push(x))) - 1) % range.length];
        }
        function steps(start, step) {
            return d3.range(domain.length).map(function(i) {
                return start + step * i;
            });
        }
        scale.domain = function(x) {
            if (!arguments.length) return domain;
            domain = [];
            index = new d3_Map();
            var i = -1, n = x.length, xi;
            while(++i < n)if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
            return scale[ranger.t].apply(scale, ranger.a);
        };
        scale.range = function(x) {
            if (!arguments.length) return range;
            range = x;
            rangeBand = 0;
            ranger = {
                t: "range",
                a: arguments
            };
            return scale;
        };
        scale.rangePoints = function(x, padding) {
            if (arguments.length < 2) padding = 0;
            var start = x[0], stop = x[1], step = (stop - start) / (Math.max(1, domain.length - 1) + padding);
            range = steps(domain.length < 2 ? (start + stop) / 2 : start + step * padding / 2, step);
            rangeBand = 0;
            ranger = {
                t: "rangePoints",
                a: arguments
            };
            return scale;
        };
        scale.rangeBands = function(x, padding, outerPadding) {
            if (arguments.length < 2) padding = 0;
            if (arguments.length < 3) outerPadding = padding;
            var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
            range = steps(start + step * outerPadding, step);
            if (reverse) range.reverse();
            rangeBand = step * (1 - padding);
            ranger = {
                t: "rangeBands",
                a: arguments
            };
            return scale;
        };
        scale.rangeRoundBands = function(x, padding, outerPadding) {
            if (arguments.length < 2) padding = 0;
            if (arguments.length < 3) outerPadding = padding;
            var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding)), error = stop - start - (domain.length - padding) * step;
            range = steps(start + Math.round(error / 2), step);
            if (reverse) range.reverse();
            rangeBand = Math.round(step * (1 - padding));
            ranger = {
                t: "rangeRoundBands",
                a: arguments
            };
            return scale;
        };
        scale.rangeBand = function() {
            return rangeBand;
        };
        scale.rangeExtent = function() {
            return d3_scaleExtent(ranger.a[0]);
        };
        scale.copy = function() {
            return d3_scale_ordinal(domain, ranger);
        };
        return scale.domain(domain);
    }
    d3.scale.category10 = function() {
        return d3.scale.ordinal().range(d3_category10);
    };
    d3.scale.category20 = function() {
        return d3.scale.ordinal().range(d3_category20);
    };
    d3.scale.category20b = function() {
        return d3.scale.ordinal().range(d3_category20b);
    };
    d3.scale.category20c = function() {
        return d3.scale.ordinal().range(d3_category20c);
    };
    var d3_category10 = [
        "#1f77b4",
        "#ff7f0e",
        "#2ca02c",
        "#d62728",
        "#9467bd",
        "#8c564b",
        "#e377c2",
        "#7f7f7f",
        "#bcbd22",
        "#17becf"
    ];
    var d3_category20 = [
        "#1f77b4",
        "#aec7e8",
        "#ff7f0e",
        "#ffbb78",
        "#2ca02c",
        "#98df8a",
        "#d62728",
        "#ff9896",
        "#9467bd",
        "#c5b0d5",
        "#8c564b",
        "#c49c94",
        "#e377c2",
        "#f7b6d2",
        "#7f7f7f",
        "#c7c7c7",
        "#bcbd22",
        "#dbdb8d",
        "#17becf",
        "#9edae5"
    ];
    var d3_category20b = [
        "#393b79",
        "#5254a3",
        "#6b6ecf",
        "#9c9ede",
        "#637939",
        "#8ca252",
        "#b5cf6b",
        "#cedb9c",
        "#8c6d31",
        "#bd9e39",
        "#e7ba52",
        "#e7cb94",
        "#843c39",
        "#ad494a",
        "#d6616b",
        "#e7969c",
        "#7b4173",
        "#a55194",
        "#ce6dbd",
        "#de9ed6"
    ];
    var d3_category20c = [
        "#3182bd",
        "#6baed6",
        "#9ecae1",
        "#c6dbef",
        "#e6550d",
        "#fd8d3c",
        "#fdae6b",
        "#fdd0a2",
        "#31a354",
        "#74c476",
        "#a1d99b",
        "#c7e9c0",
        "#756bb1",
        "#9e9ac8",
        "#bcbddc",
        "#dadaeb",
        "#636363",
        "#969696",
        "#bdbdbd",
        "#d9d9d9"
    ];
    d3.scale.quantile = function() {
        return d3_scale_quantile([], []);
    };
    function d3_scale_quantile(domain, range) {
        var thresholds;
        function rescale() {
            var k = 0, q = range.length;
            thresholds = [];
            while(++k < q)thresholds[k - 1] = d3.quantile(domain, k / q);
            return scale;
        }
        function scale(x) {
            if (isNaN(x = +x)) return NaN;
            return range[d3.bisect(thresholds, x)];
        }
        scale.domain = function(x) {
            if (!arguments.length) return domain;
            domain = x.filter(function(d) {
                return !isNaN(d);
            }).sort(d3.ascending);
            return rescale();
        };
        scale.range = function(x) {
            if (!arguments.length) return range;
            range = x;
            return rescale();
        };
        scale.quantiles = function() {
            return thresholds;
        };
        scale.copy = function() {
            return d3_scale_quantile(domain, range);
        };
        return rescale();
    }
    d3.scale.quantize = function() {
        return d3_scale_quantize(0, 1, [
            0,
            1
        ]);
    };
    function d3_scale_quantize(x0, x1, range) {
        var kx, i;
        function scale(x) {
            return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
        }
        function rescale() {
            kx = range.length / (x1 - x0);
            i = range.length - 1;
            return scale;
        }
        scale.domain = function(x) {
            if (!arguments.length) return [
                x0,
                x1
            ];
            x0 = +x[0];
            x1 = +x[x.length - 1];
            return rescale();
        };
        scale.range = function(x) {
            if (!arguments.length) return range;
            range = x;
            return rescale();
        };
        scale.copy = function() {
            return d3_scale_quantize(x0, x1, range);
        };
        return rescale();
    }
    d3.scale.threshold = function() {
        return d3_scale_threshold([
            .5
        ], [
            0,
            1
        ]);
    };
    function d3_scale_threshold(domain, range) {
        function scale(x) {
            return range[d3.bisect(domain, x)];
        }
        scale.domain = function(_) {
            if (!arguments.length) return domain;
            domain = _;
            return scale;
        };
        scale.range = function(_) {
            if (!arguments.length) return range;
            range = _;
            return scale;
        };
        scale.copy = function() {
            return d3_scale_threshold(domain, range);
        };
        return scale;
    }
    d3.scale.identity = function() {
        return d3_scale_identity([
            0,
            1
        ]);
    };
    function d3_scale_identity(domain) {
        function identity(x) {
            return +x;
        }
        identity.invert = identity;
        identity.domain = identity.range = function(x) {
            if (!arguments.length) return domain;
            domain = x.map(identity);
            return identity;
        };
        identity.ticks = function(m) {
            return d3_scale_linearTicks(domain, m);
        };
        identity.tickFormat = function(m, format) {
            return d3_scale_linearTickFormat(domain, m, format);
        };
        identity.copy = function() {
            return d3_scale_identity(domain);
        };
        return identity;
    }
    d3.svg.arc = function() {
        var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
        function arc() {
            var r0 = innerRadius.apply(this, arguments), r1 = outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) + d3_svg_arcOffset, a1 = endAngle.apply(this, arguments) + d3_svg_arcOffset, da = (a1 < a0 && (da = a0, a0 = a1, a1 = da), a1 - a0), df = da < \u03C0 ? "0" : "1", c0 = Math.cos(a0), s0 = Math.sin(a0), c1 = Math.cos(a1), s1 = Math.sin(a1);
            return da >= d3_svg_arcMax ? r0 ? "M0," + r1 + "A" + r1 + "," + r1 + " 0 1,1 0," + -r1 + "A" + r1 + "," + r1 + " 0 1,1 0," + r1 + "M0," + r0 + "A" + r0 + "," + r0 + " 0 1,0 0," + -r0 + "A" + r0 + "," + r0 + " 0 1,0 0," + r0 + "Z" : "M0," + r1 + "A" + r1 + "," + r1 + " 0 1,1 0," + -r1 + "A" + r1 + "," + r1 + " 0 1,1 0," + r1 + "Z" : r0 ? "M" + r1 * c0 + "," + r1 * s0 + "A" + r1 + "," + r1 + " 0 " + df + ",1 " + r1 * c1 + "," + r1 * s1 + "L" + r0 * c1 + "," + r0 * s1 + "A" + r0 + "," + r0 + " 0 " + df + ",0 " + r0 * c0 + "," + r0 * s0 + "Z" : "M" + r1 * c0 + "," + r1 * s0 + "A" + r1 + "," + r1 + " 0 " + df + ",1 " + r1 * c1 + "," + r1 * s1 + "L0,0" + "Z";
        }
        arc.innerRadius = function(v) {
            if (!arguments.length) return innerRadius;
            innerRadius = d3_functor(v);
            return arc;
        };
        arc.outerRadius = function(v) {
            if (!arguments.length) return outerRadius;
            outerRadius = d3_functor(v);
            return arc;
        };
        arc.startAngle = function(v) {
            if (!arguments.length) return startAngle;
            startAngle = d3_functor(v);
            return arc;
        };
        arc.endAngle = function(v) {
            if (!arguments.length) return endAngle;
            endAngle = d3_functor(v);
            return arc;
        };
        arc.centroid = function() {
            var r = (innerRadius.apply(this, arguments) + outerRadius.apply(this, arguments)) / 2, a = (startAngle.apply(this, arguments) + endAngle.apply(this, arguments)) / 2 + d3_svg_arcOffset;
            return [
                Math.cos(a) * r,
                Math.sin(a) * r
            ];
        };
        return arc;
    };
    var d3_svg_arcOffset = -\u03C0 / 2, d3_svg_arcMax = 2 * \u03C0 - 1e-6;
    function d3_svg_arcInnerRadius(d) {
        return d.innerRadius;
    }
    function d3_svg_arcOuterRadius(d) {
        return d.outerRadius;
    }
    function d3_svg_arcStartAngle(d) {
        return d.startAngle;
    }
    function d3_svg_arcEndAngle(d) {
        return d.endAngle;
    }
    d3.svg.line.radial = function() {
        var line = d3_svg_line(d3_svg_lineRadial);
        line.radius = line.x, delete line.x;
        line.angle = line.y, delete line.y;
        return line;
    };
    function d3_svg_lineRadial(points) {
        var point, i = -1, n = points.length, r, a;
        while(++i < n){
            point = points[i];
            r = point[0];
            a = point[1] + d3_svg_arcOffset;
            point[0] = r * Math.cos(a);
            point[1] = r * Math.sin(a);
        }
        return points;
    }
    function d3_svg_area(projection) {
        var x0 = d3_svg_lineX, x1 = d3_svg_lineX, y0 = 0, y1 = d3_svg_lineY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
        function area(data) {
            var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
                return x;
            } : d3_functor(x1), fy1 = y0 === y1 ? function() {
                return y;
            } : d3_functor(y1), x, y;
            function segment() {
                segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
            }
            while(++i < n){
                if (defined.call(this, d = data[i], i)) {
                    points0.push([
                        x = +fx0.call(this, d, i),
                        y = +fy0.call(this, d, i)
                    ]);
                    points1.push([
                        +fx1.call(this, d, i),
                        +fy1.call(this, d, i)
                    ]);
                } else if (points0.length) {
                    segment();
                    points0 = [];
                    points1 = [];
                }
            }
            if (points0.length) segment();
            return segments.length ? segments.join("") : null;
        }
        area.x = function(_) {
            if (!arguments.length) return x1;
            x0 = x1 = _;
            return area;
        };
        area.x0 = function(_) {
            if (!arguments.length) return x0;
            x0 = _;
            return area;
        };
        area.x1 = function(_) {
            if (!arguments.length) return x1;
            x1 = _;
            return area;
        };
        area.y = function(_) {
            if (!arguments.length) return y1;
            y0 = y1 = _;
            return area;
        };
        area.y0 = function(_) {
            if (!arguments.length) return y0;
            y0 = _;
            return area;
        };
        area.y1 = function(_) {
            if (!arguments.length) return y1;
            y1 = _;
            return area;
        };
        area.defined = function(_) {
            if (!arguments.length) return defined;
            defined = _;
            return area;
        };
        area.interpolate = function(_) {
            if (!arguments.length) return interpolateKey;
            if (typeof _ === "function") interpolateKey = interpolate = _;
            else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
            interpolateReverse = interpolate.reverse || interpolate;
            L = interpolate.closed ? "M" : "L";
            return area;
        };
        area.tension = function(_) {
            if (!arguments.length) return tension;
            tension = _;
            return area;
        };
        return area;
    }
    d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
    d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
    d3.svg.area = function() {
        return d3_svg_area(d3_identity);
    };
    d3.svg.area.radial = function() {
        var area = d3_svg_area(d3_svg_lineRadial);
        area.radius = area.x, delete area.x;
        area.innerRadius = area.x0, delete area.x0;
        area.outerRadius = area.x1, delete area.x1;
        area.angle = area.y, delete area.y;
        area.startAngle = area.y0, delete area.y0;
        area.endAngle = area.y1, delete area.y1;
        return area;
    };
    d3.svg.chord = function() {
        var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
        function chord(d, i) {
            var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
            return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
        }
        function subgroup(self, f, d, i) {
            var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) + d3_svg_arcOffset, a1 = endAngle.call(self, subgroup, i) + d3_svg_arcOffset;
            return {
                r: r,
                a0: a0,
                a1: a1,
                p0: [
                    r * Math.cos(a0),
                    r * Math.sin(a0)
                ],
                p1: [
                    r * Math.cos(a1),
                    r * Math.sin(a1)
                ]
            };
        }
        function equals(a, b1) {
            return a.a0 == b1.a0 && a.a1 == b1.a1;
        }
        function arc(r, p, a) {
            return "A" + r + "," + r + " 0 " + +(a > \u03C0) + ",1 " + p;
        }
        function curve(r0, p0, r1, p1) {
            return "Q 0,0 " + p1;
        }
        chord.radius = function(v) {
            if (!arguments.length) return radius;
            radius = d3_functor(v);
            return chord;
        };
        chord.source = function(v) {
            if (!arguments.length) return source;
            source = d3_functor(v);
            return chord;
        };
        chord.target = function(v) {
            if (!arguments.length) return target;
            target = d3_functor(v);
            return chord;
        };
        chord.startAngle = function(v) {
            if (!arguments.length) return startAngle;
            startAngle = d3_functor(v);
            return chord;
        };
        chord.endAngle = function(v) {
            if (!arguments.length) return endAngle;
            endAngle = d3_functor(v);
            return chord;
        };
        return chord;
    };
    function d3_svg_chordRadius(d) {
        return d.radius;
    }
    d3.svg.diagonal = function() {
        var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
        function diagonal(d, i) {
            var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [
                p0,
                {
                    x: p0.x,
                    y: m
                },
                {
                    x: p3.x,
                    y: m
                },
                p3
            ];
            p = p.map(projection);
            return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
        }
        diagonal.source = function(x) {
            if (!arguments.length) return source;
            source = d3_functor(x);
            return diagonal;
        };
        diagonal.target = function(x) {
            if (!arguments.length) return target;
            target = d3_functor(x);
            return diagonal;
        };
        diagonal.projection = function(x) {
            if (!arguments.length) return projection;
            projection = x;
            return diagonal;
        };
        return diagonal;
    };
    function d3_svg_diagonalProjection(d) {
        return [
            d.x,
            d.y
        ];
    }
    d3.svg.diagonal.radial = function() {
        var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
        diagonal.projection = function(x) {
            return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
        };
        return diagonal;
    };
    function d3_svg_diagonalRadialProjection(projection) {
        return function() {
            var d = projection.apply(this, arguments), r = d[0], a = d[1] + d3_svg_arcOffset;
            return [
                r * Math.cos(a),
                r * Math.sin(a)
            ];
        };
    }
    d3.svg.symbol = function() {
        var type = d3_svg_symbolType, size = d3_svg_symbolSize;
        function symbol(d, i) {
            return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
        }
        symbol.type = function(x) {
            if (!arguments.length) return type;
            type = d3_functor(x);
            return symbol;
        };
        symbol.size = function(x) {
            if (!arguments.length) return size;
            size = d3_functor(x);
            return symbol;
        };
        return symbol;
    };
    function d3_svg_symbolSize() {
        return 64;
    }
    function d3_svg_symbolType() {
        return "circle";
    }
    function d3_svg_symbolCircle(size) {
        var r = Math.sqrt(size / \u03C0);
        return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
    }
    var d3_svg_symbols = d3.map({
        circle: d3_svg_symbolCircle,
        cross: function(size) {
            var r = Math.sqrt(size / 5) / 2;
            return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
        },
        diamond: function(size) {
            var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
            return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
        },
        square: function(size) {
            var r = Math.sqrt(size) / 2;
            return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
        },
        "triangle-down": function(size) {
            var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
            return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
        },
        "triangle-up": function(size) {
            var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
            return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
        }
    });
    d3.svg.symbolTypes = d3_svg_symbols.keys();
    var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
    function d3_transition(groups, id) {
        d3_arraySubclass(groups, d3_transitionPrototype);
        groups.id = id;
        return groups;
    }
    var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit = {
        ease: d3_ease_cubicInOut,
        delay: 0,
        duration: 250
    };
    d3_transitionPrototype.call = d3_selectionPrototype.call;
    d3_transitionPrototype.empty = d3_selectionPrototype.empty;
    d3_transitionPrototype.node = d3_selectionPrototype.node;
    d3.transition = function(selection) {
        return arguments.length ? d3_transitionInheritId ? selection.transition() : selection : d3_selectionRoot.transition();
    };
    d3.transition.prototype = d3_transitionPrototype;
    d3_transitionPrototype.select = function(selector) {
        var id = this.id, subgroups = [], subgroup, subnode, node;
        if (typeof selector !== "function") selector = d3_selection_selector(selector);
        for(var j = -1, m = this.length; ++j < m;){
            subgroups.push(subgroup = []);
            for(var group = this[j], i = -1, n = group.length; ++i < n;)if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i))) {
                if ("__data__" in node) subnode.__data__ = node.__data__;
                d3_transitionNode(subnode, i, id, node.__transition__[id]);
                subgroup.push(subnode);
            } else subgroup.push(null);
        }
        return d3_transition(subgroups, id);
    };
    d3_transitionPrototype.selectAll = function(selector) {
        var id = this.id, subgroups = [], subgroup, subnodes, node, subnode, transition;
        if (typeof selector !== "function") selector = d3_selection_selectorAll(selector);
        for(var j = -1, m = this.length; ++j < m;){
            for(var group = this[j], i = -1, n = group.length; ++i < n;)if (node = group[i]) {
                transition = node.__transition__[id];
                subnodes = selector.call(node, node.__data__, i);
                subgroups.push(subgroup = []);
                for(var k = -1, o = subnodes.length; ++k < o;){
                    d3_transitionNode(subnode = subnodes[k], k, id, transition);
                    subgroup.push(subnode);
                }
            }
        }
        return d3_transition(subgroups, id);
    };
    d3_transitionPrototype.filter = function(filter) {
        var subgroups = [], subgroup, group, node;
        if (typeof filter !== "function") filter = d3_selection_filter(filter);
        for(var j = 0, m = this.length; j < m; j++){
            subgroups.push(subgroup = []);
            for(var group = this[j], i = 0, n = group.length; i < n; i++)if ((node = group[i]) && filter.call(node, node.__data__, i)) subgroup.push(node);
        }
        return d3_transition(subgroups, this.id, this.time).ease(this.ease());
    };
    d3_transitionPrototype.tween = function(name, tween) {
        var id = this.id;
        if (arguments.length < 2) return this.node().__transition__[id].tween.get(name);
        return d3_selection_each(this, tween == null ? function(node) {
            node.__transition__[id].tween.remove(name);
        } : function(node) {
            node.__transition__[id].tween.set(name, tween);
        });
    };
    function d3_transition_tween(groups, name, value, tween) {
        var id = groups.id;
        return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
            node.__transition__[id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
        } : (value = tween(value), function(node) {
            node.__transition__[id].tween.set(name, value);
        }));
    }
    d3_transitionPrototype.attr = function(nameNS, value) {
        if (arguments.length < 2) {
            for(value in nameNS)this.attr(value, nameNS[value]);
            return this;
        }
        var interpolate = d3_interpolateByName(nameNS), name = d3.ns.qualify(nameNS);
        function attrNull() {
            this.removeAttribute(name);
        }
        function attrNullNS() {
            this.removeAttributeNS(name.space, name.local);
        }
        return d3_transition_tween(this, "attr." + nameNS, value, function(b1) {
            function attrString() {
                var a = this.getAttribute(name), i;
                return a !== b1 && (i = interpolate(a, b1), function(t) {
                    this.setAttribute(name, i(t));
                });
            }
            function attrStringNS() {
                var a = this.getAttributeNS(name.space, name.local), i;
                return a !== b1 && (i = interpolate(a, b1), function(t) {
                    this.setAttributeNS(name.space, name.local, i(t));
                });
            }
            return b1 == null ? name.local ? attrNullNS : attrNull : (b1 += "", name.local ? attrStringNS : attrString);
        });
    };
    d3_transitionPrototype.attrTween = function(nameNS, tween) {
        var name = d3.ns.qualify(nameNS);
        function attrTween(d, i) {
            var f = tween.call(this, d, i, this.getAttribute(name));
            return f && function(t) {
                this.setAttribute(name, f(t));
            };
        }
        function attrTweenNS(d, i) {
            var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
            return f && function(t) {
                this.setAttributeNS(name.space, name.local, f(t));
            };
        }
        return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
    };
    d3_transitionPrototype.style = function(name, value, priority) {
        var n = arguments.length;
        if (n < 3) {
            if (typeof name !== "string") {
                if (n < 2) value = "";
                for(priority in name)this.style(priority, name[priority], value);
                return this;
            }
            priority = "";
        }
        var interpolate = d3_interpolateByName(name);
        function styleNull() {
            this.style.removeProperty(name);
        }
        return d3_transition_tween(this, "style." + name, value, function(b1) {
            function styleString() {
                var a = d3_window.getComputedStyle(this, null).getPropertyValue(name), i;
                return a !== b1 && (i = interpolate(a, b1), function(t) {
                    this.style.setProperty(name, i(t), priority);
                });
            }
            return b1 == null ? styleNull : (b1 += "", styleString);
        });
    };
    d3_transitionPrototype.styleTween = function(name, tween, priority) {
        if (arguments.length < 3) priority = "";
        return this.tween("style." + name, function(d, i) {
            var f = tween.call(this, d, i, d3_window.getComputedStyle(this, null).getPropertyValue(name));
            return f && function(t) {
                this.style.setProperty(name, f(t), priority);
            };
        });
    };
    d3_transitionPrototype.text = function(value) {
        return d3_transition_tween(this, "text", value, d3_transition_text);
    };
    function d3_transition_text(b1) {
        if (b1 == null) b1 = "";
        return function() {
            this.textContent = b1;
        };
    }
    d3_transitionPrototype.remove = function() {
        return this.each("end.transition", function() {
            var p;
            if (!this.__transition__ && (p = this.parentNode)) p.removeChild(this);
        });
    };
    d3_transitionPrototype.ease = function(value) {
        var id = this.id;
        if (arguments.length < 1) return this.node().__transition__[id].ease;
        if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
        return d3_selection_each(this, function(node) {
            node.__transition__[id].ease = value;
        });
    };
    d3_transitionPrototype.delay = function(value) {
        var id = this.id;
        return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
            node.__transition__[id].delay = value.call(node, node.__data__, i, j) | 0;
        } : (value |= 0, function(node) {
            node.__transition__[id].delay = value;
        }));
    };
    d3_transitionPrototype.duration = function(value) {
        var id = this.id;
        return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
            node.__transition__[id].duration = Math.max(1, value.call(node, node.__data__, i, j) | 0);
        } : (value = Math.max(1, value | 0), function(node) {
            node.__transition__[id].duration = value;
        }));
    };
    d3_transitionPrototype.each = function(type, listener) {
        var id = this.id;
        if (arguments.length < 2) {
            var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
            d3_transitionInheritId = id;
            d3_selection_each(this, function(node, i, j) {
                d3_transitionInherit = node.__transition__[id];
                type.call(node, node.__data__, i, j);
            });
            d3_transitionInherit = inherit;
            d3_transitionInheritId = inheritId;
        } else d3_selection_each(this, function(node) {
            node.__transition__[id].event.on(type, listener);
        });
        return this;
    };
    d3_transitionPrototype.transition = function() {
        var id0 = this.id, id1 = ++d3_transitionId, subgroups = [], subgroup, group, node, transition;
        for(var j = 0, m = this.length; j < m; j++){
            subgroups.push(subgroup = []);
            for(var group = this[j], i = 0, n = group.length; i < n; i++){
                if (node = group[i]) {
                    transition = Object.create(node.__transition__[id0]);
                    transition.delay += transition.duration;
                    d3_transitionNode(node, i, id1, transition);
                }
                subgroup.push(node);
            }
        }
        return d3_transition(subgroups, id1);
    };
    function d3_transitionNode(node, i, id, inherit) {
        var lock = node.__transition__ || (node.__transition__ = {
            active: 0,
            count: 0
        }), transition = lock[id];
        if (!transition) {
            var time = inherit.time;
            transition = lock[id] = {
                tween: new d3_Map(),
                event: d3.dispatch("start", "end"),
                time: time,
                ease: inherit.ease,
                delay: inherit.delay,
                duration: inherit.duration
            };
            ++lock.count;
            d3.timer(function(elapsed) {
                var d = node.__data__, ease = transition.ease, event = transition.event, delay = transition.delay, duration = transition.duration, tweened = [];
                return delay <= elapsed ? start(elapsed) : d3.timer(start, delay, time), 1;
                function start(elapsed) {
                    if (lock.active > id) return stop();
                    lock.active = id;
                    event.start.call(node, d, i);
                    transition.tween.forEach(function(key, value) {
                        if (value = value.call(node, d, i)) tweened.push(value);
                    });
                    if (!tick(elapsed)) d3.timer(tick, 0, time);
                    return 1;
                }
                function tick(elapsed) {
                    if (lock.active !== id) return stop();
                    var t = (elapsed - delay) / duration, e = ease(t), n = tweened.length;
                    while(n > 0)tweened[--n].call(node, e);
                    if (t >= 1) {
                        stop();
                        event.end.call(node, d, i);
                        return 1;
                    }
                }
                function stop() {
                    if (--lock.count) delete lock[id];
                    else delete node.__transition__;
                    return 1;
                }
            }, 0, time);
            return transition;
        }
    }
    d3.svg.axis = function() {
        var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, tickMajorSize = 6, tickMinorSize = 6, tickEndSize = 6, tickPadding = 3, tickArguments_ = [
            10
        ], tickValues = null, tickFormat_, tickSubdivide = 0;
        function axis(g) {
            g.each(function() {
                var g = d3.select(this);
                var ticks = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments_) : scale.domain() : tickValues, tickFormat = tickFormat_ == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments_) : String : tickFormat_;
                var subticks = d3_svg_axisSubdivide(scale, ticks, tickSubdivide), subtick = g.selectAll(".tick.minor").data(subticks, String), subtickEnter = subtick.enter().insert("line", ".tick").attr("class", "tick minor").style("opacity", 1e-6), subtickExit = d3.transition(subtick.exit()).style("opacity", 1e-6).remove(), subtickUpdate = d3.transition(subtick).style("opacity", 1);
                var tick = g.selectAll(".tick.major").data(ticks, String), tickEnter = tick.enter().insert("g", "path").attr("class", "tick major").style("opacity", 1e-6), tickExit = d3.transition(tick.exit()).style("opacity", 1e-6).remove(), tickUpdate = d3.transition(tick).style("opacity", 1), tickTransform;
                var range = d3_scaleRange(scale), path = g.selectAll(".domain").data([
                    0
                ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), d3.transition(path));
                var scale1 = scale.copy(), scale0 = this.__chart__ || scale1;
                this.__chart__ = scale1;
                tickEnter.append("line");
                tickEnter.append("text");
                var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text");
                switch(orient){
                    case "bottom":
                        tickTransform = d3_svg_axisX;
                        subtickEnter.attr("y2", tickMinorSize);
                        subtickUpdate.attr("x2", 0).attr("y2", tickMinorSize);
                        lineEnter.attr("y2", tickMajorSize);
                        textEnter.attr("y", Math.max(tickMajorSize, 0) + tickPadding);
                        lineUpdate.attr("x2", 0).attr("y2", tickMajorSize);
                        textUpdate.attr("x", 0).attr("y", Math.max(tickMajorSize, 0) + tickPadding);
                        text.attr("dy", ".71em").style("text-anchor", "middle");
                        pathUpdate.attr("d", "M" + range[0] + "," + tickEndSize + "V0H" + range[1] + "V" + tickEndSize);
                        break;
                    case "top":
                        tickTransform = d3_svg_axisX;
                        subtickEnter.attr("y2", -tickMinorSize);
                        subtickUpdate.attr("x2", 0).attr("y2", -tickMinorSize);
                        lineEnter.attr("y2", -tickMajorSize);
                        textEnter.attr("y", -(Math.max(tickMajorSize, 0) + tickPadding));
                        lineUpdate.attr("x2", 0).attr("y2", -tickMajorSize);
                        textUpdate.attr("x", 0).attr("y", -(Math.max(tickMajorSize, 0) + tickPadding));
                        text.attr("dy", "0em").style("text-anchor", "middle");
                        pathUpdate.attr("d", "M" + range[0] + "," + -tickEndSize + "V0H" + range[1] + "V" + -tickEndSize);
                        break;
                    case "left":
                        tickTransform = d3_svg_axisY;
                        subtickEnter.attr("x2", -tickMinorSize);
                        subtickUpdate.attr("x2", -tickMinorSize).attr("y2", 0);
                        lineEnter.attr("x2", -tickMajorSize);
                        textEnter.attr("x", -(Math.max(tickMajorSize, 0) + tickPadding));
                        lineUpdate.attr("x2", -tickMajorSize).attr("y2", 0);
                        textUpdate.attr("x", -(Math.max(tickMajorSize, 0) + tickPadding)).attr("y", 0);
                        text.attr("dy", ".32em").style("text-anchor", "end");
                        pathUpdate.attr("d", "M" + -tickEndSize + "," + range[0] + "H0V" + range[1] + "H" + -tickEndSize);
                        break;
                    case "right":
                        tickTransform = d3_svg_axisY;
                        subtickEnter.attr("x2", tickMinorSize);
                        subtickUpdate.attr("x2", tickMinorSize).attr("y2", 0);
                        lineEnter.attr("x2", tickMajorSize);
                        textEnter.attr("x", Math.max(tickMajorSize, 0) + tickPadding);
                        lineUpdate.attr("x2", tickMajorSize).attr("y2", 0);
                        textUpdate.attr("x", Math.max(tickMajorSize, 0) + tickPadding).attr("y", 0);
                        text.attr("dy", ".32em").style("text-anchor", "start");
                        pathUpdate.attr("d", "M" + tickEndSize + "," + range[0] + "H0V" + range[1] + "H" + tickEndSize);
                        break;
                }
                if (scale.ticks) {
                    tickEnter.call(tickTransform, scale0);
                    tickUpdate.call(tickTransform, scale1);
                    tickExit.call(tickTransform, scale1);
                    subtickEnter.call(tickTransform, scale0);
                    subtickUpdate.call(tickTransform, scale1);
                    subtickExit.call(tickTransform, scale1);
                } else {
                    var dx = scale1.rangeBand() / 2, x = function(d) {
                        return scale1(d) + dx;
                    };
                    tickEnter.call(tickTransform, x);
                    tickUpdate.call(tickTransform, x);
                }
            });
        }
        axis.scale = function(x) {
            if (!arguments.length) return scale;
            scale = x;
            return axis;
        };
        axis.orient = function(x) {
            if (!arguments.length) return orient;
            orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
            return axis;
        };
        axis.ticks = function() {
            if (!arguments.length) return tickArguments_;
            tickArguments_ = arguments;
            return axis;
        };
        axis.tickValues = function(x) {
            if (!arguments.length) return tickValues;
            tickValues = x;
            return axis;
        };
        axis.tickFormat = function(x) {
            if (!arguments.length) return tickFormat_;
            tickFormat_ = x;
            return axis;
        };
        axis.tickSize = function(x, y) {
            if (!arguments.length) return tickMajorSize;
            var n = arguments.length - 1;
            tickMajorSize = +x;
            tickMinorSize = n > 1 ? +y : tickMajorSize;
            tickEndSize = n > 0 ? +arguments[n] : tickMajorSize;
            return axis;
        };
        axis.tickPadding = function(x) {
            if (!arguments.length) return tickPadding;
            tickPadding = +x;
            return axis;
        };
        axis.tickSubdivide = function(x) {
            if (!arguments.length) return tickSubdivide;
            tickSubdivide = +x;
            return axis;
        };
        return axis;
    };
    var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
    };
    function d3_svg_axisX(selection, x) {
        selection.attr("transform", function(d) {
            return "translate(" + x(d) + ",0)";
        });
    }
    function d3_svg_axisY(selection, y) {
        selection.attr("transform", function(d) {
            return "translate(0," + y(d) + ")";
        });
    }
    function d3_svg_axisSubdivide(scale, ticks, m) {
        subticks = [];
        if (m && ticks.length > 1) {
            var extent = d3_scaleExtent(scale.domain()), subticks, i = -1, n = ticks.length, d = (ticks[1] - ticks[0]) / ++m, j, v;
            while(++i < n){
                for(j = m; --j > 0;)if ((v = +ticks[i] - j * d) >= extent[0]) subticks.push(v);
            }
            for(--i, j = 0; ++j < m && (v = +ticks[i] + j * d) < extent[1];)subticks.push(v);
        }
        return subticks;
    }
    d3.svg.brush = function() {
        var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, resizes = d3_svg_brushResizes[0], extent = [
            [
                0,
                0
            ],
            [
                0,
                0
            ]
        ], extentDomain;
        function brush(g) {
            g.each(function() {
                var g = d3.select(this), bg = g.selectAll(".background").data([
                    0
                ]), fg = g.selectAll(".extent").data([
                    0
                ]), tz = g.selectAll(".resize").data(resizes, String), e;
                g.style("pointer-events", "all").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
                bg.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
                fg.enter().append("rect").attr("class", "extent").style("cursor", "move");
                tz.enter().append("g").attr("class", function(d) {
                    return "resize " + d;
                }).style("cursor", function(d) {
                    return d3_svg_brushCursor[d];
                }).append("rect").attr("x", function(d) {
                    return /[ew]$/.test(d) ? -3 : null;
                }).attr("y", function(d) {
                    return /^[ns]/.test(d) ? -3 : null;
                }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
                tz.style("display", brush.empty() ? "none" : null);
                tz.exit().remove();
                if (x) {
                    e = d3_scaleRange(x);
                    bg.attr("x", e[0]).attr("width", e[1] - e[0]);
                    redrawX(g);
                }
                if (y) {
                    e = d3_scaleRange(y);
                    bg.attr("y", e[0]).attr("height", e[1] - e[0]);
                    redrawY(g);
                }
                redraw(g);
            });
        }
        function redraw(g) {
            g.selectAll(".resize").attr("transform", function(d) {
                return "translate(" + extent[+/e$/.test(d)][0] + "," + extent[+/^s/.test(d)][1] + ")";
            });
        }
        function redrawX(g) {
            g.select(".extent").attr("x", extent[0][0]);
            g.selectAll(".extent,.n>rect,.s>rect").attr("width", extent[1][0] - extent[0][0]);
        }
        function redrawY(g) {
            g.select(".extent").attr("y", extent[0][1]);
            g.selectAll(".extent,.e>rect,.w>rect").attr("height", extent[1][1] - extent[0][1]);
        }
        function brushstart() {
            var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), center, origin = mouse(), offset;
            var w = d3.select(d3_window).on("mousemove.brush", brushmove).on("mouseup.brush", brushend).on("touchmove.brush", brushmove).on("touchend.brush", brushend).on("keydown.brush", keydown).on("keyup.brush", keyup);
            if (dragging) {
                origin[0] = extent[0][0] - origin[0];
                origin[1] = extent[0][1] - origin[1];
            } else if (resizing) {
                var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
                offset = [
                    extent[1 - ex][0] - origin[0],
                    extent[1 - ey][1] - origin[1]
                ];
                origin[0] = extent[ex][0];
                origin[1] = extent[ey][1];
            } else if (d3.event.altKey) center = origin.slice();
            g.style("pointer-events", "none").selectAll(".resize").style("display", null);
            d3.select("body").style("cursor", eventTarget.style("cursor"));
            event_({
                type: "brushstart"
            });
            brushmove();
            d3_eventCancel();
            function mouse() {
                var touches = d3.event.changedTouches;
                return touches ? d3.touches(target, touches)[0] : d3.mouse(target);
            }
            function keydown() {
                if (d3.event.keyCode == 32) {
                    if (!dragging) {
                        center = null;
                        origin[0] -= extent[1][0];
                        origin[1] -= extent[1][1];
                        dragging = 2;
                    }
                    d3_eventCancel();
                }
            }
            function keyup() {
                if (d3.event.keyCode == 32 && dragging == 2) {
                    origin[0] += extent[1][0];
                    origin[1] += extent[1][1];
                    dragging = 0;
                    d3_eventCancel();
                }
            }
            function brushmove() {
                var point = mouse(), moved = false;
                if (offset) {
                    point[0] += offset[0];
                    point[1] += offset[1];
                }
                if (!dragging) {
                    if (d3.event.altKey) {
                        if (!center) center = [
                            (extent[0][0] + extent[1][0]) / 2,
                            (extent[0][1] + extent[1][1]) / 2
                        ];
                        origin[0] = extent[+(point[0] < center[0])][0];
                        origin[1] = extent[+(point[1] < center[1])][1];
                    } else center = null;
                }
                if (resizingX && move1(point, x, 0)) {
                    redrawX(g);
                    moved = true;
                }
                if (resizingY && move1(point, y, 1)) {
                    redrawY(g);
                    moved = true;
                }
                if (moved) {
                    redraw(g);
                    event_({
                        type: "brush",
                        mode: dragging ? "move" : "resize"
                    });
                }
            }
            function move1(point, scale, i) {
                var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], size = extent[1][i] - extent[0][i], min, max;
                if (dragging) {
                    r0 -= position;
                    r1 -= size + position;
                }
                min = Math.max(r0, Math.min(r1, point[i]));
                if (dragging) max = (min += position) + size;
                else {
                    if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
                    if (position < min) {
                        max = min;
                        min = position;
                    } else max = position;
                }
                if (extent[0][i] !== min || extent[1][i] !== max) {
                    extentDomain = null;
                    extent[0][i] = min;
                    extent[1][i] = max;
                    return true;
                }
            }
            function brushend() {
                brushmove();
                g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
                d3.select("body").style("cursor", null);
                w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
                event_({
                    type: "brushend"
                });
                d3_eventCancel();
            }
        }
        brush.x = function(z) {
            if (!arguments.length) return x;
            x = z;
            resizes = d3_svg_brushResizes[!x << 1 | !y];
            return brush;
        };
        brush.y = function(z) {
            if (!arguments.length) return y;
            y = z;
            resizes = d3_svg_brushResizes[!x << 1 | !y];
            return brush;
        };
        brush.extent = function(z) {
            var x0, x1, y0, y1, t;
            if (!arguments.length) {
                z = extentDomain || extent;
                if (x) {
                    x0 = z[0][0], x1 = z[1][0];
                    if (!extentDomain) {
                        x0 = extent[0][0], x1 = extent[1][0];
                        if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
                        if (x1 < x0) t = x0, x0 = x1, x1 = t;
                    }
                }
                if (y) {
                    y0 = z[0][1], y1 = z[1][1];
                    if (!extentDomain) {
                        y0 = extent[0][1], y1 = extent[1][1];
                        if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
                        if (y1 < y0) t = y0, y0 = y1, y1 = t;
                    }
                }
                return x && y ? [
                    [
                        x0,
                        y0
                    ],
                    [
                        x1,
                        y1
                    ]
                ] : x ? [
                    x0,
                    x1
                ] : y && [
                    y0,
                    y1
                ];
            }
            extentDomain = [
                [
                    0,
                    0
                ],
                [
                    0,
                    0
                ]
            ];
            if (x) {
                x0 = z[0], x1 = z[1];
                if (y) x0 = x0[0], x1 = x1[0];
                extentDomain[0][0] = x0, extentDomain[1][0] = x1;
                if (x.invert) x0 = x(x0), x1 = x(x1);
                if (x1 < x0) t = x0, x0 = x1, x1 = t;
                extent[0][0] = x0 | 0, extent[1][0] = x1 | 0;
            }
            if (y) {
                y0 = z[0], y1 = z[1];
                if (x) y0 = y0[1], y1 = y1[1];
                extentDomain[0][1] = y0, extentDomain[1][1] = y1;
                if (y.invert) y0 = y(y0), y1 = y(y1);
                if (y1 < y0) t = y0, y0 = y1, y1 = t;
                extent[0][1] = y0 | 0, extent[1][1] = y1 | 0;
            }
            return brush;
        };
        brush.clear = function() {
            extentDomain = null;
            extent[0][0] = extent[0][1] = extent[1][0] = extent[1][1] = 0;
            return brush;
        };
        brush.empty = function() {
            return x && extent[0][0] === extent[1][0] || y && extent[0][1] === extent[1][1];
        };
        return d3.rebind(brush, event, "on");
    };
    var d3_svg_brushCursor = {
        n: "ns-resize",
        e: "ew-resize",
        s: "ns-resize",
        w: "ew-resize",
        nw: "nwse-resize",
        ne: "nesw-resize",
        se: "nwse-resize",
        sw: "nesw-resize"
    };
    var d3_svg_brushResizes = [
        [
            "n",
            "e",
            "s",
            "w",
            "nw",
            "ne",
            "se",
            "sw"
        ],
        [
            "e",
            "w"
        ],
        [
            "n",
            "s"
        ],
        []
    ];
    d3.time = {};
    var d3_time = Date, d3_time_daySymbols = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ];
    function d3_time_utc() {
        this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
    }
    d3_time_utc.prototype = {
        getDate: function() {
            return this._.getUTCDate();
        },
        getDay: function() {
            return this._.getUTCDay();
        },
        getFullYear: function() {
            return this._.getUTCFullYear();
        },
        getHours: function() {
            return this._.getUTCHours();
        },
        getMilliseconds: function() {
            return this._.getUTCMilliseconds();
        },
        getMinutes: function() {
            return this._.getUTCMinutes();
        },
        getMonth: function() {
            return this._.getUTCMonth();
        },
        getSeconds: function() {
            return this._.getUTCSeconds();
        },
        getTime: function() {
            return this._.getTime();
        },
        getTimezoneOffset: function() {
            return 0;
        },
        valueOf: function() {
            return this._.valueOf();
        },
        setDate: function() {
            d3_time_prototype.setUTCDate.apply(this._, arguments);
        },
        setDay: function() {
            d3_time_prototype.setUTCDay.apply(this._, arguments);
        },
        setFullYear: function() {
            d3_time_prototype.setUTCFullYear.apply(this._, arguments);
        },
        setHours: function() {
            d3_time_prototype.setUTCHours.apply(this._, arguments);
        },
        setMilliseconds: function() {
            d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
        },
        setMinutes: function() {
            d3_time_prototype.setUTCMinutes.apply(this._, arguments);
        },
        setMonth: function() {
            d3_time_prototype.setUTCMonth.apply(this._, arguments);
        },
        setSeconds: function() {
            d3_time_prototype.setUTCSeconds.apply(this._, arguments);
        },
        setTime: function() {
            d3_time_prototype.setTime.apply(this._, arguments);
        }
    };
    var d3_time_prototype = Date.prototype;
    var d3_time_formatDateTime = "%a %b %e %X %Y", d3_time_formatDate = "%m/%d/%Y", d3_time_formatTime = "%H:%M:%S";
    var d3_time_days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ], d3_time_dayAbbreviations = [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ], d3_time_months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ], d3_time_monthAbbreviations = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ];
    function d3_time_interval(local, step, number) {
        function round(date) {
            var d0 = local(date), d1 = offset(d0, 1);
            return date - d0 < d1 - date ? d0 : d1;
        }
        function ceil(date) {
            step(date = local(new d3_time(date - 1)), 1);
            return date;
        }
        function offset(date, k) {
            step(date = new d3_time(+date), k);
            return date;
        }
        function range(t0, t1, dt) {
            var time = ceil(t0), times = [];
            if (dt > 1) while(time < t1){
                if (!(number(time) % dt)) times.push(new Date(+time));
                step(time, 1);
            }
            else while(time < t1)times.push(new Date(+time)), step(time, 1);
            return times;
        }
        function range_utc(t0, t1, dt) {
            try {
                d3_time = d3_time_utc;
                var utc = new d3_time_utc();
                utc._ = t0;
                return range(utc, t1, dt);
            } finally{
                d3_time = Date;
            }
        }
        local.floor = local;
        local.round = round;
        local.ceil = ceil;
        local.offset = offset;
        local.range = range;
        var utc = local.utc = d3_time_interval_utc(local);
        utc.floor = utc;
        utc.round = d3_time_interval_utc(round);
        utc.ceil = d3_time_interval_utc(ceil);
        utc.offset = d3_time_interval_utc(offset);
        utc.range = range_utc;
        return local;
    }
    function d3_time_interval_utc(method) {
        return function(date, k) {
            try {
                d3_time = d3_time_utc;
                var utc = new d3_time_utc();
                utc._ = date;
                return method(utc, k)._;
            } finally{
                d3_time = Date;
            }
        };
    }
    d3.time.year = d3_time_interval(function(date) {
        date = d3.time.day(date);
        date.setMonth(0, 1);
        return date;
    }, function(date, offset) {
        date.setFullYear(date.getFullYear() + offset);
    }, function(date) {
        return date.getFullYear();
    });
    d3.time.years = d3.time.year.range;
    d3.time.years.utc = d3.time.year.utc.range;
    d3.time.day = d3_time_interval(function(date) {
        var day = new d3_time(1970, 0);
        day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
        return day;
    }, function(date, offset) {
        date.setDate(date.getDate() + offset);
    }, function(date) {
        return date.getDate() - 1;
    });
    d3.time.days = d3.time.day.range;
    d3.time.days.utc = d3.time.day.utc.range;
    d3.time.dayOfYear = function(date) {
        var year = d3.time.year(date);
        return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
    };
    d3_time_daySymbols.forEach(function(day, i) {
        day = day.toLowerCase();
        i = 7 - i;
        var interval = d3.time[day] = d3_time_interval(function(date) {
            (date = d3.time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
            return date;
        }, function(date, offset) {
            date.setDate(date.getDate() + Math.floor(offset) * 7);
        }, function(date) {
            var day = d3.time.year(date).getDay();
            return Math.floor((d3.time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
        });
        d3.time[day + "s"] = interval.range;
        d3.time[day + "s"].utc = interval.utc.range;
        d3.time[day + "OfYear"] = function(date) {
            var day = d3.time.year(date).getDay();
            return Math.floor((d3.time.dayOfYear(date) + (day + i) % 7) / 7);
        };
    });
    d3.time.week = d3.time.sunday;
    d3.time.weeks = d3.time.sunday.range;
    d3.time.weeks.utc = d3.time.sunday.utc.range;
    d3.time.weekOfYear = d3.time.sundayOfYear;
    d3.time.format = function(template) {
        var n = template.length;
        function format(date) {
            var string = [], i = -1, j = 0, c, p, f;
            while(++i < n)if (template.charCodeAt(i) === 37) {
                string.push(template.substring(j, i));
                if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
                if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
                string.push(c);
                j = i + 1;
            }
            string.push(template.substring(j, i));
            return string.join("");
        }
        format.parse = function(string) {
            var d = {
                y: 1900,
                m: 0,
                d: 1,
                H: 0,
                M: 0,
                S: 0,
                L: 0
            }, i = d3_time_parse(d, template, string, 0);
            if (i != string.length) return null;
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            var date = new d3_time();
            date.setFullYear(d.y, d.m, d.d);
            date.setHours(d.H, d.M, d.S, d.L);
            return date;
        };
        format.toString = function() {
            return template;
        };
        return format;
    };
    function d3_time_parse(date, template, string, j) {
        var c, p, i = 0, n = template.length, m = string.length;
        while(i < n){
            if (j >= m) return -1;
            c = template.charCodeAt(i++);
            if (c === 37) {
                p = d3_time_parsers[template.charAt(i++)];
                if (!p || (j = p(date, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function d3_time_formatRe(names) {
        return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
    }
    function d3_time_formatLookup(names) {
        var map = new d3_Map(), i = -1, n = names.length;
        while(++i < n)map.set(names[i].toLowerCase(), i);
        return map;
    }
    function d3_time_formatPad(value, fill, width) {
        value += "";
        var length = value.length;
        return length < width ? new Array(width - length + 1).join(fill) + value : value;
    }
    var d3_time_dayRe = d3_time_formatRe(d3_time_days), d3_time_dayAbbrevRe = d3_time_formatRe(d3_time_dayAbbreviations), d3_time_monthRe = d3_time_formatRe(d3_time_months), d3_time_monthLookup = d3_time_formatLookup(d3_time_months), d3_time_monthAbbrevRe = d3_time_formatRe(d3_time_monthAbbreviations), d3_time_monthAbbrevLookup = d3_time_formatLookup(d3_time_monthAbbreviations);
    var d3_time_formatPads = {
        "-": "",
        _: " ",
        "0": "0"
    };
    var d3_time_formats = {
        a: function(d) {
            return d3_time_dayAbbreviations[d.getDay()];
        },
        A: function(d) {
            return d3_time_days[d.getDay()];
        },
        b: function(d) {
            return d3_time_monthAbbreviations[d.getMonth()];
        },
        B: function(d) {
            return d3_time_months[d.getMonth()];
        },
        c: d3.time.format(d3_time_formatDateTime),
        d: function(d, p) {
            return d3_time_formatPad(d.getDate(), p, 2);
        },
        e: function(d, p) {
            return d3_time_formatPad(d.getDate(), p, 2);
        },
        H: function(d, p) {
            return d3_time_formatPad(d.getHours(), p, 2);
        },
        I: function(d, p) {
            return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
        },
        j: function(d, p) {
            return d3_time_formatPad(1 + d3.time.dayOfYear(d), p, 3);
        },
        L: function(d, p) {
            return d3_time_formatPad(d.getMilliseconds(), p, 3);
        },
        m: function(d, p) {
            return d3_time_formatPad(d.getMonth() + 1, p, 2);
        },
        M: function(d, p) {
            return d3_time_formatPad(d.getMinutes(), p, 2);
        },
        p: function(d) {
            return d.getHours() >= 12 ? "PM" : "AM";
        },
        S: function(d, p) {
            return d3_time_formatPad(d.getSeconds(), p, 2);
        },
        U: function(d, p) {
            return d3_time_formatPad(d3.time.sundayOfYear(d), p, 2);
        },
        w: function(d) {
            return d.getDay();
        },
        W: function(d, p) {
            return d3_time_formatPad(d3.time.mondayOfYear(d), p, 2);
        },
        x: d3.time.format(d3_time_formatDate),
        X: d3.time.format(d3_time_formatTime),
        y: function(d, p) {
            return d3_time_formatPad(d.getFullYear() % 100, p, 2);
        },
        Y: function(d, p) {
            return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
        },
        Z: d3_time_zone,
        "%": function() {
            return "%";
        }
    };
    var d3_time_parsers = {
        a: d3_time_parseWeekdayAbbrev,
        A: d3_time_parseWeekday,
        b: d3_time_parseMonthAbbrev,
        B: d3_time_parseMonth,
        c: d3_time_parseLocaleFull,
        d: d3_time_parseDay,
        e: d3_time_parseDay,
        H: d3_time_parseHour24,
        I: d3_time_parseHour24,
        L: d3_time_parseMilliseconds,
        m: d3_time_parseMonthNumber,
        M: d3_time_parseMinutes,
        p: d3_time_parseAmPm,
        S: d3_time_parseSeconds,
        x: d3_time_parseLocaleDate,
        X: d3_time_parseLocaleTime,
        y: d3_time_parseYear,
        Y: d3_time_parseFullYear
    };
    function d3_time_parseWeekdayAbbrev(date, string, i) {
        d3_time_dayAbbrevRe.lastIndex = 0;
        var n = d3_time_dayAbbrevRe.exec(string.substring(i));
        return n ? i += n[0].length : -1;
    }
    function d3_time_parseWeekday(date, string, i) {
        d3_time_dayRe.lastIndex = 0;
        var n = d3_time_dayRe.exec(string.substring(i));
        return n ? i += n[0].length : -1;
    }
    function d3_time_parseMonthAbbrev(date, string, i) {
        d3_time_monthAbbrevRe.lastIndex = 0;
        var n = d3_time_monthAbbrevRe.exec(string.substring(i));
        return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i += n[0].length) : -1;
    }
    function d3_time_parseMonth(date, string, i) {
        d3_time_monthRe.lastIndex = 0;
        var n = d3_time_monthRe.exec(string.substring(i));
        return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i += n[0].length) : -1;
    }
    function d3_time_parseLocaleFull(date, string, i) {
        return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
    }
    function d3_time_parseLocaleDate(date, string, i) {
        return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
    }
    function d3_time_parseLocaleTime(date, string, i) {
        return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
    }
    function d3_time_parseFullYear(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.substring(i, i + 4));
        return n ? (date.y = +n[0], i += n[0].length) : -1;
    }
    function d3_time_parseYear(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.substring(i, i + 2));
        return n ? (date.y = d3_time_expandYear(+n[0]), i += n[0].length) : -1;
    }
    function d3_time_expandYear(d) {
        return d + (d > 68 ? 1900 : 2e3);
    }
    function d3_time_parseMonthNumber(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.substring(i, i + 2));
        return n ? (date.m = n[0] - 1, i += n[0].length) : -1;
    }
    function d3_time_parseDay(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.substring(i, i + 2));
        return n ? (date.d = +n[0], i += n[0].length) : -1;
    }
    function d3_time_parseHour24(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.substring(i, i + 2));
        return n ? (date.H = +n[0], i += n[0].length) : -1;
    }
    function d3_time_parseMinutes(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.substring(i, i + 2));
        return n ? (date.M = +n[0], i += n[0].length) : -1;
    }
    function d3_time_parseSeconds(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.substring(i, i + 2));
        return n ? (date.S = +n[0], i += n[0].length) : -1;
    }
    function d3_time_parseMilliseconds(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.substring(i, i + 3));
        return n ? (date.L = +n[0], i += n[0].length) : -1;
    }
    var d3_time_numberRe = /^\s*\d+/;
    function d3_time_parseAmPm(date, string, i) {
        var n = d3_time_amPmLookup.get(string.substring(i, i += 2).toLowerCase());
        return n == null ? -1 : (date.p = n, i);
    }
    var d3_time_amPmLookup = d3.map({
        am: 0,
        pm: 1
    });
    function d3_time_zone(d) {
        var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = ~~(Math.abs(z) / 60), zm = Math.abs(z) % 60;
        return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
    }
    d3.time.format.utc = function(template) {
        var local = d3.time.format(template);
        function format(date) {
            try {
                d3_time = d3_time_utc;
                var utc = new d3_time();
                utc._ = date;
                return local(utc);
            } finally{
                d3_time = Date;
            }
        }
        format.parse = function(string) {
            try {
                d3_time = d3_time_utc;
                var date = local.parse(string);
                return date && date._;
            } finally{
                d3_time = Date;
            }
        };
        format.toString = local.toString;
        return format;
    };
    var d3_time_formatIso = d3.time.format.utc("%Y-%m-%dT%H:%M:%S.%LZ");
    d3.time.format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
    function d3_time_formatIsoNative(date) {
        return date.toISOString();
    }
    d3_time_formatIsoNative.parse = function(string) {
        var date = new Date(string);
        return isNaN(date) ? null : date;
    };
    d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
    d3.time.second = d3_time_interval(function(date) {
        return new d3_time(Math.floor(date / 1e3) * 1e3);
    }, function(date, offset) {
        date.setTime(date.getTime() + Math.floor(offset) * 1e3);
    }, function(date) {
        return date.getSeconds();
    });
    d3.time.seconds = d3.time.second.range;
    d3.time.seconds.utc = d3.time.second.utc.range;
    d3.time.minute = d3_time_interval(function(date) {
        return new d3_time(Math.floor(date / 6e4) * 6e4);
    }, function(date, offset) {
        date.setTime(date.getTime() + Math.floor(offset) * 6e4);
    }, function(date) {
        return date.getMinutes();
    });
    d3.time.minutes = d3.time.minute.range;
    d3.time.minutes.utc = d3.time.minute.utc.range;
    d3.time.hour = d3_time_interval(function(date) {
        var timezone = date.getTimezoneOffset() / 60;
        return new d3_time((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
    }, function(date, offset) {
        date.setTime(date.getTime() + Math.floor(offset) * 36e5);
    }, function(date) {
        return date.getHours();
    });
    d3.time.hours = d3.time.hour.range;
    d3.time.hours.utc = d3.time.hour.utc.range;
    d3.time.month = d3_time_interval(function(date) {
        date = d3.time.day(date);
        date.setDate(1);
        return date;
    }, function(date, offset) {
        date.setMonth(date.getMonth() + offset);
    }, function(date) {
        return date.getMonth();
    });
    d3.time.months = d3.time.month.range;
    d3.time.months.utc = d3.time.month.utc.range;
    function d3_time_scale(linear, methods, format) {
        function scale(x) {
            return linear(x);
        }
        scale.invert = function(x) {
            return d3_time_scaleDate(linear.invert(x));
        };
        scale.domain = function(x) {
            if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
            linear.domain(x);
            return scale;
        };
        scale.nice = function(m) {
            return scale.domain(d3_scale_nice(scale.domain(), function() {
                return m;
            }));
        };
        scale.ticks = function(m, k) {
            var extent = d3_time_scaleExtent(scale.domain());
            if (typeof m !== "function") {
                var span = extent[1] - extent[0], target = span / m, i = d3.bisect(d3_time_scaleSteps, target);
                if (i == d3_time_scaleSteps.length) return methods.year(extent, m);
                if (!i) return linear.ticks(m).map(d3_time_scaleDate);
                if (Math.log(target / d3_time_scaleSteps[i - 1]) < Math.log(d3_time_scaleSteps[i] / target)) --i;
                m = methods[i];
                k = m[1];
                m = m[0].range;
            }
            return m(extent[0], new Date(+extent[1] + 1), k);
        };
        scale.tickFormat = function() {
            return format;
        };
        scale.copy = function() {
            return d3_time_scale(linear.copy(), methods, format);
        };
        return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
    }
    function d3_time_scaleExtent(domain) {
        var start = domain[0], stop = domain[domain.length - 1];
        return start < stop ? [
            start,
            stop
        ] : [
            stop,
            start
        ];
    }
    function d3_time_scaleDate(t) {
        return new Date(t);
    }
    function d3_time_scaleFormat(formats) {
        return function(date) {
            var i = formats.length - 1, f = formats[i];
            while(!f[1](date))f = formats[--i];
            return f[0](date);
        };
    }
    function d3_time_scaleSetYear(y) {
        var d = new Date(y, 0, 1);
        d.setFullYear(y);
        return d;
    }
    function d3_time_scaleGetYear(d) {
        var y = d.getFullYear(), d0 = d3_time_scaleSetYear(y), d1 = d3_time_scaleSetYear(y + 1);
        return y + (d - d0) / (d1 - d0);
    }
    var d3_time_scaleSteps = [
        1e3,
        5e3,
        15e3,
        3e4,
        6e4,
        3e5,
        9e5,
        18e5,
        36e5,
        108e5,
        216e5,
        432e5,
        864e5,
        1728e5,
        6048e5,
        2592e6,
        7776e6,
        31536e6
    ];
    var d3_time_scaleLocalMethods = [
        [
            d3.time.second,
            1
        ],
        [
            d3.time.second,
            5
        ],
        [
            d3.time.second,
            15
        ],
        [
            d3.time.second,
            30
        ],
        [
            d3.time.minute,
            1
        ],
        [
            d3.time.minute,
            5
        ],
        [
            d3.time.minute,
            15
        ],
        [
            d3.time.minute,
            30
        ],
        [
            d3.time.hour,
            1
        ],
        [
            d3.time.hour,
            3
        ],
        [
            d3.time.hour,
            6
        ],
        [
            d3.time.hour,
            12
        ],
        [
            d3.time.day,
            1
        ],
        [
            d3.time.day,
            2
        ],
        [
            d3.time.week,
            1
        ],
        [
            d3.time.month,
            1
        ],
        [
            d3.time.month,
            3
        ],
        [
            d3.time.year,
            1
        ]
    ];
    var d3_time_scaleLocalFormats = [
        [
            d3.time.format("%Y"),
            d3_true
        ],
        [
            d3.time.format("%B"),
            function(d) {
                return d.getMonth();
            }
        ],
        [
            d3.time.format("%b %d"),
            function(d) {
                return d.getDate() != 1;
            }
        ],
        [
            d3.time.format("%a %d"),
            function(d) {
                return d.getDay() && d.getDate() != 1;
            }
        ],
        [
            d3.time.format("%I %p"),
            function(d) {
                return d.getHours();
            }
        ],
        [
            d3.time.format("%I:%M"),
            function(d) {
                return d.getMinutes();
            }
        ],
        [
            d3.time.format(":%S"),
            function(d) {
                return d.getSeconds();
            }
        ],
        [
            d3.time.format(".%L"),
            function(d) {
                return d.getMilliseconds();
            }
        ]
    ];
    var d3_time_scaleLinear = d3.scale.linear(), d3_time_scaleLocalFormat = d3_time_scaleFormat(d3_time_scaleLocalFormats);
    d3_time_scaleLocalMethods.year = function(extent, m) {
        return d3_time_scaleLinear.domain(extent.map(d3_time_scaleGetYear)).ticks(m).map(d3_time_scaleSetYear);
    };
    d3.time.scale = function() {
        return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
    };
    var d3_time_scaleUTCMethods = d3_time_scaleLocalMethods.map(function(m) {
        return [
            m[0].utc,
            m[1]
        ];
    });
    var d3_time_scaleUTCFormats = [
        [
            d3.time.format.utc("%Y"),
            d3_true
        ],
        [
            d3.time.format.utc("%B"),
            function(d) {
                return d.getUTCMonth();
            }
        ],
        [
            d3.time.format.utc("%b %d"),
            function(d) {
                return d.getUTCDate() != 1;
            }
        ],
        [
            d3.time.format.utc("%a %d"),
            function(d) {
                return d.getUTCDay() && d.getUTCDate() != 1;
            }
        ],
        [
            d3.time.format.utc("%I %p"),
            function(d) {
                return d.getUTCHours();
            }
        ],
        [
            d3.time.format.utc("%I:%M"),
            function(d) {
                return d.getUTCMinutes();
            }
        ],
        [
            d3.time.format.utc(":%S"),
            function(d) {
                return d.getUTCSeconds();
            }
        ],
        [
            d3.time.format.utc(".%L"),
            function(d) {
                return d.getUTCMilliseconds();
            }
        ]
    ];
    var d3_time_scaleUTCFormat = d3_time_scaleFormat(d3_time_scaleUTCFormats);
    function d3_time_scaleUTCSetYear(y) {
        var d = new Date(Date.UTC(y, 0, 1));
        d.setUTCFullYear(y);
        return d;
    }
    function d3_time_scaleUTCGetYear(d) {
        var y = d.getUTCFullYear(), d0 = d3_time_scaleUTCSetYear(y), d1 = d3_time_scaleUTCSetYear(y + 1);
        return y + (d - d0) / (d1 - d0);
    }
    d3_time_scaleUTCMethods.year = function(extent, m) {
        return d3_time_scaleLinear.domain(extent.map(d3_time_scaleUTCGetYear)).ticks(m).map(d3_time_scaleUTCSetYear);
    };
    d3.time.scale.utc = function() {
        return d3_time_scale(d3.scale.linear(), d3_time_scaleUTCMethods, d3_time_scaleUTCFormat);
    };
    d3.text = function() {
        return d3.xhr.apply(d3, arguments).response(d3_text);
    };
    function d3_text(request) {
        return request.responseText;
    }
    d3.json = function(url, callback) {
        return d3.xhr(url, "application/json", callback).response(d3_json);
    };
    function d3_json(request) {
        return JSON.parse(request.responseText);
    }
    d3.html = function(url, callback) {
        return d3.xhr(url, "text/html", callback).response(d3_html);
    };
    function d3_html(request) {
        var range = d3_document.createRange();
        range.selectNode(d3_document.body);
        return range.createContextualFragment(request.responseText);
    }
    d3.xml = function() {
        return d3.xhr.apply(d3, arguments).response(d3_xml);
    };
    function d3_xml(request) {
        return request.responseXML;
    }
    return d3;
}();


var $9175b321012dc0d3$var$d3 = function() {
    var d3 = {
        version: "3.1.5"
    };
    if (!Date.now) Date.now = function() {
        return +new Date();
    };
    var d3_document = document, d3_window = window;
    try {
        d3_document.createElement("div").style.setProperty("opacity", 0, "");
    } catch (error) {
        var d3_style_prototype = d3_window.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
        d3_style_prototype.setProperty = function(name, value, priority) {
            d3_style_setProperty.call(this, name, value + "", priority);
        };
    }
    d3.ascending = function(a, b1) {
        return a < b1 ? -1 : a > b1 ? 1 : a >= b1 ? 0 : NaN;
    };
    d3.descending = function(a, b1) {
        return b1 < a ? -1 : b1 > a ? 1 : b1 >= a ? 0 : NaN;
    };
    d3.min = function(array, f) {
        var i = -1, n = array.length, a, b1;
        if (arguments.length === 1) {
            while(++i < n && ((a = array[i]) == null || a != a))a = undefined;
            while(++i < n)if ((b1 = array[i]) != null && a > b1) a = b1;
        } else {
            while(++i < n && ((a = f.call(array, array[i], i)) == null || a != a))a = undefined;
            while(++i < n)if ((b1 = f.call(array, array[i], i)) != null && a > b1) a = b1;
        }
        return a;
    };
    d3.max = function(array, f) {
        var i = -1, n = array.length, a, b1;
        if (arguments.length === 1) {
            while(++i < n && ((a = array[i]) == null || a != a))a = undefined;
            while(++i < n)if ((b1 = array[i]) != null && b1 > a) a = b1;
        } else {
            while(++i < n && ((a = f.call(array, array[i], i)) == null || a != a))a = undefined;
            while(++i < n)if ((b1 = f.call(array, array[i], i)) != null && b1 > a) a = b1;
        }
        return a;
    };
    d3.extent = function(array, f) {
        var i = -1, n = array.length, a, b1, c;
        if (arguments.length === 1) {
            while(++i < n && ((a = c = array[i]) == null || a != a))a = c = undefined;
            while(++i < n)if ((b1 = array[i]) != null) {
                if (a > b1) a = b1;
                if (c < b1) c = b1;
            }
        } else {
            while(++i < n && ((a = c = f.call(array, array[i], i)) == null || a != a))a = undefined;
            while(++i < n)if ((b1 = f.call(array, array[i], i)) != null) {
                if (a > b1) a = b1;
                if (c < b1) c = b1;
            }
        }
        return [
            a,
            c
        ];
    };
    d3.sum = function(array, f) {
        var s = 0, n = array.length, a, i = -1;
        if (arguments.length === 1) {
            while(++i < n)if (!isNaN(a = +array[i])) s += a;
        } else {
            while(++i < n)if (!isNaN(a = +f.call(array, array[i], i))) s += a;
        }
        return s;
    };
    function d3_number(x) {
        return x != null && !isNaN(x);
    }
    d3.mean = function(array, f) {
        var n = array.length, a, m = 0, i = -1, j = 0;
        if (arguments.length === 1) {
            while(++i < n)if (d3_number(a = array[i])) m += (a - m) / ++j;
        } else {
            while(++i < n)if (d3_number(a = f.call(array, array[i], i))) m += (a - m) / ++j;
        }
        return j ? m : undefined;
    };
    d3.quantile = function(values, p) {
        var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
        return e ? v + e * (values[h] - v) : v;
    };
    d3.median = function(array, f) {
        if (arguments.length > 1) array = array.map(f);
        array = array.filter(d3_number);
        return array.length ? d3.quantile(array.sort(d3.ascending), .5) : undefined;
    };
    d3.bisector = function(f) {
        return {
            left: function(a, x, lo, hi) {
                if (arguments.length < 3) lo = 0;
                if (arguments.length < 4) hi = a.length;
                while(lo < hi){
                    var mid = lo + hi >>> 1;
                    if (f.call(a, a[mid], mid) < x) lo = mid + 1;
                    else hi = mid;
                }
                return lo;
            },
            right: function(a, x, lo, hi) {
                if (arguments.length < 3) lo = 0;
                if (arguments.length < 4) hi = a.length;
                while(lo < hi){
                    var mid = lo + hi >>> 1;
                    if (x < f.call(a, a[mid], mid)) hi = mid;
                    else lo = mid + 1;
                }
                return lo;
            }
        };
    };
    var d3_bisector = d3.bisector(function(d) {
        return d;
    });
    d3.bisectLeft = d3_bisector.left;
    d3.bisect = d3.bisectRight = d3_bisector.right;
    d3.shuffle = function(array) {
        var m = array.length, t, i;
        while(m){
            i = Math.random() * m-- | 0;
            t = array[m], array[m] = array[i], array[i] = t;
        }
        return array;
    };
    d3.permute = function(array, indexes) {
        var permutes = [], i = -1, n = indexes.length;
        while(++i < n)permutes[i] = array[indexes[i]];
        return permutes;
    };
    d3.zip = function() {
        if (!(n = arguments.length)) return [];
        for(var i = -1, m = d3.min(arguments, d3_zipLength), zips = new Array(m); ++i < m;)for(var j = -1, n, zip = zips[i] = new Array(n); ++j < n;)zip[j] = arguments[j][i];
        return zips;
    };
    function d3_zipLength(d) {
        return d.length;
    }
    d3.transpose = function(matrix) {
        return d3.zip.apply(d3, matrix);
    };
    d3.keys = function(map) {
        var keys = [];
        for(var key in map)keys.push(key);
        return keys;
    };
    d3.values = function(map) {
        var values = [];
        for(var key in map)values.push(map[key]);
        return values;
    };
    d3.entries = function(map) {
        var entries = [];
        for(var key in map)entries.push({
            key: key,
            value: map[key]
        });
        return entries;
    };
    d3.merge = function(arrays) {
        return Array.prototype.concat.apply([], arrays);
    };
    d3.range = function(start, stop, step) {
        if (arguments.length < 3) {
            step = 1;
            if (arguments.length < 2) {
                stop = start;
                start = 0;
            }
        }
        if ((stop - start) / step === Infinity) throw new Error("infinite range");
        var range = [], k = d3_range_integerScale(Math.abs(step)), i = -1, j;
        start *= k, stop *= k, step *= k;
        if (step < 0) while((j = start + step * ++i) > stop)range.push(j / k);
        else while((j = start + step * ++i) < stop)range.push(j / k);
        return range;
    };
    function d3_range_integerScale(x) {
        var k = 1;
        while(x * k % 1)k *= 10;
        return k;
    }
    function d3_class(ctor, properties) {
        try {
            for(var key in properties)Object.defineProperty(ctor.prototype, key, {
                value: properties[key],
                enumerable: false
            });
        } catch (e) {
            ctor.prototype = properties;
        }
    }
    d3.map = function(object) {
        var map = new d3_Map();
        for(var key in object)map.set(key, object[key]);
        return map;
    };
    function d3_Map() {}
    d3_class(d3_Map, {
        has: function(key) {
            return d3_map_prefix + key in this;
        },
        get: function(key) {
            return this[d3_map_prefix + key];
        },
        set: function(key, value) {
            return this[d3_map_prefix + key] = value;
        },
        remove: function(key) {
            key = d3_map_prefix + key;
            return key in this && delete this[key];
        },
        keys: function() {
            var keys = [];
            this.forEach(function(key) {
                keys.push(key);
            });
            return keys;
        },
        values: function() {
            var values = [];
            this.forEach(function(key, value) {
                values.push(value);
            });
            return values;
        },
        entries: function() {
            var entries = [];
            this.forEach(function(key, value) {
                entries.push({
                    key: key,
                    value: value
                });
            });
            return entries;
        },
        forEach: function(f) {
            for(var key in this)if (key.charCodeAt(0) === d3_map_prefixCode) f.call(this, key.substring(1), this[key]);
        }
    });
    var d3_map_prefix = "\0", d3_map_prefixCode = d3_map_prefix.charCodeAt(0);
    d3.nest = function() {
        var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
        function map(mapType, array, depth) {
            if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
            var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
            while(++i < n)if (values = valuesByKey.get(keyValue = key(object = array[i]))) values.push(object);
            else valuesByKey.set(keyValue, [
                object
            ]);
            if (mapType) {
                object = mapType();
                setter = function(keyValue, values) {
                    object.set(keyValue, map(mapType, values, depth));
                };
            } else {
                object = {};
                setter = function(keyValue, values) {
                    object[keyValue] = map(mapType, values, depth);
                };
            }
            valuesByKey.forEach(setter);
            return object;
        }
        function entries(map, depth) {
            if (depth >= keys.length) return map;
            var array = [], sortKey = sortKeys[depth++];
            map.forEach(function(key, keyMap) {
                array.push({
                    key: key,
                    values: entries(keyMap, depth)
                });
            });
            return sortKey ? array.sort(function(a, b1) {
                return sortKey(a.key, b1.key);
            }) : array;
        }
        nest.map = function(array, mapType) {
            return map(mapType, array, 0);
        };
        nest.entries = function(array) {
            return entries(map(d3.map, array, 0), 0);
        };
        nest.key = function(d) {
            keys.push(d);
            return nest;
        };
        nest.sortKeys = function(order) {
            sortKeys[keys.length - 1] = order;
            return nest;
        };
        nest.sortValues = function(order) {
            sortValues = order;
            return nest;
        };
        nest.rollup = function(f) {
            rollup = f;
            return nest;
        };
        return nest;
    };
    d3.set = function(array) {
        var set = new d3_Set();
        if (array) for(var i = 0; i < array.length; i++)set.add(array[i]);
        return set;
    };
    function d3_Set() {}
    d3_class(d3_Set, {
        has: function(value) {
            return d3_map_prefix + value in this;
        },
        add: function(value) {
            this[d3_map_prefix + value] = true;
            return value;
        },
        remove: function(value) {
            value = d3_map_prefix + value;
            return value in this && delete this[value];
        },
        values: function() {
            var values = [];
            this.forEach(function(value) {
                values.push(value);
            });
            return values;
        },
        forEach: function(f) {
            for(var value in this)if (value.charCodeAt(0) === d3_map_prefixCode) f.call(this, value.substring(1));
        }
    });
    d3.behavior = {};
    d3.rebind = function(target, source) {
        var i = 1, n = arguments.length, method;
        while(++i < n)target[method = arguments[i]] = d3_rebind(target, source, source[method]);
        return target;
    };
    function d3_rebind(target, source, method) {
        return function() {
            var value = method.apply(source, arguments);
            return value === source ? target : value;
        };
    }
    d3.dispatch = function() {
        var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
        while(++i < n)dispatch[arguments[i]] = d3_dispatch_event(dispatch);
        return dispatch;
    };
    function d3_dispatch() {}
    d3_dispatch.prototype.on = function(type, listener) {
        var i = type.indexOf("."), name = "";
        if (i >= 0) {
            name = type.substring(i + 1);
            type = type.substring(0, i);
        }
        if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
        if (arguments.length === 2) {
            if (listener == null) {
                for(type in this)if (this.hasOwnProperty(type)) this[type].on(name, null);
            }
            return this;
        }
    };
    function d3_dispatch_event(dispatch) {
        var listeners = [], listenerByName = new d3_Map();
        function event() {
            var z = listeners, i = -1, n = z.length, l;
            while(++i < n)if (l = z[i].on) l.apply(this, arguments);
            return dispatch;
        }
        event.on = function(name, listener) {
            var l = listenerByName.get(name), i;
            if (arguments.length < 2) return l && l.on;
            if (l) {
                l.on = null;
                listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
                listenerByName.remove(name);
            }
            if (listener) listeners.push(listenerByName.set(name, {
                on: listener
            }));
            return dispatch;
        };
        return event;
    }
    d3.event = null;
    function d3_eventCancel() {
        d3.event.stopPropagation();
        d3.event.preventDefault();
    }
    function d3_eventSource() {
        var e = d3.event, s;
        while(s = e.sourceEvent)e = s;
        return e;
    }
    function d3_eventSuppress(target, type) {
        function off() {
            target.on(type, null);
        }
        target.on(type, function() {
            d3_eventCancel();
            off();
        }, true);
        setTimeout(off, 0);
    }
    function d3_eventDispatch(target) {
        var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
        while(++i < n)dispatch[arguments[i]] = d3_dispatch_event(dispatch);
        dispatch.of = function(thiz, argumentz) {
            return function(e1) {
                try {
                    var e0 = e1.sourceEvent = d3.event;
                    e1.target = target;
                    d3.event = e1;
                    dispatch[e1.type].apply(thiz, argumentz);
                } finally{
                    d3.event = e0;
                }
            };
        };
        return dispatch;
    }
    d3.mouse = function(container) {
        return d3_mousePoint(container, d3_eventSource());
    };
    var d3_mouse_bug44083 = /WebKit/.test(d3_window.navigator.userAgent) ? -1 : 0;
    function d3_mousePoint(container, e) {
        var svg = container.ownerSVGElement || container;
        if (svg.createSVGPoint) {
            var point = svg.createSVGPoint();
            if (d3_mouse_bug44083 < 0 && (d3_window.scrollX || d3_window.scrollY)) {
                svg = d3.select(d3_document.body).append("svg").style("position", "absolute").style("top", 0).style("left", 0);
                var ctm = svg[0][0].getScreenCTM();
                d3_mouse_bug44083 = !(ctm.f || ctm.e);
                svg.remove();
            }
            if (d3_mouse_bug44083) {
                point.x = e.pageX;
                point.y = e.pageY;
            } else {
                point.x = e.clientX;
                point.y = e.clientY;
            }
            point = point.matrixTransform(container.getScreenCTM().inverse());
            return [
                point.x,
                point.y
            ];
        }
        var rect = container.getBoundingClientRect();
        return [
            e.clientX - rect.left - container.clientLeft,
            e.clientY - rect.top - container.clientTop
        ];
    }
    var d3_array = d3_arraySlice;
    function d3_arrayCopy(pseudoarray) {
        var i = -1, n = pseudoarray.length, array = [];
        while(++i < n)array.push(pseudoarray[i]);
        return array;
    }
    function d3_arraySlice(pseudoarray) {
        return Array.prototype.slice.call(pseudoarray);
    }
    try {
        d3_array(d3_document.documentElement.childNodes)[0].nodeType;
    } catch (e) {
        d3_array = d3_arrayCopy;
    }
    var d3_arraySubclass = [].__proto__ ? function(array, prototype) {
        array.__proto__ = prototype;
    } : function(array, prototype) {
        for(var property in prototype)array[property] = prototype[property];
    };
    d3.touches = function(container, touches) {
        if (arguments.length < 2) touches = d3_eventSource().touches;
        return touches ? d3_array(touches).map(function(touch) {
            var point = d3_mousePoint(container, touch);
            point.identifier = touch.identifier;
            return point;
        }) : [];
    };
    d3.behavior.drag = function() {
        var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null;
        function drag() {
            this.on("mousedown.drag", mousedown).on("touchstart.drag", mousedown);
        }
        function mousedown() {
            var target = this, event_ = event.of(target, arguments), eventTarget = d3.event.target, touchId = d3.event.touches ? d3.event.changedTouches[0].identifier : null, offset, origin_ = point(), moved = 0;
            var w = d3.select(d3_window).on(touchId != null ? "touchmove.drag-" + touchId : "mousemove.drag", dragmove).on(touchId != null ? "touchend.drag-" + touchId : "mouseup.drag", dragend, true);
            if (origin) {
                offset = origin.apply(target, arguments);
                offset = [
                    offset.x - origin_[0],
                    offset.y - origin_[1]
                ];
            } else offset = [
                0,
                0
            ];
            if (touchId == null) d3_eventCancel();
            event_({
                type: "dragstart"
            });
            function point() {
                var p = target.parentNode;
                return touchId != null ? d3.touches(p).filter(function(p) {
                    return p.identifier === touchId;
                })[0] : d3.mouse(p);
            }
            function dragmove() {
                if (!target.parentNode) return dragend();
                var p = point(), dx = p[0] - origin_[0], dy = p[1] - origin_[1];
                moved |= dx | dy;
                origin_ = p;
                d3_eventCancel();
                event_({
                    type: "drag",
                    x: p[0] + offset[0],
                    y: p[1] + offset[1],
                    dx: dx,
                    dy: dy
                });
            }
            function dragend() {
                event_({
                    type: "dragend"
                });
                if (moved) {
                    d3_eventCancel();
                    if (d3.event.target === eventTarget) d3_eventSuppress(w, "click");
                }
                w.on(touchId != null ? "touchmove.drag-" + touchId : "mousemove.drag", null).on(touchId != null ? "touchend.drag-" + touchId : "mouseup.drag", null);
            }
        }
        drag.origin = function(x) {
            if (!arguments.length) return origin;
            origin = x;
            return drag;
        };
        return d3.rebind(drag, event, "on");
    };
    function d3_selection(groups) {
        d3_arraySubclass(groups, d3_selectionPrototype);
        return groups;
    }
    var d3_select = function(s, n) {
        return n.querySelector(s);
    }, d3_selectAll = function(s, n) {
        return n.querySelectorAll(s);
    }, d3_selectRoot = d3_document.documentElement, d3_selectMatcher = d3_selectRoot.matchesSelector || d3_selectRoot.webkitMatchesSelector || d3_selectRoot.mozMatchesSelector || d3_selectRoot.msMatchesSelector || d3_selectRoot.oMatchesSelector, d3_selectMatches = function(n, s) {
        return d3_selectMatcher.call(n, s);
    };
    if (typeof Sizzle === "function") {
        d3_select = function(s, n) {
            return Sizzle(s, n)[0] || null;
        };
        d3_selectAll = function(s, n) {
            return Sizzle.uniqueSort(Sizzle(s, n));
        };
        d3_selectMatches = Sizzle.matchesSelector;
    }
    var d3_selectionPrototype = [];
    d3.selection = function() {
        return d3_selectionRoot;
    };
    d3.selection.prototype = d3_selectionPrototype;
    d3_selectionPrototype.select = function(selector) {
        var subgroups = [], subgroup, subnode, group, node;
        if (typeof selector !== "function") selector = d3_selection_selector(selector);
        for(var j = -1, m = this.length; ++j < m;){
            subgroups.push(subgroup = []);
            subgroup.parentNode = (group = this[j]).parentNode;
            for(var i = -1, n = group.length; ++i < n;)if (node = group[i]) {
                subgroup.push(subnode = selector.call(node, node.__data__, i));
                if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
            } else subgroup.push(null);
        }
        return d3_selection(subgroups);
    };
    function d3_selection_selector(selector) {
        return function() {
            return d3_select(selector, this);
        };
    }
    d3_selectionPrototype.selectAll = function(selector) {
        var subgroups = [], subgroup, node;
        if (typeof selector !== "function") selector = d3_selection_selectorAll(selector);
        for(var j = -1, m = this.length; ++j < m;){
            for(var group = this[j], i = -1, n = group.length; ++i < n;)if (node = group[i]) {
                subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i)));
                subgroup.parentNode = node;
            }
        }
        return d3_selection(subgroups);
    };
    function d3_selection_selectorAll(selector) {
        return function() {
            return d3_selectAll(selector, this);
        };
    }
    var d3_nsPrefix = {
        svg: "http://www.w3.org/2000/svg",
        xhtml: "http://www.w3.org/1999/xhtml",
        xlink: "http://www.w3.org/1999/xlink",
        xml: "http://www.w3.org/XML/1998/namespace",
        xmlns: "http://www.w3.org/2000/xmlns/"
    };
    d3.ns = {
        prefix: d3_nsPrefix,
        qualify: function(name) {
            var i = name.indexOf(":"), prefix = name;
            if (i >= 0) {
                prefix = name.substring(0, i);
                name = name.substring(i + 1);
            }
            return d3_nsPrefix.hasOwnProperty(prefix) ? {
                space: d3_nsPrefix[prefix],
                local: name
            } : name;
        }
    };
    d3_selectionPrototype.attr = function(name, value) {
        if (arguments.length < 2) {
            if (typeof name === "string") {
                var node = this.node();
                name = d3.ns.qualify(name);
                return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
            }
            for(value in name)this.each(d3_selection_attr(value, name[value]));
            return this;
        }
        return this.each(d3_selection_attr(name, value));
    };
    function d3_selection_attr(name, value) {
        name = d3.ns.qualify(name);
        function attrNull() {
            this.removeAttribute(name);
        }
        function attrNullNS() {
            this.removeAttributeNS(name.space, name.local);
        }
        function attrConstant() {
            this.setAttribute(name, value);
        }
        function attrConstantNS() {
            this.setAttributeNS(name.space, name.local, value);
        }
        function attrFunction() {
            var x = value.apply(this, arguments);
            if (x == null) this.removeAttribute(name);
            else this.setAttribute(name, x);
        }
        function attrFunctionNS() {
            var x = value.apply(this, arguments);
            if (x == null) this.removeAttributeNS(name.space, name.local);
            else this.setAttributeNS(name.space, name.local, x);
        }
        return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
    }
    function d3_collapse(s) {
        return s.trim().replace(/\s+/g, " ");
    }
    d3.requote = function(s) {
        return s.replace(d3_requote_re, "\\$&");
    };
    var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
    d3_selectionPrototype.classed = function(name, value) {
        if (arguments.length < 2) {
            if (typeof name === "string") {
                var node = this.node(), n = (name = name.trim().split(/^|\s+/g)).length, i = -1;
                if (value = node.classList) {
                    while(++i < n)if (!value.contains(name[i])) return false;
                } else {
                    value = node.getAttribute("class");
                    while(++i < n)if (!d3_selection_classedRe(name[i]).test(value)) return false;
                }
                return true;
            }
            for(value in name)this.each(d3_selection_classed(value, name[value]));
            return this;
        }
        return this.each(d3_selection_classed(name, value));
    };
    function d3_selection_classedRe(name) {
        return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
    }
    function d3_selection_classed(name, value) {
        name = name.trim().split(/\s+/).map(d3_selection_classedName);
        var n = name.length;
        function classedConstant() {
            var i = -1;
            while(++i < n)name[i](this, value);
        }
        function classedFunction() {
            var i = -1, x = value.apply(this, arguments);
            while(++i < n)name[i](this, x);
        }
        return typeof value === "function" ? classedFunction : classedConstant;
    }
    function d3_selection_classedName(name) {
        var re = d3_selection_classedRe(name);
        return function(node, value) {
            if (c = node.classList) return value ? c.add(name) : c.remove(name);
            var c = node.getAttribute("class") || "";
            if (value) {
                re.lastIndex = 0;
                if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
            } else node.setAttribute("class", d3_collapse(c.replace(re, " ")));
        };
    }
    d3_selectionPrototype.style = function(name, value, priority) {
        var n = arguments.length;
        if (n < 3) {
            if (typeof name !== "string") {
                if (n < 2) value = "";
                for(priority in name)this.each(d3_selection_style(priority, name[priority], value));
                return this;
            }
            if (n < 2) return d3_window.getComputedStyle(this.node(), null).getPropertyValue(name);
            priority = "";
        }
        return this.each(d3_selection_style(name, value, priority));
    };
    function d3_selection_style(name, value, priority) {
        function styleNull() {
            this.style.removeProperty(name);
        }
        function styleConstant() {
            this.style.setProperty(name, value, priority);
        }
        function styleFunction() {
            var x = value.apply(this, arguments);
            if (x == null) this.style.removeProperty(name);
            else this.style.setProperty(name, x, priority);
        }
        return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
    }
    d3_selectionPrototype.property = function(name, value) {
        if (arguments.length < 2) {
            if (typeof name === "string") return this.node()[name];
            for(value in name)this.each(d3_selection_property(value, name[value]));
            return this;
        }
        return this.each(d3_selection_property(name, value));
    };
    function d3_selection_property(name, value) {
        function propertyNull() {
            delete this[name];
        }
        function propertyConstant() {
            this[name] = value;
        }
        function propertyFunction() {
            var x = value.apply(this, arguments);
            if (x == null) delete this[name];
            else this[name] = x;
        }
        return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
    }
    d3_selectionPrototype.text = function(value) {
        return arguments.length ? this.each(typeof value === "function" ? function() {
            var v = value.apply(this, arguments);
            this.textContent = v == null ? "" : v;
        } : value == null ? function() {
            this.textContent = "";
        } : function() {
            this.textContent = value;
        }) : this.node().textContent;
    };
    d3_selectionPrototype.html = function(value) {
        return arguments.length ? this.each(typeof value === "function" ? function() {
            var v = value.apply(this, arguments);
            this.innerHTML = v == null ? "" : v;
        } : value == null ? function() {
            this.innerHTML = "";
        } : function() {
            this.innerHTML = value;
        }) : this.node().innerHTML;
    };
    d3_selectionPrototype.append = function(name) {
        name = d3.ns.qualify(name);
        function append() {
            return this.appendChild(d3_document.createElementNS(this.namespaceURI, name));
        }
        function appendNS() {
            return this.appendChild(d3_document.createElementNS(name.space, name.local));
        }
        return this.select(name.local ? appendNS : append);
    };
    d3_selectionPrototype.insert = function(name, before) {
        name = d3.ns.qualify(name);
        if (typeof before !== "function") before = d3_selection_selector(before);
        function insert(d, i) {
            return this.insertBefore(d3_document.createElementNS(this.namespaceURI, name), before.call(this, d, i));
        }
        function insertNS(d, i) {
            return this.insertBefore(d3_document.createElementNS(name.space, name.local), before.call(this, d, i));
        }
        return this.select(name.local ? insertNS : insert);
    };
    d3_selectionPrototype.remove = function() {
        return this.each(function() {
            var parent = this.parentNode;
            if (parent) parent.removeChild(this);
        });
    };
    d3_selectionPrototype.data = function(value, key) {
        var i = -1, n = this.length, group, node;
        if (!arguments.length) {
            value = new Array(n = (group = this[0]).length);
            while(++i < n)if (node = group[i]) value[i] = node.__data__;
            return value;
        }
        function bind(group, groupData) {
            var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
            if (key) {
                var nodeByKeyValue = new d3_Map(), dataByKeyValue = new d3_Map(), keyValues = [], keyValue;
                for(i = -1; ++i < n;){
                    keyValue = key.call(node = group[i], node.__data__, i);
                    if (nodeByKeyValue.has(keyValue)) exitNodes[i] = node;
                    else nodeByKeyValue.set(keyValue, node);
                    keyValues.push(keyValue);
                }
                for(i = -1; ++i < m;){
                    keyValue = key.call(groupData, nodeData = groupData[i], i);
                    if (node = nodeByKeyValue.get(keyValue)) {
                        updateNodes[i] = node;
                        node.__data__ = nodeData;
                    } else if (!dataByKeyValue.has(keyValue)) enterNodes[i] = d3_selection_dataNode(nodeData);
                    dataByKeyValue.set(keyValue, nodeData);
                    nodeByKeyValue.remove(keyValue);
                }
                for(i = -1; ++i < n;)if (nodeByKeyValue.has(keyValues[i])) exitNodes[i] = group[i];
            } else {
                for(i = -1; ++i < n0;){
                    node = group[i];
                    nodeData = groupData[i];
                    if (node) {
                        node.__data__ = nodeData;
                        updateNodes[i] = node;
                    } else enterNodes[i] = d3_selection_dataNode(nodeData);
                }
                for(; i < m; ++i)enterNodes[i] = d3_selection_dataNode(groupData[i]);
                for(; i < n; ++i)exitNodes[i] = group[i];
            }
            enterNodes.update = updateNodes;
            enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
            enter.push(enterNodes);
            update.push(updateNodes);
            exit.push(exitNodes);
        }
        var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
        if (typeof value === "function") while(++i < n)bind(group = this[i], value.call(group, group.parentNode.__data__, i));
        else while(++i < n)bind(group = this[i], value);
        update.enter = function() {
            return enter;
        };
        update.exit = function() {
            return exit;
        };
        return update;
    };
    function d3_selection_dataNode(data) {
        return {
            __data__: data
        };
    }
    d3_selectionPrototype.datum = function(value) {
        return arguments.length ? this.property("__data__", value) : this.property("__data__");
    };
    d3_selectionPrototype.filter = function(filter) {
        var subgroups = [], subgroup, group, node;
        if (typeof filter !== "function") filter = d3_selection_filter(filter);
        for(var j = 0, m = this.length; j < m; j++){
            subgroups.push(subgroup = []);
            subgroup.parentNode = (group = this[j]).parentNode;
            for(var i = 0, n = group.length; i < n; i++)if ((node = group[i]) && filter.call(node, node.__data__, i)) subgroup.push(node);
        }
        return d3_selection(subgroups);
    };
    function d3_selection_filter(selector) {
        return function() {
            return d3_selectMatches(this, selector);
        };
    }
    d3_selectionPrototype.order = function() {
        for(var j = -1, m = this.length; ++j < m;){
            for(var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0;)if (node = group[i]) {
                if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
                next = node;
            }
        }
        return this;
    };
    d3_selectionPrototype.sort = function(comparator) {
        comparator = d3_selection_sortComparator.apply(this, arguments);
        for(var j = -1, m = this.length; ++j < m;)this[j].sort(comparator);
        return this.order();
    };
    function d3_selection_sortComparator(comparator) {
        if (!arguments.length) comparator = d3.ascending;
        return function(a, b1) {
            return !a - !b1 || comparator(a.__data__, b1.__data__);
        };
    }
    function d3_noop() {}
    d3_selectionPrototype.on = function(type, listener, capture) {
        var n = arguments.length;
        if (n < 3) {
            if (typeof type !== "string") {
                if (n < 2) listener = false;
                for(capture in type)this.each(d3_selection_on(capture, type[capture], listener));
                return this;
            }
            if (n < 2) return (n = this.node()["__on" + type]) && n._;
            capture = false;
        }
        return this.each(d3_selection_on(type, listener, capture));
    };
    function d3_selection_on(type, listener, capture) {
        var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
        if (i > 0) type = type.substring(0, i);
        var filter = d3_selection_onFilters.get(type);
        if (filter) type = filter, wrap = d3_selection_onFilter;
        function onRemove() {
            var l = this[name];
            if (l) {
                this.removeEventListener(type, l, l.$);
                delete this[name];
            }
        }
        function onAdd() {
            var l = wrap(listener, d3_array(arguments));
            onRemove.call(this);
            this.addEventListener(type, this[name] = l, l.$ = capture);
            l._ = listener;
        }
        function removeAll() {
            var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
            for(var name in this)if (match = name.match(re)) {
                var l = this[name];
                this.removeEventListener(match[1], l, l.$);
                delete this[name];
            }
        }
        return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
    }
    var d3_selection_onFilters = d3.map({
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    });
    d3_selection_onFilters.forEach(function(k) {
        if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
    });
    function d3_selection_onListener(listener, argumentz) {
        return function(e) {
            var o = d3.event;
            d3.event = e;
            argumentz[0] = this.__data__;
            try {
                listener.apply(this, argumentz);
            } finally{
                d3.event = o;
            }
        };
    }
    function d3_selection_onFilter(listener, argumentz) {
        var l = d3_selection_onListener(listener, argumentz);
        return function(e) {
            var target = this, related = e.relatedTarget;
            if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) l.call(target, e);
        };
    }
    d3_selectionPrototype.each = function(callback) {
        return d3_selection_each(this, function(node, i, j) {
            callback.call(node, node.__data__, i, j);
        });
    };
    function d3_selection_each(groups, callback) {
        for(var j = 0, m = groups.length; j < m; j++){
            for(var group = groups[j], i = 0, n = group.length, node; i < n; i++)if (node = group[i]) callback(node, i, j);
        }
        return groups;
    }
    d3_selectionPrototype.call = function(callback) {
        var args = d3_array(arguments);
        callback.apply(args[0] = this, args);
        return this;
    };
    d3_selectionPrototype.empty = function() {
        return !this.node();
    };
    d3_selectionPrototype.node = function() {
        for(var j = 0, m = this.length; j < m; j++)for(var group = this[j], i = 0, n = group.length; i < n; i++){
            var node = group[i];
            if (node) return node;
        }
        return null;
    };
    function d3_selection_enter(selection) {
        d3_arraySubclass(selection, d3_selection_enterPrototype);
        return selection;
    }
    var d3_selection_enterPrototype = [];
    d3.selection.enter = d3_selection_enter;
    d3.selection.enter.prototype = d3_selection_enterPrototype;
    d3_selection_enterPrototype.append = d3_selectionPrototype.append;
    d3_selection_enterPrototype.insert = d3_selectionPrototype.insert;
    d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
    d3_selection_enterPrototype.node = d3_selectionPrototype.node;
    d3_selection_enterPrototype.select = function(selector) {
        var subgroups = [], subgroup, subnode, upgroup, group, node;
        for(var j = -1, m = this.length; ++j < m;){
            upgroup = (group = this[j]).update;
            subgroups.push(subgroup = []);
            subgroup.parentNode = group.parentNode;
            for(var i = -1, n = group.length; ++i < n;)if (node = group[i]) {
                subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i));
                subnode.__data__ = node.__data__;
            } else subgroup.push(null);
        }
        return d3_selection(subgroups);
    };
    d3_selectionPrototype.transition = function() {
        var id = d3_transitionInheritId || ++d3_transitionId, subgroups = [], subgroup, node, transition = Object.create(d3_transitionInherit);
        transition.time = Date.now();
        for(var j = -1, m = this.length; ++j < m;){
            subgroups.push(subgroup = []);
            for(var group = this[j], i = -1, n = group.length; ++i < n;){
                if (node = group[i]) d3_transitionNode(node, i, id, transition);
                subgroup.push(node);
            }
        }
        return d3_transition(subgroups, id);
    };
    var d3_selectionRoot = d3_selection([
        [
            d3_document
        ]
    ]);
    d3_selectionRoot[0].parentNode = d3_selectRoot;
    d3.select = function(selector) {
        return typeof selector === "string" ? d3_selectionRoot.select(selector) : d3_selection([
            [
                selector
            ]
        ]);
    };
    d3.selectAll = function(selector) {
        return typeof selector === "string" ? d3_selectionRoot.selectAll(selector) : d3_selection([
            d3_array(selector)
        ]);
    };
    d3.behavior.zoom = function() {
        var translate = [
            0,
            0
        ], translate0, scale = 1, scale0, scaleExtent = d3_behavior_zoomInfinity, event = d3_eventDispatch(zoom, "zoom"), x0, x1, y0, y1, touchtime;
        function zoom() {
            this.on("mousedown.zoom", mousedown).on("mousemove.zoom", mousemove).on(d3_behavior_zoomWheel + ".zoom", mousewheel).on("dblclick.zoom", dblclick).on("touchstart.zoom", touchstart).on("touchmove.zoom", touchmove).on("touchend.zoom", touchstart);
        }
        zoom.translate = function(x) {
            if (!arguments.length) return translate;
            translate = x.map(Number);
            rescale();
            return zoom;
        };
        zoom.scale = function(x) {
            if (!arguments.length) return scale;
            scale = +x;
            rescale();
            return zoom;
        };
        zoom.scaleExtent = function(x) {
            if (!arguments.length) return scaleExtent;
            scaleExtent = x == null ? d3_behavior_zoomInfinity : x.map(Number);
            return zoom;
        };
        zoom.x = function(z) {
            if (!arguments.length) return x1;
            x1 = z;
            x0 = z.copy();
            translate = [
                0,
                0
            ];
            scale = 1;
            return zoom;
        };
        zoom.y = function(z) {
            if (!arguments.length) return y1;
            y1 = z;
            y0 = z.copy();
            translate = [
                0,
                0
            ];
            scale = 1;
            return zoom;
        };
        function location(p) {
            return [
                (p[0] - translate[0]) / scale,
                (p[1] - translate[1]) / scale
            ];
        }
        function point(l) {
            return [
                l[0] * scale + translate[0],
                l[1] * scale + translate[1]
            ];
        }
        function scaleTo(s) {
            scale = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
        }
        function translateTo(p, l) {
            l = point(l);
            translate[0] += p[0] - l[0];
            translate[1] += p[1] - l[1];
        }
        function rescale() {
            if (x1) x1.domain(x0.range().map(function(x) {
                return (x - translate[0]) / scale;
            }).map(x0.invert));
            if (y1) y1.domain(y0.range().map(function(y) {
                return (y - translate[1]) / scale;
            }).map(y0.invert));
        }
        function dispatch(event) {
            rescale();
            d3.event.preventDefault();
            event({
                type: "zoom",
                scale: scale,
                translate: translate
            });
        }
        function mousedown() {
            var target = this, event_ = event.of(target, arguments), eventTarget = d3.event.target, moved = 0, w = d3.select(d3_window).on("mousemove.zoom", mousemove).on("mouseup.zoom", mouseup), l = location(d3.mouse(target));
            d3_window.focus();
            d3_eventCancel();
            function mousemove() {
                moved = 1;
                translateTo(d3.mouse(target), l);
                dispatch(event_);
            }
            function mouseup() {
                if (moved) d3_eventCancel();
                w.on("mousemove.zoom", null).on("mouseup.zoom", null);
                if (moved && d3.event.target === eventTarget) d3_eventSuppress(w, "click.zoom");
            }
        }
        function mousewheel() {
            if (!translate0) translate0 = location(d3.mouse(this));
            scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * scale);
            translateTo(d3.mouse(this), translate0);
            dispatch(event.of(this, arguments));
        }
        function mousemove() {
            translate0 = null;
        }
        function dblclick() {
            var p = d3.mouse(this), l = location(p), k = Math.log(scale) / Math.LN2;
            scaleTo(Math.pow(2, d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1));
            translateTo(p, l);
            dispatch(event.of(this, arguments));
        }
        function touchstart() {
            var touches = d3.touches(this), now = Date.now();
            scale0 = scale;
            translate0 = {};
            touches.forEach(function(t) {
                translate0[t.identifier] = location(t);
            });
            d3_eventCancel();
            if (touches.length === 1) {
                if (now - touchtime < 500) {
                    var p = touches[0], l = location(touches[0]);
                    scaleTo(scale * 2);
                    translateTo(p, l);
                    dispatch(event.of(this, arguments));
                }
                touchtime = now;
            }
        }
        function touchmove() {
            var touches = d3.touches(this), p0 = touches[0], l0 = translate0[p0.identifier];
            if (p1 = touches[1]) {
                var p1, l1 = translate0[p1.identifier];
                p0 = [
                    (p0[0] + p1[0]) / 2,
                    (p0[1] + p1[1]) / 2
                ];
                l0 = [
                    (l0[0] + l1[0]) / 2,
                    (l0[1] + l1[1]) / 2
                ];
                scaleTo(d3.event.scale * scale0);
            }
            translateTo(p0, l0);
            touchtime = null;
            dispatch(event.of(this, arguments));
        }
        return d3.rebind(zoom, event, "on");
    };
    var d3_behavior_zoomInfinity = [
        0,
        Infinity
    ];
    var d3_behavior_zoomDelta, d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
    }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
        return d3.event.wheelDelta;
    }, "mousewheel") : (d3_behavior_zoomDelta = function() {
        return -d3.event.detail;
    }, "MozMousePixelScroll");
    function d3_Color() {}
    d3_Color.prototype.toString = function() {
        return this.rgb() + "";
    };
    d3.hsl = function(h, s, l) {
        return arguments.length === 1 ? h instanceof d3_Hsl ? d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : d3_hsl(+h, +s, +l);
    };
    function d3_hsl(h, s, l) {
        return new d3_Hsl(h, s, l);
    }
    function d3_Hsl(h, s, l) {
        this.h = h;
        this.s = s;
        this.l = l;
    }
    var d3_hslPrototype = d3_Hsl.prototype = new d3_Color();
    d3_hslPrototype.brighter = function(k) {
        k = Math.pow(.7, arguments.length ? k : 1);
        return d3_hsl(this.h, this.s, this.l / k);
    };
    d3_hslPrototype.darker = function(k) {
        k = Math.pow(.7, arguments.length ? k : 1);
        return d3_hsl(this.h, this.s, k * this.l);
    };
    d3_hslPrototype.rgb = function() {
        return d3_hsl_rgb(this.h, this.s, this.l);
    };
    function d3_hsl_rgb(h, s, l) {
        var m1, m2;
        h = h % 360;
        if (h < 0) h += 360;
        s = s < 0 ? 0 : s > 1 ? 1 : s;
        l = l < 0 ? 0 : l > 1 ? 1 : l;
        m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
        m1 = 2 * l - m2;
        function v(h) {
            if (h > 360) h -= 360;
            else if (h < 0) h += 360;
            if (h < 60) return m1 + (m2 - m1) * h / 60;
            if (h < 180) return m2;
            if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
            return m1;
        }
        function vv(h) {
            return Math.round(v(h) * 255);
        }
        return d3_rgb(vv(h + 120), vv(h), vv(h - 120));
    }
    var \u03C0 = Math.PI, \u03B5 = 1e-6, d3_radians = \u03C0 / 180, d3_degrees = 180 / \u03C0;
    function d3_sgn(x) {
        return x > 0 ? 1 : x < 0 ? -1 : 0;
    }
    function d3_acos(x) {
        return Math.acos(Math.max(-1, Math.min(1, x)));
    }
    function d3_asin(x) {
        return x > 1 ? \u03C0 / 2 : x < -1 ? -\u03C0 / 2 : Math.asin(x);
    }
    function d3_sinh(x) {
        return (Math.exp(x) - Math.exp(-x)) / 2;
    }
    function d3_cosh(x) {
        return (Math.exp(x) + Math.exp(-x)) / 2;
    }
    function d3_haversin(x) {
        return (x = Math.sin(x / 2)) * x;
    }
    d3.hcl = function(h, c, l) {
        return arguments.length === 1 ? h instanceof d3_Hcl ? d3_hcl(h.h, h.c, h.l) : h instanceof d3_Lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : d3_hcl(+h, +c, +l);
    };
    function d3_hcl(h, c, l) {
        return new d3_Hcl(h, c, l);
    }
    function d3_Hcl(h, c, l) {
        this.h = h;
        this.c = c;
        this.l = l;
    }
    var d3_hclPrototype = d3_Hcl.prototype = new d3_Color();
    d3_hclPrototype.brighter = function(k) {
        return d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
    };
    d3_hclPrototype.darker = function(k) {
        return d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
    };
    d3_hclPrototype.rgb = function() {
        return d3_hcl_lab(this.h, this.c, this.l).rgb();
    };
    function d3_hcl_lab(h, c, l) {
        return d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
    }
    d3.lab = function(l, a, b1) {
        return arguments.length === 1 ? l instanceof d3_Lab ? d3_lab(l.l, l.a, l.b) : l instanceof d3_Hcl ? d3_hcl_lab(l.l, l.c, l.h) : d3_rgb_lab((l = d3.rgb(l)).r, l.g, l.b) : d3_lab(+l, +a, +b1);
    };
    function d3_lab(l, a, b1) {
        return new d3_Lab(l, a, b1);
    }
    function d3_Lab(l, a, b1) {
        this.l = l;
        this.a = a;
        this.b = b1;
    }
    var d3_lab_K = 18;
    var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
    var d3_labPrototype = d3_Lab.prototype = new d3_Color();
    d3_labPrototype.brighter = function(k) {
        return d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
    };
    d3_labPrototype.darker = function(k) {
        return d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
    };
    d3_labPrototype.rgb = function() {
        return d3_lab_rgb(this.l, this.a, this.b);
    };
    function d3_lab_rgb(l, a, b1) {
        var y = (l + 16) / 116, x = y + a / 500, z = y - b1 / 200;
        x = d3_lab_xyz(x) * d3_lab_X;
        y = d3_lab_xyz(y) * d3_lab_Y;
        z = d3_lab_xyz(z) * d3_lab_Z;
        return d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-0.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
    }
    function d3_lab_hcl(l, a, b1) {
        return d3_hcl(Math.atan2(b1, a) * d3_degrees, Math.sqrt(a * a + b1 * b1), l);
    }
    function d3_lab_xyz(x) {
        return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
    }
    function d3_xyz_lab(x) {
        return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
    }
    function d3_xyz_rgb(r) {
        return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
    }
    d3.rgb = function(r, g, b1) {
        return arguments.length === 1 ? r instanceof d3_Rgb ? d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : d3_rgb(~~r, ~~g, ~~b1);
    };
    function d3_rgb(r, g, b1) {
        return new d3_Rgb(r, g, b1);
    }
    function d3_Rgb(r, g, b1) {
        this.r = r;
        this.g = g;
        this.b = b1;
    }
    var d3_rgbPrototype = d3_Rgb.prototype = new d3_Color();
    d3_rgbPrototype.brighter = function(k) {
        k = Math.pow(.7, arguments.length ? k : 1);
        var r = this.r, g = this.g, b1 = this.b, i = 30;
        if (!r && !g && !b1) return d3_rgb(i, i, i);
        if (r && r < i) r = i;
        if (g && g < i) g = i;
        if (b1 && b1 < i) b1 = i;
        return d3_rgb(Math.min(255, Math.floor(r / k)), Math.min(255, Math.floor(g / k)), Math.min(255, Math.floor(b1 / k)));
    };
    d3_rgbPrototype.darker = function(k) {
        k = Math.pow(.7, arguments.length ? k : 1);
        return d3_rgb(Math.floor(k * this.r), Math.floor(k * this.g), Math.floor(k * this.b));
    };
    d3_rgbPrototype.hsl = function() {
        return d3_rgb_hsl(this.r, this.g, this.b);
    };
    d3_rgbPrototype.toString = function() {
        return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
    };
    function d3_rgb_hex(v) {
        return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
    }
    function d3_rgb_parse(format, rgb, hsl) {
        var r = 0, g = 0, b1 = 0, m1, m2, name;
        m1 = /([a-z]+)\((.*)\)/i.exec(format);
        if (m1) {
            m2 = m1[2].split(",");
            switch(m1[1]){
                case "hsl":
                    return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
                case "rgb":
                    return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
            }
        }
        if (name = d3_rgb_names.get(format)) return rgb(name.r, name.g, name.b);
        if (format != null && format.charAt(0) === "#") {
            if (format.length === 4) {
                r = format.charAt(1);
                r += r;
                g = format.charAt(2);
                g += g;
                b1 = format.charAt(3);
                b1 += b1;
            } else if (format.length === 7) {
                r = format.substring(1, 3);
                g = format.substring(3, 5);
                b1 = format.substring(5, 7);
            }
            r = parseInt(r, 16);
            g = parseInt(g, 16);
            b1 = parseInt(b1, 16);
        }
        return rgb(r, g, b1);
    }
    function d3_rgb_hsl(r, g, b1) {
        var min = Math.min(r /= 255, g /= 255, b1 /= 255), max = Math.max(r, g, b1), d = max - min, h, s, l = (max + min) / 2;
        if (d) {
            s = l < .5 ? d / (max + min) : d / (2 - max - min);
            if (r == max) h = (g - b1) / d + (g < b1 ? 6 : 0);
            else if (g == max) h = (b1 - r) / d + 2;
            else h = (r - g) / d + 4;
            h *= 60;
        } else s = h = 0;
        return d3_hsl(h, s, l);
    }
    function d3_rgb_lab(r, g, b1) {
        r = d3_rgb_xyz(r);
        g = d3_rgb_xyz(g);
        b1 = d3_rgb_xyz(b1);
        var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b1) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b1) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b1) / d3_lab_Z);
        return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
    }
    function d3_rgb_xyz(r) {
        return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
    }
    function d3_rgb_parseNumber(c) {
        var f = parseFloat(c);
        return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
    }
    var d3_rgb_names = d3.map({
        aliceblue: "#f0f8ff",
        antiquewhite: "#faebd7",
        aqua: "#00ffff",
        aquamarine: "#7fffd4",
        azure: "#f0ffff",
        beige: "#f5f5dc",
        bisque: "#ffe4c4",
        black: "#000000",
        blanchedalmond: "#ffebcd",
        blue: "#0000ff",
        blueviolet: "#8a2be2",
        brown: "#a52a2a",
        burlywood: "#deb887",
        cadetblue: "#5f9ea0",
        chartreuse: "#7fff00",
        chocolate: "#d2691e",
        coral: "#ff7f50",
        cornflowerblue: "#6495ed",
        cornsilk: "#fff8dc",
        crimson: "#dc143c",
        cyan: "#00ffff",
        darkblue: "#00008b",
        darkcyan: "#008b8b",
        darkgoldenrod: "#b8860b",
        darkgray: "#a9a9a9",
        darkgreen: "#006400",
        darkgrey: "#a9a9a9",
        darkkhaki: "#bdb76b",
        darkmagenta: "#8b008b",
        darkolivegreen: "#556b2f",
        darkorange: "#ff8c00",
        darkorchid: "#9932cc",
        darkred: "#8b0000",
        darksalmon: "#e9967a",
        darkseagreen: "#8fbc8f",
        darkslateblue: "#483d8b",
        darkslategray: "#2f4f4f",
        darkslategrey: "#2f4f4f",
        darkturquoise: "#00ced1",
        darkviolet: "#9400d3",
        deeppink: "#ff1493",
        deepskyblue: "#00bfff",
        dimgray: "#696969",
        dimgrey: "#696969",
        dodgerblue: "#1e90ff",
        firebrick: "#b22222",
        floralwhite: "#fffaf0",
        forestgreen: "#228b22",
        fuchsia: "#ff00ff",
        gainsboro: "#dcdcdc",
        ghostwhite: "#f8f8ff",
        gold: "#ffd700",
        goldenrod: "#daa520",
        gray: "#808080",
        green: "#008000",
        greenyellow: "#adff2f",
        grey: "#808080",
        honeydew: "#f0fff0",
        hotpink: "#ff69b4",
        indianred: "#cd5c5c",
        indigo: "#4b0082",
        ivory: "#fffff0",
        khaki: "#f0e68c",
        lavender: "#e6e6fa",
        lavenderblush: "#fff0f5",
        lawngreen: "#7cfc00",
        lemonchiffon: "#fffacd",
        lightblue: "#add8e6",
        lightcoral: "#f08080",
        lightcyan: "#e0ffff",
        lightgoldenrodyellow: "#fafad2",
        lightgray: "#d3d3d3",
        lightgreen: "#90ee90",
        lightgrey: "#d3d3d3",
        lightpink: "#ffb6c1",
        lightsalmon: "#ffa07a",
        lightseagreen: "#20b2aa",
        lightskyblue: "#87cefa",
        lightslategray: "#778899",
        lightslategrey: "#778899",
        lightsteelblue: "#b0c4de",
        lightyellow: "#ffffe0",
        lime: "#00ff00",
        limegreen: "#32cd32",
        linen: "#faf0e6",
        magenta: "#ff00ff",
        maroon: "#800000",
        mediumaquamarine: "#66cdaa",
        mediumblue: "#0000cd",
        mediumorchid: "#ba55d3",
        mediumpurple: "#9370db",
        mediumseagreen: "#3cb371",
        mediumslateblue: "#7b68ee",
        mediumspringgreen: "#00fa9a",
        mediumturquoise: "#48d1cc",
        mediumvioletred: "#c71585",
        midnightblue: "#191970",
        mintcream: "#f5fffa",
        mistyrose: "#ffe4e1",
        moccasin: "#ffe4b5",
        navajowhite: "#ffdead",
        navy: "#000080",
        oldlace: "#fdf5e6",
        olive: "#808000",
        olivedrab: "#6b8e23",
        orange: "#ffa500",
        orangered: "#ff4500",
        orchid: "#da70d6",
        palegoldenrod: "#eee8aa",
        palegreen: "#98fb98",
        paleturquoise: "#afeeee",
        palevioletred: "#db7093",
        papayawhip: "#ffefd5",
        peachpuff: "#ffdab9",
        peru: "#cd853f",
        pink: "#ffc0cb",
        plum: "#dda0dd",
        powderblue: "#b0e0e6",
        purple: "#800080",
        red: "#ff0000",
        rosybrown: "#bc8f8f",
        royalblue: "#4169e1",
        saddlebrown: "#8b4513",
        salmon: "#fa8072",
        sandybrown: "#f4a460",
        seagreen: "#2e8b57",
        seashell: "#fff5ee",
        sienna: "#a0522d",
        silver: "#c0c0c0",
        skyblue: "#87ceeb",
        slateblue: "#6a5acd",
        slategray: "#708090",
        slategrey: "#708090",
        snow: "#fffafa",
        springgreen: "#00ff7f",
        steelblue: "#4682b4",
        tan: "#d2b48c",
        teal: "#008080",
        thistle: "#d8bfd8",
        tomato: "#ff6347",
        turquoise: "#40e0d0",
        violet: "#ee82ee",
        wheat: "#f5deb3",
        white: "#ffffff",
        whitesmoke: "#f5f5f5",
        yellow: "#ffff00",
        yellowgreen: "#9acd32"
    });
    d3_rgb_names.forEach(function(key, value) {
        d3_rgb_names.set(key, d3_rgb_parse(value, d3_rgb, d3_hsl_rgb));
    });
    function d3_functor(v) {
        return typeof v === "function" ? v : function() {
            return v;
        };
    }
    d3.functor = d3_functor;
    function d3_identity(d) {
        return d;
    }
    d3.xhr = function(url, mimeType, callback) {
        var xhr = {}, dispatch = d3.dispatch("progress", "load", "error"), headers = {}, response = d3_identity, request = new (d3_window.XDomainRequest && /^(http(s)?:)?\/\//.test(url) ? XDomainRequest : XMLHttpRequest)();
        "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
            request.readyState > 3 && respond();
        };
        function respond() {
            var s = request.status;
            !s && request.responseText || s >= 200 && s < 300 || s === 304 ? dispatch.load.call(xhr, response.call(xhr, request)) : dispatch.error.call(xhr, request);
        }
        request.onprogress = function(event) {
            var o = d3.event;
            d3.event = event;
            try {
                dispatch.progress.call(xhr, request);
            } finally{
                d3.event = o;
            }
        };
        xhr.header = function(name, value) {
            name = (name + "").toLowerCase();
            if (arguments.length < 2) return headers[name];
            if (value == null) delete headers[name];
            else headers[name] = value + "";
            return xhr;
        };
        xhr.mimeType = function(value) {
            if (!arguments.length) return mimeType;
            mimeType = value == null ? null : value + "";
            return xhr;
        };
        xhr.response = function(value) {
            response = value;
            return xhr;
        };
        [
            "get",
            "post"
        ].forEach(function(method) {
            xhr[method] = function() {
                return xhr.send.apply(xhr, [
                    method
                ].concat(d3_array(arguments)));
            };
        });
        xhr.send = function(method, data, callback) {
            if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
            request.open(method, url, true);
            if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
            if (request.setRequestHeader) for(var name in headers)request.setRequestHeader(name, headers[name]);
            if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
            if (callback != null) xhr.on("error", callback).on("load", function(request) {
                callback(null, request);
            });
            request.send(data == null ? null : data);
            return xhr;
        };
        xhr.abort = function() {
            request.abort();
            return xhr;
        };
        d3.rebind(xhr, dispatch, "on");
        if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, mimeType = null;
        return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
    };
    function d3_xhr_fixCallback(callback) {
        return callback.length === 1 ? function(error, request) {
            callback(error == null ? request : null);
        } : callback;
    }
    function d3_dsv(delimiter, mimeType) {
        var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
        function dsv(url, row, callback) {
            if (arguments.length < 3) callback = row, row = null;
            var xhr = d3.xhr(url, mimeType, callback);
            xhr.row = function(_) {
                return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
            };
            return xhr.row(row);
        }
        function response(request) {
            return dsv.parse(request.responseText);
        }
        function typedResponse(f) {
            return function(request) {
                return dsv.parse(request.responseText, f);
            };
        }
        dsv.parse = function(text, f) {
            var o;
            return dsv.parseRows(text, function(row, i) {
                if (o) return o(row, i - 1);
                var a = new Function("d", "return {" + row.map(function(name, i) {
                    return JSON.stringify(name) + ": d[" + i + "]";
                }).join(",") + "}");
                o = f ? function(row, i) {
                    return f(a(row), i);
                } : a;
            });
        };
        dsv.parseRows = function(text, f) {
            var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
            function token() {
                if (I >= N) return EOF;
                if (eol) return eol = false, EOL;
                var j = I;
                if (text.charCodeAt(j) === 34) {
                    var i = j;
                    while(i++ < N)if (text.charCodeAt(i) === 34) {
                        if (text.charCodeAt(i + 1) !== 34) break;
                        ++i;
                    }
                    I = i + 2;
                    var c = text.charCodeAt(i + 1);
                    if (c === 13) {
                        eol = true;
                        if (text.charCodeAt(i + 2) === 10) ++I;
                    } else if (c === 10) eol = true;
                    return text.substring(j + 1, i).replace(/""/g, '"');
                }
                while(I < N){
                    var c = text.charCodeAt(I++), k = 1;
                    if (c === 10) eol = true;
                    else if (c === 13) {
                        eol = true;
                        if (text.charCodeAt(I) === 10) ++I, ++k;
                    } else if (c !== delimiterCode) continue;
                    return text.substring(j, I - k);
                }
                return text.substring(j);
            }
            while((t = token()) !== EOF){
                var a = [];
                while(t !== EOL && t !== EOF){
                    a.push(t);
                    t = token();
                }
                if (f && !(a = f(a, n++))) continue;
                rows.push(a);
            }
            return rows;
        };
        dsv.format = function(rows) {
            if (Array.isArray(rows[0])) return dsv.formatRows(rows);
            var fieldSet = new d3_Set(), fields = [];
            rows.forEach(function(row) {
                for(var field in row)if (!fieldSet.has(field)) fields.push(fieldSet.add(field));
            });
            return [
                fields.map(formatValue).join(delimiter)
            ].concat(rows.map(function(row) {
                return fields.map(function(field) {
                    return formatValue(row[field]);
                }).join(delimiter);
            })).join("\n");
        };
        dsv.formatRows = function(rows) {
            return rows.map(formatRow).join("\n");
        };
        function formatRow(row) {
            return row.map(formatValue).join(delimiter);
        }
        function formatValue(text) {
            return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
        }
        return dsv;
    }
    d3.csv = d3_dsv(",", "text/csv");
    d3.tsv = d3_dsv("	", "text/tab-separated-values");
    var d3_timer_id = 0, d3_timer_byId = {}, d3_timer_queue = null, d3_timer_interval, d3_timer_timeout;
    d3.timer = function(callback, delay, then) {
        if (arguments.length < 3) {
            if (arguments.length < 2) delay = 0;
            else if (!isFinite(delay)) return;
            then = Date.now();
        }
        var timer = d3_timer_byId[callback.id];
        if (timer && timer.callback === callback) {
            timer.then = then;
            timer.delay = delay;
        } else d3_timer_byId[callback.id = ++d3_timer_id] = d3_timer_queue = {
            callback: callback,
            then: then,
            delay: delay,
            next: d3_timer_queue
        };
        if (!d3_timer_interval) {
            d3_timer_timeout = clearTimeout(d3_timer_timeout);
            d3_timer_interval = 1;
            d3_timer_frame(d3_timer_step);
        }
    };
    function d3_timer_step() {
        var elapsed, now = Date.now(), t1 = d3_timer_queue;
        while(t1){
            elapsed = now - t1.then;
            if (elapsed >= t1.delay) t1.flush = t1.callback(elapsed);
            t1 = t1.next;
        }
        var delay = d3_timer_flush() - now;
        if (delay > 24) {
            if (isFinite(delay)) {
                clearTimeout(d3_timer_timeout);
                d3_timer_timeout = setTimeout(d3_timer_step, delay);
            }
            d3_timer_interval = 0;
        } else {
            d3_timer_interval = 1;
            d3_timer_frame(d3_timer_step);
        }
    }
    d3.timer.flush = function() {
        var elapsed, now = Date.now(), t1 = d3_timer_queue;
        while(t1){
            elapsed = now - t1.then;
            if (!t1.delay) t1.flush = t1.callback(elapsed);
            t1 = t1.next;
        }
        d3_timer_flush();
    };
    function d3_timer_flush() {
        var t0 = null, t1 = d3_timer_queue, then = Infinity;
        while(t1)if (t1.flush) {
            delete d3_timer_byId[t1.callback.id];
            t1 = t0 ? t0.next = t1.next : d3_timer_queue = t1.next;
        } else {
            then = Math.min(then, t1.then + t1.delay);
            t1 = (t0 = t1).next;
        }
        return then;
    }
    var d3_timer_frame = d3_window.requestAnimationFrame || d3_window.webkitRequestAnimationFrame || d3_window.mozRequestAnimationFrame || d3_window.oRequestAnimationFrame || d3_window.msRequestAnimationFrame || function(callback) {
        setTimeout(callback, 17);
    };
    var d3_format_decimalPoint = ".", d3_format_thousandsSeparator = ",", d3_format_grouping = [
        3,
        3
    ];
    var d3_formatPrefixes = [
        "y",
        "z",
        "a",
        "f",
        "p",
        "n",
        "\xb5",
        "m",
        "",
        "k",
        "M",
        "G",
        "T",
        "P",
        "E",
        "Z",
        "Y"
    ].map(d3_formatPrefix);
    d3.formatPrefix = function(value, precision) {
        var i = 0;
        if (value) {
            if (value < 0) value *= -1;
            if (precision) value = d3.round(value, d3_format_precision(value, precision));
            i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
            i = Math.max(-24, Math.min(24, Math.floor((i <= 0 ? i + 1 : i - 1) / 3) * 3));
        }
        return d3_formatPrefixes[8 + i / 3];
    };
    function d3_formatPrefix(d, i) {
        var k = Math.pow(10, Math.abs(8 - i) * 3);
        return {
            scale: i > 8 ? function(d) {
                return d / k;
            } : function(d) {
                return d * k;
            },
            symbol: d
        };
    }
    d3.round = function(x, n) {
        return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
    };
    d3.format = function(specifier) {
        var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "", basePrefix = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, suffix = "", integer = false;
        if (precision) precision = +precision.substring(1);
        if (zfill || fill === "0" && align === "=") {
            zfill = fill = "0";
            align = "=";
            if (comma) width -= Math.floor((width - 1) / 4);
        }
        switch(type){
            case "n":
                comma = true;
                type = "g";
                break;
            case "%":
                scale = 100;
                suffix = "%";
                type = "f";
                break;
            case "p":
                scale = 100;
                suffix = "%";
                type = "r";
                break;
            case "b":
            case "o":
            case "x":
            case "X":
                if (basePrefix) basePrefix = "0" + type.toLowerCase();
            case "c":
            case "d":
                integer = true;
                precision = 0;
                break;
            case "s":
                scale = -1;
                type = "r";
                break;
        }
        if (basePrefix === "#") basePrefix = "";
        if (type == "r" && !precision) type = "g";
        if (precision != null) {
            if (type == "g") precision = Math.max(1, Math.min(21, precision));
            else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
        }
        type = d3_format_types.get(type) || d3_format_typeDefault;
        var zcomma = zfill && comma;
        return function(value) {
            if (integer && value % 1) return "";
            var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign;
            if (scale < 0) {
                var prefix = d3.formatPrefix(value, precision);
                value = prefix.scale(value);
                suffix = prefix.symbol;
            } else value *= scale;
            value = type(value, precision);
            if (!zfill && comma) value = d3_format_group(value);
            var length = basePrefix.length + value.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
            if (zcomma) value = d3_format_group(padding + value);
            if (d3_format_decimalPoint) value.replace(".", d3_format_decimalPoint);
            negative += basePrefix;
            return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + suffix;
        };
    };
    var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?(#)?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
    var d3_format_types = d3.map({
        b: function(x) {
            return x.toString(2);
        },
        c: function(x) {
            return String.fromCharCode(x);
        },
        o: function(x) {
            return x.toString(8);
        },
        x: function(x) {
            return x.toString(16);
        },
        X: function(x) {
            return x.toString(16).toUpperCase();
        },
        g: function(x, p) {
            return x.toPrecision(p);
        },
        e: function(x, p) {
            return x.toExponential(p);
        },
        f: function(x, p) {
            return x.toFixed(p);
        },
        r: function(x, p) {
            return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
        }
    });
    function d3_format_precision(x, p) {
        return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
    }
    function d3_format_typeDefault(x) {
        return x + "";
    }
    var d3_format_group = d3_identity;
    if (d3_format_grouping) {
        var d3_format_groupingLength = d3_format_grouping.length;
        d3_format_group = function(value) {
            var i = value.lastIndexOf("."), f = i >= 0 ? "." + value.substring(i + 1) : (i = value.length, ""), t = [], j = 0, g = d3_format_grouping[0];
            while(i > 0 && g > 0){
                t.push(value.substring(i -= g, i + g));
                g = d3_format_grouping[j = (j + 1) % d3_format_groupingLength];
            }
            return t.reverse().join(d3_format_thousandsSeparator || "") + f;
        };
    }
    d3.geo = {};
    d3.geo.stream = function(object, listener) {
        if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) d3_geo_streamObjectType[object.type](object, listener);
        else d3_geo_streamGeometry(object, listener);
    };
    function d3_geo_streamGeometry(geometry, listener) {
        if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) d3_geo_streamGeometryType[geometry.type](geometry, listener);
    }
    var d3_geo_streamObjectType = {
        Feature: function(feature, listener) {
            d3_geo_streamGeometry(feature.geometry, listener);
        },
        FeatureCollection: function(object, listener) {
            var features = object.features, i = -1, n = features.length;
            while(++i < n)d3_geo_streamGeometry(features[i].geometry, listener);
        }
    };
    var d3_geo_streamGeometryType = {
        Sphere: function(object, listener) {
            listener.sphere();
        },
        Point: function(object, listener) {
            var coordinate = object.coordinates;
            listener.point(coordinate[0], coordinate[1]);
        },
        MultiPoint: function(object, listener) {
            var coordinates = object.coordinates, i = -1, n = coordinates.length, coordinate;
            while(++i < n)coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1]);
        },
        LineString: function(object, listener) {
            d3_geo_streamLine(object.coordinates, listener, 0);
        },
        MultiLineString: function(object, listener) {
            var coordinates = object.coordinates, i = -1, n = coordinates.length;
            while(++i < n)d3_geo_streamLine(coordinates[i], listener, 0);
        },
        Polygon: function(object, listener) {
            d3_geo_streamPolygon(object.coordinates, listener);
        },
        MultiPolygon: function(object, listener) {
            var coordinates = object.coordinates, i = -1, n = coordinates.length;
            while(++i < n)d3_geo_streamPolygon(coordinates[i], listener);
        },
        GeometryCollection: function(object, listener) {
            var geometries = object.geometries, i = -1, n = geometries.length;
            while(++i < n)d3_geo_streamGeometry(geometries[i], listener);
        }
    };
    function d3_geo_streamLine(coordinates, listener, closed) {
        var i = -1, n = coordinates.length - closed, coordinate;
        listener.lineStart();
        while(++i < n)coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1]);
        listener.lineEnd();
    }
    function d3_geo_streamPolygon(coordinates, listener) {
        var i = -1, n = coordinates.length;
        listener.polygonStart();
        while(++i < n)d3_geo_streamLine(coordinates[i], listener, 1);
        listener.polygonEnd();
    }
    d3.geo.area = function(object) {
        d3_geo_areaSum = 0;
        d3.geo.stream(object, d3_geo_area);
        return d3_geo_areaSum;
    };
    var d3_geo_areaSum, d3_geo_areaRingU, d3_geo_areaRingV;
    var d3_geo_area = {
        sphere: function() {
            d3_geo_areaSum += 4 * \u03C0;
        },
        point: d3_noop,
        lineStart: d3_noop,
        lineEnd: d3_noop,
        polygonStart: function() {
            d3_geo_areaRingU = 1, d3_geo_areaRingV = 0;
            d3_geo_area.lineStart = d3_geo_areaRingStart;
        },
        polygonEnd: function() {
            var area = 2 * Math.atan2(d3_geo_areaRingV, d3_geo_areaRingU);
            d3_geo_areaSum += area < 0 ? 4 * \u03C0 + area : area;
            d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
        }
    };
    function d3_geo_areaRingStart() {
        var \u03BB00, \u03C600, \u03BB0, cos\u03C60, sin\u03C60;
        d3_geo_area.point = function(\u03BB, \u03C6) {
            d3_geo_area.point = nextPoint;
            \u03BB0 = (\u03BB00 = \u03BB) * d3_radians, cos\u03C60 = Math.cos(\u03C6 = (\u03C600 = \u03C6) * d3_radians / 2 + \u03C0 / 4), sin\u03C60 = Math.sin(\u03C6);
        };
        function nextPoint(\u03BB, \u03C6) {
            \u03BB *= d3_radians;
            \u03C6 = \u03C6 * d3_radians / 2 + \u03C0 / 4;
            var d\u03BB = \u03BB - \u03BB0, cos\u03C6 = Math.cos(\u03C6), sin\u03C6 = Math.sin(\u03C6), k = sin\u03C60 * sin\u03C6, u0 = d3_geo_areaRingU, v0 = d3_geo_areaRingV, u = cos\u03C60 * cos\u03C6 + k * Math.cos(d\u03BB), v = k * Math.sin(d\u03BB);
            d3_geo_areaRingU = u0 * u - v0 * v;
            d3_geo_areaRingV = v0 * u + u0 * v;
            \u03BB0 = \u03BB, cos\u03C60 = cos\u03C6, sin\u03C60 = sin\u03C6;
        }
        d3_geo_area.lineEnd = function() {
            nextPoint(\u03BB00, \u03C600);
        };
    }
    d3.geo.bounds = d3_geo_bounds(d3_identity);
    function d3_geo_bounds(projectStream) {
        var x0, y0, x1, y1;
        var bound = {
            point: boundPoint,
            lineStart: d3_noop,
            lineEnd: d3_noop,
            polygonStart: function() {
                bound.lineEnd = boundPolygonLineEnd;
            },
            polygonEnd: function() {
                bound.point = boundPoint;
            }
        };
        function boundPoint(x, y) {
            if (x < x0) x0 = x;
            if (x > x1) x1 = x;
            if (y < y0) y0 = y;
            if (y > y1) y1 = y;
        }
        function boundPolygonLineEnd() {
            bound.point = bound.lineEnd = d3_noop;
        }
        return function(feature) {
            y1 = x1 = -(x0 = y0 = Infinity);
            d3.geo.stream(feature, projectStream(bound));
            return [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
        };
    }
    d3.geo.centroid = function(object) {
        d3_geo_centroidDimension = d3_geo_centroidW = d3_geo_centroidX = d3_geo_centroidY = d3_geo_centroidZ = 0;
        d3.geo.stream(object, d3_geo_centroid);
        var m;
        if (d3_geo_centroidW && Math.abs(m = Math.sqrt(d3_geo_centroidX * d3_geo_centroidX + d3_geo_centroidY * d3_geo_centroidY + d3_geo_centroidZ * d3_geo_centroidZ)) > \u03B5) return [
            Math.atan2(d3_geo_centroidY, d3_geo_centroidX) * d3_degrees,
            Math.asin(Math.max(-1, Math.min(1, d3_geo_centroidZ / m))) * d3_degrees
        ];
    };
    var d3_geo_centroidDimension, d3_geo_centroidW, d3_geo_centroidX, d3_geo_centroidY, d3_geo_centroidZ;
    var d3_geo_centroid = {
        sphere: function() {
            if (d3_geo_centroidDimension < 2) {
                d3_geo_centroidDimension = 2;
                d3_geo_centroidW = d3_geo_centroidX = d3_geo_centroidY = d3_geo_centroidZ = 0;
            }
        },
        point: d3_geo_centroidPoint,
        lineStart: d3_geo_centroidLineStart,
        lineEnd: d3_geo_centroidLineEnd,
        polygonStart: function() {
            if (d3_geo_centroidDimension < 2) {
                d3_geo_centroidDimension = 2;
                d3_geo_centroidW = d3_geo_centroidX = d3_geo_centroidY = d3_geo_centroidZ = 0;
            }
            d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
        },
        polygonEnd: function() {
            d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
        }
    };
    function d3_geo_centroidPoint(\u03BB, \u03C6) {
        if (d3_geo_centroidDimension) return;
        ++d3_geo_centroidW;
        \u03BB *= d3_radians;
        var cos\u03C6 = Math.cos(\u03C6 *= d3_radians);
        d3_geo_centroidX += (cos\u03C6 * Math.cos(\u03BB) - d3_geo_centroidX) / d3_geo_centroidW;
        d3_geo_centroidY += (cos\u03C6 * Math.sin(\u03BB) - d3_geo_centroidY) / d3_geo_centroidW;
        d3_geo_centroidZ += (Math.sin(\u03C6) - d3_geo_centroidZ) / d3_geo_centroidW;
    }
    function d3_geo_centroidRingStart() {
        var \u03BB00, \u03C600;
        d3_geo_centroidDimension = 1;
        d3_geo_centroidLineStart();
        d3_geo_centroidDimension = 2;
        var linePoint = d3_geo_centroid.point;
        d3_geo_centroid.point = function(\u03BB, \u03C6) {
            linePoint(\u03BB00 = \u03BB, \u03C600 = \u03C6);
        };
        d3_geo_centroid.lineEnd = function() {
            d3_geo_centroid.point(\u03BB00, \u03C600);
            d3_geo_centroidLineEnd();
            d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
        };
    }
    function d3_geo_centroidLineStart() {
        var x0, y0, z0;
        if (d3_geo_centroidDimension > 1) return;
        if (d3_geo_centroidDimension < 1) {
            d3_geo_centroidDimension = 1;
            d3_geo_centroidW = d3_geo_centroidX = d3_geo_centroidY = d3_geo_centroidZ = 0;
        }
        d3_geo_centroid.point = function(\u03BB, \u03C6) {
            \u03BB *= d3_radians;
            var cos\u03C6 = Math.cos(\u03C6 *= d3_radians);
            x0 = cos\u03C6 * Math.cos(\u03BB);
            y0 = cos\u03C6 * Math.sin(\u03BB);
            z0 = Math.sin(\u03C6);
            d3_geo_centroid.point = nextPoint;
        };
        function nextPoint(\u03BB, \u03C6) {
            \u03BB *= d3_radians;
            var cos\u03C6 = Math.cos(\u03C6 *= d3_radians), x = cos\u03C6 * Math.cos(\u03BB), y = cos\u03C6 * Math.sin(\u03BB), z = Math.sin(\u03C6), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
            d3_geo_centroidW += w;
            d3_geo_centroidX += w * (x0 + (x0 = x));
            d3_geo_centroidY += w * (y0 + (y0 = y));
            d3_geo_centroidZ += w * (z0 + (z0 = z));
        }
    }
    function d3_geo_centroidLineEnd() {
        d3_geo_centroid.point = d3_geo_centroidPoint;
    }
    function d3_geo_cartesian(spherical) {
        var \u03BB = spherical[0], \u03C6 = spherical[1], cos\u03C6 = Math.cos(\u03C6);
        return [
            cos\u03C6 * Math.cos(\u03BB),
            cos\u03C6 * Math.sin(\u03BB),
            Math.sin(\u03C6)
        ];
    }
    function d3_geo_cartesianDot(a, b1) {
        return a[0] * b1[0] + a[1] * b1[1] + a[2] * b1[2];
    }
    function d3_geo_cartesianCross(a, b1) {
        return [
            a[1] * b1[2] - a[2] * b1[1],
            a[2] * b1[0] - a[0] * b1[2],
            a[0] * b1[1] - a[1] * b1[0]
        ];
    }
    function d3_geo_cartesianAdd(a, b1) {
        a[0] += b1[0];
        a[1] += b1[1];
        a[2] += b1[2];
    }
    function d3_geo_cartesianScale(vector, k) {
        return [
            vector[0] * k,
            vector[1] * k,
            vector[2] * k
        ];
    }
    function d3_geo_cartesianNormalize(d) {
        var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
        d[0] /= l;
        d[1] /= l;
        d[2] /= l;
    }
    function d3_true() {
        return true;
    }
    function d3_geo_spherical(cartesian) {
        return [
            Math.atan2(cartesian[1], cartesian[0]),
            Math.asin(Math.max(-1, Math.min(1, cartesian[2])))
        ];
    }
    function d3_geo_sphericalEqual(a, b1) {
        return Math.abs(a[0] - b1[0]) < \u03B5 && Math.abs(a[1] - b1[1]) < \u03B5;
    }
    function d3_geo_clipPolygon(segments, compare, inside, interpolate, listener) {
        var subject = [], clip = [];
        segments.forEach(function(segment) {
            if ((n = segment.length - 1) <= 0) return;
            var n, p0 = segment[0], p1 = segment[n];
            if (d3_geo_sphericalEqual(p0, p1)) {
                listener.lineStart();
                for(var i = 0; i < n; ++i)listener.point((p0 = segment[i])[0], p0[1]);
                listener.lineEnd();
                return;
            }
            var a = {
                point: p0,
                points: segment,
                other: null,
                visited: false,
                entry: true,
                subject: true
            }, b1 = {
                point: p0,
                points: [
                    p0
                ],
                other: a,
                visited: false,
                entry: false,
                subject: false
            };
            a.other = b1;
            subject.push(a);
            clip.push(b1);
            a = {
                point: p1,
                points: [
                    p1
                ],
                other: null,
                visited: false,
                entry: false,
                subject: true
            };
            b1 = {
                point: p1,
                points: [
                    p1
                ],
                other: a,
                visited: false,
                entry: true,
                subject: false
            };
            a.other = b1;
            subject.push(a);
            clip.push(b1);
        });
        clip.sort(compare);
        d3_geo_clipPolygonLinkCircular(subject);
        d3_geo_clipPolygonLinkCircular(clip);
        if (!subject.length) return;
        if (inside) for(var i = 1, e = !inside(clip[0].point), n = clip.length; i < n; ++i)clip[i].entry = e = !e;
        var start = subject[0], current, points, point;
        while(true){
            current = start;
            while(current.visited)if ((current = current.next) === start) return;
            points = current.points;
            listener.lineStart();
            do {
                current.visited = current.other.visited = true;
                if (current.entry) {
                    if (current.subject) for(var i = 0; i < points.length; i++)listener.point((point = points[i])[0], point[1]);
                    else interpolate(current.point, current.next.point, 1, listener);
                    current = current.next;
                } else {
                    if (current.subject) {
                        points = current.prev.points;
                        for(var i = points.length; --i >= 0;)listener.point((point = points[i])[0], point[1]);
                    } else interpolate(current.point, current.prev.point, -1, listener);
                    current = current.prev;
                }
                current = current.other;
                points = current.points;
            }while (!current.visited);
            listener.lineEnd();
        }
    }
    function d3_geo_clipPolygonLinkCircular(array) {
        if (!(n = array.length)) return;
        var n, i = 0, a = array[0], b1;
        while(++i < n){
            a.next = b1 = array[i];
            b1.prev = a;
            a = b1;
        }
        a.next = b1 = array[0];
        b1.prev = a;
    }
    function d3_geo_clip(pointVisible, clipLine, interpolate) {
        return function(listener) {
            var line = clipLine(listener);
            var clip = {
                point: point,
                lineStart: lineStart,
                lineEnd: lineEnd,
                polygonStart: function() {
                    clip.point = pointRing;
                    clip.lineStart = ringStart;
                    clip.lineEnd = ringEnd;
                    invisible = false;
                    invisibleArea = visibleArea = 0;
                    segments = [];
                    listener.polygonStart();
                },
                polygonEnd: function() {
                    clip.point = point;
                    clip.lineStart = lineStart;
                    clip.lineEnd = lineEnd;
                    segments = d3.merge(segments);
                    if (segments.length) d3_geo_clipPolygon(segments, d3_geo_clipSort, null, interpolate, listener);
                    else if (visibleArea < -\u03B5 || invisible && invisibleArea < -\u03B5) {
                        listener.lineStart();
                        interpolate(null, null, 1, listener);
                        listener.lineEnd();
                    }
                    listener.polygonEnd();
                    segments = null;
                },
                sphere: function() {
                    listener.polygonStart();
                    listener.lineStart();
                    interpolate(null, null, 1, listener);
                    listener.lineEnd();
                    listener.polygonEnd();
                }
            };
            function point(\u03BB, \u03C6) {
                if (pointVisible(\u03BB, \u03C6)) listener.point(\u03BB, \u03C6);
            }
            function pointLine(\u03BB, \u03C6) {
                line.point(\u03BB, \u03C6);
            }
            function lineStart() {
                clip.point = pointLine;
                line.lineStart();
            }
            function lineEnd() {
                clip.point = point;
                line.lineEnd();
            }
            var segments, visibleArea, invisibleArea, invisible;
            var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), ring;
            function pointRing(\u03BB, \u03C6) {
                ringListener.point(\u03BB, \u03C6);
                ring.push([
                    \u03BB,
                    \u03C6
                ]);
            }
            function ringStart() {
                ringListener.lineStart();
                ring = [];
            }
            function ringEnd() {
                pointRing(ring[0][0], ring[0][1]);
                ringListener.lineEnd();
                var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
                if (!n) {
                    invisible = true;
                    invisibleArea += d3_geo_clipAreaRing(ring, -1);
                    ring = null;
                    return;
                }
                ring = null;
                if (clean & 1) {
                    segment = ringSegments[0];
                    visibleArea += d3_geo_clipAreaRing(segment, 1);
                    var n = segment.length - 1, i = -1, point;
                    listener.lineStart();
                    while(++i < n)listener.point((point = segment[i])[0], point[1]);
                    listener.lineEnd();
                    return;
                }
                if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
                segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
            }
            return clip;
        };
    }
    function d3_geo_clipSegmentLength1(segment) {
        return segment.length > 1;
    }
    function d3_geo_clipBufferListener() {
        var lines = [], line;
        return {
            lineStart: function() {
                lines.push(line = []);
            },
            point: function(\u03BB, \u03C6) {
                line.push([
                    \u03BB,
                    \u03C6
                ]);
            },
            lineEnd: d3_noop,
            buffer: function() {
                var buffer = lines;
                lines = [];
                line = null;
                return buffer;
            },
            rejoin: function() {
                if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
            }
        };
    }
    function d3_geo_clipAreaRing(ring, invisible) {
        if (!(n = ring.length)) return 0;
        var n, i = 0, area = 0, p = ring[0], \u03BB = p[0], \u03C6 = p[1], cos\u03C6 = Math.cos(\u03C6), x0 = Math.atan2(invisible * Math.sin(\u03BB) * cos\u03C6, Math.sin(\u03C6)), y0 = 1 - invisible * Math.cos(\u03BB) * cos\u03C6, x1 = x0, x, y;
        while(++i < n){
            p = ring[i];
            cos\u03C6 = Math.cos(\u03C6 = p[1]);
            x = Math.atan2(invisible * Math.sin(\u03BB = p[0]) * cos\u03C6, Math.sin(\u03C6));
            y = 1 - invisible * Math.cos(\u03BB) * cos\u03C6;
            if (Math.abs(y0 - 2) < \u03B5 && Math.abs(y - 2) < \u03B5) continue;
            if (Math.abs(y) < \u03B5 || Math.abs(y0) < \u03B5) ;
            else if (Math.abs(Math.abs(x - x0) - \u03C0) < \u03B5) {
                if (y + y0 > 2) area += 4 * (x - x0);
            } else if (Math.abs(y0 - 2) < \u03B5) area += 4 * (x - x1);
            else area += ((3 * \u03C0 + x - x0) % (2 * \u03C0) - \u03C0) * (y0 + y);
            x1 = x0, x0 = x, y0 = y;
        }
        return area;
    }
    function d3_geo_clipSort(a, b1) {
        return ((a = a.point)[0] < 0 ? a[1] - \u03C0 / 2 - \u03B5 : \u03C0 / 2 - a[1]) - ((b1 = b1.point)[0] < 0 ? b1[1] - \u03C0 / 2 - \u03B5 : \u03C0 / 2 - b1[1]);
    }
    var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate);
    function d3_geo_clipAntimeridianLine(listener) {
        var \u03BB0 = NaN, \u03C60 = NaN, s\u03BB0 = NaN, clean;
        return {
            lineStart: function() {
                listener.lineStart();
                clean = 1;
            },
            point: function(\u03BB1, \u03C61) {
                var s\u03BB1 = \u03BB1 > 0 ? \u03C0 : -\u03C0, d\u03BB = Math.abs(\u03BB1 - \u03BB0);
                if (Math.abs(d\u03BB - \u03C0) < \u03B5) {
                    listener.point(\u03BB0, \u03C60 = (\u03C60 + \u03C61) / 2 > 0 ? \u03C0 / 2 : -\u03C0 / 2);
                    listener.point(s\u03BB0, \u03C60);
                    listener.lineEnd();
                    listener.lineStart();
                    listener.point(s\u03BB1, \u03C60);
                    listener.point(\u03BB1, \u03C60);
                    clean = 0;
                } else if (s\u03BB0 !== s\u03BB1 && d\u03BB >= \u03C0) {
                    if (Math.abs(\u03BB0 - s\u03BB0) < \u03B5) \u03BB0 -= s\u03BB0 * \u03B5;
                    if (Math.abs(\u03BB1 - s\u03BB1) < \u03B5) \u03BB1 -= s\u03BB1 * \u03B5;
                    \u03C60 = d3_geo_clipAntimeridianIntersect(\u03BB0, \u03C60, \u03BB1, \u03C61);
                    listener.point(s\u03BB0, \u03C60);
                    listener.lineEnd();
                    listener.lineStart();
                    listener.point(s\u03BB1, \u03C60);
                    clean = 0;
                }
                listener.point(\u03BB0 = \u03BB1, \u03C60 = \u03C61);
                s\u03BB0 = s\u03BB1;
            },
            lineEnd: function() {
                listener.lineEnd();
                \u03BB0 = \u03C60 = NaN;
            },
            clean: function() {
                return 2 - clean;
            }
        };
    }
    function d3_geo_clipAntimeridianIntersect(\u03BB0, \u03C60, \u03BB1, \u03C61) {
        var cos\u03C60, cos\u03C61, sin\u03BB0_\u03BB1 = Math.sin(\u03BB0 - \u03BB1);
        return Math.abs(sin\u03BB0_\u03BB1) > \u03B5 ? Math.atan((Math.sin(\u03C60) * (cos\u03C61 = Math.cos(\u03C61)) * Math.sin(\u03BB1) - Math.sin(\u03C61) * (cos\u03C60 = Math.cos(\u03C60)) * Math.sin(\u03BB0)) / (cos\u03C60 * cos\u03C61 * sin\u03BB0_\u03BB1)) : (\u03C60 + \u03C61) / 2;
    }
    function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
        var \u03C6;
        if (from == null) {
            \u03C6 = direction * \u03C0 / 2;
            listener.point(-\u03C0, \u03C6);
            listener.point(0, \u03C6);
            listener.point(\u03C0, \u03C6);
            listener.point(\u03C0, 0);
            listener.point(\u03C0, -\u03C6);
            listener.point(0, -\u03C6);
            listener.point(-\u03C0, -\u03C6);
            listener.point(-\u03C0, 0);
            listener.point(-\u03C0, \u03C6);
        } else if (Math.abs(from[0] - to[0]) > \u03B5) {
            var s = (from[0] < to[0] ? 1 : -1) * \u03C0;
            \u03C6 = direction * s / 2;
            listener.point(-s, \u03C6);
            listener.point(0, \u03C6);
            listener.point(s, \u03C6);
        } else listener.point(to[0], to[1]);
    }
    function d3_geo_clipCircle(radius) {
        var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = Math.abs(cr) > \u03B5, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
        return d3_geo_clip(visible, clipLine, interpolate);
        function visible(\u03BB, \u03C6) {
            return Math.cos(\u03BB) * Math.cos(\u03C6) > cr;
        }
        function clipLine(listener) {
            var point0, c0, v0, v00, clean;
            return {
                lineStart: function() {
                    v00 = v0 = false;
                    clean = 1;
                },
                point: function(\u03BB, \u03C6) {
                    var point1 = [
                        \u03BB,
                        \u03C6
                    ], point2, v = visible(\u03BB, \u03C6), c = smallRadius ? v ? 0 : code(\u03BB, \u03C6) : v ? code(\u03BB + (\u03BB < 0 ? \u03C0 : -\u03C0), \u03C6) : 0;
                    if (!point0 && (v00 = v0 = v)) listener.lineStart();
                    if (v !== v0) {
                        point2 = intersect(point0, point1);
                        if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
                            point1[0] += \u03B5;
                            point1[1] += \u03B5;
                            v = visible(point1[0], point1[1]);
                        }
                    }
                    if (v !== v0) {
                        clean = 0;
                        if (v) {
                            listener.lineStart();
                            point2 = intersect(point1, point0);
                            listener.point(point2[0], point2[1]);
                        } else {
                            point2 = intersect(point0, point1);
                            listener.point(point2[0], point2[1]);
                            listener.lineEnd();
                        }
                        point0 = point2;
                    } else if (notHemisphere && point0 && smallRadius ^ v) {
                        var t;
                        if (!(c & c0) && (t = intersect(point1, point0, true))) {
                            clean = 0;
                            if (smallRadius) {
                                listener.lineStart();
                                listener.point(t[0][0], t[0][1]);
                                listener.point(t[1][0], t[1][1]);
                                listener.lineEnd();
                            } else {
                                listener.point(t[1][0], t[1][1]);
                                listener.lineEnd();
                                listener.lineStart();
                                listener.point(t[0][0], t[0][1]);
                            }
                        }
                    }
                    if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) listener.point(point1[0], point1[1]);
                    point0 = point1, v0 = v, c0 = c;
                },
                lineEnd: function() {
                    if (v0) listener.lineEnd();
                    point0 = null;
                },
                clean: function() {
                    return clean | (v00 && v0) << 1;
                }
            };
        }
        function intersect(a, b1, two) {
            var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b1);
            var n1 = [
                1,
                0,
                0
            ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
            if (!determinant) return !two && a;
            var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
            d3_geo_cartesianAdd(A, B);
            var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
            if (t2 < 0) return;
            var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
            d3_geo_cartesianAdd(q, A);
            q = d3_geo_spherical(q);
            if (!two) return q;
            var \u03BB0 = a[0], \u03BB1 = b1[0], \u03C60 = a[1], \u03C61 = b1[1], z;
            if (\u03BB1 < \u03BB0) z = \u03BB0, \u03BB0 = \u03BB1, \u03BB1 = z;
            var \u03B4\u03BB = \u03BB1 - \u03BB0, polar = Math.abs(\u03B4\u03BB - \u03C0) < \u03B5, meridian = polar || \u03B4\u03BB < \u03B5;
            if (!polar && \u03C61 < \u03C60) z = \u03C60, \u03C60 = \u03C61, \u03C61 = z;
            if (meridian ? polar ? \u03C60 + \u03C61 > 0 ^ q[1] < (Math.abs(q[0] - \u03BB0) < \u03B5 ? \u03C60 : \u03C61) : \u03C60 <= q[1] && q[1] <= \u03C61 : \u03B4\u03BB > \u03C0 ^ (\u03BB0 <= q[0] && q[0] <= \u03BB1)) {
                var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
                d3_geo_cartesianAdd(q1, A);
                return [
                    q,
                    d3_geo_spherical(q1)
                ];
            }
        }
        function code(\u03BB, \u03C6) {
            var r = smallRadius ? radius : \u03C0 - radius, code = 0;
            if (\u03BB < -r) code |= 1;
            else if (\u03BB > r) code |= 2;
            if (\u03C6 < -r) code |= 4;
            else if (\u03C6 > r) code |= 8;
            return code;
        }
    }
    var d3_geo_clipViewMAX = 1e9;
    function d3_geo_clipView(x0, y0, x1, y1) {
        return function(listener) {
            var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), segments, polygon, ring;
            var clip = {
                point: point,
                lineStart: lineStart,
                lineEnd: lineEnd,
                polygonStart: function() {
                    listener = bufferListener;
                    segments = [];
                    polygon = [];
                },
                polygonEnd: function() {
                    listener = listener_;
                    if ((segments = d3.merge(segments)).length) {
                        listener.polygonStart();
                        d3_geo_clipPolygon(segments, compare, inside, interpolate, listener);
                        listener.polygonEnd();
                    } else if (insidePolygon([
                        x0,
                        y0
                    ])) {
                        listener.polygonStart(), listener.lineStart();
                        interpolate(null, null, 1, listener);
                        listener.lineEnd(), listener.polygonEnd();
                    }
                    segments = polygon = ring = null;
                }
            };
            function inside(point) {
                var a = corner(point, -1), i = insidePolygon([
                    a === 0 || a === 3 ? x0 : x1,
                    a > 1 ? y1 : y0
                ]);
                return i;
            }
            function insidePolygon(p) {
                var wn = 0, n = polygon.length, y = p[1];
                for(var i = 0; i < n; ++i)for(var j = 1, v = polygon[i], m = v.length, a = v[0]; j < m; ++j){
                    b = v[j];
                    if (a[1] <= y) {
                        if (b[1] > y && isLeft(a, b, p) > 0) ++wn;
                    } else if (b[1] <= y && isLeft(a, b, p) < 0) --wn;
                    a = b;
                }
                return wn !== 0;
            }
            function isLeft(a, b1, c) {
                return (b1[0] - a[0]) * (c[1] - a[1]) - (c[0] - a[0]) * (b1[1] - a[1]);
            }
            function interpolate(from, to, direction, listener) {
                var a = 0, a1 = 0;
                if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) do listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
                while ((a = (a + direction + 4) % 4) !== a1);
                else listener.point(to[0], to[1]);
            }
            function visible(x, y) {
                return x0 <= x && x <= x1 && y0 <= y && y <= y1;
            }
            function point(x, y) {
                if (visible(x, y)) listener.point(x, y);
            }
            var x__, y__, v__, x_, y_, v_, first;
            function lineStart() {
                clip.point = linePoint;
                if (polygon) polygon.push(ring = []);
                first = true;
                v_ = false;
                x_ = y_ = NaN;
            }
            function lineEnd() {
                if (segments) {
                    linePoint(x__, y__);
                    if (v__ && v_) bufferListener.rejoin();
                    segments.push(bufferListener.buffer());
                }
                clip.point = point;
                if (v_) listener.lineEnd();
            }
            function linePoint(x, y) {
                x = Math.max(-d3_geo_clipViewMAX, Math.min(d3_geo_clipViewMAX, x));
                y = Math.max(-d3_geo_clipViewMAX, Math.min(d3_geo_clipViewMAX, y));
                var v = visible(x, y);
                if (polygon) ring.push([
                    x,
                    y
                ]);
                if (first) {
                    x__ = x, y__ = y, v__ = v;
                    first = false;
                    if (v) {
                        listener.lineStart();
                        listener.point(x, y);
                    }
                } else if (v && v_) listener.point(x, y);
                else {
                    var a = [
                        x_,
                        y_
                    ], b1 = [
                        x,
                        y
                    ];
                    if (clipLine(a, b1)) {
                        if (!v_) {
                            listener.lineStart();
                            listener.point(a[0], a[1]);
                        }
                        listener.point(b1[0], b1[1]);
                        if (!v) listener.lineEnd();
                    } else {
                        listener.lineStart();
                        listener.point(x, y);
                    }
                }
                x_ = x, y_ = y, v_ = v;
            }
            return clip;
        };
        function corner(p, direction) {
            return Math.abs(p[0] - x0) < \u03B5 ? direction > 0 ? 0 : 3 : Math.abs(p[0] - x1) < \u03B5 ? direction > 0 ? 2 : 1 : Math.abs(p[1] - y0) < \u03B5 ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
        }
        function compare(a, b1) {
            return comparePoints(a.point, b1.point);
        }
        function comparePoints(a, b1) {
            var ca = corner(a, 1), cb = corner(b1, 1);
            return ca !== cb ? ca - cb : ca === 0 ? b1[1] - a[1] : ca === 1 ? a[0] - b1[0] : ca === 2 ? a[1] - b1[1] : b1[0] - a[0];
        }
        function clipLine(a, b1) {
            var dx = b1[0] - a[0], dy = b1[1] - a[1], t = [
                0,
                1
            ];
            if (Math.abs(dx) < \u03B5 && Math.abs(dy) < \u03B5) return x0 <= a[0] && a[0] <= x1 && y0 <= a[1] && a[1] <= y1;
            if (d3_geo_clipViewT(x0 - a[0], dx, t) && d3_geo_clipViewT(a[0] - x1, -dx, t) && d3_geo_clipViewT(y0 - a[1], dy, t) && d3_geo_clipViewT(a[1] - y1, -dy, t)) {
                if (t[1] < 1) {
                    b1[0] = a[0] + t[1] * dx;
                    b1[1] = a[1] + t[1] * dy;
                }
                if (t[0] > 0) {
                    a[0] += t[0] * dx;
                    a[1] += t[0] * dy;
                }
                return true;
            }
            return false;
        }
    }
    function d3_geo_clipViewT(num, denominator, t) {
        if (Math.abs(denominator) < \u03B5) return num <= 0;
        var u = num / denominator;
        if (denominator > 0) {
            if (u > t[1]) return false;
            if (u > t[0]) t[0] = u;
        } else {
            if (u < t[0]) return false;
            if (u < t[1]) t[1] = u;
        }
        return true;
    }
    function d3_geo_compose(a, b1) {
        function compose(x, y) {
            return x = a(x, y), b1(x[0], x[1]);
        }
        if (a.invert && b1.invert) compose.invert = function(x, y) {
            return x = b1.invert(x, y), x && a.invert(x[0], x[1]);
        };
        return compose;
    }
    function d3_geo_resample(project) {
        var \u03B42 = .5, maxDepth = 16;
        function resample(stream) {
            var \u03BB0, x0, y0, a0, b0, c0;
            var resample = {
                point: point,
                lineStart: lineStart,
                lineEnd: lineEnd,
                polygonStart: function() {
                    stream.polygonStart();
                    resample.lineStart = polygonLineStart;
                },
                polygonEnd: function() {
                    stream.polygonEnd();
                    resample.lineStart = lineStart;
                }
            };
            function point(x, y) {
                x = project(x, y);
                stream.point(x[0], x[1]);
            }
            function lineStart() {
                x0 = NaN;
                resample.point = linePoint;
                stream.lineStart();
            }
            function linePoint(\u03BB, \u03C6) {
                var c = d3_geo_cartesian([
                    \u03BB,
                    \u03C6
                ]), p = project(\u03BB, \u03C6);
                resampleLineTo(x0, y0, \u03BB0, a0, b0, c0, x0 = p[0], y0 = p[1], \u03BB0 = \u03BB, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
                stream.point(x0, y0);
            }
            function lineEnd() {
                resample.point = point;
                stream.lineEnd();
            }
            function polygonLineStart() {
                var \u03BB00, \u03C600, x00, y00, a00, b00, c00;
                lineStart();
                resample.point = function(\u03BB, \u03C6) {
                    linePoint(\u03BB00 = \u03BB, \u03C600 = \u03C6), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
                    resample.point = linePoint;
                };
                resample.lineEnd = function() {
                    resampleLineTo(x0, y0, \u03BB0, a0, b0, c0, x00, y00, \u03BB00, a00, b00, c00, maxDepth, stream);
                    resample.lineEnd = lineEnd;
                    lineEnd();
                };
            }
            return resample;
        }
        function resampleLineTo(x0, y0, \u03BB0, a0, b0, c0, x1, y1, \u03BB1, a1, b1, c1, depth, stream) {
            var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
            if (d2 > 4 * \u03B42 && depth--) {
                var a = a0 + a1, b2 = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b2 * b2 + c * c), \u03C62 = Math.asin(c /= m), \u03BB2 = Math.abs(Math.abs(c) - 1) < \u03B5 ? (\u03BB0 + \u03BB1) / 2 : Math.atan2(b2, a), p = project(\u03BB2, \u03C62), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
                if (dz * dz / d2 > \u03B42 || Math.abs((dx * dx2 + dy * dy2) / d2 - .5) > .3) {
                    resampleLineTo(x0, y0, \u03BB0, a0, b0, c0, x2, y2, \u03BB2, a /= m, b2 /= m, c, depth, stream);
                    stream.point(x2, y2);
                    resampleLineTo(x2, y2, \u03BB2, a, b2, c, x1, y1, \u03BB1, a1, b1, c1, depth, stream);
                }
            }
        }
        resample.precision = function(_) {
            if (!arguments.length) return Math.sqrt(\u03B42);
            maxDepth = (\u03B42 = _ * _) > 0 && 16;
            return resample;
        };
        return resample;
    }
    d3.geo.projection = d3_geo_projection;
    d3.geo.projectionMutator = d3_geo_projectionMutator;
    function d3_geo_projection(project) {
        return d3_geo_projectionMutator(function() {
            return project;
        })();
    }
    function d3_geo_projectionMutator(projectAt) {
        var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
            x = project(x, y);
            return [
                x[0] * k + \u03B4x,
                \u03B4y - x[1] * k
            ];
        }), k = 150, x = 480, y = 250, \u03BB = 0, \u03C6 = 0, \u03B4\u03BB = 0, \u03B4\u03C6 = 0, \u03B4\u03B3 = 0, \u03B4x, \u03B4y, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null;
        function projection(point) {
            point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
            return [
                point[0] * k + \u03B4x,
                \u03B4y - point[1] * k
            ];
        }
        function invert(point) {
            point = projectRotate.invert((point[0] - \u03B4x) / k, (\u03B4y - point[1]) / k);
            return point && [
                point[0] * d3_degrees,
                point[1] * d3_degrees
            ];
        }
        projection.stream = function(stream) {
            return d3_geo_projectionRadiansRotate(rotate, preclip(projectResample(postclip(stream))));
        };
        projection.clipAngle = function(_) {
            if (!arguments.length) return clipAngle;
            preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
            return projection;
        };
        projection.clipExtent = function(_) {
            if (!arguments.length) return clipExtent;
            clipExtent = _;
            postclip = _ == null ? d3_identity : d3_geo_clipView(_[0][0], _[0][1], _[1][0], _[1][1]);
            return projection;
        };
        projection.scale = function(_) {
            if (!arguments.length) return k;
            k = +_;
            return reset();
        };
        projection.translate = function(_) {
            if (!arguments.length) return [
                x,
                y
            ];
            x = +_[0];
            y = +_[1];
            return reset();
        };
        projection.center = function(_) {
            if (!arguments.length) return [
                \u03BB * d3_degrees,
                \u03C6 * d3_degrees
            ];
            \u03BB = _[0] % 360 * d3_radians;
            \u03C6 = _[1] % 360 * d3_radians;
            return reset();
        };
        projection.rotate = function(_) {
            if (!arguments.length) return [
                \u03B4\u03BB * d3_degrees,
                \u03B4\u03C6 * d3_degrees,
                \u03B4\u03B3 * d3_degrees
            ];
            \u03B4\u03BB = _[0] % 360 * d3_radians;
            \u03B4\u03C6 = _[1] % 360 * d3_radians;
            \u03B4\u03B3 = _.length > 2 ? _[2] % 360 * d3_radians : 0;
            return reset();
        };
        d3.rebind(projection, projectResample, "precision");
        function reset() {
            projectRotate = d3_geo_compose(rotate = d3_geo_rotation(\u03B4\u03BB, \u03B4\u03C6, \u03B4\u03B3), project);
            var center = project(\u03BB, \u03C6);
            \u03B4x = x - center[0] * k;
            \u03B4y = y + center[1] * k;
            return projection;
        }
        return function() {
            project = projectAt.apply(this, arguments);
            projection.invert = project.invert && invert;
            return reset();
        };
    }
    function d3_geo_projectionRadiansRotate(rotate, stream) {
        return {
            point: function(x, y) {
                y = rotate(x * d3_radians, y * d3_radians), x = y[0];
                stream.point(x > \u03C0 ? x - 2 * \u03C0 : x < -\u03C0 ? x + 2 * \u03C0 : x, y[1]);
            },
            sphere: function() {
                stream.sphere();
            },
            lineStart: function() {
                stream.lineStart();
            },
            lineEnd: function() {
                stream.lineEnd();
            },
            polygonStart: function() {
                stream.polygonStart();
            },
            polygonEnd: function() {
                stream.polygonEnd();
            }
        };
    }
    function d3_geo_equirectangular(\u03BB, \u03C6) {
        return [
            \u03BB,
            \u03C6
        ];
    }
    (d3.geo.equirectangular = function() {
        return d3_geo_projection(d3_geo_equirectangular);
    }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
    d3.geo.rotation = function(rotate) {
        rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
        function forward(coordinates) {
            coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
            return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
        }
        forward.invert = function(coordinates) {
            coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
            return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
        };
        return forward;
    };
    function d3_geo_rotation(\u03B4\u03BB, \u03B4\u03C6, \u03B4\u03B3) {
        return \u03B4\u03BB ? \u03B4\u03C6 || \u03B4\u03B3 ? d3_geo_compose(d3_geo_rotation\u03BB(\u03B4\u03BB), d3_geo_rotation\u03C6\u03B3(\u03B4\u03C6, \u03B4\u03B3)) : d3_geo_rotation\u03BB(\u03B4\u03BB) : \u03B4\u03C6 || \u03B4\u03B3 ? d3_geo_rotation\u03C6\u03B3(\u03B4\u03C6, \u03B4\u03B3) : d3_geo_equirectangular;
    }
    function d3_geo_forwardRotation\u03BB(\u03B4\u03BB) {
        return function(\u03BB, \u03C6) {
            return \u03BB += \u03B4\u03BB, [
                \u03BB > \u03C0 ? \u03BB - 2 * \u03C0 : \u03BB < -\u03C0 ? \u03BB + 2 * \u03C0 : \u03BB,
                \u03C6
            ];
        };
    }
    function d3_geo_rotation\u03BB(\u03B4\u03BB) {
        var rotation = d3_geo_forwardRotation\u03BB(\u03B4\u03BB);
        rotation.invert = d3_geo_forwardRotation\u03BB(-\u03B4\u03BB);
        return rotation;
    }
    function d3_geo_rotation\u03C6\u03B3(\u03B4\u03C6, \u03B4\u03B3) {
        var cos\u03B4\u03C6 = Math.cos(\u03B4\u03C6), sin\u03B4\u03C6 = Math.sin(\u03B4\u03C6), cos\u03B4\u03B3 = Math.cos(\u03B4\u03B3), sin\u03B4\u03B3 = Math.sin(\u03B4\u03B3);
        function rotation(\u03BB, \u03C6) {
            var cos\u03C6 = Math.cos(\u03C6), x = Math.cos(\u03BB) * cos\u03C6, y = Math.sin(\u03BB) * cos\u03C6, z = Math.sin(\u03C6), k = z * cos\u03B4\u03C6 + x * sin\u03B4\u03C6;
            return [
                Math.atan2(y * cos\u03B4\u03B3 - k * sin\u03B4\u03B3, x * cos\u03B4\u03C6 - z * sin\u03B4\u03C6),
                Math.asin(Math.max(-1, Math.min(1, k * cos\u03B4\u03B3 + y * sin\u03B4\u03B3)))
            ];
        }
        rotation.invert = function(\u03BB, \u03C6) {
            var cos\u03C6 = Math.cos(\u03C6), x = Math.cos(\u03BB) * cos\u03C6, y = Math.sin(\u03BB) * cos\u03C6, z = Math.sin(\u03C6), k = z * cos\u03B4\u03B3 - y * sin\u03B4\u03B3;
            return [
                Math.atan2(y * cos\u03B4\u03B3 + z * sin\u03B4\u03B3, x * cos\u03B4\u03C6 + k * sin\u03B4\u03C6),
                Math.asin(Math.max(-1, Math.min(1, k * cos\u03B4\u03C6 - x * sin\u03B4\u03C6)))
            ];
        };
        return rotation;
    }
    d3.geo.circle = function() {
        var origin = [
            0,
            0
        ], angle, precision = 6, interpolate;
        function circle() {
            var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
            interpolate(null, null, 1, {
                point: function(x, y) {
                    ring.push(x = rotate(x, y));
                    x[0] *= d3_degrees, x[1] *= d3_degrees;
                }
            });
            return {
                type: "Polygon",
                coordinates: [
                    ring
                ]
            };
        }
        circle.origin = function(x) {
            if (!arguments.length) return origin;
            origin = x;
            return circle;
        };
        circle.angle = function(x) {
            if (!arguments.length) return angle;
            interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
            return circle;
        };
        circle.precision = function(_) {
            if (!arguments.length) return precision;
            interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
            return circle;
        };
        return circle.angle(90);
    };
    function d3_geo_circleInterpolate(radius, precision) {
        var cr = Math.cos(radius), sr = Math.sin(radius);
        return function(from, to, direction, listener) {
            if (from != null) {
                from = d3_geo_circleAngle(cr, from);
                to = d3_geo_circleAngle(cr, to);
                if (direction > 0 ? from < to : from > to) from += direction * 2 * \u03C0;
            } else {
                from = radius + direction * 2 * \u03C0;
                to = radius;
            }
            var point;
            for(var step = direction * precision, t = from; direction > 0 ? t > to : t < to; t -= step)listener.point((point = d3_geo_spherical([
                cr,
                -sr * Math.cos(t),
                -sr * Math.sin(t)
            ]))[0], point[1]);
        };
    }
    function d3_geo_circleAngle(cr, point) {
        var a = d3_geo_cartesian(point);
        a[0] -= cr;
        d3_geo_cartesianNormalize(a);
        var angle = d3_acos(-a[1]);
        return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - \u03B5) % (2 * Math.PI);
    }
    d3.geo.distance = function(a, b1) {
        var \u0394\u03BB = (b1[0] - a[0]) * d3_radians, \u03C60 = a[1] * d3_radians, \u03C61 = b1[1] * d3_radians, sin\u0394\u03BB = Math.sin(\u0394\u03BB), cos\u0394\u03BB = Math.cos(\u0394\u03BB), sin\u03C60 = Math.sin(\u03C60), cos\u03C60 = Math.cos(\u03C60), sin\u03C61 = Math.sin(\u03C61), cos\u03C61 = Math.cos(\u03C61), t;
        return Math.atan2(Math.sqrt((t = cos\u03C61 * sin\u0394\u03BB) * t + (t = cos\u03C60 * sin\u03C61 - sin\u03C60 * cos\u03C61 * cos\u0394\u03BB) * t), sin\u03C60 * sin\u03C61 + cos\u03C60 * cos\u03C61 * cos\u0394\u03BB);
    };
    d3.geo.graticule = function() {
        var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
        function graticule() {
            return {
                type: "MultiLineString",
                coordinates: lines()
            };
        }
        function lines() {
            return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
                return Math.abs(x % DX) > \u03B5;
            }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
                return Math.abs(y % DY) > \u03B5;
            }).map(y));
        }
        graticule.lines = function() {
            return lines().map(function(coordinates) {
                return {
                    type: "LineString",
                    coordinates: coordinates
                };
            });
        };
        graticule.outline = function() {
            return {
                type: "Polygon",
                coordinates: [
                    X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1))
                ]
            };
        };
        graticule.extent = function(_) {
            if (!arguments.length) return graticule.minorExtent();
            return graticule.majorExtent(_).minorExtent(_);
        };
        graticule.majorExtent = function(_) {
            if (!arguments.length) return [
                [
                    X0,
                    Y0
                ],
                [
                    X1,
                    Y1
                ]
            ];
            X0 = +_[0][0], X1 = +_[1][0];
            Y0 = +_[0][1], Y1 = +_[1][1];
            if (X0 > X1) _ = X0, X0 = X1, X1 = _;
            if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
            return graticule.precision(precision);
        };
        graticule.minorExtent = function(_) {
            if (!arguments.length) return [
                [
                    x0,
                    y0
                ],
                [
                    x1,
                    y1
                ]
            ];
            x0 = +_[0][0], x1 = +_[1][0];
            y0 = +_[0][1], y1 = +_[1][1];
            if (x0 > x1) _ = x0, x0 = x1, x1 = _;
            if (y0 > y1) _ = y0, y0 = y1, y1 = _;
            return graticule.precision(precision);
        };
        graticule.step = function(_) {
            if (!arguments.length) return graticule.minorStep();
            return graticule.majorStep(_).minorStep(_);
        };
        graticule.majorStep = function(_) {
            if (!arguments.length) return [
                DX,
                DY
            ];
            DX = +_[0], DY = +_[1];
            return graticule;
        };
        graticule.minorStep = function(_) {
            if (!arguments.length) return [
                dx,
                dy
            ];
            dx = +_[0], dy = +_[1];
            return graticule;
        };
        graticule.precision = function(_) {
            if (!arguments.length) return precision;
            precision = +_;
            x = d3_geo_graticuleX(y0, y1, 90);
            y = d3_geo_graticuleY(x0, x1, precision);
            X = d3_geo_graticuleX(Y0, Y1, 90);
            Y = d3_geo_graticuleY(X0, X1, precision);
            return graticule;
        };
        return graticule.majorExtent([
            [
                -180,
                -90 + \u03B5
            ],
            [
                180,
                90 - \u03B5
            ]
        ]).minorExtent([
            [
                -180,
                -80 - \u03B5
            ],
            [
                180,
                80 + \u03B5
            ]
        ]);
    };
    function d3_geo_graticuleX(y0, y1, dy) {
        var y = d3.range(y0, y1 - \u03B5, dy).concat(y1);
        return function(x) {
            return y.map(function(y) {
                return [
                    x,
                    y
                ];
            });
        };
    }
    function d3_geo_graticuleY(x0, x1, dx) {
        var x = d3.range(x0, x1 - \u03B5, dx).concat(x1);
        return function(y) {
            return x.map(function(x) {
                return [
                    x,
                    y
                ];
            });
        };
    }
    function d3_source(d) {
        return d.source;
    }
    function d3_target(d) {
        return d.target;
    }
    d3.geo.greatArc = function() {
        var source = d3_source, source_, target = d3_target, target_;
        function greatArc() {
            return {
                type: "LineString",
                coordinates: [
                    source_ || source.apply(this, arguments),
                    target_ || target.apply(this, arguments)
                ]
            };
        }
        greatArc.distance = function() {
            return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
        };
        greatArc.source = function(_) {
            if (!arguments.length) return source;
            source = _, source_ = typeof _ === "function" ? null : _;
            return greatArc;
        };
        greatArc.target = function(_) {
            if (!arguments.length) return target;
            target = _, target_ = typeof _ === "function" ? null : _;
            return greatArc;
        };
        greatArc.precision = function() {
            return arguments.length ? greatArc : 0;
        };
        return greatArc;
    };
    d3.geo.interpolate = function(source, target) {
        return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
    };
    function d3_geo_interpolate(x0, y0, x1, y1) {
        var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
        var interpolate = d ? function(t) {
            var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
            return [
                Math.atan2(y, x) * d3_degrees,
                Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees
            ];
        } : function() {
            return [
                x0 * d3_degrees,
                y0 * d3_degrees
            ];
        };
        interpolate.distance = d;
        return interpolate;
    }
    d3.geo.length = function(object) {
        d3_geo_lengthSum = 0;
        d3.geo.stream(object, d3_geo_length);
        return d3_geo_lengthSum;
    };
    var d3_geo_lengthSum;
    var d3_geo_length = {
        sphere: d3_noop,
        point: d3_noop,
        lineStart: d3_geo_lengthLineStart,
        lineEnd: d3_noop,
        polygonStart: d3_noop,
        polygonEnd: d3_noop
    };
    function d3_geo_lengthLineStart() {
        var \u03BB0, sin\u03C60, cos\u03C60;
        d3_geo_length.point = function(\u03BB, \u03C6) {
            \u03BB0 = \u03BB * d3_radians, sin\u03C60 = Math.sin(\u03C6 *= d3_radians), cos\u03C60 = Math.cos(\u03C6);
            d3_geo_length.point = nextPoint;
        };
        d3_geo_length.lineEnd = function() {
            d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
        };
        function nextPoint(\u03BB, \u03C6) {
            var sin\u03C6 = Math.sin(\u03C6 *= d3_radians), cos\u03C6 = Math.cos(\u03C6), t = Math.abs((\u03BB *= d3_radians) - \u03BB0), cos\u0394\u03BB = Math.cos(t);
            d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cos\u03C6 * Math.sin(t)) * t + (t = cos\u03C60 * sin\u03C6 - sin\u03C60 * cos\u03C6 * cos\u0394\u03BB) * t), sin\u03C60 * sin\u03C6 + cos\u03C60 * cos\u03C6 * cos\u0394\u03BB);
            \u03BB0 = \u03BB, sin\u03C60 = sin\u03C6, cos\u03C60 = cos\u03C6;
        }
    }
    function d3_geo_conic(projectAt) {
        var \u03C60 = 0, \u03C61 = \u03C0 / 3, m = d3_geo_projectionMutator(projectAt), p = m(\u03C60, \u03C61);
        p.parallels = function(_) {
            if (!arguments.length) return [
                \u03C60 / \u03C0 * 180,
                \u03C61 / \u03C0 * 180
            ];
            return m(\u03C60 = _[0] * \u03C0 / 180, \u03C61 = _[1] * \u03C0 / 180);
        };
        return p;
    }
    function d3_geo_conicEqualArea(\u03C60, \u03C61) {
        var sin\u03C60 = Math.sin(\u03C60), n = (sin\u03C60 + Math.sin(\u03C61)) / 2, C = 1 + sin\u03C60 * (2 * n - sin\u03C60), \u03C10 = Math.sqrt(C) / n;
        function forward(\u03BB, \u03C6) {
            var \u03C1 = Math.sqrt(C - 2 * n * Math.sin(\u03C6)) / n;
            return [
                \u03C1 * Math.sin(\u03BB *= n),
                \u03C10 - \u03C1 * Math.cos(\u03BB)
            ];
        }
        forward.invert = function(x, y) {
            var \u03C10_y = \u03C10 - y;
            return [
                Math.atan2(x, \u03C10_y) / n,
                Math.asin((C - (x * x + \u03C10_y * \u03C10_y) * n * n) / (2 * n))
            ];
        };
        return forward;
    }
    (d3.geo.conicEqualArea = function() {
        return d3_geo_conic(d3_geo_conicEqualArea);
    }).raw = d3_geo_conicEqualArea;
    d3.geo.albersUsa = function() {
        var lower48 = d3.geo.conicEqualArea().rotate([
            98,
            0
        ]).center([
            0,
            38
        ]).parallels([
            29.5,
            45.5
        ]);
        var alaska = d3.geo.conicEqualArea().rotate([
            160,
            0
        ]).center([
            0,
            60
        ]).parallels([
            55,
            65
        ]);
        var hawaii = d3.geo.conicEqualArea().rotate([
            160,
            0
        ]).center([
            0,
            20
        ]).parallels([
            8,
            18
        ]);
        var puertoRico = d3.geo.conicEqualArea().rotate([
            60,
            0
        ]).center([
            0,
            10
        ]).parallels([
            8,
            18
        ]);
        var alaskaInvert, hawaiiInvert, puertoRicoInvert;
        function albersUsa(coordinates) {
            return projection(coordinates)(coordinates);
        }
        function projection(point) {
            var lon = point[0], lat = point[1];
            return lat > 50 ? alaska : lon < -140 ? hawaii : lat < 21 ? puertoRico : lower48;
        }
        albersUsa.invert = function(coordinates) {
            return alaskaInvert(coordinates) || hawaiiInvert(coordinates) || puertoRicoInvert(coordinates) || lower48.invert(coordinates);
        };
        albersUsa.scale = function(x) {
            if (!arguments.length) return lower48.scale();
            lower48.scale(x);
            alaska.scale(x * .6);
            hawaii.scale(x);
            puertoRico.scale(x * 1.5);
            return albersUsa.translate(lower48.translate());
        };
        albersUsa.translate = function(x) {
            if (!arguments.length) return lower48.translate();
            var dz = lower48.scale(), dx = x[0], dy = x[1];
            lower48.translate(x);
            alaska.translate([
                dx - .4 * dz,
                dy + .17 * dz
            ]);
            hawaii.translate([
                dx - .19 * dz,
                dy + .2 * dz
            ]);
            puertoRico.translate([
                dx + .58 * dz,
                dy + .43 * dz
            ]);
            alaskaInvert = d3_geo_albersUsaInvert(alaska, [
                [
                    -180,
                    50
                ],
                [
                    -130,
                    72
                ]
            ]);
            hawaiiInvert = d3_geo_albersUsaInvert(hawaii, [
                [
                    -164,
                    18
                ],
                [
                    -154,
                    24
                ]
            ]);
            puertoRicoInvert = d3_geo_albersUsaInvert(puertoRico, [
                [
                    -67.5,
                    17.5
                ],
                [
                    -65,
                    19
                ]
            ]);
            return albersUsa;
        };
        return albersUsa.scale(1e3);
    };
    function d3_geo_albersUsaInvert(projection, extent) {
        var a = projection(extent[0]), b1 = projection([
            .5 * (extent[0][0] + extent[1][0]),
            extent[0][1]
        ]), c = projection([
            extent[1][0],
            extent[0][1]
        ]), d = projection(extent[1]);
        var dya = b1[1] - a[1], dxa = b1[0] - a[0], dyb = c[1] - b1[1], dxb = c[0] - b1[0];
        var ma = dya / dxa, mb = dyb / dxb;
        var cx = .5 * (ma * mb * (a[1] - c[1]) + mb * (a[0] + b1[0]) - ma * (b1[0] + c[0])) / (mb - ma), cy = (.5 * (a[0] + b1[0]) - cx) / ma + .5 * (a[1] + b1[1]);
        var dx0 = d[0] - cx, dy0 = d[1] - cy, dx1 = a[0] - cx, dy1 = a[1] - cy, r0 = dx0 * dx0 + dy0 * dy0, r1 = dx1 * dx1 + dy1 * dy1;
        var a0 = Math.atan2(dy0, dx0), a1 = Math.atan2(dy1, dx1);
        return function(coordinates) {
            var dx = coordinates[0] - cx, dy = coordinates[1] - cy, r = dx * dx + dy * dy, a = Math.atan2(dy, dx);
            if (r0 < r && r < r1 && a0 < a && a < a1) return projection.invert(coordinates);
        };
    }
    var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
        point: d3_noop,
        lineStart: d3_noop,
        lineEnd: d3_noop,
        polygonStart: function() {
            d3_geo_pathAreaPolygon = 0;
            d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
        },
        polygonEnd: function() {
            d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
            d3_geo_pathAreaSum += Math.abs(d3_geo_pathAreaPolygon / 2);
        }
    };
    function d3_geo_pathAreaRingStart() {
        var x00, y00, x0, y0;
        d3_geo_pathArea.point = function(x, y) {
            d3_geo_pathArea.point = nextPoint;
            x00 = x0 = x, y00 = y0 = y;
        };
        function nextPoint(x, y) {
            d3_geo_pathAreaPolygon += y0 * x - x0 * y;
            x0 = x, y0 = y;
        }
        d3_geo_pathArea.lineEnd = function() {
            nextPoint(x00, y00);
        };
    }
    function d3_geo_pathBuffer() {
        var pointCircle = d3_geo_pathCircle(4.5), buffer = [];
        var stream = {
            point: point,
            lineStart: function() {
                stream.point = pointLineStart;
            },
            lineEnd: lineEnd,
            polygonStart: function() {
                stream.lineEnd = lineEndPolygon;
            },
            polygonEnd: function() {
                stream.lineEnd = lineEnd;
                stream.point = point;
            },
            pointRadius: function(_) {
                pointCircle = d3_geo_pathCircle(_);
                return stream;
            },
            result: function() {
                if (buffer.length) {
                    var result = buffer.join("");
                    buffer = [];
                    return result;
                }
            }
        };
        function point(x, y) {
            buffer.push("M", x, ",", y, pointCircle);
        }
        function pointLineStart(x, y) {
            buffer.push("M", x, ",", y);
            stream.point = pointLine;
        }
        function pointLine(x, y) {
            buffer.push("L", x, ",", y);
        }
        function lineEnd() {
            stream.point = point;
        }
        function lineEndPolygon() {
            buffer.push("Z");
        }
        return stream;
    }
    var d3_geo_pathCentroid = {
        point: d3_geo_pathCentroidPoint,
        lineStart: d3_geo_pathCentroidLineStart,
        lineEnd: d3_geo_pathCentroidLineEnd,
        polygonStart: function() {
            d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
        },
        polygonEnd: function() {
            d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
            d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
            d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
        }
    };
    function d3_geo_pathCentroidPoint(x, y) {
        if (d3_geo_centroidDimension) return;
        d3_geo_centroidX += x;
        d3_geo_centroidY += y;
        ++d3_geo_centroidZ;
    }
    function d3_geo_pathCentroidLineStart() {
        var x0, y0;
        if (d3_geo_centroidDimension !== 1) {
            if (d3_geo_centroidDimension < 1) {
                d3_geo_centroidDimension = 1;
                d3_geo_centroidX = d3_geo_centroidY = d3_geo_centroidZ = 0;
            } else return;
        }
        d3_geo_pathCentroid.point = function(x, y) {
            d3_geo_pathCentroid.point = nextPoint;
            x0 = x, y0 = y;
        };
        function nextPoint(x, y) {
            var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
            d3_geo_centroidX += z * (x0 + x) / 2;
            d3_geo_centroidY += z * (y0 + y) / 2;
            d3_geo_centroidZ += z;
            x0 = x, y0 = y;
        }
    }
    function d3_geo_pathCentroidLineEnd() {
        d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
    }
    function d3_geo_pathCentroidRingStart() {
        var x00, y00, x0, y0;
        if (d3_geo_centroidDimension < 2) {
            d3_geo_centroidDimension = 2;
            d3_geo_centroidX = d3_geo_centroidY = d3_geo_centroidZ = 0;
        }
        d3_geo_pathCentroid.point = function(x, y) {
            d3_geo_pathCentroid.point = nextPoint;
            x00 = x0 = x, y00 = y0 = y;
        };
        function nextPoint(x, y) {
            var z = y0 * x - x0 * y;
            d3_geo_centroidX += z * (x0 + x);
            d3_geo_centroidY += z * (y0 + y);
            d3_geo_centroidZ += z * 3;
            x0 = x, y0 = y;
        }
        d3_geo_pathCentroid.lineEnd = function() {
            nextPoint(x00, y00);
        };
    }
    function d3_geo_pathContext(context) {
        var pointRadius = 4.5;
        var stream = {
            point: point,
            lineStart: function() {
                stream.point = pointLineStart;
            },
            lineEnd: lineEnd,
            polygonStart: function() {
                stream.lineEnd = lineEndPolygon;
            },
            polygonEnd: function() {
                stream.lineEnd = lineEnd;
                stream.point = point;
            },
            pointRadius: function(_) {
                pointRadius = _;
                return stream;
            },
            result: d3_noop
        };
        function point(x, y) {
            context.moveTo(x, y);
            context.arc(x, y, pointRadius, 0, 2 * \u03C0);
        }
        function pointLineStart(x, y) {
            context.moveTo(x, y);
            stream.point = pointLine;
        }
        function pointLine(x, y) {
            context.lineTo(x, y);
        }
        function lineEnd() {
            stream.point = point;
        }
        function lineEndPolygon() {
            context.closePath();
        }
        return stream;
    }
    d3.geo.path = function() {
        var pointRadius = 4.5, projection, context, projectStream, contextStream;
        function path(object) {
            if (object) d3.geo.stream(object, projectStream(contextStream.pointRadius(typeof pointRadius === "function" ? +pointRadius.apply(this, arguments) : pointRadius)));
            return contextStream.result();
        }
        path.area = function(object) {
            d3_geo_pathAreaSum = 0;
            d3.geo.stream(object, projectStream(d3_geo_pathArea));
            return d3_geo_pathAreaSum;
        };
        path.centroid = function(object) {
            d3_geo_centroidDimension = d3_geo_centroidX = d3_geo_centroidY = d3_geo_centroidZ = 0;
            d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
            return d3_geo_centroidZ ? [
                d3_geo_centroidX / d3_geo_centroidZ,
                d3_geo_centroidY / d3_geo_centroidZ
            ] : undefined;
        };
        path.bounds = function(object) {
            return d3_geo_bounds(projectStream)(object);
        };
        path.projection = function(_) {
            if (!arguments.length) return projection;
            projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
            return path;
        };
        path.context = function(_) {
            if (!arguments.length) return context;
            contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
            return path;
        };
        path.pointRadius = function(_) {
            if (!arguments.length) return pointRadius;
            pointRadius = typeof _ === "function" ? _ : +_;
            return path;
        };
        return path.projection(d3.geo.albersUsa()).context(null);
    };
    function d3_geo_pathCircle(radius) {
        return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
    }
    function d3_geo_pathProjectStream(project) {
        var resample = d3_geo_resample(function(\u03BB, \u03C6) {
            return project([
                \u03BB * d3_degrees,
                \u03C6 * d3_degrees
            ]);
        });
        return function(stream) {
            stream = resample(stream);
            return {
                point: function(\u03BB, \u03C6) {
                    stream.point(\u03BB * d3_radians, \u03C6 * d3_radians);
                },
                sphere: function() {
                    stream.sphere();
                },
                lineStart: function() {
                    stream.lineStart();
                },
                lineEnd: function() {
                    stream.lineEnd();
                },
                polygonStart: function() {
                    stream.polygonStart();
                },
                polygonEnd: function() {
                    stream.polygonEnd();
                }
            };
        };
    }
    d3.geo.albers = function() {
        return d3.geo.conicEqualArea().parallels([
            29.5,
            45.5
        ]).rotate([
            98,
            0
        ]).center([
            0,
            38
        ]).scale(1e3);
    };
    function d3_geo_azimuthal(scale, angle) {
        function azimuthal(\u03BB, \u03C6) {
            var cos\u03BB = Math.cos(\u03BB), cos\u03C6 = Math.cos(\u03C6), k = scale(cos\u03BB * cos\u03C6);
            return [
                k * cos\u03C6 * Math.sin(\u03BB),
                k * Math.sin(\u03C6)
            ];
        }
        azimuthal.invert = function(x, y) {
            var \u03C1 = Math.sqrt(x * x + y * y), c = angle(\u03C1), sinc = Math.sin(c), cosc = Math.cos(c);
            return [
                Math.atan2(x * sinc, \u03C1 * cosc),
                Math.asin(\u03C1 && y * sinc / \u03C1)
            ];
        };
        return azimuthal;
    }
    var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cos\u03BBcos\u03C6) {
        return Math.sqrt(2 / (1 + cos\u03BBcos\u03C6));
    }, function(\u03C1) {
        return 2 * Math.asin(\u03C1 / 2);
    });
    (d3.geo.azimuthalEqualArea = function() {
        return d3_geo_projection(d3_geo_azimuthalEqualArea);
    }).raw = d3_geo_azimuthalEqualArea;
    var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cos\u03BBcos\u03C6) {
        var c = Math.acos(cos\u03BBcos\u03C6);
        return c && c / Math.sin(c);
    }, d3_identity);
    (d3.geo.azimuthalEquidistant = function() {
        return d3_geo_projection(d3_geo_azimuthalEquidistant);
    }).raw = d3_geo_azimuthalEquidistant;
    function d3_geo_conicConformal(\u03C60, \u03C61) {
        var cos\u03C60 = Math.cos(\u03C60), t = function(\u03C6) {
            return Math.tan(\u03C0 / 4 + \u03C6 / 2);
        }, n = \u03C60 === \u03C61 ? Math.sin(\u03C60) : Math.log(cos\u03C60 / Math.cos(\u03C61)) / Math.log(t(\u03C61) / t(\u03C60)), F = cos\u03C60 * Math.pow(t(\u03C60), n) / n;
        if (!n) return d3_geo_mercator;
        function forward(\u03BB, \u03C6) {
            var \u03C1 = Math.abs(Math.abs(\u03C6) - \u03C0 / 2) < \u03B5 ? 0 : F / Math.pow(t(\u03C6), n);
            return [
                \u03C1 * Math.sin(n * \u03BB),
                F - \u03C1 * Math.cos(n * \u03BB)
            ];
        }
        forward.invert = function(x, y) {
            var \u03C10_y = F - y, \u03C1 = d3_sgn(n) * Math.sqrt(x * x + \u03C10_y * \u03C10_y);
            return [
                Math.atan2(x, \u03C10_y) / n,
                2 * Math.atan(Math.pow(F / \u03C1, 1 / n)) - \u03C0 / 2
            ];
        };
        return forward;
    }
    (d3.geo.conicConformal = function() {
        return d3_geo_conic(d3_geo_conicConformal);
    }).raw = d3_geo_conicConformal;
    function d3_geo_conicEquidistant(\u03C60, \u03C61) {
        var cos\u03C60 = Math.cos(\u03C60), n = \u03C60 === \u03C61 ? Math.sin(\u03C60) : (cos\u03C60 - Math.cos(\u03C61)) / (\u03C61 - \u03C60), G = cos\u03C60 / n + \u03C60;
        if (Math.abs(n) < \u03B5) return d3_geo_equirectangular;
        function forward(\u03BB, \u03C6) {
            var \u03C1 = G - \u03C6;
            return [
                \u03C1 * Math.sin(n * \u03BB),
                G - \u03C1 * Math.cos(n * \u03BB)
            ];
        }
        forward.invert = function(x, y) {
            var \u03C10_y = G - y;
            return [
                Math.atan2(x, \u03C10_y) / n,
                G - d3_sgn(n) * Math.sqrt(x * x + \u03C10_y * \u03C10_y)
            ];
        };
        return forward;
    }
    (d3.geo.conicEquidistant = function() {
        return d3_geo_conic(d3_geo_conicEquidistant);
    }).raw = d3_geo_conicEquidistant;
    var d3_geo_gnomonic = d3_geo_azimuthal(function(cos\u03BBcos\u03C6) {
        return 1 / cos\u03BBcos\u03C6;
    }, Math.atan);
    (d3.geo.gnomonic = function() {
        return d3_geo_projection(d3_geo_gnomonic);
    }).raw = d3_geo_gnomonic;
    function d3_geo_mercator(\u03BB, \u03C6) {
        return [
            \u03BB,
            Math.log(Math.tan(\u03C0 / 4 + \u03C6 / 2))
        ];
    }
    d3_geo_mercator.invert = function(x, y) {
        return [
            x,
            2 * Math.atan(Math.exp(y)) - \u03C0 / 2
        ];
    };
    function d3_geo_mercatorProjection(project) {
        var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
        m.scale = function() {
            var v = scale.apply(m, arguments);
            return v === m ? clipAuto ? m.clipExtent(null) : m : v;
        };
        m.translate = function() {
            var v = translate.apply(m, arguments);
            return v === m ? clipAuto ? m.clipExtent(null) : m : v;
        };
        m.clipExtent = function(_) {
            var v = clipExtent.apply(m, arguments);
            if (v === m) {
                if (clipAuto = _ == null) {
                    var k = \u03C0 * scale(), t = translate();
                    clipExtent([
                        [
                            t[0] - k,
                            t[1] - k
                        ],
                        [
                            t[0] + k,
                            t[1] + k
                        ]
                    ]);
                }
            } else if (clipAuto) v = null;
            return v;
        };
        return m.clipExtent(null);
    }
    (d3.geo.mercator = function() {
        return d3_geo_mercatorProjection(d3_geo_mercator);
    }).raw = d3_geo_mercator;
    var d3_geo_orthographic = d3_geo_azimuthal(function() {
        return 1;
    }, Math.asin);
    (d3.geo.orthographic = function() {
        return d3_geo_projection(d3_geo_orthographic);
    }).raw = d3_geo_orthographic;
    var d3_geo_stereographic = d3_geo_azimuthal(function(cos\u03BBcos\u03C6) {
        return 1 / (1 + cos\u03BBcos\u03C6);
    }, function(\u03C1) {
        return 2 * Math.atan(\u03C1);
    });
    (d3.geo.stereographic = function() {
        return d3_geo_projection(d3_geo_stereographic);
    }).raw = d3_geo_stereographic;
    function d3_geo_transverseMercator(\u03BB, \u03C6) {
        var B = Math.cos(\u03C6) * Math.sin(\u03BB);
        return [
            Math.log((1 + B) / (1 - B)) / 2,
            Math.atan2(Math.tan(\u03C6), Math.cos(\u03BB))
        ];
    }
    d3_geo_transverseMercator.invert = function(x, y) {
        return [
            Math.atan2(d3_sinh(x), Math.cos(y)),
            d3_asin(Math.sin(y) / d3_cosh(x))
        ];
    };
    (d3.geo.transverseMercator = function() {
        return d3_geo_mercatorProjection(d3_geo_transverseMercator);
    }).raw = d3_geo_transverseMercator;
    d3.geom = {};
    d3.svg = {};
    function d3_svg_line(projection) {
        var x = d3_svg_lineX, y = d3_svg_lineY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
        function line(data) {
            var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
            function segment() {
                segments.push("M", interpolate(projection(points), tension));
            }
            while(++i < n){
                if (defined.call(this, d = data[i], i)) points.push([
                    +fx.call(this, d, i),
                    +fy.call(this, d, i)
                ]);
                else if (points.length) {
                    segment();
                    points = [];
                }
            }
            if (points.length) segment();
            return segments.length ? segments.join("") : null;
        }
        line.x = function(_) {
            if (!arguments.length) return x;
            x = _;
            return line;
        };
        line.y = function(_) {
            if (!arguments.length) return y;
            y = _;
            return line;
        };
        line.defined = function(_) {
            if (!arguments.length) return defined;
            defined = _;
            return line;
        };
        line.interpolate = function(_) {
            if (!arguments.length) return interpolateKey;
            if (typeof _ === "function") interpolateKey = interpolate = _;
            else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
            return line;
        };
        line.tension = function(_) {
            if (!arguments.length) return tension;
            tension = _;
            return line;
        };
        return line;
    }
    d3.svg.line = function() {
        return d3_svg_line(d3_identity);
    };
    function d3_svg_lineX(d) {
        return d[0];
    }
    function d3_svg_lineY(d) {
        return d[1];
    }
    var d3_svg_lineInterpolators = d3.map({
        linear: d3_svg_lineLinear,
        "linear-closed": d3_svg_lineLinearClosed,
        "step-before": d3_svg_lineStepBefore,
        "step-after": d3_svg_lineStepAfter,
        basis: d3_svg_lineBasis,
        "basis-open": d3_svg_lineBasisOpen,
        "basis-closed": d3_svg_lineBasisClosed,
        bundle: d3_svg_lineBundle,
        cardinal: d3_svg_lineCardinal,
        "cardinal-open": d3_svg_lineCardinalOpen,
        "cardinal-closed": d3_svg_lineCardinalClosed,
        monotone: d3_svg_lineMonotone
    });
    d3_svg_lineInterpolators.forEach(function(key, value) {
        value.key = key;
        value.closed = /-closed$/.test(key);
    });
    function d3_svg_lineLinear(points) {
        return points.join("L");
    }
    function d3_svg_lineLinearClosed(points) {
        return d3_svg_lineLinear(points) + "Z";
    }
    function d3_svg_lineStepBefore(points) {
        var i = 0, n = points.length, p = points[0], path = [
            p[0],
            ",",
            p[1]
        ];
        while(++i < n)path.push("V", (p = points[i])[1], "H", p[0]);
        return path.join("");
    }
    function d3_svg_lineStepAfter(points) {
        var i = 0, n = points.length, p = points[0], path = [
            p[0],
            ",",
            p[1]
        ];
        while(++i < n)path.push("H", (p = points[i])[0], "V", p[1]);
        return path.join("");
    }
    function d3_svg_lineCardinalOpen(points, tension) {
        return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, points.length - 1), d3_svg_lineCardinalTangents(points, tension));
    }
    function d3_svg_lineCardinalClosed(points, tension) {
        return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), points), d3_svg_lineCardinalTangents([
            points[points.length - 2]
        ].concat(points, [
            points[1]
        ]), tension));
    }
    function d3_svg_lineCardinal(points, tension) {
        return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
    }
    function d3_svg_lineHermite(points, tangents) {
        if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) return d3_svg_lineLinear(points);
        var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
        if (quad) {
            path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
            p0 = points[1];
            pi = 2;
        }
        if (tangents.length > 1) {
            t = tangents[1];
            p = points[pi];
            pi++;
            path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
            for(var i = 2; i < tangents.length; i++, pi++){
                p = points[pi];
                t = tangents[i];
                path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
            }
        }
        if (quad) {
            var lp = points[pi];
            path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
        }
        return path;
    }
    function d3_svg_lineCardinalTangents(points, tension) {
        var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
        while(++i < n){
            p0 = p1;
            p1 = p2;
            p2 = points[i];
            tangents.push([
                a * (p2[0] - p0[0]),
                a * (p2[1] - p0[1])
            ]);
        }
        return tangents;
    }
    function d3_svg_lineBasis(points) {
        if (points.length < 3) return d3_svg_lineLinear(points);
        var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [
            x0,
            x0,
            x0,
            (pi = points[1])[0]
        ], py = [
            y0,
            y0,
            y0,
            pi[1]
        ], path = [
            x0,
            ",",
            y0
        ];
        d3_svg_lineBasisBezier(path, px, py);
        while(++i < n){
            pi = points[i];
            px.shift();
            px.push(pi[0]);
            py.shift();
            py.push(pi[1]);
            d3_svg_lineBasisBezier(path, px, py);
        }
        i = -1;
        while(++i < 2){
            px.shift();
            px.push(pi[0]);
            py.shift();
            py.push(pi[1]);
            d3_svg_lineBasisBezier(path, px, py);
        }
        return path.join("");
    }
    function d3_svg_lineBasisOpen(points) {
        if (points.length < 4) return d3_svg_lineLinear(points);
        var path = [], i = -1, n = points.length, pi, px = [
            0
        ], py = [
            0
        ];
        while(++i < 3){
            pi = points[i];
            px.push(pi[0]);
            py.push(pi[1]);
        }
        path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
        --i;
        while(++i < n){
            pi = points[i];
            px.shift();
            px.push(pi[0]);
            py.shift();
            py.push(pi[1]);
            d3_svg_lineBasisBezier(path, px, py);
        }
        return path.join("");
    }
    function d3_svg_lineBasisClosed(points) {
        var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
        while(++i < 4){
            pi = points[i % n];
            px.push(pi[0]);
            py.push(pi[1]);
        }
        path = [
            d3_svg_lineDot4(d3_svg_lineBasisBezier3, px),
            ",",
            d3_svg_lineDot4(d3_svg_lineBasisBezier3, py)
        ];
        --i;
        while(++i < m){
            pi = points[i % n];
            px.shift();
            px.push(pi[0]);
            py.shift();
            py.push(pi[1]);
            d3_svg_lineBasisBezier(path, px, py);
        }
        return path.join("");
    }
    function d3_svg_lineBundle(points, tension) {
        var n = points.length - 1;
        if (n) {
            var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
            while(++i <= n){
                p = points[i];
                t = i / n;
                p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
                p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
            }
        }
        return d3_svg_lineBasis(points);
    }
    function d3_svg_lineDot4(a, b1) {
        return a[0] * b1[0] + a[1] * b1[1] + a[2] * b1[2] + a[3] * b1[3];
    }
    var d3_svg_lineBasisBezier1 = [
        0,
        2 / 3,
        1 / 3,
        0
    ], d3_svg_lineBasisBezier2 = [
        0,
        1 / 3,
        2 / 3,
        0
    ], d3_svg_lineBasisBezier3 = [
        0,
        1 / 6,
        2 / 3,
        1 / 6
    ];
    function d3_svg_lineBasisBezier(path, x, y) {
        path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
    }
    function d3_svg_lineSlope(p0, p1) {
        return (p1[1] - p0[1]) / (p1[0] - p0[0]);
    }
    function d3_svg_lineFiniteDifferences(points) {
        var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
        while(++i < j)m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
        m[i] = d;
        return m;
    }
    function d3_svg_lineMonotoneTangents(points) {
        var tangents = [], d, a, b1, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
        while(++i < j){
            d = d3_svg_lineSlope(points[i], points[i + 1]);
            if (Math.abs(d) < 1e-6) m[i] = m[i + 1] = 0;
            else {
                a = m[i] / d;
                b1 = m[i + 1] / d;
                s = a * a + b1 * b1;
                if (s > 9) {
                    s = d * 3 / Math.sqrt(s);
                    m[i] = s * a;
                    m[i + 1] = s * b1;
                }
            }
        }
        i = -1;
        while(++i <= j){
            s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
            tangents.push([
                s || 0,
                m[i] * s || 0
            ]);
        }
        return tangents;
    }
    function d3_svg_lineMonotone(points) {
        return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
    }
    d3.geom.hull = function(vertices) {
        var x = d3_svg_lineX, y = d3_svg_lineY;
        if (arguments.length) return hull(vertices);
        function hull(data) {
            if (data.length < 3) return [];
            var fx = d3_functor(x), fy = d3_functor(y), n = data.length, vertices, plen = n - 1, points = [], stack = [], d, i, j, h = 0, x1, y1, x2, y2, u, v, a, sp;
            if (fx === d3_svg_lineX && y === d3_svg_lineY) vertices = data;
            else for(i = 0, vertices = []; i < n; ++i)vertices.push([
                +fx.call(this, d = data[i], i),
                +fy.call(this, d, i)
            ]);
            for(i = 1; i < n; ++i){
                if (vertices[i][1] < vertices[h][1]) h = i;
                else if (vertices[i][1] == vertices[h][1]) h = vertices[i][0] < vertices[h][0] ? i : h;
            }
            for(i = 0; i < n; ++i){
                if (i === h) continue;
                y1 = vertices[i][1] - vertices[h][1];
                x1 = vertices[i][0] - vertices[h][0];
                points.push({
                    angle: Math.atan2(y1, x1),
                    index: i
                });
            }
            points.sort(function(a, b1) {
                return a.angle - b1.angle;
            });
            a = points[0].angle;
            v = points[0].index;
            u = 0;
            for(i = 1; i < plen; ++i){
                j = points[i].index;
                if (a == points[i].angle) {
                    x1 = vertices[v][0] - vertices[h][0];
                    y1 = vertices[v][1] - vertices[h][1];
                    x2 = vertices[j][0] - vertices[h][0];
                    y2 = vertices[j][1] - vertices[h][1];
                    if (x1 * x1 + y1 * y1 >= x2 * x2 + y2 * y2) points[i].index = -1;
                    else {
                        points[u].index = -1;
                        a = points[i].angle;
                        u = i;
                        v = j;
                    }
                } else {
                    a = points[i].angle;
                    u = i;
                    v = j;
                }
            }
            stack.push(h);
            for(i = 0, j = 0; i < 2; ++j)if (points[j].index !== -1) {
                stack.push(points[j].index);
                i++;
            }
            sp = stack.length;
            for(; j < plen; ++j){
                if (points[j].index === -1) continue;
                while(!d3_geom_hullCCW(stack[sp - 2], stack[sp - 1], points[j].index, vertices))--sp;
                stack[sp++] = points[j].index;
            }
            var poly = [];
            for(i = 0; i < sp; ++i)poly.push(data[stack[i]]);
            return poly;
        }
        hull.x = function(_) {
            return arguments.length ? (x = _, hull) : x;
        };
        hull.y = function(_) {
            return arguments.length ? (y = _, hull) : y;
        };
        return hull;
    };
    function d3_geom_hullCCW(i1, i2, i3, v) {
        var t, a, b1, c, d, e, f;
        t = v[i1];
        a = t[0];
        b1 = t[1];
        t = v[i2];
        c = t[0];
        d = t[1];
        t = v[i3];
        e = t[0];
        f = t[1];
        return (f - b1) * (c - a) - (d - b1) * (e - a) > 0;
    }
    d3.geom.polygon = function(coordinates) {
        coordinates.area = function() {
            var i = 0, n = coordinates.length, area = coordinates[n - 1][1] * coordinates[0][0] - coordinates[n - 1][0] * coordinates[0][1];
            while(++i < n)area += coordinates[i - 1][1] * coordinates[i][0] - coordinates[i - 1][0] * coordinates[i][1];
            return area * .5;
        };
        coordinates.centroid = function(k) {
            var i = -1, n = coordinates.length, x = 0, y = 0, a, b1 = coordinates[n - 1], c;
            if (!arguments.length) k = -1 / (6 * coordinates.area());
            while(++i < n){
                a = b1;
                b1 = coordinates[i];
                c = a[0] * b1[1] - b1[0] * a[1];
                x += (a[0] + b1[0]) * c;
                y += (a[1] + b1[1]) * c;
            }
            return [
                x * k,
                y * k
            ];
        };
        coordinates.clip = function(subject) {
            var input, i = -1, n = coordinates.length, j, m, a = coordinates[n - 1], b1, c, d;
            while(++i < n){
                input = subject.slice();
                subject.length = 0;
                b1 = coordinates[i];
                c = input[(m = input.length) - 1];
                j = -1;
                while(++j < m){
                    d = input[j];
                    if (d3_geom_polygonInside(d, a, b1)) {
                        if (!d3_geom_polygonInside(c, a, b1)) subject.push(d3_geom_polygonIntersect(c, d, a, b1));
                        subject.push(d);
                    } else if (d3_geom_polygonInside(c, a, b1)) subject.push(d3_geom_polygonIntersect(c, d, a, b1));
                    c = d;
                }
                a = b1;
            }
            return subject;
        };
        return coordinates;
    };
    function d3_geom_polygonInside(p, a, b1) {
        return (b1[0] - a[0]) * (p[1] - a[1]) < (b1[1] - a[1]) * (p[0] - a[0]);
    }
    function d3_geom_polygonIntersect(c, d, a, b1) {
        var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b1[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b1[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
        return [
            x1 + ua * x21,
            y1 + ua * y21
        ];
    }
    d3.geom.delaunay = function(vertices) {
        var edges = vertices.map(function() {
            return [];
        }), triangles = [];
        d3_geom_voronoiTessellate(vertices, function(e) {
            edges[e.region.l.index].push(vertices[e.region.r.index]);
        });
        edges.forEach(function(edge, i) {
            var v = vertices[i], cx = v[0], cy = v[1];
            edge.forEach(function(v) {
                v.angle = Math.atan2(v[0] - cx, v[1] - cy);
            });
            edge.sort(function(a, b1) {
                return a.angle - b1.angle;
            });
            for(var j = 0, m = edge.length - 1; j < m; j++)triangles.push([
                v,
                edge[j],
                edge[j + 1]
            ]);
        });
        return triangles;
    };
    d3.geom.voronoi = function(points) {
        var size = null, x = d3_svg_lineX, y = d3_svg_lineY, clip;
        if (arguments.length) return voronoi(points);
        function voronoi(data) {
            var points, polygons = data.map(function() {
                return [];
            }), fx = d3_functor(x), fy = d3_functor(y), d, i, n = data.length, Z = 1e6;
            if (fx === d3_svg_lineX && fy === d3_svg_lineY) points = data;
            else for(points = [], i = 0; i < n; ++i)points.push([
                +fx.call(this, d = data[i], i),
                +fy.call(this, d, i)
            ]);
            d3_geom_voronoiTessellate(points, function(e) {
                var s1, s2, x1, x2, y1, y2;
                if (e.a === 1 && e.b >= 0) {
                    s1 = e.ep.r;
                    s2 = e.ep.l;
                } else {
                    s1 = e.ep.l;
                    s2 = e.ep.r;
                }
                if (e.a === 1) {
                    y1 = s1 ? s1.y : -Z;
                    x1 = e.c - e.b * y1;
                    y2 = s2 ? s2.y : Z;
                    x2 = e.c - e.b * y2;
                } else {
                    x1 = s1 ? s1.x : -Z;
                    y1 = e.c - e.a * x1;
                    x2 = s2 ? s2.x : Z;
                    y2 = e.c - e.a * x2;
                }
                var v1 = [
                    x1,
                    y1
                ], v2 = [
                    x2,
                    y2
                ];
                polygons[e.region.l.index].push(v1, v2);
                polygons[e.region.r.index].push(v1, v2);
            });
            polygons = polygons.map(function(polygon, i) {
                var cx = points[i][0], cy = points[i][1], angle = polygon.map(function(v) {
                    return Math.atan2(v[0] - cx, v[1] - cy);
                }), order = d3.range(polygon.length).sort(function(a, b1) {
                    return angle[a] - angle[b1];
                });
                return order.filter(function(d, i) {
                    return !i || angle[d] - angle[order[i - 1]] > \u03B5;
                }).map(function(d) {
                    return polygon[d];
                });
            });
            polygons.forEach(function(polygon, i) {
                var n = polygon.length;
                if (!n) return polygon.push([
                    -Z,
                    -Z
                ], [
                    -Z,
                    Z
                ], [
                    Z,
                    Z
                ], [
                    Z,
                    -Z
                ]);
                if (n > 2) return;
                var p0 = points[i], p1 = polygon[0], p2 = polygon[1], x0 = p0[0], y0 = p0[1], x1 = p1[0], y1 = p1[1], x2 = p2[0], y2 = p2[1], dx = Math.abs(x2 - x1), dy = y2 - y1;
                if (Math.abs(dy) < \u03B5) {
                    var y = y0 < y1 ? -Z : Z;
                    polygon.push([
                        -Z,
                        y
                    ], [
                        Z,
                        y
                    ]);
                } else if (dx < \u03B5) {
                    var x = x0 < x1 ? -Z : Z;
                    polygon.push([
                        x,
                        -Z
                    ], [
                        x,
                        Z
                    ]);
                } else {
                    var y = (x2 - x1) * (y1 - y0) < (x1 - x0) * (y2 - y1) ? Z : -Z, z = Math.abs(dy) - dx;
                    if (Math.abs(z) < \u03B5) polygon.push([
                        dy < 0 ? y : -y,
                        y
                    ]);
                    else {
                        if (z > 0) y *= -1;
                        polygon.push([
                            -Z,
                            y
                        ], [
                            Z,
                            y
                        ]);
                    }
                }
            });
            if (clip) for(i = 0; i < n; ++i)clip(polygons[i]);
            for(i = 0; i < n; ++i)polygons[i].point = data[i];
            return polygons;
        }
        voronoi.x = function(_) {
            return arguments.length ? (x = _, voronoi) : x;
        };
        voronoi.y = function(_) {
            return arguments.length ? (y = _, voronoi) : y;
        };
        voronoi.size = function(_) {
            if (!arguments.length) return size;
            if (_ == null) clip = null;
            else {
                size = [
                    +_[0],
                    +_[1]
                ];
                clip = d3.geom.polygon([
                    [
                        0,
                        0
                    ],
                    [
                        0,
                        size[1]
                    ],
                    size,
                    [
                        size[0],
                        0
                    ]
                ]).clip;
            }
            return voronoi;
        };
        voronoi.links = function(data) {
            var points, graph = data.map(function() {
                return [];
            }), links = [], fx = d3_functor(x), fy = d3_functor(y), d, i, n = data.length;
            if (fx === d3_svg_lineX && fy === d3_svg_lineY) points = data;
            else for(i = 0; i < n; ++i)points.push([
                +fx.call(this, d = data[i], i),
                +fy.call(this, d, i)
            ]);
            d3_geom_voronoiTessellate(points, function(e) {
                var l = e.region.l.index, r = e.region.r.index;
                if (graph[l][r]) return;
                graph[l][r] = graph[r][l] = true;
                links.push({
                    source: data[l],
                    target: data[r]
                });
            });
            return links;
        };
        voronoi.triangles = function(data) {
            if (x === d3_svg_lineX && y === d3_svg_lineY) return d3.geom.delaunay(data);
            var points, point, fx = d3_functor(x), fy = d3_functor(y), d, i, n;
            for(i = 0, points = [], n = data.length; i < n; ++i){
                point = [
                    +fx.call(this, d = data[i], i),
                    +fy.call(this, d, i)
                ];
                point.data = d;
                points.push(point);
            }
            return d3.geom.delaunay(points).map(function(triangle) {
                return triangle.map(function(point) {
                    return point.data;
                });
            });
        };
        return voronoi;
    };
    var d3_geom_voronoiOpposite = {
        l: "r",
        r: "l"
    };
    function d3_geom_voronoiTessellate(points, callback) {
        var Sites = {
            list: points.map(function(v, i) {
                return {
                    index: i,
                    x: v[0],
                    y: v[1]
                };
            }).sort(function(a, b1) {
                return a.y < b1.y ? -1 : a.y > b1.y ? 1 : a.x < b1.x ? -1 : a.x > b1.x ? 1 : 0;
            }),
            bottomSite: null
        };
        var EdgeList = {
            list: [],
            leftEnd: null,
            rightEnd: null,
            init: function() {
                EdgeList.leftEnd = EdgeList.createHalfEdge(null, "l");
                EdgeList.rightEnd = EdgeList.createHalfEdge(null, "l");
                EdgeList.leftEnd.r = EdgeList.rightEnd;
                EdgeList.rightEnd.l = EdgeList.leftEnd;
                EdgeList.list.unshift(EdgeList.leftEnd, EdgeList.rightEnd);
            },
            createHalfEdge: function(edge, side) {
                return {
                    edge: edge,
                    side: side,
                    vertex: null,
                    l: null,
                    r: null
                };
            },
            insert: function(lb, he) {
                he.l = lb;
                he.r = lb.r;
                lb.r.l = he;
                lb.r = he;
            },
            leftBound: function(p) {
                var he = EdgeList.leftEnd;
                do he = he.r;
                while (he != EdgeList.rightEnd && Geom.rightOf(he, p));
                he = he.l;
                return he;
            },
            del: function(he) {
                he.l.r = he.r;
                he.r.l = he.l;
                he.edge = null;
            },
            right: function(he) {
                return he.r;
            },
            left: function(he) {
                return he.l;
            },
            leftRegion: function(he) {
                return he.edge == null ? Sites.bottomSite : he.edge.region[he.side];
            },
            rightRegion: function(he) {
                return he.edge == null ? Sites.bottomSite : he.edge.region[d3_geom_voronoiOpposite[he.side]];
            }
        };
        var Geom = {
            bisect: function(s1, s2) {
                var newEdge = {
                    region: {
                        l: s1,
                        r: s2
                    },
                    ep: {
                        l: null,
                        r: null
                    }
                };
                var dx = s2.x - s1.x, dy = s2.y - s1.y, adx = dx > 0 ? dx : -dx, ady = dy > 0 ? dy : -dy;
                newEdge.c = s1.x * dx + s1.y * dy + (dx * dx + dy * dy) * .5;
                if (adx > ady) {
                    newEdge.a = 1;
                    newEdge.b = dy / dx;
                    newEdge.c /= dx;
                } else {
                    newEdge.b = 1;
                    newEdge.a = dx / dy;
                    newEdge.c /= dy;
                }
                return newEdge;
            },
            intersect: function(el1, el2) {
                var e1 = el1.edge, e2 = el2.edge;
                if (!e1 || !e2 || e1.region.r == e2.region.r) return null;
                var d = e1.a * e2.b - e1.b * e2.a;
                if (Math.abs(d) < 1e-10) return null;
                var xint = (e1.c * e2.b - e2.c * e1.b) / d, yint = (e2.c * e1.a - e1.c * e2.a) / d, e1r = e1.region.r, e2r = e2.region.r, el, e;
                if (e1r.y < e2r.y || e1r.y == e2r.y && e1r.x < e2r.x) {
                    el = el1;
                    e = e1;
                } else {
                    el = el2;
                    e = e2;
                }
                var rightOfSite = xint >= e.region.r.x;
                if (rightOfSite && el.side === "l" || !rightOfSite && el.side === "r") return null;
                return {
                    x: xint,
                    y: yint
                };
            },
            rightOf: function(he, p) {
                var e = he.edge, topsite = e.region.r, rightOfSite = p.x > topsite.x;
                if (rightOfSite && he.side === "l") return 1;
                if (!rightOfSite && he.side === "r") return 0;
                if (e.a === 1) {
                    var dyp = p.y - topsite.y, dxp = p.x - topsite.x, fast = 0, above = 0;
                    if (!rightOfSite && e.b < 0 || rightOfSite && e.b >= 0) above = fast = dyp >= e.b * dxp;
                    else {
                        above = p.x + p.y * e.b > e.c;
                        if (e.b < 0) above = !above;
                        if (!above) fast = 1;
                    }
                    if (!fast) {
                        var dxs = topsite.x - e.region.l.x;
                        above = e.b * (dxp * dxp - dyp * dyp) < dxs * dyp * (1 + 2 * dxp / dxs + e.b * e.b);
                        if (e.b < 0) above = !above;
                    }
                } else {
                    var yl = e.c - e.a * p.x, t1 = p.y - yl, t2 = p.x - topsite.x, t3 = yl - topsite.y;
                    above = t1 * t1 > t2 * t2 + t3 * t3;
                }
                return he.side === "l" ? above : !above;
            },
            endPoint: function(edge, side, site) {
                edge.ep[side] = site;
                if (!edge.ep[d3_geom_voronoiOpposite[side]]) return;
                callback(edge);
            },
            distance: function(s, t) {
                var dx = s.x - t.x, dy = s.y - t.y;
                return Math.sqrt(dx * dx + dy * dy);
            }
        };
        var EventQueue = {
            list: [],
            insert: function(he, site, offset) {
                he.vertex = site;
                he.ystar = site.y + offset;
                for(var i = 0, list = EventQueue.list, l = list.length; i < l; i++){
                    var next = list[i];
                    if (he.ystar > next.ystar || he.ystar == next.ystar && site.x > next.vertex.x) continue;
                    else break;
                }
                list.splice(i, 0, he);
            },
            del: function(he) {
                for(var i = 0, ls = EventQueue.list, l = ls.length; i < l && ls[i] != he; ++i);
                ls.splice(i, 1);
            },
            empty: function() {
                return EventQueue.list.length === 0;
            },
            nextEvent: function(he) {
                for(var i = 0, ls = EventQueue.list, l = ls.length; i < l; ++i){
                    if (ls[i] == he) return ls[i + 1];
                }
                return null;
            },
            min: function() {
                var elem = EventQueue.list[0];
                return {
                    x: elem.vertex.x,
                    y: elem.ystar
                };
            },
            extractMin: function() {
                return EventQueue.list.shift();
            }
        };
        EdgeList.init();
        Sites.bottomSite = Sites.list.shift();
        var newSite = Sites.list.shift(), newIntStar;
        var lbnd, rbnd, llbnd, rrbnd, bisector;
        var bot, top, temp, p, v;
        var e, pm;
        while(true){
            if (!EventQueue.empty()) newIntStar = EventQueue.min();
            if (newSite && (EventQueue.empty() || newSite.y < newIntStar.y || newSite.y == newIntStar.y && newSite.x < newIntStar.x)) {
                lbnd = EdgeList.leftBound(newSite);
                rbnd = EdgeList.right(lbnd);
                bot = EdgeList.rightRegion(lbnd);
                e = Geom.bisect(bot, newSite);
                bisector = EdgeList.createHalfEdge(e, "l");
                EdgeList.insert(lbnd, bisector);
                p = Geom.intersect(lbnd, bisector);
                if (p) {
                    EventQueue.del(lbnd);
                    EventQueue.insert(lbnd, p, Geom.distance(p, newSite));
                }
                lbnd = bisector;
                bisector = EdgeList.createHalfEdge(e, "r");
                EdgeList.insert(lbnd, bisector);
                p = Geom.intersect(bisector, rbnd);
                if (p) EventQueue.insert(bisector, p, Geom.distance(p, newSite));
                newSite = Sites.list.shift();
            } else if (!EventQueue.empty()) {
                lbnd = EventQueue.extractMin();
                llbnd = EdgeList.left(lbnd);
                rbnd = EdgeList.right(lbnd);
                rrbnd = EdgeList.right(rbnd);
                bot = EdgeList.leftRegion(lbnd);
                top = EdgeList.rightRegion(rbnd);
                v = lbnd.vertex;
                Geom.endPoint(lbnd.edge, lbnd.side, v);
                Geom.endPoint(rbnd.edge, rbnd.side, v);
                EdgeList.del(lbnd);
                EventQueue.del(rbnd);
                EdgeList.del(rbnd);
                pm = "l";
                if (bot.y > top.y) {
                    temp = bot;
                    bot = top;
                    top = temp;
                    pm = "r";
                }
                e = Geom.bisect(bot, top);
                bisector = EdgeList.createHalfEdge(e, pm);
                EdgeList.insert(llbnd, bisector);
                Geom.endPoint(e, d3_geom_voronoiOpposite[pm], v);
                p = Geom.intersect(llbnd, bisector);
                if (p) {
                    EventQueue.del(llbnd);
                    EventQueue.insert(llbnd, p, Geom.distance(p, bot));
                }
                p = Geom.intersect(bisector, rrbnd);
                if (p) EventQueue.insert(bisector, p, Geom.distance(p, bot));
            } else break;
        }
        for(lbnd = EdgeList.right(EdgeList.leftEnd); lbnd != EdgeList.rightEnd; lbnd = EdgeList.right(lbnd))callback(lbnd.edge);
    }
    d3.geom.quadtree = function(points, x1, y1, x2, y2) {
        var x = d3_svg_lineX, y = d3_svg_lineY, compat;
        if (compat = arguments.length) {
            x = d3_geom_quadtreeCompatX;
            y = d3_geom_quadtreeCompatY;
            if (compat === 3) {
                y2 = y1;
                x2 = x1;
                y1 = x1 = 0;
            }
            return quadtree(points);
        }
        function quadtree(data) {
            var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
            if (x1 != null) x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
            else {
                x2_ = y2_ = -(x1_ = y1_ = Infinity);
                xs = [], ys = [];
                n = data.length;
                if (compat) for(i = 0; i < n; ++i){
                    d = data[i];
                    if (d.x < x1_) x1_ = d.x;
                    if (d.y < y1_) y1_ = d.y;
                    if (d.x > x2_) x2_ = d.x;
                    if (d.y > y2_) y2_ = d.y;
                    xs.push(d.x);
                    ys.push(d.y);
                }
                else for(i = 0; i < n; ++i){
                    var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
                    if (x_ < x1_) x1_ = x_;
                    if (y_ < y1_) y1_ = y_;
                    if (x_ > x2_) x2_ = x_;
                    if (y_ > y2_) y2_ = y_;
                    xs.push(x_);
                    ys.push(y_);
                }
            }
            var dx = x2_ - x1_, dy = y2_ - y1_;
            if (dx > dy) y2_ = y1_ + dx;
            else x2_ = x1_ + dy;
            function insert(n, d, x, y, x1, y1, x2, y2) {
                if (isNaN(x) || isNaN(y)) return;
                if (n.leaf) {
                    var nx = n.x, ny = n.y;
                    if (nx != null) {
                        if (Math.abs(nx - x) + Math.abs(ny - y) < .01) insertChild(n, d, x, y, x1, y1, x2, y2);
                        else {
                            var nPoint = n.point;
                            n.x = n.y = n.point = null;
                            insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
                            insertChild(n, d, x, y, x1, y1, x2, y2);
                        }
                    } else n.x = x, n.y = y, n.point = d;
                } else insertChild(n, d, x, y, x1, y1, x2, y2);
            }
            function insertChild(n, d, x, y, x1, y1, x2, y2) {
                var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, right = x >= sx, bottom = y >= sy, i = (bottom << 1) + right;
                n.leaf = false;
                n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
                if (right) x1 = sx;
                else x2 = sx;
                if (bottom) y1 = sy;
                else y2 = sy;
                insert(n, d, x, y, x1, y1, x2, y2);
            }
            var root = d3_geom_quadtreeNode();
            root.add = function(d) {
                insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
            };
            root.visit = function(f) {
                d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
            };
            i = -1;
            if (x1 == null) {
                while(++i < n)insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
                --i;
            } else data.forEach(root.add);
            xs = ys = data = d = null;
            return root;
        }
        quadtree.x = function(_) {
            return arguments.length ? (x = _, quadtree) : x;
        };
        quadtree.y = function(_) {
            return arguments.length ? (y = _, quadtree) : y;
        };
        quadtree.size = function(_) {
            if (!arguments.length) return x1 == null ? null : [
                x2,
                y2
            ];
            if (_ == null) x1 = y1 = x2 = y2 = null;
            else {
                x1 = y1 = 0;
                x2 = +_[0], y2 = +_[1];
            }
            return quadtree;
        };
        return quadtree;
    };
    function d3_geom_quadtreeCompatX(d) {
        return d.x;
    }
    function d3_geom_quadtreeCompatY(d) {
        return d.y;
    }
    function d3_geom_quadtreeNode() {
        return {
            leaf: true,
            nodes: [],
            point: null,
            x: null,
            y: null
        };
    }
    function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
        if (!f(node, x1, y1, x2, y2)) {
            var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
            if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
            if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
            if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
            if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
        }
    }
    d3.interpolateRgb = d3_interpolateRgb;
    function d3_interpolateRgb(a, b1) {
        a = d3.rgb(a);
        b1 = d3.rgb(b1);
        var ar = a.r, ag = a.g, ab = a.b, br = b1.r - ar, bg = b1.g - ag, bb = b1.b - ab;
        return function(t) {
            return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
        };
    }
    d3.transform = function(string) {
        var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
        return (d3.transform = function(string) {
            g.setAttribute("transform", string);
            var t = g.transform.baseVal.consolidate();
            return new d3_transform(t ? t.matrix : d3_transformIdentity);
        })(string);
    };
    function d3_transform(m) {
        var r0 = [
            m.a,
            m.b
        ], r1 = [
            m.c,
            m.d
        ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
        if (r0[0] * r1[1] < r1[0] * r0[1]) {
            r0[0] *= -1;
            r0[1] *= -1;
            kx *= -1;
            kz *= -1;
        }
        this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
        this.translate = [
            m.e,
            m.f
        ];
        this.scale = [
            kx,
            ky
        ];
        this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
    }
    d3_transform.prototype.toString = function() {
        return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
    };
    function d3_transformDot(a, b1) {
        return a[0] * b1[0] + a[1] * b1[1];
    }
    function d3_transformNormalize(a) {
        var k = Math.sqrt(d3_transformDot(a, a));
        if (k) {
            a[0] /= k;
            a[1] /= k;
        }
        return k;
    }
    function d3_transformCombine(a, b1, k) {
        a[0] += k * b1[0];
        a[1] += k * b1[1];
        return a;
    }
    var d3_transformIdentity = {
        a: 1,
        b: 0,
        c: 0,
        d: 1,
        e: 0,
        f: 0
    };
    d3.interpolateNumber = d3_interpolateNumber;
    function d3_interpolateNumber(a, b1) {
        b1 -= a = +a;
        return function(t) {
            return a + b1 * t;
        };
    }
    d3.interpolateTransform = d3_interpolateTransform;
    function d3_interpolateTransform(a, b1) {
        var s = [], q = [], n, A = d3.transform(a), B = d3.transform(b1), ta = A.translate, tb = B.translate, ra = A.rotate, rb = B.rotate, wa = A.skew, wb = B.skew, ka = A.scale, kb = B.scale;
        if (ta[0] != tb[0] || ta[1] != tb[1]) {
            s.push("translate(", null, ",", null, ")");
            q.push({
                i: 1,
                x: d3_interpolateNumber(ta[0], tb[0])
            }, {
                i: 3,
                x: d3_interpolateNumber(ta[1], tb[1])
            });
        } else if (tb[0] || tb[1]) s.push("translate(" + tb + ")");
        else s.push("");
        if (ra != rb) {
            if (ra - rb > 180) rb += 360;
            else if (rb - ra > 180) ra += 360;
            q.push({
                i: s.push(s.pop() + "rotate(", null, ")") - 2,
                x: d3_interpolateNumber(ra, rb)
            });
        } else if (rb) s.push(s.pop() + "rotate(" + rb + ")");
        if (wa != wb) q.push({
            i: s.push(s.pop() + "skewX(", null, ")") - 2,
            x: d3_interpolateNumber(wa, wb)
        });
        else if (wb) s.push(s.pop() + "skewX(" + wb + ")");
        if (ka[0] != kb[0] || ka[1] != kb[1]) {
            n = s.push(s.pop() + "scale(", null, ",", null, ")");
            q.push({
                i: n - 4,
                x: d3_interpolateNumber(ka[0], kb[0])
            }, {
                i: n - 2,
                x: d3_interpolateNumber(ka[1], kb[1])
            });
        } else if (kb[0] != 1 || kb[1] != 1) s.push(s.pop() + "scale(" + kb + ")");
        n = q.length;
        return function(t) {
            var i = -1, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    }
    d3.interpolateObject = d3_interpolateObject;
    function d3_interpolateObject(a, b1) {
        var i = {}, c = {}, k;
        for(k in a)if (k in b1) i[k] = d3_interpolateByName(k)(a[k], b1[k]);
        else c[k] = a[k];
        for(k in b1)if (!(k in a)) c[k] = b1[k];
        return function(t) {
            for(k in i)c[k] = i[k](t);
            return c;
        };
    }
    d3.interpolateString = d3_interpolateString;
    function d3_interpolateString(a, b1) {
        var m, i, j, s0 = 0, s1 = 0, s = [], q = [], n, o;
        a = a + "", b1 = b1 + "";
        d3_interpolate_number.lastIndex = 0;
        for(i = 0; m = d3_interpolate_number.exec(b1); ++i){
            if (m.index) s.push(b1.substring(s0, s1 = m.index));
            q.push({
                i: s.length,
                x: m[0]
            });
            s.push(null);
            s0 = d3_interpolate_number.lastIndex;
        }
        if (s0 < b1.length) s.push(b1.substring(s0));
        for(i = 0, n = q.length; (m = d3_interpolate_number.exec(a)) && i < n; ++i){
            o = q[i];
            if (o.x == m[0]) {
                if (o.i) {
                    if (s[o.i + 1] == null) {
                        s[o.i - 1] += o.x;
                        s.splice(o.i, 1);
                        for(j = i + 1; j < n; ++j)q[j].i--;
                    } else {
                        s[o.i - 1] += o.x + s[o.i + 1];
                        s.splice(o.i, 2);
                        for(j = i + 1; j < n; ++j)q[j].i -= 2;
                    }
                } else if (s[o.i + 1] == null) s[o.i] = o.x;
                else {
                    s[o.i] = o.x + s[o.i + 1];
                    s.splice(o.i + 1, 1);
                    for(j = i + 1; j < n; ++j)q[j].i--;
                }
                q.splice(i, 1);
                n--;
                i--;
            } else o.x = d3_interpolateNumber(parseFloat(m[0]), parseFloat(o.x));
        }
        while(i < n){
            o = q.pop();
            if (s[o.i + 1] == null) s[o.i] = o.x;
            else {
                s[o.i] = o.x + s[o.i + 1];
                s.splice(o.i + 1, 1);
            }
            n--;
        }
        if (s.length === 1) return s[0] == null ? q[0].x : function() {
            return b1;
        };
        return function(t) {
            for(i = 0; i < n; ++i)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    }
    var d3_interpolate_number = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
    d3.interpolate = d3_interpolate;
    function d3_interpolate(a, b1) {
        var i = d3.interpolators.length, f;
        while(--i >= 0 && !(f = d3.interpolators[i](a, b1)));
        return f;
    }
    function d3_interpolateByName(name) {
        return name == "transform" ? d3_interpolateTransform : d3_interpolate;
    }
    d3.interpolators = [
        function(a, b1) {
            var t = typeof b1;
            return (t === "string" || t !== typeof a ? d3_rgb_names.has(b1) || /^(#|rgb\(|hsl\()/.test(b1) ? d3_interpolateRgb : d3_interpolateString : b1 instanceof d3_Color ? d3_interpolateRgb : t === "object" ? Array.isArray(b1) ? d3_interpolateArray : d3_interpolateObject : d3_interpolateNumber)(a, b1);
        }
    ];
    d3.interpolateArray = d3_interpolateArray;
    function d3_interpolateArray(a, b1) {
        var x = [], c = [], na = a.length, nb = b1.length, n0 = Math.min(a.length, b1.length), i;
        for(i = 0; i < n0; ++i)x.push(d3_interpolate(a[i], b1[i]));
        for(; i < na; ++i)c[i] = a[i];
        for(; i < nb; ++i)c[i] = b1[i];
        return function(t) {
            for(i = 0; i < n0; ++i)c[i] = x[i](t);
            return c;
        };
    }
    var d3_ease_default = function() {
        return d3_identity;
    };
    var d3_ease = d3.map({
        linear: d3_ease_default,
        poly: d3_ease_poly,
        quad: function() {
            return d3_ease_quad;
        },
        cubic: function() {
            return d3_ease_cubic;
        },
        sin: function() {
            return d3_ease_sin;
        },
        exp: function() {
            return d3_ease_exp;
        },
        circle: function() {
            return d3_ease_circle;
        },
        elastic: d3_ease_elastic,
        back: d3_ease_back,
        bounce: function() {
            return d3_ease_bounce;
        }
    });
    var d3_ease_mode = d3.map({
        "in": d3_identity,
        out: d3_ease_reverse,
        "in-out": d3_ease_reflect,
        "out-in": function(f) {
            return d3_ease_reflect(d3_ease_reverse(f));
        }
    });
    d3.ease = function(name) {
        var i = name.indexOf("-"), t = i >= 0 ? name.substring(0, i) : name, m = i >= 0 ? name.substring(i + 1) : "in";
        t = d3_ease.get(t) || d3_ease_default;
        m = d3_ease_mode.get(m) || d3_identity;
        return d3_ease_clamp(m(t.apply(null, Array.prototype.slice.call(arguments, 1))));
    };
    function d3_ease_clamp(f) {
        return function(t) {
            return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
        };
    }
    function d3_ease_reverse(f) {
        return function(t) {
            return 1 - f(1 - t);
        };
    }
    function d3_ease_reflect(f) {
        return function(t) {
            return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
        };
    }
    function d3_ease_quad(t) {
        return t * t;
    }
    function d3_ease_cubic(t) {
        return t * t * t;
    }
    function d3_ease_cubicInOut(t) {
        if (t <= 0) return 0;
        if (t >= 1) return 1;
        var t2 = t * t, t3 = t2 * t;
        return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
    }
    function d3_ease_poly(e) {
        return function(t) {
            return Math.pow(t, e);
        };
    }
    function d3_ease_sin(t) {
        return 1 - Math.cos(t * \u03C0 / 2);
    }
    function d3_ease_exp(t) {
        return Math.pow(2, 10 * (t - 1));
    }
    function d3_ease_circle(t) {
        return 1 - Math.sqrt(1 - t * t);
    }
    function d3_ease_elastic(a, p) {
        var s;
        if (arguments.length < 2) p = .45;
        if (arguments.length) s = p / (2 * \u03C0) * Math.asin(1 / a);
        else a = 1, s = p / 4;
        return function(t) {
            return 1 + a * Math.pow(2, 10 * -t) * Math.sin((t - s) * 2 * \u03C0 / p);
        };
    }
    function d3_ease_back(s) {
        if (!s) s = 1.70158;
        return function(t) {
            return t * t * ((s + 1) * t - s);
        };
    }
    function d3_ease_bounce(t) {
        return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
    }
    d3.interpolateHcl = d3_interpolateHcl;
    function d3_interpolateHcl(a, b1) {
        a = d3.hcl(a);
        b1 = d3.hcl(b1);
        var ah = a.h, ac = a.c, al = a.l, bh = b1.h - ah, bc = b1.c - ac, bl = b1.l - al;
        if (bh > 180) bh -= 360;
        else if (bh < -180) bh += 360;
        return function(t) {
            return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
        };
    }
    d3.interpolateHsl = d3_interpolateHsl;
    function d3_interpolateHsl(a, b1) {
        a = d3.hsl(a);
        b1 = d3.hsl(b1);
        var h0 = a.h, s0 = a.s, l0 = a.l, h1 = b1.h - h0, s1 = b1.s - s0, l1 = b1.l - l0;
        if (h1 > 180) h1 -= 360;
        else if (h1 < -180) h1 += 360;
        return function(t) {
            return d3_hsl_rgb(h0 + h1 * t, s0 + s1 * t, l0 + l1 * t) + "";
        };
    }
    d3.interpolateLab = d3_interpolateLab;
    function d3_interpolateLab(a, b1) {
        a = d3.lab(a);
        b1 = d3.lab(b1);
        var al = a.l, aa = a.a, ab = a.b, bl = b1.l - al, ba = b1.a - aa, bb = b1.b - ab;
        return function(t) {
            return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
        };
    }
    d3.interpolateRound = d3_interpolateRound;
    function d3_interpolateRound(a, b1) {
        b1 -= a;
        return function(t) {
            return Math.round(a + b1 * t);
        };
    }
    function d3_uninterpolateNumber(a, b1) {
        b1 = b1 - (a = +a) ? 1 / (b1 - a) : 0;
        return function(x) {
            return (x - a) * b1;
        };
    }
    function d3_uninterpolateClamp(a, b1) {
        b1 = b1 - (a = +a) ? 1 / (b1 - a) : 0;
        return function(x) {
            return Math.max(0, Math.min(1, (x - a) * b1));
        };
    }
    d3.layout = {};
    d3.layout.bundle = function() {
        return function(links) {
            var paths = [], i = -1, n = links.length;
            while(++i < n)paths.push(d3_layout_bundlePath(links[i]));
            return paths;
        };
    };
    function d3_layout_bundlePath(link) {
        var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [
            start
        ];
        while(start !== lca){
            start = start.parent;
            points.push(start);
        }
        var k = points.length;
        while(end !== lca){
            points.splice(k, 0, end);
            end = end.parent;
        }
        return points;
    }
    function d3_layout_bundleAncestors(node) {
        var ancestors = [], parent = node.parent;
        while(parent != null){
            ancestors.push(node);
            node = parent;
            parent = parent.parent;
        }
        ancestors.push(node);
        return ancestors;
    }
    function d3_layout_bundleLeastCommonAncestor(a, b1) {
        if (a === b1) return a;
        var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b1), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
        while(aNode === bNode){
            sharedNode = aNode;
            aNode = aNodes.pop();
            bNode = bNodes.pop();
        }
        return sharedNode;
    }
    d3.layout.chord = function() {
        var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
        function relayout() {
            var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
            chords = [];
            groups = [];
            k = 0, i = -1;
            while(++i < n){
                x = 0, j = -1;
                while(++j < n)x += matrix[i][j];
                groupSums.push(x);
                subgroupIndex.push(d3.range(n));
                k += x;
            }
            if (sortGroups) groupIndex.sort(function(a, b1) {
                return sortGroups(groupSums[a], groupSums[b1]);
            });
            if (sortSubgroups) subgroupIndex.forEach(function(d, i) {
                d.sort(function(a, b1) {
                    return sortSubgroups(matrix[i][a], matrix[i][b1]);
                });
            });
            k = (2 * \u03C0 - padding * n) / k;
            x = 0, i = -1;
            while(++i < n){
                x0 = x, j = -1;
                while(++j < n){
                    var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
                    subgroups[di + "-" + dj] = {
                        index: di,
                        subindex: dj,
                        startAngle: a0,
                        endAngle: a1,
                        value: v
                    };
                }
                groups[di] = {
                    index: di,
                    startAngle: x0,
                    endAngle: x,
                    value: (x - x0) / k
                };
                x += padding;
            }
            i = -1;
            while(++i < n){
                j = i - 1;
                while(++j < n){
                    var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
                    if (source.value || target.value) chords.push(source.value < target.value ? {
                        source: target,
                        target: source
                    } : {
                        source: source,
                        target: target
                    });
                }
            }
            if (sortChords) resort();
        }
        function resort() {
            chords.sort(function(a, b1) {
                return sortChords((a.source.value + a.target.value) / 2, (b1.source.value + b1.target.value) / 2);
            });
        }
        chord.matrix = function(x) {
            if (!arguments.length) return matrix;
            n = (matrix = x) && matrix.length;
            chords = groups = null;
            return chord;
        };
        chord.padding = function(x) {
            if (!arguments.length) return padding;
            padding = x;
            chords = groups = null;
            return chord;
        };
        chord.sortGroups = function(x) {
            if (!arguments.length) return sortGroups;
            sortGroups = x;
            chords = groups = null;
            return chord;
        };
        chord.sortSubgroups = function(x) {
            if (!arguments.length) return sortSubgroups;
            sortSubgroups = x;
            chords = null;
            return chord;
        };
        chord.sortChords = function(x) {
            if (!arguments.length) return sortChords;
            sortChords = x;
            if (chords) resort();
            return chord;
        };
        chord.chords = function() {
            if (!chords) relayout();
            return chords;
        };
        chord.groups = function() {
            if (!groups) relayout();
            return groups;
        };
        return chord;
    };
    d3.layout.force = function() {
        var force = {}, event = d3.dispatch("start", "tick", "end"), size = [
            1,
            1
        ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, gravity = .1, theta = .8, nodes = [], links = [], distances, strengths, charges;
        function repulse(node) {
            return function(quad, x1, _, x2) {
                if (quad.point !== node) {
                    var dx = quad.cx - node.x, dy = quad.cy - node.y, dn = 1 / Math.sqrt(dx * dx + dy * dy);
                    if ((x2 - x1) * dn < theta) {
                        var k = quad.charge * dn * dn;
                        node.px -= dx * k;
                        node.py -= dy * k;
                        return true;
                    }
                    if (quad.point && isFinite(dn)) {
                        var k = quad.pointCharge * dn * dn;
                        node.px -= dx * k;
                        node.py -= dy * k;
                    }
                }
                return !quad.charge;
            };
        }
        force.tick = function() {
            if ((alpha *= .99) < .005) {
                event.end({
                    type: "end",
                    alpha: alpha = 0
                });
                return true;
            }
            var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
            for(i = 0; i < m; ++i){
                o = links[i];
                s = o.source;
                t = o.target;
                x = t.x - s.x;
                y = t.y - s.y;
                if (l = x * x + y * y) {
                    l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
                    x *= l;
                    y *= l;
                    t.x -= x * (k = s.weight / (t.weight + s.weight));
                    t.y -= y * k;
                    s.x += x * (k = 1 - k);
                    s.y += y * k;
                }
            }
            if (k = alpha * gravity) {
                x = size[0] / 2;
                y = size[1] / 2;
                i = -1;
                if (k) while(++i < n){
                    o = nodes[i];
                    o.x += (x - o.x) * k;
                    o.y += (y - o.y) * k;
                }
            }
            if (charge) {
                d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
                i = -1;
                while(++i < n)if (!(o = nodes[i]).fixed) q.visit(repulse(o));
            }
            i = -1;
            while(++i < n){
                o = nodes[i];
                if (o.fixed) {
                    o.x = o.px;
                    o.y = o.py;
                } else {
                    o.x -= (o.px - (o.px = o.x)) * friction;
                    o.y -= (o.py - (o.py = o.y)) * friction;
                }
            }
            event.tick({
                type: "tick",
                alpha: alpha
            });
        };
        force.nodes = function(x) {
            if (!arguments.length) return nodes;
            nodes = x;
            return force;
        };
        force.links = function(x) {
            if (!arguments.length) return links;
            links = x;
            return force;
        };
        force.size = function(x) {
            if (!arguments.length) return size;
            size = x;
            return force;
        };
        force.linkDistance = function(x) {
            if (!arguments.length) return linkDistance;
            linkDistance = typeof x === "function" ? x : +x;
            return force;
        };
        force.distance = force.linkDistance;
        force.linkStrength = function(x) {
            if (!arguments.length) return linkStrength;
            linkStrength = typeof x === "function" ? x : +x;
            return force;
        };
        force.friction = function(x) {
            if (!arguments.length) return friction;
            friction = +x;
            return force;
        };
        force.charge = function(x) {
            if (!arguments.length) return charge;
            charge = typeof x === "function" ? x : +x;
            return force;
        };
        force.gravity = function(x) {
            if (!arguments.length) return gravity;
            gravity = +x;
            return force;
        };
        force.theta = function(x) {
            if (!arguments.length) return theta;
            theta = +x;
            return force;
        };
        force.alpha = function(x) {
            if (!arguments.length) return alpha;
            x = +x;
            if (alpha) {
                if (x > 0) alpha = x;
                else alpha = 0;
            } else if (x > 0) {
                event.start({
                    type: "start",
                    alpha: alpha = x
                });
                d3.timer(force.tick);
            }
            return force;
        };
        force.start = function() {
            var i, j, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
            for(i = 0; i < n; ++i){
                (o = nodes[i]).index = i;
                o.weight = 0;
            }
            for(i = 0; i < m; ++i){
                o = links[i];
                if (typeof o.source == "number") o.source = nodes[o.source];
                if (typeof o.target == "number") o.target = nodes[o.target];
                ++o.source.weight;
                ++o.target.weight;
            }
            for(i = 0; i < n; ++i){
                o = nodes[i];
                if (isNaN(o.x)) o.x = position("x", w);
                if (isNaN(o.y)) o.y = position("y", h);
                if (isNaN(o.px)) o.px = o.x;
                if (isNaN(o.py)) o.py = o.y;
            }
            distances = [];
            if (typeof linkDistance === "function") for(i = 0; i < m; ++i)distances[i] = +linkDistance.call(this, links[i], i);
            else for(i = 0; i < m; ++i)distances[i] = linkDistance;
            strengths = [];
            if (typeof linkStrength === "function") for(i = 0; i < m; ++i)strengths[i] = +linkStrength.call(this, links[i], i);
            else for(i = 0; i < m; ++i)strengths[i] = linkStrength;
            charges = [];
            if (typeof charge === "function") for(i = 0; i < n; ++i)charges[i] = +charge.call(this, nodes[i], i);
            else for(i = 0; i < n; ++i)charges[i] = charge;
            function position(dimension, size) {
                var neighbors = neighbor(i), j = -1, m = neighbors.length, x;
                while(++j < m)if (!isNaN(x = neighbors[j][dimension])) return x;
                return Math.random() * size;
            }
            function neighbor() {
                if (!neighbors) {
                    neighbors = [];
                    for(j = 0; j < n; ++j)neighbors[j] = [];
                    for(j = 0; j < m; ++j){
                        var o = links[j];
                        neighbors[o.source.index].push(o.target);
                        neighbors[o.target.index].push(o.source);
                    }
                }
                return neighbors[i];
            }
            return force.resume();
        };
        force.resume = function() {
            return force.alpha(.1);
        };
        force.stop = function() {
            return force.alpha(0);
        };
        force.drag = function() {
            if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
            if (!arguments.length) return drag;
            this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
        };
        function dragmove(d) {
            d.px = d3.event.x, d.py = d3.event.y;
            force.resume();
        }
        return d3.rebind(force, event, "on");
    };
    function d3_layout_forceDragstart(d) {
        d.fixed |= 2;
    }
    function d3_layout_forceDragend(d) {
        d.fixed &= -7;
    }
    function d3_layout_forceMouseover(d) {
        d.fixed |= 4;
        d.px = d.x, d.py = d.y;
    }
    function d3_layout_forceMouseout(d) {
        d.fixed &= -5;
    }
    function d3_layout_forceAccumulate(quad, alpha, charges) {
        var cx = 0, cy = 0;
        quad.charge = 0;
        if (!quad.leaf) {
            var nodes = quad.nodes, n = nodes.length, i = -1, c;
            while(++i < n){
                c = nodes[i];
                if (c == null) continue;
                d3_layout_forceAccumulate(c, alpha, charges);
                quad.charge += c.charge;
                cx += c.charge * c.cx;
                cy += c.charge * c.cy;
            }
        }
        if (quad.point) {
            if (!quad.leaf) {
                quad.point.x += Math.random() - .5;
                quad.point.y += Math.random() - .5;
            }
            var k = alpha * charges[quad.point.index];
            quad.charge += quad.pointCharge = k;
            cx += k * quad.point.x;
            cy += k * quad.point.y;
        }
        quad.cx = cx / quad.charge;
        quad.cy = cy / quad.charge;
    }
    var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1;
    d3.layout.hierarchy = function() {
        var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
        function recurse(node, depth, nodes) {
            var childs = children.call(hierarchy, node, depth);
            node.depth = depth;
            nodes.push(node);
            if (childs && (n = childs.length)) {
                var i = -1, n, c = node.children = [], v = 0, j = depth + 1, d;
                while(++i < n){
                    d = recurse(childs[i], j, nodes);
                    d.parent = node;
                    c.push(d);
                    v += d.value;
                }
                if (sort) c.sort(sort);
                if (value) node.value = v;
            } else if (value) node.value = +value.call(hierarchy, node, depth) || 0;
            return node;
        }
        function revalue(node, depth) {
            var children = node.children, v = 0;
            if (children && (n = children.length)) {
                var i = -1, n, j = depth + 1;
                while(++i < n)v += revalue(children[i], j);
            } else if (value) v = +value.call(hierarchy, node, depth) || 0;
            if (value) node.value = v;
            return v;
        }
        function hierarchy(d) {
            var nodes = [];
            recurse(d, 0, nodes);
            return nodes;
        }
        hierarchy.sort = function(x) {
            if (!arguments.length) return sort;
            sort = x;
            return hierarchy;
        };
        hierarchy.children = function(x) {
            if (!arguments.length) return children;
            children = x;
            return hierarchy;
        };
        hierarchy.value = function(x) {
            if (!arguments.length) return value;
            value = x;
            return hierarchy;
        };
        hierarchy.revalue = function(root) {
            revalue(root, 0);
            return root;
        };
        return hierarchy;
    };
    function d3_layout_hierarchyRebind(object, hierarchy) {
        d3.rebind(object, hierarchy, "sort", "children", "value");
        object.nodes = object;
        object.links = d3_layout_hierarchyLinks;
        return object;
    }
    function d3_layout_hierarchyChildren(d) {
        return d.children;
    }
    function d3_layout_hierarchyValue(d) {
        return d.value;
    }
    function d3_layout_hierarchySort(a, b1) {
        return b1.value - a.value;
    }
    function d3_layout_hierarchyLinks(nodes) {
        return d3.merge(nodes.map(function(parent) {
            return (parent.children || []).map(function(child) {
                return {
                    source: parent,
                    target: child
                };
            });
        }));
    }
    d3.layout.partition = function() {
        var hierarchy = d3.layout.hierarchy(), size = [
            1,
            1
        ];
        function position(node, x, dx, dy) {
            var children = node.children;
            node.x = x;
            node.y = node.depth * dy;
            node.dx = dx;
            node.dy = dy;
            if (children && (n = children.length)) {
                var i = -1, n, c, d;
                dx = node.value ? dx / node.value : 0;
                while(++i < n){
                    position(c = children[i], x, d = c.value * dx, dy);
                    x += d;
                }
            }
        }
        function depth(node) {
            var children = node.children, d = 0;
            if (children && (n = children.length)) {
                var i = -1, n;
                while(++i < n)d = Math.max(d, depth(children[i]));
            }
            return 1 + d;
        }
        function partition(d, i) {
            var nodes = hierarchy.call(this, d, i);
            position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
            return nodes;
        }
        partition.size = function(x) {
            if (!arguments.length) return size;
            size = x;
            return partition;
        };
        return d3_layout_hierarchyRebind(partition, hierarchy);
    };
    d3.layout.pie = function() {
        var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = 2 * \u03C0;
        function pie(data) {
            var values = data.map(function(d, i) {
                return +value.call(pie, d, i);
            });
            var a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle);
            var k = ((typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a) / d3.sum(values);
            var index = d3.range(data.length);
            if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
                return values[j] - values[i];
            } : function(i, j) {
                return sort(data[i], data[j]);
            });
            var arcs = [];
            index.forEach(function(i) {
                var d;
                arcs[i] = {
                    data: data[i],
                    value: d = values[i],
                    startAngle: a,
                    endAngle: a += d * k
                };
            });
            return arcs;
        }
        pie.value = function(x) {
            if (!arguments.length) return value;
            value = x;
            return pie;
        };
        pie.sort = function(x) {
            if (!arguments.length) return sort;
            sort = x;
            return pie;
        };
        pie.startAngle = function(x) {
            if (!arguments.length) return startAngle;
            startAngle = x;
            return pie;
        };
        pie.endAngle = function(x) {
            if (!arguments.length) return endAngle;
            endAngle = x;
            return pie;
        };
        return pie;
    };
    var d3_layout_pieSortByValue = {};
    d3.layout.stack = function() {
        var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
        function stack(data, index) {
            var series = data.map(function(d, i) {
                return values.call(stack, d, i);
            });
            var points = series.map(function(d) {
                return d.map(function(v, i) {
                    return [
                        x.call(stack, v, i),
                        y.call(stack, v, i)
                    ];
                });
            });
            var orders = order.call(stack, points, index);
            series = d3.permute(series, orders);
            points = d3.permute(points, orders);
            var offsets = offset.call(stack, points, index);
            var n = series.length, m = series[0].length, i, j, o;
            for(j = 0; j < m; ++j){
                out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
                for(i = 1; i < n; ++i)out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
            }
            return data;
        }
        stack.values = function(x) {
            if (!arguments.length) return values;
            values = x;
            return stack;
        };
        stack.order = function(x) {
            if (!arguments.length) return order;
            order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
            return stack;
        };
        stack.offset = function(x) {
            if (!arguments.length) return offset;
            offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
            return stack;
        };
        stack.x = function(z) {
            if (!arguments.length) return x;
            x = z;
            return stack;
        };
        stack.y = function(z) {
            if (!arguments.length) return y;
            y = z;
            return stack;
        };
        stack.out = function(z) {
            if (!arguments.length) return out;
            out = z;
            return stack;
        };
        return stack;
    };
    function d3_layout_stackX(d) {
        return d.x;
    }
    function d3_layout_stackY(d) {
        return d.y;
    }
    function d3_layout_stackOut(d, y0, y) {
        d.y0 = y0;
        d.y = y;
    }
    var d3_layout_stackOrders = d3.map({
        "inside-out": function(data) {
            var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b1) {
                return max[a] - max[b1];
            }), top = 0, bottom = 0, tops = [], bottoms = [];
            for(i = 0; i < n; ++i){
                j = index[i];
                if (top < bottom) {
                    top += sums[j];
                    tops.push(j);
                } else {
                    bottom += sums[j];
                    bottoms.push(j);
                }
            }
            return bottoms.reverse().concat(tops);
        },
        reverse: function(data) {
            return d3.range(data.length).reverse();
        },
        "default": d3_layout_stackOrderDefault
    });
    var d3_layout_stackOffsets = d3.map({
        silhouette: function(data) {
            var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
            for(j = 0; j < m; ++j){
                for(i = 0, o = 0; i < n; i++)o += data[i][j][1];
                if (o > max) max = o;
                sums.push(o);
            }
            for(j = 0; j < m; ++j)y0[j] = (max - sums[j]) / 2;
            return y0;
        },
        wiggle: function(data) {
            var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
            y0[0] = o = o0 = 0;
            for(j = 1; j < m; ++j){
                for(i = 0, s1 = 0; i < n; ++i)s1 += data[i][j][1];
                for(i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i){
                    for(k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k)s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
                    s2 += s3 * data[i][j][1];
                }
                y0[j] = o -= s1 ? s2 / s1 * dx : 0;
                if (o < o0) o0 = o;
            }
            for(j = 0; j < m; ++j)y0[j] -= o0;
            return y0;
        },
        expand: function(data) {
            var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
            for(j = 0; j < m; ++j){
                for(i = 0, o = 0; i < n; i++)o += data[i][j][1];
                if (o) for(i = 0; i < n; i++)data[i][j][1] /= o;
                else for(i = 0; i < n; i++)data[i][j][1] = k;
            }
            for(j = 0; j < m; ++j)y0[j] = 0;
            return y0;
        },
        zero: d3_layout_stackOffsetZero
    });
    function d3_layout_stackOrderDefault(data) {
        return d3.range(data.length);
    }
    function d3_layout_stackOffsetZero(data) {
        var j = -1, m = data[0].length, y0 = [];
        while(++j < m)y0[j] = 0;
        return y0;
    }
    function d3_layout_stackMaxIndex(array) {
        var i = 1, j = 0, v = array[0][1], k, n = array.length;
        for(; i < n; ++i)if ((k = array[i][1]) > v) {
            j = i;
            v = k;
        }
        return j;
    }
    function d3_layout_stackReduceSum(d) {
        return d.reduce(d3_layout_stackSum, 0);
    }
    function d3_layout_stackSum(p, d) {
        return p + d[1];
    }
    d3.layout.histogram = function() {
        var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
        function histogram(data, i) {
            var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
            while(++i < m){
                bin = bins[i] = [];
                bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
                bin.y = 0;
            }
            if (m > 0) {
                i = -1;
                while(++i < n){
                    x = values[i];
                    if (x >= range[0] && x <= range[1]) {
                        bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
                        bin.y += k;
                        bin.push(data[i]);
                    }
                }
            }
            return bins;
        }
        histogram.value = function(x) {
            if (!arguments.length) return valuer;
            valuer = x;
            return histogram;
        };
        histogram.range = function(x) {
            if (!arguments.length) return ranger;
            ranger = d3_functor(x);
            return histogram;
        };
        histogram.bins = function(x) {
            if (!arguments.length) return binner;
            binner = typeof x === "number" ? function(range) {
                return d3_layout_histogramBinFixed(range, x);
            } : d3_functor(x);
            return histogram;
        };
        histogram.frequency = function(x) {
            if (!arguments.length) return frequency;
            frequency = !!x;
            return histogram;
        };
        return histogram;
    };
    function d3_layout_histogramBinSturges(range, values) {
        return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
    }
    function d3_layout_histogramBinFixed(range, n) {
        var x = -1, b1 = +range[0], m = (range[1] - b1) / n, f = [];
        while(++x <= n)f[x] = m * x + b1;
        return f;
    }
    function d3_layout_histogramRange(values) {
        return [
            d3.min(values),
            d3.max(values)
        ];
    }
    d3.layout.tree = function() {
        var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [
            1,
            1
        ];
        function tree(d, i) {
            var nodes = hierarchy.call(this, d, i), root = nodes[0];
            function firstWalk(node, previousSibling) {
                var children = node.children, layout = node._tree;
                if (children && (n = children.length)) {
                    var n, firstChild = children[0], previousChild, ancestor = firstChild, child, i = -1;
                    while(++i < n){
                        child = children[i];
                        firstWalk(child, previousChild);
                        ancestor = apportion(child, previousChild, ancestor);
                        previousChild = child;
                    }
                    d3_layout_treeShift(node);
                    var midpoint = .5 * (firstChild._tree.prelim + child._tree.prelim);
                    if (previousSibling) {
                        layout.prelim = previousSibling._tree.prelim + separation(node, previousSibling);
                        layout.mod = layout.prelim - midpoint;
                    } else layout.prelim = midpoint;
                } else if (previousSibling) layout.prelim = previousSibling._tree.prelim + separation(node, previousSibling);
            }
            function secondWalk(node, x) {
                node.x = node._tree.prelim + x;
                var children = node.children;
                if (children && (n = children.length)) {
                    var i = -1, n;
                    x += node._tree.mod;
                    while(++i < n)secondWalk(children[i], x);
                }
            }
            function apportion(node, previousSibling, ancestor) {
                if (previousSibling) {
                    var vip = node, vop = node, vim = previousSibling, vom = node.parent.children[0], sip = vip._tree.mod, sop = vop._tree.mod, sim = vim._tree.mod, som = vom._tree.mod, shift;
                    while(vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip){
                        vom = d3_layout_treeLeft(vom);
                        vop = d3_layout_treeRight(vop);
                        vop._tree.ancestor = node;
                        shift = vim._tree.prelim + sim - vip._tree.prelim - sip + separation(vim, vip);
                        if (shift > 0) {
                            d3_layout_treeMove(d3_layout_treeAncestor(vim, node, ancestor), node, shift);
                            sip += shift;
                            sop += shift;
                        }
                        sim += vim._tree.mod;
                        sip += vip._tree.mod;
                        som += vom._tree.mod;
                        sop += vop._tree.mod;
                    }
                    if (vim && !d3_layout_treeRight(vop)) {
                        vop._tree.thread = vim;
                        vop._tree.mod += sim - sop;
                    }
                    if (vip && !d3_layout_treeLeft(vom)) {
                        vom._tree.thread = vip;
                        vom._tree.mod += sip - som;
                        ancestor = node;
                    }
                }
                return ancestor;
            }
            d3_layout_treeVisitAfter(root, function(node, previousSibling) {
                node._tree = {
                    ancestor: node,
                    prelim: 0,
                    mod: 0,
                    change: 0,
                    shift: 0,
                    number: previousSibling ? previousSibling._tree.number + 1 : 0
                };
            });
            firstWalk(root);
            secondWalk(root, -root._tree.prelim);
            var left = d3_layout_treeSearch(root, d3_layout_treeLeftmost), right = d3_layout_treeSearch(root, d3_layout_treeRightmost), deep = d3_layout_treeSearch(root, d3_layout_treeDeepest), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2, y1 = deep.depth || 1;
            d3_layout_treeVisitAfter(root, function(node) {
                node.x = (node.x - x0) / (x1 - x0) * size[0];
                node.y = node.depth / y1 * size[1];
                delete node._tree;
            });
            return nodes;
        }
        tree.separation = function(x) {
            if (!arguments.length) return separation;
            separation = x;
            return tree;
        };
        tree.size = function(x) {
            if (!arguments.length) return size;
            size = x;
            return tree;
        };
        return d3_layout_hierarchyRebind(tree, hierarchy);
    };
    function d3_layout_treeSeparation(a, b1) {
        return a.parent == b1.parent ? 1 : 2;
    }
    function d3_layout_treeLeft(node) {
        var children = node.children;
        return children && children.length ? children[0] : node._tree.thread;
    }
    function d3_layout_treeRight(node) {
        var children = node.children, n;
        return children && (n = children.length) ? children[n - 1] : node._tree.thread;
    }
    function d3_layout_treeSearch(node, compare) {
        var children = node.children;
        if (children && (n = children.length)) {
            var child, n, i = -1;
            while(++i < n)if (compare(child = d3_layout_treeSearch(children[i], compare), node) > 0) node = child;
        }
        return node;
    }
    function d3_layout_treeRightmost(a, b1) {
        return a.x - b1.x;
    }
    function d3_layout_treeLeftmost(a, b1) {
        return b1.x - a.x;
    }
    function d3_layout_treeDeepest(a, b1) {
        return a.depth - b1.depth;
    }
    function d3_layout_treeVisitAfter(node, callback) {
        function visit(node, previousSibling) {
            var children = node.children;
            if (children && (n = children.length)) {
                var child, previousChild = null, i = -1, n;
                while(++i < n){
                    child = children[i];
                    visit(child, previousChild);
                    previousChild = child;
                }
            }
            callback(node, previousSibling);
        }
        visit(node, null);
    }
    function d3_layout_treeShift(node) {
        var shift = 0, change = 0, children = node.children, i = children.length, child;
        while(--i >= 0){
            child = children[i]._tree;
            child.prelim += shift;
            child.mod += shift;
            shift += child.shift + (change += child.change);
        }
    }
    function d3_layout_treeMove(ancestor, node, shift) {
        ancestor = ancestor._tree;
        node = node._tree;
        var change = shift / (node.number - ancestor.number);
        ancestor.change += change;
        node.change -= change;
        node.shift += shift;
        node.prelim += shift;
        node.mod += shift;
    }
    function d3_layout_treeAncestor(vim, node, ancestor) {
        return vim._tree.ancestor.parent == node.parent ? vim._tree.ancestor : ancestor;
    }
    d3.layout.pack = function() {
        var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [
            1,
            1
        ];
        function pack(d, i) {
            var nodes = hierarchy.call(this, d, i), root = nodes[0];
            root.x = 0;
            root.y = 0;
            d3_layout_treeVisitAfter(root, function(d) {
                d.r = Math.sqrt(d.value);
            });
            d3_layout_treeVisitAfter(root, d3_layout_packSiblings);
            var w = size[0], h = size[1], k = Math.max(2 * root.r / w, 2 * root.r / h);
            if (padding > 0) {
                var dr = padding * k / 2;
                d3_layout_treeVisitAfter(root, function(d) {
                    d.r += dr;
                });
                d3_layout_treeVisitAfter(root, d3_layout_packSiblings);
                d3_layout_treeVisitAfter(root, function(d) {
                    d.r -= dr;
                });
                k = Math.max(2 * root.r / w, 2 * root.r / h);
            }
            d3_layout_packTransform(root, w / 2, h / 2, 1 / k);
            return nodes;
        }
        pack.size = function(x) {
            if (!arguments.length) return size;
            size = x;
            return pack;
        };
        pack.padding = function(_) {
            if (!arguments.length) return padding;
            padding = +_;
            return pack;
        };
        return d3_layout_hierarchyRebind(pack, hierarchy);
    };
    function d3_layout_packSort(a, b1) {
        return a.value - b1.value;
    }
    function d3_layout_packInsert(a, b1) {
        var c = a._pack_next;
        a._pack_next = b1;
        b1._pack_prev = a;
        b1._pack_next = c;
        c._pack_prev = b1;
    }
    function d3_layout_packSplice(a, b1) {
        a._pack_next = b1;
        b1._pack_prev = a;
    }
    function d3_layout_packIntersects(a, b1) {
        var dx = b1.x - a.x, dy = b1.y - a.y, dr = a.r + b1.r;
        return dr * dr - dx * dx - dy * dy > .001;
    }
    function d3_layout_packSiblings(node) {
        if (!(nodes = node.children) || !(n = nodes.length)) return;
        var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b1, c, i, j, k, n;
        function bound(node) {
            xMin = Math.min(node.x - node.r, xMin);
            xMax = Math.max(node.x + node.r, xMax);
            yMin = Math.min(node.y - node.r, yMin);
            yMax = Math.max(node.y + node.r, yMax);
        }
        nodes.forEach(d3_layout_packLink);
        a = nodes[0];
        a.x = -a.r;
        a.y = 0;
        bound(a);
        if (n > 1) {
            b1 = nodes[1];
            b1.x = b1.r;
            b1.y = 0;
            bound(b1);
            if (n > 2) {
                c = nodes[2];
                d3_layout_packPlace(a, b1, c);
                bound(c);
                d3_layout_packInsert(a, c);
                a._pack_prev = c;
                d3_layout_packInsert(c, b1);
                b1 = a._pack_next;
                for(i = 3; i < n; i++){
                    d3_layout_packPlace(a, b1, c = nodes[i]);
                    var isect = 0, s1 = 1, s2 = 1;
                    for(j = b1._pack_next; j !== b1; j = j._pack_next, s1++)if (d3_layout_packIntersects(j, c)) {
                        isect = 1;
                        break;
                    }
                    if (isect == 1) for(k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++){
                        if (d3_layout_packIntersects(k, c)) break;
                    }
                    if (isect) {
                        if (s1 < s2 || s1 == s2 && b1.r < a.r) d3_layout_packSplice(a, b1 = j);
                        else d3_layout_packSplice(a = k, b1);
                        i--;
                    } else {
                        d3_layout_packInsert(a, c);
                        b1 = c;
                        bound(c);
                    }
                }
            }
        }
        var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
        for(i = 0; i < n; i++){
            c = nodes[i];
            c.x -= cx;
            c.y -= cy;
            cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
        }
        node.r = cr;
        nodes.forEach(d3_layout_packUnlink);
    }
    function d3_layout_packLink(node) {
        node._pack_next = node._pack_prev = node;
    }
    function d3_layout_packUnlink(node) {
        delete node._pack_next;
        delete node._pack_prev;
    }
    function d3_layout_packTransform(node, x, y, k) {
        var children = node.children;
        node.x = x += k * node.x;
        node.y = y += k * node.y;
        node.r *= k;
        if (children) {
            var i = -1, n = children.length;
            while(++i < n)d3_layout_packTransform(children[i], x, y, k);
        }
    }
    function d3_layout_packPlace(a, b1, c) {
        var db = a.r + c.r, dx = b1.x - a.x, dy = b1.y - a.y;
        if (db && (dx || dy)) {
            var da = b1.r + c.r, dc = dx * dx + dy * dy;
            da *= da;
            db *= db;
            var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
            c.x = a.x + x * dx + y * dy;
            c.y = a.y + x * dy - y * dx;
        } else {
            c.x = a.x + db;
            c.y = a.y;
        }
    }
    d3.layout.cluster = function() {
        var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [
            1,
            1
        ];
        function cluster(d, i) {
            var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
            d3_layout_treeVisitAfter(root, function(node) {
                var children = node.children;
                if (children && children.length) {
                    node.x = d3_layout_clusterX(children);
                    node.y = d3_layout_clusterY(children);
                } else {
                    node.x = previousNode ? x += separation(node, previousNode) : 0;
                    node.y = 0;
                    previousNode = node;
                }
            });
            var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
            d3_layout_treeVisitAfter(root, function(node) {
                node.x = (node.x - x0) / (x1 - x0) * size[0];
                node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
            });
            return nodes;
        }
        cluster.separation = function(x) {
            if (!arguments.length) return separation;
            separation = x;
            return cluster;
        };
        cluster.size = function(x) {
            if (!arguments.length) return size;
            size = x;
            return cluster;
        };
        return d3_layout_hierarchyRebind(cluster, hierarchy);
    };
    function d3_layout_clusterY(children) {
        return 1 + d3.max(children, function(child) {
            return child.y;
        });
    }
    function d3_layout_clusterX(children) {
        return children.reduce(function(x, child) {
            return x + child.x;
        }, 0) / children.length;
    }
    function d3_layout_clusterLeft(node) {
        var children = node.children;
        return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
    }
    function d3_layout_clusterRight(node) {
        var children = node.children, n;
        return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
    }
    d3.layout.treemap = function() {
        var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [
            1,
            1
        ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
        function scale(children, k) {
            var i = -1, n = children.length, child, area;
            while(++i < n){
                area = (child = children[i]).value * (k < 0 ? 0 : k);
                child.area = isNaN(area) || area <= 0 ? 0 : area;
            }
        }
        function squarify(node) {
            var children = node.children;
            if (children && children.length) {
                var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
                scale(remaining, rect.dx * rect.dy / node.value);
                row.area = 0;
                while((n = remaining.length) > 0){
                    row.push(child = remaining[n - 1]);
                    row.area += child.area;
                    if (mode !== "squarify" || (score = worst(row, u)) <= best) {
                        remaining.pop();
                        best = score;
                    } else {
                        row.area -= row.pop().area;
                        position(row, u, rect, false);
                        u = Math.min(rect.dx, rect.dy);
                        row.length = row.area = 0;
                        best = Infinity;
                    }
                }
                if (row.length) {
                    position(row, u, rect, true);
                    row.length = row.area = 0;
                }
                children.forEach(squarify);
            }
        }
        function stickify(node) {
            var children = node.children;
            if (children && children.length) {
                var rect = pad(node), remaining = children.slice(), child, row = [];
                scale(remaining, rect.dx * rect.dy / node.value);
                row.area = 0;
                while(child = remaining.pop()){
                    row.push(child);
                    row.area += child.area;
                    if (child.z != null) {
                        position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
                        row.length = row.area = 0;
                    }
                }
                children.forEach(stickify);
            }
        }
        function worst(row, u) {
            var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
            while(++i < n){
                if (!(r = row[i].area)) continue;
                if (r < rmin) rmin = r;
                if (r > rmax) rmax = r;
            }
            s *= s;
            u *= u;
            return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
        }
        function position(row, u, rect, flush) {
            var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
            if (u == rect.dx) {
                if (flush || v > rect.dy) v = rect.dy;
                while(++i < n){
                    o = row[i];
                    o.x = x;
                    o.y = y;
                    o.dy = v;
                    x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
                }
                o.z = true;
                o.dx += rect.x + rect.dx - x;
                rect.y += v;
                rect.dy -= v;
            } else {
                if (flush || v > rect.dx) v = rect.dx;
                while(++i < n){
                    o = row[i];
                    o.x = x;
                    o.y = y;
                    o.dx = v;
                    y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
                }
                o.z = false;
                o.dy += rect.y + rect.dy - y;
                rect.x += v;
                rect.dx -= v;
            }
        }
        function treemap(d) {
            var nodes = stickies || hierarchy(d), root = nodes[0];
            root.x = 0;
            root.y = 0;
            root.dx = size[0];
            root.dy = size[1];
            if (stickies) hierarchy.revalue(root);
            scale([
                root
            ], root.dx * root.dy / root.value);
            (stickies ? stickify : squarify)(root);
            if (sticky) stickies = nodes;
            return nodes;
        }
        treemap.size = function(x) {
            if (!arguments.length) return size;
            size = x;
            return treemap;
        };
        treemap.padding = function(x) {
            if (!arguments.length) return padding;
            function padFunction(node) {
                var p = x.call(treemap, node, node.depth);
                return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [
                    p,
                    p,
                    p,
                    p
                ] : p);
            }
            function padConstant(node) {
                return d3_layout_treemapPad(node, x);
            }
            var type;
            pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [
                x,
                x,
                x,
                x
            ], padConstant) : padConstant;
            return treemap;
        };
        treemap.round = function(x) {
            if (!arguments.length) return round != Number;
            round = x ? Math.round : Number;
            return treemap;
        };
        treemap.sticky = function(x) {
            if (!arguments.length) return sticky;
            sticky = x;
            stickies = null;
            return treemap;
        };
        treemap.ratio = function(x) {
            if (!arguments.length) return ratio;
            ratio = x;
            return treemap;
        };
        treemap.mode = function(x) {
            if (!arguments.length) return mode;
            mode = x + "";
            return treemap;
        };
        return d3_layout_hierarchyRebind(treemap, hierarchy);
    };
    function d3_layout_treemapPadNull(node) {
        return {
            x: node.x,
            y: node.y,
            dx: node.dx,
            dy: node.dy
        };
    }
    function d3_layout_treemapPad(node, padding) {
        var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
        if (dx < 0) {
            x += dx / 2;
            dx = 0;
        }
        if (dy < 0) {
            y += dy / 2;
            dy = 0;
        }
        return {
            x: x,
            y: y,
            dx: dx,
            dy: dy
        };
    }
    d3.random = {
        normal: function(mu, \u03C3) {
            var n = arguments.length;
            if (n < 2) \u03C3 = 1;
            if (n < 1) mu = 0;
            return function() {
                var x, y, r;
                do {
                    x = Math.random() * 2 - 1;
                    y = Math.random() * 2 - 1;
                    r = x * x + y * y;
                }while (!r || r > 1);
                return mu + \u03C3 * x * Math.sqrt(-2 * Math.log(r) / r);
            };
        },
        logNormal: function() {
            var random = d3.random.normal.apply(d3, arguments);
            return function() {
                return Math.exp(random());
            };
        },
        irwinHall: function(m) {
            return function() {
                for(var s = 0, j = 0; j < m; j++)s += Math.random();
                return s / m;
            };
        }
    };
    d3.scale = {};
    function d3_scaleExtent(domain) {
        var start = domain[0], stop = domain[domain.length - 1];
        return start < stop ? [
            start,
            stop
        ] : [
            stop,
            start
        ];
    }
    function d3_scaleRange(scale) {
        return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
    }
    function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
        var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
        return function(x) {
            return i(u(x));
        };
    }
    function d3_scale_nice(domain, nice) {
        var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
        if (x1 < x0) {
            dx = i0, i0 = i1, i1 = dx;
            dx = x0, x0 = x1, x1 = dx;
        }
        if (nice = nice(x1 - x0)) {
            domain[i0] = nice.floor(x0);
            domain[i1] = nice.ceil(x1);
        }
        return domain;
    }
    function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
        var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
        if (domain[k] < domain[0]) {
            domain = domain.slice().reverse();
            range = range.slice().reverse();
        }
        while(++j <= k){
            u.push(uninterpolate(domain[j - 1], domain[j]));
            i.push(interpolate(range[j - 1], range[j]));
        }
        return function(x) {
            var j = d3.bisect(domain, x, 1, k) - 1;
            return i[j](u[j](x));
        };
    }
    d3.scale.linear = function() {
        return d3_scale_linear([
            0,
            1
        ], [
            0,
            1
        ], d3_interpolate, false);
    };
    function d3_scale_linear(domain, range, interpolate, clamp) {
        var output, input;
        function rescale() {
            var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
            output = linear(domain, range, uninterpolate, interpolate);
            input = linear(range, domain, uninterpolate, d3_interpolate);
            return scale;
        }
        function scale(x) {
            return output(x);
        }
        scale.invert = function(y) {
            return input(y);
        };
        scale.domain = function(x) {
            if (!arguments.length) return domain;
            domain = x.map(Number);
            return rescale();
        };
        scale.range = function(x) {
            if (!arguments.length) return range;
            range = x;
            return rescale();
        };
        scale.rangeRound = function(x) {
            return scale.range(x).interpolate(d3_interpolateRound);
        };
        scale.clamp = function(x) {
            if (!arguments.length) return clamp;
            clamp = x;
            return rescale();
        };
        scale.interpolate = function(x) {
            if (!arguments.length) return interpolate;
            interpolate = x;
            return rescale();
        };
        scale.ticks = function(m) {
            return d3_scale_linearTicks(domain, m);
        };
        scale.tickFormat = function(m, format) {
            return d3_scale_linearTickFormat(domain, m, format);
        };
        scale.nice = function() {
            d3_scale_nice(domain, d3_scale_linearNice);
            return rescale();
        };
        scale.copy = function() {
            return d3_scale_linear(domain, range, interpolate, clamp);
        };
        return rescale();
    }
    function d3_scale_linearRebind(scale, linear) {
        return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
    }
    function d3_scale_linearNice(dx) {
        dx = Math.pow(10, Math.round(Math.log(dx) / Math.LN10) - 1);
        return dx && {
            floor: function(x) {
                return Math.floor(x / dx) * dx;
            },
            ceil: function(x) {
                return Math.ceil(x / dx) * dx;
            }
        };
    }
    function d3_scale_linearTickRange(domain, m) {
        var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
        if (err <= .15) step *= 10;
        else if (err <= .35) step *= 5;
        else if (err <= .75) step *= 2;
        extent[0] = Math.ceil(extent[0] / step) * step;
        extent[1] = Math.floor(extent[1] / step) * step + step * .5;
        extent[2] = step;
        return extent;
    }
    function d3_scale_linearTicks(domain, m) {
        return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
    }
    function d3_scale_linearTickFormat(domain, m, format) {
        var precision = -Math.floor(Math.log(d3_scale_linearTickRange(domain, m)[2]) / Math.LN10 + .01);
        return d3.format(format ? format.replace(d3_format_re, function(a, b1, c, d, e, f, g, h, i, j) {
            return [
                b1,
                c,
                d,
                e,
                f,
                g,
                h,
                i || "." + (precision - (j === "%") * 2),
                j
            ].join("");
        }) : ",." + precision + "f");
    }
    d3.scale.log = function() {
        return d3_scale_log(d3.scale.linear().domain([
            0,
            Math.LN10
        ]), 10, d3_scale_logp, d3_scale_powp);
    };
    function d3_scale_log(linear, base, log, pow) {
        function scale(x) {
            return linear(log(x));
        }
        scale.invert = function(x) {
            return pow(linear.invert(x));
        };
        scale.domain = function(x) {
            if (!arguments.length) return linear.domain().map(pow);
            if (x[0] < 0) log = d3_scale_logn, pow = d3_scale_pown;
            else log = d3_scale_logp, pow = d3_scale_powp;
            linear.domain(x.map(log));
            return scale;
        };
        scale.base = function(_) {
            if (!arguments.length) return base;
            base = +_;
            return scale;
        };
        scale.nice = function() {
            linear.domain(d3_scale_nice(linear.domain(), d3_scale_logNice(base)));
            return scale;
        };
        scale.ticks = function() {
            var extent = d3_scaleExtent(linear.domain()), ticks = [];
            if (extent.every(isFinite)) {
                var b1 = Math.log(base), i = Math.floor(extent[0] / b1), j = Math.ceil(extent[1] / b1), u = pow(extent[0]), v = pow(extent[1]), n = base % 1 ? 2 : base;
                if (log === d3_scale_logn) {
                    ticks.push(-Math.pow(base, -i));
                    for(; i++ < j;)for(var k = n - 1; k > 0; k--)ticks.push(-Math.pow(base, -i) * k);
                } else {
                    for(; i < j; i++)for(var k = 1; k < n; k++)ticks.push(Math.pow(base, i) * k);
                    ticks.push(Math.pow(base, i));
                }
                for(i = 0; ticks[i] < u; i++);
                for(j = ticks.length; ticks[j - 1] > v; j--);
                ticks = ticks.slice(i, j);
            }
            return ticks;
        };
        scale.tickFormat = function(n, format) {
            if (arguments.length < 2) format = d3_scale_logFormat;
            if (!arguments.length) return format;
            var b1 = Math.log(base), k = Math.max(.1, n / scale.ticks().length), f = log === d3_scale_logn ? (e = -0.000000000001, Math.floor) : (e = 1e-12, Math.ceil), e;
            return function(d) {
                return d / pow(b1 * f(log(d) / b1 + e)) <= k ? format(d) : "";
            };
        };
        scale.copy = function() {
            return d3_scale_log(linear.copy(), base, log, pow);
        };
        return d3_scale_linearRebind(scale, linear);
    }
    var d3_scale_logFormat = d3.format(".0e");
    function d3_scale_logp(x) {
        return Math.log(x < 0 ? 0 : x);
    }
    function d3_scale_powp(x) {
        return Math.exp(x);
    }
    function d3_scale_logn(x) {
        return -Math.log(x > 0 ? 0 : -x);
    }
    function d3_scale_pown(x) {
        return -Math.exp(-x);
    }
    function d3_scale_logNice(base) {
        base = Math.log(base);
        var nice = {
            floor: function(x) {
                return Math.floor(x / base) * base;
            },
            ceil: function(x) {
                return Math.ceil(x / base) * base;
            }
        };
        return function() {
            return nice;
        };
    }
    d3.scale.pow = function() {
        return d3_scale_pow(d3.scale.linear(), 1);
    };
    function d3_scale_pow(linear, exponent) {
        var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
        function scale(x) {
            return linear(powp(x));
        }
        scale.invert = function(x) {
            return powb(linear.invert(x));
        };
        scale.domain = function(x) {
            if (!arguments.length) return linear.domain().map(powb);
            linear.domain(x.map(powp));
            return scale;
        };
        scale.ticks = function(m) {
            return d3_scale_linearTicks(scale.domain(), m);
        };
        scale.tickFormat = function(m, format) {
            return d3_scale_linearTickFormat(scale.domain(), m, format);
        };
        scale.nice = function() {
            return scale.domain(d3_scale_nice(scale.domain(), d3_scale_linearNice));
        };
        scale.exponent = function(x) {
            if (!arguments.length) return exponent;
            var domain = scale.domain();
            powp = d3_scale_powPow(exponent = x);
            powb = d3_scale_powPow(1 / exponent);
            return scale.domain(domain);
        };
        scale.copy = function() {
            return d3_scale_pow(linear.copy(), exponent);
        };
        return d3_scale_linearRebind(scale, linear);
    }
    function d3_scale_powPow(e) {
        return function(x) {
            return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
        };
    }
    d3.scale.sqrt = function() {
        return d3.scale.pow().exponent(.5);
    };
    d3.scale.ordinal = function() {
        return d3_scale_ordinal([], {
            t: "range",
            a: [
                []
            ]
        });
    };
    function d3_scale_ordinal(domain, ranger) {
        var index, range, rangeBand;
        function scale(x) {
            return range[((index.get(x) || index.set(x, domain.push(x))) - 1) % range.length];
        }
        function steps(start, step) {
            return d3.range(domain.length).map(function(i) {
                return start + step * i;
            });
        }
        scale.domain = function(x) {
            if (!arguments.length) return domain;
            domain = [];
            index = new d3_Map();
            var i = -1, n = x.length, xi;
            while(++i < n)if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
            return scale[ranger.t].apply(scale, ranger.a);
        };
        scale.range = function(x) {
            if (!arguments.length) return range;
            range = x;
            rangeBand = 0;
            ranger = {
                t: "range",
                a: arguments
            };
            return scale;
        };
        scale.rangePoints = function(x, padding) {
            if (arguments.length < 2) padding = 0;
            var start = x[0], stop = x[1], step = (stop - start) / (Math.max(1, domain.length - 1) + padding);
            range = steps(domain.length < 2 ? (start + stop) / 2 : start + step * padding / 2, step);
            rangeBand = 0;
            ranger = {
                t: "rangePoints",
                a: arguments
            };
            return scale;
        };
        scale.rangeBands = function(x, padding, outerPadding) {
            if (arguments.length < 2) padding = 0;
            if (arguments.length < 3) outerPadding = padding;
            var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
            range = steps(start + step * outerPadding, step);
            if (reverse) range.reverse();
            rangeBand = step * (1 - padding);
            ranger = {
                t: "rangeBands",
                a: arguments
            };
            return scale;
        };
        scale.rangeRoundBands = function(x, padding, outerPadding) {
            if (arguments.length < 2) padding = 0;
            if (arguments.length < 3) outerPadding = padding;
            var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding)), error = stop - start - (domain.length - padding) * step;
            range = steps(start + Math.round(error / 2), step);
            if (reverse) range.reverse();
            rangeBand = Math.round(step * (1 - padding));
            ranger = {
                t: "rangeRoundBands",
                a: arguments
            };
            return scale;
        };
        scale.rangeBand = function() {
            return rangeBand;
        };
        scale.rangeExtent = function() {
            return d3_scaleExtent(ranger.a[0]);
        };
        scale.copy = function() {
            return d3_scale_ordinal(domain, ranger);
        };
        return scale.domain(domain);
    }
    d3.scale.category10 = function() {
        return d3.scale.ordinal().range(d3_category10);
    };
    d3.scale.category20 = function() {
        return d3.scale.ordinal().range(d3_category20);
    };
    d3.scale.category20b = function() {
        return d3.scale.ordinal().range(d3_category20b);
    };
    d3.scale.category20c = function() {
        return d3.scale.ordinal().range(d3_category20c);
    };
    var d3_category10 = [
        "#1f77b4",
        "#ff7f0e",
        "#2ca02c",
        "#d62728",
        "#9467bd",
        "#8c564b",
        "#e377c2",
        "#7f7f7f",
        "#bcbd22",
        "#17becf"
    ];
    var d3_category20 = [
        "#1f77b4",
        "#aec7e8",
        "#ff7f0e",
        "#ffbb78",
        "#2ca02c",
        "#98df8a",
        "#d62728",
        "#ff9896",
        "#9467bd",
        "#c5b0d5",
        "#8c564b",
        "#c49c94",
        "#e377c2",
        "#f7b6d2",
        "#7f7f7f",
        "#c7c7c7",
        "#bcbd22",
        "#dbdb8d",
        "#17becf",
        "#9edae5"
    ];
    var d3_category20b = [
        "#393b79",
        "#5254a3",
        "#6b6ecf",
        "#9c9ede",
        "#637939",
        "#8ca252",
        "#b5cf6b",
        "#cedb9c",
        "#8c6d31",
        "#bd9e39",
        "#e7ba52",
        "#e7cb94",
        "#843c39",
        "#ad494a",
        "#d6616b",
        "#e7969c",
        "#7b4173",
        "#a55194",
        "#ce6dbd",
        "#de9ed6"
    ];
    var d3_category20c = [
        "#3182bd",
        "#6baed6",
        "#9ecae1",
        "#c6dbef",
        "#e6550d",
        "#fd8d3c",
        "#fdae6b",
        "#fdd0a2",
        "#31a354",
        "#74c476",
        "#a1d99b",
        "#c7e9c0",
        "#756bb1",
        "#9e9ac8",
        "#bcbddc",
        "#dadaeb",
        "#636363",
        "#969696",
        "#bdbdbd",
        "#d9d9d9"
    ];
    d3.scale.quantile = function() {
        return d3_scale_quantile([], []);
    };
    function d3_scale_quantile(domain, range) {
        var thresholds;
        function rescale() {
            var k = 0, q = range.length;
            thresholds = [];
            while(++k < q)thresholds[k - 1] = d3.quantile(domain, k / q);
            return scale;
        }
        function scale(x) {
            if (isNaN(x = +x)) return NaN;
            return range[d3.bisect(thresholds, x)];
        }
        scale.domain = function(x) {
            if (!arguments.length) return domain;
            domain = x.filter(function(d) {
                return !isNaN(d);
            }).sort(d3.ascending);
            return rescale();
        };
        scale.range = function(x) {
            if (!arguments.length) return range;
            range = x;
            return rescale();
        };
        scale.quantiles = function() {
            return thresholds;
        };
        scale.copy = function() {
            return d3_scale_quantile(domain, range);
        };
        return rescale();
    }
    d3.scale.quantize = function() {
        return d3_scale_quantize(0, 1, [
            0,
            1
        ]);
    };
    function d3_scale_quantize(x0, x1, range) {
        var kx, i;
        function scale(x) {
            return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
        }
        function rescale() {
            kx = range.length / (x1 - x0);
            i = range.length - 1;
            return scale;
        }
        scale.domain = function(x) {
            if (!arguments.length) return [
                x0,
                x1
            ];
            x0 = +x[0];
            x1 = +x[x.length - 1];
            return rescale();
        };
        scale.range = function(x) {
            if (!arguments.length) return range;
            range = x;
            return rescale();
        };
        scale.copy = function() {
            return d3_scale_quantize(x0, x1, range);
        };
        return rescale();
    }
    d3.scale.threshold = function() {
        return d3_scale_threshold([
            .5
        ], [
            0,
            1
        ]);
    };
    function d3_scale_threshold(domain, range) {
        function scale(x) {
            return range[d3.bisect(domain, x)];
        }
        scale.domain = function(_) {
            if (!arguments.length) return domain;
            domain = _;
            return scale;
        };
        scale.range = function(_) {
            if (!arguments.length) return range;
            range = _;
            return scale;
        };
        scale.copy = function() {
            return d3_scale_threshold(domain, range);
        };
        return scale;
    }
    d3.scale.identity = function() {
        return d3_scale_identity([
            0,
            1
        ]);
    };
    function d3_scale_identity(domain) {
        function identity(x) {
            return +x;
        }
        identity.invert = identity;
        identity.domain = identity.range = function(x) {
            if (!arguments.length) return domain;
            domain = x.map(identity);
            return identity;
        };
        identity.ticks = function(m) {
            return d3_scale_linearTicks(domain, m);
        };
        identity.tickFormat = function(m, format) {
            return d3_scale_linearTickFormat(domain, m, format);
        };
        identity.copy = function() {
            return d3_scale_identity(domain);
        };
        return identity;
    }
    d3.svg.arc = function() {
        var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
        function arc() {
            var r0 = innerRadius.apply(this, arguments), r1 = outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) + d3_svg_arcOffset, a1 = endAngle.apply(this, arguments) + d3_svg_arcOffset, da = (a1 < a0 && (da = a0, a0 = a1, a1 = da), a1 - a0), df = da < \u03C0 ? "0" : "1", c0 = Math.cos(a0), s0 = Math.sin(a0), c1 = Math.cos(a1), s1 = Math.sin(a1);
            return da >= d3_svg_arcMax ? r0 ? "M0," + r1 + "A" + r1 + "," + r1 + " 0 1,1 0," + -r1 + "A" + r1 + "," + r1 + " 0 1,1 0," + r1 + "M0," + r0 + "A" + r0 + "," + r0 + " 0 1,0 0," + -r0 + "A" + r0 + "," + r0 + " 0 1,0 0," + r0 + "Z" : "M0," + r1 + "A" + r1 + "," + r1 + " 0 1,1 0," + -r1 + "A" + r1 + "," + r1 + " 0 1,1 0," + r1 + "Z" : r0 ? "M" + r1 * c0 + "," + r1 * s0 + "A" + r1 + "," + r1 + " 0 " + df + ",1 " + r1 * c1 + "," + r1 * s1 + "L" + r0 * c1 + "," + r0 * s1 + "A" + r0 + "," + r0 + " 0 " + df + ",0 " + r0 * c0 + "," + r0 * s0 + "Z" : "M" + r1 * c0 + "," + r1 * s0 + "A" + r1 + "," + r1 + " 0 " + df + ",1 " + r1 * c1 + "," + r1 * s1 + "L0,0" + "Z";
        }
        arc.innerRadius = function(v) {
            if (!arguments.length) return innerRadius;
            innerRadius = d3_functor(v);
            return arc;
        };
        arc.outerRadius = function(v) {
            if (!arguments.length) return outerRadius;
            outerRadius = d3_functor(v);
            return arc;
        };
        arc.startAngle = function(v) {
            if (!arguments.length) return startAngle;
            startAngle = d3_functor(v);
            return arc;
        };
        arc.endAngle = function(v) {
            if (!arguments.length) return endAngle;
            endAngle = d3_functor(v);
            return arc;
        };
        arc.centroid = function() {
            var r = (innerRadius.apply(this, arguments) + outerRadius.apply(this, arguments)) / 2, a = (startAngle.apply(this, arguments) + endAngle.apply(this, arguments)) / 2 + d3_svg_arcOffset;
            return [
                Math.cos(a) * r,
                Math.sin(a) * r
            ];
        };
        return arc;
    };
    var d3_svg_arcOffset = -\u03C0 / 2, d3_svg_arcMax = 2 * \u03C0 - 1e-6;
    function d3_svg_arcInnerRadius(d) {
        return d.innerRadius;
    }
    function d3_svg_arcOuterRadius(d) {
        return d.outerRadius;
    }
    function d3_svg_arcStartAngle(d) {
        return d.startAngle;
    }
    function d3_svg_arcEndAngle(d) {
        return d.endAngle;
    }
    d3.svg.line.radial = function() {
        var line = d3_svg_line(d3_svg_lineRadial);
        line.radius = line.x, delete line.x;
        line.angle = line.y, delete line.y;
        return line;
    };
    function d3_svg_lineRadial(points) {
        var point, i = -1, n = points.length, r, a;
        while(++i < n){
            point = points[i];
            r = point[0];
            a = point[1] + d3_svg_arcOffset;
            point[0] = r * Math.cos(a);
            point[1] = r * Math.sin(a);
        }
        return points;
    }
    function d3_svg_area(projection) {
        var x0 = d3_svg_lineX, x1 = d3_svg_lineX, y0 = 0, y1 = d3_svg_lineY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
        function area(data) {
            var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
                return x;
            } : d3_functor(x1), fy1 = y0 === y1 ? function() {
                return y;
            } : d3_functor(y1), x, y;
            function segment() {
                segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
            }
            while(++i < n){
                if (defined.call(this, d = data[i], i)) {
                    points0.push([
                        x = +fx0.call(this, d, i),
                        y = +fy0.call(this, d, i)
                    ]);
                    points1.push([
                        +fx1.call(this, d, i),
                        +fy1.call(this, d, i)
                    ]);
                } else if (points0.length) {
                    segment();
                    points0 = [];
                    points1 = [];
                }
            }
            if (points0.length) segment();
            return segments.length ? segments.join("") : null;
        }
        area.x = function(_) {
            if (!arguments.length) return x1;
            x0 = x1 = _;
            return area;
        };
        area.x0 = function(_) {
            if (!arguments.length) return x0;
            x0 = _;
            return area;
        };
        area.x1 = function(_) {
            if (!arguments.length) return x1;
            x1 = _;
            return area;
        };
        area.y = function(_) {
            if (!arguments.length) return y1;
            y0 = y1 = _;
            return area;
        };
        area.y0 = function(_) {
            if (!arguments.length) return y0;
            y0 = _;
            return area;
        };
        area.y1 = function(_) {
            if (!arguments.length) return y1;
            y1 = _;
            return area;
        };
        area.defined = function(_) {
            if (!arguments.length) return defined;
            defined = _;
            return area;
        };
        area.interpolate = function(_) {
            if (!arguments.length) return interpolateKey;
            if (typeof _ === "function") interpolateKey = interpolate = _;
            else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
            interpolateReverse = interpolate.reverse || interpolate;
            L = interpolate.closed ? "M" : "L";
            return area;
        };
        area.tension = function(_) {
            if (!arguments.length) return tension;
            tension = _;
            return area;
        };
        return area;
    }
    d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
    d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
    d3.svg.area = function() {
        return d3_svg_area(d3_identity);
    };
    d3.svg.area.radial = function() {
        var area = d3_svg_area(d3_svg_lineRadial);
        area.radius = area.x, delete area.x;
        area.innerRadius = area.x0, delete area.x0;
        area.outerRadius = area.x1, delete area.x1;
        area.angle = area.y, delete area.y;
        area.startAngle = area.y0, delete area.y0;
        area.endAngle = area.y1, delete area.y1;
        return area;
    };
    d3.svg.chord = function() {
        var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
        function chord(d, i) {
            var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
            return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
        }
        function subgroup(self, f, d, i) {
            var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) + d3_svg_arcOffset, a1 = endAngle.call(self, subgroup, i) + d3_svg_arcOffset;
            return {
                r: r,
                a0: a0,
                a1: a1,
                p0: [
                    r * Math.cos(a0),
                    r * Math.sin(a0)
                ],
                p1: [
                    r * Math.cos(a1),
                    r * Math.sin(a1)
                ]
            };
        }
        function equals(a, b1) {
            return a.a0 == b1.a0 && a.a1 == b1.a1;
        }
        function arc(r, p, a) {
            return "A" + r + "," + r + " 0 " + +(a > \u03C0) + ",1 " + p;
        }
        function curve(r0, p0, r1, p1) {
            return "Q 0,0 " + p1;
        }
        chord.radius = function(v) {
            if (!arguments.length) return radius;
            radius = d3_functor(v);
            return chord;
        };
        chord.source = function(v) {
            if (!arguments.length) return source;
            source = d3_functor(v);
            return chord;
        };
        chord.target = function(v) {
            if (!arguments.length) return target;
            target = d3_functor(v);
            return chord;
        };
        chord.startAngle = function(v) {
            if (!arguments.length) return startAngle;
            startAngle = d3_functor(v);
            return chord;
        };
        chord.endAngle = function(v) {
            if (!arguments.length) return endAngle;
            endAngle = d3_functor(v);
            return chord;
        };
        return chord;
    };
    function d3_svg_chordRadius(d) {
        return d.radius;
    }
    d3.svg.diagonal = function() {
        var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
        function diagonal(d, i) {
            var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [
                p0,
                {
                    x: p0.x,
                    y: m
                },
                {
                    x: p3.x,
                    y: m
                },
                p3
            ];
            p = p.map(projection);
            return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
        }
        diagonal.source = function(x) {
            if (!arguments.length) return source;
            source = d3_functor(x);
            return diagonal;
        };
        diagonal.target = function(x) {
            if (!arguments.length) return target;
            target = d3_functor(x);
            return diagonal;
        };
        diagonal.projection = function(x) {
            if (!arguments.length) return projection;
            projection = x;
            return diagonal;
        };
        return diagonal;
    };
    function d3_svg_diagonalProjection(d) {
        return [
            d.x,
            d.y
        ];
    }
    d3.svg.diagonal.radial = function() {
        var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
        diagonal.projection = function(x) {
            return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
        };
        return diagonal;
    };
    function d3_svg_diagonalRadialProjection(projection) {
        return function() {
            var d = projection.apply(this, arguments), r = d[0], a = d[1] + d3_svg_arcOffset;
            return [
                r * Math.cos(a),
                r * Math.sin(a)
            ];
        };
    }
    d3.svg.symbol = function() {
        var type = d3_svg_symbolType, size = d3_svg_symbolSize;
        function symbol(d, i) {
            return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
        }
        symbol.type = function(x) {
            if (!arguments.length) return type;
            type = d3_functor(x);
            return symbol;
        };
        symbol.size = function(x) {
            if (!arguments.length) return size;
            size = d3_functor(x);
            return symbol;
        };
        return symbol;
    };
    function d3_svg_symbolSize() {
        return 64;
    }
    function d3_svg_symbolType() {
        return "circle";
    }
    function d3_svg_symbolCircle(size) {
        var r = Math.sqrt(size / \u03C0);
        return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
    }
    var d3_svg_symbols = d3.map({
        circle: d3_svg_symbolCircle,
        cross: function(size) {
            var r = Math.sqrt(size / 5) / 2;
            return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
        },
        diamond: function(size) {
            var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
            return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
        },
        square: function(size) {
            var r = Math.sqrt(size) / 2;
            return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
        },
        "triangle-down": function(size) {
            var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
            return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
        },
        "triangle-up": function(size) {
            var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
            return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
        }
    });
    d3.svg.symbolTypes = d3_svg_symbols.keys();
    var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
    function d3_transition(groups, id) {
        d3_arraySubclass(groups, d3_transitionPrototype);
        groups.id = id;
        return groups;
    }
    var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit = {
        ease: d3_ease_cubicInOut,
        delay: 0,
        duration: 250
    };
    d3_transitionPrototype.call = d3_selectionPrototype.call;
    d3_transitionPrototype.empty = d3_selectionPrototype.empty;
    d3_transitionPrototype.node = d3_selectionPrototype.node;
    d3.transition = function(selection) {
        return arguments.length ? d3_transitionInheritId ? selection.transition() : selection : d3_selectionRoot.transition();
    };
    d3.transition.prototype = d3_transitionPrototype;
    d3_transitionPrototype.select = function(selector) {
        var id = this.id, subgroups = [], subgroup, subnode, node;
        if (typeof selector !== "function") selector = d3_selection_selector(selector);
        for(var j = -1, m = this.length; ++j < m;){
            subgroups.push(subgroup = []);
            for(var group = this[j], i = -1, n = group.length; ++i < n;)if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i))) {
                if ("__data__" in node) subnode.__data__ = node.__data__;
                d3_transitionNode(subnode, i, id, node.__transition__[id]);
                subgroup.push(subnode);
            } else subgroup.push(null);
        }
        return d3_transition(subgroups, id);
    };
    d3_transitionPrototype.selectAll = function(selector) {
        var id = this.id, subgroups = [], subgroup, subnodes, node, subnode, transition;
        if (typeof selector !== "function") selector = d3_selection_selectorAll(selector);
        for(var j = -1, m = this.length; ++j < m;){
            for(var group = this[j], i = -1, n = group.length; ++i < n;)if (node = group[i]) {
                transition = node.__transition__[id];
                subnodes = selector.call(node, node.__data__, i);
                subgroups.push(subgroup = []);
                for(var k = -1, o = subnodes.length; ++k < o;){
                    d3_transitionNode(subnode = subnodes[k], k, id, transition);
                    subgroup.push(subnode);
                }
            }
        }
        return d3_transition(subgroups, id);
    };
    d3_transitionPrototype.filter = function(filter) {
        var subgroups = [], subgroup, group, node;
        if (typeof filter !== "function") filter = d3_selection_filter(filter);
        for(var j = 0, m = this.length; j < m; j++){
            subgroups.push(subgroup = []);
            for(var group = this[j], i = 0, n = group.length; i < n; i++)if ((node = group[i]) && filter.call(node, node.__data__, i)) subgroup.push(node);
        }
        return d3_transition(subgroups, this.id, this.time).ease(this.ease());
    };
    d3_transitionPrototype.tween = function(name, tween) {
        var id = this.id;
        if (arguments.length < 2) return this.node().__transition__[id].tween.get(name);
        return d3_selection_each(this, tween == null ? function(node) {
            node.__transition__[id].tween.remove(name);
        } : function(node) {
            node.__transition__[id].tween.set(name, tween);
        });
    };
    function d3_transition_tween(groups, name, value, tween) {
        var id = groups.id;
        return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
            node.__transition__[id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
        } : (value = tween(value), function(node) {
            node.__transition__[id].tween.set(name, value);
        }));
    }
    d3_transitionPrototype.attr = function(nameNS, value) {
        if (arguments.length < 2) {
            for(value in nameNS)this.attr(value, nameNS[value]);
            return this;
        }
        var interpolate = d3_interpolateByName(nameNS), name = d3.ns.qualify(nameNS);
        function attrNull() {
            this.removeAttribute(name);
        }
        function attrNullNS() {
            this.removeAttributeNS(name.space, name.local);
        }
        return d3_transition_tween(this, "attr." + nameNS, value, function(b1) {
            function attrString() {
                var a = this.getAttribute(name), i;
                return a !== b1 && (i = interpolate(a, b1), function(t) {
                    this.setAttribute(name, i(t));
                });
            }
            function attrStringNS() {
                var a = this.getAttributeNS(name.space, name.local), i;
                return a !== b1 && (i = interpolate(a, b1), function(t) {
                    this.setAttributeNS(name.space, name.local, i(t));
                });
            }
            return b1 == null ? name.local ? attrNullNS : attrNull : (b1 += "", name.local ? attrStringNS : attrString);
        });
    };
    d3_transitionPrototype.attrTween = function(nameNS, tween) {
        var name = d3.ns.qualify(nameNS);
        function attrTween(d, i) {
            var f = tween.call(this, d, i, this.getAttribute(name));
            return f && function(t) {
                this.setAttribute(name, f(t));
            };
        }
        function attrTweenNS(d, i) {
            var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
            return f && function(t) {
                this.setAttributeNS(name.space, name.local, f(t));
            };
        }
        return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
    };
    d3_transitionPrototype.style = function(name, value, priority) {
        var n = arguments.length;
        if (n < 3) {
            if (typeof name !== "string") {
                if (n < 2) value = "";
                for(priority in name)this.style(priority, name[priority], value);
                return this;
            }
            priority = "";
        }
        var interpolate = d3_interpolateByName(name);
        function styleNull() {
            this.style.removeProperty(name);
        }
        return d3_transition_tween(this, "style." + name, value, function(b1) {
            function styleString() {
                var a = d3_window.getComputedStyle(this, null).getPropertyValue(name), i;
                return a !== b1 && (i = interpolate(a, b1), function(t) {
                    this.style.setProperty(name, i(t), priority);
                });
            }
            return b1 == null ? styleNull : (b1 += "", styleString);
        });
    };
    d3_transitionPrototype.styleTween = function(name, tween, priority) {
        if (arguments.length < 3) priority = "";
        return this.tween("style." + name, function(d, i) {
            var f = tween.call(this, d, i, d3_window.getComputedStyle(this, null).getPropertyValue(name));
            return f && function(t) {
                this.style.setProperty(name, f(t), priority);
            };
        });
    };
    d3_transitionPrototype.text = function(value) {
        return d3_transition_tween(this, "text", value, d3_transition_text);
    };
    function d3_transition_text(b1) {
        if (b1 == null) b1 = "";
        return function() {
            this.textContent = b1;
        };
    }
    d3_transitionPrototype.remove = function() {
        return this.each("end.transition", function() {
            var p;
            if (!this.__transition__ && (p = this.parentNode)) p.removeChild(this);
        });
    };
    d3_transitionPrototype.ease = function(value) {
        var id = this.id;
        if (arguments.length < 1) return this.node().__transition__[id].ease;
        if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
        return d3_selection_each(this, function(node) {
            node.__transition__[id].ease = value;
        });
    };
    d3_transitionPrototype.delay = function(value) {
        var id = this.id;
        return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
            node.__transition__[id].delay = value.call(node, node.__data__, i, j) | 0;
        } : (value |= 0, function(node) {
            node.__transition__[id].delay = value;
        }));
    };
    d3_transitionPrototype.duration = function(value) {
        var id = this.id;
        return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
            node.__transition__[id].duration = Math.max(1, value.call(node, node.__data__, i, j) | 0);
        } : (value = Math.max(1, value | 0), function(node) {
            node.__transition__[id].duration = value;
        }));
    };
    d3_transitionPrototype.each = function(type, listener) {
        var id = this.id;
        if (arguments.length < 2) {
            var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
            d3_transitionInheritId = id;
            d3_selection_each(this, function(node, i, j) {
                d3_transitionInherit = node.__transition__[id];
                type.call(node, node.__data__, i, j);
            });
            d3_transitionInherit = inherit;
            d3_transitionInheritId = inheritId;
        } else d3_selection_each(this, function(node) {
            node.__transition__[id].event.on(type, listener);
        });
        return this;
    };
    d3_transitionPrototype.transition = function() {
        var id0 = this.id, id1 = ++d3_transitionId, subgroups = [], subgroup, group, node, transition;
        for(var j = 0, m = this.length; j < m; j++){
            subgroups.push(subgroup = []);
            for(var group = this[j], i = 0, n = group.length; i < n; i++){
                if (node = group[i]) {
                    transition = Object.create(node.__transition__[id0]);
                    transition.delay += transition.duration;
                    d3_transitionNode(node, i, id1, transition);
                }
                subgroup.push(node);
            }
        }
        return d3_transition(subgroups, id1);
    };
    function d3_transitionNode(node, i, id, inherit) {
        var lock = node.__transition__ || (node.__transition__ = {
            active: 0,
            count: 0
        }), transition = lock[id];
        if (!transition) {
            var time = inherit.time;
            transition = lock[id] = {
                tween: new d3_Map(),
                event: d3.dispatch("start", "end"),
                time: time,
                ease: inherit.ease,
                delay: inherit.delay,
                duration: inherit.duration
            };
            ++lock.count;
            d3.timer(function(elapsed) {
                var d = node.__data__, ease = transition.ease, event = transition.event, delay = transition.delay, duration = transition.duration, tweened = [];
                return delay <= elapsed ? start(elapsed) : d3.timer(start, delay, time), 1;
                function start(elapsed) {
                    if (lock.active > id) return stop();
                    lock.active = id;
                    event.start.call(node, d, i);
                    transition.tween.forEach(function(key, value) {
                        if (value = value.call(node, d, i)) tweened.push(value);
                    });
                    if (!tick(elapsed)) d3.timer(tick, 0, time);
                    return 1;
                }
                function tick(elapsed) {
                    if (lock.active !== id) return stop();
                    var t = (elapsed - delay) / duration, e = ease(t), n = tweened.length;
                    while(n > 0)tweened[--n].call(node, e);
                    if (t >= 1) {
                        stop();
                        event.end.call(node, d, i);
                        return 1;
                    }
                }
                function stop() {
                    if (--lock.count) delete lock[id];
                    else delete node.__transition__;
                    return 1;
                }
            }, 0, time);
            return transition;
        }
    }
    d3.svg.axis = function() {
        var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, tickMajorSize = 6, tickMinorSize = 6, tickEndSize = 6, tickPadding = 3, tickArguments_ = [
            10
        ], tickValues = null, tickFormat_, tickSubdivide = 0;
        function axis(g) {
            g.each(function() {
                var g = d3.select(this);
                var ticks = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments_) : scale.domain() : tickValues, tickFormat = tickFormat_ == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments_) : String : tickFormat_;
                var subticks = d3_svg_axisSubdivide(scale, ticks, tickSubdivide), subtick = g.selectAll(".tick.minor").data(subticks, String), subtickEnter = subtick.enter().insert("line", ".tick").attr("class", "tick minor").style("opacity", 1e-6), subtickExit = d3.transition(subtick.exit()).style("opacity", 1e-6).remove(), subtickUpdate = d3.transition(subtick).style("opacity", 1);
                var tick = g.selectAll(".tick.major").data(ticks, String), tickEnter = tick.enter().insert("g", "path").attr("class", "tick major").style("opacity", 1e-6), tickExit = d3.transition(tick.exit()).style("opacity", 1e-6).remove(), tickUpdate = d3.transition(tick).style("opacity", 1), tickTransform;
                var range = d3_scaleRange(scale), path = g.selectAll(".domain").data([
                    0
                ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), d3.transition(path));
                var scale1 = scale.copy(), scale0 = this.__chart__ || scale1;
                this.__chart__ = scale1;
                tickEnter.append("line");
                tickEnter.append("text");
                var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text");
                switch(orient){
                    case "bottom":
                        tickTransform = d3_svg_axisX;
                        subtickEnter.attr("y2", tickMinorSize);
                        subtickUpdate.attr("x2", 0).attr("y2", tickMinorSize);
                        lineEnter.attr("y2", tickMajorSize);
                        textEnter.attr("y", Math.max(tickMajorSize, 0) + tickPadding);
                        lineUpdate.attr("x2", 0).attr("y2", tickMajorSize);
                        textUpdate.attr("x", 0).attr("y", Math.max(tickMajorSize, 0) + tickPadding);
                        text.attr("dy", ".71em").style("text-anchor", "middle");
                        pathUpdate.attr("d", "M" + range[0] + "," + tickEndSize + "V0H" + range[1] + "V" + tickEndSize);
                        break;
                    case "top":
                        tickTransform = d3_svg_axisX;
                        subtickEnter.attr("y2", -tickMinorSize);
                        subtickUpdate.attr("x2", 0).attr("y2", -tickMinorSize);
                        lineEnter.attr("y2", -tickMajorSize);
                        textEnter.attr("y", -(Math.max(tickMajorSize, 0) + tickPadding));
                        lineUpdate.attr("x2", 0).attr("y2", -tickMajorSize);
                        textUpdate.attr("x", 0).attr("y", -(Math.max(tickMajorSize, 0) + tickPadding));
                        text.attr("dy", "0em").style("text-anchor", "middle");
                        pathUpdate.attr("d", "M" + range[0] + "," + -tickEndSize + "V0H" + range[1] + "V" + -tickEndSize);
                        break;
                    case "left":
                        tickTransform = d3_svg_axisY;
                        subtickEnter.attr("x2", -tickMinorSize);
                        subtickUpdate.attr("x2", -tickMinorSize).attr("y2", 0);
                        lineEnter.attr("x2", -tickMajorSize);
                        textEnter.attr("x", -(Math.max(tickMajorSize, 0) + tickPadding));
                        lineUpdate.attr("x2", -tickMajorSize).attr("y2", 0);
                        textUpdate.attr("x", -(Math.max(tickMajorSize, 0) + tickPadding)).attr("y", 0);
                        text.attr("dy", ".32em").style("text-anchor", "end");
                        pathUpdate.attr("d", "M" + -tickEndSize + "," + range[0] + "H0V" + range[1] + "H" + -tickEndSize);
                        break;
                    case "right":
                        tickTransform = d3_svg_axisY;
                        subtickEnter.attr("x2", tickMinorSize);
                        subtickUpdate.attr("x2", tickMinorSize).attr("y2", 0);
                        lineEnter.attr("x2", tickMajorSize);
                        textEnter.attr("x", Math.max(tickMajorSize, 0) + tickPadding);
                        lineUpdate.attr("x2", tickMajorSize).attr("y2", 0);
                        textUpdate.attr("x", Math.max(tickMajorSize, 0) + tickPadding).attr("y", 0);
                        text.attr("dy", ".32em").style("text-anchor", "start");
                        pathUpdate.attr("d", "M" + tickEndSize + "," + range[0] + "H0V" + range[1] + "H" + tickEndSize);
                        break;
                }
                if (scale.ticks) {
                    tickEnter.call(tickTransform, scale0);
                    tickUpdate.call(tickTransform, scale1);
                    tickExit.call(tickTransform, scale1);
                    subtickEnter.call(tickTransform, scale0);
                    subtickUpdate.call(tickTransform, scale1);
                    subtickExit.call(tickTransform, scale1);
                } else {
                    var dx = scale1.rangeBand() / 2, x = function(d) {
                        return scale1(d) + dx;
                    };
                    tickEnter.call(tickTransform, x);
                    tickUpdate.call(tickTransform, x);
                }
            });
        }
        axis.scale = function(x) {
            if (!arguments.length) return scale;
            scale = x;
            return axis;
        };
        axis.orient = function(x) {
            if (!arguments.length) return orient;
            orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
            return axis;
        };
        axis.ticks = function() {
            if (!arguments.length) return tickArguments_;
            tickArguments_ = arguments;
            return axis;
        };
        axis.tickValues = function(x) {
            if (!arguments.length) return tickValues;
            tickValues = x;
            return axis;
        };
        axis.tickFormat = function(x) {
            if (!arguments.length) return tickFormat_;
            tickFormat_ = x;
            return axis;
        };
        axis.tickSize = function(x, y) {
            if (!arguments.length) return tickMajorSize;
            var n = arguments.length - 1;
            tickMajorSize = +x;
            tickMinorSize = n > 1 ? +y : tickMajorSize;
            tickEndSize = n > 0 ? +arguments[n] : tickMajorSize;
            return axis;
        };
        axis.tickPadding = function(x) {
            if (!arguments.length) return tickPadding;
            tickPadding = +x;
            return axis;
        };
        axis.tickSubdivide = function(x) {
            if (!arguments.length) return tickSubdivide;
            tickSubdivide = +x;
            return axis;
        };
        return axis;
    };
    var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
    };
    function d3_svg_axisX(selection, x) {
        selection.attr("transform", function(d) {
            return "translate(" + x(d) + ",0)";
        });
    }
    function d3_svg_axisY(selection, y) {
        selection.attr("transform", function(d) {
            return "translate(0," + y(d) + ")";
        });
    }
    function d3_svg_axisSubdivide(scale, ticks, m) {
        subticks = [];
        if (m && ticks.length > 1) {
            var extent = d3_scaleExtent(scale.domain()), subticks, i = -1, n = ticks.length, d = (ticks[1] - ticks[0]) / ++m, j, v;
            while(++i < n){
                for(j = m; --j > 0;)if ((v = +ticks[i] - j * d) >= extent[0]) subticks.push(v);
            }
            for(--i, j = 0; ++j < m && (v = +ticks[i] + j * d) < extent[1];)subticks.push(v);
        }
        return subticks;
    }
    d3.svg.brush = function() {
        var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, resizes = d3_svg_brushResizes[0], extent = [
            [
                0,
                0
            ],
            [
                0,
                0
            ]
        ], extentDomain;
        function brush(g) {
            g.each(function() {
                var g = d3.select(this), bg = g.selectAll(".background").data([
                    0
                ]), fg = g.selectAll(".extent").data([
                    0
                ]), tz = g.selectAll(".resize").data(resizes, String), e;
                g.style("pointer-events", "all").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
                bg.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
                fg.enter().append("rect").attr("class", "extent").style("cursor", "move");
                tz.enter().append("g").attr("class", function(d) {
                    return "resize " + d;
                }).style("cursor", function(d) {
                    return d3_svg_brushCursor[d];
                }).append("rect").attr("x", function(d) {
                    return /[ew]$/.test(d) ? -3 : null;
                }).attr("y", function(d) {
                    return /^[ns]/.test(d) ? -3 : null;
                }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
                tz.style("display", brush.empty() ? "none" : null);
                tz.exit().remove();
                if (x) {
                    e = d3_scaleRange(x);
                    bg.attr("x", e[0]).attr("width", e[1] - e[0]);
                    redrawX(g);
                }
                if (y) {
                    e = d3_scaleRange(y);
                    bg.attr("y", e[0]).attr("height", e[1] - e[0]);
                    redrawY(g);
                }
                redraw(g);
            });
        }
        function redraw(g) {
            g.selectAll(".resize").attr("transform", function(d) {
                return "translate(" + extent[+/e$/.test(d)][0] + "," + extent[+/^s/.test(d)][1] + ")";
            });
        }
        function redrawX(g) {
            g.select(".extent").attr("x", extent[0][0]);
            g.selectAll(".extent,.n>rect,.s>rect").attr("width", extent[1][0] - extent[0][0]);
        }
        function redrawY(g) {
            g.select(".extent").attr("y", extent[0][1]);
            g.selectAll(".extent,.e>rect,.w>rect").attr("height", extent[1][1] - extent[0][1]);
        }
        function brushstart() {
            var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), center, origin = mouse(), offset;
            var w = d3.select(d3_window).on("mousemove.brush", brushmove).on("mouseup.brush", brushend).on("touchmove.brush", brushmove).on("touchend.brush", brushend).on("keydown.brush", keydown).on("keyup.brush", keyup);
            if (dragging) {
                origin[0] = extent[0][0] - origin[0];
                origin[1] = extent[0][1] - origin[1];
            } else if (resizing) {
                var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
                offset = [
                    extent[1 - ex][0] - origin[0],
                    extent[1 - ey][1] - origin[1]
                ];
                origin[0] = extent[ex][0];
                origin[1] = extent[ey][1];
            } else if (d3.event.altKey) center = origin.slice();
            g.style("pointer-events", "none").selectAll(".resize").style("display", null);
            d3.select("body").style("cursor", eventTarget.style("cursor"));
            event_({
                type: "brushstart"
            });
            brushmove();
            d3_eventCancel();
            function mouse() {
                var touches = d3.event.changedTouches;
                return touches ? d3.touches(target, touches)[0] : d3.mouse(target);
            }
            function keydown() {
                if (d3.event.keyCode == 32) {
                    if (!dragging) {
                        center = null;
                        origin[0] -= extent[1][0];
                        origin[1] -= extent[1][1];
                        dragging = 2;
                    }
                    d3_eventCancel();
                }
            }
            function keyup() {
                if (d3.event.keyCode == 32 && dragging == 2) {
                    origin[0] += extent[1][0];
                    origin[1] += extent[1][1];
                    dragging = 0;
                    d3_eventCancel();
                }
            }
            function brushmove() {
                var point = mouse(), moved = false;
                if (offset) {
                    point[0] += offset[0];
                    point[1] += offset[1];
                }
                if (!dragging) {
                    if (d3.event.altKey) {
                        if (!center) center = [
                            (extent[0][0] + extent[1][0]) / 2,
                            (extent[0][1] + extent[1][1]) / 2
                        ];
                        origin[0] = extent[+(point[0] < center[0])][0];
                        origin[1] = extent[+(point[1] < center[1])][1];
                    } else center = null;
                }
                if (resizingX && move1(point, x, 0)) {
                    redrawX(g);
                    moved = true;
                }
                if (resizingY && move1(point, y, 1)) {
                    redrawY(g);
                    moved = true;
                }
                if (moved) {
                    redraw(g);
                    event_({
                        type: "brush",
                        mode: dragging ? "move" : "resize"
                    });
                }
            }
            function move1(point, scale, i) {
                var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], size = extent[1][i] - extent[0][i], min, max;
                if (dragging) {
                    r0 -= position;
                    r1 -= size + position;
                }
                min = Math.max(r0, Math.min(r1, point[i]));
                if (dragging) max = (min += position) + size;
                else {
                    if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
                    if (position < min) {
                        max = min;
                        min = position;
                    } else max = position;
                }
                if (extent[0][i] !== min || extent[1][i] !== max) {
                    extentDomain = null;
                    extent[0][i] = min;
                    extent[1][i] = max;
                    return true;
                }
            }
            function brushend() {
                brushmove();
                g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
                d3.select("body").style("cursor", null);
                w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
                event_({
                    type: "brushend"
                });
                d3_eventCancel();
            }
        }
        brush.x = function(z) {
            if (!arguments.length) return x;
            x = z;
            resizes = d3_svg_brushResizes[!x << 1 | !y];
            return brush;
        };
        brush.y = function(z) {
            if (!arguments.length) return y;
            y = z;
            resizes = d3_svg_brushResizes[!x << 1 | !y];
            return brush;
        };
        brush.extent = function(z) {
            var x0, x1, y0, y1, t;
            if (!arguments.length) {
                z = extentDomain || extent;
                if (x) {
                    x0 = z[0][0], x1 = z[1][0];
                    if (!extentDomain) {
                        x0 = extent[0][0], x1 = extent[1][0];
                        if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
                        if (x1 < x0) t = x0, x0 = x1, x1 = t;
                    }
                }
                if (y) {
                    y0 = z[0][1], y1 = z[1][1];
                    if (!extentDomain) {
                        y0 = extent[0][1], y1 = extent[1][1];
                        if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
                        if (y1 < y0) t = y0, y0 = y1, y1 = t;
                    }
                }
                return x && y ? [
                    [
                        x0,
                        y0
                    ],
                    [
                        x1,
                        y1
                    ]
                ] : x ? [
                    x0,
                    x1
                ] : y && [
                    y0,
                    y1
                ];
            }
            extentDomain = [
                [
                    0,
                    0
                ],
                [
                    0,
                    0
                ]
            ];
            if (x) {
                x0 = z[0], x1 = z[1];
                if (y) x0 = x0[0], x1 = x1[0];
                extentDomain[0][0] = x0, extentDomain[1][0] = x1;
                if (x.invert) x0 = x(x0), x1 = x(x1);
                if (x1 < x0) t = x0, x0 = x1, x1 = t;
                extent[0][0] = x0 | 0, extent[1][0] = x1 | 0;
            }
            if (y) {
                y0 = z[0], y1 = z[1];
                if (x) y0 = y0[1], y1 = y1[1];
                extentDomain[0][1] = y0, extentDomain[1][1] = y1;
                if (y.invert) y0 = y(y0), y1 = y(y1);
                if (y1 < y0) t = y0, y0 = y1, y1 = t;
                extent[0][1] = y0 | 0, extent[1][1] = y1 | 0;
            }
            return brush;
        };
        brush.clear = function() {
            extentDomain = null;
            extent[0][0] = extent[0][1] = extent[1][0] = extent[1][1] = 0;
            return brush;
        };
        brush.empty = function() {
            return x && extent[0][0] === extent[1][0] || y && extent[0][1] === extent[1][1];
        };
        return d3.rebind(brush, event, "on");
    };
    var d3_svg_brushCursor = {
        n: "ns-resize",
        e: "ew-resize",
        s: "ns-resize",
        w: "ew-resize",
        nw: "nwse-resize",
        ne: "nesw-resize",
        se: "nwse-resize",
        sw: "nesw-resize"
    };
    var d3_svg_brushResizes = [
        [
            "n",
            "e",
            "s",
            "w",
            "nw",
            "ne",
            "se",
            "sw"
        ],
        [
            "e",
            "w"
        ],
        [
            "n",
            "s"
        ],
        []
    ];
    d3.time = {};
    var d3_time = Date, d3_time_daySymbols = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ];
    function d3_time_utc() {
        this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
    }
    d3_time_utc.prototype = {
        getDate: function() {
            return this._.getUTCDate();
        },
        getDay: function() {
            return this._.getUTCDay();
        },
        getFullYear: function() {
            return this._.getUTCFullYear();
        },
        getHours: function() {
            return this._.getUTCHours();
        },
        getMilliseconds: function() {
            return this._.getUTCMilliseconds();
        },
        getMinutes: function() {
            return this._.getUTCMinutes();
        },
        getMonth: function() {
            return this._.getUTCMonth();
        },
        getSeconds: function() {
            return this._.getUTCSeconds();
        },
        getTime: function() {
            return this._.getTime();
        },
        getTimezoneOffset: function() {
            return 0;
        },
        valueOf: function() {
            return this._.valueOf();
        },
        setDate: function() {
            d3_time_prototype.setUTCDate.apply(this._, arguments);
        },
        setDay: function() {
            d3_time_prototype.setUTCDay.apply(this._, arguments);
        },
        setFullYear: function() {
            d3_time_prototype.setUTCFullYear.apply(this._, arguments);
        },
        setHours: function() {
            d3_time_prototype.setUTCHours.apply(this._, arguments);
        },
        setMilliseconds: function() {
            d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
        },
        setMinutes: function() {
            d3_time_prototype.setUTCMinutes.apply(this._, arguments);
        },
        setMonth: function() {
            d3_time_prototype.setUTCMonth.apply(this._, arguments);
        },
        setSeconds: function() {
            d3_time_prototype.setUTCSeconds.apply(this._, arguments);
        },
        setTime: function() {
            d3_time_prototype.setTime.apply(this._, arguments);
        }
    };
    var d3_time_prototype = Date.prototype;
    var d3_time_formatDateTime = "%a %b %e %X %Y", d3_time_formatDate = "%m/%d/%Y", d3_time_formatTime = "%H:%M:%S";
    var d3_time_days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ], d3_time_dayAbbreviations = [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ], d3_time_months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ], d3_time_monthAbbreviations = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ];
    function d3_time_interval(local, step, number) {
        function round(date) {
            var d0 = local(date), d1 = offset(d0, 1);
            return date - d0 < d1 - date ? d0 : d1;
        }
        function ceil(date) {
            step(date = local(new d3_time(date - 1)), 1);
            return date;
        }
        function offset(date, k) {
            step(date = new d3_time(+date), k);
            return date;
        }
        function range(t0, t1, dt) {
            var time = ceil(t0), times = [];
            if (dt > 1) while(time < t1){
                if (!(number(time) % dt)) times.push(new Date(+time));
                step(time, 1);
            }
            else while(time < t1)times.push(new Date(+time)), step(time, 1);
            return times;
        }
        function range_utc(t0, t1, dt) {
            try {
                d3_time = d3_time_utc;
                var utc = new d3_time_utc();
                utc._ = t0;
                return range(utc, t1, dt);
            } finally{
                d3_time = Date;
            }
        }
        local.floor = local;
        local.round = round;
        local.ceil = ceil;
        local.offset = offset;
        local.range = range;
        var utc = local.utc = d3_time_interval_utc(local);
        utc.floor = utc;
        utc.round = d3_time_interval_utc(round);
        utc.ceil = d3_time_interval_utc(ceil);
        utc.offset = d3_time_interval_utc(offset);
        utc.range = range_utc;
        return local;
    }
    function d3_time_interval_utc(method) {
        return function(date, k) {
            try {
                d3_time = d3_time_utc;
                var utc = new d3_time_utc();
                utc._ = date;
                return method(utc, k)._;
            } finally{
                d3_time = Date;
            }
        };
    }
    d3.time.year = d3_time_interval(function(date) {
        date = d3.time.day(date);
        date.setMonth(0, 1);
        return date;
    }, function(date, offset) {
        date.setFullYear(date.getFullYear() + offset);
    }, function(date) {
        return date.getFullYear();
    });
    d3.time.years = d3.time.year.range;
    d3.time.years.utc = d3.time.year.utc.range;
    d3.time.day = d3_time_interval(function(date) {
        var day = new d3_time(1970, 0);
        day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
        return day;
    }, function(date, offset) {
        date.setDate(date.getDate() + offset);
    }, function(date) {
        return date.getDate() - 1;
    });
    d3.time.days = d3.time.day.range;
    d3.time.days.utc = d3.time.day.utc.range;
    d3.time.dayOfYear = function(date) {
        var year = d3.time.year(date);
        return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
    };
    d3_time_daySymbols.forEach(function(day, i) {
        day = day.toLowerCase();
        i = 7 - i;
        var interval = d3.time[day] = d3_time_interval(function(date) {
            (date = d3.time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
            return date;
        }, function(date, offset) {
            date.setDate(date.getDate() + Math.floor(offset) * 7);
        }, function(date) {
            var day = d3.time.year(date).getDay();
            return Math.floor((d3.time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
        });
        d3.time[day + "s"] = interval.range;
        d3.time[day + "s"].utc = interval.utc.range;
        d3.time[day + "OfYear"] = function(date) {
            var day = d3.time.year(date).getDay();
            return Math.floor((d3.time.dayOfYear(date) + (day + i) % 7) / 7);
        };
    });
    d3.time.week = d3.time.sunday;
    d3.time.weeks = d3.time.sunday.range;
    d3.time.weeks.utc = d3.time.sunday.utc.range;
    d3.time.weekOfYear = d3.time.sundayOfYear;
    d3.time.format = function(template) {
        var n = template.length;
        function format(date) {
            var string = [], i = -1, j = 0, c, p, f;
            while(++i < n)if (template.charCodeAt(i) === 37) {
                string.push(template.substring(j, i));
                if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
                if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
                string.push(c);
                j = i + 1;
            }
            string.push(template.substring(j, i));
            return string.join("");
        }
        format.parse = function(string) {
            var d = {
                y: 1900,
                m: 0,
                d: 1,
                H: 0,
                M: 0,
                S: 0,
                L: 0
            }, i = d3_time_parse(d, template, string, 0);
            if (i != string.length) return null;
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            var date = new d3_time();
            date.setFullYear(d.y, d.m, d.d);
            date.setHours(d.H, d.M, d.S, d.L);
            return date;
        };
        format.toString = function() {
            return template;
        };
        return format;
    };
    function d3_time_parse(date, template, string, j) {
        var c, p, i = 0, n = template.length, m = string.length;
        while(i < n){
            if (j >= m) return -1;
            c = template.charCodeAt(i++);
            if (c === 37) {
                p = d3_time_parsers[template.charAt(i++)];
                if (!p || (j = p(date, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function d3_time_formatRe(names) {
        return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
    }
    function d3_time_formatLookup(names) {
        var map = new d3_Map(), i = -1, n = names.length;
        while(++i < n)map.set(names[i].toLowerCase(), i);
        return map;
    }
    function d3_time_formatPad(value, fill, width) {
        value += "";
        var length = value.length;
        return length < width ? new Array(width - length + 1).join(fill) + value : value;
    }
    var d3_time_dayRe = d3_time_formatRe(d3_time_days), d3_time_dayAbbrevRe = d3_time_formatRe(d3_time_dayAbbreviations), d3_time_monthRe = d3_time_formatRe(d3_time_months), d3_time_monthLookup = d3_time_formatLookup(d3_time_months), d3_time_monthAbbrevRe = d3_time_formatRe(d3_time_monthAbbreviations), d3_time_monthAbbrevLookup = d3_time_formatLookup(d3_time_monthAbbreviations);
    var d3_time_formatPads = {
        "-": "",
        _: " ",
        "0": "0"
    };
    var d3_time_formats = {
        a: function(d) {
            return d3_time_dayAbbreviations[d.getDay()];
        },
        A: function(d) {
            return d3_time_days[d.getDay()];
        },
        b: function(d) {
            return d3_time_monthAbbreviations[d.getMonth()];
        },
        B: function(d) {
            return d3_time_months[d.getMonth()];
        },
        c: d3.time.format(d3_time_formatDateTime),
        d: function(d, p) {
            return d3_time_formatPad(d.getDate(), p, 2);
        },
        e: function(d, p) {
            return d3_time_formatPad(d.getDate(), p, 2);
        },
        H: function(d, p) {
            return d3_time_formatPad(d.getHours(), p, 2);
        },
        I: function(d, p) {
            return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
        },
        j: function(d, p) {
            return d3_time_formatPad(1 + d3.time.dayOfYear(d), p, 3);
        },
        L: function(d, p) {
            return d3_time_formatPad(d.getMilliseconds(), p, 3);
        },
        m: function(d, p) {
            return d3_time_formatPad(d.getMonth() + 1, p, 2);
        },
        M: function(d, p) {
            return d3_time_formatPad(d.getMinutes(), p, 2);
        },
        p: function(d) {
            return d.getHours() >= 12 ? "PM" : "AM";
        },
        S: function(d, p) {
            return d3_time_formatPad(d.getSeconds(), p, 2);
        },
        U: function(d, p) {
            return d3_time_formatPad(d3.time.sundayOfYear(d), p, 2);
        },
        w: function(d) {
            return d.getDay();
        },
        W: function(d, p) {
            return d3_time_formatPad(d3.time.mondayOfYear(d), p, 2);
        },
        x: d3.time.format(d3_time_formatDate),
        X: d3.time.format(d3_time_formatTime),
        y: function(d, p) {
            return d3_time_formatPad(d.getFullYear() % 100, p, 2);
        },
        Y: function(d, p) {
            return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
        },
        Z: d3_time_zone,
        "%": function() {
            return "%";
        }
    };
    var d3_time_parsers = {
        a: d3_time_parseWeekdayAbbrev,
        A: d3_time_parseWeekday,
        b: d3_time_parseMonthAbbrev,
        B: d3_time_parseMonth,
        c: d3_time_parseLocaleFull,
        d: d3_time_parseDay,
        e: d3_time_parseDay,
        H: d3_time_parseHour24,
        I: d3_time_parseHour24,
        L: d3_time_parseMilliseconds,
        m: d3_time_parseMonthNumber,
        M: d3_time_parseMinutes,
        p: d3_time_parseAmPm,
        S: d3_time_parseSeconds,
        x: d3_time_parseLocaleDate,
        X: d3_time_parseLocaleTime,
        y: d3_time_parseYear,
        Y: d3_time_parseFullYear
    };
    function d3_time_parseWeekdayAbbrev(date, string, i) {
        d3_time_dayAbbrevRe.lastIndex = 0;
        var n = d3_time_dayAbbrevRe.exec(string.substring(i));
        return n ? i += n[0].length : -1;
    }
    function d3_time_parseWeekday(date, string, i) {
        d3_time_dayRe.lastIndex = 0;
        var n = d3_time_dayRe.exec(string.substring(i));
        return n ? i += n[0].length : -1;
    }
    function d3_time_parseMonthAbbrev(date, string, i) {
        d3_time_monthAbbrevRe.lastIndex = 0;
        var n = d3_time_monthAbbrevRe.exec(string.substring(i));
        return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i += n[0].length) : -1;
    }
    function d3_time_parseMonth(date, string, i) {
        d3_time_monthRe.lastIndex = 0;
        var n = d3_time_monthRe.exec(string.substring(i));
        return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i += n[0].length) : -1;
    }
    function d3_time_parseLocaleFull(date, string, i) {
        return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
    }
    function d3_time_parseLocaleDate(date, string, i) {
        return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
    }
    function d3_time_parseLocaleTime(date, string, i) {
        return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
    }
    function d3_time_parseFullYear(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.substring(i, i + 4));
        return n ? (date.y = +n[0], i += n[0].length) : -1;
    }
    function d3_time_parseYear(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.substring(i, i + 2));
        return n ? (date.y = d3_time_expandYear(+n[0]), i += n[0].length) : -1;
    }
    function d3_time_expandYear(d) {
        return d + (d > 68 ? 1900 : 2e3);
    }
    function d3_time_parseMonthNumber(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.substring(i, i + 2));
        return n ? (date.m = n[0] - 1, i += n[0].length) : -1;
    }
    function d3_time_parseDay(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.substring(i, i + 2));
        return n ? (date.d = +n[0], i += n[0].length) : -1;
    }
    function d3_time_parseHour24(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.substring(i, i + 2));
        return n ? (date.H = +n[0], i += n[0].length) : -1;
    }
    function d3_time_parseMinutes(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.substring(i, i + 2));
        return n ? (date.M = +n[0], i += n[0].length) : -1;
    }
    function d3_time_parseSeconds(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.substring(i, i + 2));
        return n ? (date.S = +n[0], i += n[0].length) : -1;
    }
    function d3_time_parseMilliseconds(date, string, i) {
        d3_time_numberRe.lastIndex = 0;
        var n = d3_time_numberRe.exec(string.substring(i, i + 3));
        return n ? (date.L = +n[0], i += n[0].length) : -1;
    }
    var d3_time_numberRe = /^\s*\d+/;
    function d3_time_parseAmPm(date, string, i) {
        var n = d3_time_amPmLookup.get(string.substring(i, i += 2).toLowerCase());
        return n == null ? -1 : (date.p = n, i);
    }
    var d3_time_amPmLookup = d3.map({
        am: 0,
        pm: 1
    });
    function d3_time_zone(d) {
        var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = ~~(Math.abs(z) / 60), zm = Math.abs(z) % 60;
        return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
    }
    d3.time.format.utc = function(template) {
        var local = d3.time.format(template);
        function format(date) {
            try {
                d3_time = d3_time_utc;
                var utc = new d3_time();
                utc._ = date;
                return local(utc);
            } finally{
                d3_time = Date;
            }
        }
        format.parse = function(string) {
            try {
                d3_time = d3_time_utc;
                var date = local.parse(string);
                return date && date._;
            } finally{
                d3_time = Date;
            }
        };
        format.toString = local.toString;
        return format;
    };
    var d3_time_formatIso = d3.time.format.utc("%Y-%m-%dT%H:%M:%S.%LZ");
    d3.time.format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
    function d3_time_formatIsoNative(date) {
        return date.toISOString();
    }
    d3_time_formatIsoNative.parse = function(string) {
        var date = new Date(string);
        return isNaN(date) ? null : date;
    };
    d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
    d3.time.second = d3_time_interval(function(date) {
        return new d3_time(Math.floor(date / 1e3) * 1e3);
    }, function(date, offset) {
        date.setTime(date.getTime() + Math.floor(offset) * 1e3);
    }, function(date) {
        return date.getSeconds();
    });
    d3.time.seconds = d3.time.second.range;
    d3.time.seconds.utc = d3.time.second.utc.range;
    d3.time.minute = d3_time_interval(function(date) {
        return new d3_time(Math.floor(date / 6e4) * 6e4);
    }, function(date, offset) {
        date.setTime(date.getTime() + Math.floor(offset) * 6e4);
    }, function(date) {
        return date.getMinutes();
    });
    d3.time.minutes = d3.time.minute.range;
    d3.time.minutes.utc = d3.time.minute.utc.range;
    d3.time.hour = d3_time_interval(function(date) {
        var timezone = date.getTimezoneOffset() / 60;
        return new d3_time((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
    }, function(date, offset) {
        date.setTime(date.getTime() + Math.floor(offset) * 36e5);
    }, function(date) {
        return date.getHours();
    });
    d3.time.hours = d3.time.hour.range;
    d3.time.hours.utc = d3.time.hour.utc.range;
    d3.time.month = d3_time_interval(function(date) {
        date = d3.time.day(date);
        date.setDate(1);
        return date;
    }, function(date, offset) {
        date.setMonth(date.getMonth() + offset);
    }, function(date) {
        return date.getMonth();
    });
    d3.time.months = d3.time.month.range;
    d3.time.months.utc = d3.time.month.utc.range;
    function d3_time_scale(linear, methods, format) {
        function scale(x) {
            return linear(x);
        }
        scale.invert = function(x) {
            return d3_time_scaleDate(linear.invert(x));
        };
        scale.domain = function(x) {
            if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
            linear.domain(x);
            return scale;
        };
        scale.nice = function(m) {
            return scale.domain(d3_scale_nice(scale.domain(), function() {
                return m;
            }));
        };
        scale.ticks = function(m, k) {
            var extent = d3_time_scaleExtent(scale.domain());
            if (typeof m !== "function") {
                var span = extent[1] - extent[0], target = span / m, i = d3.bisect(d3_time_scaleSteps, target);
                if (i == d3_time_scaleSteps.length) return methods.year(extent, m);
                if (!i) return linear.ticks(m).map(d3_time_scaleDate);
                if (Math.log(target / d3_time_scaleSteps[i - 1]) < Math.log(d3_time_scaleSteps[i] / target)) --i;
                m = methods[i];
                k = m[1];
                m = m[0].range;
            }
            return m(extent[0], new Date(+extent[1] + 1), k);
        };
        scale.tickFormat = function() {
            return format;
        };
        scale.copy = function() {
            return d3_time_scale(linear.copy(), methods, format);
        };
        return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
    }
    function d3_time_scaleExtent(domain) {
        var start = domain[0], stop = domain[domain.length - 1];
        return start < stop ? [
            start,
            stop
        ] : [
            stop,
            start
        ];
    }
    function d3_time_scaleDate(t) {
        return new Date(t);
    }
    function d3_time_scaleFormat(formats) {
        return function(date) {
            var i = formats.length - 1, f = formats[i];
            while(!f[1](date))f = formats[--i];
            return f[0](date);
        };
    }
    function d3_time_scaleSetYear(y) {
        var d = new Date(y, 0, 1);
        d.setFullYear(y);
        return d;
    }
    function d3_time_scaleGetYear(d) {
        var y = d.getFullYear(), d0 = d3_time_scaleSetYear(y), d1 = d3_time_scaleSetYear(y + 1);
        return y + (d - d0) / (d1 - d0);
    }
    var d3_time_scaleSteps = [
        1e3,
        5e3,
        15e3,
        3e4,
        6e4,
        3e5,
        9e5,
        18e5,
        36e5,
        108e5,
        216e5,
        432e5,
        864e5,
        1728e5,
        6048e5,
        2592e6,
        7776e6,
        31536e6
    ];
    var d3_time_scaleLocalMethods = [
        [
            d3.time.second,
            1
        ],
        [
            d3.time.second,
            5
        ],
        [
            d3.time.second,
            15
        ],
        [
            d3.time.second,
            30
        ],
        [
            d3.time.minute,
            1
        ],
        [
            d3.time.minute,
            5
        ],
        [
            d3.time.minute,
            15
        ],
        [
            d3.time.minute,
            30
        ],
        [
            d3.time.hour,
            1
        ],
        [
            d3.time.hour,
            3
        ],
        [
            d3.time.hour,
            6
        ],
        [
            d3.time.hour,
            12
        ],
        [
            d3.time.day,
            1
        ],
        [
            d3.time.day,
            2
        ],
        [
            d3.time.week,
            1
        ],
        [
            d3.time.month,
            1
        ],
        [
            d3.time.month,
            3
        ],
        [
            d3.time.year,
            1
        ]
    ];
    var d3_time_scaleLocalFormats = [
        [
            d3.time.format("%Y"),
            d3_true
        ],
        [
            d3.time.format("%B"),
            function(d) {
                return d.getMonth();
            }
        ],
        [
            d3.time.format("%b %d"),
            function(d) {
                return d.getDate() != 1;
            }
        ],
        [
            d3.time.format("%a %d"),
            function(d) {
                return d.getDay() && d.getDate() != 1;
            }
        ],
        [
            d3.time.format("%I %p"),
            function(d) {
                return d.getHours();
            }
        ],
        [
            d3.time.format("%I:%M"),
            function(d) {
                return d.getMinutes();
            }
        ],
        [
            d3.time.format(":%S"),
            function(d) {
                return d.getSeconds();
            }
        ],
        [
            d3.time.format(".%L"),
            function(d) {
                return d.getMilliseconds();
            }
        ]
    ];
    var d3_time_scaleLinear = d3.scale.linear(), d3_time_scaleLocalFormat = d3_time_scaleFormat(d3_time_scaleLocalFormats);
    d3_time_scaleLocalMethods.year = function(extent, m) {
        return d3_time_scaleLinear.domain(extent.map(d3_time_scaleGetYear)).ticks(m).map(d3_time_scaleSetYear);
    };
    d3.time.scale = function() {
        return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
    };
    var d3_time_scaleUTCMethods = d3_time_scaleLocalMethods.map(function(m) {
        return [
            m[0].utc,
            m[1]
        ];
    });
    var d3_time_scaleUTCFormats = [
        [
            d3.time.format.utc("%Y"),
            d3_true
        ],
        [
            d3.time.format.utc("%B"),
            function(d) {
                return d.getUTCMonth();
            }
        ],
        [
            d3.time.format.utc("%b %d"),
            function(d) {
                return d.getUTCDate() != 1;
            }
        ],
        [
            d3.time.format.utc("%a %d"),
            function(d) {
                return d.getUTCDay() && d.getUTCDate() != 1;
            }
        ],
        [
            d3.time.format.utc("%I %p"),
            function(d) {
                return d.getUTCHours();
            }
        ],
        [
            d3.time.format.utc("%I:%M"),
            function(d) {
                return d.getUTCMinutes();
            }
        ],
        [
            d3.time.format.utc(":%S"),
            function(d) {
                return d.getUTCSeconds();
            }
        ],
        [
            d3.time.format.utc(".%L"),
            function(d) {
                return d.getUTCMilliseconds();
            }
        ]
    ];
    var d3_time_scaleUTCFormat = d3_time_scaleFormat(d3_time_scaleUTCFormats);
    function d3_time_scaleUTCSetYear(y) {
        var d = new Date(Date.UTC(y, 0, 1));
        d.setUTCFullYear(y);
        return d;
    }
    function d3_time_scaleUTCGetYear(d) {
        var y = d.getUTCFullYear(), d0 = d3_time_scaleUTCSetYear(y), d1 = d3_time_scaleUTCSetYear(y + 1);
        return y + (d - d0) / (d1 - d0);
    }
    d3_time_scaleUTCMethods.year = function(extent, m) {
        return d3_time_scaleLinear.domain(extent.map(d3_time_scaleUTCGetYear)).ticks(m).map(d3_time_scaleUTCSetYear);
    };
    d3.time.scale.utc = function() {
        return d3_time_scale(d3.scale.linear(), d3_time_scaleUTCMethods, d3_time_scaleUTCFormat);
    };
    d3.text = function() {
        return d3.xhr.apply(d3, arguments).response(d3_text);
    };
    function d3_text(request) {
        return request.responseText;
    }
    d3.json = function(url, callback) {
        return d3.xhr(url, "application/json", callback).response(d3_json);
    };
    function d3_json(request) {
        return JSON.parse(request.responseText);
    }
    d3.html = function(url, callback) {
        return d3.xhr(url, "text/html", callback).response(d3_html);
    };
    function d3_html(request) {
        var range = d3_document.createRange();
        range.selectNode(d3_document.body);
        return range.createContextualFragment(request.responseText);
    }
    d3.xml = function() {
        return d3.xhr.apply(d3, arguments).response(d3_xml);
    };
    function d3_xml(request) {
        return request.responseXML;
    }
    return d3;
}();
(function() {
    var nv = window.nv || {};
    nv.version = '1.1.11b';
    nv.dev = true //set false when in production
    ;
    window.nv = nv;
    nv.tooltip = {}; // For the tooltip system
    nv.utils = {}; // Utility subsystem
    nv.models = {}; //stores all the possible models/components
    nv.charts = {}; //stores all the ready to use charts
    nv.graphs = []; //stores all the graphs currently on the page
    nv.logs = {}; //stores some statistics and potential error messages
    nv.dispatch = $9175b321012dc0d3$var$d3.dispatch('render_start', 'render_end');
    // *************************************************************************
    //  Development render timers - disabled if dev = false
    if (nv.dev) {
        nv.dispatch.on('render_start', function(e) {
            nv.logs.startTime = +new Date();
        });
        nv.dispatch.on('render_end', function(e) {
            nv.logs.endTime = +new Date();
            nv.logs.totalTime = nv.logs.endTime - nv.logs.startTime;
            nv.log('total', nv.logs.totalTime); // used for development, to keep track of graph generation times
        });
    }
    // ********************************************
    //  Public Core NV functions
    // Logs all arguments, and returns the last so you can test things in place
    // Note: in IE8 console.log is an object not a function, and if modernizr is used
    // then calling Function.prototype.bind with with anything other than a function
    // causes a TypeError to be thrown.
    nv.log = function() {
        if (nv.dev && console.log && console.log.apply) console.log.apply(console, arguments);
        else if (nv.dev && typeof console.log == "function" && Function.prototype.bind) {
            var log = Function.prototype.bind.call(console.log, console);
            log.apply(console, arguments);
        }
        return arguments[arguments.length - 1];
    };
    nv.render = function render(step) {
        step = step || 1; // number of graphs to generate in each timeout loop
        nv.render.active = true;
        nv.dispatch.render_start();
        setTimeout(function() {
            var chart, graph;
            for(var i = 0; i < step && (graph = nv.render.queue[i]); i++){
                chart = graph.generate();
                if (typeof graph.callback == typeof Function) graph.callback(chart);
                nv.graphs.push(chart);
            }
            nv.render.queue.splice(0, i);
            if (nv.render.queue.length) setTimeout(arguments.callee, 0);
            else {
                nv.render.active = false;
                nv.dispatch.render_end();
            }
        }, 0);
    };
    nv.render.active = false;
    nv.render.queue = [];
    nv.addGraph = function(obj) {
        if (typeof arguments[0] === typeof Function) obj = {
            generate: arguments[0],
            callback: arguments[1]
        };
        nv.render.queue.push(obj);
        if (!nv.render.active) nv.render();
    };
    nv.identity = function(d) {
        return d;
    };
    nv.strip = function(s) {
        return s.replace(/(\s|&)/g, '');
    };
    function daysInMonth(month, year) {
        return new Date(year, month + 1, 0).getDate();
    }
    function d3_time_range(floor, step, number) {
        return function(t0, t1, dt) {
            var time = floor(t0), times = [];
            if (time < t0) step(time);
            if (dt > 1) while(time < t1){
                var date = new Date(+time);
                if (number(date) % dt === 0) times.push(date);
                step(time);
            }
            else while(time < t1){
                times.push(new Date(+time));
                step(time);
            }
            return times;
        };
    }
    $9175b321012dc0d3$var$d3.time.monthEnd = function(date) {
        return new Date(date.getFullYear(), date.getMonth(), 0);
    };
    $9175b321012dc0d3$var$d3.time.monthEnds = d3_time_range($9175b321012dc0d3$var$d3.time.monthEnd, function(date) {
        date.setUTCDate(date.getUTCDate() + 1);
        date.setDate(daysInMonth(date.getMonth() + 1, date.getFullYear()));
    }, function(date) {
        return date.getMonth();
    });
    /* Utility class to handle creation of an interactive layer.
This places a rectangle on top of the chart. When you mouse move over it, it sends a dispatch
containing the X-coordinate. It can also render a vertical line where the mouse is located.

dispatch.elementMousemove is the important event to latch onto.  It is fired whenever the mouse moves over
the rectangle. The dispatch is given one object which contains the mouseX/Y location.
It also has 'pointXValue', which is the conversion of mouseX to the x-axis scale.
*/ nv.interactiveGuideline = function() {
        "use strict";
        var tooltip = nv.models.tooltip();
        //Public settings
        var width = null, height = null, margin = {
            left: 0,
            top: 0
        }, xScale = $9175b321012dc0d3$var$d3.scale.linear(), yScale = $9175b321012dc0d3$var$d3.scale.linear(), dispatch = $9175b321012dc0d3$var$d3.dispatch('elementMousemove', 'elementMouseout', 'elementDblclick'), showGuideLine = true, svgContainer = null;
        //Private variables
        var isMSIE = navigator.userAgent.indexOf("MSIE") !== -1 //Check user-agent for Microsoft Internet Explorer.
        ;
        function layer(selection) {
            selection.each(function(data) {
                var container = $9175b321012dc0d3$var$d3.select(this);
                var availableWidth = width || 960, availableHeight = height || 400;
                var wrap = container.selectAll("g.nv-wrap.nv-interactiveLineLayer").data([
                    data
                ]);
                var wrapEnter = wrap.enter().append("g").attr("class", " nv-wrap nv-interactiveLineLayer");
                wrapEnter.append("g").attr("class", "nv-interactiveGuideLine");
                if (!svgContainer) return;
                function mouseHandler() {
                    var d3mouse = $9175b321012dc0d3$var$d3.mouse(this);
                    var mouseX = d3mouse[0];
                    var mouseY = d3mouse[1];
                    var subtractMargin = true;
                    var mouseOutAnyReason = false;
                    if (isMSIE) {
                        /*
                            D3.js (or maybe SVG.getScreenCTM) has a nasty bug in Internet Explorer 10.
                            d3.mouse() returns incorrect X,Y mouse coordinates when mouse moving
                            over a rect in IE 10.
                            However, d3.event.offsetX/Y also returns the mouse coordinates
                            relative to the triggering <rect>. So we use offsetX/Y on IE.
                         */ mouseX = $9175b321012dc0d3$var$d3.event.offsetX;
                        mouseY = $9175b321012dc0d3$var$d3.event.offsetY;
                        /*
                            On IE, if you attach a mouse event listener to the <svg> container,
                            it will actually trigger it for all the child elements (like <path>, <circle>, etc).
                            When this happens on IE, the offsetX/Y is set to where ever the child element
                            is located.
                            As a result, we do NOT need to subtract margins to figure out the mouse X/Y
                            position under this scenario. Removing the line below *will* cause
                            the interactive layer to not work right on IE.
                         */ if ($9175b321012dc0d3$var$d3.event.target.tagName !== "svg") subtractMargin = false;
                        if ($9175b321012dc0d3$var$d3.event.target.className.baseVal.match("nv-legend")) mouseOutAnyReason = true;
                    }
                    if (subtractMargin) {
                        mouseX -= margin.left;
                        mouseY -= margin.top;
                    }
                    /* If mouseX/Y is outside of the chart's bounds,
                      trigger a mouseOut event.
                      */ if (mouseX < 0 || mouseY < 0 || mouseX > availableWidth || mouseY > availableHeight || $9175b321012dc0d3$var$d3.event.relatedTarget && $9175b321012dc0d3$var$d3.event.relatedTarget.ownerSVGElement === undefined || mouseOutAnyReason) {
                        if (isMSIE) {
                            if ($9175b321012dc0d3$var$d3.event.relatedTarget && $9175b321012dc0d3$var$d3.event.relatedTarget.ownerSVGElement === undefined && $9175b321012dc0d3$var$d3.event.relatedTarget.className.match(tooltip.nvPointerEventsClass)) return;
                        }
                        dispatch.elementMouseout({
                            mouseX: mouseX,
                            mouseY: mouseY
                        });
                        layer.renderGuideLine(null); //hide the guideline
                        return;
                    }
                    var pointXValue = xScale.invert(mouseX);
                    dispatch.elementMousemove({
                        mouseX: mouseX,
                        mouseY: mouseY,
                        pointXValue: pointXValue
                    });
                    //If user double clicks the layer, fire a elementDblclick dispatch.
                    if ($9175b321012dc0d3$var$d3.event.type === "dblclick") dispatch.elementDblclick({
                        mouseX: mouseX,
                        mouseY: mouseY,
                        pointXValue: pointXValue
                    });
                }
                svgContainer.on("mousemove", mouseHandler, true).on("mouseout", mouseHandler, true).on("dblclick", mouseHandler);
                //Draws a vertical guideline at the given X postion.
                layer.renderGuideLine = function(x) {
                    if (!showGuideLine) return;
                    var line = wrap.select(".nv-interactiveGuideLine").selectAll("line").data(x != null ? [
                        nv.utils.NaNtoZero(x)
                    ] : [], String);
                    line.enter().append("line").attr("class", "nv-guideline").attr("x1", function(d) {
                        return d;
                    }).attr("x2", function(d) {
                        return d;
                    }).attr("y1", availableHeight).attr("y2", 0);
                    line.exit().remove();
                };
            });
        }
        layer.dispatch = dispatch;
        layer.tooltip = tooltip;
        layer.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return layer;
        };
        layer.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return layer;
        };
        layer.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return layer;
        };
        layer.xScale = function(_) {
            if (!arguments.length) return xScale;
            xScale = _;
            return layer;
        };
        layer.showGuideLine = function(_) {
            if (!arguments.length) return showGuideLine;
            showGuideLine = _;
            return layer;
        };
        layer.svgContainer = function(_) {
            if (!arguments.length) return svgContainer;
            svgContainer = _;
            return layer;
        };
        return layer;
    };
    /* Utility class that uses d3.bisect to find the index in a given array, where a search value can be inserted.
This is different from normal bisectLeft; this function finds the nearest index to insert the search value.

For instance, lets say your array is [1,2,3,5,10,30], and you search for 28.
Normal d3.bisectLeft will return 4, because 28 is inserted after the number 10.  But interactiveBisect will return 5
because 28 is closer to 30 than 10.

Unit tests can be found in: interactiveBisectTest.html

Has the following known issues:
   * Will not work if the data points move backwards (ie, 10,9,8,7, etc) or if the data points are in random order.
   * Won't work if there are duplicate x coordinate values.
*/ nv.interactiveBisect = function(values, searchVal, xAccessor) {
        "use strict";
        if (!values instanceof Array) return null;
        if (typeof xAccessor !== 'function') xAccessor = function(d, i) {
            return d.x;
        };
        var bisect = $9175b321012dc0d3$var$d3.bisector(xAccessor).left;
        var index = $9175b321012dc0d3$var$d3.max([
            0,
            bisect(values, searchVal) - 1
        ]);
        var currentValue = xAccessor(values[index], index);
        if (typeof currentValue === 'undefined') currentValue = index;
        if (currentValue === searchVal) return index; //found exact match
        var nextIndex = $9175b321012dc0d3$var$d3.min([
            index + 1,
            values.length - 1
        ]);
        var nextValue = xAccessor(values[nextIndex], nextIndex);
        if (typeof nextValue === 'undefined') nextValue = nextIndex;
        if (Math.abs(nextValue - searchVal) >= Math.abs(currentValue - searchVal)) return index;
        else return nextIndex;
    }; /* Tooltip rendering model for nvd3 charts.
window.nv.models.tooltip is the updated,new way to render tooltips.

window.nv.tooltip.show is the old tooltip code.
window.nv.tooltip.* also has various helper methods.
*/ 
    (function() {
        "use strict";
        window.nv.tooltip = {};
        /* Model which can be instantiated to handle tooltip rendering.
    Example usage:
    var tip = nv.models.tooltip().gravity('w').distance(23)
                .data(myDataObject);

        tip();    //just invoke the returned function to render tooltip.
  */ window.nv.models.tooltip = function() {
            var content = null //HTML contents of the tooltip.  If null, the content is generated via the data variable.
            , data = null, gravity = 'w' //Can be 'n','s','e','w'. Determines how tooltip is positioned.
            , distance = 50 //Distance to offset tooltip from the mouse location.
            , snapDistance = 25 //Tolerance allowed before tooltip is moved from its current position (creates 'snapping' effect)
            , fixedTop = null //If not null, this fixes the top position of the tooltip.
            , classes = null //Attaches additional CSS classes to the tooltip DIV that is created.
            , chartContainer = null //Parent DIV, of the SVG Container that holds the chart.
            , tooltipElem = null //actual DOM element representing the tooltip.
            , position = {
                left: null,
                top: null
            } //Relative position of the tooltip inside chartContainer.
            , enabled = true //True -> tooltips are rendered. False -> don't render tooltips.
            , id = "nvtooltip-" + Math.floor(Math.random() * 100000);
            //CSS class to specify whether element should not have mouse events.
            var nvPointerEventsClass = "nv-pointer-events-none";
            //Format function for the tooltip values column
            var valueFormatter = function(d, i) {
                return d;
            };
            //Format function for the tooltip header value.
            var headerFormatter = function(d) {
                return d;
            };
            //By default, the tooltip model renders a beautiful table inside a DIV.
            //You can override this function if a custom tooltip is desired.
            var contentGenerator = function(d) {
                if (content != null) return content;
                if (d == null) return '';
                var table = $9175b321012dc0d3$var$d3.select(document.createElement("table"));
                var theadEnter = table.selectAll("thead").data([
                    d
                ]).enter().append("thead");
                theadEnter.append("tr").append("td").attr("colspan", 3).append("strong").classed("x-value", true).text(headerFormatter(d.value));
                var tbodyEnter = table.selectAll("tbody").data([
                    d
                ]).enter().append("tbody");
                var trowEnter = tbodyEnter.selectAll("tr").data(function(p) {
                    return p.series;
                }).enter().append("tr").classed("highlight", function(p) {
                    return p.highlight;
                });
                trowEnter.append("td").classed("legend-color-guide", true).append("div").style("background-color", function(p) {
                    return p.color;
                });
                trowEnter.append("td").classed("key", true).text(function(p) {
                    return p.key;
                });
                trowEnter.append("td").classed("value", true).text(function(p, i) {
                    return valueFormatter(p.value, i);
                });
                trowEnter.selectAll("td").each(function(p) {
                    if (p.highlight) $9175b321012dc0d3$var$d3.select(this).style("border-bottom", "solid 1px " + p.color).style("border-top", "solid 1px " + p.color);
                });
                var html = table.node().outerHTML;
                if (d.footer !== undefined) html += "<div class='footer'>" + d.footer + "</div>";
                return html;
            };
            var dataSeriesExists = function(d) {
                if (d && d.series && d.series.length > 0) return true;
                return false;
            };
            //In situations where the chart is in a 'viewBox', re-position the tooltip based on how far chart is zoomed.
            function convertViewBoxRatio() {
                if (chartContainer) {
                    var svg = $9175b321012dc0d3$var$d3.select(chartContainer);
                    if (svg.node().tagName !== "svg") svg = svg.select("svg");
                    var viewBox = svg.node() ? svg.attr('viewBox') : null;
                    if (viewBox) {
                        viewBox = viewBox.split(' ');
                        var ratio = parseInt(svg.style('width')) / viewBox[2];
                        position.left = position.left * ratio;
                        position.top = position.top * ratio;
                    }
                }
            }
            //Creates new tooltip container, or uses existing one on DOM.
            function getTooltipContainer(newContent) {
                var body;
                if (chartContainer) body = $9175b321012dc0d3$var$d3.select(chartContainer);
                else body = $9175b321012dc0d3$var$d3.select("body");
                var container = body.select(".nvtooltip");
                if (container.node() === null) //Create new tooltip div if it doesn't exist on DOM.
                container = body.append("div").attr("class", "nvtooltip " + (classes ? classes : "xy-tooltip")).attr("id", id);
                container.node().innerHTML = newContent;
                container.style("top", 0).style("left", 0).style("opacity", 0);
                container.selectAll("div, table, td, tr").classed(nvPointerEventsClass, true);
                container.classed(nvPointerEventsClass, true);
                return container.node();
            }
            //Draw the tooltip onto the DOM.
            function nvtooltip() {
                if (!enabled) return;
                if (!dataSeriesExists(data)) return;
                convertViewBoxRatio();
                var left = position.left;
                var top = fixedTop != null ? fixedTop : position.top;
                var container = getTooltipContainer(contentGenerator(data));
                tooltipElem = container;
                if (chartContainer) {
                    var svgComp = chartContainer.getElementsByTagName("svg")[0];
                    var boundRect = svgComp ? svgComp.getBoundingClientRect() : chartContainer.getBoundingClientRect();
                    var svgOffset = {
                        left: 0,
                        top: 0
                    };
                    if (svgComp) {
                        var svgBound = svgComp.getBoundingClientRect();
                        var chartBound = chartContainer.getBoundingClientRect();
                        var svgBoundTop = svgBound.top;
                        //Defensive code. Sometimes, svgBoundTop can be a really negative
                        //  number, like -134254. That's a bug.
                        //  If such a number is found, use zero instead. FireFox bug only
                        if (svgBoundTop < 0) {
                            var containerBound = chartContainer.getBoundingClientRect();
                            svgBoundTop = Math.abs(svgBoundTop) > containerBound.height ? 0 : svgBoundTop;
                        }
                        svgOffset.top = Math.abs(svgBoundTop - chartBound.top);
                        svgOffset.left = Math.abs(svgBound.left - chartBound.left);
                    }
                    //If the parent container is an overflow <div> with scrollbars, subtract the scroll offsets.
                    //You need to also add any offset between the <svg> element and its containing <div>
                    //Finally, add any offset of the containing <div> on the whole page.
                    left += chartContainer.offsetLeft + svgOffset.left - 2 * chartContainer.scrollLeft;
                    top += chartContainer.offsetTop + svgOffset.top - 2 * chartContainer.scrollTop;
                }
                if (snapDistance && snapDistance > 0) top = Math.floor(top / snapDistance) * snapDistance;
                nv.tooltip.calcTooltipPosition([
                    left,
                    top
                ], gravity, distance, container);
                return nvtooltip;
            }
            nvtooltip.nvPointerEventsClass = nvPointerEventsClass;
            nvtooltip.content = function(_) {
                if (!arguments.length) return content;
                content = _;
                return nvtooltip;
            };
            //Returns tooltipElem...not able to set it.
            nvtooltip.tooltipElem = function() {
                return tooltipElem;
            };
            nvtooltip.contentGenerator = function(_) {
                if (!arguments.length) return contentGenerator;
                if (typeof _ === 'function') contentGenerator = _;
                return nvtooltip;
            };
            nvtooltip.data = function(_) {
                if (!arguments.length) return data;
                data = _;
                return nvtooltip;
            };
            nvtooltip.gravity = function(_) {
                if (!arguments.length) return gravity;
                gravity = _;
                return nvtooltip;
            };
            nvtooltip.distance = function(_) {
                if (!arguments.length) return distance;
                distance = _;
                return nvtooltip;
            };
            nvtooltip.snapDistance = function(_) {
                if (!arguments.length) return snapDistance;
                snapDistance = _;
                return nvtooltip;
            };
            nvtooltip.classes = function(_) {
                if (!arguments.length) return classes;
                classes = _;
                return nvtooltip;
            };
            nvtooltip.chartContainer = function(_) {
                if (!arguments.length) return chartContainer;
                chartContainer = _;
                return nvtooltip;
            };
            nvtooltip.position = function(_) {
                if (!arguments.length) return position;
                position.left = typeof _.left !== 'undefined' ? _.left : position.left;
                position.top = typeof _.top !== 'undefined' ? _.top : position.top;
                return nvtooltip;
            };
            nvtooltip.fixedTop = function(_) {
                if (!arguments.length) return fixedTop;
                fixedTop = _;
                return nvtooltip;
            };
            nvtooltip.enabled = function(_) {
                if (!arguments.length) return enabled;
                enabled = _;
                return nvtooltip;
            };
            nvtooltip.valueFormatter = function(_) {
                if (!arguments.length) return valueFormatter;
                if (typeof _ === 'function') valueFormatter = _;
                return nvtooltip;
            };
            nvtooltip.headerFormatter = function(_) {
                if (!arguments.length) return headerFormatter;
                if (typeof _ === 'function') headerFormatter = _;
                return nvtooltip;
            };
            //id() is a read-only function. You can't use it to set the id.
            nvtooltip.id = function() {
                return id;
            };
            return nvtooltip;
        };
        //Original tooltip.show function. Kept for backward compatibility.
        // pos = [left,top]
        nv.tooltip.show = function(pos, content, gravity, dist, parentContainer, classes) {
            //Create new tooltip div if it doesn't exist on DOM.
            var container = document.createElement('div');
            container.className = 'nvtooltip ' + (classes ? classes : 'xy-tooltip');
            var body = parentContainer;
            if (!parentContainer || parentContainer.tagName.match(/g|svg/i)) //If the parent element is an SVG element, place tooltip in the <body> element.
            body = document.getElementsByTagName('body')[0];
            container.style.left = 0;
            container.style.top = 0;
            container.style.opacity = 0;
            container.innerHTML = content;
            body.appendChild(container);
            //If the parent container is an overflow <div> with scrollbars, subtract the scroll offsets.
            if (parentContainer) {
                pos[0] = pos[0] - parentContainer.scrollLeft;
                pos[1] = pos[1] - parentContainer.scrollTop;
            }
            nv.tooltip.calcTooltipPosition(pos, gravity, dist, container);
        };
        //Looks up the ancestry of a DOM element, and returns the first NON-svg node.
        nv.tooltip.findFirstNonSVGParent = function(Elem) {
            while(Elem.tagName.match(/^g|svg$/i) !== null)Elem = Elem.parentNode;
            return Elem;
        };
        //Finds the total offsetTop of a given DOM element.
        //Looks up the entire ancestry of an element, up to the first relatively positioned element.
        nv.tooltip.findTotalOffsetTop = function(Elem, initialTop) {
            var offsetTop = initialTop;
            do if (!isNaN(Elem.offsetTop)) offsetTop += Elem.offsetTop;
            while (Elem = Elem.offsetParent);
            return offsetTop;
        };
        //Finds the total offsetLeft of a given DOM element.
        //Looks up the entire ancestry of an element, up to the first relatively positioned element.
        nv.tooltip.findTotalOffsetLeft = function(Elem, initialLeft) {
            var offsetLeft = initialLeft;
            do if (!isNaN(Elem.offsetLeft)) offsetLeft += Elem.offsetLeft;
            while (Elem = Elem.offsetParent);
            return offsetLeft;
        };
        //Global utility function to render a tooltip on the DOM.
        //pos = [left,top] coordinates of where to place the tooltip, relative to the SVG chart container.
        //gravity = how to orient the tooltip
        //dist = how far away from the mouse to place tooltip
        //container = tooltip DIV
        nv.tooltip.calcTooltipPosition = function(pos, gravity, dist, container) {
            var height = parseInt(container.offsetHeight), width = parseInt(container.offsetWidth), windowWidth = nv.utils.windowSize().width, windowHeight = nv.utils.windowSize().height, scrollTop = window.pageYOffset, scrollLeft = window.pageXOffset, left, top;
            windowHeight = window.innerWidth >= document.body.scrollWidth ? windowHeight : windowHeight - 16;
            windowWidth = window.innerHeight >= document.body.scrollHeight ? windowWidth : windowWidth - 16;
            gravity = gravity || 's';
            dist = dist || 20;
            var tooltipTop = function(Elem) {
                return nv.tooltip.findTotalOffsetTop(Elem, top);
            };
            var tooltipLeft = function(Elem) {
                return nv.tooltip.findTotalOffsetLeft(Elem, left);
            };
            switch(gravity){
                case 'e':
                    left = pos[0] - width - dist;
                    top = pos[1] - height / 2;
                    var tLeft = tooltipLeft(container);
                    var tTop = tooltipTop(container);
                    if (tLeft < scrollLeft) left = pos[0] + dist > scrollLeft ? pos[0] + dist : scrollLeft - tLeft + left;
                    if (tTop < scrollTop) top = scrollTop - tTop + top;
                    if (tTop + height > scrollTop + windowHeight) top = scrollTop + windowHeight - tTop + top - height;
                    break;
                case 'w':
                    left = pos[0] + dist;
                    top = pos[1] - height / 2;
                    var tLeft = tooltipLeft(container);
                    var tTop = tooltipTop(container);
                    if (tLeft + width > windowWidth) left = pos[0] - width - dist;
                    if (tTop < scrollTop) top = scrollTop + 5;
                    if (tTop + height > scrollTop + windowHeight) top = scrollTop + windowHeight - tTop + top - height;
                    break;
                case 'n':
                    left = pos[0] - width / 2 - 5;
                    top = pos[1] + dist;
                    var tLeft = tooltipLeft(container);
                    var tTop = tooltipTop(container);
                    if (tLeft < scrollLeft) left = scrollLeft + 5;
                    if (tLeft + width > windowWidth) left = left - width / 2 + 5;
                    if (tTop + height > scrollTop + windowHeight) top = scrollTop + windowHeight - tTop + top - height;
                    break;
                case 's':
                    left = pos[0] - width / 2;
                    top = pos[1] - height - dist;
                    var tLeft = tooltipLeft(container);
                    var tTop = tooltipTop(container);
                    if (tLeft < scrollLeft) left = scrollLeft + 5;
                    if (tLeft + width > windowWidth) left = left - width / 2 + 5;
                    if (scrollTop > tTop) top = scrollTop;
                    break;
                case 'none':
                    left = pos[0];
                    top = pos[1] - dist;
                    var tLeft = tooltipLeft(container);
                    var tTop = tooltipTop(container);
                    break;
            }
            container.style.left = left + 'px';
            container.style.top = top + 'px';
            container.style.opacity = 1;
            container.style.position = 'absolute';
            return container;
        };
        //Global utility function to remove tooltips from the DOM.
        nv.tooltip.cleanup = function() {
            // Find the tooltips, mark them for removal by this class (so others cleanups won't find it)
            var tooltips = document.getElementsByClassName('nvtooltip');
            var purging = [];
            while(tooltips.length){
                purging.push(tooltips[0]);
                tooltips[0].style.transitionDelay = '0 !important';
                tooltips[0].style.opacity = 0;
                tooltips[0].className = 'nvtooltip-pending-removal';
            }
            setTimeout(function() {
                while(purging.length){
                    var removeMe = purging.pop();
                    removeMe.parentNode.removeChild(removeMe);
                }
            }, 500);
        };
    })();
    nv.utils.windowSize = function() {
        // Sane defaults
        var size = {
            width: 640,
            height: 480
        };
        // Earlier IE uses Doc.body
        if (document.body && document.body.offsetWidth) {
            size.width = document.body.offsetWidth;
            size.height = document.body.offsetHeight;
        }
        // IE can use depending on mode it is in
        if (document.compatMode == 'CSS1Compat' && document.documentElement && document.documentElement.offsetWidth) {
            size.width = document.documentElement.offsetWidth;
            size.height = document.documentElement.offsetHeight;
        }
        // Most recent browsers use
        if (window.innerWidth && window.innerHeight) {
            size.width = window.innerWidth;
            size.height = window.innerHeight;
        }
        return size;
    };
    // Easy way to bind multiple functions to window.onresize
    // TODO: give a way to remove a function after its bound, other than removing all of them
    nv.utils.windowResize = function(fun) {
        if (fun === undefined) return;
        var oldresize = window.onresize;
        window.onresize = function(e) {
            if (typeof oldresize == 'function') oldresize(e);
            fun(e);
        };
    };
    // Backwards compatible way to implement more d3-like coloring of graphs.
    // If passed an array, wrap it in a function which implements the old default
    // behavior
    nv.utils.getColor = function(color) {
        if (!arguments.length) return nv.utils.defaultColor(); //if you pass in nothing, get default colors back
        if (Object.prototype.toString.call(color) === '[object Array]') return function(d, i) {
            return d.color || color[i % color.length];
        };
        else return color;
    //can't really help it if someone passes rubbish as color
    };
    // Default color chooser uses the index of an object as before.
    nv.utils.defaultColor = function() {
        var colors = $9175b321012dc0d3$var$d3.scale.category20().range();
        return function(d, i) {
            return d.color || colors[i % colors.length];
        };
    };
    // Returns a color function that takes the result of 'getKey' for each series and
    // looks for a corresponding color from the dictionary,
    nv.utils.customTheme = function(dictionary, getKey, defaultColors) {
        getKey = getKey || function(series) {
            return series.key;
        }; // use default series.key if getKey is undefined
        defaultColors = defaultColors || $9175b321012dc0d3$var$d3.scale.category20().range(); //default color function
        var defIndex = defaultColors.length; //current default color (going in reverse)
        return function(series, index) {
            var key = getKey(series);
            if (!defIndex) defIndex = defaultColors.length; //used all the default colors, start over
            if (typeof dictionary[key] !== "undefined") return typeof dictionary[key] === "function" ? dictionary[key]() : dictionary[key];
            else return defaultColors[--defIndex]; // no match in dictionary, use default color
        };
    };
    // From the PJAX example on d3js.org, while this is not really directly needed
    // it's a very cool method for doing pjax, I may expand upon it a little bit,
    // open to suggestions on anything that may be useful
    nv.utils.pjax = function(links, content) {
        $9175b321012dc0d3$var$d3.selectAll(links).on("click", function() {
            history.pushState(this.href, this.textContent, this.href);
            load(this.href);
            $9175b321012dc0d3$var$d3.event.preventDefault();
        });
        function load(href) {
            $9175b321012dc0d3$var$d3.html(href, function(fragment) {
                var target = $9175b321012dc0d3$var$d3.select(content).node();
                target.parentNode.replaceChild($9175b321012dc0d3$var$d3.select(fragment).select(content).node(), target);
                nv.utils.pjax(links, content);
            });
        }
        $9175b321012dc0d3$var$d3.select(window).on("popstate", function() {
            if ($9175b321012dc0d3$var$d3.event.state) load($9175b321012dc0d3$var$d3.event.state);
        });
    };
    /* For situations where we want to approximate the width in pixels for an SVG:text element.
Most common instance is when the element is in a display:none; container.
Forumla is : text.length * font-size * constant_factor
*/ nv.utils.calcApproxTextWidth = function(svgTextElem) {
        if (svgTextElem instanceof $9175b321012dc0d3$var$d3.selection) {
            var fontSize = parseInt(svgTextElem.style("font-size").replace("px", ""));
            var textLength = svgTextElem.text().length;
            return textLength * fontSize * 0.5;
        }
        return 0;
    };
    /* Numbers that are undefined, null or NaN, convert them to zeros.
*/ nv.utils.NaNtoZero = function(n) {
        if (typeof n !== 'number' || isNaN(n) || n === null || n === Infinity) return 0;
        return n;
    };
    /*
Snippet of code you can insert into each nv.models.* to give you the ability to
do things like:
chart.options({
  showXAxis: true,
  tooltips: true
});

To enable in the chart:
chart.options = nv.utils.optionsFunc.bind(chart);
*/ nv.utils.optionsFunc = function(args) {
        if (args) $9175b321012dc0d3$var$d3.map(args).forEach((function(key, value) {
            if (typeof this[key] === "function") this[key](value);
        }).bind(this));
        return this;
    };
    nv.models.axis = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var axis = $9175b321012dc0d3$var$d3.svg.axis();
        var margin = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }, width = 75 //only used for tickLabel currently
        , height = 60 //only used for tickLabel currently
        , scale = $9175b321012dc0d3$var$d3.scale.linear(), axisLabelText = null, showMaxMin = true //TODO: showMaxMin should be disabled on all ordinal scaled axes
        , highlightZero = true, rotateLabels = 0, rotateYLabel = true, staggerLabels = false, isOrdinal = false, ticks = null, axisLabelDistance = 12 //The larger this number is, the closer the axis label is to the axis.
        ;
        axis.scale(scale).orient('bottom').tickFormat(function(d) {
            return d;
        });
        //============================================================
        //============================================================
        // Private Variables
        //------------------------------------------------------------
        var scale0;
        //============================================================
        function chart(selection) {
            selection.each(function(data) {
                var container = $9175b321012dc0d3$var$d3.select(this);
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = container.selectAll('g.nv-wrap.nv-axis').data([
                    data
                ]);
                var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-axis');
                var gEnter = wrapEnter.append('g');
                var g = wrap.select('g');
                //------------------------------------------------------------
                if (ticks !== null) axis.ticks(ticks);
                else if (axis.orient() == 'top' || axis.orient() == 'bottom') axis.ticks(Math.abs(scale.range()[1] - scale.range()[0]) / 100);
                //TODO: consider calculating width/height based on whether or not label is added, for reference in charts using this component
                g.transition().call(axis);
                scale0 = scale0 || axis.scale();
                var fmt = axis.tickFormat();
                if (fmt == null) fmt = scale0.tickFormat();
                var axisLabel = g.selectAll('text.nv-axislabel').data([
                    axisLabelText || null
                ]);
                axisLabel.exit().remove();
                switch(axis.orient()){
                    case 'top':
                        axisLabel.enter().append('text').attr('class', 'nv-axislabel');
                        var w = scale.range().length == 2 ? scale.range()[1] : scale.range()[scale.range().length - 1] + (scale.range()[1] - scale.range()[0]);
                        axisLabel.attr('text-anchor', 'middle').attr('y', 0).attr('x', w / 2);
                        if (showMaxMin) {
                            var axisMaxMin = wrap.selectAll('g.nv-axisMaxMin').data(scale.domain());
                            axisMaxMin.enter().append('g').attr('class', 'nv-axisMaxMin').append('text');
                            axisMaxMin.exit().remove();
                            axisMaxMin.attr('transform', function(d, i) {
                                return 'translate(' + scale(d) + ',0)';
                            }).select('text').attr('dy', '0em').attr('y', -axis.tickPadding()).attr('text-anchor', 'middle').text(function(d, i) {
                                var v = fmt(d);
                                return ('' + v).match('NaN') ? '' : v;
                            });
                            axisMaxMin.transition().attr('transform', function(d, i) {
                                return 'translate(' + scale.range()[i] + ',0)';
                            });
                        }
                        break;
                    case 'bottom':
                        var xLabelMargin = 36;
                        var maxTextWidth = 30;
                        var xTicks = g.selectAll('g').select("text");
                        if (rotateLabels % 360) {
                            //Calculate the longest xTick width
                            xTicks.each(function(d, i) {
                                var width = this.getBBox().width;
                                if (width > maxTextWidth) maxTextWidth = width;
                            });
                            //Convert to radians before calculating sin. Add 30 to margin for healthy padding.
                            var sin = Math.abs(Math.sin(rotateLabels * Math.PI / 180));
                            var xLabelMargin = (sin ? sin * maxTextWidth : maxTextWidth) + 30;
                            //Rotate all xTicks
                            xTicks.attr('transform', function(d, i, j) {
                                return 'rotate(' + rotateLabels + ' 0,0)';
                            }).style('text-anchor', rotateLabels % 360 > 0 ? 'start' : 'end');
                        }
                        axisLabel.enter().append('text').attr('class', 'nv-axislabel');
                        var w = scale.range().length == 2 ? scale.range()[1] : scale.range()[scale.range().length - 1] + (scale.range()[1] - scale.range()[0]);
                        axisLabel.attr('text-anchor', 'middle').attr('y', xLabelMargin).attr('x', w / 2);
                        if (showMaxMin) {
                            //if (showMaxMin && !isOrdinal) {
                            var axisMaxMin = wrap.selectAll('g.nv-axisMaxMin')//.data(scale.domain())
                            .data([
                                scale.domain()[0],
                                scale.domain()[scale.domain().length - 1]
                            ]);
                            axisMaxMin.enter().append('g').attr('class', 'nv-axisMaxMin').append('text');
                            axisMaxMin.exit().remove();
                            axisMaxMin.attr('transform', function(d, i) {
                                return 'translate(' + (scale(d) + (isOrdinal ? scale.rangeBand() / 2 : 0)) + ',0)';
                            }).select('text').attr('dy', '.71em').attr('y', axis.tickPadding()).attr('transform', function(d, i, j) {
                                return 'rotate(' + rotateLabels + ' 0,0)';
                            }).style('text-anchor', rotateLabels ? rotateLabels % 360 > 0 ? 'start' : 'end' : 'middle').text(function(d, i) {
                                var v = fmt(d);
                                return ('' + v).match('NaN') ? '' : v;
                            });
                            axisMaxMin.transition().attr('transform', function(d, i) {
                                //return 'translate(' + scale.range()[i] + ',0)'
                                //return 'translate(' + scale(d) + ',0)'
                                return 'translate(' + (scale(d) + (isOrdinal ? scale.rangeBand() / 2 : 0)) + ',0)';
                            });
                        }
                        if (staggerLabels) xTicks.attr('transform', function(d, i) {
                            return 'translate(0,' + (i % 2 == 0 ? '0' : '12') + ')';
                        });
                        break;
                    case 'right':
                        axisLabel.enter().append('text').attr('class', 'nv-axislabel');
                        axisLabel.style('text-anchor', rotateYLabel ? 'middle' : 'begin').attr('transform', rotateYLabel ? 'rotate(90)' : '').attr('y', rotateYLabel ? -Math.max(margin.right, width) + 12 : -10) //TODO: consider calculating this based on largest tick width... OR at least expose this on chart
                        .attr('x', rotateYLabel ? scale.range()[0] / 2 : axis.tickPadding());
                        if (showMaxMin) {
                            var axisMaxMin = wrap.selectAll('g.nv-axisMaxMin').data(scale.domain());
                            axisMaxMin.enter().append('g').attr('class', 'nv-axisMaxMin').append('text').style('opacity', 0);
                            axisMaxMin.exit().remove();
                            axisMaxMin.attr('transform', function(d, i) {
                                return 'translate(0,' + scale(d) + ')';
                            }).select('text').attr('dy', '.32em').attr('y', 0).attr('x', axis.tickPadding()).style('text-anchor', 'start').text(function(d, i) {
                                var v = fmt(d);
                                return ('' + v).match('NaN') ? '' : v;
                            });
                            axisMaxMin.transition().attr('transform', function(d, i) {
                                return 'translate(0,' + scale.range()[i] + ')';
                            }).select('text').style('opacity', 1);
                        }
                        break;
                    case 'left':
                        /*
          //For dynamically placing the label. Can be used with dynamically-sized chart axis margins
          var yTicks = g.selectAll('g').select("text");
          yTicks.each(function(d,i){
            var labelPadding = this.getBBox().width + axis.tickPadding() + 16;
            if(labelPadding > width) width = labelPadding;
          });
          */ axisLabel.enter().append('text').attr('class', 'nv-axislabel');
                        axisLabel.style('text-anchor', rotateYLabel ? 'middle' : 'end').attr('transform', rotateYLabel ? 'rotate(-90)' : '').attr('y', rotateYLabel ? -Math.max(margin.left, width) + axisLabelDistance : -10) //TODO: consider calculating this based on largest tick width... OR at least expose this on chart
                        .attr('x', rotateYLabel ? -scale.range()[0] / 2 : -axis.tickPadding());
                        if (showMaxMin) {
                            var axisMaxMin = wrap.selectAll('g.nv-axisMaxMin').data(scale.domain());
                            axisMaxMin.enter().append('g').attr('class', 'nv-axisMaxMin').append('text').style('opacity', 0);
                            axisMaxMin.exit().remove();
                            axisMaxMin.attr('transform', function(d, i) {
                                return 'translate(0,' + scale0(d) + ')';
                            }).select('text').attr('dy', '.32em').attr('y', 0).attr('x', -axis.tickPadding()).attr('text-anchor', 'end').text(function(d, i) {
                                var v = fmt(d);
                                return ('' + v).match('NaN') ? '' : v;
                            });
                            axisMaxMin.transition().attr('transform', function(d, i) {
                                return 'translate(0,' + scale.range()[i] + ')';
                            }).select('text').style('opacity', 1);
                        }
                        break;
                }
                axisLabel.text(function(d) {
                    return d;
                });
                if (showMaxMin && (axis.orient() === 'left' || axis.orient() === 'right')) {
                    //check if max and min overlap other values, if so, hide the values that overlap
                    g.selectAll('g') // the g's wrapping each tick
                    .each(function(d, i) {
                        $9175b321012dc0d3$var$d3.select(this).select('text').attr('opacity', 1);
                        if (scale(d) < scale.range()[1] + 10 || scale(d) > scale.range()[0] - 10) {
                            if (d > 1e-10 || d < -0.0000000001) $9175b321012dc0d3$var$d3.select(this).attr('opacity', 0);
                            $9175b321012dc0d3$var$d3.select(this).select('text').attr('opacity', 0); // Don't remove the ZERO line!!
                        }
                    });
                    //if Max and Min = 0 only show min, Issue #281
                    if (scale.domain()[0] == scale.domain()[1] && scale.domain()[0] == 0) wrap.selectAll('g.nv-axisMaxMin').style('opacity', function(d, i) {
                        return !i ? 1 : 0;
                    });
                }
                if (showMaxMin && (axis.orient() === 'top' || axis.orient() === 'bottom')) {
                    var maxMinRange = [];
                    wrap.selectAll('g.nv-axisMaxMin').each(function(d, i) {
                        try {
                            if (i) maxMinRange.push(scale(d) - this.getBBox().width - 4) //assuming the max and min labels are as wide as the next tick (with an extra 4 pixels just in case)
                            ;
                            else maxMinRange.push(scale(d) + this.getBBox().width + 4);
                        } catch (err) {
                            if (i) maxMinRange.push(scale(d) - 4) //assuming the max and min labels are as wide as the next tick (with an extra 4 pixels just in case)
                            ;
                            else maxMinRange.push(scale(d) + 4);
                        }
                    });
                    g.selectAll('g') // the g's wrapping each tick
                    .each(function(d, i) {
                        if (scale(d) < maxMinRange[0] || scale(d) > maxMinRange[1]) {
                            if (d > 1e-10 || d < -0.0000000001) $9175b321012dc0d3$var$d3.select(this).remove();
                            else $9175b321012dc0d3$var$d3.select(this).select('text').remove(); // Don't remove the ZERO line!!
                        }
                    });
                }
                //highlight zero line ... Maybe should not be an option and should just be in CSS?
                if (highlightZero) g.selectAll('.tick').filter(function(d) {
                    return !parseFloat(Math.round(d.__data__ * 100000) / 1000000) && d.__data__ !== undefined;
                }) //this is because sometimes the 0 tick is a very small fraction, TODO: think of cleaner technique
                .classed('zero', true);
                //store old scales for use in transitions on update
                scale0 = scale.copy();
            });
            return chart;
        }
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        // expose chart's sub-components
        chart.axis = axis;
        $9175b321012dc0d3$var$d3.rebind(chart, axis, 'orient', 'tickValues', 'tickSubdivide', 'tickSize', 'tickPadding', 'tickFormat');
        $9175b321012dc0d3$var$d3.rebind(chart, scale, 'domain', 'range', 'rangeBand', 'rangeBands'); //these are also accessible by chart.scale(), but added common ones directly for ease of use
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.ticks = function(_) {
            if (!arguments.length) return ticks;
            ticks = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.axisLabel = function(_) {
            if (!arguments.length) return axisLabelText;
            axisLabelText = _;
            return chart;
        };
        chart.showMaxMin = function(_) {
            if (!arguments.length) return showMaxMin;
            showMaxMin = _;
            return chart;
        };
        chart.highlightZero = function(_) {
            if (!arguments.length) return highlightZero;
            highlightZero = _;
            return chart;
        };
        chart.scale = function(_) {
            if (!arguments.length) return scale;
            scale = _;
            axis.scale(scale);
            isOrdinal = typeof scale.rangeBands === 'function';
            $9175b321012dc0d3$var$d3.rebind(chart, scale, 'domain', 'range', 'rangeBand', 'rangeBands');
            return chart;
        };
        chart.rotateYLabel = function(_) {
            if (!arguments.length) return rotateYLabel;
            rotateYLabel = _;
            return chart;
        };
        chart.rotateLabels = function(_) {
            if (!arguments.length) return rotateLabels;
            rotateLabels = _;
            return chart;
        };
        chart.staggerLabels = function(_) {
            if (!arguments.length) return staggerLabels;
            staggerLabels = _;
            return chart;
        };
        chart.axisLabelDistance = function(_) {
            if (!arguments.length) return axisLabelDistance;
            axisLabelDistance = _;
            return chart;
        };
        //============================================================
        return chart;
    };
    // Chart design based on the recommendations of Stephen Few. Implementation
    // based on the work of Clint Ivy, Jamie Love, and Jason Davies.
    // http://projects.instantcognition.com/protovis/bulletchart/
    nv.models.bullet = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var margin = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }, orient = 'left' // TODO top & bottom
        , reverse = false, ranges = function(d) {
            return d.ranges;
        }, markers = function(d) {
            return d.markers;
        }, measures = function(d) {
            return d.measures;
        }, rangeLabels = function(d) {
            return d.rangeLabels ? d.rangeLabels : [];
        }, markerLabels = function(d) {
            return d.markerLabels ? d.markerLabels : [];
        }, measureLabels = function(d) {
            return d.measureLabels ? d.measureLabels : [];
        }, forceX = [
            0
        ] // List of numbers to Force into the X scale (ie. 0, or a max / min, etc.)
        , width = 380, height = 30, tickFormat = null, color = nv.utils.getColor([
            '#1f77b4'
        ]), dispatch = $9175b321012dc0d3$var$d3.dispatch('elementMouseover', 'elementMouseout');
        //============================================================
        function chart(selection) {
            selection.each(function(d, i) {
                var availableWidth = width - margin.left - margin.right, availableHeight = height - margin.top - margin.bottom, container = $9175b321012dc0d3$var$d3.select(this);
                var rangez = ranges.call(this, d, i).slice().sort($9175b321012dc0d3$var$d3.descending), markerz = markers.call(this, d, i).slice().sort($9175b321012dc0d3$var$d3.descending), measurez = measures.call(this, d, i).slice().sort($9175b321012dc0d3$var$d3.descending), rangeLabelz = rangeLabels.call(this, d, i).slice(), markerLabelz = markerLabels.call(this, d, i).slice(), measureLabelz = measureLabels.call(this, d, i).slice();
                //------------------------------------------------------------
                // Setup Scales
                // Compute the new x-scale.
                var x1 = $9175b321012dc0d3$var$d3.scale.linear().domain($9175b321012dc0d3$var$d3.extent($9175b321012dc0d3$var$d3.merge([
                    forceX,
                    rangez
                ]))).range(reverse ? [
                    availableWidth,
                    0
                ] : [
                    0,
                    availableWidth
                ]);
                // Retrieve the old x-scale, if this is an update.
                var x0 = this.__chart__ || $9175b321012dc0d3$var$d3.scale.linear().domain([
                    0,
                    Infinity
                ]).range(x1.range());
                // Stash the new scale.
                this.__chart__ = x1;
                var rangeMin = $9175b321012dc0d3$var$d3.min(rangez), rangeMax = $9175b321012dc0d3$var$d3.max(rangez), rangeAvg = rangez[1];
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = container.selectAll('g.nv-wrap.nv-bullet').data([
                    d
                ]);
                var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-bullet');
                var gEnter = wrapEnter.append('g');
                var g = wrap.select('g');
                gEnter.append('rect').attr('class', 'nv-range nv-rangeMax');
                gEnter.append('rect').attr('class', 'nv-range nv-rangeAvg');
                gEnter.append('rect').attr('class', 'nv-range nv-rangeMin');
                gEnter.append('rect').attr('class', 'nv-measure');
                gEnter.append('path').attr('class', 'nv-markerTriangle');
                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                //------------------------------------------------------------
                var w0 = function(d) {
                    return Math.abs(x0(d) - x0(0));
                }, w1 = function(d) {
                    return Math.abs(x1(d) - x1(0));
                };
                var xp0 = function(d) {
                    return d < 0 ? x0(d) : x0(0);
                }, xp1 = function(d) {
                    return d < 0 ? x1(d) : x1(0);
                };
                g.select('rect.nv-rangeMax').attr('height', availableHeight).attr('width', w1(rangeMax > 0 ? rangeMax : rangeMin)).attr('x', xp1(rangeMax > 0 ? rangeMax : rangeMin)).datum(rangeMax > 0 ? rangeMax : rangeMin);
                /*
          .attr('x', rangeMin < 0 ?
                         rangeMax > 0 ?
                             x1(rangeMin)
                           : x1(rangeMax)
                       : x1(0))
                      */ g.select('rect.nv-rangeAvg').attr('height', availableHeight).attr('width', w1(rangeAvg)).attr('x', xp1(rangeAvg)).datum(rangeAvg);
                /*
          .attr('width', rangeMax <= 0 ?
                             x1(rangeMax) - x1(rangeAvg)
                           : x1(rangeAvg) - x1(rangeMin))
          .attr('x', rangeMax <= 0 ?
                         x1(rangeAvg)
                       : x1(rangeMin))
                      */ g.select('rect.nv-rangeMin').attr('height', availableHeight).attr('width', w1(rangeMax)).attr('x', xp1(rangeMax)).attr('width', w1(rangeMax > 0 ? rangeMin : rangeMax)).attr('x', xp1(rangeMax > 0 ? rangeMin : rangeMax)).datum(rangeMax > 0 ? rangeMin : rangeMax);
                /*
          .attr('width', rangeMax <= 0 ?
                             x1(rangeAvg) - x1(rangeMin)
                           : x1(rangeMax) - x1(rangeAvg))
          .attr('x', rangeMax <= 0 ?
                         x1(rangeMin)
                       : x1(rangeAvg))
                      */ g.select('rect.nv-measure').style('fill', color).attr('height', availableHeight / 3).attr('y', availableHeight / 3).attr('width', measurez < 0 ? x1(0) - x1(measurez[0]) : x1(measurez[0]) - x1(0)).attr('x', xp1(measurez)).on('mouseover', function() {
                    dispatch.elementMouseover({
                        value: measurez[0],
                        label: measureLabelz[0] || 'Current',
                        pos: [
                            x1(measurez[0]),
                            availableHeight / 2
                        ]
                    });
                }).on('mouseout', function() {
                    dispatch.elementMouseout({
                        value: measurez[0],
                        label: measureLabelz[0] || 'Current'
                    });
                });
                var h3 = availableHeight / 6;
                if (markerz[0]) g.selectAll('path.nv-markerTriangle').attr('transform', function(d) {
                    return 'translate(' + x1(markerz[0]) + ',' + availableHeight / 2 + ')';
                }).attr('d', 'M0,' + h3 + 'L' + h3 + ',' + -h3 + ' ' + -h3 + ',' + -h3 + 'Z').on('mouseover', function() {
                    dispatch.elementMouseover({
                        value: markerz[0],
                        label: markerLabelz[0] || 'Previous',
                        pos: [
                            x1(markerz[0]),
                            availableHeight / 2
                        ]
                    });
                }).on('mouseout', function() {
                    dispatch.elementMouseout({
                        value: markerz[0],
                        label: markerLabelz[0] || 'Previous'
                    });
                });
                else g.selectAll('path.nv-markerTriangle').remove();
                wrap.selectAll('.nv-range').on('mouseover', function(d, i) {
                    var label = rangeLabelz[i] || (!i ? "Maximum" : i == 1 ? "Mean" : "Minimum");
                    dispatch.elementMouseover({
                        value: d,
                        label: label,
                        pos: [
                            x1(d),
                            availableHeight / 2
                        ]
                    });
                }).on('mouseout', function(d, i) {
                    var label = rangeLabelz[i] || (!i ? "Maximum" : i == 1 ? "Mean" : "Minimum");
                    dispatch.elementMouseout({
                        value: d,
                        label: label
                    });
                });
            /* // THIS IS THE PREVIOUS BULLET IMPLEMENTATION, WILL REMOVE SHORTLY
      // Update the range rects.
      var range = g.selectAll('rect.nv-range')
          .data(rangez);

      range.enter().append('rect')
          .attr('class', function(d, i) { return 'nv-range nv-s' + i; })
          .attr('width', w0)
          .attr('height', availableHeight)
          .attr('x', reverse ? x0 : 0)
          .on('mouseover', function(d,i) {
              dispatch.elementMouseover({
                value: d,
                label: (i <= 0) ? 'Maximum' : (i > 1) ? 'Minimum' : 'Mean', //TODO: make these labels a variable
                pos: [x1(d), availableHeight/2]
              })
          })
          .on('mouseout', function(d,i) {
              dispatch.elementMouseout({
                value: d,
                label: (i <= 0) ? 'Minimum' : (i >=1) ? 'Maximum' : 'Mean' //TODO: make these labels a variable
              })
          })

      d3.transition(range)
          .attr('x', reverse ? x1 : 0)
          .attr('width', w1)
          .attr('height', availableHeight);


      // Update the measure rects.
      var measure = g.selectAll('rect.nv-measure')
          .data(measurez);

      measure.enter().append('rect')
          .attr('class', function(d, i) { return 'nv-measure nv-s' + i; })
          .style('fill', function(d,i) { return color(d,i ) })
          .attr('width', w0)
          .attr('height', availableHeight / 3)
          .attr('x', reverse ? x0 : 0)
          .attr('y', availableHeight / 3)
          .on('mouseover', function(d) {
              dispatch.elementMouseover({
                value: d,
                label: 'Current', //TODO: make these labels a variable
                pos: [x1(d), availableHeight/2]
              })
          })
          .on('mouseout', function(d) {
              dispatch.elementMouseout({
                value: d,
                label: 'Current' //TODO: make these labels a variable
              })
          })

      d3.transition(measure)
          .attr('width', w1)
          .attr('height', availableHeight / 3)
          .attr('x', reverse ? x1 : 0)
          .attr('y', availableHeight / 3);



      // Update the marker lines.
      var marker = g.selectAll('path.nv-markerTriangle')
          .data(markerz);

      var h3 =  availableHeight / 6;
      marker.enter().append('path')
          .attr('class', 'nv-markerTriangle')
          .attr('transform', function(d) { return 'translate(' + x0(d) + ',' + (availableHeight / 2) + ')' })
          .attr('d', 'M0,' + h3 + 'L' + h3 + ',' + (-h3) + ' ' + (-h3) + ',' + (-h3) + 'Z')
          .on('mouseover', function(d,i) {
              dispatch.elementMouseover({
                value: d,
                label: 'Previous',
                pos: [x1(d), availableHeight/2]
              })
          })
          .on('mouseout', function(d,i) {
              dispatch.elementMouseout({
                value: d,
                label: 'Previous'
              })
          });

      d3.transition(marker)
          .attr('transform', function(d) { return 'translate(' + (x1(d) - x1(0)) + ',' + (availableHeight / 2) + ')' });

      marker.exit().remove();
*/ });
            // d3.timer.flush();  // Not needed?
            return chart;
        }
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        chart.dispatch = dispatch;
        chart.options = nv.utils.optionsFunc.bind(chart);
        // left, right, top, bottom
        chart.orient = function(_) {
            if (!arguments.length) return orient;
            orient = _;
            reverse = orient == 'right' || orient == 'bottom';
            return chart;
        };
        // ranges (bad, satisfactory, good)
        chart.ranges = function(_) {
            if (!arguments.length) return ranges;
            ranges = _;
            return chart;
        };
        // markers (previous, goal)
        chart.markers = function(_) {
            if (!arguments.length) return markers;
            markers = _;
            return chart;
        };
        // measures (actual, forecast)
        chart.measures = function(_) {
            if (!arguments.length) return measures;
            measures = _;
            return chart;
        };
        chart.forceX = function(_) {
            if (!arguments.length) return forceX;
            forceX = _;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.tickFormat = function(_) {
            if (!arguments.length) return tickFormat;
            tickFormat = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = nv.utils.getColor(_);
            return chart;
        };
        //============================================================
        return chart;
    };
    // Chart design based on the recommendations of Stephen Few. Implementation
    // based on the work of Clint Ivy, Jamie Love, and Jason Davies.
    // http://projects.instantcognition.com/protovis/bulletchart/
    nv.models.bulletChart = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var bullet = nv.models.bullet();
        var orient = 'left' // TODO top & bottom
        , reverse = false, margin = {
            top: 5,
            right: 40,
            bottom: 20,
            left: 120
        }, ranges = function(d) {
            return d.ranges;
        }, markers = function(d) {
            return d.markers;
        }, measures = function(d) {
            return d.measures;
        }, width = null, height = 55, tickFormat = null, tooltips = true, tooltip = function(key, x, y, e, graph) {
            return '<h3>' + x + '</h3>' + '<p>' + y + '</p>';
        }, noData = 'No Data Available.', dispatch = $9175b321012dc0d3$var$d3.dispatch('tooltipShow', 'tooltipHide');
        //============================================================
        //============================================================
        // Private Variables
        //------------------------------------------------------------
        var showTooltip = function(e, offsetElement) {
            var left = e.pos[0] + (offsetElement.offsetLeft || 0) + margin.left, top = e.pos[1] + (offsetElement.offsetTop || 0) + margin.top, content = tooltip(e.key, e.label, e.value, e, chart);
            nv.tooltip.show([
                left,
                top
            ], content, e.value < 0 ? 'e' : 'w', null, offsetElement);
        };
        //============================================================
        function chart(selection) {
            selection.each(function(d, i) {
                var container = $9175b321012dc0d3$var$d3.select(this);
                var availableWidth = (width || parseInt(container.style('width')) || 960) - margin.left - margin.right, availableHeight = height - margin.top - margin.bottom, that = this;
                chart.update = function() {
                    chart(selection);
                };
                chart.container = this;
                //------------------------------------------------------------
                // Display No Data message if there's nothing to show.
                if (!d || !ranges.call(this, d, i)) {
                    var noDataText = container.selectAll('.nv-noData').data([
                        noData
                    ]);
                    noDataText.enter().append('text').attr('class', 'nvd3 nv-noData').attr('dy', '-.7em').style('text-anchor', 'middle');
                    noDataText.attr('x', margin.left + availableWidth / 2).attr('y', 18 + margin.top + availableHeight / 2).text(function(d) {
                        return d;
                    });
                    return chart;
                } else container.selectAll('.nv-noData').remove();
                //------------------------------------------------------------
                var rangez = ranges.call(this, d, i).slice().sort($9175b321012dc0d3$var$d3.descending), markerz = markers.call(this, d, i).slice().sort($9175b321012dc0d3$var$d3.descending), measurez = measures.call(this, d, i).slice().sort($9175b321012dc0d3$var$d3.descending);
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = container.selectAll('g.nv-wrap.nv-bulletChart').data([
                    d
                ]);
                var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-bulletChart');
                var gEnter = wrapEnter.append('g');
                var g = wrap.select('g');
                gEnter.append('g').attr('class', 'nv-bulletWrap');
                gEnter.append('g').attr('class', 'nv-titles');
                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                //------------------------------------------------------------
                // Compute the new x-scale.
                var x1 = $9175b321012dc0d3$var$d3.scale.linear().domain([
                    0,
                    Math.max(rangez[0], markerz[0], measurez[0])
                ]) // TODO: need to allow forceX and forceY, and xDomain, yDomain
                .range(reverse ? [
                    availableWidth,
                    0
                ] : [
                    0,
                    availableWidth
                ]);
                // Retrieve the old x-scale, if this is an update.
                var x0 = this.__chart__ || $9175b321012dc0d3$var$d3.scale.linear().domain([
                    0,
                    Infinity
                ]).range(x1.range());
                // Stash the new scale.
                this.__chart__ = x1;
                /*
      // Derive width-scales from the x-scales.
      var w0 = bulletWidth(x0),
          w1 = bulletWidth(x1);

      function bulletWidth(x) {
        var x0 = x(0);
        return function(d) {
          return Math.abs(x(d) - x(0));
        };
      }

      function bulletTranslate(x) {
        return function(d) {
          return 'translate(' + x(d) + ',0)';
        };
      }
      */ var w0 = function(d) {
                    return Math.abs(x0(d) - x0(0));
                }, w1 = function(d) {
                    return Math.abs(x1(d) - x1(0));
                };
                var title = gEnter.select('.nv-titles').append('g').attr('text-anchor', 'end').attr('transform', 'translate(-6,' + (height - margin.top - margin.bottom) / 2 + ')');
                title.append('text').attr('class', 'nv-title').text(function(d) {
                    return d.title;
                });
                title.append('text').attr('class', 'nv-subtitle').attr('dy', '1em').text(function(d) {
                    return d.subtitle;
                });
                bullet.width(availableWidth).height(availableHeight);
                var bulletWrap = g.select('.nv-bulletWrap');
                $9175b321012dc0d3$var$d3.transition(bulletWrap).call(bullet);
                // Compute the tick format.
                var format = tickFormat || x1.tickFormat(availableWidth / 100);
                // Update the tick groups.
                var tick = g.selectAll('g.nv-tick').data(x1.ticks(availableWidth / 50), function(d) {
                    return this.textContent || format(d);
                });
                // Initialize the ticks with the old scale, x0.
                var tickEnter = tick.enter().append('g').attr('class', 'nv-tick').attr('transform', function(d) {
                    return 'translate(' + x0(d) + ',0)';
                }).style('opacity', 1e-6);
                tickEnter.append('line').attr('y1', availableHeight).attr('y2', availableHeight * 7 / 6);
                tickEnter.append('text').attr('text-anchor', 'middle').attr('dy', '1em').attr('y', availableHeight * 7 / 6).text(format);
                // Transition the updating ticks to the new scale, x1.
                var tickUpdate = $9175b321012dc0d3$var$d3.transition(tick).attr('transform', function(d) {
                    return 'translate(' + x1(d) + ',0)';
                }).style('opacity', 1);
                tickUpdate.select('line').attr('y1', availableHeight).attr('y2', availableHeight * 7 / 6);
                tickUpdate.select('text').attr('y', availableHeight * 7 / 6);
                // Transition the exiting ticks to the new scale, x1.
                $9175b321012dc0d3$var$d3.transition(tick.exit()).attr('transform', function(d) {
                    return 'translate(' + x1(d) + ',0)';
                }).style('opacity', 1e-6).remove();
                //============================================================
                // Event Handling/Dispatching (in chart's scope)
                //------------------------------------------------------------
                dispatch.on('tooltipShow', function(e) {
                    e.key = d.title;
                    if (tooltips) showTooltip(e, that.parentNode);
                });
            //============================================================
            });
            $9175b321012dc0d3$var$d3.timer.flush();
            return chart;
        }
        //============================================================
        // Event Handling/Dispatching (out of chart's scope)
        //------------------------------------------------------------
        bullet.dispatch.on('elementMouseover.tooltip', function(e) {
            dispatch.tooltipShow(e);
        });
        bullet.dispatch.on('elementMouseout.tooltip', function(e) {
            dispatch.tooltipHide(e);
        });
        dispatch.on('tooltipHide', function() {
            if (tooltips) nv.tooltip.cleanup();
        });
        //============================================================
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        chart.dispatch = dispatch;
        chart.bullet = bullet;
        $9175b321012dc0d3$var$d3.rebind(chart, bullet, 'color');
        chart.options = nv.utils.optionsFunc.bind(chart);
        // left, right, top, bottom
        chart.orient = function(x) {
            if (!arguments.length) return orient;
            orient = x;
            reverse = orient == 'right' || orient == 'bottom';
            return chart;
        };
        // ranges (bad, satisfactory, good)
        chart.ranges = function(x) {
            if (!arguments.length) return ranges;
            ranges = x;
            return chart;
        };
        // markers (previous, goal)
        chart.markers = function(x) {
            if (!arguments.length) return markers;
            markers = x;
            return chart;
        };
        // measures (actual, forecast)
        chart.measures = function(x) {
            if (!arguments.length) return measures;
            measures = x;
            return chart;
        };
        chart.width = function(x) {
            if (!arguments.length) return width;
            width = x;
            return chart;
        };
        chart.height = function(x) {
            if (!arguments.length) return height;
            height = x;
            return chart;
        };
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.tickFormat = function(x) {
            if (!arguments.length) return tickFormat;
            tickFormat = x;
            return chart;
        };
        chart.tooltips = function(_) {
            if (!arguments.length) return tooltips;
            tooltips = _;
            return chart;
        };
        chart.tooltipContent = function(_) {
            if (!arguments.length) return tooltip;
            tooltip = _;
            return chart;
        };
        chart.noData = function(_) {
            if (!arguments.length) return noData;
            noData = _;
            return chart;
        };
        //============================================================
        return chart;
    };
    nv.models.cumulativeLineChart = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var lines = nv.models.line(), xAxis = nv.models.axis(), yAxis = nv.models.axis(), legend = nv.models.legend(), controls = nv.models.legend(), interactiveLayer = nv.interactiveGuideline();
        var margin = {
            top: 30,
            right: 30,
            bottom: 50,
            left: 60
        }, color = nv.utils.defaultColor(), width = null, height = null, showLegend = true, showXAxis = true, showYAxis = true, rightAlignYAxis = false, tooltips = true, showControls = true, useInteractiveGuideline = false, rescaleY = true, tooltip = function(key, x, y, e, graph) {
            return '<h3>' + key + '</h3>' + '<p>' + y + ' at ' + x + '</p>';
        }, x //can be accessed via chart.xScale()
        , y //can be accessed via chart.yScale()
        , id = lines.id(), state = {
            index: 0,
            rescaleY: rescaleY
        }, defaultState = null, noData = 'No Data Available.', average = function(d) {
            return d.average;
        }, dispatch = $9175b321012dc0d3$var$d3.dispatch('tooltipShow', 'tooltipHide', 'stateChange', 'changeState'), transitionDuration = 250;
        xAxis.orient('bottom').tickPadding(7);
        yAxis.orient(rightAlignYAxis ? 'right' : 'left');
        //============================================================
        controls.updateState(false);
        //============================================================
        // Private Variables
        //------------------------------------------------------------
        var dx = $9175b321012dc0d3$var$d3.scale.linear(), index = {
            i: 0,
            x: 0
        };
        var showTooltip = function(e, offsetElement) {
            var left = e.pos[0] + (offsetElement.offsetLeft || 0), top = e.pos[1] + (offsetElement.offsetTop || 0), x = xAxis.tickFormat()(lines.x()(e.point, e.pointIndex)), y = yAxis.tickFormat()(lines.y()(e.point, e.pointIndex)), content = tooltip(e.series.key, x, y, e, chart);
            nv.tooltip.show([
                left,
                top
            ], content, null, null, offsetElement);
        };
        /*
  //Moved to see if we can get better behavior to fix issue #315
  var indexDrag = d3.behavior.drag()
                    .on('dragstart', dragStart)
                    .on('drag', dragMove)
                    .on('dragend', dragEnd);

  function dragStart(d,i) {
    d3.select(chart.container)
        .style('cursor', 'ew-resize');
  }

  function dragMove(d,i) {
    d.x += d3.event.dx;
    d.i = Math.round(dx.invert(d.x));

    d3.select(this).attr('transform', 'translate(' + dx(d.i) + ',0)');
    chart.update();
  }

  function dragEnd(d,i) {
    d3.select(chart.container)
        .style('cursor', 'auto');
    chart.update();
  }
*/ //============================================================
        function chart(selection) {
            selection.each(function(data) {
                var container = $9175b321012dc0d3$var$d3.select(this).classed('nv-chart-' + id, true), that = this;
                var availableWidth = (width || parseInt(container.style('width')) || 960) - margin.left - margin.right, availableHeight = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom;
                chart.update = function() {
                    container.transition().duration(transitionDuration).call(chart);
                };
                chart.container = this;
                //set state.disabled
                state.disabled = data.map(function(d) {
                    return !!d.disabled;
                });
                if (!defaultState) {
                    var key;
                    defaultState = {};
                    for(key in state)if (state[key] instanceof Array) defaultState[key] = state[key].slice(0);
                    else defaultState[key] = state[key];
                }
                var indexDrag = $9175b321012dc0d3$var$d3.behavior.drag().on('dragstart', dragStart).on('drag', dragMove).on('dragend', dragEnd);
                function dragStart(d, i) {
                    $9175b321012dc0d3$var$d3.select(chart.container).style('cursor', 'ew-resize');
                }
                function dragMove(d, i) {
                    index.x = $9175b321012dc0d3$var$d3.event.x;
                    index.i = Math.round(dx.invert(index.x));
                    updateZero();
                }
                function dragEnd(d, i) {
                    $9175b321012dc0d3$var$d3.select(chart.container).style('cursor', 'auto');
                    // update state and send stateChange with new index
                    state.index = index.i;
                    dispatch.stateChange(state);
                }
                //------------------------------------------------------------
                // Display No Data message if there's nothing to show.
                if (!data || !data.length || !data.filter(function(d) {
                    return d.values.length;
                }).length) {
                    var noDataText = container.selectAll('.nv-noData').data([
                        noData
                    ]);
                    noDataText.enter().append('text').attr('class', 'nvd3 nv-noData').attr('dy', '-.7em').style('text-anchor', 'middle');
                    noDataText.attr('x', margin.left + availableWidth / 2).attr('y', margin.top + availableHeight / 2).text(function(d) {
                        return d;
                    });
                    return chart;
                } else container.selectAll('.nv-noData').remove();
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup Scales
                x = lines.xScale();
                y = lines.yScale();
                if (!rescaleY) {
                    var seriesDomains = data.filter(function(series) {
                        return !series.disabled;
                    }).map(function(series, i) {
                        var initialDomain = $9175b321012dc0d3$var$d3.extent(series.values, lines.y());
                        //account for series being disabled when losing 95% or more
                        if (initialDomain[0] < -0.95) initialDomain[0] = -0.95;
                        return [
                            (initialDomain[0] - initialDomain[1]) / (1 + initialDomain[1]),
                            (initialDomain[1] - initialDomain[0]) / (1 + initialDomain[0])
                        ];
                    });
                    var completeDomain = [
                        $9175b321012dc0d3$var$d3.min(seriesDomains, function(d) {
                            return d[0];
                        }),
                        $9175b321012dc0d3$var$d3.max(seriesDomains, function(d) {
                            return d[1];
                        })
                    ];
                    lines.yDomain(completeDomain);
                } else lines.yDomain(null);
                dx.domain([
                    0,
                    data[0].values.length - 1
                ]) //Assumes all series have same length
                .range([
                    0,
                    availableWidth
                ]).clamp(true);
                //------------------------------------------------------------
                var data = indexify(index.i, data);
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var interactivePointerEvents = useInteractiveGuideline ? "none" : "all";
                var wrap = container.selectAll('g.nv-wrap.nv-cumulativeLine').data([
                    data
                ]);
                var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-cumulativeLine').append('g');
                var g = wrap.select('g');
                gEnter.append('g').attr('class', 'nv-interactive');
                gEnter.append('g').attr('class', 'nv-x nv-axis').style("pointer-events", "none");
                gEnter.append('g').attr('class', 'nv-y nv-axis');
                gEnter.append('g').attr('class', 'nv-background');
                gEnter.append('g').attr('class', 'nv-linesWrap').style("pointer-events", interactivePointerEvents);
                gEnter.append('g').attr('class', 'nv-avgLinesWrap').style("pointer-events", "none");
                gEnter.append('g').attr('class', 'nv-legendWrap');
                gEnter.append('g').attr('class', 'nv-controlsWrap');
                //------------------------------------------------------------
                // Legend
                if (showLegend) {
                    legend.width(availableWidth);
                    g.select('.nv-legendWrap').datum(data).call(legend);
                    if (margin.top != legend.height()) {
                        margin.top = legend.height();
                        availableHeight = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom;
                    }
                    g.select('.nv-legendWrap').attr('transform', 'translate(0,' + -margin.top + ')');
                }
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Controls
                if (showControls) {
                    var controlsData = [
                        {
                            key: 'Re-scale y-axis',
                            disabled: !rescaleY
                        }
                    ];
                    controls.width(140).color([
                        '#444',
                        '#444',
                        '#444'
                    ]);
                    g.select('.nv-controlsWrap').datum(controlsData).attr('transform', 'translate(0,' + -margin.top + ')').call(controls);
                }
                //------------------------------------------------------------
                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                if (rightAlignYAxis) g.select(".nv-y.nv-axis").attr("transform", "translate(" + availableWidth + ",0)");
                // Show error if series goes below 100%
                var tempDisabled = data.filter(function(d) {
                    return d.tempDisabled;
                });
                wrap.select('.tempDisabled').remove(); //clean-up and prevent duplicates
                if (tempDisabled.length) wrap.append('text').attr('class', 'tempDisabled').attr('x', availableWidth / 2).attr('y', '-.71em').style('text-anchor', 'end').text(tempDisabled.map(function(d) {
                    return d.key;
                }).join(', ') + ' values cannot be calculated for this time period.');
                //------------------------------------------------------------
                // Main Chart Component(s)
                //------------------------------------------------------------
                //Set up interactive layer
                if (useInteractiveGuideline) {
                    interactiveLayer.width(availableWidth).height(availableHeight).margin({
                        left: margin.left,
                        top: margin.top
                    }).svgContainer(container).xScale(x);
                    wrap.select(".nv-interactive").call(interactiveLayer);
                }
                gEnter.select('.nv-background').append('rect');
                g.select('.nv-background rect').attr('width', availableWidth).attr('height', availableHeight);
                lines//.x(function(d) { return d.x })
                .y(function(d) {
                    return d.display.y;
                }).width(availableWidth).height(availableHeight).color(data.map(function(d, i) {
                    return d.color || color(d, i);
                }).filter(function(d, i) {
                    return !data[i].disabled && !data[i].tempDisabled;
                }));
                var linesWrap = g.select('.nv-linesWrap').datum(data.filter(function(d) {
                    return !d.disabled && !d.tempDisabled;
                }));
                //d3.transition(linesWrap).call(lines);
                linesWrap.call(lines);
                /*Handle average lines [AN-612] ----------------------------*/ //Store a series index number in the data array.
                data.forEach(function(d, i) {
                    d.seriesIndex = i;
                });
                var avgLineData = data.filter(function(d) {
                    return !d.disabled && !!average(d);
                });
                var avgLines = g.select(".nv-avgLinesWrap").selectAll("line").data(avgLineData, function(d) {
                    return d.key;
                });
                var getAvgLineY = function(d) {
                    //If average lines go off the svg element, clamp them to the svg bounds.
                    var yVal = y(average(d));
                    if (yVal < 0) return 0;
                    if (yVal > availableHeight) return availableHeight;
                    return yVal;
                };
                avgLines.enter().append('line').style('stroke-width', 2).style('stroke-dasharray', '10,10').style('stroke', function(d, i) {
                    return lines.color()(d, d.seriesIndex);
                }).attr('x1', 0).attr('x2', availableWidth).attr('y1', getAvgLineY).attr('y2', getAvgLineY);
                avgLines.style('stroke-opacity', function(d) {
                    //If average lines go offscreen, make them transparent
                    var yVal = y(average(d));
                    if (yVal < 0 || yVal > availableHeight) return 0;
                    return 1;
                }).attr('x1', 0).attr('x2', availableWidth).attr('y1', getAvgLineY).attr('y2', getAvgLineY);
                avgLines.exit().remove();
                //Create index line -----------------------------------------
                var indexLine = linesWrap.selectAll('.nv-indexLine').data([
                    index
                ]);
                indexLine.enter().append('rect').attr('class', 'nv-indexLine').attr('width', 3).attr('x', -2).attr('fill', 'red').attr('fill-opacity', .5).style("pointer-events", "all").call(indexDrag);
                indexLine.attr('transform', function(d) {
                    return 'translate(' + dx(d.i) + ',0)';
                }).attr('height', availableHeight);
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup Axes
                if (showXAxis) {
                    xAxis.scale(x)//Suggest how many ticks based on the chart width and D3 should listen (70 is the optimal number for MM/DD/YY dates)
                    .ticks(Math.min(data[0].values.length, availableWidth / 70)).tickSize(-availableHeight, 0);
                    g.select('.nv-x.nv-axis').attr('transform', 'translate(0,' + y.range()[0] + ')');
                    $9175b321012dc0d3$var$d3.transition(g.select('.nv-x.nv-axis')).call(xAxis);
                }
                if (showYAxis) {
                    yAxis.scale(y).ticks(availableHeight / 36).tickSize(-availableWidth, 0);
                    $9175b321012dc0d3$var$d3.transition(g.select('.nv-y.nv-axis')).call(yAxis);
                }
                //------------------------------------------------------------
                //============================================================
                // Event Handling/Dispatching (in chart's scope)
                //------------------------------------------------------------
                function updateZero() {
                    indexLine.data([
                        index
                    ]);
                    //When dragging the index line, turn off line transitions.
                    // Then turn them back on when done dragging.
                    var oldDuration = chart.transitionDuration();
                    chart.transitionDuration(0);
                    chart.update();
                    chart.transitionDuration(oldDuration);
                }
                g.select('.nv-background rect').on('click', function() {
                    index.x = $9175b321012dc0d3$var$d3.mouse(this)[0];
                    index.i = Math.round(dx.invert(index.x));
                    // update state and send stateChange with new index
                    state.index = index.i;
                    dispatch.stateChange(state);
                    updateZero();
                });
                lines.dispatch.on('elementClick', function(e) {
                    index.i = e.pointIndex;
                    index.x = dx(index.i);
                    // update state and send stateChange with new index
                    state.index = index.i;
                    dispatch.stateChange(state);
                    updateZero();
                });
                controls.dispatch.on('legendClick', function(d, i) {
                    d.disabled = !d.disabled;
                    rescaleY = !d.disabled;
                    state.rescaleY = rescaleY;
                    dispatch.stateChange(state);
                    chart.update();
                });
                legend.dispatch.on('stateChange', function(newState) {
                    state.disabled = newState.disabled;
                    dispatch.stateChange(state);
                    chart.update();
                });
                interactiveLayer.dispatch.on('elementMousemove', function(e) {
                    lines.clearHighlights();
                    var singlePoint1, pointIndex, pointXLocation, allData = [];
                    data.filter(function(series, i) {
                        series.seriesIndex = i;
                        return !series.disabled;
                    }).forEach(function(series, i) {
                        pointIndex = nv.interactiveBisect(series.values, e.pointXValue, chart.x());
                        lines.highlightPoint(i, pointIndex, true);
                        var point = series.values[pointIndex];
                        if (typeof point === 'undefined') return;
                        if (typeof singlePoint1 === 'undefined') singlePoint1 = point;
                        if (typeof pointXLocation === 'undefined') pointXLocation = chart.xScale()(chart.x()(point, pointIndex));
                        allData.push({
                            key: series.key,
                            value: chart.y()(point, pointIndex),
                            color: color(series, series.seriesIndex)
                        });
                    });
                    //Highlight the tooltip entry based on which point the mouse is closest to.
                    if (allData.length > 2) {
                        var yValue = chart.yScale().invert(e.mouseY);
                        var yDistMax = Infinity, indexToHighlight = null;
                        allData.forEach(function(series, i) {
                            var delta = Math.abs(yValue - series.value);
                            if (delta < yDistMax) {
                                yDistMax = delta;
                                indexToHighlight = i;
                            }
                        });
                        allData[indexToHighlight].highlight = true;
                    }
                    var xValue = xAxis.tickFormat()(chart.x()(singlePoint1, pointIndex), pointIndex);
                    interactiveLayer.tooltip.position({
                        left: pointXLocation + margin.left,
                        top: e.mouseY + margin.top
                    }).chartContainer(that.parentNode).enabled(tooltips).valueFormatter(function(d, i) {
                        return yAxis.tickFormat()(d);
                    }).data({
                        value: xValue,
                        series: allData
                    })();
                    interactiveLayer.renderGuideLine(pointXLocation);
                });
                interactiveLayer.dispatch.on("elementMouseout", function(e) {
                    dispatch.tooltipHide();
                    lines.clearHighlights();
                });
                dispatch.on('tooltipShow', function(e) {
                    if (tooltips) showTooltip(e, that.parentNode);
                });
                // Update chart from a state object passed to event handler
                dispatch.on('changeState', function(e) {
                    if (typeof e.disabled !== 'undefined') {
                        data.forEach(function(series, i) {
                            series.disabled = e.disabled[i];
                        });
                        state.disabled = e.disabled;
                    }
                    if (typeof e.index !== 'undefined') {
                        index.i = e.index;
                        index.x = dx(index.i);
                        state.index = e.index;
                        indexLine.data([
                            index
                        ]);
                    }
                    if (typeof e.rescaleY !== 'undefined') rescaleY = e.rescaleY;
                    chart.update();
                });
            //============================================================
            });
            return chart;
        }
        //============================================================
        // Event Handling/Dispatching (out of chart's scope)
        //------------------------------------------------------------
        lines.dispatch.on('elementMouseover.tooltip', function(e) {
            e.pos = [
                e.pos[0] + margin.left,
                e.pos[1] + margin.top
            ];
            dispatch.tooltipShow(e);
        });
        lines.dispatch.on('elementMouseout.tooltip', function(e) {
            dispatch.tooltipHide(e);
        });
        dispatch.on('tooltipHide', function() {
            if (tooltips) nv.tooltip.cleanup();
        });
        //============================================================
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        // expose chart's sub-components
        chart.dispatch = dispatch;
        chart.lines = lines;
        chart.legend = legend;
        chart.xAxis = xAxis;
        chart.yAxis = yAxis;
        chart.interactiveLayer = interactiveLayer;
        $9175b321012dc0d3$var$d3.rebind(chart, lines, 'defined', 'isArea', 'x', 'y', 'xScale', 'yScale', 'size', 'xDomain', 'yDomain', 'xRange', 'yRange', 'forceX', 'forceY', 'interactive', 'clipEdge', 'clipVoronoi', 'useVoronoi', 'id');
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = nv.utils.getColor(_);
            legend.color(color);
            return chart;
        };
        chart.rescaleY = function(_) {
            if (!arguments.length) return rescaleY;
            rescaleY = _;
            return rescaleY;
        };
        chart.showControls = function(_) {
            if (!arguments.length) return showControls;
            showControls = _;
            return chart;
        };
        chart.useInteractiveGuideline = function(_) {
            if (!arguments.length) return useInteractiveGuideline;
            useInteractiveGuideline = _;
            if (_ === true) {
                chart.interactive(false);
                chart.useVoronoi(false);
            }
            return chart;
        };
        chart.showLegend = function(_) {
            if (!arguments.length) return showLegend;
            showLegend = _;
            return chart;
        };
        chart.showXAxis = function(_) {
            if (!arguments.length) return showXAxis;
            showXAxis = _;
            return chart;
        };
        chart.showYAxis = function(_) {
            if (!arguments.length) return showYAxis;
            showYAxis = _;
            return chart;
        };
        chart.rightAlignYAxis = function(_) {
            if (!arguments.length) return rightAlignYAxis;
            rightAlignYAxis = _;
            yAxis.orient(_ ? 'right' : 'left');
            return chart;
        };
        chart.tooltips = function(_) {
            if (!arguments.length) return tooltips;
            tooltips = _;
            return chart;
        };
        chart.tooltipContent = function(_) {
            if (!arguments.length) return tooltip;
            tooltip = _;
            return chart;
        };
        chart.state = function(_) {
            if (!arguments.length) return state;
            state = _;
            return chart;
        };
        chart.defaultState = function(_) {
            if (!arguments.length) return defaultState;
            defaultState = _;
            return chart;
        };
        chart.noData = function(_) {
            if (!arguments.length) return noData;
            noData = _;
            return chart;
        };
        chart.average = function(_) {
            if (!arguments.length) return average;
            average = _;
            return chart;
        };
        chart.transitionDuration = function(_) {
            if (!arguments.length) return transitionDuration;
            transitionDuration = _;
            return chart;
        };
        //============================================================
        //============================================================
        // Functions
        //------------------------------------------------------------
        /* Normalize the data according to an index point. */ function indexify(idx, data) {
            return data.map(function(line, i) {
                if (!line.values) return line;
                var v = lines.y()(line.values[idx], idx);
                //TODO: implement check below, and disable series if series loses 100% or more cause divide by 0 issue
                if (v < -0.95) {
                    //if a series loses more than 100%, calculations fail.. anything close can cause major distortion (but is mathematically correct till it hits 100)
                    line.tempDisabled = true;
                    return line;
                }
                line.tempDisabled = false;
                line.values = line.values.map(function(point, pointIndex) {
                    point.display = {
                        'y': (lines.y()(point, pointIndex) - v) / (1 + v)
                    };
                    return point;
                });
                return line;
            });
        }
        //============================================================
        return chart;
    };
    //TODO: consider deprecating by adding necessary features to multiBar model
    nv.models.discreteBar = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var margin = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }, width = 960, height = 500, id = Math.floor(Math.random() * 10000) //Create semi-unique ID in case user doesn't select one
        , x = $9175b321012dc0d3$var$d3.scale.ordinal(), y = $9175b321012dc0d3$var$d3.scale.linear(), getX1 = function(d) {
            return d.x;
        }, getY1 = function(d) {
            return d.y;
        }, forceY = [
            0
        ] // 0 is forced by default.. this makes sense for the majority of bar graphs... user can always do chart.forceY([]) to remove
        , color = nv.utils.defaultColor(), showValues = false, valueFormat = $9175b321012dc0d3$var$d3.format(',.2f'), xDomain, yDomain, xRange, yRange, dispatch = $9175b321012dc0d3$var$d3.dispatch('chartClick', 'elementClick', 'elementDblClick', 'elementMouseover', 'elementMouseout'), rectClass = 'discreteBar';
        //============================================================
        //============================================================
        // Private Variables
        //------------------------------------------------------------
        var x0, y0;
        //============================================================
        function chart(selection) {
            selection.each(function(data) {
                var availableWidth = width - margin.left - margin.right, availableHeight = height - margin.top - margin.bottom, container = $9175b321012dc0d3$var$d3.select(this);
                //add series index to each data point for reference
                data = data.map(function(series, i) {
                    series.values = series.values.map(function(point) {
                        point.series = i;
                        return point;
                    });
                    return series;
                });
                //------------------------------------------------------------
                // Setup Scales
                // remap and flatten the data for use in calculating the scales' domains
                var seriesData = xDomain && yDomain ? [] : data.map(function(d) {
                    return d.values.map(function(d, i) {
                        return {
                            x: getX1(d, i),
                            y: getY1(d, i),
                            y0: d.y0
                        };
                    });
                });
                x.domain(xDomain || $9175b321012dc0d3$var$d3.merge(seriesData).map(function(d) {
                    return d.x;
                })).rangeBands(xRange || [
                    0,
                    availableWidth
                ], .1);
                y.domain(yDomain || $9175b321012dc0d3$var$d3.extent($9175b321012dc0d3$var$d3.merge(seriesData).map(function(d) {
                    return d.y;
                }).concat(forceY)));
                // If showValues, pad the Y axis range to account for label height
                if (showValues) y.range(yRange || [
                    availableHeight - (y.domain()[0] < 0 ? 12 : 0),
                    y.domain()[1] > 0 ? 12 : 0
                ]);
                else y.range(yRange || [
                    availableHeight,
                    0
                ]);
                //store old scales if they exist
                x0 = x0 || x;
                y0 = y0 || y.copy().range([
                    y(0),
                    y(0)
                ]);
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = container.selectAll('g.nv-wrap.nv-discretebar').data([
                    data
                ]);
                var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-discretebar');
                var gEnter = wrapEnter.append('g');
                var g = wrap.select('g');
                gEnter.append('g').attr('class', 'nv-groups');
                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                //------------------------------------------------------------
                //TODO: by definition, the discrete bar should not have multiple groups, will modify/remove later
                var groups = wrap.select('.nv-groups').selectAll('.nv-group').data(function(d) {
                    return d;
                }, function(d) {
                    return d.key;
                });
                groups.enter().append('g').style('stroke-opacity', 1e-6).style('fill-opacity', 1e-6);
                groups.exit().transition().style('stroke-opacity', 1e-6).style('fill-opacity', 1e-6).remove();
                groups.attr('class', function(d, i) {
                    return 'nv-group nv-series-' + i;
                }).classed('hover', function(d) {
                    return d.hover;
                });
                groups.transition().style('stroke-opacity', 1).style('fill-opacity', .75);
                var bars = groups.selectAll('g.nv-bar').data(function(d) {
                    return d.values;
                });
                bars.exit().remove();
                var barsEnter = bars.enter().append('g').attr('transform', function(d, i, j) {
                    return 'translate(' + (x(getX1(d, i)) + x.rangeBand() * .05) + ', ' + y(0) + ')';
                }).on('mouseover', function(d, i) {
                    $9175b321012dc0d3$var$d3.select(this).classed('hover', true);
                    dispatch.elementMouseover({
                        value: getY1(d, i),
                        point: d,
                        series: data[d.series],
                        pos: [
                            x(getX1(d, i)) + x.rangeBand() * (d.series + .5) / data.length,
                            y(getY1(d, i))
                        ],
                        pointIndex: i,
                        seriesIndex: d.series,
                        e: $9175b321012dc0d3$var$d3.event
                    });
                }).on('mouseout', function(d, i) {
                    $9175b321012dc0d3$var$d3.select(this).classed('hover', false);
                    dispatch.elementMouseout({
                        value: getY1(d, i),
                        point: d,
                        series: data[d.series],
                        pointIndex: i,
                        seriesIndex: d.series,
                        e: $9175b321012dc0d3$var$d3.event
                    });
                }).on('click', function(d, i) {
                    dispatch.elementClick({
                        value: getY1(d, i),
                        point: d,
                        series: data[d.series],
                        pos: [
                            x(getX1(d, i)) + x.rangeBand() * (d.series + .5) / data.length,
                            y(getY1(d, i))
                        ],
                        pointIndex: i,
                        seriesIndex: d.series,
                        e: $9175b321012dc0d3$var$d3.event
                    });
                    $9175b321012dc0d3$var$d3.event.stopPropagation();
                }).on('dblclick', function(d, i) {
                    dispatch.elementDblClick({
                        value: getY1(d, i),
                        point: d,
                        series: data[d.series],
                        pos: [
                            x(getX1(d, i)) + x.rangeBand() * (d.series + .5) / data.length,
                            y(getY1(d, i))
                        ],
                        pointIndex: i,
                        seriesIndex: d.series,
                        e: $9175b321012dc0d3$var$d3.event
                    });
                    $9175b321012dc0d3$var$d3.event.stopPropagation();
                });
                barsEnter.append('rect').attr('height', 0).attr('width', x.rangeBand() * .9 / data.length);
                if (showValues) {
                    barsEnter.append('text').attr('text-anchor', 'middle');
                    bars.select('text').text(function(d, i) {
                        return valueFormat(getY1(d, i));
                    }).transition().attr('x', x.rangeBand() * .9 / 2).attr('y', function(d, i) {
                        return getY1(d, i) < 0 ? y(getY1(d, i)) - y(0) + 12 : -4;
                    });
                } else bars.selectAll('text').remove();
                bars.attr('class', function(d, i) {
                    return getY1(d, i) < 0 ? 'nv-bar negative' : 'nv-bar positive';
                }).style('fill', function(d, i) {
                    return d.color || color(d, i);
                }).style('stroke', function(d, i) {
                    return d.color || color(d, i);
                }).select('rect').attr('class', rectClass).transition().attr('width', x.rangeBand() * .9 / data.length);
                bars.transition()//.delay(function(d,i) { return i * 1200 / data[0].values.length })
                .attr('transform', function(d, i) {
                    var left = x(getX1(d, i)) + x.rangeBand() * .05, top = getY1(d, i) < 0 ? y(0) : y(0) - y(getY1(d, i)) < 1 ? y(0) - 1 : y(getY1(d, i));
                    return 'translate(' + left + ', ' + top + ')';
                }).select('rect').attr('height', function(d, i) {
                    return Math.max(Math.abs(y(getY1(d, i)) - y(yDomain && yDomain[0] || 0)) || 1);
                });
                //store old scales for use in transitions on update
                x0 = x.copy();
                y0 = y.copy();
            });
            return chart;
        }
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        chart.dispatch = dispatch;
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.x = function(_) {
            if (!arguments.length) return getX1;
            getX1 = _;
            return chart;
        };
        chart.y = function(_) {
            if (!arguments.length) return getY1;
            getY1 = _;
            return chart;
        };
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.xScale = function(_) {
            if (!arguments.length) return x;
            x = _;
            return chart;
        };
        chart.yScale = function(_) {
            if (!arguments.length) return y;
            y = _;
            return chart;
        };
        chart.xDomain = function(_) {
            if (!arguments.length) return xDomain;
            xDomain = _;
            return chart;
        };
        chart.yDomain = function(_) {
            if (!arguments.length) return yDomain;
            yDomain = _;
            return chart;
        };
        chart.xRange = function(_) {
            if (!arguments.length) return xRange;
            xRange = _;
            return chart;
        };
        chart.yRange = function(_) {
            if (!arguments.length) return yRange;
            yRange = _;
            return chart;
        };
        chart.forceY = function(_) {
            if (!arguments.length) return forceY;
            forceY = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = nv.utils.getColor(_);
            return chart;
        };
        chart.id = function(_) {
            if (!arguments.length) return id;
            id = _;
            return chart;
        };
        chart.showValues = function(_) {
            if (!arguments.length) return showValues;
            showValues = _;
            return chart;
        };
        chart.valueFormat = function(_) {
            if (!arguments.length) return valueFormat;
            valueFormat = _;
            return chart;
        };
        chart.rectClass = function(_) {
            if (!arguments.length) return rectClass;
            rectClass = _;
            return chart;
        };
        //============================================================
        return chart;
    };
    nv.models.discreteBarChart = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var discretebar = nv.models.discreteBar(), xAxis = nv.models.axis(), yAxis = nv.models.axis();
        var margin = {
            top: 15,
            right: 10,
            bottom: 50,
            left: 60
        }, width = null, height = null, color = nv.utils.getColor(), showXAxis = true, showYAxis = true, rightAlignYAxis = false, staggerLabels = false, tooltips = true, tooltip = function(key, x, y, e, graph) {
            return '<h3>' + x + '</h3>' + '<p>' + y + '</p>';
        }, x, y, noData = "No Data Available.", dispatch = $9175b321012dc0d3$var$d3.dispatch('tooltipShow', 'tooltipHide', 'beforeUpdate'), transitionDuration = 250;
        xAxis.orient('bottom').highlightZero(false).showMaxMin(false).tickFormat(function(d) {
            return d;
        });
        yAxis.orient(rightAlignYAxis ? 'right' : 'left').tickFormat($9175b321012dc0d3$var$d3.format(',.1f'));
        //============================================================
        //============================================================
        // Private Variables
        //------------------------------------------------------------
        var showTooltip = function(e, offsetElement) {
            var left = e.pos[0] + (offsetElement.offsetLeft || 0), top = e.pos[1] + (offsetElement.offsetTop || 0), x = xAxis.tickFormat()(discretebar.x()(e.point, e.pointIndex)), y = yAxis.tickFormat()(discretebar.y()(e.point, e.pointIndex)), content = tooltip(e.series.key, x, y, e, chart);
            nv.tooltip.show([
                left,
                top
            ], content, e.value < 0 ? 'n' : 's', null, offsetElement);
        };
        //============================================================
        function chart(selection) {
            selection.each(function(data) {
                var container = $9175b321012dc0d3$var$d3.select(this), that = this;
                var availableWidth = (width || parseInt(container.style('width')) || 960) - margin.left - margin.right, availableHeight = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom;
                chart.update = function() {
                    dispatch.beforeUpdate();
                    container.transition().duration(transitionDuration).call(chart);
                };
                chart.container = this;
                //------------------------------------------------------------
                // Display No Data message if there's nothing to show.
                if (!data || !data.length || !data.filter(function(d) {
                    return d.values.length;
                }).length) {
                    var noDataText = container.selectAll('.nv-noData').data([
                        noData
                    ]);
                    noDataText.enter().append('text').attr('class', 'nvd3 nv-noData').attr('dy', '-.7em').style('text-anchor', 'middle');
                    noDataText.attr('x', margin.left + availableWidth / 2).attr('y', margin.top + availableHeight / 2).text(function(d) {
                        return d;
                    });
                    return chart;
                } else container.selectAll('.nv-noData').remove();
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup Scales
                x = discretebar.xScale();
                y = discretebar.yScale().clamp(true);
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = container.selectAll('g.nv-wrap.nv-discreteBarWithAxes').data([
                    data
                ]);
                var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-discreteBarWithAxes').append('g');
                var defsEnter = gEnter.append('defs');
                var g = wrap.select('g');
                gEnter.append('g').attr('class', 'nv-x nv-axis');
                gEnter.append('g').attr('class', 'nv-y nv-axis');
                gEnter.append('g').attr('class', 'nv-barsWrap');
                g.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                if (rightAlignYAxis) g.select(".nv-y.nv-axis").attr("transform", "translate(" + availableWidth + ",0)");
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Main Chart Component(s)
                discretebar.width(availableWidth).height(availableHeight);
                var barsWrap = g.select('.nv-barsWrap').datum(data.filter(function(d) {
                    return !d.disabled;
                }));
                barsWrap.transition().call(discretebar);
                //------------------------------------------------------------
                defsEnter.append('clipPath').attr('id', 'nv-x-label-clip-' + discretebar.id()).append('rect');
                g.select('#nv-x-label-clip-' + discretebar.id() + ' rect').attr('width', x.rangeBand() * (staggerLabels ? 2 : 1)).attr('height', 16).attr('x', -x.rangeBand() / (staggerLabels ? 1 : 2));
                //------------------------------------------------------------
                // Setup Axes
                if (showXAxis) {
                    xAxis.scale(x).ticks(availableWidth / 100).tickSize(-availableHeight, 0);
                    g.select('.nv-x.nv-axis').attr('transform', 'translate(0,' + (y.range()[0] + (discretebar.showValues() && y.domain()[0] < 0 ? 16 : 0)) + ')');
                    //d3.transition(g.select('.nv-x.nv-axis'))
                    g.select('.nv-x.nv-axis').transition().call(xAxis);
                    var xTicks = g.select('.nv-x.nv-axis').selectAll('g');
                    if (staggerLabels) xTicks.selectAll('text').attr('transform', function(d, i, j) {
                        return 'translate(0,' + (j % 2 == 0 ? '5' : '17') + ')';
                    });
                }
                if (showYAxis) {
                    yAxis.scale(y).ticks(availableHeight / 36).tickSize(-availableWidth, 0);
                    g.select('.nv-y.nv-axis').transition().call(yAxis);
                }
                //------------------------------------------------------------
                //============================================================
                // Event Handling/Dispatching (in chart's scope)
                //------------------------------------------------------------
                dispatch.on('tooltipShow', function(e) {
                    if (tooltips) showTooltip(e, that.parentNode);
                });
            //============================================================
            });
            return chart;
        }
        //============================================================
        // Event Handling/Dispatching (out of chart's scope)
        //------------------------------------------------------------
        discretebar.dispatch.on('elementMouseover.tooltip', function(e) {
            e.pos = [
                e.pos[0] + margin.left,
                e.pos[1] + margin.top
            ];
            dispatch.tooltipShow(e);
        });
        discretebar.dispatch.on('elementMouseout.tooltip', function(e) {
            dispatch.tooltipHide(e);
        });
        dispatch.on('tooltipHide', function() {
            if (tooltips) nv.tooltip.cleanup();
        });
        //============================================================
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        // expose chart's sub-components
        chart.dispatch = dispatch;
        chart.discretebar = discretebar;
        chart.xAxis = xAxis;
        chart.yAxis = yAxis;
        $9175b321012dc0d3$var$d3.rebind(chart, discretebar, 'x', 'y', 'xDomain', 'yDomain', 'xRange', 'yRange', 'forceX', 'forceY', 'id', 'showValues', 'valueFormat');
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = nv.utils.getColor(_);
            discretebar.color(color);
            return chart;
        };
        chart.showXAxis = function(_) {
            if (!arguments.length) return showXAxis;
            showXAxis = _;
            return chart;
        };
        chart.showYAxis = function(_) {
            if (!arguments.length) return showYAxis;
            showYAxis = _;
            return chart;
        };
        chart.rightAlignYAxis = function(_) {
            if (!arguments.length) return rightAlignYAxis;
            rightAlignYAxis = _;
            yAxis.orient(_ ? 'right' : 'left');
            return chart;
        };
        chart.staggerLabels = function(_) {
            if (!arguments.length) return staggerLabels;
            staggerLabels = _;
            return chart;
        };
        chart.tooltips = function(_) {
            if (!arguments.length) return tooltips;
            tooltips = _;
            return chart;
        };
        chart.tooltipContent = function(_) {
            if (!arguments.length) return tooltip;
            tooltip = _;
            return chart;
        };
        chart.noData = function(_) {
            if (!arguments.length) return noData;
            noData = _;
            return chart;
        };
        chart.transitionDuration = function(_) {
            if (!arguments.length) return transitionDuration;
            transitionDuration = _;
            return chart;
        };
        //============================================================
        return chart;
    };
    nv.models.distribution = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var margin = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }, width = 400 //technically width or height depending on x or y....
        , size = 8, axis = 'x' // 'x' or 'y'... horizontal or vertical
        , getData = function(d) {
            return d[axis];
        } // defaults d.x or d.y
        , color = nv.utils.defaultColor(), scale = $9175b321012dc0d3$var$d3.scale.linear(), domain;
        //============================================================
        //============================================================
        // Private Variables
        //------------------------------------------------------------
        var scale0;
        //============================================================
        function chart(selection) {
            selection.each(function(data) {
                var availableLength = width - (axis === 'x' ? margin.left + margin.right : margin.top + margin.bottom), naxis = axis == 'x' ? 'y' : 'x', container = $9175b321012dc0d3$var$d3.select(this);
                //------------------------------------------------------------
                // Setup Scales
                scale0 = scale0 || scale;
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = container.selectAll('g.nv-distribution').data([
                    data
                ]);
                var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-distribution');
                var gEnter = wrapEnter.append('g');
                var g = wrap.select('g');
                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                //------------------------------------------------------------
                var distWrap = g.selectAll('g.nv-dist').data(function(d) {
                    return d;
                }, function(d) {
                    return d.key;
                });
                distWrap.enter().append('g');
                distWrap.attr('class', function(d, i) {
                    return 'nv-dist nv-series-' + i;
                }).style('stroke', function(d, i) {
                    return color(d, i);
                });
                var dist = distWrap.selectAll('line.nv-dist' + axis).data(function(d) {
                    return d.values;
                });
                dist.enter().append('line').attr(axis + '1', function(d, i) {
                    return scale0(getData(d, i));
                }).attr(axis + '2', function(d, i) {
                    return scale0(getData(d, i));
                });
                distWrap.exit().selectAll('line.nv-dist' + axis).transition().attr(axis + '1', function(d, i) {
                    return scale(getData(d, i));
                }).attr(axis + '2', function(d, i) {
                    return scale(getData(d, i));
                }).style('stroke-opacity', 0).remove();
                dist.attr('class', function(d, i) {
                    return 'nv-dist' + axis + ' nv-dist' + axis + '-' + i;
                }).attr(naxis + '1', 0).attr(naxis + '2', size);
                dist.transition().attr(axis + '1', function(d, i) {
                    return scale(getData(d, i));
                }).attr(axis + '2', function(d, i) {
                    return scale(getData(d, i));
                });
                scale0 = scale.copy();
            });
            return chart;
        }
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.axis = function(_) {
            if (!arguments.length) return axis;
            axis = _;
            return chart;
        };
        chart.size = function(_) {
            if (!arguments.length) return size;
            size = _;
            return chart;
        };
        chart.getData = function(_) {
            if (!arguments.length) return getData;
            getData = $9175b321012dc0d3$var$d3.functor(_);
            return chart;
        };
        chart.scale = function(_) {
            if (!arguments.length) return scale;
            scale = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = nv.utils.getColor(_);
            return chart;
        };
        //============================================================
        return chart;
    };
    //TODO: consider deprecating and using multibar with single series for this
    nv.models.historicalBar = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var margin = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }, width = 960, height = 500, id = Math.floor(Math.random() * 10000) //Create semi-unique ID in case user doesn't select one
        , x = $9175b321012dc0d3$var$d3.scale.linear(), y = $9175b321012dc0d3$var$d3.scale.linear(), getX1 = function(d) {
            return d.x;
        }, getY1 = function(d) {
            return d.y;
        }, forceX = [], forceY = [
            0
        ], padData = false, clipEdge = true, color = nv.utils.defaultColor(), xDomain, yDomain, xRange, yRange, dispatch = $9175b321012dc0d3$var$d3.dispatch('chartClick', 'elementClick', 'elementDblClick', 'elementMouseover', 'elementMouseout'), interactive = true;
        //============================================================
        function chart(selection) {
            selection.each(function(data) {
                var availableWidth = width - margin.left - margin.right, availableHeight = height - margin.top - margin.bottom, container = $9175b321012dc0d3$var$d3.select(this);
                //------------------------------------------------------------
                // Setup Scales
                x.domain(xDomain || $9175b321012dc0d3$var$d3.extent(data[0].values.map(getX1).concat(forceX)));
                if (padData) x.range(xRange || [
                    availableWidth * .5 / data[0].values.length,
                    availableWidth * (data[0].values.length - .5) / data[0].values.length
                ]);
                else x.range(xRange || [
                    0,
                    availableWidth
                ]);
                y.domain(yDomain || $9175b321012dc0d3$var$d3.extent(data[0].values.map(getY1).concat(forceY))).range(yRange || [
                    availableHeight,
                    0
                ]);
                // If scale's domain don't have a range, slightly adjust to make one... so a chart can show a single data point
                if (x.domain()[0] === x.domain()[1]) x.domain()[0] ? x.domain([
                    x.domain()[0] - x.domain()[0] * 0.01,
                    x.domain()[1] + x.domain()[1] * 0.01
                ]) : x.domain([
                    -1,
                    1
                ]);
                if (y.domain()[0] === y.domain()[1]) y.domain()[0] ? y.domain([
                    y.domain()[0] + y.domain()[0] * 0.01,
                    y.domain()[1] - y.domain()[1] * 0.01
                ]) : y.domain([
                    -1,
                    1
                ]);
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = container.selectAll('g.nv-wrap.nv-historicalBar-' + id).data([
                    data[0].values
                ]);
                var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-historicalBar-' + id);
                var defsEnter = wrapEnter.append('defs');
                var gEnter = wrapEnter.append('g');
                var g = wrap.select('g');
                gEnter.append('g').attr('class', 'nv-bars');
                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                //------------------------------------------------------------
                container.on('click', function(d, i) {
                    dispatch.chartClick({
                        data: d,
                        index: i,
                        pos: $9175b321012dc0d3$var$d3.event,
                        id: id
                    });
                });
                defsEnter.append('clipPath').attr('id', 'nv-chart-clip-path-' + id).append('rect');
                wrap.select('#nv-chart-clip-path-' + id + ' rect').attr('width', availableWidth).attr('height', availableHeight);
                g.attr('clip-path', clipEdge ? 'url(#nv-chart-clip-path-' + id + ')' : '');
                var bars = wrap.select('.nv-bars').selectAll('.nv-bar').data(function(d) {
                    return d;
                }, function(d, i) {
                    return getX1(d, i);
                });
                bars.exit().remove();
                var barsEnter = bars.enter().append('rect')//.attr('class', function(d,i,j) { return (getY(d,i) < 0 ? 'nv-bar negative' : 'nv-bar positive') + ' nv-bar-' + j + '-' + i })
                .attr('x', 0).attr('y', function(d, i) {
                    return nv.utils.NaNtoZero(y(Math.max(0, getY1(d, i))));
                }).attr('height', function(d, i) {
                    return nv.utils.NaNtoZero(Math.abs(y(getY1(d, i)) - y(0)));
                }).attr('transform', function(d, i) {
                    return 'translate(' + (x(getX1(d, i)) - availableWidth / data[0].values.length * .45) + ',0)';
                }).on('mouseover', function(d, i) {
                    if (!interactive) return;
                    $9175b321012dc0d3$var$d3.select(this).classed('hover', true);
                    dispatch.elementMouseover({
                        point: d,
                        series: data[0],
                        pos: [
                            x(getX1(d, i)),
                            y(getY1(d, i))
                        ],
                        pointIndex: i,
                        seriesIndex: 0,
                        e: $9175b321012dc0d3$var$d3.event
                    });
                }).on('mouseout', function(d, i) {
                    if (!interactive) return;
                    $9175b321012dc0d3$var$d3.select(this).classed('hover', false);
                    dispatch.elementMouseout({
                        point: d,
                        series: data[0],
                        pointIndex: i,
                        seriesIndex: 0,
                        e: $9175b321012dc0d3$var$d3.event
                    });
                }).on('click', function(d, i) {
                    if (!interactive) return;
                    dispatch.elementClick({
                        //label: d[label],
                        value: getY1(d, i),
                        data: d,
                        index: i,
                        pos: [
                            x(getX1(d, i)),
                            y(getY1(d, i))
                        ],
                        e: $9175b321012dc0d3$var$d3.event,
                        id: id
                    });
                    $9175b321012dc0d3$var$d3.event.stopPropagation();
                }).on('dblclick', function(d, i) {
                    if (!interactive) return;
                    dispatch.elementDblClick({
                        //label: d[label],
                        value: getY1(d, i),
                        data: d,
                        index: i,
                        pos: [
                            x(getX1(d, i)),
                            y(getY1(d, i))
                        ],
                        e: $9175b321012dc0d3$var$d3.event,
                        id: id
                    });
                    $9175b321012dc0d3$var$d3.event.stopPropagation();
                });
                bars.attr('fill', function(d, i) {
                    return color(d, i);
                }).attr('class', function(d, i, j) {
                    return (getY1(d, i) < 0 ? 'nv-bar negative' : 'nv-bar positive') + ' nv-bar-' + j + '-' + i;
                }).transition().attr('transform', function(d, i) {
                    return 'translate(' + (x(getX1(d, i)) - availableWidth / data[0].values.length * .45) + ',0)';
                })//TODO: better width calculations that don't assume always uniform data spacing;w
                .attr('width', availableWidth / data[0].values.length * .9);
                bars.transition().attr('y', function(d, i) {
                    var rval = getY1(d, i) < 0 ? y(0) : y(0) - y(getY1(d, i)) < 1 ? y(0) - 1 : y(getY1(d, i));
                    return nv.utils.NaNtoZero(rval);
                }).attr('height', function(d, i) {
                    return nv.utils.NaNtoZero(Math.max(Math.abs(y(getY1(d, i)) - y(0)), 1));
                });
            });
            return chart;
        }
        //Create methods to allow outside functions to highlight a specific bar.
        chart.highlightPoint = function(pointIndex, isHoverOver) {
            $9175b321012dc0d3$var$d3.select(".nv-historicalBar-" + id).select(".nv-bars .nv-bar-0-" + pointIndex).classed("hover", isHoverOver);
        };
        chart.clearHighlights = function() {
            $9175b321012dc0d3$var$d3.select(".nv-historicalBar-" + id).select(".nv-bars .nv-bar.hover").classed("hover", false);
        };
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        chart.dispatch = dispatch;
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.x = function(_) {
            if (!arguments.length) return getX1;
            getX1 = _;
            return chart;
        };
        chart.y = function(_) {
            if (!arguments.length) return getY1;
            getY1 = _;
            return chart;
        };
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.xScale = function(_) {
            if (!arguments.length) return x;
            x = _;
            return chart;
        };
        chart.yScale = function(_) {
            if (!arguments.length) return y;
            y = _;
            return chart;
        };
        chart.xDomain = function(_) {
            if (!arguments.length) return xDomain;
            xDomain = _;
            return chart;
        };
        chart.yDomain = function(_) {
            if (!arguments.length) return yDomain;
            yDomain = _;
            return chart;
        };
        chart.xRange = function(_) {
            if (!arguments.length) return xRange;
            xRange = _;
            return chart;
        };
        chart.yRange = function(_) {
            if (!arguments.length) return yRange;
            yRange = _;
            return chart;
        };
        chart.forceX = function(_) {
            if (!arguments.length) return forceX;
            forceX = _;
            return chart;
        };
        chart.forceY = function(_) {
            if (!arguments.length) return forceY;
            forceY = _;
            return chart;
        };
        chart.padData = function(_) {
            if (!arguments.length) return padData;
            padData = _;
            return chart;
        };
        chart.clipEdge = function(_) {
            if (!arguments.length) return clipEdge;
            clipEdge = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = nv.utils.getColor(_);
            return chart;
        };
        chart.id = function(_) {
            if (!arguments.length) return id;
            id = _;
            return chart;
        };
        chart.interactive = function(_) {
            if (!arguments.length) return interactive;
            interactive = false;
            return chart;
        };
        //============================================================
        return chart;
    };
    nv.models.historicalBarChart = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var bars = nv.models.historicalBar(), xAxis = nv.models.axis(), yAxis = nv.models.axis(), legend = nv.models.legend();
        var margin = {
            top: 30,
            right: 90,
            bottom: 50,
            left: 90
        }, color = nv.utils.defaultColor(), width = null, height = null, showLegend = false, showXAxis = true, showYAxis = true, rightAlignYAxis = false, tooltips = true, tooltip = function(key, x, y, e, graph) {
            return '<h3>' + key + '</h3>' + '<p>' + y + ' at ' + x + '</p>';
        }, x, y, state = {}, defaultState = null, noData = 'No Data Available.', dispatch = $9175b321012dc0d3$var$d3.dispatch('tooltipShow', 'tooltipHide', 'stateChange', 'changeState'), transitionDuration = 250;
        xAxis.orient('bottom').tickPadding(7);
        yAxis.orient(rightAlignYAxis ? 'right' : 'left');
        //============================================================
        //============================================================
        // Private Variables
        //------------------------------------------------------------
        var showTooltip = function(e, offsetElement) {
            // New addition to calculate position if SVG is scaled with viewBox, may move TODO: consider implementing everywhere else
            if (offsetElement) {
                var svg = $9175b321012dc0d3$var$d3.select(offsetElement).select('svg');
                var viewBox = svg.node() ? svg.attr('viewBox') : null;
                if (viewBox) {
                    viewBox = viewBox.split(' ');
                    var ratio = parseInt(svg.style('width')) / viewBox[2];
                    e.pos[0] = e.pos[0] * ratio;
                    e.pos[1] = e.pos[1] * ratio;
                }
            }
            var left = e.pos[0] + (offsetElement.offsetLeft || 0), top = e.pos[1] + (offsetElement.offsetTop || 0), x = xAxis.tickFormat()(bars.x()(e.point, e.pointIndex)), y = yAxis.tickFormat()(bars.y()(e.point, e.pointIndex)), content = tooltip(e.series.key, x, y, e, chart);
            nv.tooltip.show([
                left,
                top
            ], content, null, null, offsetElement);
        };
        //============================================================
        function chart(selection) {
            selection.each(function(data) {
                var container = $9175b321012dc0d3$var$d3.select(this), that = this;
                var availableWidth = (width || parseInt(container.style('width')) || 960) - margin.left - margin.right, availableHeight = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom;
                chart.update = function() {
                    container.transition().duration(transitionDuration).call(chart);
                };
                chart.container = this;
                //set state.disabled
                state.disabled = data.map(function(d) {
                    return !!d.disabled;
                });
                if (!defaultState) {
                    var key;
                    defaultState = {};
                    for(key in state)if (state[key] instanceof Array) defaultState[key] = state[key].slice(0);
                    else defaultState[key] = state[key];
                }
                //------------------------------------------------------------
                // Display noData message if there's nothing to show.
                if (!data || !data.length || !data.filter(function(d) {
                    return d.values.length;
                }).length) {
                    var noDataText = container.selectAll('.nv-noData').data([
                        noData
                    ]);
                    noDataText.enter().append('text').attr('class', 'nvd3 nv-noData').attr('dy', '-.7em').style('text-anchor', 'middle');
                    noDataText.attr('x', margin.left + availableWidth / 2).attr('y', margin.top + availableHeight / 2).text(function(d) {
                        return d;
                    });
                    return chart;
                } else container.selectAll('.nv-noData').remove();
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup Scales
                x = bars.xScale();
                y = bars.yScale();
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = container.selectAll('g.nv-wrap.nv-historicalBarChart').data([
                    data
                ]);
                var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-historicalBarChart').append('g');
                var g = wrap.select('g');
                gEnter.append('g').attr('class', 'nv-x nv-axis');
                gEnter.append('g').attr('class', 'nv-y nv-axis');
                gEnter.append('g').attr('class', 'nv-barsWrap');
                gEnter.append('g').attr('class', 'nv-legendWrap');
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Legend
                if (showLegend) {
                    legend.width(availableWidth);
                    g.select('.nv-legendWrap').datum(data).call(legend);
                    if (margin.top != legend.height()) {
                        margin.top = legend.height();
                        availableHeight = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom;
                    }
                    wrap.select('.nv-legendWrap').attr('transform', 'translate(0,' + -margin.top + ')');
                }
                //------------------------------------------------------------
                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                if (rightAlignYAxis) g.select(".nv-y.nv-axis").attr("transform", "translate(" + availableWidth + ",0)");
                //------------------------------------------------------------
                // Main Chart Component(s)
                bars.width(availableWidth).height(availableHeight).color(data.map(function(d, i) {
                    return d.color || color(d, i);
                }).filter(function(d, i) {
                    return !data[i].disabled;
                }));
                var barsWrap = g.select('.nv-barsWrap').datum(data.filter(function(d) {
                    return !d.disabled;
                }));
                barsWrap.transition().call(bars);
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup Axes
                if (showXAxis) {
                    xAxis.scale(x).tickSize(-availableHeight, 0);
                    g.select('.nv-x.nv-axis').attr('transform', 'translate(0,' + y.range()[0] + ')');
                    g.select('.nv-x.nv-axis').transition().call(xAxis);
                }
                if (showYAxis) {
                    yAxis.scale(y).ticks(availableHeight / 36).tickSize(-availableWidth, 0);
                    g.select('.nv-y.nv-axis').transition().call(yAxis);
                }
                //------------------------------------------------------------
                //============================================================
                // Event Handling/Dispatching (in chart's scope)
                //------------------------------------------------------------
                legend.dispatch.on('legendClick', function(d, i) {
                    d.disabled = !d.disabled;
                    if (!data.filter(function(d) {
                        return !d.disabled;
                    }).length) data.map(function(d) {
                        d.disabled = false;
                        wrap.selectAll('.nv-series').classed('disabled', false);
                        return d;
                    });
                    state.disabled = data.map(function(d) {
                        return !!d.disabled;
                    });
                    dispatch.stateChange(state);
                    selection.transition().call(chart);
                });
                legend.dispatch.on('legendDblclick', function(d) {
                    //Double clicking should always enable current series, and disabled all others.
                    data.forEach(function(d) {
                        d.disabled = true;
                    });
                    d.disabled = false;
                    state.disabled = data.map(function(d) {
                        return !!d.disabled;
                    });
                    dispatch.stateChange(state);
                    chart.update();
                });
                dispatch.on('tooltipShow', function(e) {
                    if (tooltips) showTooltip(e, that.parentNode);
                });
                dispatch.on('changeState', function(e) {
                    if (typeof e.disabled !== 'undefined') {
                        data.forEach(function(series, i) {
                            series.disabled = e.disabled[i];
                        });
                        state.disabled = e.disabled;
                    }
                    selection.call(chart);
                });
            //============================================================
            });
            return chart;
        }
        //============================================================
        // Event Handling/Dispatching (out of chart's scope)
        //------------------------------------------------------------
        bars.dispatch.on('elementMouseover.tooltip', function(e) {
            e.pos = [
                e.pos[0] + margin.left,
                e.pos[1] + margin.top
            ];
            dispatch.tooltipShow(e);
        });
        bars.dispatch.on('elementMouseout.tooltip', function(e) {
            dispatch.tooltipHide(e);
        });
        dispatch.on('tooltipHide', function() {
            if (tooltips) nv.tooltip.cleanup();
        });
        //============================================================
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        // expose chart's sub-components
        chart.dispatch = dispatch;
        chart.bars = bars;
        chart.legend = legend;
        chart.xAxis = xAxis;
        chart.yAxis = yAxis;
        $9175b321012dc0d3$var$d3.rebind(chart, bars, 'defined', 'isArea', 'x', 'y', 'size', 'xScale', 'yScale', 'xDomain', 'yDomain', 'xRange', 'yRange', 'forceX', 'forceY', 'interactive', 'clipEdge', 'clipVoronoi', 'id', 'interpolate', 'highlightPoint', 'clearHighlights', 'interactive');
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = nv.utils.getColor(_);
            legend.color(color);
            return chart;
        };
        chart.showLegend = function(_) {
            if (!arguments.length) return showLegend;
            showLegend = _;
            return chart;
        };
        chart.showXAxis = function(_) {
            if (!arguments.length) return showXAxis;
            showXAxis = _;
            return chart;
        };
        chart.showYAxis = function(_) {
            if (!arguments.length) return showYAxis;
            showYAxis = _;
            return chart;
        };
        chart.rightAlignYAxis = function(_) {
            if (!arguments.length) return rightAlignYAxis;
            rightAlignYAxis = _;
            yAxis.orient(_ ? 'right' : 'left');
            return chart;
        };
        chart.tooltips = function(_) {
            if (!arguments.length) return tooltips;
            tooltips = _;
            return chart;
        };
        chart.tooltipContent = function(_) {
            if (!arguments.length) return tooltip;
            tooltip = _;
            return chart;
        };
        chart.state = function(_) {
            if (!arguments.length) return state;
            state = _;
            return chart;
        };
        chart.defaultState = function(_) {
            if (!arguments.length) return defaultState;
            defaultState = _;
            return chart;
        };
        chart.noData = function(_) {
            if (!arguments.length) return noData;
            noData = _;
            return chart;
        };
        chart.transitionDuration = function(_) {
            if (!arguments.length) return transitionDuration;
            transitionDuration = _;
            return chart;
        };
        //============================================================
        return chart;
    };
    nv.models.indentedTree = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var margin = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        } //TODO: implement, maybe as margin on the containing div
        , width = 960, height = 500, color = nv.utils.defaultColor(), id = Math.floor(Math.random() * 10000), header = true, filterZero = false, noData = "No Data Available.", childIndent = 20, columns = [
            {
                key: 'key',
                label: 'Name',
                type: 'text'
            }
        ] //TODO: consider functions like chart.addColumn, chart.removeColumn, instead of a block like this
        , tableClass = null, iconOpen = 'images/grey-plus.png' //TODO: consider removing this and replacing with a '+' or '-' unless user defines images
        , iconClose = 'images/grey-minus.png', dispatch = $9175b321012dc0d3$var$d3.dispatch('elementClick', 'elementDblclick', 'elementMouseover', 'elementMouseout'), getUrl = function(d) {
            return d.url;
        };
        //============================================================
        var idx = 0;
        function chart(selection) {
            selection.each(function(data) {
                var depth = 1, container = $9175b321012dc0d3$var$d3.select(this);
                var tree = $9175b321012dc0d3$var$d3.layout.tree().children(function(d) {
                    return d.values;
                }).size([
                    height,
                    childIndent
                ]); //Not sure if this is needed now that the result is HTML
                chart.update = function() {
                    container.transition().duration(600).call(chart);
                };
                //------------------------------------------------------------
                // Display No Data message if there's nothing to show.
                if (!data[0]) data[0] = {
                    key: noData
                };
                //------------------------------------------------------------
                var nodes = tree.nodes(data[0]);
                // nodes.map(function(d) {
                //   d.id = i++;
                // })
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = $9175b321012dc0d3$var$d3.select(this).selectAll('div').data([
                    [
                        nodes
                    ]
                ]);
                var wrapEnter = wrap.enter().append('div').attr('class', 'nvd3 nv-wrap nv-indentedtree');
                var tableEnter = wrapEnter.append('table');
                var table = wrap.select('table').attr('width', '100%').attr('class', tableClass);
                //------------------------------------------------------------
                if (header) {
                    var thead = tableEnter.append('thead');
                    var theadRow1 = thead.append('tr');
                    columns.forEach(function(column) {
                        theadRow1.append('th').attr('width', column.width ? column.width : '10%').style('text-align', column.type == 'numeric' ? 'right' : 'left').append('span').text(column.label);
                    });
                }
                var tbody = table.selectAll('tbody').data(function(d) {
                    return d;
                });
                tbody.enter().append('tbody');
                //compute max generations
                depth = $9175b321012dc0d3$var$d3.max(nodes, function(node) {
                    return node.depth;
                });
                tree.size([
                    height,
                    depth * childIndent
                ]); //TODO: see if this is necessary at all
                // Update the nodes…
                var node = tbody.selectAll('tr')// .data(function(d) { return d; }, function(d) { return d.id || (d.id == ++i)});
                .data(function(d) {
                    return d.filter(function(d) {
                        return filterZero && !d.children ? filterZero(d) : true;
                    });
                }, function(d, i) {
                    return d.id || d.id || ++idx;
                });
                //.style('display', 'table-row'); //TODO: see if this does anything
                node.exit().remove();
                node.select('img.nv-treeicon').attr('src', icon).classed('folded', folded);
                var nodeEnter = node.enter().append('tr');
                columns.forEach(function(column, index) {
                    var nodeName = nodeEnter.append('td').style('padding-left', function(d) {
                        return (index ? 0 : d.depth * childIndent + 12 + (icon(d) ? 0 : 16)) + 'px';
                    }, 'important') //TODO: check why I did the ternary here
                    .style('text-align', column.type == 'numeric' ? 'right' : 'left');
                    if (index == 0) nodeName.append('img').classed('nv-treeicon', true).classed('nv-folded', folded).attr('src', icon).style('width', '14px').style('height', '14px').style('padding', '0 1px').style('display', function(d) {
                        return icon(d) ? 'inline-block' : 'none';
                    }).on('click', click);
                    nodeName.each(function(d) {
                        if (!index && getUrl(d)) $9175b321012dc0d3$var$d3.select(this).append('a').attr('href', getUrl).attr('class', $9175b321012dc0d3$var$d3.functor(column.classes)).append('span');
                        else $9175b321012dc0d3$var$d3.select(this).append('span');
                        $9175b321012dc0d3$var$d3.select(this).select('span').attr('class', $9175b321012dc0d3$var$d3.functor(column.classes)).text(function(d) {
                            return column.format ? column.format(d) : d[column.key] || '-';
                        });
                    });
                    if (column.showCount) {
                        nodeName.append('span').attr('class', 'nv-childrenCount');
                        node.selectAll('span.nv-childrenCount').text(function(d) {
                            return d.values && d.values.length || d._values && d._values.length ? '(' + (d.values && d.values.filter(function(d) {
                                return filterZero ? filterZero(d) : true;
                            }).length || d._values && d._values.filter(function(d) {
                                return filterZero ? filterZero(d) : true;
                            }).length //Otherwise, do the same, but with the other name, _values...
                             || 0) + ')' //This is the catch-all in case there are no children after a filter
                             : '' //If this is not a parent, just give an empty string
                            ;
                        });
                    }
                // if (column.click)
                //   nodeName.select('span').on('click', column.click);
                });
                node.order().on('click', function(d) {
                    dispatch.elementClick({
                        row: this,
                        data: d,
                        pos: [
                            d.x,
                            d.y
                        ]
                    });
                }).on('dblclick', function(d) {
                    dispatch.elementDblclick({
                        row: this,
                        data: d,
                        pos: [
                            d.x,
                            d.y
                        ]
                    });
                }).on('mouseover', function(d) {
                    dispatch.elementMouseover({
                        row: this,
                        data: d,
                        pos: [
                            d.x,
                            d.y
                        ]
                    });
                }).on('mouseout', function(d) {
                    dispatch.elementMouseout({
                        row: this,
                        data: d,
                        pos: [
                            d.x,
                            d.y
                        ]
                    });
                });
                // Toggle children on click.
                function click(d, _, unshift) {
                    $9175b321012dc0d3$var$d3.event.stopPropagation();
                    if ($9175b321012dc0d3$var$d3.event.shiftKey && !unshift) {
                        //If you shift-click, it'll toggle fold all the children, instead of itself
                        $9175b321012dc0d3$var$d3.event.shiftKey = false;
                        d.values && d.values.forEach(function(node) {
                            if (node.values || node._values) click(node, 0, true);
                        });
                        return true;
                    }
                    if (!hasChildren(d)) //download file
                    //window.location.href = d.url;
                    return true;
                    if (d.values) {
                        d._values = d.values;
                        d.values = null;
                    } else {
                        d.values = d._values;
                        d._values = null;
                    }
                    chart.update();
                }
                function icon(d) {
                    return d._values && d._values.length ? iconOpen : d.values && d.values.length ? iconClose : '';
                }
                function folded(d) {
                    return d._values && d._values.length;
                }
                function hasChildren(d) {
                    var values = d.values || d._values;
                    return values && values.length;
                }
            });
            return chart;
        }
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = nv.utils.getColor(_);
            scatter.color(color);
            return chart;
        };
        chart.id = function(_) {
            if (!arguments.length) return id;
            id = _;
            return chart;
        };
        chart.header = function(_) {
            if (!arguments.length) return header;
            header = _;
            return chart;
        };
        chart.noData = function(_) {
            if (!arguments.length) return noData;
            noData = _;
            return chart;
        };
        chart.filterZero = function(_) {
            if (!arguments.length) return filterZero;
            filterZero = _;
            return chart;
        };
        chart.columns = function(_) {
            if (!arguments.length) return columns;
            columns = _;
            return chart;
        };
        chart.tableClass = function(_) {
            if (!arguments.length) return tableClass;
            tableClass = _;
            return chart;
        };
        chart.iconOpen = function(_) {
            if (!arguments.length) return iconOpen;
            iconOpen = _;
            return chart;
        };
        chart.iconClose = function(_) {
            if (!arguments.length) return iconClose;
            iconClose = _;
            return chart;
        };
        chart.getUrl = function(_) {
            if (!arguments.length) return getUrl;
            getUrl = _;
            return chart;
        };
        //============================================================
        return chart;
    };
    nv.models.legend = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var margin = {
            top: 5,
            right: 0,
            bottom: 5,
            left: 0
        }, width = 400, height = 20, getKey = function(d) {
            return d.key;
        }, color = nv.utils.defaultColor(), align = true, rightAlign = true, updateState = true //If true, legend will update data.disabled and trigger a 'stateChange' dispatch.
        , radioButtonMode = false //If true, clicking legend items will cause it to behave like a radio button. (only one can be selected at a time)
        , dispatch = $9175b321012dc0d3$var$d3.dispatch('legendClick', 'legendDblclick', 'legendMouseover', 'legendMouseout', 'stateChange');
        //============================================================
        function chart(selection) {
            selection.each(function(data) {
                var availableWidth = width - margin.left - margin.right, container = $9175b321012dc0d3$var$d3.select(this);
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = container.selectAll('g.nv-legend').data([
                    data
                ]);
                var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-legend').append('g');
                var g = wrap.select('g');
                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                //------------------------------------------------------------
                var series = g.selectAll('.nv-series').data(function(d) {
                    return d;
                });
                var seriesEnter = series.enter().append('g').attr('class', 'nv-series').on('mouseover', function(d, i) {
                    dispatch.legendMouseover(d, i); //TODO: Make consistent with other event objects
                }).on('mouseout', function(d, i) {
                    dispatch.legendMouseout(d, i);
                }).on('click', function(d, i) {
                    dispatch.legendClick(d, i);
                    if (updateState) {
                        if (radioButtonMode) {
                            //Radio button mode: set every series to disabled,
                            //  and enable the clicked series.
                            data.forEach(function(series) {
                                series.disabled = true;
                            });
                            d.disabled = false;
                        } else {
                            d.disabled = !d.disabled;
                            if (data.every(function(series) {
                                return series.disabled;
                            })) //the default behavior of NVD3 legends is, if every single series
                            // is disabled, turn all series' back on.
                            data.forEach(function(series) {
                                series.disabled = false;
                            });
                        }
                        dispatch.stateChange({
                            disabled: data.map(function(d) {
                                return !!d.disabled;
                            })
                        });
                    }
                }).on('dblclick', function(d, i) {
                    dispatch.legendDblclick(d, i);
                    if (updateState) {
                        //the default behavior of NVD3 legends, when double clicking one,
                        // is to set all other series' to false, and make the double clicked series enabled.
                        data.forEach(function(series) {
                            series.disabled = true;
                        });
                        d.disabled = false;
                        dispatch.stateChange({
                            disabled: data.map(function(d) {
                                return !!d.disabled;
                            })
                        });
                    }
                });
                seriesEnter.append('circle').style('stroke-width', 2).attr('class', 'nv-legend-symbol').attr('r', 5);
                seriesEnter.append('text').attr('text-anchor', 'start').attr('class', 'nv-legend-text').attr('dy', '.32em').attr('dx', '8');
                series.classed('disabled', function(d) {
                    return d.disabled;
                });
                series.exit().remove();
                series.select('circle').style('fill', function(d, i) {
                    return d.color || color(d, i);
                }).style('stroke', function(d, i) {
                    return d.color || color(d, i);
                });
                series.select('text').text(getKey);
                //TODO: implement fixed-width and max-width options (max-width is especially useful with the align option)
                // NEW ALIGNING CODE, TODO: clean up
                if (align) {
                    var seriesWidths = [];
                    series.each(function(d, i) {
                        var legendText = $9175b321012dc0d3$var$d3.select(this).select('text');
                        var nodeTextLength;
                        try {
                            nodeTextLength = legendText.node().getComputedTextLength();
                        } catch (e) {
                            nodeTextLength = nv.utils.calcApproxTextWidth(legendText);
                        }
                        seriesWidths.push(nodeTextLength + 28); // 28 is ~ the width of the circle plus some padding
                    });
                    var seriesPerRow = 0;
                    var legendWidth = 0;
                    var columnWidths = [];
                    while(legendWidth < availableWidth && seriesPerRow < seriesWidths.length){
                        columnWidths[seriesPerRow] = seriesWidths[seriesPerRow];
                        legendWidth += seriesWidths[seriesPerRow++];
                    }
                    if (seriesPerRow === 0) seriesPerRow = 1; //minimum of one series per row
                    while(legendWidth > availableWidth && seriesPerRow > 1){
                        columnWidths = [];
                        seriesPerRow--;
                        for(var k = 0; k < seriesWidths.length; k++)if (seriesWidths[k] > (columnWidths[k % seriesPerRow] || 0)) columnWidths[k % seriesPerRow] = seriesWidths[k];
                        legendWidth = columnWidths.reduce(function(prev, cur, index, array) {
                            return prev + cur;
                        });
                    }
                    var xPositions = [];
                    for(var i = 0, curX = 0; i < seriesPerRow; i++){
                        xPositions[i] = curX;
                        curX += columnWidths[i];
                    }
                    series.attr('transform', function(d, i) {
                        return 'translate(' + xPositions[i % seriesPerRow] + ',' + (5 + Math.floor(i / seriesPerRow) * 20) + ')';
                    });
                    //position legend as far right as possible within the total width
                    if (rightAlign) g.attr('transform', 'translate(' + (width - margin.right - legendWidth) + ',' + margin.top + ')');
                    else g.attr('transform', "translate(0," + margin.top + ')');
                    height = margin.top + margin.bottom + Math.ceil(seriesWidths.length / seriesPerRow) * 20;
                } else {
                    var ypos = 5, newxpos = 5, maxwidth = 0, xpos;
                    series.attr('transform', function(d, i) {
                        var length = $9175b321012dc0d3$var$d3.select(this).select('text').node().getComputedTextLength() + 28;
                        xpos = newxpos;
                        if (width < margin.left + margin.right + xpos + length) {
                            newxpos = xpos = 5;
                            ypos += 20;
                        }
                        newxpos += length;
                        if (newxpos > maxwidth) maxwidth = newxpos;
                        return 'translate(' + xpos + ',' + ypos + ')';
                    });
                    //position legend as far right as possible within the total width
                    g.attr('transform', 'translate(' + (width - margin.right - maxwidth) + ',' + margin.top + ')');
                    height = margin.top + margin.bottom + ypos + 15;
                }
            });
            return chart;
        }
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        chart.dispatch = dispatch;
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.key = function(_) {
            if (!arguments.length) return getKey;
            getKey = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = nv.utils.getColor(_);
            return chart;
        };
        chart.align = function(_) {
            if (!arguments.length) return align;
            align = _;
            return chart;
        };
        chart.rightAlign = function(_) {
            if (!arguments.length) return rightAlign;
            rightAlign = _;
            return chart;
        };
        chart.updateState = function(_) {
            if (!arguments.length) return updateState;
            updateState = _;
            return chart;
        };
        chart.radioButtonMode = function(_) {
            if (!arguments.length) return radioButtonMode;
            radioButtonMode = _;
            return chart;
        };
        //============================================================
        return chart;
    };
    nv.models.line = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var scatter1 = nv.models.scatter();
        var margin = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }, width = 960, height = 500, color = nv.utils.defaultColor() // a function that returns a color
        , getX1 = function(d) {
            return d.x;
        } // accessor to get the x value from a data point
        , getY1 = function(d) {
            return d.y;
        } // accessor to get the y value from a data point
        , defined = function(d, i) {
            return !isNaN(getY1(d, i)) && getY1(d, i) !== null;
        } // allows a line to be not continuous when it is not defined
        , isArea = function(d) {
            return d.area;
        } // decides if a line is an area or just a line
        , clipEdge = false // if true, masks lines within x and y scale
        , x //can be accessed via chart.xScale()
        , y //can be accessed via chart.yScale()
        , interpolate = "linear" // controls the line interpolation
        ;
        scatter1.size(16) // default size
        .sizeDomain([
            16,
            256
        ]) //set to speed up calculation, needs to be unset if there is a custom size accessor
        ;
        //============================================================
        //============================================================
        // Private Variables
        //------------------------------------------------------------
        var x0, y0 //used to store previous scales
        ;
        //============================================================
        function chart(selection) {
            selection.each(function(data) {
                var availableWidth = width - margin.left - margin.right, availableHeight = height - margin.top - margin.bottom, container = $9175b321012dc0d3$var$d3.select(this);
                //------------------------------------------------------------
                // Setup Scales
                x = scatter1.xScale();
                y = scatter1.yScale();
                x0 = x0 || x;
                y0 = y0 || y;
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = container.selectAll('g.nv-wrap.nv-line').data([
                    data
                ]);
                var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-line');
                var defsEnter = wrapEnter.append('defs');
                var gEnter = wrapEnter.append('g');
                var g = wrap.select('g');
                gEnter.append('g').attr('class', 'nv-groups');
                gEnter.append('g').attr('class', 'nv-scatterWrap');
                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                //------------------------------------------------------------
                scatter1.width(availableWidth).height(availableHeight);
                var scatterWrap = wrap.select('.nv-scatterWrap');
                //.datum(data); // Data automatically trickles down from the wrap
                scatterWrap.transition().call(scatter1);
                defsEnter.append('clipPath').attr('id', 'nv-edge-clip-' + scatter1.id()).append('rect');
                wrap.select('#nv-edge-clip-' + scatter1.id() + ' rect').attr('width', availableWidth).attr('height', availableHeight);
                g.attr('clip-path', clipEdge ? 'url(#nv-edge-clip-' + scatter1.id() + ')' : '');
                scatterWrap.attr('clip-path', clipEdge ? 'url(#nv-edge-clip-' + scatter1.id() + ')' : '');
                var groups = wrap.select('.nv-groups').selectAll('.nv-group').data(function(d) {
                    return d;
                }, function(d) {
                    return d.key;
                });
                groups.enter().append('g').style('stroke-opacity', 1e-6).style('fill-opacity', 1e-6);
                groups.exit().transition().style('stroke-opacity', 1e-6).style('fill-opacity', 1e-6).remove();
                groups.attr('class', function(d, i) {
                    return 'nv-group nv-series-' + i;
                }).classed('hover', function(d) {
                    return d.hover;
                }).style('fill', function(d, i) {
                    return color(d, i);
                }).style('stroke', function(d, i) {
                    return color(d, i);
                });
                groups.transition().style('stroke-opacity', 1).style('fill-opacity', .5);
                var areaPaths = groups.selectAll('path.nv-area').data(function(d) {
                    return isArea(d) ? [
                        d
                    ] : [];
                }); // this is done differently than lines because I need to check if series is an area
                areaPaths.enter().append('path').attr('class', 'nv-area').attr('d', function(d) {
                    return $9175b321012dc0d3$var$d3.svg.area().interpolate(interpolate).defined(defined).x(function(d, i) {
                        return nv.utils.NaNtoZero(x0(getX1(d, i)));
                    }).y0(function(d, i) {
                        return nv.utils.NaNtoZero(y0(getY1(d, i)));
                    }).y1(function(d, i) {
                        return y0(y.domain()[0] <= 0 ? y.domain()[1] >= 0 ? 0 : y.domain()[1] : y.domain()[0]);
                    })//.y1(function(d,i) { return y0(0) }) //assuming 0 is within y domain.. may need to tweak this
                    .apply(this, [
                        d.values
                    ]);
                });
                groups.exit().selectAll('path.nv-area').remove();
                areaPaths.transition().attr('d', function(d) {
                    return $9175b321012dc0d3$var$d3.svg.area().interpolate(interpolate).defined(defined).x(function(d, i) {
                        return nv.utils.NaNtoZero(x(getX1(d, i)));
                    }).y0(function(d, i) {
                        return nv.utils.NaNtoZero(y(getY1(d, i)));
                    }).y1(function(d, i) {
                        return y(y.domain()[0] <= 0 ? y.domain()[1] >= 0 ? 0 : y.domain()[1] : y.domain()[0]);
                    })//.y1(function(d,i) { return y0(0) }) //assuming 0 is within y domain.. may need to tweak this
                    .apply(this, [
                        d.values
                    ]);
                });
                var linePaths = groups.selectAll('path.nv-line').data(function(d) {
                    return [
                        d.values
                    ];
                });
                linePaths.enter().append('path').attr('class', 'nv-line').attr('d', $9175b321012dc0d3$var$d3.svg.line().interpolate(interpolate).defined(defined).x(function(d, i) {
                    return nv.utils.NaNtoZero(x0(getX1(d, i)));
                }).y(function(d, i) {
                    return nv.utils.NaNtoZero(y0(getY1(d, i)));
                }));
                groups.exit().selectAll('path.nv-line').transition().attr('d', $9175b321012dc0d3$var$d3.svg.line().interpolate(interpolate).defined(defined).x(function(d, i) {
                    return nv.utils.NaNtoZero(x(getX1(d, i)));
                }).y(function(d, i) {
                    return nv.utils.NaNtoZero(y(getY1(d, i)));
                }));
                linePaths.transition().attr('d', $9175b321012dc0d3$var$d3.svg.line().interpolate(interpolate).defined(defined).x(function(d, i) {
                    return nv.utils.NaNtoZero(x(getX1(d, i)));
                }).y(function(d, i) {
                    return nv.utils.NaNtoZero(y(getY1(d, i)));
                }));
                //store old scales for use in transitions on update
                x0 = x.copy();
                y0 = y.copy();
            });
            return chart;
        }
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        chart.dispatch = scatter1.dispatch;
        chart.scatter = scatter1;
        $9175b321012dc0d3$var$d3.rebind(chart, scatter1, 'id', 'interactive', 'size', 'xScale', 'yScale', 'zScale', 'xDomain', 'yDomain', 'xRange', 'yRange', 'sizeDomain', 'forceX', 'forceY', 'forceSize', 'clipVoronoi', 'useVoronoi', 'clipRadius', 'padData', 'highlightPoint', 'clearHighlights');
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.x = function(_) {
            if (!arguments.length) return getX1;
            getX1 = _;
            scatter1.x(_);
            return chart;
        };
        chart.y = function(_) {
            if (!arguments.length) return getY1;
            getY1 = _;
            scatter1.y(_);
            return chart;
        };
        chart.clipEdge = function(_) {
            if (!arguments.length) return clipEdge;
            clipEdge = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = nv.utils.getColor(_);
            scatter1.color(color);
            return chart;
        };
        chart.interpolate = function(_) {
            if (!arguments.length) return interpolate;
            interpolate = _;
            return chart;
        };
        chart.defined = function(_) {
            if (!arguments.length) return defined;
            defined = _;
            return chart;
        };
        chart.isArea = function(_) {
            if (!arguments.length) return isArea;
            isArea = $9175b321012dc0d3$var$d3.functor(_);
            return chart;
        };
        //============================================================
        return chart;
    };
    nv.models.lineChart = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var lines = nv.models.line(), xAxis = nv.models.axis(), yAxis = nv.models.axis(), legend = nv.models.legend(), interactiveLayer = nv.interactiveGuideline();
        var margin = {
            top: 30,
            right: 20,
            bottom: 50,
            left: 60
        }, color = nv.utils.defaultColor(), width = null, height = null, showLegend = true, showXAxis = true, showYAxis = true, rightAlignYAxis = false, useInteractiveGuideline = false, tooltips = true, tooltip = function(key, x, y, e, graph) {
            return '<h3>' + key + '</h3>' + '<p>' + y + ' at ' + x + '</p>';
        }, x, y, state = {}, defaultState = null, noData = 'No Data Available.', dispatch = $9175b321012dc0d3$var$d3.dispatch('tooltipShow', 'tooltipHide', 'stateChange', 'changeState'), transitionDuration = 250;
        xAxis.orient('bottom').tickPadding(7);
        yAxis.orient(rightAlignYAxis ? 'right' : 'left');
        //============================================================
        //============================================================
        // Private Variables
        //------------------------------------------------------------
        var showTooltip = function(e, offsetElement) {
            var left = e.pos[0] + (offsetElement.offsetLeft || 0), top = e.pos[1] + (offsetElement.offsetTop || 0), x = xAxis.tickFormat()(lines.x()(e.point, e.pointIndex)), y = yAxis.tickFormat()(lines.y()(e.point, e.pointIndex)), content = tooltip(e.series.key, x, y, e, chart);
            nv.tooltip.show([
                left,
                top
            ], content, null, null, offsetElement);
        };
        //============================================================
        function chart(selection) {
            selection.each(function(data) {
                var container = $9175b321012dc0d3$var$d3.select(this), that = this;
                var availableWidth = (width || parseInt(container.style('width')) || 960) - margin.left - margin.right, availableHeight = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom;
                chart.update = function() {
                    container.transition().duration(transitionDuration).call(chart);
                };
                chart.container = this;
                //set state.disabled
                state.disabled = data.map(function(d) {
                    return !!d.disabled;
                });
                if (!defaultState) {
                    var key;
                    defaultState = {};
                    for(key in state)if (state[key] instanceof Array) defaultState[key] = state[key].slice(0);
                    else defaultState[key] = state[key];
                }
                //------------------------------------------------------------
                // Display noData message if there's nothing to show.
                if (!data || !data.length || !data.filter(function(d) {
                    return d.values.length;
                }).length) {
                    var noDataText = container.selectAll('.nv-noData').data([
                        noData
                    ]);
                    noDataText.enter().append('text').attr('class', 'nvd3 nv-noData').attr('dy', '-.7em').style('text-anchor', 'middle');
                    noDataText.attr('x', margin.left + availableWidth / 2).attr('y', margin.top + availableHeight / 2).text(function(d) {
                        return d;
                    });
                    return chart;
                } else container.selectAll('.nv-noData').remove();
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup Scales
                x = lines.xScale();
                y = lines.yScale();
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = container.selectAll('g.nv-wrap.nv-lineChart').data([
                    data
                ]);
                var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-lineChart').append('g');
                var g = wrap.select('g');
                gEnter.append("rect").style("opacity", 0);
                gEnter.append('g').attr('class', 'nv-x nv-axis');
                gEnter.append('g').attr('class', 'nv-y nv-axis');
                gEnter.append('g').attr('class', 'nv-linesWrap');
                gEnter.append('g').attr('class', 'nv-legendWrap');
                gEnter.append('g').attr('class', 'nv-interactive');
                g.select("rect").attr("width", availableWidth).attr("height", availableHeight);
                //------------------------------------------------------------
                // Legend
                if (showLegend) {
                    legend.width(availableWidth);
                    g.select('.nv-legendWrap').datum(data).call(legend);
                    if (margin.top != legend.height()) {
                        margin.top = legend.height();
                        availableHeight = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom;
                    }
                    wrap.select('.nv-legendWrap').attr('transform', 'translate(0,' + -margin.top + ')');
                }
                //------------------------------------------------------------
                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                if (rightAlignYAxis) g.select(".nv-y.nv-axis").attr("transform", "translate(" + availableWidth + ",0)");
                //------------------------------------------------------------
                // Main Chart Component(s)
                //------------------------------------------------------------
                //Set up interactive layer
                if (useInteractiveGuideline) {
                    interactiveLayer.width(availableWidth).height(availableHeight).margin({
                        left: margin.left,
                        top: margin.top
                    }).svgContainer(container).xScale(x);
                    wrap.select(".nv-interactive").call(interactiveLayer);
                }
                lines.width(availableWidth).height(availableHeight).color(data.map(function(d, i) {
                    return d.color || color(d, i);
                }).filter(function(d, i) {
                    return !data[i].disabled;
                }));
                var linesWrap = g.select('.nv-linesWrap').datum(data.filter(function(d) {
                    return !d.disabled;
                }));
                linesWrap.transition().call(lines);
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup Axes
                if (showXAxis) {
                    xAxis.scale(x).ticks(availableWidth / 100).tickSize(-availableHeight, 0);
                    g.select('.nv-x.nv-axis').attr('transform', 'translate(0,' + y.range()[0] + ')');
                    g.select('.nv-x.nv-axis').transition().call(xAxis);
                }
                if (showYAxis) {
                    yAxis.scale(y).ticks(availableHeight / 36).tickSize(-availableWidth, 0);
                    g.select('.nv-y.nv-axis').transition().call(yAxis);
                }
                //------------------------------------------------------------
                //============================================================
                // Event Handling/Dispatching (in chart's scope)
                //------------------------------------------------------------
                legend.dispatch.on('stateChange', function(newState) {
                    state = newState;
                    dispatch.stateChange(state);
                    chart.update();
                });
                interactiveLayer.dispatch.on('elementMousemove', function(e) {
                    lines.clearHighlights();
                    var singlePoint1, pointIndex, pointXLocation, allData = [];
                    data.filter(function(series, i) {
                        series.seriesIndex = i;
                        return !series.disabled;
                    }).forEach(function(series, i) {
                        pointIndex = nv.interactiveBisect(series.values, e.pointXValue, chart.x());
                        lines.highlightPoint(i, pointIndex, true);
                        var point = series.values[pointIndex];
                        if (typeof point === 'undefined') return;
                        if (typeof singlePoint1 === 'undefined') singlePoint1 = point;
                        if (typeof pointXLocation === 'undefined') pointXLocation = chart.xScale()(chart.x()(point, pointIndex));
                        allData.push({
                            key: series.key,
                            value: chart.y()(point, pointIndex),
                            color: color(series, series.seriesIndex)
                        });
                    });
                    //Highlight the tooltip entry based on which point the mouse is closest to.
                    if (allData.length > 2) {
                        var yValue = chart.yScale().invert(e.mouseY);
                        var yDistMax = Infinity, indexToHighlight = null;
                        allData.forEach(function(series, i) {
                            var delta = Math.abs(yValue - series.value);
                            if (delta < yDistMax) {
                                yDistMax = delta;
                                indexToHighlight = i;
                            }
                        });
                        allData[indexToHighlight].highlight = true;
                    }
                    var xValue = xAxis.tickFormat()(chart.x()(singlePoint1, pointIndex));
                    interactiveLayer.tooltip.position({
                        left: pointXLocation + margin.left,
                        top: e.mouseY + margin.top
                    }).chartContainer(that.parentNode).enabled(tooltips).valueFormatter(function(d, i) {
                        return yAxis.tickFormat()(d);
                    }).data({
                        value: xValue,
                        series: allData
                    })();
                    interactiveLayer.renderGuideLine(pointXLocation);
                });
                interactiveLayer.dispatch.on("elementMouseout", function(e) {
                    dispatch.tooltipHide();
                    lines.clearHighlights();
                });
                dispatch.on('tooltipShow', function(e) {
                    if (tooltips) showTooltip(e, that.parentNode);
                });
                dispatch.on('changeState', function(e) {
                    if (typeof e.disabled !== 'undefined') {
                        data.forEach(function(series, i) {
                            series.disabled = e.disabled[i];
                        });
                        state.disabled = e.disabled;
                    }
                    chart.update();
                });
            //============================================================
            });
            return chart;
        }
        //============================================================
        // Event Handling/Dispatching (out of chart's scope)
        //------------------------------------------------------------
        lines.dispatch.on('elementMouseover.tooltip', function(e) {
            e.pos = [
                e.pos[0] + margin.left,
                e.pos[1] + margin.top
            ];
            dispatch.tooltipShow(e);
        });
        lines.dispatch.on('elementMouseout.tooltip', function(e) {
            dispatch.tooltipHide(e);
        });
        dispatch.on('tooltipHide', function() {
            if (tooltips) nv.tooltip.cleanup();
        });
        //============================================================
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        // expose chart's sub-components
        chart.dispatch = dispatch;
        chart.lines = lines;
        chart.legend = legend;
        chart.xAxis = xAxis;
        chart.yAxis = yAxis;
        chart.interactiveLayer = interactiveLayer;
        $9175b321012dc0d3$var$d3.rebind(chart, lines, 'defined', 'isArea', 'x', 'y', 'size', 'xScale', 'yScale', 'xDomain', 'yDomain', 'xRange', 'yRange', 'forceX', 'forceY', 'interactive', 'clipEdge', 'clipVoronoi', 'useVoronoi', 'id', 'interpolate');
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = nv.utils.getColor(_);
            legend.color(color);
            return chart;
        };
        chart.showLegend = function(_) {
            if (!arguments.length) return showLegend;
            showLegend = _;
            return chart;
        };
        chart.showXAxis = function(_) {
            if (!arguments.length) return showXAxis;
            showXAxis = _;
            return chart;
        };
        chart.showYAxis = function(_) {
            if (!arguments.length) return showYAxis;
            showYAxis = _;
            return chart;
        };
        chart.rightAlignYAxis = function(_) {
            if (!arguments.length) return rightAlignYAxis;
            rightAlignYAxis = _;
            yAxis.orient(_ ? 'right' : 'left');
            return chart;
        };
        chart.useInteractiveGuideline = function(_) {
            if (!arguments.length) return useInteractiveGuideline;
            useInteractiveGuideline = _;
            if (_ === true) {
                chart.interactive(false);
                chart.useVoronoi(false);
            }
            return chart;
        };
        chart.tooltips = function(_) {
            if (!arguments.length) return tooltips;
            tooltips = _;
            return chart;
        };
        chart.tooltipContent = function(_) {
            if (!arguments.length) return tooltip;
            tooltip = _;
            return chart;
        };
        chart.state = function(_) {
            if (!arguments.length) return state;
            state = _;
            return chart;
        };
        chart.defaultState = function(_) {
            if (!arguments.length) return defaultState;
            defaultState = _;
            return chart;
        };
        chart.noData = function(_) {
            if (!arguments.length) return noData;
            noData = _;
            return chart;
        };
        chart.transitionDuration = function(_) {
            if (!arguments.length) return transitionDuration;
            transitionDuration = _;
            return chart;
        };
        //============================================================
        return chart;
    };
    nv.models.linePlusBarChart = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var lines = nv.models.line(), bars = nv.models.historicalBar(), xAxis = nv.models.axis(), y1Axis = nv.models.axis(), y2Axis = nv.models.axis(), legend = nv.models.legend();
        var margin = {
            top: 30,
            right: 60,
            bottom: 50,
            left: 60
        }, width = null, height = null, getX1 = function(d) {
            return d.x;
        }, getY1 = function(d) {
            return d.y;
        }, color = nv.utils.defaultColor(), showLegend = true, tooltips = true, tooltip = function(key, x, y, e, graph) {
            return '<h3>' + key + '</h3>' + '<p>' + y + ' at ' + x + '</p>';
        }, x, y1, y2, state = {}, defaultState = null, noData = "No Data Available.", dispatch = $9175b321012dc0d3$var$d3.dispatch('tooltipShow', 'tooltipHide', 'stateChange', 'changeState');
        bars.padData(true);
        lines.clipEdge(false).padData(true);
        xAxis.orient('bottom').tickPadding(7).highlightZero(false);
        y1Axis.orient('left');
        y2Axis.orient('right');
        //============================================================
        //============================================================
        // Private Variables
        //------------------------------------------------------------
        var showTooltip = function(e, offsetElement) {
            var left = e.pos[0] + (offsetElement.offsetLeft || 0), top = e.pos[1] + (offsetElement.offsetTop || 0), x = xAxis.tickFormat()(lines.x()(e.point, e.pointIndex)), y = (e.series.bar ? y1Axis : y2Axis).tickFormat()(lines.y()(e.point, e.pointIndex)), content = tooltip(e.series.key, x, y, e, chart);
            nv.tooltip.show([
                left,
                top
            ], content, e.value < 0 ? 'n' : 's', null, offsetElement);
        };
        //------------------------------------------------------------
        function chart(selection) {
            selection.each(function(data) {
                var container = $9175b321012dc0d3$var$d3.select(this), that = this;
                var availableWidth = (width || parseInt(container.style('width')) || 960) - margin.left - margin.right, availableHeight = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom;
                chart.update = function() {
                    container.transition().call(chart);
                };
                // chart.container = this;
                //set state.disabled
                state.disabled = data.map(function(d) {
                    return !!d.disabled;
                });
                if (!defaultState) {
                    var key;
                    defaultState = {};
                    for(key in state)if (state[key] instanceof Array) defaultState[key] = state[key].slice(0);
                    else defaultState[key] = state[key];
                }
                //------------------------------------------------------------
                // Display No Data message if there's nothing to show.
                if (!data || !data.length || !data.filter(function(d) {
                    return d.values.length;
                }).length) {
                    var noDataText = container.selectAll('.nv-noData').data([
                        noData
                    ]);
                    noDataText.enter().append('text').attr('class', 'nvd3 nv-noData').attr('dy', '-.7em').style('text-anchor', 'middle');
                    noDataText.attr('x', margin.left + availableWidth / 2).attr('y', margin.top + availableHeight / 2).text(function(d) {
                        return d;
                    });
                    return chart;
                } else container.selectAll('.nv-noData').remove();
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup Scales
                var dataBars = data.filter(function(d) {
                    return !d.disabled && d.bar;
                });
                var dataLines = data.filter(function(d) {
                    return !d.bar;
                }); // removed the !d.disabled clause here to fix Issue #240
                //x = xAxis.scale();
                x = dataLines.filter(function(d) {
                    return !d.disabled;
                }).length && dataLines.filter(function(d) {
                    return !d.disabled;
                })[0].values.length ? lines.xScale() : bars.xScale();
                //x = dataLines.filter(function(d) { return !d.disabled; }).length ? lines.xScale() : bars.xScale(); //old code before change above
                y1 = bars.yScale();
                y2 = lines.yScale();
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = $9175b321012dc0d3$var$d3.select(this).selectAll('g.nv-wrap.nv-linePlusBar').data([
                    data
                ]);
                var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-linePlusBar').append('g');
                var g = wrap.select('g');
                gEnter.append('g').attr('class', 'nv-x nv-axis');
                gEnter.append('g').attr('class', 'nv-y1 nv-axis');
                gEnter.append('g').attr('class', 'nv-y2 nv-axis');
                gEnter.append('g').attr('class', 'nv-barsWrap');
                gEnter.append('g').attr('class', 'nv-linesWrap');
                gEnter.append('g').attr('class', 'nv-legendWrap');
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Legend
                if (showLegend) {
                    legend.width(availableWidth / 2);
                    g.select('.nv-legendWrap').datum(data.map(function(series) {
                        series.originalKey = series.originalKey === undefined ? series.key : series.originalKey;
                        series.key = series.originalKey + (series.bar ? ' (left axis)' : ' (right axis)');
                        return series;
                    })).call(legend);
                    if (margin.top != legend.height()) {
                        margin.top = legend.height();
                        availableHeight = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom;
                    }
                    g.select('.nv-legendWrap').attr('transform', 'translate(' + availableWidth / 2 + ',' + -margin.top + ')');
                }
                //------------------------------------------------------------
                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                //------------------------------------------------------------
                // Main Chart Component(s)
                lines.width(availableWidth).height(availableHeight).color(data.map(function(d, i) {
                    return d.color || color(d, i);
                }).filter(function(d, i) {
                    return !data[i].disabled && !data[i].bar;
                }));
                bars.width(availableWidth).height(availableHeight).color(data.map(function(d, i) {
                    return d.color || color(d, i);
                }).filter(function(d, i) {
                    return !data[i].disabled && data[i].bar;
                }));
                var barsWrap = g.select('.nv-barsWrap').datum(dataBars.length ? dataBars : [
                    {
                        values: []
                    }
                ]);
                var linesWrap = g.select('.nv-linesWrap').datum(dataLines[0] && !dataLines[0].disabled ? dataLines : [
                    {
                        values: []
                    }
                ]);
                //.datum(!dataLines[0].disabled ? dataLines : [{values:dataLines[0].values.map(function(d) { return [d[0], null] }) }] );
                $9175b321012dc0d3$var$d3.transition(barsWrap).call(bars);
                $9175b321012dc0d3$var$d3.transition(linesWrap).call(lines);
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup Axes
                xAxis.scale(x).ticks(availableWidth / 100).tickSize(-availableHeight, 0);
                g.select('.nv-x.nv-axis').attr('transform', 'translate(0,' + y1.range()[0] + ')');
                $9175b321012dc0d3$var$d3.transition(g.select('.nv-x.nv-axis')).call(xAxis);
                y1Axis.scale(y1).ticks(availableHeight / 36).tickSize(-availableWidth, 0);
                $9175b321012dc0d3$var$d3.transition(g.select('.nv-y1.nv-axis')).style('opacity', dataBars.length ? 1 : 0).call(y1Axis);
                y2Axis.scale(y2).ticks(availableHeight / 36).tickSize(dataBars.length ? 0 : -availableWidth, 0); // Show the y2 rules only if y1 has none
                g.select('.nv-y2.nv-axis').style('opacity', dataLines.length ? 1 : 0).attr('transform', 'translate(' + availableWidth + ',0)');
                //.attr('transform', 'translate(' + x.range()[1] + ',0)');
                $9175b321012dc0d3$var$d3.transition(g.select('.nv-y2.nv-axis')).call(y2Axis);
                //------------------------------------------------------------
                //============================================================
                // Event Handling/Dispatching (in chart's scope)
                //------------------------------------------------------------
                legend.dispatch.on('stateChange', function(newState) {
                    state = newState;
                    dispatch.stateChange(state);
                    chart.update();
                });
                dispatch.on('tooltipShow', function(e) {
                    if (tooltips) showTooltip(e, that.parentNode);
                });
                // Update chart from a state object passed to event handler
                dispatch.on('changeState', function(e) {
                    if (typeof e.disabled !== 'undefined') {
                        data.forEach(function(series, i) {
                            series.disabled = e.disabled[i];
                        });
                        state.disabled = e.disabled;
                    }
                    chart.update();
                });
            //============================================================
            });
            return chart;
        }
        //============================================================
        // Event Handling/Dispatching (out of chart's scope)
        //------------------------------------------------------------
        lines.dispatch.on('elementMouseover.tooltip', function(e) {
            e.pos = [
                e.pos[0] + margin.left,
                e.pos[1] + margin.top
            ];
            dispatch.tooltipShow(e);
        });
        lines.dispatch.on('elementMouseout.tooltip', function(e) {
            dispatch.tooltipHide(e);
        });
        bars.dispatch.on('elementMouseover.tooltip', function(e) {
            e.pos = [
                e.pos[0] + margin.left,
                e.pos[1] + margin.top
            ];
            dispatch.tooltipShow(e);
        });
        bars.dispatch.on('elementMouseout.tooltip', function(e) {
            dispatch.tooltipHide(e);
        });
        dispatch.on('tooltipHide', function() {
            if (tooltips) nv.tooltip.cleanup();
        });
        //============================================================
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        // expose chart's sub-components
        chart.dispatch = dispatch;
        chart.legend = legend;
        chart.lines = lines;
        chart.bars = bars;
        chart.xAxis = xAxis;
        chart.y1Axis = y1Axis;
        chart.y2Axis = y2Axis;
        $9175b321012dc0d3$var$d3.rebind(chart, lines, 'defined', 'size', 'clipVoronoi', 'interpolate');
        //TODO: consider rebinding x, y and some other stuff, and simply do soemthign lile bars.x(lines.x()), etc.
        //d3.rebind(chart, lines, 'x', 'y', 'size', 'xDomain', 'yDomain', 'xRange', 'yRange', 'forceX', 'forceY', 'interactive', 'clipEdge', 'clipVoronoi', 'id');
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.x = function(_) {
            if (!arguments.length) return getX1;
            getX1 = _;
            lines.x(_);
            bars.x(_);
            return chart;
        };
        chart.y = function(_) {
            if (!arguments.length) return getY1;
            getY1 = _;
            lines.y(_);
            bars.y(_);
            return chart;
        };
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = nv.utils.getColor(_);
            legend.color(color);
            return chart;
        };
        chart.showLegend = function(_) {
            if (!arguments.length) return showLegend;
            showLegend = _;
            return chart;
        };
        chart.tooltips = function(_) {
            if (!arguments.length) return tooltips;
            tooltips = _;
            return chart;
        };
        chart.tooltipContent = function(_) {
            if (!arguments.length) return tooltip;
            tooltip = _;
            return chart;
        };
        chart.state = function(_) {
            if (!arguments.length) return state;
            state = _;
            return chart;
        };
        chart.defaultState = function(_) {
            if (!arguments.length) return defaultState;
            defaultState = _;
            return chart;
        };
        chart.noData = function(_) {
            if (!arguments.length) return noData;
            noData = _;
            return chart;
        };
        //============================================================
        return chart;
    };
    nv.models.lineWithFocusChart = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var lines = nv.models.line(), lines2 = nv.models.line(), xAxis = nv.models.axis(), yAxis = nv.models.axis(), x2Axis = nv.models.axis(), y2Axis = nv.models.axis(), legend = nv.models.legend(), brush = $9175b321012dc0d3$var$d3.svg.brush();
        var margin = {
            top: 30,
            right: 30,
            bottom: 30,
            left: 60
        }, margin2 = {
            top: 0,
            right: 30,
            bottom: 20,
            left: 60
        }, color = nv.utils.defaultColor(), width = null, height = null, height2 = 100, x, y, x2, y2, showLegend = true, brushExtent = null, tooltips = true, tooltip = function(key, x, y, e, graph) {
            return '<h3>' + key + '</h3>' + '<p>' + y + ' at ' + x + '</p>';
        }, noData = "No Data Available.", dispatch = $9175b321012dc0d3$var$d3.dispatch('tooltipShow', 'tooltipHide', 'brush'), transitionDuration = 250;
        lines.clipEdge(true);
        lines2.interactive(false);
        xAxis.orient('bottom').tickPadding(5);
        yAxis.orient('left');
        x2Axis.orient('bottom').tickPadding(5);
        y2Axis.orient('left');
        //============================================================
        //============================================================
        // Private Variables
        //------------------------------------------------------------
        var showTooltip = function(e, offsetElement) {
            var left = e.pos[0] + (offsetElement.offsetLeft || 0), top = e.pos[1] + (offsetElement.offsetTop || 0), x = xAxis.tickFormat()(lines.x()(e.point, e.pointIndex)), y = yAxis.tickFormat()(lines.y()(e.point, e.pointIndex)), content = tooltip(e.series.key, x, y, e, chart);
            nv.tooltip.show([
                left,
                top
            ], content, null, null, offsetElement);
        };
        //============================================================
        function chart(selection) {
            selection.each(function(data) {
                var container = $9175b321012dc0d3$var$d3.select(this), that = this;
                var availableWidth = (width || parseInt(container.style('width')) || 960) - margin.left - margin.right, availableHeight1 = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom - height2, availableHeight2 = height2 - margin2.top - margin2.bottom;
                chart.update = function() {
                    container.transition().duration(transitionDuration).call(chart);
                };
                chart.container = this;
                //------------------------------------------------------------
                // Display No Data message if there's nothing to show.
                if (!data || !data.length || !data.filter(function(d) {
                    return d.values.length;
                }).length) {
                    var noDataText = container.selectAll('.nv-noData').data([
                        noData
                    ]);
                    noDataText.enter().append('text').attr('class', 'nvd3 nv-noData').attr('dy', '-.7em').style('text-anchor', 'middle');
                    noDataText.attr('x', margin.left + availableWidth / 2).attr('y', margin.top + availableHeight1 / 2).text(function(d) {
                        return d;
                    });
                    return chart;
                } else container.selectAll('.nv-noData').remove();
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup Scales
                x = lines.xScale();
                y = lines.yScale();
                x2 = lines2.xScale();
                y2 = lines2.yScale();
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = container.selectAll('g.nv-wrap.nv-lineWithFocusChart').data([
                    data
                ]);
                var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-lineWithFocusChart').append('g');
                var g = wrap.select('g');
                gEnter.append('g').attr('class', 'nv-legendWrap');
                var focusEnter = gEnter.append('g').attr('class', 'nv-focus');
                focusEnter.append('g').attr('class', 'nv-x nv-axis');
                focusEnter.append('g').attr('class', 'nv-y nv-axis');
                focusEnter.append('g').attr('class', 'nv-linesWrap');
                var contextEnter = gEnter.append('g').attr('class', 'nv-context');
                contextEnter.append('g').attr('class', 'nv-x nv-axis');
                contextEnter.append('g').attr('class', 'nv-y nv-axis');
                contextEnter.append('g').attr('class', 'nv-linesWrap');
                contextEnter.append('g').attr('class', 'nv-brushBackground');
                contextEnter.append('g').attr('class', 'nv-x nv-brush');
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Legend
                if (showLegend) {
                    legend.width(availableWidth);
                    g.select('.nv-legendWrap').datum(data).call(legend);
                    if (margin.top != legend.height()) {
                        margin.top = legend.height();
                        availableHeight1 = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom - height2;
                    }
                    g.select('.nv-legendWrap').attr('transform', 'translate(0,' + -margin.top + ')');
                }
                //------------------------------------------------------------
                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                //------------------------------------------------------------
                // Main Chart Component(s)
                lines.width(availableWidth).height(availableHeight1).color(data.map(function(d, i) {
                    return d.color || color(d, i);
                }).filter(function(d, i) {
                    return !data[i].disabled;
                }));
                lines2.defined(lines.defined()).width(availableWidth).height(availableHeight2).color(data.map(function(d, i) {
                    return d.color || color(d, i);
                }).filter(function(d, i) {
                    return !data[i].disabled;
                }));
                g.select('.nv-context').attr('transform', 'translate(0,' + (availableHeight1 + margin.bottom + margin2.top) + ')');
                var contextLinesWrap = g.select('.nv-context .nv-linesWrap').datum(data.filter(function(d) {
                    return !d.disabled;
                }));
                $9175b321012dc0d3$var$d3.transition(contextLinesWrap).call(lines2);
                //------------------------------------------------------------
                /*
      var focusLinesWrap = g.select('.nv-focus .nv-linesWrap')
          .datum(data.filter(function(d) { return !d.disabled }))

      d3.transition(focusLinesWrap).call(lines);
     */ //------------------------------------------------------------
                // Setup Main (Focus) Axes
                xAxis.scale(x).ticks(availableWidth / 100).tickSize(-availableHeight1, 0);
                yAxis.scale(y).ticks(availableHeight1 / 36).tickSize(-availableWidth, 0);
                g.select('.nv-focus .nv-x.nv-axis').attr('transform', 'translate(0,' + availableHeight1 + ')');
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup Brush
                brush.x(x2).on('brush', function() {
                    //When brushing, turn off transitions because chart needs to change immediately.
                    var oldTransition = chart.transitionDuration();
                    chart.transitionDuration(0);
                    onBrush();
                    chart.transitionDuration(oldTransition);
                });
                if (brushExtent) brush.extent(brushExtent);
                var brushBG = g.select('.nv-brushBackground').selectAll('g').data([
                    brushExtent || brush.extent()
                ]);
                var brushBGenter = brushBG.enter().append('g');
                brushBGenter.append('rect').attr('class', 'left').attr('x', 0).attr('y', 0).attr('height', availableHeight2);
                brushBGenter.append('rect').attr('class', 'right').attr('x', 0).attr('y', 0).attr('height', availableHeight2);
                var gBrush = g.select('.nv-x.nv-brush').call(brush);
                gBrush.selectAll('rect')//.attr('y', -5)
                .attr('height', availableHeight2);
                gBrush.selectAll('.resize').append('path').attr('d', resizePath);
                onBrush();
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup Secondary (Context) Axes
                x2Axis.scale(x2).ticks(availableWidth / 100).tickSize(-availableHeight2, 0);
                g.select('.nv-context .nv-x.nv-axis').attr('transform', 'translate(0,' + y2.range()[0] + ')');
                $9175b321012dc0d3$var$d3.transition(g.select('.nv-context .nv-x.nv-axis')).call(x2Axis);
                y2Axis.scale(y2).ticks(availableHeight2 / 36).tickSize(-availableWidth, 0);
                $9175b321012dc0d3$var$d3.transition(g.select('.nv-context .nv-y.nv-axis')).call(y2Axis);
                g.select('.nv-context .nv-x.nv-axis').attr('transform', 'translate(0,' + y2.range()[0] + ')');
                //------------------------------------------------------------
                //============================================================
                // Event Handling/Dispatching (in chart's scope)
                //------------------------------------------------------------
                legend.dispatch.on('stateChange', function(newState) {
                    chart.update();
                });
                dispatch.on('tooltipShow', function(e) {
                    if (tooltips) showTooltip(e, that.parentNode);
                });
                //============================================================
                //============================================================
                // Functions
                //------------------------------------------------------------
                // Taken from crossfilter (http://square.github.com/crossfilter/)
                function resizePath(d) {
                    var e = +(d == 'e'), x = e ? 1 : -1, y = availableHeight2 / 3;
                    return 'M' + .5 * x + ',' + y + 'A6,6 0 0 ' + e + ' ' + 6.5 * x + ',' + (y + 6) + 'V' + (2 * y - 6) + 'A6,6 0 0 ' + e + ' ' + .5 * x + ',' + 2 * y + 'Z' + 'M' + 2.5 * x + ',' + (y + 8) + 'V' + (2 * y - 8) + 'M' + 4.5 * x + ',' + (y + 8) + 'V' + (2 * y - 8);
                }
                function updateBrushBG() {
                    if (!brush.empty()) brush.extent(brushExtent);
                    brushBG.data([
                        brush.empty() ? x2.domain() : brushExtent
                    ]).each(function(d, i) {
                        var leftWidth = x2(d[0]) - x.range()[0], rightWidth = x.range()[1] - x2(d[1]);
                        $9175b321012dc0d3$var$d3.select(this).select('.left').attr('width', leftWidth < 0 ? 0 : leftWidth);
                        $9175b321012dc0d3$var$d3.select(this).select('.right').attr('x', x2(d[1])).attr('width', rightWidth < 0 ? 0 : rightWidth);
                    });
                }
                function onBrush() {
                    brushExtent = brush.empty() ? null : brush.extent();
                    var extent = brush.empty() ? x2.domain() : brush.extent();
                    //The brush extent cannot be less than one.  If it is, don't update the line chart.
                    if (Math.abs(extent[0] - extent[1]) <= 1) return;
                    dispatch.brush({
                        extent: extent,
                        brush: brush
                    });
                    updateBrushBG();
                    // Update Main (Focus)
                    var focusLinesWrap = g.select('.nv-focus .nv-linesWrap').datum(data.filter(function(d) {
                        return !d.disabled;
                    }).map(function(d, i) {
                        return {
                            key: d.key,
                            values: d.values.filter(function(d, i) {
                                return lines.x()(d, i) >= extent[0] && lines.x()(d, i) <= extent[1];
                            })
                        };
                    }));
                    focusLinesWrap.transition().duration(transitionDuration).call(lines);
                    // Update Main (Focus) Axes
                    g.select('.nv-focus .nv-x.nv-axis').transition().duration(transitionDuration).call(xAxis);
                    g.select('.nv-focus .nv-y.nv-axis').transition().duration(transitionDuration).call(yAxis);
                }
            //============================================================
            });
            return chart;
        }
        //============================================================
        // Event Handling/Dispatching (out of chart's scope)
        //------------------------------------------------------------
        lines.dispatch.on('elementMouseover.tooltip', function(e) {
            e.pos = [
                e.pos[0] + margin.left,
                e.pos[1] + margin.top
            ];
            dispatch.tooltipShow(e);
        });
        lines.dispatch.on('elementMouseout.tooltip', function(e) {
            dispatch.tooltipHide(e);
        });
        dispatch.on('tooltipHide', function() {
            if (tooltips) nv.tooltip.cleanup();
        });
        //============================================================
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        // expose chart's sub-components
        chart.dispatch = dispatch;
        chart.legend = legend;
        chart.lines = lines;
        chart.lines2 = lines2;
        chart.xAxis = xAxis;
        chart.yAxis = yAxis;
        chart.x2Axis = x2Axis;
        chart.y2Axis = y2Axis;
        $9175b321012dc0d3$var$d3.rebind(chart, lines, 'defined', 'isArea', 'size', 'xDomain', 'yDomain', 'xRange', 'yRange', 'forceX', 'forceY', 'interactive', 'clipEdge', 'clipVoronoi', 'id');
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.x = function(_) {
            if (!arguments.length) return lines.x;
            lines.x(_);
            lines2.x(_);
            return chart;
        };
        chart.y = function(_) {
            if (!arguments.length) return lines.y;
            lines.y(_);
            lines2.y(_);
            return chart;
        };
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.margin2 = function(_) {
            if (!arguments.length) return margin2;
            margin2 = _;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.height2 = function(_) {
            if (!arguments.length) return height2;
            height2 = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = nv.utils.getColor(_);
            legend.color(color);
            return chart;
        };
        chart.showLegend = function(_) {
            if (!arguments.length) return showLegend;
            showLegend = _;
            return chart;
        };
        chart.tooltips = function(_) {
            if (!arguments.length) return tooltips;
            tooltips = _;
            return chart;
        };
        chart.tooltipContent = function(_) {
            if (!arguments.length) return tooltip;
            tooltip = _;
            return chart;
        };
        chart.interpolate = function(_) {
            if (!arguments.length) return lines.interpolate();
            lines.interpolate(_);
            lines2.interpolate(_);
            return chart;
        };
        chart.noData = function(_) {
            if (!arguments.length) return noData;
            noData = _;
            return chart;
        };
        // Chart has multiple similar Axes, to prevent code duplication, probably need to link all axis functions manually like below
        chart.xTickFormat = function(_) {
            if (!arguments.length) return xAxis.tickFormat();
            xAxis.tickFormat(_);
            x2Axis.tickFormat(_);
            return chart;
        };
        chart.yTickFormat = function(_) {
            if (!arguments.length) return yAxis.tickFormat();
            yAxis.tickFormat(_);
            y2Axis.tickFormat(_);
            return chart;
        };
        chart.brushExtent = function(_) {
            if (!arguments.length) return brushExtent;
            brushExtent = _;
            return chart;
        };
        chart.transitionDuration = function(_) {
            if (!arguments.length) return transitionDuration;
            transitionDuration = _;
            return chart;
        };
        //============================================================
        return chart;
    };
    nv.models.linePlusBarWithFocusChart = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var lines = nv.models.line(), lines2 = nv.models.line(), bars = nv.models.historicalBar(), bars2 = nv.models.historicalBar(), xAxis = nv.models.axis(), x2Axis = nv.models.axis(), y1Axis = nv.models.axis(), y2Axis = nv.models.axis(), y3Axis = nv.models.axis(), y4Axis = nv.models.axis(), legend = nv.models.legend(), brush = $9175b321012dc0d3$var$d3.svg.brush();
        var margin = {
            top: 30,
            right: 30,
            bottom: 30,
            left: 60
        }, margin2 = {
            top: 0,
            right: 30,
            bottom: 20,
            left: 60
        }, width = null, height = null, height2 = 100, getX1 = function(d) {
            return d.x;
        }, getY1 = function(d) {
            return d.y;
        }, color = nv.utils.defaultColor(), showLegend = true, extent, brushExtent = null, tooltips = true, tooltip = function(key, x, y, e, graph) {
            return '<h3>' + key + '</h3>' + '<p>' + y + ' at ' + x + '</p>';
        }, x, x2, y1, y2, y3, y4, noData = "No Data Available.", dispatch = $9175b321012dc0d3$var$d3.dispatch('tooltipShow', 'tooltipHide', 'brush'), transitionDuration = 0;
        lines.clipEdge(true);
        lines2.interactive(false);
        xAxis.orient('bottom').tickPadding(5);
        y1Axis.orient('left');
        y2Axis.orient('right');
        x2Axis.orient('bottom').tickPadding(5);
        y3Axis.orient('left');
        y4Axis.orient('right');
        //============================================================
        //============================================================
        // Private Variables
        //------------------------------------------------------------
        var showTooltip = function(e, offsetElement) {
            if (extent) e.pointIndex += Math.ceil(extent[0]);
            var left = e.pos[0] + (offsetElement.offsetLeft || 0), top = e.pos[1] + (offsetElement.offsetTop || 0), x = xAxis.tickFormat()(lines.x()(e.point, e.pointIndex)), y = (e.series.bar ? y1Axis : y2Axis).tickFormat()(lines.y()(e.point, e.pointIndex)), content = tooltip(e.series.key, x, y, e, chart);
            nv.tooltip.show([
                left,
                top
            ], content, e.value < 0 ? 'n' : 's', null, offsetElement);
        };
        //------------------------------------------------------------
        function chart(selection) {
            selection.each(function(data) {
                var container = $9175b321012dc0d3$var$d3.select(this), that = this;
                var availableWidth = (width || parseInt(container.style('width')) || 960) - margin.left - margin.right, availableHeight1 = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom - height2, availableHeight2 = height2 - margin2.top - margin2.bottom;
                chart.update = function() {
                    container.transition().duration(transitionDuration).call(chart);
                };
                chart.container = this;
                //------------------------------------------------------------
                // Display No Data message if there's nothing to show.
                if (!data || !data.length || !data.filter(function(d) {
                    return d.values.length;
                }).length) {
                    var noDataText = container.selectAll('.nv-noData').data([
                        noData
                    ]);
                    noDataText.enter().append('text').attr('class', 'nvd3 nv-noData').attr('dy', '-.7em').style('text-anchor', 'middle');
                    noDataText.attr('x', margin.left + availableWidth / 2).attr('y', margin.top + availableHeight1 / 2).text(function(d) {
                        return d;
                    });
                    return chart;
                } else container.selectAll('.nv-noData').remove();
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup Scales
                var dataBars = data.filter(function(d) {
                    return !d.disabled && d.bar;
                });
                var dataLines = data.filter(function(d) {
                    return !d.bar;
                }); // removed the !d.disabled clause here to fix Issue #240
                x = bars.xScale();
                x2 = x2Axis.scale();
                y1 = bars.yScale();
                y2 = lines.yScale();
                y3 = bars2.yScale();
                y4 = lines2.yScale();
                var series1 = data.filter(function(d) {
                    return !d.disabled && d.bar;
                }).map(function(d) {
                    return d.values.map(function(d, i) {
                        return {
                            x: getX1(d, i),
                            y: getY1(d, i)
                        };
                    });
                });
                var series2 = data.filter(function(d) {
                    return !d.disabled && !d.bar;
                }).map(function(d) {
                    return d.values.map(function(d, i) {
                        return {
                            x: getX1(d, i),
                            y: getY1(d, i)
                        };
                    });
                });
                x.range([
                    0,
                    availableWidth
                ]);
                x2.domain($9175b321012dc0d3$var$d3.extent($9175b321012dc0d3$var$d3.merge(series1.concat(series2)), function(d) {
                    return d.x;
                })).range([
                    0,
                    availableWidth
                ]);
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = container.selectAll('g.nv-wrap.nv-linePlusBar').data([
                    data
                ]);
                var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-linePlusBar').append('g');
                var g = wrap.select('g');
                gEnter.append('g').attr('class', 'nv-legendWrap');
                var focusEnter = gEnter.append('g').attr('class', 'nv-focus');
                focusEnter.append('g').attr('class', 'nv-x nv-axis');
                focusEnter.append('g').attr('class', 'nv-y1 nv-axis');
                focusEnter.append('g').attr('class', 'nv-y2 nv-axis');
                focusEnter.append('g').attr('class', 'nv-barsWrap');
                focusEnter.append('g').attr('class', 'nv-linesWrap');
                var contextEnter = gEnter.append('g').attr('class', 'nv-context');
                contextEnter.append('g').attr('class', 'nv-x nv-axis');
                contextEnter.append('g').attr('class', 'nv-y1 nv-axis');
                contextEnter.append('g').attr('class', 'nv-y2 nv-axis');
                contextEnter.append('g').attr('class', 'nv-barsWrap');
                contextEnter.append('g').attr('class', 'nv-linesWrap');
                contextEnter.append('g').attr('class', 'nv-brushBackground');
                contextEnter.append('g').attr('class', 'nv-x nv-brush');
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Legend
                if (showLegend) {
                    legend.width(availableWidth / 2);
                    g.select('.nv-legendWrap').datum(data.map(function(series) {
                        series.originalKey = series.originalKey === undefined ? series.key : series.originalKey;
                        series.key = series.originalKey + (series.bar ? ' (left axis)' : ' (right axis)');
                        return series;
                    })).call(legend);
                    if (margin.top != legend.height()) {
                        margin.top = legend.height();
                        availableHeight1 = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom - height2;
                    }
                    g.select('.nv-legendWrap').attr('transform', 'translate(' + availableWidth / 2 + ',' + -margin.top + ')');
                }
                //------------------------------------------------------------
                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                //------------------------------------------------------------
                // Context Components
                bars2.width(availableWidth).height(availableHeight2).color(data.map(function(d, i) {
                    return d.color || color(d, i);
                }).filter(function(d, i) {
                    return !data[i].disabled && data[i].bar;
                }));
                lines2.width(availableWidth).height(availableHeight2).color(data.map(function(d, i) {
                    return d.color || color(d, i);
                }).filter(function(d, i) {
                    return !data[i].disabled && !data[i].bar;
                }));
                var bars2Wrap = g.select('.nv-context .nv-barsWrap').datum(dataBars.length ? dataBars : [
                    {
                        values: []
                    }
                ]);
                var lines2Wrap = g.select('.nv-context .nv-linesWrap').datum(!dataLines[0].disabled ? dataLines : [
                    {
                        values: []
                    }
                ]);
                g.select('.nv-context').attr('transform', 'translate(0,' + (availableHeight1 + margin.bottom + margin2.top) + ')');
                bars2Wrap.transition().call(bars2);
                lines2Wrap.transition().call(lines2);
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup Brush
                brush.x(x2).on('brush', onBrush);
                if (brushExtent) brush.extent(brushExtent);
                var brushBG = g.select('.nv-brushBackground').selectAll('g').data([
                    brushExtent || brush.extent()
                ]);
                var brushBGenter = brushBG.enter().append('g');
                brushBGenter.append('rect').attr('class', 'left').attr('x', 0).attr('y', 0).attr('height', availableHeight2);
                brushBGenter.append('rect').attr('class', 'right').attr('x', 0).attr('y', 0).attr('height', availableHeight2);
                var gBrush = g.select('.nv-x.nv-brush').call(brush);
                gBrush.selectAll('rect')//.attr('y', -5)
                .attr('height', availableHeight2);
                gBrush.selectAll('.resize').append('path').attr('d', resizePath);
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup Secondary (Context) Axes
                x2Axis.ticks(availableWidth / 100).tickSize(-availableHeight2, 0);
                g.select('.nv-context .nv-x.nv-axis').attr('transform', 'translate(0,' + y3.range()[0] + ')');
                g.select('.nv-context .nv-x.nv-axis').transition().call(x2Axis);
                y3Axis.scale(y3).ticks(availableHeight2 / 36).tickSize(-availableWidth, 0);
                g.select('.nv-context .nv-y1.nv-axis').style('opacity', dataBars.length ? 1 : 0).attr('transform', 'translate(0,' + x2.range()[0] + ')');
                g.select('.nv-context .nv-y1.nv-axis').transition().call(y3Axis);
                y4Axis.scale(y4).ticks(availableHeight2 / 36).tickSize(dataBars.length ? 0 : -availableWidth, 0); // Show the y2 rules only if y1 has none
                g.select('.nv-context .nv-y2.nv-axis').style('opacity', dataLines.length ? 1 : 0).attr('transform', 'translate(' + x2.range()[1] + ',0)');
                g.select('.nv-context .nv-y2.nv-axis').transition().call(y4Axis);
                //------------------------------------------------------------
                //============================================================
                // Event Handling/Dispatching (in chart's scope)
                //------------------------------------------------------------
                legend.dispatch.on('stateChange', function(newState) {
                    chart.update();
                });
                dispatch.on('tooltipShow', function(e) {
                    if (tooltips) showTooltip(e, that.parentNode);
                });
                //============================================================
                //============================================================
                // Functions
                //------------------------------------------------------------
                // Taken from crossfilter (http://square.github.com/crossfilter/)
                function resizePath(d) {
                    var e = +(d == 'e'), x = e ? 1 : -1, y = availableHeight2 / 3;
                    return 'M' + .5 * x + ',' + y + 'A6,6 0 0 ' + e + ' ' + 6.5 * x + ',' + (y + 6) + 'V' + (2 * y - 6) + 'A6,6 0 0 ' + e + ' ' + .5 * x + ',' + 2 * y + 'Z' + 'M' + 2.5 * x + ',' + (y + 8) + 'V' + (2 * y - 8) + 'M' + 4.5 * x + ',' + (y + 8) + 'V' + (2 * y - 8);
                }
                function updateBrushBG() {
                    if (!brush.empty()) brush.extent(brushExtent);
                    brushBG.data([
                        brush.empty() ? x2.domain() : brushExtent
                    ]).each(function(d, i) {
                        var leftWidth = x2(d[0]) - x2.range()[0], rightWidth = x2.range()[1] - x2(d[1]);
                        $9175b321012dc0d3$var$d3.select(this).select('.left').attr('width', leftWidth < 0 ? 0 : leftWidth);
                        $9175b321012dc0d3$var$d3.select(this).select('.right').attr('x', x2(d[1])).attr('width', rightWidth < 0 ? 0 : rightWidth);
                    });
                }
                function onBrush() {
                    brushExtent = brush.empty() ? null : brush.extent();
                    extent = brush.empty() ? x2.domain() : brush.extent();
                    dispatch.brush({
                        extent: extent,
                        brush: brush
                    });
                    updateBrushBG();
                    //------------------------------------------------------------
                    // Prepare Main (Focus) Bars and Lines
                    bars.width(availableWidth).height(availableHeight1).color(data.map(function(d, i) {
                        return d.color || color(d, i);
                    }).filter(function(d, i) {
                        return !data[i].disabled && data[i].bar;
                    }));
                    lines.width(availableWidth).height(availableHeight1).color(data.map(function(d, i) {
                        return d.color || color(d, i);
                    }).filter(function(d, i) {
                        return !data[i].disabled && !data[i].bar;
                    }));
                    var focusBarsWrap = g.select('.nv-focus .nv-barsWrap').datum(!dataBars.length ? [
                        {
                            values: []
                        }
                    ] : dataBars.map(function(d, i) {
                        return {
                            key: d.key,
                            values: d.values.filter(function(d, i) {
                                return bars.x()(d, i) >= extent[0] && bars.x()(d, i) <= extent[1];
                            })
                        };
                    }));
                    var focusLinesWrap = g.select('.nv-focus .nv-linesWrap').datum(dataLines[0].disabled ? [
                        {
                            values: []
                        }
                    ] : dataLines.map(function(d, i) {
                        return {
                            key: d.key,
                            values: d.values.filter(function(d, i) {
                                return lines.x()(d, i) >= extent[0] && lines.x()(d, i) <= extent[1];
                            })
                        };
                    }));
                    //------------------------------------------------------------
                    //------------------------------------------------------------
                    // Update Main (Focus) X Axis
                    if (dataBars.length) x = bars.xScale();
                    else x = lines.xScale();
                    xAxis.scale(x).ticks(availableWidth / 100).tickSize(-availableHeight1, 0);
                    xAxis.domain([
                        Math.ceil(extent[0]),
                        Math.floor(extent[1])
                    ]);
                    g.select('.nv-x.nv-axis').transition().duration(transitionDuration).call(xAxis);
                    //------------------------------------------------------------
                    //------------------------------------------------------------
                    // Update Main (Focus) Bars and Lines
                    focusBarsWrap.transition().duration(transitionDuration).call(bars);
                    focusLinesWrap.transition().duration(transitionDuration).call(lines);
                    //------------------------------------------------------------
                    //------------------------------------------------------------
                    // Setup and Update Main (Focus) Y Axes
                    g.select('.nv-focus .nv-x.nv-axis').attr('transform', 'translate(0,' + y1.range()[0] + ')');
                    y1Axis.scale(y1).ticks(availableHeight1 / 36).tickSize(-availableWidth, 0);
                    g.select('.nv-focus .nv-y1.nv-axis').style('opacity', dataBars.length ? 1 : 0);
                    y2Axis.scale(y2).ticks(availableHeight1 / 36).tickSize(dataBars.length ? 0 : -availableWidth, 0); // Show the y2 rules only if y1 has none
                    g.select('.nv-focus .nv-y2.nv-axis').style('opacity', dataLines.length ? 1 : 0).attr('transform', 'translate(' + x.range()[1] + ',0)');
                    g.select('.nv-focus .nv-y1.nv-axis').transition().duration(transitionDuration).call(y1Axis);
                    g.select('.nv-focus .nv-y2.nv-axis').transition().duration(transitionDuration).call(y2Axis);
                }
                //============================================================
                onBrush();
            });
            return chart;
        }
        //============================================================
        // Event Handling/Dispatching (out of chart's scope)
        //------------------------------------------------------------
        lines.dispatch.on('elementMouseover.tooltip', function(e) {
            e.pos = [
                e.pos[0] + margin.left,
                e.pos[1] + margin.top
            ];
            dispatch.tooltipShow(e);
        });
        lines.dispatch.on('elementMouseout.tooltip', function(e) {
            dispatch.tooltipHide(e);
        });
        bars.dispatch.on('elementMouseover.tooltip', function(e) {
            e.pos = [
                e.pos[0] + margin.left,
                e.pos[1] + margin.top
            ];
            dispatch.tooltipShow(e);
        });
        bars.dispatch.on('elementMouseout.tooltip', function(e) {
            dispatch.tooltipHide(e);
        });
        dispatch.on('tooltipHide', function() {
            if (tooltips) nv.tooltip.cleanup();
        });
        //============================================================
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        // expose chart's sub-components
        chart.dispatch = dispatch;
        chart.legend = legend;
        chart.lines = lines;
        chart.lines2 = lines2;
        chart.bars = bars;
        chart.bars2 = bars2;
        chart.xAxis = xAxis;
        chart.x2Axis = x2Axis;
        chart.y1Axis = y1Axis;
        chart.y2Axis = y2Axis;
        chart.y3Axis = y3Axis;
        chart.y4Axis = y4Axis;
        $9175b321012dc0d3$var$d3.rebind(chart, lines, 'defined', 'size', 'clipVoronoi', 'interpolate');
        //TODO: consider rebinding x, y and some other stuff, and simply do soemthign lile bars.x(lines.x()), etc.
        //d3.rebind(chart, lines, 'x', 'y', 'size', 'xDomain', 'yDomain', 'xRange', 'yRange', 'forceX', 'forceY', 'interactive', 'clipEdge', 'clipVoronoi', 'id');
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.x = function(_) {
            if (!arguments.length) return getX1;
            getX1 = _;
            lines.x(_);
            bars.x(_);
            return chart;
        };
        chart.y = function(_) {
            if (!arguments.length) return getY1;
            getY1 = _;
            lines.y(_);
            bars.y(_);
            return chart;
        };
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = nv.utils.getColor(_);
            legend.color(color);
            return chart;
        };
        chart.showLegend = function(_) {
            if (!arguments.length) return showLegend;
            showLegend = _;
            return chart;
        };
        chart.tooltips = function(_) {
            if (!arguments.length) return tooltips;
            tooltips = _;
            return chart;
        };
        chart.tooltipContent = function(_) {
            if (!arguments.length) return tooltip;
            tooltip = _;
            return chart;
        };
        chart.noData = function(_) {
            if (!arguments.length) return noData;
            noData = _;
            return chart;
        };
        chart.brushExtent = function(_) {
            if (!arguments.length) return brushExtent;
            brushExtent = _;
            return chart;
        };
        //============================================================
        return chart;
    };
    nv.models.multiBar = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var margin = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }, width = 960, height = 500, x = $9175b321012dc0d3$var$d3.scale.ordinal(), y = $9175b321012dc0d3$var$d3.scale.linear(), id = Math.floor(Math.random() * 10000) //Create semi-unique ID in case user doesn't select one
        , getX1 = function(d) {
            return d.x;
        }, getY1 = function(d) {
            return d.y;
        }, forceY = [
            0
        ] // 0 is forced by default.. this makes sense for the majority of bar graphs... user can always do chart.forceY([]) to remove
        , clipEdge = true, stacked = false, color = nv.utils.defaultColor(), hideable = false, barColor = null // adding the ability to set the color for each rather than the whole group
        , disabled // used in conjunction with barColor to communicate from multiBarHorizontalChart what series are disabled
        , delay = 1200, xDomain, yDomain, xRange, yRange, groupSpacing = 0.1, dispatch = $9175b321012dc0d3$var$d3.dispatch('chartClick', 'elementClick', 'elementDblClick', 'elementMouseover', 'elementMouseout');
        //============================================================
        //============================================================
        // Private Variables
        //------------------------------------------------------------
        var x0, y0 //used to store previous scales
        ;
        //============================================================
        function chart(selection) {
            selection.each(function(data) {
                var availableWidth = width - margin.left - margin.right, availableHeight = height - margin.top - margin.bottom, container = $9175b321012dc0d3$var$d3.select(this);
                if (hideable && data.length) hideable = [
                    {
                        values: data[0].values.map(function(d) {
                            return {
                                x: d.x,
                                y: 0,
                                series: d.series,
                                size: 0.01
                            };
                        })
                    }
                ];
                if (stacked) data = $9175b321012dc0d3$var$d3.layout.stack().offset('zero').values(function(d) {
                    return d.values;
                }).y(getY1)(!data.length && hideable ? hideable : data);
                //add series index to each data point for reference
                data = data.map(function(series, i) {
                    series.values = series.values.map(function(point) {
                        point.series = i;
                        return point;
                    });
                    return series;
                });
                //------------------------------------------------------------
                // HACK for negative value stacking
                if (stacked) data[0].values.map(function(d, i) {
                    var posBase = 0, negBase = 0;
                    data.map(function(d) {
                        var f = d.values[i];
                        f.size = Math.abs(f.y);
                        if (f.y < 0) {
                            f.y1 = negBase;
                            negBase = negBase - f.size;
                        } else {
                            f.y1 = f.size + posBase;
                            posBase = posBase + f.size;
                        }
                    });
                });
                //------------------------------------------------------------
                // Setup Scales
                // remap and flatten the data for use in calculating the scales' domains
                var seriesData = xDomain && yDomain ? [] : data.map(function(d) {
                    return d.values.map(function(d, i) {
                        return {
                            x: getX1(d, i),
                            y: getY1(d, i),
                            y0: d.y0,
                            y1: d.y1
                        };
                    });
                });
                x.domain(xDomain || $9175b321012dc0d3$var$d3.merge(seriesData).map(function(d) {
                    return d.x;
                })).rangeBands(xRange || [
                    0,
                    availableWidth
                ], groupSpacing);
                //y   .domain(yDomain || d3.extent(d3.merge(seriesData).map(function(d) { return d.y + (stacked ? d.y1 : 0) }).concat(forceY)))
                y.domain(yDomain || $9175b321012dc0d3$var$d3.extent($9175b321012dc0d3$var$d3.merge(seriesData).map(function(d) {
                    return stacked ? d.y > 0 ? d.y1 : d.y1 + d.y : d.y;
                }).concat(forceY))).range(yRange || [
                    availableHeight,
                    0
                ]);
                // If scale's domain don't have a range, slightly adjust to make one... so a chart can show a single data point
                if (x.domain()[0] === x.domain()[1]) x.domain()[0] ? x.domain([
                    x.domain()[0] - x.domain()[0] * 0.01,
                    x.domain()[1] + x.domain()[1] * 0.01
                ]) : x.domain([
                    -1,
                    1
                ]);
                if (y.domain()[0] === y.domain()[1]) y.domain()[0] ? y.domain([
                    y.domain()[0] + y.domain()[0] * 0.01,
                    y.domain()[1] - y.domain()[1] * 0.01
                ]) : y.domain([
                    -1,
                    1
                ]);
                x0 = x0 || x;
                y0 = y0 || y;
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = container.selectAll('g.nv-wrap.nv-multibar').data([
                    data
                ]);
                var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-multibar');
                var defsEnter = wrapEnter.append('defs');
                var gEnter = wrapEnter.append('g');
                var g = wrap.select('g');
                gEnter.append('g').attr('class', 'nv-groups');
                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                //------------------------------------------------------------
                defsEnter.append('clipPath').attr('id', 'nv-edge-clip-' + id).append('rect');
                wrap.select('#nv-edge-clip-' + id + ' rect').attr('width', availableWidth).attr('height', availableHeight);
                g.attr('clip-path', clipEdge ? 'url(#nv-edge-clip-' + id + ')' : '');
                var groups = wrap.select('.nv-groups').selectAll('.nv-group').data(function(d) {
                    return d;
                }, function(d, i) {
                    return i;
                });
                groups.enter().append('g').style('stroke-opacity', 1e-6).style('fill-opacity', 1e-6);
                groups.exit().transition().selectAll('rect.nv-bar').delay(function(d, i) {
                    return i * delay / data[0].values.length;
                }).attr('y', function(d) {
                    return stacked ? y0(d.y0) : y0(0);
                }).attr('height', 0).remove();
                groups.attr('class', function(d, i) {
                    return 'nv-group nv-series-' + i;
                }).classed('hover', function(d) {
                    return d.hover;
                }).style('fill', function(d, i) {
                    return color(d, i);
                }).style('stroke', function(d, i) {
                    return color(d, i);
                });
                groups.transition().style('stroke-opacity', 1).style('fill-opacity', .75);
                var bars = groups.selectAll('rect.nv-bar').data(function(d) {
                    return hideable && !data.length ? hideable.values : d.values;
                });
                bars.exit().remove();
                var barsEnter = bars.enter().append('rect').attr('class', function(d, i) {
                    return getY1(d, i) < 0 ? 'nv-bar negative' : 'nv-bar positive';
                }).attr('x', function(d, i, j) {
                    return stacked ? 0 : j * x.rangeBand() / data.length;
                }).attr('y', function(d) {
                    return y0(stacked ? d.y0 : 0);
                }).attr('height', 0).attr('width', x.rangeBand() / (stacked ? 1 : data.length)).attr('transform', function(d, i) {
                    return 'translate(' + x(getX1(d, i)) + ',0)';
                });
                bars.style('fill', function(d, i, j) {
                    return color(d, j, i);
                }).style('stroke', function(d, i, j) {
                    return color(d, j, i);
                }).on('mouseover', function(d, i) {
                    $9175b321012dc0d3$var$d3.select(this).classed('hover', true);
                    dispatch.elementMouseover({
                        value: getY1(d, i),
                        point: d,
                        series: data[d.series],
                        pos: [
                            x(getX1(d, i)) + x.rangeBand() * (stacked ? data.length / 2 : d.series + .5) / data.length,
                            y(getY1(d, i) + (stacked ? d.y0 : 0))
                        ],
                        pointIndex: i,
                        seriesIndex: d.series,
                        e: $9175b321012dc0d3$var$d3.event
                    });
                }).on('mouseout', function(d, i) {
                    $9175b321012dc0d3$var$d3.select(this).classed('hover', false);
                    dispatch.elementMouseout({
                        value: getY1(d, i),
                        point: d,
                        series: data[d.series],
                        pointIndex: i,
                        seriesIndex: d.series,
                        e: $9175b321012dc0d3$var$d3.event
                    });
                }).on('click', function(d, i) {
                    dispatch.elementClick({
                        value: getY1(d, i),
                        point: d,
                        series: data[d.series],
                        pos: [
                            x(getX1(d, i)) + x.rangeBand() * (stacked ? data.length / 2 : d.series + .5) / data.length,
                            y(getY1(d, i) + (stacked ? d.y0 : 0))
                        ],
                        pointIndex: i,
                        seriesIndex: d.series,
                        e: $9175b321012dc0d3$var$d3.event
                    });
                    $9175b321012dc0d3$var$d3.event.stopPropagation();
                }).on('dblclick', function(d, i) {
                    dispatch.elementDblClick({
                        value: getY1(d, i),
                        point: d,
                        series: data[d.series],
                        pos: [
                            x(getX1(d, i)) + x.rangeBand() * (stacked ? data.length / 2 : d.series + .5) / data.length,
                            y(getY1(d, i) + (stacked ? d.y0 : 0))
                        ],
                        pointIndex: i,
                        seriesIndex: d.series,
                        e: $9175b321012dc0d3$var$d3.event
                    });
                    $9175b321012dc0d3$var$d3.event.stopPropagation();
                });
                bars.attr('class', function(d, i) {
                    return getY1(d, i) < 0 ? 'nv-bar negative' : 'nv-bar positive';
                }).transition().attr('transform', function(d, i) {
                    return 'translate(' + x(getX1(d, i)) + ',0)';
                });
                if (barColor) {
                    if (!disabled) disabled = data.map(function() {
                        return true;
                    });
                    bars.style('fill', function(d, i, j) {
                        return $9175b321012dc0d3$var$d3.rgb(barColor(d, i)).darker(disabled.map(function(d, i) {
                            return i;
                        }).filter(function(d, i) {
                            return !disabled[i];
                        })[j]).toString();
                    }).style('stroke', function(d, i, j) {
                        return $9175b321012dc0d3$var$d3.rgb(barColor(d, i)).darker(disabled.map(function(d, i) {
                            return i;
                        }).filter(function(d, i) {
                            return !disabled[i];
                        })[j]).toString();
                    });
                }
                if (stacked) bars.transition().delay(function(d, i) {
                    return i * delay / data[0].values.length;
                }).attr('y', function(d, i) {
                    return y(stacked ? d.y1 : 0);
                }).attr('height', function(d, i) {
                    return Math.max(Math.abs(y(d.y + (stacked ? d.y0 : 0)) - y(stacked ? d.y0 : 0)), 1);
                }).attr('x', function(d, i) {
                    return stacked ? 0 : d.series * x.rangeBand() / data.length;
                }).attr('width', x.rangeBand() / (stacked ? 1 : data.length));
                else bars.transition().delay(function(d, i) {
                    return i * delay / data[0].values.length;
                }).attr('x', function(d, i) {
                    return d.series * x.rangeBand() / data.length;
                }).attr('width', x.rangeBand() / data.length).attr('y', function(d, i) {
                    return getY1(d, i) < 0 ? y(0) : y(0) - y(getY1(d, i)) < 1 ? y(0) - 1 : y(getY1(d, i)) || 0;
                }).attr('height', function(d, i) {
                    return Math.max(Math.abs(y(getY1(d, i)) - y(0)), 1) || 0;
                });
                //store old scales for use in transitions on update
                x0 = x.copy();
                y0 = y.copy();
            });
            return chart;
        }
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        chart.dispatch = dispatch;
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.x = function(_) {
            if (!arguments.length) return getX1;
            getX1 = _;
            return chart;
        };
        chart.y = function(_) {
            if (!arguments.length) return getY1;
            getY1 = _;
            return chart;
        };
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.xScale = function(_) {
            if (!arguments.length) return x;
            x = _;
            return chart;
        };
        chart.yScale = function(_) {
            if (!arguments.length) return y;
            y = _;
            return chart;
        };
        chart.xDomain = function(_) {
            if (!arguments.length) return xDomain;
            xDomain = _;
            return chart;
        };
        chart.yDomain = function(_) {
            if (!arguments.length) return yDomain;
            yDomain = _;
            return chart;
        };
        chart.xRange = function(_) {
            if (!arguments.length) return xRange;
            xRange = _;
            return chart;
        };
        chart.yRange = function(_) {
            if (!arguments.length) return yRange;
            yRange = _;
            return chart;
        };
        chart.forceY = function(_) {
            if (!arguments.length) return forceY;
            forceY = _;
            return chart;
        };
        chart.stacked = function(_) {
            if (!arguments.length) return stacked;
            stacked = _;
            return chart;
        };
        chart.clipEdge = function(_) {
            if (!arguments.length) return clipEdge;
            clipEdge = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = nv.utils.getColor(_);
            return chart;
        };
        chart.barColor = function(_) {
            if (!arguments.length) return barColor;
            barColor = nv.utils.getColor(_);
            return chart;
        };
        chart.disabled = function(_) {
            if (!arguments.length) return disabled;
            disabled = _;
            return chart;
        };
        chart.id = function(_) {
            if (!arguments.length) return id;
            id = _;
            return chart;
        };
        chart.hideable = function(_) {
            if (!arguments.length) return hideable;
            hideable = _;
            return chart;
        };
        chart.delay = function(_) {
            if (!arguments.length) return delay;
            delay = _;
            return chart;
        };
        chart.groupSpacing = function(_) {
            if (!arguments.length) return groupSpacing;
            groupSpacing = _;
            return chart;
        };
        //============================================================
        return chart;
    };
    nv.models.multiBarChart = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var multibar = nv.models.multiBar(), xAxis = nv.models.axis(), yAxis = nv.models.axis(), legend = nv.models.legend(), controls = nv.models.legend();
        var margin = {
            top: 30,
            right: 20,
            bottom: 50,
            left: 60
        }, width = null, height = null, color = nv.utils.defaultColor(), showControls = true, showLegend = true, showXAxis = true, showYAxis = true, rightAlignYAxis = false, reduceXTicks = true // if false a tick will show for every data point
        , staggerLabels = false, rotateLabels = 0, tooltips = true, tooltip = function(key, x, y, e, graph) {
            return '<h3>' + key + '</h3>' + '<p>' + y + ' on ' + x + '</p>';
        }, x //can be accessed via chart.xScale()
        , y //can be accessed via chart.yScale()
        , state = {
            stacked: false
        }, defaultState = null, noData = "No Data Available.", dispatch = $9175b321012dc0d3$var$d3.dispatch('tooltipShow', 'tooltipHide', 'stateChange', 'changeState'), controlWidth = function() {
            return showControls ? 180 : 0;
        }, transitionDuration = 250;
        multibar.stacked(false);
        xAxis.orient('bottom').tickPadding(7).highlightZero(true).showMaxMin(false).tickFormat(function(d) {
            return d;
        });
        yAxis.orient(rightAlignYAxis ? 'right' : 'left').tickFormat($9175b321012dc0d3$var$d3.format(',.1f'));
        controls.updateState(false);
        //============================================================
        //============================================================
        // Private Variables
        //------------------------------------------------------------
        var showTooltip = function(e, offsetElement) {
            var left = e.pos[0] + (offsetElement.offsetLeft || 0), top = e.pos[1] + (offsetElement.offsetTop || 0), x = xAxis.tickFormat()(multibar.x()(e.point, e.pointIndex)), y = yAxis.tickFormat()(multibar.y()(e.point, e.pointIndex)), content = tooltip(e.series.key, x, y, e, chart);
            nv.tooltip.show([
                left,
                top
            ], content, e.value < 0 ? 'n' : 's', null, offsetElement);
        };
        //============================================================
        function chart(selection) {
            selection.each(function(data) {
                var container = $9175b321012dc0d3$var$d3.select(this), that = this;
                var availableWidth = (width || parseInt(container.style('width')) || 960) - margin.left - margin.right, availableHeight = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom;
                chart.update = function() {
                    container.transition().duration(transitionDuration).call(chart);
                };
                chart.container = this;
                //set state.disabled
                state.disabled = data.map(function(d) {
                    return !!d.disabled;
                });
                if (!defaultState) {
                    var key;
                    defaultState = {};
                    for(key in state)if (state[key] instanceof Array) defaultState[key] = state[key].slice(0);
                    else defaultState[key] = state[key];
                }
                //------------------------------------------------------------
                // Display noData message if there's nothing to show.
                if (!data || !data.length || !data.filter(function(d) {
                    return d.values.length;
                }).length) {
                    var noDataText = container.selectAll('.nv-noData').data([
                        noData
                    ]);
                    noDataText.enter().append('text').attr('class', 'nvd3 nv-noData').attr('dy', '-.7em').style('text-anchor', 'middle');
                    noDataText.attr('x', margin.left + availableWidth / 2).attr('y', margin.top + availableHeight / 2).text(function(d) {
                        return d;
                    });
                    return chart;
                } else container.selectAll('.nv-noData').remove();
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup Scales
                x = multibar.xScale();
                y = multibar.yScale();
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = container.selectAll('g.nv-wrap.nv-multiBarWithLegend').data([
                    data
                ]);
                var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-multiBarWithLegend').append('g');
                var g = wrap.select('g');
                gEnter.append('g').attr('class', 'nv-x nv-axis');
                gEnter.append('g').attr('class', 'nv-y nv-axis');
                gEnter.append('g').attr('class', 'nv-barsWrap');
                gEnter.append('g').attr('class', 'nv-legendWrap');
                gEnter.append('g').attr('class', 'nv-controlsWrap');
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Legend
                if (showLegend) {
                    legend.width(availableWidth - controlWidth());
                    if (multibar.barColor()) data.forEach(function(series, i) {
                        series.color = $9175b321012dc0d3$var$d3.rgb('#ccc').darker(i * 1.5).toString();
                    });
                    g.select('.nv-legendWrap').datum(data).call(legend);
                    if (margin.top != legend.height()) {
                        margin.top = legend.height();
                        availableHeight = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom;
                    }
                    g.select('.nv-legendWrap').attr('transform', 'translate(' + controlWidth() + ',' + -margin.top + ')');
                }
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Controls
                if (showControls) {
                    var controlsData = [
                        {
                            key: 'Grouped',
                            disabled: multibar.stacked()
                        },
                        {
                            key: 'Stacked',
                            disabled: !multibar.stacked()
                        }
                    ];
                    controls.width(controlWidth()).color([
                        '#444',
                        '#444',
                        '#444'
                    ]);
                    g.select('.nv-controlsWrap').datum(controlsData).attr('transform', 'translate(0,' + -margin.top + ')').call(controls);
                }
                //------------------------------------------------------------
                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                if (rightAlignYAxis) g.select(".nv-y.nv-axis").attr("transform", "translate(" + availableWidth + ",0)");
                //------------------------------------------------------------
                // Main Chart Component(s)
                multibar.disabled(data.map(function(series) {
                    return series.disabled;
                })).width(availableWidth).height(availableHeight).color(data.map(function(d, i) {
                    return d.color || color(d, i);
                }).filter(function(d, i) {
                    return !data[i].disabled;
                }));
                var barsWrap = g.select('.nv-barsWrap').datum(data.filter(function(d) {
                    return !d.disabled;
                }));
                barsWrap.transition().call(multibar);
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup Axes
                if (showXAxis) {
                    xAxis.scale(x).ticks(availableWidth / 100).tickSize(-availableHeight, 0);
                    g.select('.nv-x.nv-axis').attr('transform', 'translate(0,' + y.range()[0] + ')');
                    g.select('.nv-x.nv-axis').transition().call(xAxis);
                    var xTicks = g.select('.nv-x.nv-axis > g').selectAll('g');
                    xTicks.selectAll('line, text').style('opacity', 1);
                    if (staggerLabels) {
                        var getTranslate = function(x, y) {
                            return "translate(" + x + "," + y + ")";
                        };
                        var staggerUp = 5, staggerDown = 17; //pixels to stagger by
                        // Issue #140
                        xTicks.selectAll("text").attr('transform', function(d, i, j) {
                            return getTranslate(0, j % 2 == 0 ? staggerUp : staggerDown);
                        });
                        var totalInBetweenTicks = $9175b321012dc0d3$var$d3.selectAll(".nv-x.nv-axis .nv-wrap g g text")[0].length;
                        g.selectAll(".nv-x.nv-axis .nv-axisMaxMin text").attr("transform", function(d, i) {
                            return getTranslate(0, i === 0 || totalInBetweenTicks % 2 !== 0 ? staggerDown : staggerUp);
                        });
                    }
                    if (reduceXTicks) xTicks.filter(function(d, i) {
                        return i % Math.ceil(data[0].values.length / (availableWidth / 100)) !== 0;
                    }).selectAll('text, line').style('opacity', 0);
                    if (rotateLabels) xTicks.selectAll('.tick text').attr('transform', 'rotate(' + rotateLabels + ' 0,0)').style('text-anchor', rotateLabels > 0 ? 'start' : 'end');
                    g.select('.nv-x.nv-axis').selectAll('g.nv-axisMaxMin text').style('opacity', 1);
                }
                if (showYAxis) {
                    yAxis.scale(y).ticks(availableHeight / 36).tickSize(-availableWidth, 0);
                    g.select('.nv-y.nv-axis').transition().call(yAxis);
                }
                //------------------------------------------------------------
                //============================================================
                // Event Handling/Dispatching (in chart's scope)
                //------------------------------------------------------------
                legend.dispatch.on('stateChange', function(newState) {
                    state = newState;
                    dispatch.stateChange(state);
                    chart.update();
                });
                controls.dispatch.on('legendClick', function(d, i) {
                    if (!d.disabled) return;
                    controlsData = controlsData.map(function(s) {
                        s.disabled = true;
                        return s;
                    });
                    d.disabled = false;
                    switch(d.key){
                        case 'Grouped':
                            multibar.stacked(false);
                            break;
                        case 'Stacked':
                            multibar.stacked(true);
                            break;
                    }
                    state.stacked = multibar.stacked();
                    dispatch.stateChange(state);
                    chart.update();
                });
                dispatch.on('tooltipShow', function(e) {
                    if (tooltips) showTooltip(e, that.parentNode);
                });
                // Update chart from a state object passed to event handler
                dispatch.on('changeState', function(e) {
                    if (typeof e.disabled !== 'undefined') {
                        data.forEach(function(series, i) {
                            series.disabled = e.disabled[i];
                        });
                        state.disabled = e.disabled;
                    }
                    if (typeof e.stacked !== 'undefined') {
                        multibar.stacked(e.stacked);
                        state.stacked = e.stacked;
                    }
                    chart.update();
                });
            //============================================================
            });
            return chart;
        }
        //============================================================
        // Event Handling/Dispatching (out of chart's scope)
        //------------------------------------------------------------
        multibar.dispatch.on('elementMouseover.tooltip', function(e) {
            e.pos = [
                e.pos[0] + margin.left,
                e.pos[1] + margin.top
            ];
            dispatch.tooltipShow(e);
        });
        multibar.dispatch.on('elementMouseout.tooltip', function(e) {
            dispatch.tooltipHide(e);
        });
        dispatch.on('tooltipHide', function() {
            if (tooltips) nv.tooltip.cleanup();
        });
        //============================================================
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        // expose chart's sub-components
        chart.dispatch = dispatch;
        chart.multibar = multibar;
        chart.legend = legend;
        chart.xAxis = xAxis;
        chart.yAxis = yAxis;
        $9175b321012dc0d3$var$d3.rebind(chart, multibar, 'x', 'y', 'xDomain', 'yDomain', 'xRange', 'yRange', 'forceX', 'forceY', 'clipEdge', 'id', 'stacked', 'delay', 'barColor', 'groupSpacing');
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = nv.utils.getColor(_);
            legend.color(color);
            return chart;
        };
        chart.showControls = function(_) {
            if (!arguments.length) return showControls;
            showControls = _;
            return chart;
        };
        chart.showLegend = function(_) {
            if (!arguments.length) return showLegend;
            showLegend = _;
            return chart;
        };
        chart.showXAxis = function(_) {
            if (!arguments.length) return showXAxis;
            showXAxis = _;
            return chart;
        };
        chart.showYAxis = function(_) {
            if (!arguments.length) return showYAxis;
            showYAxis = _;
            return chart;
        };
        chart.rightAlignYAxis = function(_) {
            if (!arguments.length) return rightAlignYAxis;
            rightAlignYAxis = _;
            yAxis.orient(_ ? 'right' : 'left');
            return chart;
        };
        chart.reduceXTicks = function(_) {
            if (!arguments.length) return reduceXTicks;
            reduceXTicks = _;
            return chart;
        };
        chart.rotateLabels = function(_) {
            if (!arguments.length) return rotateLabels;
            rotateLabels = _;
            return chart;
        };
        chart.staggerLabels = function(_) {
            if (!arguments.length) return staggerLabels;
            staggerLabels = _;
            return chart;
        };
        chart.tooltip = function(_) {
            if (!arguments.length) return tooltip;
            tooltip = _;
            return chart;
        };
        chart.tooltips = function(_) {
            if (!arguments.length) return tooltips;
            tooltips = _;
            return chart;
        };
        chart.tooltipContent = function(_) {
            if (!arguments.length) return tooltip;
            tooltip = _;
            return chart;
        };
        chart.state = function(_) {
            if (!arguments.length) return state;
            state = _;
            return chart;
        };
        chart.defaultState = function(_) {
            if (!arguments.length) return defaultState;
            defaultState = _;
            return chart;
        };
        chart.noData = function(_) {
            if (!arguments.length) return noData;
            noData = _;
            return chart;
        };
        chart.transitionDuration = function(_) {
            if (!arguments.length) return transitionDuration;
            transitionDuration = _;
            return chart;
        };
        //============================================================
        return chart;
    };
    nv.models.multiBarHorizontal = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var margin = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }, width = 960, height = 500, id = Math.floor(Math.random() * 10000) //Create semi-unique ID in case user doesn't select one
        , x = $9175b321012dc0d3$var$d3.scale.ordinal(), y = $9175b321012dc0d3$var$d3.scale.linear(), getX1 = function(d) {
            return d.x;
        }, getY1 = function(d) {
            return d.y;
        }, forceY = [
            0
        ] // 0 is forced by default.. this makes sense for the majority of bar graphs... user can always do chart.forceY([]) to remove
        , color = nv.utils.defaultColor(), barColor = null // adding the ability to set the color for each rather than the whole group
        , disabled // used in conjunction with barColor to communicate from multiBarHorizontalChart what series are disabled
        , stacked = false, showValues = false, valuePadding = 60, valueFormat = $9175b321012dc0d3$var$d3.format(',.2f'), delay = 1200, xDomain, yDomain, xRange, yRange, dispatch = $9175b321012dc0d3$var$d3.dispatch('chartClick', 'elementClick', 'elementDblClick', 'elementMouseover', 'elementMouseout');
        //============================================================
        //============================================================
        // Private Variables
        //------------------------------------------------------------
        var x0, y0 //used to store previous scales
        ;
        //============================================================
        function chart(selection) {
            selection.each(function(data) {
                var availableWidth = width - margin.left - margin.right, availableHeight = height - margin.top - margin.bottom, container = $9175b321012dc0d3$var$d3.select(this);
                if (stacked) data = $9175b321012dc0d3$var$d3.layout.stack().offset('zero').values(function(d) {
                    return d.values;
                }).y(getY1)(data);
                //add series index to each data point for reference
                data = data.map(function(series, i) {
                    series.values = series.values.map(function(point) {
                        point.series = i;
                        return point;
                    });
                    return series;
                });
                //------------------------------------------------------------
                // HACK for negative value stacking
                if (stacked) data[0].values.map(function(d, i) {
                    var posBase = 0, negBase = 0;
                    data.map(function(d) {
                        var f = d.values[i];
                        f.size = Math.abs(f.y);
                        if (f.y < 0) {
                            f.y1 = negBase - f.size;
                            negBase = negBase - f.size;
                        } else {
                            f.y1 = posBase;
                            posBase = posBase + f.size;
                        }
                    });
                });
                //------------------------------------------------------------
                // Setup Scales
                // remap and flatten the data for use in calculating the scales' domains
                var seriesData = xDomain && yDomain ? [] : data.map(function(d) {
                    return d.values.map(function(d, i) {
                        return {
                            x: getX1(d, i),
                            y: getY1(d, i),
                            y0: d.y0,
                            y1: d.y1
                        };
                    });
                });
                x.domain(xDomain || $9175b321012dc0d3$var$d3.merge(seriesData).map(function(d) {
                    return d.x;
                })).rangeBands(xRange || [
                    0,
                    availableHeight
                ], .1);
                //y   .domain(yDomain || d3.extent(d3.merge(seriesData).map(function(d) { return d.y + (stacked ? d.y0 : 0) }).concat(forceY)))
                y.domain(yDomain || $9175b321012dc0d3$var$d3.extent($9175b321012dc0d3$var$d3.merge(seriesData).map(function(d) {
                    return stacked ? d.y > 0 ? d.y1 + d.y : d.y1 : d.y;
                }).concat(forceY)));
                if (showValues && !stacked) y.range(yRange || [
                    y.domain()[0] < 0 ? valuePadding : 0,
                    availableWidth - (y.domain()[1] > 0 ? valuePadding : 0)
                ]);
                else y.range(yRange || [
                    0,
                    availableWidth
                ]);
                x0 = x0 || x;
                y0 = y0 || $9175b321012dc0d3$var$d3.scale.linear().domain(y.domain()).range([
                    y(0),
                    y(0)
                ]);
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = $9175b321012dc0d3$var$d3.select(this).selectAll('g.nv-wrap.nv-multibarHorizontal').data([
                    data
                ]);
                var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-multibarHorizontal');
                var defsEnter = wrapEnter.append('defs');
                var gEnter = wrapEnter.append('g');
                var g = wrap.select('g');
                gEnter.append('g').attr('class', 'nv-groups');
                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                //------------------------------------------------------------
                var groups = wrap.select('.nv-groups').selectAll('.nv-group').data(function(d) {
                    return d;
                }, function(d, i) {
                    return i;
                });
                groups.enter().append('g').style('stroke-opacity', 1e-6).style('fill-opacity', 1e-6);
                groups.exit().transition().style('stroke-opacity', 1e-6).style('fill-opacity', 1e-6).remove();
                groups.attr('class', function(d, i) {
                    return 'nv-group nv-series-' + i;
                }).classed('hover', function(d) {
                    return d.hover;
                }).style('fill', function(d, i) {
                    return color(d, i);
                }).style('stroke', function(d, i) {
                    return color(d, i);
                });
                groups.transition().style('stroke-opacity', 1).style('fill-opacity', .75);
                var bars = groups.selectAll('g.nv-bar').data(function(d) {
                    return d.values;
                });
                bars.exit().remove();
                var barsEnter = bars.enter().append('g').attr('transform', function(d, i, j) {
                    return 'translate(' + y0(stacked ? d.y0 : 0) + ',' + (stacked ? 0 : j * x.rangeBand() / data.length + x(getX1(d, i))) + ')';
                });
                barsEnter.append('rect').attr('width', 0).attr('height', x.rangeBand() / (stacked ? 1 : data.length));
                bars.on('mouseover', function(d, i) {
                    $9175b321012dc0d3$var$d3.select(this).classed('hover', true);
                    dispatch.elementMouseover({
                        value: getY1(d, i),
                        point: d,
                        series: data[d.series],
                        pos: [
                            y(getY1(d, i) + (stacked ? d.y0 : 0)),
                            x(getX1(d, i)) + x.rangeBand() * (stacked ? data.length / 2 : d.series + .5) / data.length
                        ],
                        pointIndex: i,
                        seriesIndex: d.series,
                        e: $9175b321012dc0d3$var$d3.event
                    });
                }).on('mouseout', function(d, i) {
                    $9175b321012dc0d3$var$d3.select(this).classed('hover', false);
                    dispatch.elementMouseout({
                        value: getY1(d, i),
                        point: d,
                        series: data[d.series],
                        pointIndex: i,
                        seriesIndex: d.series,
                        e: $9175b321012dc0d3$var$d3.event
                    });
                }).on('click', function(d, i) {
                    dispatch.elementClick({
                        value: getY1(d, i),
                        point: d,
                        series: data[d.series],
                        pos: [
                            x(getX1(d, i)) + x.rangeBand() * (stacked ? data.length / 2 : d.series + .5) / data.length,
                            y(getY1(d, i) + (stacked ? d.y0 : 0))
                        ],
                        pointIndex: i,
                        seriesIndex: d.series,
                        e: $9175b321012dc0d3$var$d3.event
                    });
                    $9175b321012dc0d3$var$d3.event.stopPropagation();
                }).on('dblclick', function(d, i) {
                    dispatch.elementDblClick({
                        value: getY1(d, i),
                        point: d,
                        series: data[d.series],
                        pos: [
                            x(getX1(d, i)) + x.rangeBand() * (stacked ? data.length / 2 : d.series + .5) / data.length,
                            y(getY1(d, i) + (stacked ? d.y0 : 0))
                        ],
                        pointIndex: i,
                        seriesIndex: d.series,
                        e: $9175b321012dc0d3$var$d3.event
                    });
                    $9175b321012dc0d3$var$d3.event.stopPropagation();
                });
                barsEnter.append('text');
                if (showValues && !stacked) {
                    bars.select('text').attr('text-anchor', function(d, i) {
                        return getY1(d, i) < 0 ? 'end' : 'start';
                    }).attr('y', x.rangeBand() / (data.length * 2)).attr('dy', '.32em').text(function(d, i) {
                        return valueFormat(getY1(d, i));
                    });
                    bars.transition().select('text').attr('x', function(d, i) {
                        return getY1(d, i) < 0 ? -4 : y(getY1(d, i)) - y(0) + 4;
                    });
                } else bars.selectAll('text').text('');
                bars.attr('class', function(d, i) {
                    return getY1(d, i) < 0 ? 'nv-bar negative' : 'nv-bar positive';
                });
                if (barColor) {
                    if (!disabled) disabled = data.map(function() {
                        return true;
                    });
                    bars.style('fill', function(d, i, j) {
                        return $9175b321012dc0d3$var$d3.rgb(barColor(d, i)).darker(disabled.map(function(d, i) {
                            return i;
                        }).filter(function(d, i) {
                            return !disabled[i];
                        })[j]).toString();
                    }).style('stroke', function(d, i, j) {
                        return $9175b321012dc0d3$var$d3.rgb(barColor(d, i)).darker(disabled.map(function(d, i) {
                            return i;
                        }).filter(function(d, i) {
                            return !disabled[i];
                        })[j]).toString();
                    });
                }
                if (stacked) bars.transition().attr('transform', function(d, i) {
                    return 'translate(' + y(d.y1) + ',' + x(getX1(d, i)) + ')';
                }).select('rect').attr('width', function(d, i) {
                    return Math.abs(y(getY1(d, i) + d.y0) - y(d.y0));
                }).attr('height', x.rangeBand());
                else bars.transition().attr('transform', function(d, i) {
                    //TODO: stacked must be all positive or all negative, not both?
                    return 'translate(' + (getY1(d, i) < 0 ? y(getY1(d, i)) : y(0)) + ',' + (d.series * x.rangeBand() / data.length + x(getX1(d, i))) + ')';
                }).select('rect').attr('height', x.rangeBand() / data.length).attr('width', function(d, i) {
                    return Math.max(Math.abs(y(getY1(d, i)) - y(0)), 1);
                });
                //store old scales for use in transitions on update
                x0 = x.copy();
                y0 = y.copy();
            });
            return chart;
        }
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        chart.dispatch = dispatch;
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.x = function(_) {
            if (!arguments.length) return getX1;
            getX1 = _;
            return chart;
        };
        chart.y = function(_) {
            if (!arguments.length) return getY1;
            getY1 = _;
            return chart;
        };
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.xScale = function(_) {
            if (!arguments.length) return x;
            x = _;
            return chart;
        };
        chart.yScale = function(_) {
            if (!arguments.length) return y;
            y = _;
            return chart;
        };
        chart.xDomain = function(_) {
            if (!arguments.length) return xDomain;
            xDomain = _;
            return chart;
        };
        chart.yDomain = function(_) {
            if (!arguments.length) return yDomain;
            yDomain = _;
            return chart;
        };
        chart.xRange = function(_) {
            if (!arguments.length) return xRange;
            xRange = _;
            return chart;
        };
        chart.yRange = function(_) {
            if (!arguments.length) return yRange;
            yRange = _;
            return chart;
        };
        chart.forceY = function(_) {
            if (!arguments.length) return forceY;
            forceY = _;
            return chart;
        };
        chart.stacked = function(_) {
            if (!arguments.length) return stacked;
            stacked = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = nv.utils.getColor(_);
            return chart;
        };
        chart.barColor = function(_) {
            if (!arguments.length) return barColor;
            barColor = nv.utils.getColor(_);
            return chart;
        };
        chart.disabled = function(_) {
            if (!arguments.length) return disabled;
            disabled = _;
            return chart;
        };
        chart.id = function(_) {
            if (!arguments.length) return id;
            id = _;
            return chart;
        };
        chart.delay = function(_) {
            if (!arguments.length) return delay;
            delay = _;
            return chart;
        };
        chart.showValues = function(_) {
            if (!arguments.length) return showValues;
            showValues = _;
            return chart;
        };
        chart.valueFormat = function(_) {
            if (!arguments.length) return valueFormat;
            valueFormat = _;
            return chart;
        };
        chart.valuePadding = function(_) {
            if (!arguments.length) return valuePadding;
            valuePadding = _;
            return chart;
        };
        //============================================================
        return chart;
    };
    nv.models.multiBarHorizontalChart = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var multibar = nv.models.multiBarHorizontal(), xAxis = nv.models.axis(), yAxis = nv.models.axis(), legend = nv.models.legend().height(30), controls = nv.models.legend().height(30);
        var margin = {
            top: 30,
            right: 20,
            bottom: 50,
            left: 60
        }, width = null, height = null, color = nv.utils.defaultColor(), showControls = true, showLegend = true, stacked = false, tooltips = true, tooltip = function(key, x, y, e, graph) {
            return '<h3>' + key + ' - ' + x + '</h3>' + '<p>' + y + '</p>';
        }, x //can be accessed via chart.xScale()
        , y //can be accessed via chart.yScale()
        , state = {
            stacked: stacked
        }, defaultState = null, noData = 'No Data Available.', dispatch = $9175b321012dc0d3$var$d3.dispatch('tooltipShow', 'tooltipHide', 'stateChange', 'changeState'), controlWidth = function() {
            return showControls ? 180 : 0;
        }, transitionDuration = 250;
        multibar.stacked(stacked);
        xAxis.orient('left').tickPadding(5).highlightZero(false).showMaxMin(false).tickFormat(function(d) {
            return d;
        });
        yAxis.orient('bottom').tickFormat($9175b321012dc0d3$var$d3.format(',.1f'));
        controls.updateState(false);
        //============================================================
        //============================================================
        // Private Variables
        //------------------------------------------------------------
        var showTooltip = function(e, offsetElement) {
            var left = e.pos[0] + (offsetElement.offsetLeft || 0), top = e.pos[1] + (offsetElement.offsetTop || 0), x = xAxis.tickFormat()(multibar.x()(e.point, e.pointIndex)), y = yAxis.tickFormat()(multibar.y()(e.point, e.pointIndex)), content = tooltip(e.series.key, x, y, e, chart);
            nv.tooltip.show([
                left,
                top
            ], content, e.value < 0 ? 'e' : 'w', null, offsetElement);
        };
        //============================================================
        function chart(selection) {
            selection.each(function(data) {
                var container = $9175b321012dc0d3$var$d3.select(this), that = this;
                var availableWidth = (width || parseInt(container.style('width')) || 960) - margin.left - margin.right, availableHeight = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom;
                chart.update = function() {
                    container.transition().duration(transitionDuration).call(chart);
                };
                chart.container = this;
                //set state.disabled
                state.disabled = data.map(function(d) {
                    return !!d.disabled;
                });
                if (!defaultState) {
                    var key;
                    defaultState = {};
                    for(key in state)if (state[key] instanceof Array) defaultState[key] = state[key].slice(0);
                    else defaultState[key] = state[key];
                }
                //------------------------------------------------------------
                // Display No Data message if there's nothing to show.
                if (!data || !data.length || !data.filter(function(d) {
                    return d.values.length;
                }).length) {
                    var noDataText = container.selectAll('.nv-noData').data([
                        noData
                    ]);
                    noDataText.enter().append('text').attr('class', 'nvd3 nv-noData').attr('dy', '-.7em').style('text-anchor', 'middle');
                    noDataText.attr('x', margin.left + availableWidth / 2).attr('y', margin.top + availableHeight / 2).text(function(d) {
                        return d;
                    });
                    return chart;
                } else container.selectAll('.nv-noData').remove();
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup Scales
                x = multibar.xScale();
                y = multibar.yScale();
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = container.selectAll('g.nv-wrap.nv-multiBarHorizontalChart').data([
                    data
                ]);
                var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-multiBarHorizontalChart').append('g');
                var g = wrap.select('g');
                gEnter.append('g').attr('class', 'nv-x nv-axis');
                gEnter.append('g').attr('class', 'nv-y nv-axis');
                gEnter.append('g').attr('class', 'nv-barsWrap');
                gEnter.append('g').attr('class', 'nv-legendWrap');
                gEnter.append('g').attr('class', 'nv-controlsWrap');
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Legend
                if (showLegend) {
                    legend.width(availableWidth - controlWidth());
                    if (multibar.barColor()) data.forEach(function(series, i) {
                        series.color = $9175b321012dc0d3$var$d3.rgb('#ccc').darker(i * 1.5).toString();
                    });
                    g.select('.nv-legendWrap').datum(data).call(legend);
                    if (margin.top != legend.height()) {
                        margin.top = legend.height();
                        availableHeight = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom;
                    }
                    g.select('.nv-legendWrap').attr('transform', 'translate(' + controlWidth() + ',' + -margin.top + ')');
                }
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Controls
                if (showControls) {
                    var controlsData = [
                        {
                            key: 'Grouped',
                            disabled: multibar.stacked()
                        },
                        {
                            key: 'Stacked',
                            disabled: !multibar.stacked()
                        }
                    ];
                    controls.width(controlWidth()).color([
                        '#444',
                        '#444',
                        '#444'
                    ]);
                    g.select('.nv-controlsWrap').datum(controlsData).attr('transform', 'translate(0,' + -margin.top + ')').call(controls);
                }
                //------------------------------------------------------------
                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                //------------------------------------------------------------
                // Main Chart Component(s)
                multibar.disabled(data.map(function(series) {
                    return series.disabled;
                })).width(availableWidth).height(availableHeight).color(data.map(function(d, i) {
                    return d.color || color(d, i);
                }).filter(function(d, i) {
                    return !data[i].disabled;
                }));
                var barsWrap = g.select('.nv-barsWrap').datum(data.filter(function(d) {
                    return !d.disabled;
                }));
                barsWrap.transition().call(multibar);
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup Axes
                xAxis.scale(x).ticks(availableHeight / 24).tickSize(-availableWidth, 0);
                g.select('.nv-x.nv-axis').transition().call(xAxis);
                var xTicks = g.select('.nv-x.nv-axis').selectAll('g');
                xTicks.selectAll('line, text').style('opacity', 1);
                yAxis.scale(y).ticks(availableWidth / 100).tickSize(-availableHeight, 0);
                g.select('.nv-y.nv-axis').attr('transform', 'translate(0,' + availableHeight + ')');
                g.select('.nv-y.nv-axis').transition().call(yAxis);
                //------------------------------------------------------------
                //============================================================
                // Event Handling/Dispatching (in chart's scope)
                //------------------------------------------------------------
                legend.dispatch.on('stateChange', function(newState) {
                    state = newState;
                    dispatch.stateChange(state);
                    chart.update();
                });
                controls.dispatch.on('legendClick', function(d, i) {
                    if (!d.disabled) return;
                    controlsData = controlsData.map(function(s) {
                        s.disabled = true;
                        return s;
                    });
                    d.disabled = false;
                    switch(d.key){
                        case 'Grouped':
                            multibar.stacked(false);
                            break;
                        case 'Stacked':
                            multibar.stacked(true);
                            break;
                    }
                    state.stacked = multibar.stacked();
                    dispatch.stateChange(state);
                    chart.update();
                });
                dispatch.on('tooltipShow', function(e) {
                    if (tooltips) showTooltip(e, that.parentNode);
                });
                // Update chart from a state object passed to event handler
                dispatch.on('changeState', function(e) {
                    if (typeof e.disabled !== 'undefined') {
                        data.forEach(function(series, i) {
                            series.disabled = e.disabled[i];
                        });
                        state.disabled = e.disabled;
                    }
                    if (typeof e.stacked !== 'undefined') {
                        multibar.stacked(e.stacked);
                        state.stacked = e.stacked;
                    }
                    selection.call(chart);
                });
            //============================================================
            });
            return chart;
        }
        //============================================================
        // Event Handling/Dispatching (out of chart's scope)
        //------------------------------------------------------------
        multibar.dispatch.on('elementMouseover.tooltip', function(e) {
            e.pos = [
                e.pos[0] + margin.left,
                e.pos[1] + margin.top
            ];
            dispatch.tooltipShow(e);
        });
        multibar.dispatch.on('elementMouseout.tooltip', function(e) {
            dispatch.tooltipHide(e);
        });
        dispatch.on('tooltipHide', function() {
            if (tooltips) nv.tooltip.cleanup();
        });
        //============================================================
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        // expose chart's sub-components
        chart.dispatch = dispatch;
        chart.multibar = multibar;
        chart.legend = legend;
        chart.xAxis = xAxis;
        chart.yAxis = yAxis;
        $9175b321012dc0d3$var$d3.rebind(chart, multibar, 'x', 'y', 'xDomain', 'yDomain', 'xRange', 'yRange', 'forceX', 'forceY', 'clipEdge', 'id', 'delay', 'showValues', 'valueFormat', 'stacked', 'barColor');
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = nv.utils.getColor(_);
            legend.color(color);
            return chart;
        };
        chart.showControls = function(_) {
            if (!arguments.length) return showControls;
            showControls = _;
            return chart;
        };
        chart.showLegend = function(_) {
            if (!arguments.length) return showLegend;
            showLegend = _;
            return chart;
        };
        chart.tooltip = function(_) {
            if (!arguments.length) return tooltip;
            tooltip = _;
            return chart;
        };
        chart.tooltips = function(_) {
            if (!arguments.length) return tooltips;
            tooltips = _;
            return chart;
        };
        chart.tooltipContent = function(_) {
            if (!arguments.length) return tooltip;
            tooltip = _;
            return chart;
        };
        chart.state = function(_) {
            if (!arguments.length) return state;
            state = _;
            return chart;
        };
        chart.defaultState = function(_) {
            if (!arguments.length) return defaultState;
            defaultState = _;
            return chart;
        };
        chart.noData = function(_) {
            if (!arguments.length) return noData;
            noData = _;
            return chart;
        };
        chart.transitionDuration = function(_) {
            if (!arguments.length) return transitionDuration;
            transitionDuration = _;
            return chart;
        };
        //============================================================
        return chart;
    };
    nv.models.multiChart = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var margin = {
            top: 30,
            right: 20,
            bottom: 50,
            left: 60
        }, color = $9175b321012dc0d3$var$d3.scale.category20().range(), width = null, height = null, showLegend = true, tooltips = true, tooltip = function(key, x, y, e, graph) {
            return '<h3>' + key + '</h3>' + '<p>' + y + ' at ' + x + '</p>';
        }, x, y, yDomain1, yDomain2; //can be accessed via chart.lines.[x/y]Scale()
        //============================================================
        // Private Variables
        //------------------------------------------------------------
        var x = $9175b321012dc0d3$var$d3.scale.linear(), yScale1 = $9175b321012dc0d3$var$d3.scale.linear(), yScale2 = $9175b321012dc0d3$var$d3.scale.linear(), lines1 = nv.models.line().yScale(yScale1), lines2 = nv.models.line().yScale(yScale2), bars1 = nv.models.multiBar().stacked(false).yScale(yScale1), bars2 = nv.models.multiBar().stacked(false).yScale(yScale2), stack1 = nv.models.stackedArea().yScale(yScale1), stack2 = nv.models.stackedArea().yScale(yScale2), xAxis = nv.models.axis().scale(x).orient('bottom').tickPadding(5), yAxis1 = nv.models.axis().scale(yScale1).orient('left'), yAxis2 = nv.models.axis().scale(yScale2).orient('right'), legend = nv.models.legend().height(30), dispatch = $9175b321012dc0d3$var$d3.dispatch('tooltipShow', 'tooltipHide');
        var showTooltip = function(e, offsetElement) {
            var left = e.pos[0] + (offsetElement.offsetLeft || 0), top = e.pos[1] + (offsetElement.offsetTop || 0), x = xAxis.tickFormat()(lines1.x()(e.point, e.pointIndex)), y = (e.series.yAxis == 2 ? yAxis2 : yAxis1).tickFormat()(lines1.y()(e.point, e.pointIndex)), content = tooltip(e.series.key, x, y, e, chart);
            nv.tooltip.show([
                left,
                top
            ], content, undefined, undefined, offsetElement.offsetParent);
        };
        function chart(selection) {
            selection.each(function(data) {
                var container = $9175b321012dc0d3$var$d3.select(this), that = this;
                chart.update = function() {
                    container.transition().call(chart);
                };
                chart.container = this;
                var availableWidth = (width || parseInt(container.style('width')) || 960) - margin.left - margin.right, availableHeight = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom;
                var dataLines1 = data.filter(function(d) {
                    return !d.disabled && d.type == 'line' && d.yAxis == 1;
                });
                var dataLines2 = data.filter(function(d) {
                    return !d.disabled && d.type == 'line' && d.yAxis == 2;
                });
                var dataBars1 = data.filter(function(d) {
                    return !d.disabled && d.type == 'bar' && d.yAxis == 1;
                });
                var dataBars2 = data.filter(function(d) {
                    return !d.disabled && d.type == 'bar' && d.yAxis == 2;
                });
                var dataStack1 = data.filter(function(d) {
                    return !d.disabled && d.type == 'area' && d.yAxis == 1;
                });
                var dataStack2 = data.filter(function(d) {
                    return !d.disabled && d.type == 'area' && d.yAxis == 2;
                });
                var series1 = data.filter(function(d) {
                    return !d.disabled && d.yAxis == 1;
                }).map(function(d) {
                    return d.values.map(function(d, i) {
                        return {
                            x: d.x,
                            y: d.y
                        };
                    });
                });
                var series2 = data.filter(function(d) {
                    return !d.disabled && d.yAxis == 2;
                }).map(function(d) {
                    return d.values.map(function(d, i) {
                        return {
                            x: d.x,
                            y: d.y
                        };
                    });
                });
                x.domain($9175b321012dc0d3$var$d3.extent($9175b321012dc0d3$var$d3.merge(series1.concat(series2)), function(d) {
                    return d.x;
                })).range([
                    0,
                    availableWidth
                ]);
                var wrap = container.selectAll('g.wrap.multiChart').data([
                    data
                ]);
                var gEnter = wrap.enter().append('g').attr('class', 'wrap nvd3 multiChart').append('g');
                gEnter.append('g').attr('class', 'x axis');
                gEnter.append('g').attr('class', 'y1 axis');
                gEnter.append('g').attr('class', 'y2 axis');
                gEnter.append('g').attr('class', 'lines1Wrap');
                gEnter.append('g').attr('class', 'lines2Wrap');
                gEnter.append('g').attr('class', 'bars1Wrap');
                gEnter.append('g').attr('class', 'bars2Wrap');
                gEnter.append('g').attr('class', 'stack1Wrap');
                gEnter.append('g').attr('class', 'stack2Wrap');
                gEnter.append('g').attr('class', 'legendWrap');
                var g = wrap.select('g');
                if (showLegend) {
                    legend.width(availableWidth / 2);
                    g.select('.legendWrap').datum(data.map(function(series) {
                        series.originalKey = series.originalKey === undefined ? series.key : series.originalKey;
                        series.key = series.originalKey + (series.yAxis == 1 ? '' : ' (right axis)');
                        return series;
                    })).call(legend);
                    if (margin.top != legend.height()) {
                        margin.top = legend.height();
                        availableHeight = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom;
                    }
                    g.select('.legendWrap').attr('transform', 'translate(' + availableWidth / 2 + ',' + -margin.top + ')');
                }
                lines1.width(availableWidth).height(availableHeight).interpolate("monotone").color(data.map(function(d, i) {
                    return d.color || color[i % color.length];
                }).filter(function(d, i) {
                    return !data[i].disabled && data[i].yAxis == 1 && data[i].type == 'line';
                }));
                lines2.width(availableWidth).height(availableHeight).interpolate("monotone").color(data.map(function(d, i) {
                    return d.color || color[i % color.length];
                }).filter(function(d, i) {
                    return !data[i].disabled && data[i].yAxis == 2 && data[i].type == 'line';
                }));
                bars1.width(availableWidth).height(availableHeight).color(data.map(function(d, i) {
                    return d.color || color[i % color.length];
                }).filter(function(d, i) {
                    return !data[i].disabled && data[i].yAxis == 1 && data[i].type == 'bar';
                }));
                bars2.width(availableWidth).height(availableHeight).color(data.map(function(d, i) {
                    return d.color || color[i % color.length];
                }).filter(function(d, i) {
                    return !data[i].disabled && data[i].yAxis == 2 && data[i].type == 'bar';
                }));
                stack1.width(availableWidth).height(availableHeight).color(data.map(function(d, i) {
                    return d.color || color[i % color.length];
                }).filter(function(d, i) {
                    return !data[i].disabled && data[i].yAxis == 1 && data[i].type == 'area';
                }));
                stack2.width(availableWidth).height(availableHeight).color(data.map(function(d, i) {
                    return d.color || color[i % color.length];
                }).filter(function(d, i) {
                    return !data[i].disabled && data[i].yAxis == 2 && data[i].type == 'area';
                }));
                g.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                var lines1Wrap = g.select('.lines1Wrap').datum(dataLines1);
                var bars1Wrap = g.select('.bars1Wrap').datum(dataBars1);
                var stack1Wrap = g.select('.stack1Wrap').datum(dataStack1);
                var lines2Wrap = g.select('.lines2Wrap').datum(dataLines2);
                var bars2Wrap = g.select('.bars2Wrap').datum(dataBars2);
                var stack2Wrap = g.select('.stack2Wrap').datum(dataStack2);
                var extraValue1 = dataStack1.length ? dataStack1.map(function(a) {
                    return a.values;
                }).reduce(function(a, b1) {
                    return a.map(function(aVal, i) {
                        return {
                            x: aVal.x,
                            y: aVal.y + b1[i].y
                        };
                    });
                }).concat([
                    {
                        x: 0,
                        y: 0
                    }
                ]) : [];
                var extraValue2 = dataStack2.length ? dataStack2.map(function(a) {
                    return a.values;
                }).reduce(function(a, b1) {
                    return a.map(function(aVal, i) {
                        return {
                            x: aVal.x,
                            y: aVal.y + b1[i].y
                        };
                    });
                }).concat([
                    {
                        x: 0,
                        y: 0
                    }
                ]) : [];
                yScale1.domain(yDomain1 || $9175b321012dc0d3$var$d3.extent($9175b321012dc0d3$var$d3.merge(series1).concat(extraValue1), function(d) {
                    return d.y;
                })).range([
                    0,
                    availableHeight
                ]);
                yScale2.domain(yDomain2 || $9175b321012dc0d3$var$d3.extent($9175b321012dc0d3$var$d3.merge(series2).concat(extraValue2), function(d) {
                    return d.y;
                })).range([
                    0,
                    availableHeight
                ]);
                lines1.yDomain(yScale1.domain());
                bars1.yDomain(yScale1.domain());
                stack1.yDomain(yScale1.domain());
                lines2.yDomain(yScale2.domain());
                bars2.yDomain(yScale2.domain());
                stack2.yDomain(yScale2.domain());
                if (dataStack1.length) $9175b321012dc0d3$var$d3.transition(stack1Wrap).call(stack1);
                if (dataStack2.length) $9175b321012dc0d3$var$d3.transition(stack2Wrap).call(stack2);
                if (dataBars1.length) $9175b321012dc0d3$var$d3.transition(bars1Wrap).call(bars1);
                if (dataBars2.length) $9175b321012dc0d3$var$d3.transition(bars2Wrap).call(bars2);
                if (dataLines1.length) $9175b321012dc0d3$var$d3.transition(lines1Wrap).call(lines1);
                if (dataLines2.length) $9175b321012dc0d3$var$d3.transition(lines2Wrap).call(lines2);
                xAxis.ticks(availableWidth / 100).tickSize(-availableHeight, 0);
                g.select('.x.axis').attr('transform', 'translate(0,' + availableHeight + ')');
                $9175b321012dc0d3$var$d3.transition(g.select('.x.axis')).call(xAxis);
                yAxis1.ticks(availableHeight / 36).tickSize(-availableWidth, 0);
                $9175b321012dc0d3$var$d3.transition(g.select('.y1.axis')).call(yAxis1);
                yAxis2.ticks(availableHeight / 36).tickSize(-availableWidth, 0);
                $9175b321012dc0d3$var$d3.transition(g.select('.y2.axis')).call(yAxis2);
                g.select('.y2.axis').style('opacity', series2.length ? 1 : 0).attr('transform', 'translate(' + x.range()[1] + ',0)');
                legend.dispatch.on('stateChange', function(newState) {
                    chart.update();
                });
                dispatch.on('tooltipShow', function(e) {
                    if (tooltips) showTooltip(e, that.parentNode);
                });
            });
            return chart;
        }
        //============================================================
        // Event Handling/Dispatching (out of chart's scope)
        //------------------------------------------------------------
        lines1.dispatch.on('elementMouseover.tooltip', function(e) {
            e.pos = [
                e.pos[0] + margin.left,
                e.pos[1] + margin.top
            ];
            dispatch.tooltipShow(e);
        });
        lines1.dispatch.on('elementMouseout.tooltip', function(e) {
            dispatch.tooltipHide(e);
        });
        lines2.dispatch.on('elementMouseover.tooltip', function(e) {
            e.pos = [
                e.pos[0] + margin.left,
                e.pos[1] + margin.top
            ];
            dispatch.tooltipShow(e);
        });
        lines2.dispatch.on('elementMouseout.tooltip', function(e) {
            dispatch.tooltipHide(e);
        });
        bars1.dispatch.on('elementMouseover.tooltip', function(e) {
            e.pos = [
                e.pos[0] + margin.left,
                e.pos[1] + margin.top
            ];
            dispatch.tooltipShow(e);
        });
        bars1.dispatch.on('elementMouseout.tooltip', function(e) {
            dispatch.tooltipHide(e);
        });
        bars2.dispatch.on('elementMouseover.tooltip', function(e) {
            e.pos = [
                e.pos[0] + margin.left,
                e.pos[1] + margin.top
            ];
            dispatch.tooltipShow(e);
        });
        bars2.dispatch.on('elementMouseout.tooltip', function(e) {
            dispatch.tooltipHide(e);
        });
        stack1.dispatch.on('tooltipShow', function(e) {
            //disable tooltips when value ~= 0
            //// TODO: consider removing points from voronoi that have 0 value instead of this hack
            if (!Math.round(stack1.y()(e.point) * 100)) {
                setTimeout(function() {
                    $9175b321012dc0d3$var$d3.selectAll('.point.hover').classed('hover', false);
                }, 0);
                return false;
            }
            e.pos = [
                e.pos[0] + margin.left,
                e.pos[1] + margin.top
            ], dispatch.tooltipShow(e);
        });
        stack1.dispatch.on('tooltipHide', function(e) {
            dispatch.tooltipHide(e);
        });
        stack2.dispatch.on('tooltipShow', function(e) {
            //disable tooltips when value ~= 0
            //// TODO: consider removing points from voronoi that have 0 value instead of this hack
            if (!Math.round(stack2.y()(e.point) * 100)) {
                setTimeout(function() {
                    $9175b321012dc0d3$var$d3.selectAll('.point.hover').classed('hover', false);
                }, 0);
                return false;
            }
            e.pos = [
                e.pos[0] + margin.left,
                e.pos[1] + margin.top
            ], dispatch.tooltipShow(e);
        });
        stack2.dispatch.on('tooltipHide', function(e) {
            dispatch.tooltipHide(e);
        });
        lines1.dispatch.on('elementMouseover.tooltip', function(e) {
            e.pos = [
                e.pos[0] + margin.left,
                e.pos[1] + margin.top
            ];
            dispatch.tooltipShow(e);
        });
        lines1.dispatch.on('elementMouseout.tooltip', function(e) {
            dispatch.tooltipHide(e);
        });
        lines2.dispatch.on('elementMouseover.tooltip', function(e) {
            e.pos = [
                e.pos[0] + margin.left,
                e.pos[1] + margin.top
            ];
            dispatch.tooltipShow(e);
        });
        lines2.dispatch.on('elementMouseout.tooltip', function(e) {
            dispatch.tooltipHide(e);
        });
        dispatch.on('tooltipHide', function() {
            if (tooltips) nv.tooltip.cleanup();
        });
        //============================================================
        // Global getters and setters
        //------------------------------------------------------------
        chart.dispatch = dispatch;
        chart.lines1 = lines1;
        chart.lines2 = lines2;
        chart.bars1 = bars1;
        chart.bars2 = bars2;
        chart.stack1 = stack1;
        chart.stack2 = stack2;
        chart.xAxis = xAxis;
        chart.yAxis1 = yAxis1;
        chart.yAxis2 = yAxis2;
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.x = function(_) {
            if (!arguments.length) return getX;
            getX = _;
            lines1.x(_);
            bars1.x(_);
            return chart;
        };
        chart.y = function(_) {
            if (!arguments.length) return getY;
            getY = _;
            lines1.y(_);
            bars1.y(_);
            return chart;
        };
        chart.yDomain1 = function(_) {
            if (!arguments.length) return yDomain1;
            yDomain1 = _;
            return chart;
        };
        chart.yDomain2 = function(_) {
            if (!arguments.length) return yDomain2;
            yDomain2 = _;
            return chart;
        };
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin = _;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = _;
            legend.color(_);
            return chart;
        };
        chart.showLegend = function(_) {
            if (!arguments.length) return showLegend;
            showLegend = _;
            return chart;
        };
        chart.tooltips = function(_) {
            if (!arguments.length) return tooltips;
            tooltips = _;
            return chart;
        };
        chart.tooltipContent = function(_) {
            if (!arguments.length) return tooltip;
            tooltip = _;
            return chart;
        };
        return chart;
    };
    nv.models.ohlcBar = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var margin = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }, width = 960, height = 500, id = Math.floor(Math.random() * 10000) //Create semi-unique ID in case user doesn't select one
        , x = $9175b321012dc0d3$var$d3.scale.linear(), y = $9175b321012dc0d3$var$d3.scale.linear(), getX1 = function(d) {
            return d.x;
        }, getY1 = function(d) {
            return d.y;
        }, getOpen = function(d) {
            return d.open;
        }, getClose = function(d) {
            return d.close;
        }, getHigh = function(d) {
            return d.high;
        }, getLow = function(d) {
            return d.low;
        }, forceX = [], forceY = [], padData = false // If true, adds half a data points width to front and back, for lining up a line chart with a bar chart
        , clipEdge = true, color = nv.utils.defaultColor(), xDomain, yDomain, xRange, yRange, dispatch = $9175b321012dc0d3$var$d3.dispatch('chartClick', 'elementClick', 'elementDblClick', 'elementMouseover', 'elementMouseout');
        //============================================================
        //============================================================
        // Private Variables
        //------------------------------------------------------------
        //TODO: store old scales for transitions
        //============================================================
        function chart(selection) {
            selection.each(function(data) {
                var availableWidth = width - margin.left - margin.right, availableHeight = height - margin.top - margin.bottom, container = $9175b321012dc0d3$var$d3.select(this);
                //------------------------------------------------------------
                // Setup Scales
                x.domain(xDomain || $9175b321012dc0d3$var$d3.extent(data[0].values.map(getX1).concat(forceX)));
                if (padData) x.range(xRange || [
                    availableWidth * .5 / data[0].values.length,
                    availableWidth * (data[0].values.length - .5) / data[0].values.length
                ]);
                else x.range(xRange || [
                    0,
                    availableWidth
                ]);
                y.domain(yDomain || [
                    $9175b321012dc0d3$var$d3.min(data[0].values.map(getLow).concat(forceY)),
                    $9175b321012dc0d3$var$d3.max(data[0].values.map(getHigh).concat(forceY))
                ]).range(yRange || [
                    availableHeight,
                    0
                ]);
                // If scale's domain don't have a range, slightly adjust to make one... so a chart can show a single data point
                if (x.domain()[0] === x.domain()[1] || y.domain()[0] === y.domain()[1]) singlePoint = true;
                if (x.domain()[0] === x.domain()[1]) x.domain()[0] ? x.domain([
                    x.domain()[0] - x.domain()[0] * 0.01,
                    x.domain()[1] + x.domain()[1] * 0.01
                ]) : x.domain([
                    -1,
                    1
                ]);
                if (y.domain()[0] === y.domain()[1]) y.domain()[0] ? y.domain([
                    y.domain()[0] + y.domain()[0] * 0.01,
                    y.domain()[1] - y.domain()[1] * 0.01
                ]) : y.domain([
                    -1,
                    1
                ]);
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = $9175b321012dc0d3$var$d3.select(this).selectAll('g.nv-wrap.nv-ohlcBar').data([
                    data[0].values
                ]);
                var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-ohlcBar');
                var defsEnter = wrapEnter.append('defs');
                var gEnter = wrapEnter.append('g');
                var g = wrap.select('g');
                gEnter.append('g').attr('class', 'nv-ticks');
                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                //------------------------------------------------------------
                container.on('click', function(d, i) {
                    dispatch.chartClick({
                        data: d,
                        index: i,
                        pos: $9175b321012dc0d3$var$d3.event,
                        id: id
                    });
                });
                defsEnter.append('clipPath').attr('id', 'nv-chart-clip-path-' + id).append('rect');
                wrap.select('#nv-chart-clip-path-' + id + ' rect').attr('width', availableWidth).attr('height', availableHeight);
                g.attr('clip-path', clipEdge ? 'url(#nv-chart-clip-path-' + id + ')' : '');
                var ticks = wrap.select('.nv-ticks').selectAll('.nv-tick').data(function(d) {
                    return d;
                });
                ticks.exit().remove();
                var ticksEnter = ticks.enter().append('path').attr('class', function(d, i, j) {
                    return (getOpen(d, i) > getClose(d, i) ? 'nv-tick negative' : 'nv-tick positive') + ' nv-tick-' + j + '-' + i;
                }).attr('d', function(d, i) {
                    var w = availableWidth / data[0].values.length * .9;
                    return 'm0,0l0,' + (y(getOpen(d, i)) - y(getHigh(d, i))) + 'l' + -w / 2 + ',0l' + w / 2 + ',0l0,' + (y(getLow(d, i)) - y(getOpen(d, i))) + 'l0,' + (y(getClose(d, i)) - y(getLow(d, i))) + 'l' + w / 2 + ',0l' + -w / 2 + ',0z';
                }).attr('transform', function(d, i) {
                    return 'translate(' + x(getX1(d, i)) + ',' + y(getHigh(d, i)) + ')';
                })//.attr('fill', function(d,i) { return color[0]; })
                //.attr('stroke', function(d,i) { return color[0]; })
                //.attr('x', 0 )
                //.attr('y', function(d,i) {  return y(Math.max(0, getY(d,i))) })
                //.attr('height', function(d,i) { return Math.abs(y(getY(d,i)) - y(0)) })
                .on('mouseover', function(d, i) {
                    $9175b321012dc0d3$var$d3.select(this).classed('hover', true);
                    dispatch.elementMouseover({
                        point: d,
                        series: data[0],
                        pos: [
                            x(getX1(d, i)),
                            y(getY1(d, i))
                        ],
                        pointIndex: i,
                        seriesIndex: 0,
                        e: $9175b321012dc0d3$var$d3.event
                    });
                }).on('mouseout', function(d, i) {
                    $9175b321012dc0d3$var$d3.select(this).classed('hover', false);
                    dispatch.elementMouseout({
                        point: d,
                        series: data[0],
                        pointIndex: i,
                        seriesIndex: 0,
                        e: $9175b321012dc0d3$var$d3.event
                    });
                }).on('click', function(d, i) {
                    dispatch.elementClick({
                        //label: d[label],
                        value: getY1(d, i),
                        data: d,
                        index: i,
                        pos: [
                            x(getX1(d, i)),
                            y(getY1(d, i))
                        ],
                        e: $9175b321012dc0d3$var$d3.event,
                        id: id
                    });
                    $9175b321012dc0d3$var$d3.event.stopPropagation();
                }).on('dblclick', function(d, i) {
                    dispatch.elementDblClick({
                        //label: d[label],
                        value: getY1(d, i),
                        data: d,
                        index: i,
                        pos: [
                            x(getX1(d, i)),
                            y(getY1(d, i))
                        ],
                        e: $9175b321012dc0d3$var$d3.event,
                        id: id
                    });
                    $9175b321012dc0d3$var$d3.event.stopPropagation();
                });
                ticks.attr('class', function(d, i, j) {
                    return (getOpen(d, i) > getClose(d, i) ? 'nv-tick negative' : 'nv-tick positive') + ' nv-tick-' + j + '-' + i;
                });
                $9175b321012dc0d3$var$d3.transition(ticks).attr('transform', function(d, i) {
                    return 'translate(' + x(getX1(d, i)) + ',' + y(getHigh(d, i)) + ')';
                }).attr('d', function(d, i) {
                    var w = availableWidth / data[0].values.length * .9;
                    return 'm0,0l0,' + (y(getOpen(d, i)) - y(getHigh(d, i))) + 'l' + -w / 2 + ',0l' + w / 2 + ',0l0,' + (y(getLow(d, i)) - y(getOpen(d, i))) + 'l0,' + (y(getClose(d, i)) - y(getLow(d, i))) + 'l' + w / 2 + ',0l' + -w / 2 + ',0z';
                });
            //.attr('width', (availableWidth / data[0].values.length) * .9 )
            //d3.transition(ticks)
            //.attr('y', function(d,i) {  return y(Math.max(0, getY(d,i))) })
            //.attr('height', function(d,i) { return Math.abs(y(getY(d,i)) - y(0)) });
            //.order();  // not sure if this makes any sense for this model
            });
            return chart;
        }
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        chart.dispatch = dispatch;
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.x = function(_) {
            if (!arguments.length) return getX1;
            getX1 = _;
            return chart;
        };
        chart.y = function(_) {
            if (!arguments.length) return getY1;
            getY1 = _;
            return chart;
        };
        chart.open = function(_) {
            if (!arguments.length) return getOpen;
            getOpen = _;
            return chart;
        };
        chart.close = function(_) {
            if (!arguments.length) return getClose;
            getClose = _;
            return chart;
        };
        chart.high = function(_) {
            if (!arguments.length) return getHigh;
            getHigh = _;
            return chart;
        };
        chart.low = function(_) {
            if (!arguments.length) return getLow;
            getLow = _;
            return chart;
        };
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.xScale = function(_) {
            if (!arguments.length) return x;
            x = _;
            return chart;
        };
        chart.yScale = function(_) {
            if (!arguments.length) return y;
            y = _;
            return chart;
        };
        chart.xDomain = function(_) {
            if (!arguments.length) return xDomain;
            xDomain = _;
            return chart;
        };
        chart.yDomain = function(_) {
            if (!arguments.length) return yDomain;
            yDomain = _;
            return chart;
        };
        chart.xRange = function(_) {
            if (!arguments.length) return xRange;
            xRange = _;
            return chart;
        };
        chart.yRange = function(_) {
            if (!arguments.length) return yRange;
            yRange = _;
            return chart;
        };
        chart.forceX = function(_) {
            if (!arguments.length) return forceX;
            forceX = _;
            return chart;
        };
        chart.forceY = function(_) {
            if (!arguments.length) return forceY;
            forceY = _;
            return chart;
        };
        chart.padData = function(_) {
            if (!arguments.length) return padData;
            padData = _;
            return chart;
        };
        chart.clipEdge = function(_) {
            if (!arguments.length) return clipEdge;
            clipEdge = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = nv.utils.getColor(_);
            return chart;
        };
        chart.id = function(_) {
            if (!arguments.length) return id;
            id = _;
            return chart;
        };
        //============================================================
        return chart;
    };
    nv.models.pie = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var margin = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }, width = 500, height = 500, getX1 = function(d) {
            return d.x;
        }, getY1 = function(d) {
            return d.y;
        }, getDescription = function(d) {
            return d.description;
        }, id = Math.floor(Math.random() * 10000) //Create semi-unique ID in case user doesn't select one
        , color = nv.utils.defaultColor(), valueFormat = $9175b321012dc0d3$var$d3.format(',.2f'), showLabels = true, pieLabelsOutside = true, donutLabelsOutside = false, labelType = "key", labelThreshold = .02 //if slice percentage is under this, don't show label
        , donut = false, labelSunbeamLayout = false, startAngle = false, endAngle = false, donutRatio = 0.5, dispatch = $9175b321012dc0d3$var$d3.dispatch('chartClick', 'elementClick', 'elementDblClick', 'elementMouseover', 'elementMouseout');
        //============================================================
        function chart(selection) {
            selection.each(function(data) {
                var availableWidth = width - margin.left - margin.right, availableHeight = height - margin.top - margin.bottom, radius = Math.min(availableWidth, availableHeight) / 2, arcRadius = radius - radius / 5, container = $9175b321012dc0d3$var$d3.select(this);
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                //var wrap = container.selectAll('.nv-wrap.nv-pie').data([data]);
                var wrap = container.selectAll('.nv-wrap.nv-pie').data(data);
                var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-pie nv-chart-' + id);
                var gEnter = wrapEnter.append('g');
                var g = wrap.select('g');
                gEnter.append('g').attr('class', 'nv-pie');
                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                g.select('.nv-pie').attr('transform', 'translate(' + availableWidth / 2 + ',' + availableHeight / 2 + ')');
                //------------------------------------------------------------
                container.on('click', function(d, i) {
                    dispatch.chartClick({
                        data: d,
                        index: i,
                        pos: $9175b321012dc0d3$var$d3.event,
                        id: id
                    });
                });
                var arc = $9175b321012dc0d3$var$d3.svg.arc().outerRadius(arcRadius);
                if (startAngle) arc.startAngle(startAngle);
                if (endAngle) arc.endAngle(endAngle);
                if (donut) arc.innerRadius(radius * donutRatio);
                // Setup the Pie chart and choose the data element
                var pie = $9175b321012dc0d3$var$d3.layout.pie().sort(null).value(function(d) {
                    return d.disabled ? 0 : getY1(d);
                });
                var slices = wrap.select('.nv-pie').selectAll('.nv-slice').data(pie);
                slices.exit().remove();
                var ae = slices.enter().append('g').attr('class', 'nv-slice').on('mouseover', function(d, i) {
                    $9175b321012dc0d3$var$d3.select(this).classed('hover', true);
                    dispatch.elementMouseover({
                        label: getX1(d.data),
                        value: getY1(d.data),
                        point: d.data,
                        pointIndex: i,
                        pos: [
                            $9175b321012dc0d3$var$d3.event.pageX,
                            $9175b321012dc0d3$var$d3.event.pageY
                        ],
                        id: id
                    });
                }).on('mouseout', function(d, i) {
                    $9175b321012dc0d3$var$d3.select(this).classed('hover', false);
                    dispatch.elementMouseout({
                        label: getX1(d.data),
                        value: getY1(d.data),
                        point: d.data,
                        index: i,
                        id: id
                    });
                }).on('click', function(d, i) {
                    dispatch.elementClick({
                        label: getX1(d.data),
                        value: getY1(d.data),
                        point: d.data,
                        index: i,
                        pos: $9175b321012dc0d3$var$d3.event,
                        id: id
                    });
                    $9175b321012dc0d3$var$d3.event.stopPropagation();
                }).on('dblclick', function(d, i) {
                    dispatch.elementDblClick({
                        label: getX1(d.data),
                        value: getY1(d.data),
                        point: d.data,
                        index: i,
                        pos: $9175b321012dc0d3$var$d3.event,
                        id: id
                    });
                    $9175b321012dc0d3$var$d3.event.stopPropagation();
                });
                slices.attr('fill', function(d, i) {
                    return color(d, i);
                }).attr('stroke', function(d, i) {
                    return color(d, i);
                });
                var paths = ae.append('path').each(function(d) {
                    this._current = d;
                });
                //.attr('d', arc);
                $9175b321012dc0d3$var$d3.transition(slices.select('path')).attr('d', arc).attrTween('d', arcTween);
                if (showLabels) {
                    // This does the normal label
                    var labelsArc = $9175b321012dc0d3$var$d3.svg.arc().innerRadius(0);
                    if (pieLabelsOutside) labelsArc = arc;
                    if (donutLabelsOutside) labelsArc = $9175b321012dc0d3$var$d3.svg.arc().outerRadius(arc.outerRadius());
                    ae.append("g").classed("nv-label", true).each(function(d, i) {
                        var group = $9175b321012dc0d3$var$d3.select(this);
                        group.attr('transform', function(d) {
                            if (labelSunbeamLayout) {
                                d.outerRadius = arcRadius + 10; // Set Outer Coordinate
                                d.innerRadius = arcRadius + 15; // Set Inner Coordinate
                                var rotateAngle = (d.startAngle + d.endAngle) / 2 * (180 / Math.PI);
                                if ((d.startAngle + d.endAngle) / 2 < Math.PI) rotateAngle -= 90;
                                else rotateAngle += 90;
                                return 'translate(' + labelsArc.centroid(d) + ') rotate(' + rotateAngle + ')';
                            } else {
                                d.outerRadius = radius + 10; // Set Outer Coordinate
                                d.innerRadius = radius + 15; // Set Inner Coordinate
                                return 'translate(' + labelsArc.centroid(d) + ')';
                            }
                        });
                        group.append('rect').style('stroke', '#fff').style('fill', '#fff').attr("rx", 3).attr("ry", 3);
                        group.append('text').style('text-anchor', labelSunbeamLayout ? (d.startAngle + d.endAngle) / 2 < Math.PI ? 'start' : 'end' : 'middle') //center the text on it's origin or begin/end if orthogonal aligned
                        .style('fill', '#000');
                    });
                    slices.select(".nv-label").transition().attr('transform', function(d) {
                        if (labelSunbeamLayout) {
                            d.outerRadius = arcRadius + 10; // Set Outer Coordinate
                            d.innerRadius = arcRadius + 15; // Set Inner Coordinate
                            var rotateAngle = (d.startAngle + d.endAngle) / 2 * (180 / Math.PI);
                            if ((d.startAngle + d.endAngle) / 2 < Math.PI) rotateAngle -= 90;
                            else rotateAngle += 90;
                            return 'translate(' + labelsArc.centroid(d) + ') rotate(' + rotateAngle + ')';
                        } else {
                            d.outerRadius = radius + 10; // Set Outer Coordinate
                            d.innerRadius = radius + 15; // Set Inner Coordinate
                            return 'translate(' + labelsArc.centroid(d) + ')';
                        }
                    });
                    slices.each(function(d, i) {
                        var slice = $9175b321012dc0d3$var$d3.select(this);
                        slice.select(".nv-label text").style('text-anchor', labelSunbeamLayout ? (d.startAngle + d.endAngle) / 2 < Math.PI ? 'start' : 'end' : 'middle') //center the text on it's origin or begin/end if orthogonal aligned
                        .text(function(d, i) {
                            var percent = (d.endAngle - d.startAngle) / (2 * Math.PI);
                            var labelTypes = {
                                "key": getX1(d.data),
                                "value": getY1(d.data),
                                "percent": $9175b321012dc0d3$var$d3.format('%')(percent)
                            };
                            return d.value && percent > labelThreshold ? labelTypes[labelType] : '';
                        });
                        var textBox = slice.select('text').node().getBBox();
                        slice.select(".nv-label rect").attr("width", textBox.width + 10).attr("height", textBox.height + 10).attr("transform", function() {
                            return "translate(" + [
                                textBox.x - 5,
                                textBox.y - 5
                            ] + ")";
                        });
                    });
                }
                // Computes the angle of an arc, converting from radians to degrees.
                function angle(d) {
                    var a = (d.startAngle + d.endAngle) * 90 / Math.PI - 90;
                    return a > 90 ? a - 180 : a;
                }
                function arcTween(a) {
                    a.endAngle = isNaN(a.endAngle) ? 0 : a.endAngle;
                    a.startAngle = isNaN(a.startAngle) ? 0 : a.startAngle;
                    if (!donut) a.innerRadius = 0;
                    var i = $9175b321012dc0d3$var$d3.interpolate(this._current, a);
                    this._current = i(0);
                    return function(t) {
                        return arc(i(t));
                    };
                }
                function tweenPie(b1) {
                    b1.innerRadius = 0;
                    var i = $9175b321012dc0d3$var$d3.interpolate({
                        startAngle: 0,
                        endAngle: 0
                    }, b1);
                    return function(t) {
                        return arc(i(t));
                    };
                }
            });
            return chart;
        }
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        chart.dispatch = dispatch;
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.values = function(_) {
            nv.log("pie.values() is no longer supported.");
            return chart;
        };
        chart.x = function(_) {
            if (!arguments.length) return getX1;
            getX1 = _;
            return chart;
        };
        chart.y = function(_) {
            if (!arguments.length) return getY1;
            getY1 = $9175b321012dc0d3$var$d3.functor(_);
            return chart;
        };
        chart.description = function(_) {
            if (!arguments.length) return getDescription;
            getDescription = _;
            return chart;
        };
        chart.showLabels = function(_) {
            if (!arguments.length) return showLabels;
            showLabels = _;
            return chart;
        };
        chart.labelSunbeamLayout = function(_) {
            if (!arguments.length) return labelSunbeamLayout;
            labelSunbeamLayout = _;
            return chart;
        };
        chart.donutLabelsOutside = function(_) {
            if (!arguments.length) return donutLabelsOutside;
            donutLabelsOutside = _;
            return chart;
        };
        chart.pieLabelsOutside = function(_) {
            if (!arguments.length) return pieLabelsOutside;
            pieLabelsOutside = _;
            return chart;
        };
        chart.labelType = function(_) {
            if (!arguments.length) return labelType;
            labelType = _;
            labelType = labelType || "key";
            return chart;
        };
        chart.donut = function(_) {
            if (!arguments.length) return donut;
            donut = _;
            return chart;
        };
        chart.donutRatio = function(_) {
            if (!arguments.length) return donutRatio;
            donutRatio = _;
            return chart;
        };
        chart.startAngle = function(_) {
            if (!arguments.length) return startAngle;
            startAngle = _;
            return chart;
        };
        chart.endAngle = function(_) {
            if (!arguments.length) return endAngle;
            endAngle = _;
            return chart;
        };
        chart.id = function(_) {
            if (!arguments.length) return id;
            id = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = nv.utils.getColor(_);
            return chart;
        };
        chart.valueFormat = function(_) {
            if (!arguments.length) return valueFormat;
            valueFormat = _;
            return chart;
        };
        chart.labelThreshold = function(_) {
            if (!arguments.length) return labelThreshold;
            labelThreshold = _;
            return chart;
        };
        //============================================================
        return chart;
    };
    nv.models.pieChart = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var pie = nv.models.pie(), legend = nv.models.legend();
        var margin = {
            top: 30,
            right: 20,
            bottom: 20,
            left: 20
        }, width = null, height = null, showLegend = true, color = nv.utils.defaultColor(), tooltips = true, tooltip = function(key, y, e, graph) {
            return '<h3>' + key + '</h3>' + '<p>' + y + '</p>';
        }, state = {}, defaultState = null, noData = "No Data Available.", dispatch = $9175b321012dc0d3$var$d3.dispatch('tooltipShow', 'tooltipHide', 'stateChange', 'changeState');
        //============================================================
        //============================================================
        // Private Variables
        //------------------------------------------------------------
        var showTooltip = function(e, offsetElement) {
            var tooltipLabel = pie.description()(e.point) || pie.x()(e.point);
            var left = e.pos[0] + (offsetElement && offsetElement.offsetLeft || 0), top = e.pos[1] + (offsetElement && offsetElement.offsetTop || 0), y = pie.valueFormat()(pie.y()(e.point)), content = tooltip(tooltipLabel, y, e, chart);
            nv.tooltip.show([
                left,
                top
            ], content, e.value < 0 ? 'n' : 's', null, offsetElement);
        };
        //============================================================
        function chart(selection) {
            selection.each(function(data) {
                var container = $9175b321012dc0d3$var$d3.select(this), that = this;
                var availableWidth = (width || parseInt(container.style('width')) || 960) - margin.left - margin.right, availableHeight = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom;
                chart.update = function() {
                    container.transition().call(chart);
                };
                chart.container = this;
                //set state.disabled
                state.disabled = data.map(function(d) {
                    return !!d.disabled;
                });
                if (!defaultState) {
                    var key;
                    defaultState = {};
                    for(key in state)if (state[key] instanceof Array) defaultState[key] = state[key].slice(0);
                    else defaultState[key] = state[key];
                }
                //------------------------------------------------------------
                // Display No Data message if there's nothing to show.
                if (!data || !data.length) {
                    var noDataText = container.selectAll('.nv-noData').data([
                        noData
                    ]);
                    noDataText.enter().append('text').attr('class', 'nvd3 nv-noData').attr('dy', '-.7em').style('text-anchor', 'middle');
                    noDataText.attr('x', margin.left + availableWidth / 2).attr('y', margin.top + availableHeight / 2).text(function(d) {
                        return d;
                    });
                    return chart;
                } else container.selectAll('.nv-noData').remove();
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = container.selectAll('g.nv-wrap.nv-pieChart').data([
                    data
                ]);
                var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-pieChart').append('g');
                var g = wrap.select('g');
                gEnter.append('g').attr('class', 'nv-pieWrap');
                gEnter.append('g').attr('class', 'nv-legendWrap');
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Legend
                if (showLegend) {
                    legend.width(availableWidth).key(pie.x());
                    wrap.select('.nv-legendWrap').datum(data).call(legend);
                    if (margin.top != legend.height()) {
                        margin.top = legend.height();
                        availableHeight = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom;
                    }
                    wrap.select('.nv-legendWrap').attr('transform', 'translate(0,' + -margin.top + ')');
                }
                //------------------------------------------------------------
                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                //------------------------------------------------------------
                // Main Chart Component(s)
                pie.width(availableWidth).height(availableHeight);
                var pieWrap = g.select('.nv-pieWrap').datum([
                    data
                ]);
                $9175b321012dc0d3$var$d3.transition(pieWrap).call(pie);
                //------------------------------------------------------------
                //============================================================
                // Event Handling/Dispatching (in chart's scope)
                //------------------------------------------------------------
                legend.dispatch.on('stateChange', function(newState) {
                    state = newState;
                    dispatch.stateChange(state);
                    chart.update();
                });
                pie.dispatch.on('elementMouseout.tooltip', function(e) {
                    dispatch.tooltipHide(e);
                });
                // Update chart from a state object passed to event handler
                dispatch.on('changeState', function(e) {
                    if (typeof e.disabled !== 'undefined') {
                        data.forEach(function(series, i) {
                            series.disabled = e.disabled[i];
                        });
                        state.disabled = e.disabled;
                    }
                    chart.update();
                });
            //============================================================
            });
            return chart;
        }
        //============================================================
        // Event Handling/Dispatching (out of chart's scope)
        //------------------------------------------------------------
        pie.dispatch.on('elementMouseover.tooltip', function(e) {
            e.pos = [
                e.pos[0] + margin.left,
                e.pos[1] + margin.top
            ];
            dispatch.tooltipShow(e);
        });
        dispatch.on('tooltipShow', function(e) {
            if (tooltips) showTooltip(e);
        });
        dispatch.on('tooltipHide', function() {
            if (tooltips) nv.tooltip.cleanup();
        });
        //============================================================
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        // expose chart's sub-components
        chart.legend = legend;
        chart.dispatch = dispatch;
        chart.pie = pie;
        $9175b321012dc0d3$var$d3.rebind(chart, pie, 'valueFormat', 'values', 'x', 'y', 'description', 'id', 'showLabels', 'donutLabelsOutside', 'pieLabelsOutside', 'labelType', 'donut', 'donutRatio', 'labelThreshold');
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = nv.utils.getColor(_);
            legend.color(color);
            pie.color(color);
            return chart;
        };
        chart.showLegend = function(_) {
            if (!arguments.length) return showLegend;
            showLegend = _;
            return chart;
        };
        chart.tooltips = function(_) {
            if (!arguments.length) return tooltips;
            tooltips = _;
            return chart;
        };
        chart.tooltipContent = function(_) {
            if (!arguments.length) return tooltip;
            tooltip = _;
            return chart;
        };
        chart.state = function(_) {
            if (!arguments.length) return state;
            state = _;
            return chart;
        };
        chart.defaultState = function(_) {
            if (!arguments.length) return defaultState;
            defaultState = _;
            return chart;
        };
        chart.noData = function(_) {
            if (!arguments.length) return noData;
            noData = _;
            return chart;
        };
        //============================================================
        return chart;
    };
    nv.models.scatter = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var margin = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }, width = 960, height = 500, color = nv.utils.defaultColor() // chooses color
        , id = Math.floor(Math.random() * 100000) //Create semi-unique ID incase user doesn't select one
        , x = $9175b321012dc0d3$var$d3.scale.linear(), y = $9175b321012dc0d3$var$d3.scale.linear(), z = $9175b321012dc0d3$var$d3.scale.linear() //linear because d3.svg.shape.size is treated as area
        , getX1 = function(d) {
            return d.x;
        } // accessor to get the x value
        , getY1 = function(d) {
            return d.y;
        } // accessor to get the y value
        , getSize = function(d) {
            return d.size || 1;
        } // accessor to get the point size
        , getShape = function(d) {
            return d.shape || 'circle';
        } // accessor to get point shape
        , onlyCircles = true // Set to false to use shapes
        , forceX = [] // List of numbers to Force into the X scale (ie. 0, or a max / min, etc.)
        , forceY = [] // List of numbers to Force into the Y scale
        , forceSize = [] // List of numbers to Force into the Size scale
        , interactive = true // If true, plots a voronoi overlay for advanced point intersection
        , pointKey = null, pointActive = function(d) {
            return !d.notActive;
        } // any points that return false will be filtered out
        , padData = false // If true, adds half a data points width to front and back, for lining up a line chart with a bar chart
        , padDataOuter = .1 //outerPadding to imitate ordinal scale outer padding
        , clipEdge = false // if true, masks points within x and y scale
        , clipVoronoi = true // if true, masks each point with a circle... can turn off to slightly increase performance
        , clipRadius = function() {
            return 25;
        } // function to get the radius for voronoi point clips
        , xDomain = null // Override x domain (skips the calculation from data)
        , yDomain = null // Override y domain
        , xRange = null // Override x range
        , yRange = null // Override y range
        , sizeDomain = null // Override point size domain
        , sizeRange = null, singlePoint1 = false, dispatch = $9175b321012dc0d3$var$d3.dispatch('elementClick', 'elementMouseover', 'elementMouseout'), useVoronoi = true;
        //============================================================
        //============================================================
        // Private Variables
        //------------------------------------------------------------
        var x0, y0, z0 // used to store previous scales
        , timeoutID, needsUpdate = false // Flag for when the points are visually updating, but the interactive layer is behind, to disable tooltips
        ;
        //============================================================
        function chart(selection) {
            selection.each(function(data) {
                var availableWidth = width - margin.left - margin.right, availableHeight = height - margin.top - margin.bottom, container = $9175b321012dc0d3$var$d3.select(this);
                //add series index to each data point for reference
                data = data.map(function(series, i) {
                    series.values = series.values.map(function(point) {
                        point.series = i;
                        return point;
                    });
                    return series;
                });
                //------------------------------------------------------------
                // Setup Scales
                // remap and flatten the data for use in calculating the scales' domains
                var seriesData = xDomain && yDomain && sizeDomain ? [] : $9175b321012dc0d3$var$d3.merge(data.map(function(d) {
                    return d.values.map(function(d, i) {
                        return {
                            x: getX1(d, i),
                            y: getY1(d, i),
                            size: getSize(d, i)
                        };
                    });
                }));
                x.domain(xDomain || $9175b321012dc0d3$var$d3.extent(seriesData.map(function(d) {
                    return d.x;
                }).concat(forceX)));
                if (padData && data[0]) x.range(xRange || [
                    (availableWidth * padDataOuter + availableWidth) / (2 * data[0].values.length),
                    availableWidth - availableWidth * (1 + padDataOuter) / (2 * data[0].values.length)
                ]);
                else x.range(xRange || [
                    0,
                    availableWidth
                ]);
                y.domain(yDomain || $9175b321012dc0d3$var$d3.extent(seriesData.map(function(d) {
                    return d.y;
                }).concat(forceY))).range(yRange || [
                    availableHeight,
                    0
                ]);
                z.domain(sizeDomain || $9175b321012dc0d3$var$d3.extent(seriesData.map(function(d) {
                    return d.size;
                }).concat(forceSize))).range(sizeRange || [
                    16,
                    256
                ]);
                // If scale's domain don't have a range, slightly adjust to make one... so a chart can show a single data point
                if (x.domain()[0] === x.domain()[1] || y.domain()[0] === y.domain()[1]) singlePoint1 = true;
                if (x.domain()[0] === x.domain()[1]) x.domain()[0] ? x.domain([
                    x.domain()[0] - x.domain()[0] * 0.01,
                    x.domain()[1] + x.domain()[1] * 0.01
                ]) : x.domain([
                    -1,
                    1
                ]);
                if (y.domain()[0] === y.domain()[1]) y.domain()[0] ? y.domain([
                    y.domain()[0] - y.domain()[0] * 0.01,
                    y.domain()[1] + y.domain()[1] * 0.01
                ]) : y.domain([
                    -1,
                    1
                ]);
                if (isNaN(x.domain()[0])) x.domain([
                    -1,
                    1
                ]);
                if (isNaN(y.domain()[0])) y.domain([
                    -1,
                    1
                ]);
                x0 = x0 || x;
                y0 = y0 || y;
                z0 = z0 || z;
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = container.selectAll('g.nv-wrap.nv-scatter').data([
                    data
                ]);
                var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-scatter nv-chart-' + id + (singlePoint1 ? ' nv-single-point' : ''));
                var defsEnter = wrapEnter.append('defs');
                var gEnter = wrapEnter.append('g');
                var g = wrap.select('g');
                gEnter.append('g').attr('class', 'nv-groups');
                gEnter.append('g').attr('class', 'nv-point-paths');
                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                //------------------------------------------------------------
                defsEnter.append('clipPath').attr('id', 'nv-edge-clip-' + id).append('rect');
                wrap.select('#nv-edge-clip-' + id + ' rect').attr('width', availableWidth).attr('height', availableHeight);
                g.attr('clip-path', clipEdge ? 'url(#nv-edge-clip-' + id + ')' : '');
                function updateInteractiveLayer() {
                    if (!interactive) return false;
                    var eventElements;
                    var vertices = $9175b321012dc0d3$var$d3.merge(data.map(function(group, groupIndex) {
                        return group.values.map(function(point, pointIndex) {
                            // *Adding noise to make duplicates very unlikely
                            // *Injecting series and point index for reference
                            /* *Adding a 'jitter' to the points, because there's an issue in d3.geom.voronoi.
                */ var pX = getX1(point, pointIndex);
                            var pY = getY1(point, pointIndex);
                            return [
                                x(pX) + Math.random() * 1e-7,
                                y(pY) + Math.random() * 1e-7,
                                groupIndex,
                                pointIndex,
                                point
                            ]; //temp hack to add noise untill I think of a better way so there are no duplicates
                        }).filter(function(pointArray, pointIndex) {
                            return pointActive(pointArray[4], pointIndex); // Issue #237.. move filter to after map, so pointIndex is correct!
                        });
                    }));
                    //inject series and point index for reference into voronoi
                    if (useVoronoi === true) {
                        if (clipVoronoi) {
                            var pointClipsEnter = wrap.select('defs').selectAll('.nv-point-clips').data([
                                id
                            ]).enter();
                            pointClipsEnter.append('clipPath').attr('class', 'nv-point-clips').attr('id', 'nv-points-clip-' + id);
                            var pointClips = wrap.select('#nv-points-clip-' + id).selectAll('circle').data(vertices);
                            pointClips.enter().append('circle').attr('r', clipRadius);
                            pointClips.exit().remove();
                            pointClips.attr('cx', function(d) {
                                return d[0];
                            }).attr('cy', function(d) {
                                return d[1];
                            });
                            wrap.select('.nv-point-paths').attr('clip-path', 'url(#nv-points-clip-' + id + ')');
                        }
                        if (vertices.length) {
                            // Issue #283 - Adding 2 dummy points to the voronoi b/c voronoi requires min 3 points to work
                            vertices.push([
                                x.range()[0] - 20,
                                y.range()[0] - 20,
                                null,
                                null
                            ]);
                            vertices.push([
                                x.range()[1] + 20,
                                y.range()[1] + 20,
                                null,
                                null
                            ]);
                            vertices.push([
                                x.range()[0] - 20,
                                y.range()[0] + 20,
                                null,
                                null
                            ]);
                            vertices.push([
                                x.range()[1] + 20,
                                y.range()[1] - 20,
                                null,
                                null
                            ]);
                        }
                        var bounds = $9175b321012dc0d3$var$d3.geom.polygon([
                            [
                                -10,
                                -10
                            ],
                            [
                                -10,
                                height + 10
                            ],
                            [
                                width + 10,
                                height + 10
                            ],
                            [
                                width + 10,
                                -10
                            ]
                        ]);
                        var voronoi = $9175b321012dc0d3$var$d3.geom.voronoi(vertices).map(function(d, i) {
                            return {
                                'data': bounds.clip(d),
                                'series': vertices[i][2],
                                'point': vertices[i][3]
                            };
                        });
                        var pointPaths = wrap.select('.nv-point-paths').selectAll('path').data(voronoi);
                        pointPaths.enter().append('path').attr('class', function(d, i) {
                            return 'nv-path-' + i;
                        });
                        pointPaths.exit().remove();
                        pointPaths.attr('d', function(d) {
                            if (d.data.length === 0) return 'M 0 0';
                            else return 'M' + d.data.join('L') + 'Z';
                        });
                        var mouseEventCallback = function(d, mDispatch) {
                            if (needsUpdate) return 0;
                            var series = data[d.series];
                            if (typeof series === 'undefined') return;
                            var point = series.values[d.point];
                            mDispatch({
                                point: point,
                                series: series,
                                pos: [
                                    x(getX1(point, d.point)) + margin.left,
                                    y(getY1(point, d.point)) + margin.top
                                ],
                                seriesIndex: d.series,
                                pointIndex: d.point
                            });
                        };
                        pointPaths.on('click', function(d) {
                            mouseEventCallback(d, dispatch.elementClick);
                        }).on('mouseover', function(d) {
                            mouseEventCallback(d, dispatch.elementMouseover);
                        }).on('mouseout', function(d, i) {
                            mouseEventCallback(d, dispatch.elementMouseout);
                        });
                    } else /*
          // bring data in form needed for click handlers
          var dataWithPoints = vertices.map(function(d, i) {
              return {
                'data': d,
                'series': vertices[i][2],
                'point': vertices[i][3]
              }
            });
           */ // add event handlers to points instead voronoi paths
                    wrap.select('.nv-groups').selectAll('.nv-group').selectAll('.nv-point')//.data(dataWithPoints)
                    //.style('pointer-events', 'auto') // recativate events, disabled by css
                    .on('click', function(d, i) {
                        //nv.log('test', d, i);
                        if (needsUpdate || !data[d.series]) return 0; //check if this is a dummy point
                        var series = data[d.series], point = series.values[i];
                        dispatch.elementClick({
                            point: point,
                            series: series,
                            pos: [
                                x(getX1(point, i)) + margin.left,
                                y(getY1(point, i)) + margin.top
                            ],
                            seriesIndex: d.series,
                            pointIndex: i
                        });
                    }).on('mouseover', function(d, i) {
                        if (needsUpdate || !data[d.series]) return 0; //check if this is a dummy point
                        var series = data[d.series], point = series.values[i];
                        dispatch.elementMouseover({
                            point: point,
                            series: series,
                            pos: [
                                x(getX1(point, i)) + margin.left,
                                y(getY1(point, i)) + margin.top
                            ],
                            seriesIndex: d.series,
                            pointIndex: i
                        });
                    }).on('mouseout', function(d, i) {
                        if (needsUpdate || !data[d.series]) return 0; //check if this is a dummy point
                        var series = data[d.series], point = series.values[i];
                        dispatch.elementMouseout({
                            point: point,
                            series: series,
                            seriesIndex: d.series,
                            pointIndex: i
                        });
                    });
                    needsUpdate = false;
                }
                needsUpdate = true;
                var groups = wrap.select('.nv-groups').selectAll('.nv-group').data(function(d) {
                    return d;
                }, function(d) {
                    return d.key;
                });
                groups.enter().append('g').style('stroke-opacity', 1e-6).style('fill-opacity', 1e-6);
                groups.exit().remove();
                groups.attr('class', function(d, i) {
                    return 'nv-group nv-series-' + i;
                }).classed('hover', function(d) {
                    return d.hover;
                });
                groups.transition().style('fill', function(d, i) {
                    return color(d, i);
                }).style('stroke', function(d, i) {
                    return color(d, i);
                }).style('stroke-opacity', 1).style('fill-opacity', .5);
                if (onlyCircles) {
                    var points = groups.selectAll('circle.nv-point').data(function(d) {
                        return d.values;
                    }, pointKey);
                    points.enter().append('circle').style('fill', function(d, i) {
                        return d.color;
                    }).style('stroke', function(d, i) {
                        return d.color;
                    }).attr('cx', function(d, i) {
                        return nv.utils.NaNtoZero(x0(getX1(d, i)));
                    }).attr('cy', function(d, i) {
                        return nv.utils.NaNtoZero(y0(getY1(d, i)));
                    }).attr('r', function(d, i) {
                        return Math.sqrt(z(getSize(d, i)) / Math.PI);
                    });
                    points.exit().remove();
                    groups.exit().selectAll('path.nv-point').transition().attr('cx', function(d, i) {
                        return nv.utils.NaNtoZero(x(getX1(d, i)));
                    }).attr('cy', function(d, i) {
                        return nv.utils.NaNtoZero(y(getY1(d, i)));
                    }).remove();
                    points.each(function(d, i) {
                        $9175b321012dc0d3$var$d3.select(this).classed('nv-point', true).classed('nv-point-' + i, true).classed('hover', false);
                    });
                    points.transition().attr('cx', function(d, i) {
                        return nv.utils.NaNtoZero(x(getX1(d, i)));
                    }).attr('cy', function(d, i) {
                        return nv.utils.NaNtoZero(y(getY1(d, i)));
                    }).attr('r', function(d, i) {
                        return Math.sqrt(z(getSize(d, i)) / Math.PI);
                    });
                } else {
                    var points = groups.selectAll('path.nv-point').data(function(d) {
                        return d.values;
                    });
                    points.enter().append('path').style('fill', function(d, i) {
                        return d.color;
                    }).style('stroke', function(d, i) {
                        return d.color;
                    }).attr('transform', function(d, i) {
                        return 'translate(' + x0(getX1(d, i)) + ',' + y0(getY1(d, i)) + ')';
                    }).attr('d', $9175b321012dc0d3$var$d3.svg.symbol().type(getShape).size(function(d, i) {
                        return z(getSize(d, i));
                    }));
                    points.exit().remove();
                    groups.exit().selectAll('path.nv-point').transition().attr('transform', function(d, i) {
                        return 'translate(' + x(getX1(d, i)) + ',' + y(getY1(d, i)) + ')';
                    }).remove();
                    points.each(function(d, i) {
                        $9175b321012dc0d3$var$d3.select(this).classed('nv-point', true).classed('nv-point-' + i, true).classed('hover', false);
                    });
                    points.transition().attr('transform', function(d, i) {
                        //nv.log(d,i,getX(d,i), x(getX(d,i)));
                        return 'translate(' + x(getX1(d, i)) + ',' + y(getY1(d, i)) + ')';
                    }).attr('d', $9175b321012dc0d3$var$d3.svg.symbol().type(getShape).size(function(d, i) {
                        return z(getSize(d, i));
                    }));
                }
                // Delay updating the invisible interactive layer for smoother animation
                clearTimeout(timeoutID); // stop repeat calls to updateInteractiveLayer
                timeoutID = setTimeout(updateInteractiveLayer, 300);
                //updateInteractiveLayer();
                //store old scales for use in transitions on update
                x0 = x.copy();
                y0 = y.copy();
                z0 = z.copy();
            });
            return chart;
        }
        //============================================================
        // Event Handling/Dispatching (out of chart's scope)
        //------------------------------------------------------------
        chart.clearHighlights = function() {
            //Remove the 'hover' class from all highlighted points.
            $9175b321012dc0d3$var$d3.selectAll(".nv-chart-" + id + " .nv-point.hover").classed("hover", false);
        };
        chart.highlightPoint = function(seriesIndex, pointIndex, isHoverOver) {
            $9175b321012dc0d3$var$d3.select(".nv-chart-" + id + " .nv-series-" + seriesIndex + " .nv-point-" + pointIndex).classed("hover", isHoverOver);
        };
        dispatch.on('elementMouseover.point', function(d) {
            if (interactive) chart.highlightPoint(d.seriesIndex, d.pointIndex, true);
        });
        dispatch.on('elementMouseout.point', function(d) {
            if (interactive) chart.highlightPoint(d.seriesIndex, d.pointIndex, false);
        });
        //============================================================
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        chart.dispatch = dispatch;
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.x = function(_) {
            if (!arguments.length) return getX1;
            getX1 = $9175b321012dc0d3$var$d3.functor(_);
            return chart;
        };
        chart.y = function(_) {
            if (!arguments.length) return getY1;
            getY1 = $9175b321012dc0d3$var$d3.functor(_);
            return chart;
        };
        chart.size = function(_) {
            if (!arguments.length) return getSize;
            getSize = $9175b321012dc0d3$var$d3.functor(_);
            return chart;
        };
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.xScale = function(_) {
            if (!arguments.length) return x;
            x = _;
            return chart;
        };
        chart.yScale = function(_) {
            if (!arguments.length) return y;
            y = _;
            return chart;
        };
        chart.zScale = function(_) {
            if (!arguments.length) return z;
            z = _;
            return chart;
        };
        chart.xDomain = function(_) {
            if (!arguments.length) return xDomain;
            xDomain = _;
            return chart;
        };
        chart.yDomain = function(_) {
            if (!arguments.length) return yDomain;
            yDomain = _;
            return chart;
        };
        chart.sizeDomain = function(_) {
            if (!arguments.length) return sizeDomain;
            sizeDomain = _;
            return chart;
        };
        chart.xRange = function(_) {
            if (!arguments.length) return xRange;
            xRange = _;
            return chart;
        };
        chart.yRange = function(_) {
            if (!arguments.length) return yRange;
            yRange = _;
            return chart;
        };
        chart.sizeRange = function(_) {
            if (!arguments.length) return sizeRange;
            sizeRange = _;
            return chart;
        };
        chart.forceX = function(_) {
            if (!arguments.length) return forceX;
            forceX = _;
            return chart;
        };
        chart.forceY = function(_) {
            if (!arguments.length) return forceY;
            forceY = _;
            return chart;
        };
        chart.forceSize = function(_) {
            if (!arguments.length) return forceSize;
            forceSize = _;
            return chart;
        };
        chart.interactive = function(_) {
            if (!arguments.length) return interactive;
            interactive = _;
            return chart;
        };
        chart.pointKey = function(_) {
            if (!arguments.length) return pointKey;
            pointKey = _;
            return chart;
        };
        chart.pointActive = function(_) {
            if (!arguments.length) return pointActive;
            pointActive = _;
            return chart;
        };
        chart.padData = function(_) {
            if (!arguments.length) return padData;
            padData = _;
            return chart;
        };
        chart.padDataOuter = function(_) {
            if (!arguments.length) return padDataOuter;
            padDataOuter = _;
            return chart;
        };
        chart.clipEdge = function(_) {
            if (!arguments.length) return clipEdge;
            clipEdge = _;
            return chart;
        };
        chart.clipVoronoi = function(_) {
            if (!arguments.length) return clipVoronoi;
            clipVoronoi = _;
            return chart;
        };
        chart.useVoronoi = function(_) {
            if (!arguments.length) return useVoronoi;
            useVoronoi = _;
            if (useVoronoi === false) clipVoronoi = false;
            return chart;
        };
        chart.clipRadius = function(_) {
            if (!arguments.length) return clipRadius;
            clipRadius = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = nv.utils.getColor(_);
            return chart;
        };
        chart.shape = function(_) {
            if (!arguments.length) return getShape;
            getShape = _;
            return chart;
        };
        chart.onlyCircles = function(_) {
            if (!arguments.length) return onlyCircles;
            onlyCircles = _;
            return chart;
        };
        chart.id = function(_) {
            if (!arguments.length) return id;
            id = _;
            return chart;
        };
        chart.singlePoint = function(_) {
            if (!arguments.length) return singlePoint1;
            singlePoint1 = _;
            return chart;
        };
        //============================================================
        return chart;
    };
    nv.models.scatterChart = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var scatter1 = nv.models.scatter(), xAxis = nv.models.axis(), yAxis = nv.models.axis(), legend = nv.models.legend(), controls = nv.models.legend(), distX = nv.models.distribution(), distY = nv.models.distribution();
        var margin = {
            top: 30,
            right: 20,
            bottom: 50,
            left: 75
        }, width = null, height = null, color = nv.utils.defaultColor(), x = $9175b321012dc0d3$var$d3.fisheye ? $9175b321012dc0d3$var$d3.fisheye.scale($9175b321012dc0d3$var$d3.scale.linear).distortion(0) : scatter1.xScale(), y = $9175b321012dc0d3$var$d3.fisheye ? $9175b321012dc0d3$var$d3.fisheye.scale($9175b321012dc0d3$var$d3.scale.linear).distortion(0) : scatter1.yScale(), xPadding = 0, yPadding = 0, showDistX = false, showDistY = false, showLegend = true, showXAxis = true, showYAxis = true, rightAlignYAxis = false, showControls = !!$9175b321012dc0d3$var$d3.fisheye, fisheye = 0, pauseFisheye = false, tooltips = true, tooltipX = function(key, x, y) {
            return '<strong>' + x + '</strong>';
        }, tooltipY = function(key, x, y) {
            return '<strong>' + y + '</strong>';
        }, tooltip = null, state = {}, defaultState = null, dispatch = $9175b321012dc0d3$var$d3.dispatch('tooltipShow', 'tooltipHide', 'stateChange', 'changeState'), noData = "No Data Available.", transitionDuration = 250;
        scatter1.xScale(x).yScale(y);
        xAxis.orient('bottom').tickPadding(10);
        yAxis.orient(rightAlignYAxis ? 'right' : 'left').tickPadding(10);
        distX.axis('x');
        distY.axis('y');
        controls.updateState(false);
        //============================================================
        //============================================================
        // Private Variables
        //------------------------------------------------------------
        var x0, y0;
        var showTooltip = function(e, offsetElement) {
            //TODO: make tooltip style an option between single or dual on axes (maybe on all charts with axes?)
            var left = e.pos[0] + (offsetElement.offsetLeft || 0), top = e.pos[1] + (offsetElement.offsetTop || 0), leftX = e.pos[0] + (offsetElement.offsetLeft || 0), topX = y.range()[0] + margin.top + (offsetElement.offsetTop || 0), leftY = x.range()[0] + margin.left + (offsetElement.offsetLeft || 0), topY = e.pos[1] + (offsetElement.offsetTop || 0), xVal = xAxis.tickFormat()(scatter1.x()(e.point, e.pointIndex)), yVal = yAxis.tickFormat()(scatter1.y()(e.point, e.pointIndex));
            if (tooltipX != null) nv.tooltip.show([
                leftX,
                topX
            ], tooltipX(e.series.key, xVal, yVal, e, chart), 'n', 1, offsetElement, 'x-nvtooltip');
            if (tooltipY != null) nv.tooltip.show([
                leftY,
                topY
            ], tooltipY(e.series.key, xVal, yVal, e, chart), 'e', 1, offsetElement, 'y-nvtooltip');
            if (tooltip != null) nv.tooltip.show([
                left,
                top
            ], tooltip(e.series.key, xVal, yVal, e, chart), e.value < 0 ? 'n' : 's', null, offsetElement);
        };
        var controlsData = [
            {
                key: 'Magnify',
                disabled: true
            }
        ];
        //============================================================
        function chart(selection) {
            selection.each(function(data) {
                var container = $9175b321012dc0d3$var$d3.select(this), that = this;
                var availableWidth = (width || parseInt(container.style('width')) || 960) - margin.left - margin.right, availableHeight = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom;
                chart.update = function() {
                    container.transition().duration(transitionDuration).call(chart);
                };
                chart.container = this;
                //set state.disabled
                state.disabled = data.map(function(d) {
                    return !!d.disabled;
                });
                if (!defaultState) {
                    var key;
                    defaultState = {};
                    for(key in state)if (state[key] instanceof Array) defaultState[key] = state[key].slice(0);
                    else defaultState[key] = state[key];
                }
                //------------------------------------------------------------
                // Display noData message if there's nothing to show.
                if (!data || !data.length || !data.filter(function(d) {
                    return d.values.length;
                }).length) {
                    var noDataText = container.selectAll('.nv-noData').data([
                        noData
                    ]);
                    noDataText.enter().append('text').attr('class', 'nvd3 nv-noData').attr('dy', '-.7em').style('text-anchor', 'middle');
                    noDataText.attr('x', margin.left + availableWidth / 2).attr('y', margin.top + availableHeight / 2).text(function(d) {
                        return d;
                    });
                    return chart;
                } else container.selectAll('.nv-noData').remove();
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup Scales
                x0 = x0 || x;
                y0 = y0 || y;
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = container.selectAll('g.nv-wrap.nv-scatterChart').data([
                    data
                ]);
                var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-scatterChart nv-chart-' + scatter1.id());
                var gEnter = wrapEnter.append('g');
                var g = wrap.select('g');
                // background for pointer events
                gEnter.append('rect').attr('class', 'nvd3 nv-background');
                gEnter.append('g').attr('class', 'nv-x nv-axis');
                gEnter.append('g').attr('class', 'nv-y nv-axis');
                gEnter.append('g').attr('class', 'nv-scatterWrap');
                gEnter.append('g').attr('class', 'nv-distWrap');
                gEnter.append('g').attr('class', 'nv-legendWrap');
                gEnter.append('g').attr('class', 'nv-controlsWrap');
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Legend
                if (showLegend) {
                    var legendWidth = showControls ? availableWidth / 2 : availableWidth;
                    legend.width(legendWidth);
                    wrap.select('.nv-legendWrap').datum(data).call(legend);
                    if (margin.top != legend.height()) {
                        margin.top = legend.height();
                        availableHeight = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom;
                    }
                    wrap.select('.nv-legendWrap').attr('transform', 'translate(' + (availableWidth - legendWidth) + ',' + -margin.top + ')');
                }
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Controls
                if (showControls) {
                    controls.width(180).color([
                        '#444'
                    ]);
                    g.select('.nv-controlsWrap').datum(controlsData).attr('transform', 'translate(0,' + -margin.top + ')').call(controls);
                }
                //------------------------------------------------------------
                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                if (rightAlignYAxis) g.select(".nv-y.nv-axis").attr("transform", "translate(" + availableWidth + ",0)");
                //------------------------------------------------------------
                // Main Chart Component(s)
                scatter1.width(availableWidth).height(availableHeight).color(data.map(function(d, i) {
                    return d.color || color(d, i);
                }).filter(function(d, i) {
                    return !data[i].disabled;
                }));
                if (xPadding !== 0) scatter1.xDomain(null);
                if (yPadding !== 0) scatter1.yDomain(null);
                wrap.select('.nv-scatterWrap').datum(data.filter(function(d) {
                    return !d.disabled;
                })).call(scatter1);
                //Adjust for x and y padding
                if (xPadding !== 0) {
                    var xRange = x.domain()[1] - x.domain()[0];
                    scatter1.xDomain([
                        x.domain()[0] - xPadding * xRange,
                        x.domain()[1] + xPadding * xRange
                    ]);
                }
                if (yPadding !== 0) {
                    var yRange = y.domain()[1] - y.domain()[0];
                    scatter1.yDomain([
                        y.domain()[0] - yPadding * yRange,
                        y.domain()[1] + yPadding * yRange
                    ]);
                }
                //Only need to update the scatter again if x/yPadding changed the domain.
                if (yPadding !== 0 || xPadding !== 0) wrap.select('.nv-scatterWrap').datum(data.filter(function(d) {
                    return !d.disabled;
                })).call(scatter1);
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup Axes
                if (showXAxis) {
                    xAxis.scale(x).ticks(xAxis.ticks() && xAxis.ticks().length ? xAxis.ticks() : availableWidth / 100).tickSize(-availableHeight, 0);
                    g.select('.nv-x.nv-axis').attr('transform', 'translate(0,' + y.range()[0] + ')').call(xAxis);
                }
                if (showYAxis) {
                    yAxis.scale(y).ticks(yAxis.ticks() && yAxis.ticks().length ? yAxis.ticks() : availableHeight / 36).tickSize(-availableWidth, 0);
                    g.select('.nv-y.nv-axis').call(yAxis);
                }
                if (showDistX) {
                    distX.getData(scatter1.x()).scale(x).width(availableWidth).color(data.map(function(d, i) {
                        return d.color || color(d, i);
                    }).filter(function(d, i) {
                        return !data[i].disabled;
                    }));
                    gEnter.select('.nv-distWrap').append('g').attr('class', 'nv-distributionX');
                    g.select('.nv-distributionX').attr('transform', 'translate(0,' + y.range()[0] + ')').datum(data.filter(function(d) {
                        return !d.disabled;
                    })).call(distX);
                }
                if (showDistY) {
                    distY.getData(scatter1.y()).scale(y).width(availableHeight).color(data.map(function(d, i) {
                        return d.color || color(d, i);
                    }).filter(function(d, i) {
                        return !data[i].disabled;
                    }));
                    gEnter.select('.nv-distWrap').append('g').attr('class', 'nv-distributionY');
                    g.select('.nv-distributionY').attr('transform', 'translate(' + (rightAlignYAxis ? availableWidth : -distY.size()) + ',0)').datum(data.filter(function(d) {
                        return !d.disabled;
                    })).call(distY);
                }
                //------------------------------------------------------------
                if ($9175b321012dc0d3$var$d3.fisheye) {
                    g.select('.nv-background').attr('width', availableWidth).attr('height', availableHeight);
                    g.select('.nv-background').on('mousemove', updateFisheye);
                    g.select('.nv-background').on('click', function() {
                        pauseFisheye = !pauseFisheye;
                    });
                    scatter1.dispatch.on('elementClick.freezeFisheye', function() {
                        pauseFisheye = !pauseFisheye;
                    });
                }
                function updateFisheye() {
                    if (pauseFisheye) {
                        g.select('.nv-point-paths').style('pointer-events', 'all');
                        return false;
                    }
                    g.select('.nv-point-paths').style('pointer-events', 'none');
                    var mouse = $9175b321012dc0d3$var$d3.mouse(this);
                    x.distortion(fisheye).focus(mouse[0]);
                    y.distortion(fisheye).focus(mouse[1]);
                    g.select('.nv-scatterWrap').call(scatter1);
                    if (showXAxis) g.select('.nv-x.nv-axis').call(xAxis);
                    if (showYAxis) g.select('.nv-y.nv-axis').call(yAxis);
                    g.select('.nv-distributionX').datum(data.filter(function(d) {
                        return !d.disabled;
                    })).call(distX);
                    g.select('.nv-distributionY').datum(data.filter(function(d) {
                        return !d.disabled;
                    })).call(distY);
                }
                //============================================================
                // Event Handling/Dispatching (in chart's scope)
                //------------------------------------------------------------
                controls.dispatch.on('legendClick', function(d, i) {
                    d.disabled = !d.disabled;
                    fisheye = d.disabled ? 0 : 2.5;
                    g.select('.nv-background').style('pointer-events', d.disabled ? 'none' : 'all');
                    g.select('.nv-point-paths').style('pointer-events', d.disabled ? 'all' : 'none');
                    if (d.disabled) {
                        x.distortion(fisheye).focus(0);
                        y.distortion(fisheye).focus(0);
                        g.select('.nv-scatterWrap').call(scatter1);
                        g.select('.nv-x.nv-axis').call(xAxis);
                        g.select('.nv-y.nv-axis').call(yAxis);
                    } else pauseFisheye = false;
                    chart.update();
                });
                legend.dispatch.on('stateChange', function(newState) {
                    state.disabled = newState.disabled;
                    dispatch.stateChange(state);
                    chart.update();
                });
                scatter1.dispatch.on('elementMouseover.tooltip', function(e) {
                    $9175b321012dc0d3$var$d3.select('.nv-chart-' + scatter1.id() + ' .nv-series-' + e.seriesIndex + ' .nv-distx-' + e.pointIndex).attr('y1', function(d, i) {
                        return e.pos[1] - availableHeight;
                    });
                    $9175b321012dc0d3$var$d3.select('.nv-chart-' + scatter1.id() + ' .nv-series-' + e.seriesIndex + ' .nv-disty-' + e.pointIndex).attr('x2', e.pos[0] + distX.size());
                    e.pos = [
                        e.pos[0] + margin.left,
                        e.pos[1] + margin.top
                    ];
                    dispatch.tooltipShow(e);
                });
                dispatch.on('tooltipShow', function(e) {
                    if (tooltips) showTooltip(e, that.parentNode);
                });
                // Update chart from a state object passed to event handler
                dispatch.on('changeState', function(e) {
                    if (typeof e.disabled !== 'undefined') {
                        data.forEach(function(series, i) {
                            series.disabled = e.disabled[i];
                        });
                        state.disabled = e.disabled;
                    }
                    chart.update();
                });
                //============================================================
                //store old scales for use in transitions on update
                x0 = x.copy();
                y0 = y.copy();
            });
            return chart;
        }
        //============================================================
        // Event Handling/Dispatching (out of chart's scope)
        //------------------------------------------------------------
        scatter1.dispatch.on('elementMouseout.tooltip', function(e) {
            dispatch.tooltipHide(e);
            $9175b321012dc0d3$var$d3.select('.nv-chart-' + scatter1.id() + ' .nv-series-' + e.seriesIndex + ' .nv-distx-' + e.pointIndex).attr('y1', 0);
            $9175b321012dc0d3$var$d3.select('.nv-chart-' + scatter1.id() + ' .nv-series-' + e.seriesIndex + ' .nv-disty-' + e.pointIndex).attr('x2', distY.size());
        });
        dispatch.on('tooltipHide', function() {
            if (tooltips) nv.tooltip.cleanup();
        });
        //============================================================
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        // expose chart's sub-components
        chart.dispatch = dispatch;
        chart.scatter = scatter1;
        chart.legend = legend;
        chart.controls = controls;
        chart.xAxis = xAxis;
        chart.yAxis = yAxis;
        chart.distX = distX;
        chart.distY = distY;
        $9175b321012dc0d3$var$d3.rebind(chart, scatter1, 'id', 'interactive', 'pointActive', 'x', 'y', 'shape', 'size', 'xScale', 'yScale', 'zScale', 'xDomain', 'yDomain', 'xRange', 'yRange', 'sizeDomain', 'sizeRange', 'forceX', 'forceY', 'forceSize', 'clipVoronoi', 'clipRadius', 'useVoronoi');
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = nv.utils.getColor(_);
            legend.color(color);
            distX.color(color);
            distY.color(color);
            return chart;
        };
        chart.showDistX = function(_) {
            if (!arguments.length) return showDistX;
            showDistX = _;
            return chart;
        };
        chart.showDistY = function(_) {
            if (!arguments.length) return showDistY;
            showDistY = _;
            return chart;
        };
        chart.showControls = function(_) {
            if (!arguments.length) return showControls;
            showControls = _;
            return chart;
        };
        chart.showLegend = function(_) {
            if (!arguments.length) return showLegend;
            showLegend = _;
            return chart;
        };
        chart.showXAxis = function(_) {
            if (!arguments.length) return showXAxis;
            showXAxis = _;
            return chart;
        };
        chart.showYAxis = function(_) {
            if (!arguments.length) return showYAxis;
            showYAxis = _;
            return chart;
        };
        chart.rightAlignYAxis = function(_) {
            if (!arguments.length) return rightAlignYAxis;
            rightAlignYAxis = _;
            yAxis.orient(_ ? 'right' : 'left');
            return chart;
        };
        chart.fisheye = function(_) {
            if (!arguments.length) return fisheye;
            fisheye = _;
            return chart;
        };
        chart.xPadding = function(_) {
            if (!arguments.length) return xPadding;
            xPadding = _;
            return chart;
        };
        chart.yPadding = function(_) {
            if (!arguments.length) return yPadding;
            yPadding = _;
            return chart;
        };
        chart.tooltips = function(_) {
            if (!arguments.length) return tooltips;
            tooltips = _;
            return chart;
        };
        chart.tooltipContent = function(_) {
            if (!arguments.length) return tooltip;
            tooltip = _;
            return chart;
        };
        chart.tooltipXContent = function(_) {
            if (!arguments.length) return tooltipX;
            tooltipX = _;
            return chart;
        };
        chart.tooltipYContent = function(_) {
            if (!arguments.length) return tooltipY;
            tooltipY = _;
            return chart;
        };
        chart.state = function(_) {
            if (!arguments.length) return state;
            state = _;
            return chart;
        };
        chart.defaultState = function(_) {
            if (!arguments.length) return defaultState;
            defaultState = _;
            return chart;
        };
        chart.noData = function(_) {
            if (!arguments.length) return noData;
            noData = _;
            return chart;
        };
        chart.transitionDuration = function(_) {
            if (!arguments.length) return transitionDuration;
            transitionDuration = _;
            return chart;
        };
        //============================================================
        return chart;
    };
    nv.models.scatterPlusLineChart = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var scatter1 = nv.models.scatter(), xAxis = nv.models.axis(), yAxis = nv.models.axis(), legend = nv.models.legend(), controls = nv.models.legend(), distX = nv.models.distribution(), distY = nv.models.distribution();
        var margin = {
            top: 30,
            right: 20,
            bottom: 50,
            left: 75
        }, width = null, height = null, color = nv.utils.defaultColor(), x = $9175b321012dc0d3$var$d3.fisheye ? $9175b321012dc0d3$var$d3.fisheye.scale($9175b321012dc0d3$var$d3.scale.linear).distortion(0) : scatter1.xScale(), y = $9175b321012dc0d3$var$d3.fisheye ? $9175b321012dc0d3$var$d3.fisheye.scale($9175b321012dc0d3$var$d3.scale.linear).distortion(0) : scatter1.yScale(), showDistX = false, showDistY = false, showLegend = true, showXAxis = true, showYAxis = true, rightAlignYAxis = false, showControls = !!$9175b321012dc0d3$var$d3.fisheye, fisheye = 0, pauseFisheye = false, tooltips = true, tooltipX = function(key, x, y) {
            return '<strong>' + x + '</strong>';
        }, tooltipY = function(key, x, y) {
            return '<strong>' + y + '</strong>';
        }, tooltip = function(key, x, y, date) {
            return '<h3>' + key + '</h3>' + '<p>' + date + '</p>';
        }, state = {}, defaultState = null, dispatch = $9175b321012dc0d3$var$d3.dispatch('tooltipShow', 'tooltipHide', 'stateChange', 'changeState'), noData = "No Data Available.", transitionDuration = 250;
        scatter1.xScale(x).yScale(y);
        xAxis.orient('bottom').tickPadding(10);
        yAxis.orient(rightAlignYAxis ? 'right' : 'left').tickPadding(10);
        distX.axis('x');
        distY.axis('y');
        controls.updateState(false);
        //============================================================
        //============================================================
        // Private Variables
        //------------------------------------------------------------
        var x0, y0;
        var showTooltip = function(e, offsetElement) {
            //TODO: make tooltip style an option between single or dual on axes (maybe on all charts with axes?)
            var left = e.pos[0] + (offsetElement.offsetLeft || 0), top = e.pos[1] + (offsetElement.offsetTop || 0), leftX = e.pos[0] + (offsetElement.offsetLeft || 0), topX = y.range()[0] + margin.top + (offsetElement.offsetTop || 0), leftY = x.range()[0] + margin.left + (offsetElement.offsetLeft || 0), topY = e.pos[1] + (offsetElement.offsetTop || 0), xVal = xAxis.tickFormat()(scatter1.x()(e.point, e.pointIndex)), yVal = yAxis.tickFormat()(scatter1.y()(e.point, e.pointIndex));
            if (tooltipX != null) nv.tooltip.show([
                leftX,
                topX
            ], tooltipX(e.series.key, xVal, yVal, e, chart), 'n', 1, offsetElement, 'x-nvtooltip');
            if (tooltipY != null) nv.tooltip.show([
                leftY,
                topY
            ], tooltipY(e.series.key, xVal, yVal, e, chart), 'e', 1, offsetElement, 'y-nvtooltip');
            if (tooltip != null) nv.tooltip.show([
                left,
                top
            ], tooltip(e.series.key, xVal, yVal, e.point.tooltip, e, chart), e.value < 0 ? 'n' : 's', null, offsetElement);
        };
        var controlsData = [
            {
                key: 'Magnify',
                disabled: true
            }
        ];
        //============================================================
        function chart(selection) {
            selection.each(function(data) {
                var container = $9175b321012dc0d3$var$d3.select(this), that = this;
                var availableWidth = (width || parseInt(container.style('width')) || 960) - margin.left - margin.right, availableHeight = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom;
                chart.update = function() {
                    container.transition().duration(transitionDuration).call(chart);
                };
                chart.container = this;
                //set state.disabled
                state.disabled = data.map(function(d) {
                    return !!d.disabled;
                });
                if (!defaultState) {
                    var key;
                    defaultState = {};
                    for(key in state)if (state[key] instanceof Array) defaultState[key] = state[key].slice(0);
                    else defaultState[key] = state[key];
                }
                //------------------------------------------------------------
                // Display noData message if there's nothing to show.
                if (!data || !data.length || !data.filter(function(d) {
                    return d.values.length;
                }).length) {
                    var noDataText = container.selectAll('.nv-noData').data([
                        noData
                    ]);
                    noDataText.enter().append('text').attr('class', 'nvd3 nv-noData').attr('dy', '-.7em').style('text-anchor', 'middle');
                    noDataText.attr('x', margin.left + availableWidth / 2).attr('y', margin.top + availableHeight / 2).text(function(d) {
                        return d;
                    });
                    return chart;
                } else container.selectAll('.nv-noData').remove();
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup Scales
                x = scatter1.xScale();
                y = scatter1.yScale();
                x0 = x0 || x;
                y0 = y0 || y;
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = container.selectAll('g.nv-wrap.nv-scatterChart').data([
                    data
                ]);
                var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-scatterChart nv-chart-' + scatter1.id());
                var gEnter = wrapEnter.append('g');
                var g = wrap.select('g');
                // background for pointer events
                gEnter.append('rect').attr('class', 'nvd3 nv-background').style("pointer-events", "none");
                gEnter.append('g').attr('class', 'nv-x nv-axis');
                gEnter.append('g').attr('class', 'nv-y nv-axis');
                gEnter.append('g').attr('class', 'nv-scatterWrap');
                gEnter.append('g').attr('class', 'nv-regressionLinesWrap');
                gEnter.append('g').attr('class', 'nv-distWrap');
                gEnter.append('g').attr('class', 'nv-legendWrap');
                gEnter.append('g').attr('class', 'nv-controlsWrap');
                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                if (rightAlignYAxis) g.select(".nv-y.nv-axis").attr("transform", "translate(" + availableWidth + ",0)");
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Legend
                if (showLegend) {
                    legend.width(availableWidth / 2);
                    wrap.select('.nv-legendWrap').datum(data).call(legend);
                    if (margin.top != legend.height()) {
                        margin.top = legend.height();
                        availableHeight = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom;
                    }
                    wrap.select('.nv-legendWrap').attr('transform', 'translate(' + availableWidth / 2 + ',' + -margin.top + ')');
                }
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Controls
                if (showControls) {
                    controls.width(180).color([
                        '#444'
                    ]);
                    g.select('.nv-controlsWrap').datum(controlsData).attr('transform', 'translate(0,' + -margin.top + ')').call(controls);
                }
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Main Chart Component(s)
                scatter1.width(availableWidth).height(availableHeight).color(data.map(function(d, i) {
                    return d.color || color(d, i);
                }).filter(function(d, i) {
                    return !data[i].disabled;
                }));
                wrap.select('.nv-scatterWrap').datum(data.filter(function(d) {
                    return !d.disabled;
                })).call(scatter1);
                wrap.select('.nv-regressionLinesWrap').attr('clip-path', 'url(#nv-edge-clip-' + scatter1.id() + ')');
                var regWrap = wrap.select('.nv-regressionLinesWrap').selectAll('.nv-regLines').data(function(d) {
                    return d;
                });
                regWrap.enter().append('g').attr('class', 'nv-regLines');
                var regLine = regWrap.selectAll('.nv-regLine').data(function(d) {
                    return [
                        d
                    ];
                });
                var regLineEnter = regLine.enter().append('line').attr('class', 'nv-regLine').style('stroke-opacity', 0);
                regLine.transition().attr('x1', x.range()[0]).attr('x2', x.range()[1]).attr('y1', function(d, i) {
                    return y(x.domain()[0] * d.slope + d.intercept);
                }).attr('y2', function(d, i) {
                    return y(x.domain()[1] * d.slope + d.intercept);
                }).style('stroke', function(d, i, j) {
                    return color(d, j);
                }).style('stroke-opacity', function(d, i) {
                    return d.disabled || typeof d.slope === 'undefined' || typeof d.intercept === 'undefined' ? 0 : 1;
                });
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup Axes
                if (showXAxis) {
                    xAxis.scale(x).ticks(xAxis.ticks() ? xAxis.ticks() : availableWidth / 100).tickSize(-availableHeight, 0);
                    g.select('.nv-x.nv-axis').attr('transform', 'translate(0,' + y.range()[0] + ')').call(xAxis);
                }
                if (showYAxis) {
                    yAxis.scale(y).ticks(yAxis.ticks() ? yAxis.ticks() : availableHeight / 36).tickSize(-availableWidth, 0);
                    g.select('.nv-y.nv-axis').call(yAxis);
                }
                if (showDistX) {
                    distX.getData(scatter1.x()).scale(x).width(availableWidth).color(data.map(function(d, i) {
                        return d.color || color(d, i);
                    }).filter(function(d, i) {
                        return !data[i].disabled;
                    }));
                    gEnter.select('.nv-distWrap').append('g').attr('class', 'nv-distributionX');
                    g.select('.nv-distributionX').attr('transform', 'translate(0,' + y.range()[0] + ')').datum(data.filter(function(d) {
                        return !d.disabled;
                    })).call(distX);
                }
                if (showDistY) {
                    distY.getData(scatter1.y()).scale(y).width(availableHeight).color(data.map(function(d, i) {
                        return d.color || color(d, i);
                    }).filter(function(d, i) {
                        return !data[i].disabled;
                    }));
                    gEnter.select('.nv-distWrap').append('g').attr('class', 'nv-distributionY');
                    g.select('.nv-distributionY').attr('transform', 'translate(' + (rightAlignYAxis ? availableWidth : -distY.size()) + ',0)').datum(data.filter(function(d) {
                        return !d.disabled;
                    })).call(distY);
                }
                //------------------------------------------------------------
                if ($9175b321012dc0d3$var$d3.fisheye) {
                    g.select('.nv-background').attr('width', availableWidth).attr('height', availableHeight);
                    g.select('.nv-background').on('mousemove', updateFisheye);
                    g.select('.nv-background').on('click', function() {
                        pauseFisheye = !pauseFisheye;
                    });
                    scatter1.dispatch.on('elementClick.freezeFisheye', function() {
                        pauseFisheye = !pauseFisheye;
                    });
                }
                function updateFisheye() {
                    if (pauseFisheye) {
                        g.select('.nv-point-paths').style('pointer-events', 'all');
                        return false;
                    }
                    g.select('.nv-point-paths').style('pointer-events', 'none');
                    var mouse = $9175b321012dc0d3$var$d3.mouse(this);
                    x.distortion(fisheye).focus(mouse[0]);
                    y.distortion(fisheye).focus(mouse[1]);
                    g.select('.nv-scatterWrap').datum(data.filter(function(d) {
                        return !d.disabled;
                    })).call(scatter1);
                    if (showXAxis) g.select('.nv-x.nv-axis').call(xAxis);
                    if (showYAxis) g.select('.nv-y.nv-axis').call(yAxis);
                    g.select('.nv-distributionX').datum(data.filter(function(d) {
                        return !d.disabled;
                    })).call(distX);
                    g.select('.nv-distributionY').datum(data.filter(function(d) {
                        return !d.disabled;
                    })).call(distY);
                }
                //============================================================
                // Event Handling/Dispatching (in chart's scope)
                //------------------------------------------------------------
                controls.dispatch.on('legendClick', function(d, i) {
                    d.disabled = !d.disabled;
                    fisheye = d.disabled ? 0 : 2.5;
                    g.select('.nv-background').style('pointer-events', d.disabled ? 'none' : 'all');
                    g.select('.nv-point-paths').style('pointer-events', d.disabled ? 'all' : 'none');
                    if (d.disabled) {
                        x.distortion(fisheye).focus(0);
                        y.distortion(fisheye).focus(0);
                        g.select('.nv-scatterWrap').call(scatter1);
                        g.select('.nv-x.nv-axis').call(xAxis);
                        g.select('.nv-y.nv-axis').call(yAxis);
                    } else pauseFisheye = false;
                    chart.update();
                });
                legend.dispatch.on('stateChange', function(newState) {
                    state = newState;
                    dispatch.stateChange(state);
                    chart.update();
                });
                scatter1.dispatch.on('elementMouseover.tooltip', function(e) {
                    $9175b321012dc0d3$var$d3.select('.nv-chart-' + scatter1.id() + ' .nv-series-' + e.seriesIndex + ' .nv-distx-' + e.pointIndex).attr('y1', e.pos[1] - availableHeight);
                    $9175b321012dc0d3$var$d3.select('.nv-chart-' + scatter1.id() + ' .nv-series-' + e.seriesIndex + ' .nv-disty-' + e.pointIndex).attr('x2', e.pos[0] + distX.size());
                    e.pos = [
                        e.pos[0] + margin.left,
                        e.pos[1] + margin.top
                    ];
                    dispatch.tooltipShow(e);
                });
                dispatch.on('tooltipShow', function(e) {
                    if (tooltips) showTooltip(e, that.parentNode);
                });
                // Update chart from a state object passed to event handler
                dispatch.on('changeState', function(e) {
                    if (typeof e.disabled !== 'undefined') {
                        data.forEach(function(series, i) {
                            series.disabled = e.disabled[i];
                        });
                        state.disabled = e.disabled;
                    }
                    chart.update();
                });
                //============================================================
                //store old scales for use in transitions on update
                x0 = x.copy();
                y0 = y.copy();
            });
            return chart;
        }
        //============================================================
        // Event Handling/Dispatching (out of chart's scope)
        //------------------------------------------------------------
        scatter1.dispatch.on('elementMouseout.tooltip', function(e) {
            dispatch.tooltipHide(e);
            $9175b321012dc0d3$var$d3.select('.nv-chart-' + scatter1.id() + ' .nv-series-' + e.seriesIndex + ' .nv-distx-' + e.pointIndex).attr('y1', 0);
            $9175b321012dc0d3$var$d3.select('.nv-chart-' + scatter1.id() + ' .nv-series-' + e.seriesIndex + ' .nv-disty-' + e.pointIndex).attr('x2', distY.size());
        });
        dispatch.on('tooltipHide', function() {
            if (tooltips) nv.tooltip.cleanup();
        });
        //============================================================
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        // expose chart's sub-components
        chart.dispatch = dispatch;
        chart.scatter = scatter1;
        chart.legend = legend;
        chart.controls = controls;
        chart.xAxis = xAxis;
        chart.yAxis = yAxis;
        chart.distX = distX;
        chart.distY = distY;
        $9175b321012dc0d3$var$d3.rebind(chart, scatter1, 'id', 'interactive', 'pointActive', 'x', 'y', 'shape', 'size', 'xScale', 'yScale', 'zScale', 'xDomain', 'yDomain', 'xRange', 'yRange', 'sizeDomain', 'sizeRange', 'forceX', 'forceY', 'forceSize', 'clipVoronoi', 'clipRadius', 'useVoronoi');
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = nv.utils.getColor(_);
            legend.color(color);
            distX.color(color);
            distY.color(color);
            return chart;
        };
        chart.showDistX = function(_) {
            if (!arguments.length) return showDistX;
            showDistX = _;
            return chart;
        };
        chart.showDistY = function(_) {
            if (!arguments.length) return showDistY;
            showDistY = _;
            return chart;
        };
        chart.showControls = function(_) {
            if (!arguments.length) return showControls;
            showControls = _;
            return chart;
        };
        chart.showLegend = function(_) {
            if (!arguments.length) return showLegend;
            showLegend = _;
            return chart;
        };
        chart.showXAxis = function(_) {
            if (!arguments.length) return showXAxis;
            showXAxis = _;
            return chart;
        };
        chart.showYAxis = function(_) {
            if (!arguments.length) return showYAxis;
            showYAxis = _;
            return chart;
        };
        chart.rightAlignYAxis = function(_) {
            if (!arguments.length) return rightAlignYAxis;
            rightAlignYAxis = _;
            yAxis.orient(_ ? 'right' : 'left');
            return chart;
        };
        chart.fisheye = function(_) {
            if (!arguments.length) return fisheye;
            fisheye = _;
            return chart;
        };
        chart.tooltips = function(_) {
            if (!arguments.length) return tooltips;
            tooltips = _;
            return chart;
        };
        chart.tooltipContent = function(_) {
            if (!arguments.length) return tooltip;
            tooltip = _;
            return chart;
        };
        chart.tooltipXContent = function(_) {
            if (!arguments.length) return tooltipX;
            tooltipX = _;
            return chart;
        };
        chart.tooltipYContent = function(_) {
            if (!arguments.length) return tooltipY;
            tooltipY = _;
            return chart;
        };
        chart.state = function(_) {
            if (!arguments.length) return state;
            state = _;
            return chart;
        };
        chart.defaultState = function(_) {
            if (!arguments.length) return defaultState;
            defaultState = _;
            return chart;
        };
        chart.noData = function(_) {
            if (!arguments.length) return noData;
            noData = _;
            return chart;
        };
        chart.transitionDuration = function(_) {
            if (!arguments.length) return transitionDuration;
            transitionDuration = _;
            return chart;
        };
        //============================================================
        return chart;
    };
    nv.models.sparkline = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var margin = {
            top: 2,
            right: 0,
            bottom: 2,
            left: 0
        }, width = 400, height = 32, animate = true, x = $9175b321012dc0d3$var$d3.scale.linear(), y = $9175b321012dc0d3$var$d3.scale.linear(), getX1 = function(d) {
            return d.x;
        }, getY1 = function(d) {
            return d.y;
        }, color = nv.utils.getColor([
            '#000'
        ]), xDomain, yDomain, xRange, yRange;
        //============================================================
        function chart(selection) {
            selection.each(function(data) {
                var availableWidth = width - margin.left - margin.right, availableHeight = height - margin.top - margin.bottom, container = $9175b321012dc0d3$var$d3.select(this);
                //------------------------------------------------------------
                // Setup Scales
                x.domain(xDomain || $9175b321012dc0d3$var$d3.extent(data, getX1)).range(xRange || [
                    0,
                    availableWidth
                ]);
                y.domain(yDomain || $9175b321012dc0d3$var$d3.extent(data, getY1)).range(yRange || [
                    availableHeight,
                    0
                ]);
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = container.selectAll('g.nv-wrap.nv-sparkline').data([
                    data
                ]);
                var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-sparkline');
                var gEnter = wrapEnter.append('g');
                var g = wrap.select('g');
                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                //------------------------------------------------------------
                var paths = wrap.selectAll('path').data(function(d) {
                    return [
                        d
                    ];
                });
                paths.enter().append('path');
                paths.exit().remove();
                paths.style('stroke', function(d, i) {
                    return d.color || color(d, i);
                }).attr('d', $9175b321012dc0d3$var$d3.svg.line().x(function(d, i) {
                    return x(getX1(d, i));
                }).y(function(d, i) {
                    return y(getY1(d, i));
                }));
                // TODO: Add CURRENT data point (Need Min, Mac, Current / Most recent)
                var points = wrap.selectAll('circle.nv-point').data(function(data) {
                    var yValues = data.map(function(d, i) {
                        return getY1(d, i);
                    });
                    function pointIndex(index) {
                        if (index != -1) {
                            var result = data[index];
                            result.pointIndex = index;
                            return result;
                        } else return null;
                    }
                    var maxPoint = pointIndex(yValues.lastIndexOf(y.domain()[1])), minPoint = pointIndex(yValues.indexOf(y.domain()[0])), currentPoint = pointIndex(yValues.length - 1);
                    return [
                        minPoint,
                        maxPoint,
                        currentPoint
                    ].filter(function(d) {
                        return d != null;
                    });
                });
                points.enter().append('circle');
                points.exit().remove();
                points.attr('cx', function(d, i) {
                    return x(getX1(d, d.pointIndex));
                }).attr('cy', function(d, i) {
                    return y(getY1(d, d.pointIndex));
                }).attr('r', 2).attr('class', function(d, i) {
                    return getX1(d, d.pointIndex) == x.domain()[1] ? 'nv-point nv-currentValue' : getY1(d, d.pointIndex) == y.domain()[0] ? 'nv-point nv-minValue' : 'nv-point nv-maxValue';
                });
            });
            return chart;
        }
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.x = function(_) {
            if (!arguments.length) return getX1;
            getX1 = $9175b321012dc0d3$var$d3.functor(_);
            return chart;
        };
        chart.y = function(_) {
            if (!arguments.length) return getY1;
            getY1 = $9175b321012dc0d3$var$d3.functor(_);
            return chart;
        };
        chart.xScale = function(_) {
            if (!arguments.length) return x;
            x = _;
            return chart;
        };
        chart.yScale = function(_) {
            if (!arguments.length) return y;
            y = _;
            return chart;
        };
        chart.xDomain = function(_) {
            if (!arguments.length) return xDomain;
            xDomain = _;
            return chart;
        };
        chart.yDomain = function(_) {
            if (!arguments.length) return yDomain;
            yDomain = _;
            return chart;
        };
        chart.xRange = function(_) {
            if (!arguments.length) return xRange;
            xRange = _;
            return chart;
        };
        chart.yRange = function(_) {
            if (!arguments.length) return yRange;
            yRange = _;
            return chart;
        };
        chart.animate = function(_) {
            if (!arguments.length) return animate;
            animate = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = nv.utils.getColor(_);
            return chart;
        };
        //============================================================
        return chart;
    };
    nv.models.sparklinePlus = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var sparkline = nv.models.sparkline();
        var margin = {
            top: 15,
            right: 100,
            bottom: 10,
            left: 50
        }, width = null, height = null, x, y, index = [], paused = false, xTickFormat = $9175b321012dc0d3$var$d3.format(',r'), yTickFormat = $9175b321012dc0d3$var$d3.format(',.2f'), showValue = true, alignValue = true, rightAlignValue = false, noData = "No Data Available.";
        //============================================================
        function chart(selection) {
            selection.each(function(data) {
                var container = $9175b321012dc0d3$var$d3.select(this);
                var availableWidth = (width || parseInt(container.style('width')) || 960) - margin.left - margin.right, availableHeight = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom;
                chart.update = function() {
                    chart(selection);
                };
                chart.container = this;
                //------------------------------------------------------------
                // Display No Data message if there's nothing to show.
                if (!data || !data.length) {
                    var noDataText = container.selectAll('.nv-noData').data([
                        noData
                    ]);
                    noDataText.enter().append('text').attr('class', 'nvd3 nv-noData').attr('dy', '-.7em').style('text-anchor', 'middle');
                    noDataText.attr('x', margin.left + availableWidth / 2).attr('y', margin.top + availableHeight / 2).text(function(d) {
                        return d;
                    });
                    return chart;
                } else container.selectAll('.nv-noData').remove();
                var currentValue = sparkline.y()(data[data.length - 1], data.length - 1);
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup Scales
                x = sparkline.xScale();
                y = sparkline.yScale();
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = container.selectAll('g.nv-wrap.nv-sparklineplus').data([
                    data
                ]);
                var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-sparklineplus');
                var gEnter = wrapEnter.append('g');
                var g = wrap.select('g');
                gEnter.append('g').attr('class', 'nv-sparklineWrap');
                gEnter.append('g').attr('class', 'nv-valueWrap');
                gEnter.append('g').attr('class', 'nv-hoverArea');
                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Main Chart Component(s)
                var sparklineWrap = g.select('.nv-sparklineWrap');
                sparkline.width(availableWidth).height(availableHeight);
                sparklineWrap.call(sparkline);
                //------------------------------------------------------------
                var valueWrap = g.select('.nv-valueWrap');
                var value = valueWrap.selectAll('.nv-currentValue').data([
                    currentValue
                ]);
                value.enter().append('text').attr('class', 'nv-currentValue').attr('dx', rightAlignValue ? -8 : 8).attr('dy', '.9em').style('text-anchor', rightAlignValue ? 'end' : 'start');
                value.attr('x', availableWidth + (rightAlignValue ? margin.right : 0)).attr('y', alignValue ? function(d) {
                    return y(d);
                } : 0).style('fill', sparkline.color()(data[data.length - 1], data.length - 1)).text(yTickFormat(currentValue));
                gEnter.select('.nv-hoverArea').append('rect').on('mousemove', sparklineHover).on('click', function() {
                    paused = !paused;
                }).on('mouseout', function() {
                    index = [];
                    updateValueLine();
                });
                //.on('mouseout', function() { index = null; updateValueLine(); });
                g.select('.nv-hoverArea rect').attr('transform', function(d) {
                    return 'translate(' + -margin.left + ',' + -margin.top + ')';
                }).attr('width', availableWidth + margin.left + margin.right).attr('height', availableHeight + margin.top);
                function updateValueLine() {
                    if (paused) return;
                    var hoverValue = g.selectAll('.nv-hoverValue').data(index);
                    var hoverEnter = hoverValue.enter().append('g').attr('class', 'nv-hoverValue').style('stroke-opacity', 0).style('fill-opacity', 0);
                    hoverValue.exit().transition().duration(250).style('stroke-opacity', 0).style('fill-opacity', 0).remove();
                    hoverValue.attr('transform', function(d) {
                        return 'translate(' + x(sparkline.x()(data[d], d)) + ',0)';
                    }).transition().duration(250).style('stroke-opacity', 1).style('fill-opacity', 1);
                    if (!index.length) return;
                    hoverEnter.append('line').attr('x1', 0).attr('y1', -margin.top).attr('x2', 0).attr('y2', availableHeight);
                    hoverEnter.append('text').attr('class', 'nv-xValue').attr('x', -6).attr('y', -margin.top).attr('text-anchor', 'end').attr('dy', '.9em');
                    g.select('.nv-hoverValue .nv-xValue').text(xTickFormat(sparkline.x()(data[index[0]], index[0])));
                    hoverEnter.append('text').attr('class', 'nv-yValue').attr('x', 6).attr('y', -margin.top).attr('text-anchor', 'start').attr('dy', '.9em');
                    g.select('.nv-hoverValue .nv-yValue').text(yTickFormat(sparkline.y()(data[index[0]], index[0])));
                }
                function sparklineHover() {
                    if (paused) return;
                    var pos = $9175b321012dc0d3$var$d3.mouse(this)[0] - margin.left;
                    function getClosestIndex(data, x) {
                        var distance = Math.abs(sparkline.x()(data[0], 0) - x);
                        var closestIndex = 0;
                        for(var i = 0; i < data.length; i++)if (Math.abs(sparkline.x()(data[i], i) - x) < distance) {
                            distance = Math.abs(sparkline.x()(data[i], i) - x);
                            closestIndex = i;
                        }
                        return closestIndex;
                    }
                    index = [
                        getClosestIndex(data, Math.round(x.invert(pos)))
                    ];
                    updateValueLine();
                }
            });
            return chart;
        }
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        // expose chart's sub-components
        chart.sparkline = sparkline;
        $9175b321012dc0d3$var$d3.rebind(chart, sparkline, 'x', 'y', 'xScale', 'yScale', 'color');
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.xTickFormat = function(_) {
            if (!arguments.length) return xTickFormat;
            xTickFormat = _;
            return chart;
        };
        chart.yTickFormat = function(_) {
            if (!arguments.length) return yTickFormat;
            yTickFormat = _;
            return chart;
        };
        chart.showValue = function(_) {
            if (!arguments.length) return showValue;
            showValue = _;
            return chart;
        };
        chart.alignValue = function(_) {
            if (!arguments.length) return alignValue;
            alignValue = _;
            return chart;
        };
        chart.rightAlignValue = function(_) {
            if (!arguments.length) return rightAlignValue;
            rightAlignValue = _;
            return chart;
        };
        chart.noData = function(_) {
            if (!arguments.length) return noData;
            noData = _;
            return chart;
        };
        //============================================================
        return chart;
    };
    nv.models.stackedArea = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var margin = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }, width = 960, height = 500, color = nv.utils.defaultColor() // a function that computes the color
        , id = Math.floor(Math.random() * 100000) //Create semi-unique ID incase user doesn't selet one
        , getX1 = function(d) {
            return d.x;
        } // accessor to get the x value from a data point
        , getY1 = function(d) {
            return d.y;
        } // accessor to get the y value from a data point
        , style = 'stack', offset = 'zero', order = 'default', interpolate = 'linear' // controls the line interpolation
        , clipEdge = false // if true, masks lines within x and y scale
        , x //can be accessed via chart.xScale()
        , y //can be accessed via chart.yScale()
        , scatter1 = nv.models.scatter(), dispatch = $9175b321012dc0d3$var$d3.dispatch('tooltipShow', 'tooltipHide', 'areaClick', 'areaMouseover', 'areaMouseout');
        scatter1.size(2.2) // default size
        .sizeDomain([
            2.2,
            2.2
        ]) // all the same size by default
        ;
        /************************************
         * offset:
         *   'wiggle' (stream)
         *   'zero' (stacked)
         *   'expand' (normalize to 100%)
         *   'silhouette' (simple centered)
         *
         * order:
         *   'inside-out' (stream)
         *   'default' (input order)
         ************************************/ //============================================================
        function chart(selection) {
            selection.each(function(data) {
                var availableWidth = width - margin.left - margin.right, availableHeight = height - margin.top - margin.bottom, container = $9175b321012dc0d3$var$d3.select(this);
                //------------------------------------------------------------
                // Setup Scales
                x = scatter1.xScale();
                y = scatter1.yScale();
                //------------------------------------------------------------
                // Injecting point index into each point because d3.layout.stack().out does not give index
                data = data.map(function(aseries, i) {
                    aseries.seriesIndex = i;
                    aseries.values = aseries.values.map(function(d, j) {
                        d.index = j;
                        d.seriesIndex = i;
                        return d;
                    });
                    return aseries;
                });
                var dataFiltered = data.filter(function(series) {
                    return !series.disabled;
                });
                data = $9175b321012dc0d3$var$d3.layout.stack().order(order).offset(offset).values(function(d) {
                    return d.values;
                }) //TODO: make values customizeable in EVERY model in this fashion
                .x(getX1).y(getY1).out(function(d, y0, y) {
                    var yHeight = getY1(d) === 0 ? 0 : y;
                    d.display = {
                        y: yHeight,
                        y0: y0
                    };
                })(dataFiltered);
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = container.selectAll('g.nv-wrap.nv-stackedarea').data([
                    data
                ]);
                var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-stackedarea');
                var defsEnter = wrapEnter.append('defs');
                var gEnter = wrapEnter.append('g');
                var g = wrap.select('g');
                gEnter.append('g').attr('class', 'nv-areaWrap');
                gEnter.append('g').attr('class', 'nv-scatterWrap');
                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                //------------------------------------------------------------
                scatter1.width(availableWidth).height(availableHeight).x(getX1).y(function(d) {
                    return d.display.y + d.display.y0;
                }).forceY([
                    0
                ]).color(data.map(function(d, i) {
                    return d.color || color(d, d.seriesIndex);
                }));
                var scatterWrap = g.select('.nv-scatterWrap').datum(data);
                scatterWrap.call(scatter1);
                defsEnter.append('clipPath').attr('id', 'nv-edge-clip-' + id).append('rect');
                wrap.select('#nv-edge-clip-' + id + ' rect').attr('width', availableWidth).attr('height', availableHeight);
                g.attr('clip-path', clipEdge ? 'url(#nv-edge-clip-' + id + ')' : '');
                var area = $9175b321012dc0d3$var$d3.svg.area().x(function(d, i) {
                    return x(getX1(d, i));
                }).y0(function(d) {
                    return y(d.display.y0);
                }).y1(function(d) {
                    return y(d.display.y + d.display.y0);
                }).interpolate(interpolate);
                var zeroArea = $9175b321012dc0d3$var$d3.svg.area().x(function(d, i) {
                    return x(getX1(d, i));
                }).y0(function(d) {
                    return y(d.display.y0);
                }).y1(function(d) {
                    return y(d.display.y0);
                });
                var path = g.select('.nv-areaWrap').selectAll('path.nv-area').data(function(d) {
                    return d;
                });
                path.enter().append('path').attr('class', function(d, i) {
                    return 'nv-area nv-area-' + i;
                }).attr('d', function(d, i) {
                    return zeroArea(d.values, d.seriesIndex);
                }).on('mouseover', function(d, i) {
                    $9175b321012dc0d3$var$d3.select(this).classed('hover', true);
                    dispatch.areaMouseover({
                        point: d,
                        series: d.key,
                        pos: [
                            $9175b321012dc0d3$var$d3.event.pageX,
                            $9175b321012dc0d3$var$d3.event.pageY
                        ],
                        seriesIndex: i
                    });
                }).on('mouseout', function(d, i) {
                    $9175b321012dc0d3$var$d3.select(this).classed('hover', false);
                    dispatch.areaMouseout({
                        point: d,
                        series: d.key,
                        pos: [
                            $9175b321012dc0d3$var$d3.event.pageX,
                            $9175b321012dc0d3$var$d3.event.pageY
                        ],
                        seriesIndex: i
                    });
                }).on('click', function(d, i) {
                    $9175b321012dc0d3$var$d3.select(this).classed('hover', false);
                    dispatch.areaClick({
                        point: d,
                        series: d.key,
                        pos: [
                            $9175b321012dc0d3$var$d3.event.pageX,
                            $9175b321012dc0d3$var$d3.event.pageY
                        ],
                        seriesIndex: i
                    });
                });
                path.exit().transition().attr('d', function(d, i) {
                    return zeroArea(d.values, i);
                }).remove();
                path.style('fill', function(d, i) {
                    return d.color || color(d, d.seriesIndex);
                }).style('stroke', function(d, i) {
                    return d.color || color(d, d.seriesIndex);
                });
                path.transition().attr('d', function(d, i) {
                    return area(d.values, i);
                });
                //============================================================
                // Event Handling/Dispatching (in chart's scope)
                //------------------------------------------------------------
                scatter1.dispatch.on('elementMouseover.area', function(e) {
                    g.select('.nv-chart-' + id + ' .nv-area-' + e.seriesIndex).classed('hover', true);
                });
                scatter1.dispatch.on('elementMouseout.area', function(e) {
                    g.select('.nv-chart-' + id + ' .nv-area-' + e.seriesIndex).classed('hover', false);
                });
            //============================================================
            });
            return chart;
        }
        //============================================================
        // Event Handling/Dispatching (out of chart's scope)
        //------------------------------------------------------------
        scatter1.dispatch.on('elementClick.area', function(e) {
            dispatch.areaClick(e);
        });
        scatter1.dispatch.on('elementMouseover.tooltip', function(e) {
            e.pos = [
                e.pos[0] + margin.left,
                e.pos[1] + margin.top
            ], dispatch.tooltipShow(e);
        });
        scatter1.dispatch.on('elementMouseout.tooltip', function(e) {
            dispatch.tooltipHide(e);
        });
        //============================================================
        //============================================================
        // Global getters and setters
        //------------------------------------------------------------
        chart.dispatch = dispatch;
        chart.scatter = scatter1;
        $9175b321012dc0d3$var$d3.rebind(chart, scatter1, 'interactive', 'size', 'xScale', 'yScale', 'zScale', 'xDomain', 'yDomain', 'xRange', 'yRange', 'sizeDomain', 'forceX', 'forceY', 'forceSize', 'clipVoronoi', 'useVoronoi', 'clipRadius', 'highlightPoint', 'clearHighlights');
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.x = function(_) {
            if (!arguments.length) return getX1;
            getX1 = $9175b321012dc0d3$var$d3.functor(_);
            return chart;
        };
        chart.y = function(_) {
            if (!arguments.length) return getY1;
            getY1 = $9175b321012dc0d3$var$d3.functor(_);
            return chart;
        };
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.clipEdge = function(_) {
            if (!arguments.length) return clipEdge;
            clipEdge = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = nv.utils.getColor(_);
            return chart;
        };
        chart.offset = function(_) {
            if (!arguments.length) return offset;
            offset = _;
            return chart;
        };
        chart.order = function(_) {
            if (!arguments.length) return order;
            order = _;
            return chart;
        };
        //shortcut for offset + order
        chart.style = function(_) {
            if (!arguments.length) return style;
            style = _;
            switch(style){
                case 'stack':
                    chart.offset('zero');
                    chart.order('default');
                    break;
                case 'stream':
                    chart.offset('wiggle');
                    chart.order('inside-out');
                    break;
                case 'stream-center':
                    chart.offset('silhouette');
                    chart.order('inside-out');
                    break;
                case 'expand':
                    chart.offset('expand');
                    chart.order('default');
                    break;
            }
            return chart;
        };
        chart.interpolate = function(_) {
            if (!arguments.length) return interpolate;
            interpolate = _;
            return chart;
        };
        //============================================================
        return chart;
    };
    nv.models.stackedAreaChart = function() {
        "use strict";
        //============================================================
        // Public Variables with Default Settings
        //------------------------------------------------------------
        var stacked = nv.models.stackedArea(), xAxis = nv.models.axis(), yAxis = nv.models.axis(), legend = nv.models.legend(), controls = nv.models.legend(), interactiveLayer = nv.interactiveGuideline();
        var margin = {
            top: 30,
            right: 25,
            bottom: 50,
            left: 60
        }, width = null, height = null, color = nv.utils.defaultColor() // a function that takes in d, i and returns color
        , showControls = true, showLegend = true, showXAxis = true, showYAxis = true, rightAlignYAxis = false, useInteractiveGuideline = false, tooltips = true, tooltip = function(key, x, y, e, graph) {
            return '<h3>' + key + '</h3>' + '<p>' + y + ' on ' + x + '</p>';
        }, x //can be accessed via chart.xScale()
        , y //can be accessed via chart.yScale()
        , yAxisTickFormat = $9175b321012dc0d3$var$d3.format(',.2f'), state = {
            style: stacked.style()
        }, defaultState = null, noData = 'No Data Available.', dispatch = $9175b321012dc0d3$var$d3.dispatch('tooltipShow', 'tooltipHide', 'stateChange', 'changeState'), controlWidth = 250, cData = [
            'Stacked',
            'Stream',
            'Expanded'
        ], transitionDuration = 250;
        xAxis.orient('bottom').tickPadding(7);
        yAxis.orient(rightAlignYAxis ? 'right' : 'left');
        controls.updateState(false);
        //============================================================
        //============================================================
        // Private Variables
        //------------------------------------------------------------
        var showTooltip = function(e, offsetElement) {
            var left = e.pos[0] + (offsetElement.offsetLeft || 0), top = e.pos[1] + (offsetElement.offsetTop || 0), x = xAxis.tickFormat()(stacked.x()(e.point, e.pointIndex)), y = yAxis.tickFormat()(stacked.y()(e.point, e.pointIndex)), content = tooltip(e.series.key, x, y, e, chart);
            nv.tooltip.show([
                left,
                top
            ], content, e.value < 0 ? 'n' : 's', null, offsetElement);
        };
        //============================================================
        function chart(selection) {
            selection.each(function(data) {
                var container = $9175b321012dc0d3$var$d3.select(this), that = this;
                var availableWidth = (width || parseInt(container.style('width')) || 960) - margin.left - margin.right, availableHeight = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom;
                chart.update = function() {
                    container.transition().duration(transitionDuration).call(chart);
                };
                chart.container = this;
                //set state.disabled
                state.disabled = data.map(function(d) {
                    return !!d.disabled;
                });
                if (!defaultState) {
                    var key;
                    defaultState = {};
                    for(key in state)if (state[key] instanceof Array) defaultState[key] = state[key].slice(0);
                    else defaultState[key] = state[key];
                }
                //------------------------------------------------------------
                // Display No Data message if there's nothing to show.
                if (!data || !data.length || !data.filter(function(d) {
                    return d.values.length;
                }).length) {
                    var noDataText = container.selectAll('.nv-noData').data([
                        noData
                    ]);
                    noDataText.enter().append('text').attr('class', 'nvd3 nv-noData').attr('dy', '-.7em').style('text-anchor', 'middle');
                    noDataText.attr('x', margin.left + availableWidth / 2).attr('y', margin.top + availableHeight / 2).text(function(d) {
                        return d;
                    });
                    return chart;
                } else container.selectAll('.nv-noData').remove();
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup Scales
                x = stacked.xScale();
                y = stacked.yScale();
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup containers and skeleton of chart
                var wrap = container.selectAll('g.nv-wrap.nv-stackedAreaChart').data([
                    data
                ]);
                var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-stackedAreaChart').append('g');
                var g = wrap.select('g');
                gEnter.append("rect").style("opacity", 0);
                gEnter.append('g').attr('class', 'nv-x nv-axis');
                gEnter.append('g').attr('class', 'nv-y nv-axis');
                gEnter.append('g').attr('class', 'nv-stackedWrap');
                gEnter.append('g').attr('class', 'nv-legendWrap');
                gEnter.append('g').attr('class', 'nv-controlsWrap');
                gEnter.append('g').attr('class', 'nv-interactive');
                g.select("rect").attr("width", availableWidth).attr("height", availableHeight);
                //------------------------------------------------------------
                // Legend
                if (showLegend) {
                    var legendWidth = showControls ? availableWidth - controlWidth : availableWidth;
                    legend.width(legendWidth);
                    g.select('.nv-legendWrap').datum(data).call(legend);
                    if (margin.top != legend.height()) {
                        margin.top = legend.height();
                        availableHeight = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom;
                    }
                    g.select('.nv-legendWrap').attr('transform', 'translate(' + (availableWidth - legendWidth) + ',' + -margin.top + ')');
                }
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Controls
                if (showControls) {
                    var controlsData = [
                        {
                            key: 'Stacked',
                            disabled: stacked.offset() != 'zero'
                        },
                        {
                            key: 'Stream',
                            disabled: stacked.offset() != 'wiggle'
                        },
                        {
                            key: 'Expanded',
                            disabled: stacked.offset() != 'expand'
                        }
                    ];
                    controlWidth = cData.length / 3 * 260;
                    controlsData = controlsData.filter(function(d) {
                        return cData.indexOf(d.key) > -1;
                    });
                    controls.width(controlWidth).color([
                        '#444',
                        '#444',
                        '#444'
                    ]);
                    g.select('.nv-controlsWrap').datum(controlsData).call(controls);
                    if (margin.top != Math.max(controls.height(), legend.height())) {
                        margin.top = Math.max(controls.height(), legend.height());
                        availableHeight = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom;
                    }
                    g.select('.nv-controlsWrap').attr('transform', 'translate(0,' + -margin.top + ')');
                }
                //------------------------------------------------------------
                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
                if (rightAlignYAxis) g.select(".nv-y.nv-axis").attr("transform", "translate(" + availableWidth + ",0)");
                //------------------------------------------------------------
                // Main Chart Component(s)
                //------------------------------------------------------------
                //Set up interactive layer
                if (useInteractiveGuideline) {
                    interactiveLayer.width(availableWidth).height(availableHeight).margin({
                        left: margin.left,
                        top: margin.top
                    }).svgContainer(container).xScale(x);
                    wrap.select(".nv-interactive").call(interactiveLayer);
                }
                stacked.width(availableWidth).height(availableHeight);
                var stackedWrap = g.select('.nv-stackedWrap').datum(data);
                stackedWrap.transition().call(stacked);
                //------------------------------------------------------------
                //------------------------------------------------------------
                // Setup Axes
                if (showXAxis) {
                    xAxis.scale(x).ticks(availableWidth / 100).tickSize(-availableHeight, 0);
                    g.select('.nv-x.nv-axis').attr('transform', 'translate(0,' + availableHeight + ')');
                    g.select('.nv-x.nv-axis').transition().duration(0).call(xAxis);
                }
                if (showYAxis) {
                    yAxis.scale(y).ticks(stacked.offset() == 'wiggle' ? 0 : availableHeight / 36).tickSize(-availableWidth, 0).setTickFormat(stacked.offset() == 'expand' ? $9175b321012dc0d3$var$d3.format('%') : yAxisTickFormat);
                    g.select('.nv-y.nv-axis').transition().duration(0).call(yAxis);
                }
                //------------------------------------------------------------
                //============================================================
                // Event Handling/Dispatching (in chart's scope)
                //------------------------------------------------------------
                stacked.dispatch.on('areaClick.toggle', function(e) {
                    if (data.filter(function(d) {
                        return !d.disabled;
                    }).length === 1) data = data.map(function(d) {
                        d.disabled = false;
                        return d;
                    });
                    else data = data.map(function(d, i) {
                        d.disabled = i != e.seriesIndex;
                        return d;
                    });
                    state.disabled = data.map(function(d) {
                        return !!d.disabled;
                    });
                    dispatch.stateChange(state);
                    chart.update();
                });
                legend.dispatch.on('stateChange', function(newState) {
                    state.disabled = newState.disabled;
                    dispatch.stateChange(state);
                    chart.update();
                });
                controls.dispatch.on('legendClick', function(d, i) {
                    if (!d.disabled) return;
                    controlsData = controlsData.map(function(s) {
                        s.disabled = true;
                        return s;
                    });
                    d.disabled = false;
                    switch(d.key){
                        case 'Stacked':
                            stacked.style('stack');
                            break;
                        case 'Stream':
                            stacked.style('stream');
                            break;
                        case 'Expanded':
                            stacked.style('expand');
                            break;
                    }
                    state.style = stacked.style();
                    dispatch.stateChange(state);
                    chart.update();
                });
                interactiveLayer.dispatch.on('elementMousemove', function(e) {
                    stacked.clearHighlights();
                    var singlePoint1, pointIndex, pointXLocation, allData = [];
                    data.filter(function(series, i) {
                        series.seriesIndex = i;
                        return !series.disabled;
                    }).forEach(function(series, i) {
                        pointIndex = nv.interactiveBisect(series.values, e.pointXValue, chart.x());
                        stacked.highlightPoint(i, pointIndex, true);
                        var point = series.values[pointIndex];
                        if (typeof point === 'undefined') return;
                        if (typeof singlePoint1 === 'undefined') singlePoint1 = point;
                        if (typeof pointXLocation === 'undefined') pointXLocation = chart.xScale()(chart.x()(point, pointIndex));
                        allData.push({
                            key: series.key,
                            value: chart.y()(point, pointIndex),
                            color: color(series, series.seriesIndex),
                            stackedValue: point.display
                        });
                    });
                    allData.reverse();
                    //Highlight the tooltip entry based on which stack the mouse is closest to.
                    if (allData.length > 2) {
                        var yValue = chart.yScale().invert(e.mouseY);
                        var yDistMax = Infinity, indexToHighlight = null;
                        allData.forEach(function(series, i) {
                            if (yValue >= series.stackedValue.y0 && yValue <= series.stackedValue.y0 + series.stackedValue.y) {
                                indexToHighlight = i;
                                return;
                            }
                        });
                        if (indexToHighlight != null) allData[indexToHighlight].highlight = true;
                    }
                    var xValue = xAxis.tickFormat()(chart.x()(singlePoint1, pointIndex));
                    interactiveLayer.tooltip.position({
                        left: pointXLocation + margin.left,
                        top: e.mouseY + margin.top
                    }).chartContainer(that.parentNode).enabled(tooltips).valueFormatter(function(d, i) {
                        return yAxis.tickFormat()(d);
                    }).data({
                        value: xValue,
                        series: allData
                    })();
                    interactiveLayer.renderGuideLine(pointXLocation);
                });
                interactiveLayer.dispatch.on("elementMouseout", function(e) {
                    dispatch.tooltipHide();
                    stacked.clearHighlights();
                });
                dispatch.on('tooltipShow', function(e) {
                    if (tooltips) showTooltip(e, that.parentNode);
                });
                // Update chart from a state object passed to event handler
                dispatch.on('changeState', function(e) {
                    if (typeof e.disabled !== 'undefined') {
                        data.forEach(function(series, i) {
                            series.disabled = e.disabled[i];
                        });
                        state.disabled = e.disabled;
                    }
                    if (typeof e.style !== 'undefined') stacked.style(e.style);
                    chart.update();
                });
            });
            return chart;
        }
        //============================================================
        // Event Handling/Dispatching (out of chart's scope)
        //------------------------------------------------------------
        stacked.dispatch.on('tooltipShow', function(e) {
            //disable tooltips when value ~= 0
            //// TODO: consider removing points from voronoi that have 0 value instead of this hack
            /*
    if (!Math.round(stacked.y()(e.point) * 100)) {  // 100 will not be good for very small numbers... will have to think about making this valu dynamic, based on data range
      setTimeout(function() { d3.selectAll('.point.hover').classed('hover', false) }, 0);
      return false;
    }
   */ e.pos = [
                e.pos[0] + margin.left,
                e.pos[1] + margin.top
            ], dispatch.tooltipShow(e);
        });
        stacked.dispatch.on('tooltipHide', function(e) {
            dispatch.tooltipHide(e);
        });
        dispatch.on('tooltipHide', function() {
            if (tooltips) nv.tooltip.cleanup();
        });
        //============================================================
        //============================================================
        // Expose Public Variables
        //------------------------------------------------------------
        // expose chart's sub-components
        chart.dispatch = dispatch;
        chart.stacked = stacked;
        chart.legend = legend;
        chart.controls = controls;
        chart.xAxis = xAxis;
        chart.yAxis = yAxis;
        chart.interactiveLayer = interactiveLayer;
        $9175b321012dc0d3$var$d3.rebind(chart, stacked, 'x', 'y', 'size', 'xScale', 'yScale', 'xDomain', 'yDomain', 'xRange', 'yRange', 'sizeDomain', 'interactive', 'useVoronoi', 'offset', 'order', 'style', 'clipEdge', 'forceX', 'forceY', 'forceSize', 'interpolate');
        chart.options = nv.utils.optionsFunc.bind(chart);
        chart.margin = function(_) {
            if (!arguments.length) return margin;
            margin.top = typeof _.top != 'undefined' ? _.top : margin.top;
            margin.right = typeof _.right != 'undefined' ? _.right : margin.right;
            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
            margin.left = typeof _.left != 'undefined' ? _.left : margin.left;
            return chart;
        };
        chart.width = function(_) {
            if (!arguments.length) return width;
            width = _;
            return chart;
        };
        chart.height = function(_) {
            if (!arguments.length) return height;
            height = _;
            return chart;
        };
        chart.color = function(_) {
            if (!arguments.length) return color;
            color = nv.utils.getColor(_);
            legend.color(color);
            stacked.color(color);
            return chart;
        };
        chart.showControls = function(_) {
            if (!arguments.length) return showControls;
            showControls = _;
            return chart;
        };
        chart.showLegend = function(_) {
            if (!arguments.length) return showLegend;
            showLegend = _;
            return chart;
        };
        chart.showXAxis = function(_) {
            if (!arguments.length) return showXAxis;
            showXAxis = _;
            return chart;
        };
        chart.showYAxis = function(_) {
            if (!arguments.length) return showYAxis;
            showYAxis = _;
            return chart;
        };
        chart.rightAlignYAxis = function(_) {
            if (!arguments.length) return rightAlignYAxis;
            rightAlignYAxis = _;
            yAxis.orient(_ ? 'right' : 'left');
            return chart;
        };
        chart.useInteractiveGuideline = function(_) {
            if (!arguments.length) return useInteractiveGuideline;
            useInteractiveGuideline = _;
            if (_ === true) {
                chart.interactive(false);
                chart.useVoronoi(false);
            }
            return chart;
        };
        chart.tooltip = function(_) {
            if (!arguments.length) return tooltip;
            tooltip = _;
            return chart;
        };
        chart.tooltips = function(_) {
            if (!arguments.length) return tooltips;
            tooltips = _;
            return chart;
        };
        chart.tooltipContent = function(_) {
            if (!arguments.length) return tooltip;
            tooltip = _;
            return chart;
        };
        chart.state = function(_) {
            if (!arguments.length) return state;
            state = _;
            return chart;
        };
        chart.defaultState = function(_) {
            if (!arguments.length) return defaultState;
            defaultState = _;
            return chart;
        };
        chart.noData = function(_) {
            if (!arguments.length) return noData;
            noData = _;
            return chart;
        };
        chart.transitionDuration = function(_) {
            if (!arguments.length) return transitionDuration;
            transitionDuration = _;
            return chart;
        };
        chart.controlsData = function(_) {
            if (!arguments.length) return cData;
            cData = _;
            return chart;
        };
        yAxis.setTickFormat = yAxis.tickFormat;
        yAxis.tickFormat = function(_) {
            if (!arguments.length) return yAxisTickFormat;
            yAxisTickFormat = _;
            return yAxis;
        };
        //============================================================
        return chart;
    };
})();


const $6ff67e0fbdc170e0$var$funds = {
    settings: {
        elements: {
            chartOverlay: null,
            chartTabButtons: null,
            chartDateButtons: null,
            checkboxes: null,
            tableCategorySelect: null,
            tableProductSelect: null,
            tableDots: null
        },
        tableSelectProduct: 'Wszystkie',
        tableSelectCategory: 'Wszystkie',
        filterChart: {
            tab: null,
            date: null
        },
        calendarContainer: null,
        chartData: [],
        chartElement: null,
        calendar: {
            initialDate: null,
            endingDate: null
        },
        lock: false,
        queue: [],
        month: {
            "stycze\u0144": '01',
            'luty': '02',
            'marzec': '03',
            "kwiecie\u0144": '04',
            'maj': '05',
            'czerwiec': '06',
            'lipiec': '07',
            "sierpie\u0144": '08',
            "wrzesie\u0144": '09',
            "pa\u017Adziernik": '10',
            'listopad': '11',
            "grudzie\u0144": '12'
        },
        monthArray: [
            "stycze\u0144",
            'luty',
            'marzec',
            "kwiecie\u0144",
            'maj',
            'czerwiec',
            'lipiec',
            "sierpie\u0144",
            "wrzesie\u0144",
            "pa\u017Adziernik",
            'listopad',
            "grudzie\u0144"
        ],
        currentDate: {
            year: null,
            month: null
        }
    },
    chart: null,
    getElements () {
        this.settings.calendarContainer = document.querySelector('.calendar');
        this.settings.elements.chartOverlay = document.querySelector('.funds__chart__overlay');
        this.settings.elements.chartTabButtons = [
            ...document.querySelectorAll('.funds__tabs__tab')
        ];
        this.settings.elements.chartDateButtons = document.querySelectorAll('.funds__dates__date');
        this.settings.elements.checkboxes = [
            ...document.querySelectorAll('.funds__table input[type="checkbox"]')
        ];
        this.settings.elements.tableCategorySelect = [
            ...document.querySelector('.funds__filters__category .select-options').children
        ];
        this.settings.elements.tableProductSelect = [
            ...document.querySelector('.funds__filters__products .select-options').children
        ];
    },
    init () {
        const checkPage = document.querySelector('.funds__chart');
        if (checkPage == null) return;
        this.settings.currentDate.year = new Date().getFullYear();
        this.settings.currentDate.month = this.settings.monthArray[new Date().getMonth()];
        //this.initializeChart();
        this.getElements();
        this.checkChartFilters();
        this.chartDateButtonsClickEvent();
        this.chartTabButtonsClickEvent();
        this.tableInputsClickEvent();
        this.tableCategorySelectClickEvent();
        this.tableProductSelectClickEvent();
        this.switchContainer();
        this.setCalendar();
        this.showAdditionalSettings();
    },
    showAdditionalSettings () {
        let $this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.funds__table__values__dots').click(function(e) {
            e.stopPropagation();
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).toggleClass('active');
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.funds__table__values__dots').not(this).removeClass('active');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).click(function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.funds__table__values__dots').removeClass('active');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.funds__table__values__dots__list__item--csv a').click(function() {
            $this.downloadCSV(this);
        });
    },
    initializeChart () {
        if (this.chart) return;
        let $this = this;
        nv.addGraph(function() {
            document.getElementById('chart').style.visibility = "visible";
            $this.chart = nv.models.lineChart().margin({
                left: 100
            }) //Adjust chart margins to give the x-axis some breathing room.
            .useInteractiveGuideline(true) //We want nice looking tooltips and a guideline!
            .transitionDuration(350).showLegend(true) //Show the legend, allowing users to turn on/off line series.
            .showYAxis(true) //Show the y-axis
            .showXAxis(true); //Show the x-axis
            $this.chart.noData("Brak danych.");
            $this.chart.xAxis.tickFormat(function(d) {
                var date = new Date(d);
                return $67569c21d3f40419$exports.time.format('%d-%m-%y')(date);
            });
            if ($this.settings.filterChart.tab === 'rate_of_return') $this.chart.yAxis.showMaxMin(true).tickFormat(function(d) {
                return parseFloat(d).toFixed(2) + ' %';
            });
            else if ($this.settings.filterChart.tab === 'absolute_value') $this.chart.yAxis.showMaxMin(true).tickFormat(function(d) {
                return parseFloat(d).toFixed(2) + " z\u0142";
            });
            else $this.chart.yAxis //Chart y-axis settings
            .tickFormat(function(d) {
                return parseFloat(d).toFixed(2) + ' PLN';
            });
            $this.chart.color(function(d, i) {
                var colors = $67569c21d3f40419$exports.scale.category10().range();
                return colors[i % colors.length];
            });
            /* Done setting the chart up? Time to render it!*/ $this.chartElement = $67569c21d3f40419$exports.select('#chart svg') //Select the <svg> element you want to render the chart in.
            .datum($this.settings.chartData); //Finally, render the chart!
            $this.chartElement.transition().duration(500).call($this.chart);
            //Update the chart when window resizes.
            nv.utils.windowResize(function() {
                $this.chart.update();
            });
            return $this.chart;
        });
    },
    updateChart () {
        let data = this.settings.chartData;
        document.getElementById('chart').style.visibility = "visible";
        if (this.settings.filterChart.tab === 'rate_of_return') this.chart.yAxis.showMaxMin(true).tickFormat(function(d) {
            return parseFloat(d).toFixed(2) + ' %';
        });
        else if (this.settings.filterChart.tab === 'absolute_value') this.chart.yAxis.showMaxMin(true).tickFormat(function(d) {
            return parseFloat(d).toFixed(2) + " z\u0142";
        });
        else this.chart.yAxis //Chart y-axis settings
        .tickFormat(function(d) {
            return parseFloat(d).toFixed(2) + ' PLN';
        });
        // Update the SVG with the new data and call chart
        this.chartElement.datum(data).transition().duration(500).call(this.chart);
        nv.utils.windowResize(this.chart.update);
    },
    destroyChart (chart) {
        document.getElementById('chart').style.visibility = "hidden";
        chart.selectAll('g').remove();
        this.chartOverlayOn();
        this.chart = null;
    },
    drawChart () {
        if (this.chart !== null) this.updateChart();
        else this.initializeChart();
        this.chartOverlayOff();
        if (this.settings.chartData.length === 0) this.destroyChart($67569c21d3f40419$exports.select('#chart'));
    },
    tableCategorySelectClickEvent () {
        this.settings.elements.tableCategorySelect.forEach((el)=>el.addEventListener('click', this.getTableSelectCategory.bind(this)));
    },
    tableProductSelectClickEvent () {
        this.settings.elements.tableProductSelect.forEach((el)=>el.addEventListener('click', this.getTableSelectProduct.bind(this)));
    },
    getTableSelectCategory (e) {
        this.settings.tableSelectCategory = e.target.parentElement.getAttribute('category');
        this.filterTableByCategory();
        this.filterTableByProduct();
    },
    getTableSelectProduct (e) {
        this.settings.tableSelectProduct = e.target.parentElement.getAttribute('rel');
        this.filterTableByCategory();
        this.filterTableByProduct();
    },
    filterTableByCategory () {
        const tables = document.querySelectorAll('table');
        tables.forEach((table)=>{
            const tableCategory = table.getAttribute('data-category');
            if (tableCategory != this.settings.tableSelectCategory && this.settings.tableSelectCategory != 'Wszystkie') {
                table.style.display = "none";
                const checkboxes = table.querySelectorAll('input[type=checkbox]');
                checkboxes.forEach((el)=>el.checked = false);
            } else table.style.display = 'table';
        });
        this.checkChartByCategoryFilter();
    },
    filterTableByProduct () {
        const rows = document.querySelectorAll('.funds__table__values');
        const tables = document.querySelectorAll('.funds__table table');
        let $this = this;
        tables.forEach((table)=>{
            let table_rows = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(table).find('tr[data-include-in-product]');
            let show_table = 0;
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(table_rows).each(function() {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr('data-include-in-product').indexOf($this.settings.tableSelectProduct) >= 0) show_table = 1;
            });
            if (this.settings.tableSelectProduct != 'Wszystkie' && show_table === 0) table.style.display = "none";
        });
        rows.forEach((row)=>{
            let productList = row.getAttribute('data-include-in-product');
            productList = productList.split(',');
            if (!productList.includes(this.settings.tableSelectProduct) && this.settings.tableSelectProduct != 'Wszystkie') {
                row.style.display = "none";
                const checkboxes = document.querySelectorAll(' table input[type=checkbox]');
                checkboxes.forEach((el)=>el.checked = false);
            } else row.style.display = "table-row";
        });
        this.checkChartByCategoryFilter();
    },
    checkChartByCategoryFilter () {
        if (this.chart == undefined || this.settings.chartData == 0) return;
        if (this.settings.tableSelectCategory == 'Wszystkie') return;
        if (this.settings.tableSelectProduct == 'Wszystkie') return;
    },
    chartOverlayOn () {
        this.settings.elements.chartOverlay.style.display = 'flex';
    },
    chartOverlayOff () {
        this.settings.elements.chartOverlay.style.display = 'none';
    },
    checkChartFilters () {
        if (this.settings.filterChart.tab === null) {
            this.settings.filterChart.tab = 'rate_of_return';
            this.settings.elements.chartTabButtons[0].classList.add('var_active');
        }
        if (this.settings.filterChart.date === null) {
            this.settings.filterChart.date = '12';
            this.settings.elements.chartDateButtons[2].classList.add('var_active');
        }
    },
    chartDateButtonsClickEvent () {
        this.settings.elements.chartDateButtons.forEach((el)=>el.addEventListener('click', (e)=>{
                this.getDateButtonData(e);
                this.styleButtonsBehaviour(e);
            }));
    },
    styleButtonsBehaviour (e) {
        const searchClass = e.target.classList[0];
        const lastActiveElement = document.querySelector(`.${searchClass}.var_active`);
        lastActiveElement && lastActiveElement.classList.remove('var_active');
        e.target.classList.add('var_active');
    },
    getDateButtonData (e) {
        let dataAttribute = e.target.getAttribute('data-date') === null ? 'custom' : e.target.getAttribute('data-date');
        if (dataAttribute != this.settings.filterChart.date) this.settings.filterChart.date = dataAttribute;
        this.filterChartByDate();
    },
    filterChartByDate () {
        let $this = this;
        if (this.settings.filterChart.date !== 'custom') {
            this.litepicker.clearSelection();
            this.settings.calendar.initialDate = null;
            this.settings.calendar.endingDate = null;
            if (this.settings.filterChart.tab !== 'exchange_rate') this.getCheckboxData();
            else this.getDataForCurrencyChart();
        }
    },
    chartTabButtonsClickEvent () {
        this.settings.elements.chartTabButtons.forEach((el)=>el.addEventListener('click', (e)=>{
                this.getTabButtonData(e);
                this.styleButtonsBehaviour(e);
            }));
    },
    getTabButtonData (e) {
        let dataAttribute = e.target.getAttribute('data-tab');
        if (dataAttribute !== this.settings.filterChart.tab) {
            this.settings.filterChart.tab = dataAttribute;
            this.filterChartByTab();
        }
    },
    filterChartByTab () {
        //this.litepicker.clearSelection();
        if (this.settings.filterChart.tab === 'exchange_rate') {
            this.litepicker.destroy();
            this.setCalendar();
            this.getDataForCurrencyChart();
        } else {
            this.litepicker.destroy();
            this.setCalendar();
            this.getCheckboxData();
        }
    },
    tableInputsClickEvent () {
        this.settings.elements.checkboxes.forEach((el)=>el.addEventListener('click', this.getCheckboxData.bind(this)));
    },
    getCheckboxData (el) {
        let checked_inputs = document.querySelectorAll('.funds__table input[type="checkbox"]:checked'), $this = this, id = [], fund_name = [], returnRateMonths = this.settings.filterChart.date, initialDate = this.settings.calendar.initialDate, endingDate = this.settings.calendar.endingDate;
        // Reset chart data
        this.settings.chartData = [];
        if (checked_inputs.length > 0) checked_inputs.forEach((el, i)=>{
            id.push(parseInt(el.dataset.fundid));
            fund_name.push(el.dataset.fundname);
        });
        else if ($this.chart !== null) $this.destroyChart($67569c21d3f40419$exports.select('#chart'));
        id = id.toString();
        switch(this.settings.filterChart.tab){
            case 'rate_of_return':
                this.getReturnRateData(id, returnRateMonths, initialDate, endingDate, fund_name);
                break;
            case 'absolute_value':
                this.getFundData(id, returnRateMonths, initialDate, endingDate, fund_name);
                break;
        }
    },
    getDataForCurrencyChart () {
        let returnRateMonths = this.settings.filterChart.date, initialDate = this.settings.calendar.initialDate, endingDate = this.settings.calendar.endingDate;
        this.settings.chartData = [];
        this.getCurrencyData(returnRateMonths, initialDate, endingDate);
    },
    setCalendar () {
        this.litepicker = new (0, (/*@__PURE__*/$parcel$interopDefault($91cBK)))({
            element: document.querySelector('#litepicker'),
            parentEl: document.querySelector('.calendar'),
            singleMode: false,
            showTooltip: false,
            dropdowns: {
                "minYear": 2004,
                "maxYear": null,
                "months": true,
                "years": true
            },
            maxDate: new Date(),
            lang: "pl-PL",
            setup: (picker)=>{
                picker.on('selected', (initialDate, endingDate)=>{
                    this.settings.calendar.initialDate = $67569c21d3f40419$exports.time.format('%Y-%m-%d')(new Date(Date.parse(initialDate.dateInstance)));
                    this.settings.calendar.endingDate = $67569c21d3f40419$exports.time.format('%Y-%m-%d')(new Date(Date.parse(endingDate.dateInstance)));
                    this.settings.calendarContainer.classList.add('var_fill');
                    if (this.settings.filterChart.tab !== 'exchange_rate') this.getCheckboxData();
                    else this.getDataForCurrencyChart();
                });
                picker.on('before:show', ()=>{
                    this.settings.calendarContainer.classList.add('var_active');
                });
                picker.on('hide', ()=>{
                    this.settings.calendarContainer.classList.remove('var_active');
                });
                picker.on('render', (ui)=>{
                    if (!this.clearButton) {
                        this.handleCalendarButtons();
                        setTimeout(()=>this.styleSelect());
                    } else this.clearButton = false;
                    document.querySelector('.calendar .month-item').appendChild(document.querySelector('.reset-button-custom-funds'));
                });
                picker.on('clear:selection', ()=>{
                    this.settings.calendarContainer.classList.remove('var_fill');
                });
            },
            resetButton: ()=>{
                let btn2 = document.createElement('button');
                btn2.innerText = "Wyczy\u015B\u0107";
                btn2.className = "reset-button-custom reset-button-custom-funds";
                btn2.addEventListener('click', (evt)=>{
                    evt.preventDefault();
                    this.settings.currentDate.year = new Date().getFullYear();
                    this.settings.currentDate.month = this.settings.monthArray[new Date().getMonth()];
                    this.clearButton = true;
                    this.litepicker.gotoDate(`${this.settings.currentDate.year}-${this.settings.month[this.settings.currentDate.month]}-01`);
                });
                return btn2;
            }
        });
    },
    styleSelect () {
        const objectThis = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('.litepicker select').each(function() {
            const dateType = this.classList[0] == 'month-item-name' ? 'month' : 'year';
            var $this = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this), numberOfOptions = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).children().length;
            $this.find('option:first-child').attr('value', 'hide');
            $this.addClass('select-hidden');
            $this.wrap(`<div class="select ${dateType}"></div>`);
            $this.after('<div class="select-styled"></div>');
            var label = $this.attr('data-label');
            if (label) $this.before(`<div class="select-label">${label}</div>`);
            var $styledSelect = $this.next('div.select-styled');
            if (dateType === 'month') $styledSelect.text(objectThis.settings.currentDate.month);
            else $styledSelect.text(objectThis.settings.currentDate.year);
            var $list = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('<ul />', {
                'class': `select-options ${dateType}`
            }).insertAfter($styledSelect);
            for(var i = 0; i < numberOfOptions; i++)(0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('<li />', {
                html: $this.children().eq(i).html(),
                rel: $this.children().eq(i).html(),
                disabled: $this.children().eq(i).attr('disabled')
            }).appendTo($list);
            var $listItems = $list.children('li');
            $styledSelect.click(function(e) {
                e.stopPropagation();
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('div.select-styled.active').not(this).each(function() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).removeClass('active').next('ul.select-options').hide();
                });
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).toggleClass('active').next('ul.select-options').toggle();
            });
            $listItems.each(function() {
                (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).wrapInner('<span class="select-options__text"></span>');
            });
            $listItems.click(function(e) {
                e.stopPropagation();
                $styledSelect.removeClass('active');
                $styledSelect.addClass('selected');
                $this.val((0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(this).attr('rel'));
                $list.hide();
                objectThis.handleDateChange(this);
            // $this.trigger( 'change' );
            // console.log(objectThis.currentDate)
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(document).click(function() {
                $styledSelect.removeClass('active');
                $list.hide();
            });
        });
    },
    handleDateChange (clickedElement) {
        const parentElement = clickedElement.parentElement;
        if (parentElement.classList.contains('month')) {
            this.settings.currentDate.month = clickedElement.getAttribute('rel');
            this.litepicker.gotoDate(`${this.settings.currentDate.year}-${this.settings.month[this.settings.currentDate.month]}-01`);
        } else {
            this.settings.currentDate.year = clickedElement.getAttribute('rel');
            this.litepicker.gotoDate(`${this.settings.currentDate.year}-${this.settings.month[this.settings.currentDate.month]}-01`);
        }
    },
    handleCalendarButtons () {
        const prev = document.querySelector('.calendar .button-previous-month');
        const next = document.querySelector('.calendar .button-next-month');
        prev.addEventListener('click', ()=>this.changeSelectDate(-1));
        next.addEventListener('click', ()=>this.changeSelectDate(1));
    },
    changeSelectDate (direction) {
        let getCurrentMonthIndex = this.settings.monthArray.indexOf(this.settings.currentDate.month);
        if (getCurrentMonthIndex == 0 && direction == -1) {
            getCurrentMonthIndex = 12;
            this.settings.currentDate.year -= 1;
        } else if (getCurrentMonthIndex == 11 && direction == 1) {
            getCurrentMonthIndex = -1;
            this.settings.currentDate.year += 1;
        }
        if (direction > 0) this.settings.currentDate.month = this.settings.monthArray[getCurrentMonthIndex + 1];
        else this.settings.currentDate.month = this.settings.monthArray[getCurrentMonthIndex - 1];
    },
    switchContainer () {
        const parent = document.querySelector('.funds__dates');
        const desktop = window.matchMedia('(min-width: 1441px)').matches;
        if (desktop) parent.appendChild(this.settings.calendarContainer);
        else parent.after(this.settings.calendarContainer);
    },
    sendRequest (url, fund_name) {
        let $this = this, data_x_y = [], loader = document.querySelectorAll('.funds__loader');
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).ajax({
            url: url,
            beforeSend: function() {
                $this.settings.elements.checkboxes.forEach((el)=>{
                    el.disabled = true;
                });
                loader.forEach((el)=>{
                    el.style.display = 'block';
                });
            },
            success: function(data) {
                $this.settings.elements.checkboxes.forEach((el)=>{
                    el.disabled = false;
                });
                loader.forEach((el)=>{
                    el.style.display = 'none';
                });
                data.forEach(function(el, index) {
                    let parent_el = el, parent_index = index;
                    data_x_y[index] = [];
                    el.Offsets.double.forEach(function(el, index) {
                        data_x_y[parent_index].push({
                            x: Date.parse(el),
                            y: parseFloat(parent_el.Values.double[index])
                        });
                    });
                });
                data_x_y.forEach(function(el, index) {
                    $this.settings.chartData.push({
                        values: el,
                        key: fund_name[index]
                    });
                });
                $this.drawChart();
            }
        });
    },
    getReturnRateData (fundsId, returnRateMonths, initialDate, endingDate, fund_name) {
        let url = returnRateMonths !== 'custom' ? `${compensa_general.link}/wp-json/cmp_services/funds?funds_id=${fundsId}&rate_month=${returnRateMonths}&chart=rate_of_return` : `${compensa_general.link}/wp-json/cmp_services/funds?funds_id=${fundsId}&rate_month=-1&chart=rate_of_return&initial_date=${initialDate}&ending_date=${endingDate}`;
        this.sendRequest(url, fund_name);
    },
    getFundData (fundsId, returnRateMonths, initialDate, endingDate, fund_name) {
        let url = returnRateMonths !== 'custom' ? `${compensa_general.link}/wp-json/cmp_services/funds?funds_id=${fundsId}&rate_month=${returnRateMonths}&chart=absolute_value` : `${compensa_general.link}/wp-json/cmp_services/funds?funds_id=${fundsId}&rate_month=-1&chart=absolute_value&initial_date=${initialDate}&ending_date=${endingDate}`;
        this.sendRequest(url, fund_name);
    },
    getCurrencyData (returnRateMonths, initialDate, endingDate) {
        let fund_name = [
            'USD-PLN',
            'EUR-PLN'
        ], url = returnRateMonths !== 'custom' ? `${compensa_general.link}/wp-json/cmp_services/funds?rate_month=${returnRateMonths}&chart=exchange_rate` : `${compensa_general.link}/wp-json/cmp_services/funds?rate_month=-1&chart=exchange_rate&initial_date=${initialDate}&ending_date=${endingDate}`;
        this.sendRequest(url, fund_name);
    },
    downloadCSV (el) {
        (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr))).ajax({
            method: "POST",
            url: `${compensa_general.link}/wp/wp-admin/admin-ajax.php`,
            data: {
                'action': 'generate_csv',
                'fundid': (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(el).data('fundid'),
                'fundName': (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(el).data('fundname')
            }
        }).done(function(data) {
            let csvContent = "data:text/csv;charset=utf-8,", json = JSON.parse(data);
            json.csv.forEach(function(rowArray) {
                let row = rowArray.join(",");
                csvContent += row + "\r\n";
            });
            let encodedUri = encodeURI(csvContent), link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", json.fileName);
            document.body.appendChild(link); // Required for FF
            link.click();
        });
    }
};
var $6ff67e0fbdc170e0$export$2e2bcd8739ae039 = $6ff67e0fbdc170e0$var$funds;
window.addEventListener('load', ()=>$6ff67e0fbdc170e0$var$funds.init());

})();
//# sourceMappingURL=funds.js.map
